import './style.css';
import { computed as te, unref as he, ref as je, shallowRef as yf, watch as kt, getCurrentScope as bf, onScopeDispose as pu, shallowReadonly as ea, defineComponent as tt, openBlock as we, createElementBlock as Te, createElementVNode as xe, renderSlot as Xt, normalizeStyle as la, createCommentVNode as vt, createVNode as ce, mergeProps as Qt, createTextVNode as Se, normalizeClass as gt, createBlock as Ut, resolveDynamicComponent as ao, toDisplayString as _t, withModifiers as ws, withCtx as Je, Fragment as Et, renderList as rn, markRaw as Ua, onMounted as In, onBeforeUnmount as Dv, Teleport as Iv, pushScopeId as mu, popScopeId as gu, toRaw as tn, nextTick as nn, reactive as Ir, mergeModels as Ci, useModel as or, normalizeProps as ua, guardReactiveProps as ks, triggerRef as Hc, watchEffect as ti, cloneVNode as wf, h as Cr, inject as Ri, provide as Bi, onUnmounted as _o, withDirectives as Pi, Transition as oo, vShow as vu, toRefs as Av, withKeys as xs, toRef as us, isRef as Za, resolveComponent as Mi, resolveDirective as Rv, toHandlers as Bv, vModelCheckbox as kf, useSlots as $v, vModelText as Nv, vModelDynamic as zv } from "vue";
const Ls = Math.min, Sr = Math.max, Ms = Math.round, Go = Math.floor, sr = (e) => ({
  x: e,
  y: e
}), Fv = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, jv = {
  start: "end",
  end: "start"
};
function Uc(e, t, n) {
  return Sr(e, Ls(t, n));
}
function Us(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Or(e) {
  return e.split("-")[0];
}
function Zs(e) {
  return e.split("-")[1];
}
function xf(e) {
  return e === "x" ? "y" : "x";
}
function Lf(e) {
  return e === "y" ? "height" : "width";
}
function Ws(e) {
  return ["top", "bottom"].includes(Or(e)) ? "y" : "x";
}
function Mf(e) {
  return xf(Ws(e));
}
function Vv(e, t, n) {
  n === void 0 && (n = !1);
  const r = Zs(e), a = Mf(e), l = Lf(a);
  let u = a === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[l] > t.floating[l] && (u = Ss(u)), [u, Ss(u)];
}
function Yv(e) {
  const t = Ss(e);
  return [Hl(e), t, Hl(t)];
}
function Hl(e) {
  return e.replace(/start|end/g, (t) => jv[t]);
}
function Hv(e, t, n) {
  const r = ["left", "right"], a = ["right", "left"], l = ["top", "bottom"], u = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? a : r : t ? r : a;
    case "left":
    case "right":
      return t ? l : u;
    default:
      return [];
  }
}
function Uv(e, t, n, r) {
  const a = Zs(e);
  let l = Hv(Or(e), n === "start", r);
  return a && (l = l.map((u) => u + "-" + a), t && (l = l.concat(l.map(Hl)))), l;
}
function Ss(e) {
  return e.replace(/left|right|bottom|top/g, (t) => Fv[t]);
}
function Zv(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function Wv(e) {
  return typeof e != "number" ? Zv(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function Ps(e) {
  return {
    ...e,
    top: e.y,
    left: e.x,
    right: e.x + e.width,
    bottom: e.y + e.height
  };
}
function Zc(e, t, n) {
  let {
    reference: r,
    floating: a
  } = e;
  const l = Ws(t), u = Mf(t), h = Lf(u), f = Or(t), m = l === "y", v = r.x + r.width / 2 - a.width / 2, y = r.y + r.height / 2 - a.height / 2, k = r[h] / 2 - a[h] / 2;
  let x;
  switch (f) {
    case "top":
      x = {
        x: v,
        y: r.y - a.height
      };
      break;
    case "bottom":
      x = {
        x: v,
        y: r.y + r.height
      };
      break;
    case "right":
      x = {
        x: r.x + r.width,
        y
      };
      break;
    case "left":
      x = {
        x: r.x - a.width,
        y
      };
      break;
    default:
      x = {
        x: r.x,
        y: r.y
      };
  }
  switch (Zs(t)) {
    case "start":
      x[u] -= k * (n && m ? -1 : 1);
      break;
    case "end":
      x[u] += k * (n && m ? -1 : 1);
      break;
  }
  return x;
}
const Gv = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: a = "absolute",
    middleware: l = [],
    platform: u
  } = n, h = l.filter(Boolean), f = await (u.isRTL == null ? void 0 : u.isRTL(t));
  let m = await u.getElementRects({
    reference: e,
    floating: t,
    strategy: a
  }), {
    x: v,
    y
  } = Zc(m, r, f), k = r, x = {}, M = 0;
  for (let O = 0; O < h.length; O++) {
    const {
      name: R,
      fn: C
    } = h[O], {
      x: T,
      y: A,
      data: P,
      reset: D
    } = await C({
      x: v,
      y,
      initialPlacement: r,
      placement: k,
      strategy: a,
      middlewareData: x,
      rects: m,
      platform: u,
      elements: {
        reference: e,
        floating: t
      }
    });
    if (v = T ?? v, y = A ?? y, x = {
      ...x,
      [R]: {
        ...x[R],
        ...P
      }
    }, D && M <= 50) {
      M++, typeof D == "object" && (D.placement && (k = D.placement), D.rects && (m = D.rects === !0 ? await u.getElementRects({
        reference: e,
        floating: t,
        strategy: a
      }) : D.rects), {
        x: v,
        y
      } = Zc(m, k, f)), O = -1;
      continue;
    }
  }
  return {
    x: v,
    y,
    placement: k,
    strategy: a,
    middlewareData: x
  };
};
async function Sf(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: r,
    y: a,
    platform: l,
    rects: u,
    elements: h,
    strategy: f
  } = e, {
    boundary: m = "clippingAncestors",
    rootBoundary: v = "viewport",
    elementContext: y = "floating",
    altBoundary: k = !1,
    padding: x = 0
  } = Us(t, e), M = Wv(x), R = h[k ? y === "floating" ? "reference" : "floating" : y], C = Ps(await l.getClippingRect({
    element: (n = await (l.isElement == null ? void 0 : l.isElement(R))) == null || n ? R : R.contextElement || await (l.getDocumentElement == null ? void 0 : l.getDocumentElement(h.floating)),
    boundary: m,
    rootBoundary: v,
    strategy: f
  })), T = y === "floating" ? {
    ...u.floating,
    x: r,
    y: a
  } : u.reference, A = await (l.getOffsetParent == null ? void 0 : l.getOffsetParent(h.floating)), P = await (l.isElement == null ? void 0 : l.isElement(A)) ? await (l.getScale == null ? void 0 : l.getScale(A)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, D = Ps(l.convertOffsetParentRelativeRectToViewportRelativeRect ? await l.convertOffsetParentRelativeRectToViewportRelativeRect({
    rect: T,
    offsetParent: A,
    strategy: f
  }) : T);
  return {
    top: (C.top - D.top + M.top) / P.y,
    bottom: (D.bottom - C.bottom + M.bottom) / P.y,
    left: (C.left - D.left + M.left) / P.x,
    right: (D.right - C.right + M.right) / P.x
  };
}
const qv = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: a,
        middlewareData: l,
        rects: u,
        initialPlacement: h,
        platform: f,
        elements: m
      } = t, {
        mainAxis: v = !0,
        crossAxis: y = !0,
        fallbackPlacements: k,
        fallbackStrategy: x = "bestFit",
        fallbackAxisSideDirection: M = "none",
        flipAlignment: O = !0,
        ...R
      } = Us(e, t);
      if ((n = l.arrow) != null && n.alignmentOffset)
        return {};
      const C = Or(a), T = Or(h) === h, A = await (f.isRTL == null ? void 0 : f.isRTL(m.floating)), P = k || (T || !O ? [Ss(h)] : Yv(h));
      !k && M !== "none" && P.push(...Uv(h, O, M, A));
      const D = [h, ...P], $ = await Sf(t, R), Y = [];
      let G = ((r = l.flip) == null ? void 0 : r.overflows) || [];
      if (v && Y.push($[C]), y) {
        const ne = Vv(a, u, A);
        Y.push($[ne[0]], $[ne[1]]);
      }
      if (G = [...G, {
        placement: a,
        overflows: Y
      }], !Y.every((ne) => ne <= 0)) {
        var ee, X;
        const ne = (((ee = l.flip) == null ? void 0 : ee.index) || 0) + 1, se = D[ne];
        if (se)
          return {
            data: {
              index: ne,
              overflows: G
            },
            reset: {
              placement: se
            }
          };
        let re = (X = G.filter((Q) => Q.overflows[0] <= 0).sort((Q, ke) => Q.overflows[1] - ke.overflows[1])[0]) == null ? void 0 : X.placement;
        if (!re)
          switch (x) {
            case "bestFit": {
              var ae;
              const Q = (ae = G.map((ke) => [ke.placement, ke.overflows.filter((Ae) => Ae > 0).reduce((Ae, pe) => Ae + pe, 0)]).sort((ke, Ae) => ke[1] - Ae[1])[0]) == null ? void 0 : ae[0];
              Q && (re = Q);
              break;
            }
            case "initialPlacement":
              re = h;
              break;
          }
        if (a !== re)
          return {
            reset: {
              placement: re
            }
          };
      }
      return {};
    }
  };
};
async function Kv(e, t) {
  const {
    placement: n,
    platform: r,
    elements: a
  } = e, l = await (r.isRTL == null ? void 0 : r.isRTL(a.floating)), u = Or(n), h = Zs(n), f = Ws(n) === "y", m = ["left", "top"].includes(u) ? -1 : 1, v = l && f ? -1 : 1, y = Us(t, e);
  let {
    mainAxis: k,
    crossAxis: x,
    alignmentAxis: M
  } = typeof y == "number" ? {
    mainAxis: y,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...y
  };
  return h && typeof M == "number" && (x = h === "end" ? M * -1 : M), f ? {
    x: x * v,
    y: k * m
  } : {
    x: k * m,
    y: x * v
  };
}
const Jv = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, r;
      const {
        x: a,
        y: l,
        placement: u,
        middlewareData: h
      } = t, f = await Kv(t, e);
      return u === ((n = h.offset) == null ? void 0 : n.placement) && (r = h.arrow) != null && r.alignmentOffset ? {} : {
        x: a + f.x,
        y: l + f.y,
        data: {
          ...f,
          placement: u
        }
      };
    }
  };
}, Xv = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r,
        placement: a
      } = t, {
        mainAxis: l = !0,
        crossAxis: u = !1,
        limiter: h = {
          fn: (R) => {
            let {
              x: C,
              y: T
            } = R;
            return {
              x: C,
              y: T
            };
          }
        },
        ...f
      } = Us(e, t), m = {
        x: n,
        y: r
      }, v = await Sf(t, f), y = Ws(Or(a)), k = xf(y);
      let x = m[k], M = m[y];
      if (l) {
        const R = k === "y" ? "top" : "left", C = k === "y" ? "bottom" : "right", T = x + v[R], A = x - v[C];
        x = Uc(T, x, A);
      }
      if (u) {
        const R = y === "y" ? "top" : "left", C = y === "y" ? "bottom" : "right", T = M + v[R], A = M - v[C];
        M = Uc(T, M, A);
      }
      const O = h.fn({
        ...t,
        [k]: x,
        [y]: M
      });
      return {
        ...O,
        data: {
          x: O.x - n,
          y: O.y - r
        }
      };
    }
  };
};
function Oi(e) {
  return _u(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function Tn(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function $i(e) {
  var t;
  return (t = (_u(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function _u(e) {
  return e instanceof Node || e instanceof Tn(e).Node;
}
function Ei(e) {
  return e instanceof Element || e instanceof Tn(e).Element;
}
function pi(e) {
  return e instanceof HTMLElement || e instanceof Tn(e).HTMLElement;
}
function Wc(e) {
  return typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof Tn(e).ShadowRoot;
}
function yo(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: a
  } = jn(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !["inline", "contents"].includes(a);
}
function Qv(e) {
  return ["table", "td", "th"].includes(Oi(e));
}
function yu(e) {
  const t = bu(), n = jn(e);
  return n.transform !== "none" || n.perspective !== "none" || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((r) => (n.willChange || "").includes(r)) || ["paint", "layout", "strict", "content"].some((r) => (n.contain || "").includes(r));
}
function e_(e) {
  let t = pa(e);
  for (; pi(t) && !Gs(t); ) {
    if (yu(t))
      return t;
    t = pa(t);
  }
  return null;
}
function bu() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function Gs(e) {
  return ["html", "body", "#document"].includes(Oi(e));
}
function jn(e) {
  return Tn(e).getComputedStyle(e);
}
function qs(e) {
  return Ei(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.pageXOffset,
    scrollTop: e.pageYOffset
  };
}
function pa(e) {
  if (Oi(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    Wc(e) && e.host || // Fallback.
    $i(e)
  );
  return Wc(t) ? t.host : t;
}
function Pf(e) {
  const t = pa(e);
  return Gs(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : pi(t) && yo(t) ? t : Pf(t);
}
function so(e, t, n) {
  var r;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const a = Pf(e), l = a === ((r = e.ownerDocument) == null ? void 0 : r.body), u = Tn(a);
  return l ? t.concat(u, u.visualViewport || [], yo(a) ? a : [], u.frameElement && n ? so(u.frameElement) : []) : t.concat(a, so(a, [], n));
}
function Cf(e) {
  const t = jn(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const a = pi(e), l = a ? e.offsetWidth : n, u = a ? e.offsetHeight : r, h = Ms(n) !== l || Ms(r) !== u;
  return h && (n = l, r = u), {
    width: n,
    height: r,
    $: h
  };
}
function wu(e) {
  return Ei(e) ? e : e.contextElement;
}
function ca(e) {
  const t = wu(e);
  if (!pi(t))
    return sr(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: a,
    $: l
  } = Cf(t);
  let u = (l ? Ms(n.width) : n.width) / r, h = (l ? Ms(n.height) : n.height) / a;
  return (!u || !Number.isFinite(u)) && (u = 1), (!h || !Number.isFinite(h)) && (h = 1), {
    x: u,
    y: h
  };
}
const t_ = /* @__PURE__ */ sr(0);
function Of(e) {
  const t = Tn(e);
  return !bu() || !t.visualViewport ? t_ : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function n_(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== Tn(e) ? !1 : t;
}
function Er(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const a = e.getBoundingClientRect(), l = wu(e);
  let u = sr(1);
  t && (r ? Ei(r) && (u = ca(r)) : u = ca(e));
  const h = n_(l, n, r) ? Of(l) : sr(0);
  let f = (a.left + h.x) / u.x, m = (a.top + h.y) / u.y, v = a.width / u.x, y = a.height / u.y;
  if (l) {
    const k = Tn(l), x = r && Ei(r) ? Tn(r) : r;
    let M = k.frameElement;
    for (; M && r && x !== k; ) {
      const O = ca(M), R = M.getBoundingClientRect(), C = jn(M), T = R.left + (M.clientLeft + parseFloat(C.paddingLeft)) * O.x, A = R.top + (M.clientTop + parseFloat(C.paddingTop)) * O.y;
      f *= O.x, m *= O.y, v *= O.x, y *= O.y, f += T, m += A, M = Tn(M).frameElement;
    }
  }
  return Ps({
    width: v,
    height: y,
    x: f,
    y: m
  });
}
function i_(e) {
  let {
    rect: t,
    offsetParent: n,
    strategy: r
  } = e;
  const a = pi(n), l = $i(n);
  if (n === l)
    return t;
  let u = {
    scrollLeft: 0,
    scrollTop: 0
  }, h = sr(1);
  const f = sr(0);
  if ((a || !a && r !== "fixed") && ((Oi(n) !== "body" || yo(l)) && (u = qs(n)), pi(n))) {
    const m = Er(n);
    h = ca(n), f.x = m.x + n.clientLeft, f.y = m.y + n.clientTop;
  }
  return {
    width: t.width * h.x,
    height: t.height * h.y,
    x: t.x * h.x - u.scrollLeft * h.x + f.x,
    y: t.y * h.y - u.scrollTop * h.y + f.y
  };
}
function r_(e) {
  return Array.from(e.getClientRects());
}
function Ef(e) {
  return Er($i(e)).left + qs(e).scrollLeft;
}
function a_(e) {
  const t = $i(e), n = qs(e), r = e.ownerDocument.body, a = Sr(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), l = Sr(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight);
  let u = -n.scrollLeft + Ef(e);
  const h = -n.scrollTop;
  return jn(r).direction === "rtl" && (u += Sr(t.clientWidth, r.clientWidth) - a), {
    width: a,
    height: l,
    x: u,
    y: h
  };
}
function o_(e, t) {
  const n = Tn(e), r = $i(e), a = n.visualViewport;
  let l = r.clientWidth, u = r.clientHeight, h = 0, f = 0;
  if (a) {
    l = a.width, u = a.height;
    const m = bu();
    (!m || m && t === "fixed") && (h = a.offsetLeft, f = a.offsetTop);
  }
  return {
    width: l,
    height: u,
    x: h,
    y: f
  };
}
function s_(e, t) {
  const n = Er(e, !0, t === "fixed"), r = n.top + e.clientTop, a = n.left + e.clientLeft, l = pi(e) ? ca(e) : sr(1), u = e.clientWidth * l.x, h = e.clientHeight * l.y, f = a * l.x, m = r * l.y;
  return {
    width: u,
    height: h,
    x: f,
    y: m
  };
}
function Gc(e, t, n) {
  let r;
  if (t === "viewport")
    r = o_(e, n);
  else if (t === "document")
    r = a_($i(e));
  else if (Ei(t))
    r = s_(t, n);
  else {
    const a = Of(e);
    r = {
      ...t,
      x: t.x - a.x,
      y: t.y - a.y
    };
  }
  return Ps(r);
}
function Tf(e, t) {
  const n = pa(e);
  return n === t || !Ei(n) || Gs(n) ? !1 : jn(n).position === "fixed" || Tf(n, t);
}
function l_(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let r = so(e, [], !1).filter((h) => Ei(h) && Oi(h) !== "body"), a = null;
  const l = jn(e).position === "fixed";
  let u = l ? pa(e) : e;
  for (; Ei(u) && !Gs(u); ) {
    const h = jn(u), f = yu(u);
    !f && h.position === "fixed" && (a = null), (l ? !f && !a : !f && h.position === "static" && !!a && ["absolute", "fixed"].includes(a.position) || yo(u) && !f && Tf(e, u)) ? r = r.filter((v) => v !== u) : a = h, u = pa(u);
  }
  return t.set(e, r), r;
}
function u_(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: a
  } = e;
  const u = [...n === "clippingAncestors" ? l_(t, this._c) : [].concat(n), r], h = u[0], f = u.reduce((m, v) => {
    const y = Gc(t, v, a);
    return m.top = Sr(y.top, m.top), m.right = Ls(y.right, m.right), m.bottom = Ls(y.bottom, m.bottom), m.left = Sr(y.left, m.left), m;
  }, Gc(t, h, a));
  return {
    width: f.right - f.left,
    height: f.bottom - f.top,
    x: f.left,
    y: f.top
  };
}
function c_(e) {
  const {
    width: t,
    height: n
  } = Cf(e);
  return {
    width: t,
    height: n
  };
}
function h_(e, t, n) {
  const r = pi(t), a = $i(t), l = n === "fixed", u = Er(e, !0, l, t);
  let h = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const f = sr(0);
  if (r || !r && !l)
    if ((Oi(t) !== "body" || yo(a)) && (h = qs(t)), r) {
      const m = Er(t, !0, l, t);
      f.x = m.x + t.clientLeft, f.y = m.y + t.clientTop;
    } else
      a && (f.x = Ef(a));
  return {
    x: u.left + h.scrollLeft - f.x,
    y: u.top + h.scrollTop - f.y,
    width: u.width,
    height: u.height
  };
}
function qc(e, t) {
  return !pi(e) || jn(e).position === "fixed" ? null : t ? t(e) : e.offsetParent;
}
function Df(e, t) {
  const n = Tn(e);
  if (!pi(e))
    return n;
  let r = qc(e, t);
  for (; r && Qv(r) && jn(r).position === "static"; )
    r = qc(r, t);
  return r && (Oi(r) === "html" || Oi(r) === "body" && jn(r).position === "static" && !yu(r)) ? n : r || e_(e) || n;
}
const d_ = async function(e) {
  let {
    reference: t,
    floating: n,
    strategy: r
  } = e;
  const a = this.getOffsetParent || Df, l = this.getDimensions;
  return {
    reference: h_(t, await a(n), r),
    floating: {
      x: 0,
      y: 0,
      ...await l(n)
    }
  };
};
function f_(e) {
  return jn(e).direction === "rtl";
}
const p_ = {
  convertOffsetParentRelativeRectToViewportRelativeRect: i_,
  getDocumentElement: $i,
  getClippingRect: u_,
  getOffsetParent: Df,
  getElementRects: d_,
  getClientRects: r_,
  getDimensions: c_,
  getScale: ca,
  isElement: Ei,
  isRTL: f_
};
function m_(e, t) {
  let n = null, r;
  const a = $i(e);
  function l() {
    clearTimeout(r), n && n.disconnect(), n = null;
  }
  function u(h, f) {
    h === void 0 && (h = !1), f === void 0 && (f = 1), l();
    const {
      left: m,
      top: v,
      width: y,
      height: k
    } = e.getBoundingClientRect();
    if (h || t(), !y || !k)
      return;
    const x = Go(v), M = Go(a.clientWidth - (m + y)), O = Go(a.clientHeight - (v + k)), R = Go(m), T = {
      rootMargin: -x + "px " + -M + "px " + -O + "px " + -R + "px",
      threshold: Sr(0, Ls(1, f)) || 1
    };
    let A = !0;
    function P(D) {
      const $ = D[0].intersectionRatio;
      if ($ !== f) {
        if (!A)
          return u();
        $ ? u(!1, $) : r = setTimeout(() => {
          u(!1, 1e-7);
        }, 100);
      }
      A = !1;
    }
    try {
      n = new IntersectionObserver(P, {
        ...T,
        // Handle <iframe>s
        root: a.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(P, T);
    }
    n.observe(e);
  }
  return u(!0), l;
}
function g_(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: a = !0,
    ancestorResize: l = !0,
    elementResize: u = typeof ResizeObserver == "function",
    layoutShift: h = typeof IntersectionObserver == "function",
    animationFrame: f = !1
  } = r, m = wu(e), v = a || l ? [...m ? so(m) : [], ...so(t)] : [];
  v.forEach((C) => {
    a && C.addEventListener("scroll", n, {
      passive: !0
    }), l && C.addEventListener("resize", n);
  });
  const y = m && h ? m_(m, n) : null;
  let k = -1, x = null;
  u && (x = new ResizeObserver((C) => {
    let [T] = C;
    T && T.target === m && x && (x.unobserve(t), cancelAnimationFrame(k), k = requestAnimationFrame(() => {
      x && x.observe(t);
    })), n();
  }), m && !f && x.observe(m), x.observe(t));
  let M, O = f ? Er(e) : null;
  f && R();
  function R() {
    const C = Er(e);
    O && (C.x !== O.x || C.y !== O.y || C.width !== O.width || C.height !== O.height) && n(), O = C, M = requestAnimationFrame(R);
  }
  return n(), () => {
    v.forEach((C) => {
      a && C.removeEventListener("scroll", n), l && C.removeEventListener("resize", n);
    }), y && y(), x && x.disconnect(), x = null, f && cancelAnimationFrame(M);
  };
}
const v_ = Xv, __ = qv, y_ = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), a = {
    platform: p_,
    ...n
  }, l = {
    ...a.platform,
    _c: r
  };
  return Gv(e, t, {
    ...a,
    platform: l
  });
};
function b_(e) {
  return e != null && {}.hasOwnProperty.call(e, "$el");
}
function Kc(e) {
  if (b_(e)) {
    const t = e.$el;
    return _u(t) && Oi(t) === "#comment" ? null : t;
  }
  return e;
}
function If(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Jc(e, t) {
  const n = If(e);
  return Math.round(t * n) / n;
}
function w_(e, t, n) {
  n === void 0 && (n = {});
  const r = n.whileElementsMounted, a = te(() => {
    var Y;
    return (Y = he(n.open)) != null ? Y : !0;
  }), l = te(() => he(n.middleware)), u = te(() => {
    var Y;
    return (Y = he(n.placement)) != null ? Y : "bottom";
  }), h = te(() => {
    var Y;
    return (Y = he(n.strategy)) != null ? Y : "absolute";
  }), f = te(() => {
    var Y;
    return (Y = he(n.transform)) != null ? Y : !0;
  }), m = te(() => Kc(e.value)), v = te(() => Kc(t.value)), y = je(0), k = je(0), x = je(h.value), M = je(u.value), O = yf({}), R = je(!1), C = te(() => {
    const Y = {
      position: x.value,
      left: "0",
      top: "0"
    };
    if (!v.value)
      return Y;
    const G = Jc(v.value, y.value), ee = Jc(v.value, k.value);
    return f.value ? {
      ...Y,
      transform: "translate(" + G + "px, " + ee + "px)",
      ...If(v.value) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: x.value,
      left: G + "px",
      top: ee + "px"
    };
  });
  let T;
  function A() {
    m.value == null || v.value == null || y_(m.value, v.value, {
      middleware: l.value,
      placement: u.value,
      strategy: h.value
    }).then((Y) => {
      y.value = Y.x, k.value = Y.y, x.value = Y.strategy, M.value = Y.placement, O.value = Y.middlewareData, R.value = !0;
    });
  }
  function P() {
    typeof T == "function" && (T(), T = void 0);
  }
  function D() {
    if (P(), r === void 0) {
      A();
      return;
    }
    if (m.value != null && v.value != null) {
      T = r(m.value, v.value, A);
      return;
    }
  }
  function $() {
    a.value || (R.value = !1);
  }
  return kt([l, u, h], A, {
    flush: "sync"
  }), kt([m, v], D, {
    flush: "sync"
  }), kt(a, $, {
    flush: "sync"
  }), bf() && pu(P), {
    x: ea(y),
    y: ea(k),
    strategy: ea(x),
    placement: ea(M),
    middlewareData: ea(O),
    isPositioned: ea(R),
    floatingStyles: C,
    update: A
  };
}
function k_(e) {
  return bf() ? (pu(e), !0) : !1;
}
function Af(e) {
  return typeof e == "function" ? e() : he(e);
}
const Rf = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const x_ = Object.prototype.toString, L_ = (e) => x_.call(e) === "[object Object]", cs = () => {
}, M_ = /* @__PURE__ */ S_();
function S_() {
  var e, t;
  return Rf && ((e = window == null ? void 0 : window.navigator) == null ? void 0 : e.userAgent) && (/iP(ad|hone|od)/.test(window.navigator.userAgent) || ((t = window == null ? void 0 : window.navigator) == null ? void 0 : t.maxTouchPoints) > 2 && /iPad|Macintosh/.test(window == null ? void 0 : window.navigator.userAgent));
}
function Qa(e) {
  var t;
  const n = Af(e);
  return (t = n == null ? void 0 : n.$el) != null ? t : n;
}
const Bf = Rf ? window : void 0;
function Ml(...e) {
  let t, n, r, a;
  if (typeof e[0] == "string" || Array.isArray(e[0]) ? ([n, r, a] = e, t = Bf) : [t, n, r, a] = e, !t)
    return cs;
  Array.isArray(n) || (n = [n]), Array.isArray(r) || (r = [r]);
  const l = [], u = () => {
    l.forEach((v) => v()), l.length = 0;
  }, h = (v, y, k, x) => (v.addEventListener(y, k, x), () => v.removeEventListener(y, k, x)), f = kt(
    () => [Qa(t), Af(a)],
    ([v, y]) => {
      if (u(), !v)
        return;
      const k = L_(y) ? { ...y } : y;
      l.push(
        ...n.flatMap((x) => r.map((M) => h(v, x, M, k)))
      );
    },
    { immediate: !0, flush: "post" }
  ), m = () => {
    f(), u();
  };
  return k_(m), m;
}
let Xc = !1;
function P_(e, t, n = {}) {
  const { window: r = Bf, ignore: a = [], capture: l = !0, detectIframe: u = !1 } = n;
  if (!r)
    return cs;
  M_ && !Xc && (Xc = !0, Array.from(r.document.body.children).forEach((k) => k.addEventListener("click", cs)), r.document.documentElement.addEventListener("click", cs));
  let h = !0;
  const f = (k) => a.some((x) => {
    if (typeof x == "string")
      return Array.from(r.document.querySelectorAll(x)).some((M) => M === k.target || k.composedPath().includes(M));
    {
      const M = Qa(x);
      return M && (k.target === M || k.composedPath().includes(M));
    }
  }), v = [
    Ml(r, "click", (k) => {
      const x = Qa(e);
      if (!(!x || x === k.target || k.composedPath().includes(x))) {
        if (k.detail === 0 && (h = !f(k)), !h) {
          h = !0;
          return;
        }
        t(k);
      }
    }, { passive: !0, capture: l }),
    Ml(r, "pointerdown", (k) => {
      const x = Qa(e);
      h = !f(k) && !!(x && !k.composedPath().includes(x));
    }, { passive: !0 }),
    u && Ml(r, "blur", (k) => {
      setTimeout(() => {
        var x;
        const M = Qa(e);
        ((x = r.document.activeElement) == null ? void 0 : x.tagName) === "IFRAME" && !(M != null && M.contains(r.document.activeElement)) && t(k);
      }, 0);
    })
  ].filter(Boolean);
  return () => v.forEach((k) => k());
}
const C_ = /* @__PURE__ */ tt({
  __name: "VoyagerPopper",
  setup(e) {
    const t = je(null), n = je(null), r = je(!1), { x: a, y: l, strategy: u } = w_(t, n, {
      placement: "bottom",
      middleware: [__(), v_(), Jv(10)],
      whileElementsMounted: g_
    }), h = () => {
      r.value = !r.value;
    };
    return P_(n, () => r.value = !1, {
      ignore: [t]
    }), (m, v) => (we(), Te("div", null, [
      xe("button", {
        onClick: h,
        class: "toggle-trigger v-button",
        ref_key: "floatingTrigger",
        ref: t,
        "data-ts": "popper-trigger"
      }, [
        Xt(m.$slots, "default", {}, void 0, !0)
      ], 512),
      r.value ? (we(), Te("div", {
        key: 0,
        ref_key: "floatingContent",
        ref: n,
        class: "toggle-content",
        "data-ts": "popper-content",
        style: la({
          position: he(u),
          top: `${he(l) ?? 0}px`,
          left: `${he(a) ?? 0}px`
          // display: showContent ? 'block' : 'none'
        })
      }, [
        Xt(m.$slots, "content", {}, void 0, !0)
      ], 4)) : vt("", !0)
    ]));
  }
}), ur = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [r, a] of t)
    n[r] = a;
  return n;
}, ku = /* @__PURE__ */ ur(C_, [["__scopeId", "data-v-88cff263"]]);
var O_ = {
  name: "AdjustmentsHorizontalIcon",
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const e = this.$props.size + "px", t = this.$data.attrs || {}, n = {
      width: t.width || e,
      height: t.height || e
    };
    return ce("svg", Qt({
      xmlns: "http://www.w3.org/2000/svg",
      class: "icon-tabler icon-tabler-adjustments-horizontal",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      "stroke-width": "2",
      stroke: "currentColor",
      fill: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, n), [Se("   "), ce("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }, null), Se("   "), ce("path", {
      d: "M14 6m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), Se("   "), ce("path", {
      d: "M4 6l8 0"
    }, null), Se("   "), ce("path", {
      d: "M16 6l4 0"
    }, null), Se("   "), ce("path", {
      d: "M8 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), Se("   "), ce("path", {
      d: "M4 12l2 0"
    }, null), Se("   "), ce("path", {
      d: "M10 12l10 0"
    }, null), Se("   "), ce("path", {
      d: "M17 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), Se("   "), ce("path", {
      d: "M4 18l11 0"
    }, null), Se("   "), ce("path", {
      d: "M19 18l1 0"
    }, null), Se(" ")]);
  }
}, E_ = {
  name: "AffiliateIcon",
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const e = this.$props.size + "px", t = this.$data.attrs || {}, n = {
      width: t.width || e,
      height: t.height || e
    };
    return ce("svg", Qt({
      xmlns: "http://www.w3.org/2000/svg",
      class: "icon-tabler icon-tabler-affiliate",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      "stroke-width": "2",
      stroke: "currentColor",
      fill: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, n), [Se("   "), ce("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }, null), Se("   "), ce("path", {
      d: "M5.931 6.936l1.275 4.249m5.607 5.609l4.251 1.275"
    }, null), Se("   "), ce("path", {
      d: "M11.683 12.317l5.759 -5.759"
    }, null), Se("   "), ce("path", {
      d: "M5.5 5.5m-1.5 0a1.5 1.5 0 1 0 3 0a1.5 1.5 0 1 0 -3 0"
    }, null), Se("   "), ce("path", {
      d: "M18.5 5.5m-1.5 0a1.5 1.5 0 1 0 3 0a1.5 1.5 0 1 0 -3 0"
    }, null), Se("   "), ce("path", {
      d: "M18.5 18.5m-1.5 0a1.5 1.5 0 1 0 3 0a1.5 1.5 0 1 0 -3 0"
    }, null), Se("   "), ce("path", {
      d: "M8.5 15.5m-4.5 0a4.5 4.5 0 1 0 9 0a4.5 4.5 0 1 0 -9 0"
    }, null), Se(" ")]);
  }
}, Qc = {
  name: "CalendarIcon",
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const e = this.$props.size + "px", t = this.$data.attrs || {}, n = {
      width: t.width || e,
      height: t.height || e
    };
    return ce("svg", Qt({
      xmlns: "http://www.w3.org/2000/svg",
      class: "icon-tabler icon-tabler-calendar",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      "stroke-width": "2",
      stroke: "currentColor",
      fill: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, n), [Se("   "), ce("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }, null), Se("   "), ce("path", {
      d: "M4 7a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12z"
    }, null), Se("   "), ce("path", {
      d: "M16 3v4"
    }, null), Se("   "), ce("path", {
      d: "M8 3v4"
    }, null), Se("   "), ce("path", {
      d: "M4 11h16"
    }, null), Se("   "), ce("path", {
      d: "M11 15h1"
    }, null), Se("   "), ce("path", {
      d: "M12 15v3"
    }, null), Se(" ")]);
  }
}, T_ = {
  name: "ChevronDownIcon",
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const e = this.$props.size + "px", t = this.$data.attrs || {}, n = {
      width: t.width || e,
      height: t.height || e
    };
    return ce("svg", Qt({
      xmlns: "http://www.w3.org/2000/svg",
      class: "icon-tabler icon-tabler-chevron-down",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      "stroke-width": "2",
      stroke: "currentColor",
      fill: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, n), [Se("   "), ce("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }, null), Se("   "), ce("path", {
      d: "M6 9l6 6l6 -6"
    }, null), Se(" ")]);
  }
}, D_ = {
  name: "ChevronLeftIcon",
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const e = this.$props.size + "px", t = this.$data.attrs || {}, n = {
      width: t.width || e,
      height: t.height || e
    };
    return ce("svg", Qt({
      xmlns: "http://www.w3.org/2000/svg",
      class: "icon-tabler icon-tabler-chevron-left",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      "stroke-width": "2",
      stroke: "currentColor",
      fill: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, n), [Se("   "), ce("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }, null), Se("   "), ce("path", {
      d: "M15 6l-6 6l6 6"
    }, null), Se(" ")]);
  }
}, $f = {
  name: "ChevronRightIcon",
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const e = this.$props.size + "px", t = this.$data.attrs || {}, n = {
      width: t.width || e,
      height: t.height || e
    };
    return ce("svg", Qt({
      xmlns: "http://www.w3.org/2000/svg",
      class: "icon-tabler icon-tabler-chevron-right",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      "stroke-width": "2",
      stroke: "currentColor",
      fill: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, n), [Se("   "), ce("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }, null), Se("   "), ce("path", {
      d: "M9 6l6 6l-6 6"
    }, null), Se(" ")]);
  }
}, I_ = {
  name: "CopyIcon",
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const e = this.$props.size + "px", t = this.$data.attrs || {}, n = {
      width: t.width || e,
      height: t.height || e
    };
    return ce("svg", Qt({
      xmlns: "http://www.w3.org/2000/svg",
      class: "icon-tabler icon-tabler-copy",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      "stroke-width": "2",
      stroke: "currentColor",
      fill: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, n), [Se("   "), ce("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }, null), Se("   "), ce("path", {
      d: "M8 8m0 2a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2z"
    }, null), Se("   "), ce("path", {
      d: "M16 8v-2a2 2 0 0 0 -2 -2h-8a2 2 0 0 0 -2 2v8a2 2 0 0 0 2 2h2"
    }, null), Se(" ")]);
  }
}, A_ = {
  name: "DownloadIcon",
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const e = this.$props.size + "px", t = this.$data.attrs || {}, n = {
      width: t.width || e,
      height: t.height || e
    };
    return ce("svg", Qt({
      xmlns: "http://www.w3.org/2000/svg",
      class: "icon-tabler icon-tabler-download",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      "stroke-width": "2",
      stroke: "currentColor",
      fill: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, n), [Se("   "), ce("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }, null), Se("   "), ce("path", {
      d: "M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-2"
    }, null), Se("   "), ce("path", {
      d: "M7 11l5 5l5 -5"
    }, null), Se("   "), ce("path", {
      d: "M12 4l0 12"
    }, null), Se(" ")]);
  }
}, R_ = {
  name: "EyeClosedIcon",
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const e = this.$props.size + "px", t = this.$data.attrs || {}, n = {
      width: t.width || e,
      height: t.height || e
    };
    return ce("svg", Qt({
      xmlns: "http://www.w3.org/2000/svg",
      class: "icon-tabler icon-tabler-eye-closed",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      "stroke-width": "2",
      stroke: "currentColor",
      fill: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, n), [Se("   "), ce("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }, null), Se("   "), ce("path", {
      d: "M21 9c-2.4 2.667 -5.4 4 -9 4c-3.6 0 -6.6 -1.333 -9 -4"
    }, null), Se("   "), ce("path", {
      d: "M3 15l2.5 -3.8"
    }, null), Se("   "), ce("path", {
      d: "M21 14.976l-2.492 -3.776"
    }, null), Se("   "), ce("path", {
      d: "M9 17l.5 -4"
    }, null), Se("   "), ce("path", {
      d: "M15 17l-.5 -4"
    }, null), Se(" ")]);
  }
}, B_ = {
  name: "EyeIcon",
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const e = this.$props.size + "px", t = this.$data.attrs || {}, n = {
      width: t.width || e,
      height: t.height || e
    };
    return ce("svg", Qt({
      xmlns: "http://www.w3.org/2000/svg",
      class: "icon-tabler icon-tabler-eye",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      "stroke-width": "2",
      stroke: "currentColor",
      fill: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, n), [Se("   "), ce("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }, null), Se("   "), ce("path", {
      d: "M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0"
    }, null), Se("   "), ce("path", {
      d: "M21 12c-2.4 4 -5.4 6 -9 6c-3.6 0 -6.6 -2 -9 -6c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6"
    }, null), Se(" ")]);
  }
}, $_ = {
  name: "MapIcon",
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const e = this.$props.size + "px", t = this.$data.attrs || {}, n = {
      width: t.width || e,
      height: t.height || e
    };
    return ce("svg", Qt({
      xmlns: "http://www.w3.org/2000/svg",
      class: "icon-tabler icon-tabler-map",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      "stroke-width": "2",
      stroke: "currentColor",
      fill: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, n), [Se("   "), ce("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }, null), Se("   "), ce("path", {
      d: "M3 7l6 -3l6 3l6 -3l0 13l-6 3l-6 -3l-6 3l0 -13"
    }, null), Se("   "), ce("path", {
      d: "M9 4l0 13"
    }, null), Se("   "), ce("path", {
      d: "M15 7l0 13"
    }, null), Se(" ")]);
  }
}, N_ = {
  name: "MinusIcon",
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const e = this.$props.size + "px", t = this.$data.attrs || {}, n = {
      width: t.width || e,
      height: t.height || e
    };
    return ce("svg", Qt({
      xmlns: "http://www.w3.org/2000/svg",
      class: "icon-tabler icon-tabler-minus",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      "stroke-width": "2",
      stroke: "currentColor",
      fill: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, n), [Se("   "), ce("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }, null), Se("   "), ce("path", {
      d: "M5 12l14 0"
    }, null), Se(" ")]);
  }
}, Nf = {
  name: "PlusIcon",
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const e = this.$props.size + "px", t = this.$data.attrs || {}, n = {
      width: t.width || e,
      height: t.height || e
    };
    return ce("svg", Qt({
      xmlns: "http://www.w3.org/2000/svg",
      class: "icon-tabler icon-tabler-plus",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      "stroke-width": "2",
      stroke: "currentColor",
      fill: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, n), [Se("   "), ce("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }, null), Se("   "), ce("path", {
      d: "M12 5l0 14"
    }, null), Se("   "), ce("path", {
      d: "M5 12l14 0"
    }, null), Se(" ")]);
  }
}, z_ = {
  name: "SearchIcon",
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const e = this.$props.size + "px", t = this.$data.attrs || {}, n = {
      width: t.width || e,
      height: t.height || e
    };
    return ce("svg", Qt({
      xmlns: "http://www.w3.org/2000/svg",
      class: "icon-tabler icon-tabler-search",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      "stroke-width": "2",
      stroke: "currentColor",
      fill: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, n), [Se("   "), ce("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }, null), Se("   "), ce("path", {
      d: "M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0"
    }, null), Se("   "), ce("path", {
      d: "M21 21l-6 -6"
    }, null), Se(" ")]);
  }
}, F_ = {
  name: "WandIcon",
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const e = this.$props.size + "px", t = this.$data.attrs || {}, n = {
      width: t.width || e,
      height: t.height || e
    };
    return ce("svg", Qt({
      xmlns: "http://www.w3.org/2000/svg",
      class: "icon-tabler icon-tabler-wand",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      "stroke-width": "2",
      stroke: "currentColor",
      fill: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, n), [Se("   "), ce("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }, null), Se("   "), ce("path", {
      d: "M6 21l15 -15l-3 -3l-15 15l3 3"
    }, null), Se("   "), ce("path", {
      d: "M15 6l3 3"
    }, null), Se("   "), ce("path", {
      d: "M9 3a2 2 0 0 0 2 2a2 2 0 0 0 -2 2a2 2 0 0 0 -2 -2a2 2 0 0 0 2 -2"
    }, null), Se("   "), ce("path", {
      d: "M19 13a2 2 0 0 0 2 2a2 2 0 0 0 -2 2a2 2 0 0 0 -2 -2a2 2 0 0 0 2 -2"
    }, null), Se(" ")]);
  }
}, j_ = {
  name: "XIcon",
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const e = this.$props.size + "px", t = this.$data.attrs || {}, n = {
      width: t.width || e,
      height: t.height || e
    };
    return ce("svg", Qt({
      xmlns: "http://www.w3.org/2000/svg",
      class: "icon-tabler icon-tabler-x",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      "stroke-width": "2",
      stroke: "currentColor",
      fill: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, n), [Se("   "), ce("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }, null), Se("   "), ce("path", {
      d: "M18 6l-12 12"
    }, null), Se("   "), ce("path", {
      d: "M6 6l12 12"
    }, null), Se(" ")]);
  }
};
const V_ = { class: "voyager-popper__container" }, Y_ = ["data-ts"], H_ = {
  class: "voyager-popper-trigger",
  "data-ts": "splitbutton-trigger"
}, U_ = ["onClick", "data-ts"], Z_ = /* @__PURE__ */ tt({
  __name: "VoyagerSplitButton",
  props: {
    items: {
      type: Array,
      required: !0
    }
  },
  setup(e) {
    const t = e;
    let n = [];
    const r = te(() => n.slice(1, n.length));
    return kt(t.items, (a) => {
      n = a;
    }, { deep: !0, immediate: !0 }), (a, l) => (we(), Te("div", V_, [
      xe("button", {
        onClick: l[0] || (l[0] = //@ts-ignore
        (...u) => e.items[0].command && e.items[0].command(...u)),
        class: gt(["popper__main-action v-button", e.items[0].class]),
        "data-ts": e.items[0].testTag
      }, [
        (we(), Ut(ao(e.items[0].icon))),
        Se(" " + _t(e.items[0].label), 1)
      ], 10, Y_),
      ce(ku, {
        onClick: l[1] || (l[1] = ws(() => {
        }, ["stop"])),
        class: "voyager-popper",
        style: { border: "none", "margin-left": "0px" }
      }, {
        content: Je(() => [
          (we(!0), Te(Et, null, rn(r.value, (u) => (we(), Te("div", {
            key: u.label
          }, [
            xe("div", {
              class: gt(["popper-options", u.class]),
              onClick: u.command,
              "data-ts": u.testTag
            }, [
              (we(), Ut(ao(u.icon))),
              Se(_t(u.label), 1)
            ], 10, U_)
          ]))), 128))
        ]),
        default: Je(() => [
          xe("span", H_, [
            ce(he(T_))
          ])
        ]),
        _: 1
      })
    ]));
  }
}), W_ = /* @__PURE__ */ ur(Z_, [["__scopeId", "data-v-394b2331"]]), G_ = ({ key: e, result: t, id: n }) => {
  var r;
  if (t)
    return ((r = t.display) == null ? void 0 : r[e]) || void 0;
}, q_ = ({ keys: e, result: t, id: n }) => {
  const r = [];
  return e.forEach((a) => {
    let l;
    t && (l = t.fields[a]), l && r.push(l);
  }), r;
}, aa = ({ displayKey: e, result: t }) => {
  let n;
  if (t !== void 0) {
    if (n = G_({ key: e, result: t }), n && Array.isArray(n))
      return q_({ keys: n, result: t });
    if (n !== void 0)
      return t.fields[n];
  }
}, K_ = ["src"], J_ = { class: "result-card__body" }, X_ = {
  class: "result-card__header",
  "data-ts": "card-header"
}, Q_ = {
  class: "result-card__content",
  "data-ts": "card-content"
}, ey = {
  key: 0,
  class: "result-card__footer",
  "data-ts": "card-footer"
}, zf = /* @__PURE__ */ tt({
  __name: "VoyagerCard",
  props: {
    result: {
      type: Object,
      required: !1
    },
    orientation: {
      type: String,
      required: !1,
      default: "vertical"
    },
    loading: {
      type: Boolean,
      required: !1,
      default: !1
    },
    isInCart: {
      type: Boolean,
      required: !1,
      default: !1
    }
  },
  emits: ["userAction", "navigation", "query:add"],
  setup(e, { expose: t, emit: n }) {
    const r = e, a = {
      thumb: te(() => aa({ displayKey: "thumbnail", result: r.result })),
      header: te(() => aa({ displayKey: "header", result: r.result })),
      subheader: te(() => aa({ displayKey: "subheader", result: r.result })),
      content: te(() => aa({ displayKey: "content", result: r.result }))
    }, l = ({ key: k, primaryProperty: x = "valueDisplay" }) => {
      var M, O, R, C;
      if (k !== void 0 && (O = (M = a[k]) == null ? void 0 : M.value) != null && O[x])
        return (C = (R = a == null ? void 0 : a[k]) == null ? void 0 : R.value) == null ? void 0 : C[x];
    }, u = te(() => {
      var k, x;
      return ((x = (k = a.thumb) == null ? void 0 : k.value) == null ? void 0 : x.value) || "";
    }), h = n, f = () => {
      r.isInCart ? h("userAction", { action: "removeFromList", result: r.result }) : h("userAction", { action: "addToList", result: r.result });
    }, m = () => {
      h("userAction", { action: "view", result: r.result }), h("navigation", { location: "details", result: r.result });
    }, v = (k) => k ? h("query:add", k) : void 0, y = je([
      {
        label: te(() => r.isInCart ? "Remove" : "Add"),
        icon: te(() => r.isInCart ? Ua(N_) : Ua(Nf)),
        command: f,
        class: "result-card__tool-options",
        testTag: "card-add-action"
      },
      {
        label: "Download",
        icon: Ua(A_),
        command: () => h("userAction", { action: "download", result: r.result }),
        class: "result-card__tool-options",
        testTag: "card-download-action"
      },
      {
        label: "Open In ArcGIS Online",
        icon: Ua($_),
        command: () => h("userAction", { action: "openWith", app: "Agol", result: r.result }),
        class: "result-card__tool-options",
        testTag: "card-openWith-action"
      },
      {
        label: "More Like This",
        icon: Ua(E_),
        command: () => {
          h("userAction", { action: "moreLikeThis", result: r.result }), h("navigation", { location: "moreLikeThis", result: r.result });
        },
        class: "result-card__tool-options",
        testTag: "card-moreLikeThis-action"
      }
    ]);
    return t({ cardTools: y }), (k, x) => (we(), Te("div", {
      class: gt(["result-card", e.orientation])
    }, [
      Xt(k.$slots, "thumbnail", {}, () => [
        a.thumb !== void 0 ? (we(), Te("div", {
          key: 0,
          class: gt(["result-card__thumbnail", e.orientation]),
          "data-ts": "card-thumb"
        }, [
          xe("img", { src: u.value }, null, 8, K_)
        ], 2)) : vt("", !0)
      ]),
      xe("div", J_, [
        Xt(k.$slots, "header", {}, () => [
          xe("h3", X_, _t(l({ key: "header" })), 1)
        ]),
        Xt(k.$slots, "subheader", {}, () => [
          xe("h4", {
            class: "result-card__subheader",
            "data-ts": "card-subheader",
            onClick: x[0] || (x[0] = (M) => v(a.subheader.value))
          }, _t(l({ key: "subheader" })), 1)
        ]),
        Xt(k.$slots, "content", {}, () => [
          xe("p", Q_, _t(l({ key: "content" })), 1)
        ]),
        Xt(k.$slots, "tools", {}, () => [
          e.loading ? vt("", !0) : (we(), Te("footer", ey, [
            xe("button", {
              onClick: x[1] || (x[1] = (M) => m()),
              class: "result-card__tools v-button",
              "data-ts": "card-view-details"
            }, "View"),
            ce(W_, { items: y.value }, null, 8, ["items"])
          ]))
        ])
      ])
    ], 2));
  }
}), ty = { class: "result-tile__container" }, ny = ["src"], iy = { class: "result-tile__popover-card" }, ry = /* @__PURE__ */ xe("div", null, null, -1), W$ = /* @__PURE__ */ tt({
  __name: "VoyagerTile",
  props: {
    result: {
      type: Object,
      required: !1
    },
    isInCart: {
      type: Boolean,
      required: !1,
      default: !1
    }
  },
  emits: ["userAction", "navigation"],
  setup(e, { emit: t }) {
    const n = e, r = t, a = (h) => r("userAction", h), l = (h) => r("navigation", h), u = te(() => {
      const h = aa({ displayKey: "thumbnail", result: n.result });
      return !Array.isArray(h) && (h != null && h.value) && typeof (h == null ? void 0 : h.value) == "string" ? h == null ? void 0 : h.value : "";
    });
    return (h, f) => (we(), Te("div", ty, [
      ce(ku, { style: { border: "none", width: "100%" } }, {
        content: Je(() => [
          xe("div", iy, [
            ce(zf, {
              result: e.result,
              onUserAction: a,
              onNavigation: l
            }, {
              thumbnail: Je(() => [
                ry
              ]),
              _: 1
            }, 8, ["result"])
          ])
        ]),
        default: Je(() => [
          xe("div", {
            class: gt(["result-tile__thumbnail", e.isInCart ? "inCart" : void 0]),
            "data-ts": "tile-thumb"
          }, [
            xe("img", { src: u.value }, null, 8, ny)
          ], 2)
        ]),
        _: 1
      })
    ]));
  }
});
var ay = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Ff(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Ul = { exports: {} };
/* @preserve
 * Leaflet 1.9.4, a JS library for interactive maps. https://leafletjs.com
 * (c) 2010-2023 Vladimir Agafonkin, (c) 2010-2011 CloudMade
 */
(function(e, t) {
  (function(n, r) {
    r(t);
  })(ay, function(n) {
    var r = "1.9.4";
    function a(i) {
      var s, d, g, b;
      for (d = 1, g = arguments.length; d < g; d++) {
        b = arguments[d];
        for (s in b)
          i[s] = b[s];
      }
      return i;
    }
    var l = Object.create || /* @__PURE__ */ function() {
      function i() {
      }
      return function(s) {
        return i.prototype = s, new i();
      };
    }();
    function u(i, s) {
      var d = Array.prototype.slice;
      if (i.bind)
        return i.bind.apply(i, d.call(arguments, 1));
      var g = d.call(arguments, 2);
      return function() {
        return i.apply(s, g.length ? g.concat(d.call(arguments)) : arguments);
      };
    }
    var h = 0;
    function f(i) {
      return "_leaflet_id" in i || (i._leaflet_id = ++h), i._leaflet_id;
    }
    function m(i, s, d) {
      var g, b, I, W;
      return W = function() {
        g = !1, b && (I.apply(d, b), b = !1);
      }, I = function() {
        g ? b = arguments : (i.apply(d, arguments), setTimeout(W, s), g = !0);
      }, I;
    }
    function v(i, s, d) {
      var g = s[1], b = s[0], I = g - b;
      return i === g && d ? i : ((i - b) % I + I) % I + b;
    }
    function y() {
      return !1;
    }
    function k(i, s) {
      if (s === !1)
        return i;
      var d = Math.pow(10, s === void 0 ? 6 : s);
      return Math.round(i * d) / d;
    }
    function x(i) {
      return i.trim ? i.trim() : i.replace(/^\s+|\s+$/g, "");
    }
    function M(i) {
      return x(i).split(/\s+/);
    }
    function O(i, s) {
      Object.prototype.hasOwnProperty.call(i, "options") || (i.options = i.options ? l(i.options) : {});
      for (var d in s)
        i.options[d] = s[d];
      return i.options;
    }
    function R(i, s, d) {
      var g = [];
      for (var b in i)
        g.push(encodeURIComponent(d ? b.toUpperCase() : b) + "=" + encodeURIComponent(i[b]));
      return (!s || s.indexOf("?") === -1 ? "?" : "&") + g.join("&");
    }
    var C = /\{ *([\w_ -]+) *\}/g;
    function T(i, s) {
      return i.replace(C, function(d, g) {
        var b = s[g];
        if (b === void 0)
          throw new Error("No value provided for variable " + d);
        return typeof b == "function" && (b = b(s)), b;
      });
    }
    var A = Array.isArray || function(i) {
      return Object.prototype.toString.call(i) === "[object Array]";
    };
    function P(i, s) {
      for (var d = 0; d < i.length; d++)
        if (i[d] === s)
          return d;
      return -1;
    }
    var D = "data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=";
    function $(i) {
      return window["webkit" + i] || window["moz" + i] || window["ms" + i];
    }
    var Y = 0;
    function G(i) {
      var s = +/* @__PURE__ */ new Date(), d = Math.max(0, 16 - (s - Y));
      return Y = s + d, window.setTimeout(i, d);
    }
    var ee = window.requestAnimationFrame || $("RequestAnimationFrame") || G, X = window.cancelAnimationFrame || $("CancelAnimationFrame") || $("CancelRequestAnimationFrame") || function(i) {
      window.clearTimeout(i);
    };
    function ae(i, s, d) {
      if (d && ee === G)
        i.call(s);
      else
        return ee.call(window, u(i, s));
    }
    function ne(i) {
      i && X.call(window, i);
    }
    var se = {
      __proto__: null,
      extend: a,
      create: l,
      bind: u,
      get lastId() {
        return h;
      },
      stamp: f,
      throttle: m,
      wrapNum: v,
      falseFn: y,
      formatNum: k,
      trim: x,
      splitWords: M,
      setOptions: O,
      getParamString: R,
      template: T,
      isArray: A,
      indexOf: P,
      emptyImageUrl: D,
      requestFn: ee,
      cancelFn: X,
      requestAnimFrame: ae,
      cancelAnimFrame: ne
    };
    function re() {
    }
    re.extend = function(i) {
      var s = function() {
        O(this), this.initialize && this.initialize.apply(this, arguments), this.callInitHooks();
      }, d = s.__super__ = this.prototype, g = l(d);
      g.constructor = s, s.prototype = g;
      for (var b in this)
        Object.prototype.hasOwnProperty.call(this, b) && b !== "prototype" && b !== "__super__" && (s[b] = this[b]);
      return i.statics && a(s, i.statics), i.includes && (Q(i.includes), a.apply(null, [g].concat(i.includes))), a(g, i), delete g.statics, delete g.includes, g.options && (g.options = d.options ? l(d.options) : {}, a(g.options, i.options)), g._initHooks = [], g.callInitHooks = function() {
        if (!this._initHooksCalled) {
          d.callInitHooks && d.callInitHooks.call(this), this._initHooksCalled = !0;
          for (var I = 0, W = g._initHooks.length; I < W; I++)
            g._initHooks[I].call(this);
        }
      }, s;
    }, re.include = function(i) {
      var s = this.prototype.options;
      return a(this.prototype, i), i.options && (this.prototype.options = s, this.mergeOptions(i.options)), this;
    }, re.mergeOptions = function(i) {
      return a(this.prototype.options, i), this;
    }, re.addInitHook = function(i) {
      var s = Array.prototype.slice.call(arguments, 1), d = typeof i == "function" ? i : function() {
        this[i].apply(this, s);
      };
      return this.prototype._initHooks = this.prototype._initHooks || [], this.prototype._initHooks.push(d), this;
    };
    function Q(i) {
      if (!(typeof L > "u" || !L || !L.Mixin)) {
        i = A(i) ? i : [i];
        for (var s = 0; s < i.length; s++)
          i[s] === L.Mixin.Events && console.warn("Deprecated include of L.Mixin.Events: this property will be removed in future releases, please inherit from L.Evented instead.", new Error().stack);
      }
    }
    var ke = {
      /* @method on(type: String, fn: Function, context?: Object): this
       * Adds a listener function (`fn`) to a particular event type of the object. You can optionally specify the context of the listener (object the this keyword will point to). You can also pass several space-separated types (e.g. `'click dblclick'`).
       *
       * @alternative
       * @method on(eventMap: Object): this
       * Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
       */
      on: function(i, s, d) {
        if (typeof i == "object")
          for (var g in i)
            this._on(g, i[g], s);
        else {
          i = M(i);
          for (var b = 0, I = i.length; b < I; b++)
            this._on(i[b], s, d);
        }
        return this;
      },
      /* @method off(type: String, fn?: Function, context?: Object): this
       * Removes a previously added listener function. If no function is specified, it will remove all the listeners of that particular event from the object. Note that if you passed a custom context to `on`, you must pass the same context to `off` in order to remove the listener.
       *
       * @alternative
       * @method off(eventMap: Object): this
       * Removes a set of type/listener pairs.
       *
       * @alternative
       * @method off: this
       * Removes all listeners to all events on the object. This includes implicitly attached events.
       */
      off: function(i, s, d) {
        if (!arguments.length)
          delete this._events;
        else if (typeof i == "object")
          for (var g in i)
            this._off(g, i[g], s);
        else {
          i = M(i);
          for (var b = arguments.length === 1, I = 0, W = i.length; I < W; I++)
            b ? this._off(i[I]) : this._off(i[I], s, d);
        }
        return this;
      },
      // attach listener (without syntactic sugar now)
      _on: function(i, s, d, g) {
        if (typeof s != "function") {
          console.warn("wrong listener type: " + typeof s);
          return;
        }
        if (this._listens(i, s, d) === !1) {
          d === this && (d = void 0);
          var b = { fn: s, ctx: d };
          g && (b.once = !0), this._events = this._events || {}, this._events[i] = this._events[i] || [], this._events[i].push(b);
        }
      },
      _off: function(i, s, d) {
        var g, b, I;
        if (this._events && (g = this._events[i], !!g)) {
          if (arguments.length === 1) {
            if (this._firingCount)
              for (b = 0, I = g.length; b < I; b++)
                g[b].fn = y;
            delete this._events[i];
            return;
          }
          if (typeof s != "function") {
            console.warn("wrong listener type: " + typeof s);
            return;
          }
          var W = this._listens(i, s, d);
          if (W !== !1) {
            var le = g[W];
            this._firingCount && (le.fn = y, this._events[i] = g = g.slice()), g.splice(W, 1);
          }
        }
      },
      // @method fire(type: String, data?: Object, propagate?: Boolean): this
      // Fires an event of the specified type. You can optionally provide a data
      // object — the first argument of the listener function will contain its
      // properties. The event can optionally be propagated to event parents.
      fire: function(i, s, d) {
        if (!this.listens(i, d))
          return this;
        var g = a({}, s, {
          type: i,
          target: this,
          sourceTarget: s && s.sourceTarget || this
        });
        if (this._events) {
          var b = this._events[i];
          if (b) {
            this._firingCount = this._firingCount + 1 || 1;
            for (var I = 0, W = b.length; I < W; I++) {
              var le = b[I], de = le.fn;
              le.once && this.off(i, de, le.ctx), de.call(le.ctx || this, g);
            }
            this._firingCount--;
          }
        }
        return d && this._propagateEvent(g), this;
      },
      // @method listens(type: String, propagate?: Boolean): Boolean
      // @method listens(type: String, fn: Function, context?: Object, propagate?: Boolean): Boolean
      // Returns `true` if a particular event type has any listeners attached to it.
      // The verification can optionally be propagated, it will return `true` if parents have the listener attached to it.
      listens: function(i, s, d, g) {
        typeof i != "string" && console.warn('"string" type argument expected');
        var b = s;
        typeof s != "function" && (g = !!s, b = void 0, d = void 0);
        var I = this._events && this._events[i];
        if (I && I.length && this._listens(i, b, d) !== !1)
          return !0;
        if (g) {
          for (var W in this._eventParents)
            if (this._eventParents[W].listens(i, s, d, g))
              return !0;
        }
        return !1;
      },
      // returns the index (number) or false
      _listens: function(i, s, d) {
        if (!this._events)
          return !1;
        var g = this._events[i] || [];
        if (!s)
          return !!g.length;
        d === this && (d = void 0);
        for (var b = 0, I = g.length; b < I; b++)
          if (g[b].fn === s && g[b].ctx === d)
            return b;
        return !1;
      },
      // @method once(…): this
      // Behaves as [`on(…)`](#evented-on), except the listener will only get fired once and then removed.
      once: function(i, s, d) {
        if (typeof i == "object")
          for (var g in i)
            this._on(g, i[g], s, !0);
        else {
          i = M(i);
          for (var b = 0, I = i.length; b < I; b++)
            this._on(i[b], s, d, !0);
        }
        return this;
      },
      // @method addEventParent(obj: Evented): this
      // Adds an event parent - an `Evented` that will receive propagated events
      addEventParent: function(i) {
        return this._eventParents = this._eventParents || {}, this._eventParents[f(i)] = i, this;
      },
      // @method removeEventParent(obj: Evented): this
      // Removes an event parent, so it will stop receiving propagated events
      removeEventParent: function(i) {
        return this._eventParents && delete this._eventParents[f(i)], this;
      },
      _propagateEvent: function(i) {
        for (var s in this._eventParents)
          this._eventParents[s].fire(i.type, a({
            layer: i.target,
            propagatedFrom: i.target
          }, i), !0);
      }
    };
    ke.addEventListener = ke.on, ke.removeEventListener = ke.clearAllEventListeners = ke.off, ke.addOneTimeEventListener = ke.once, ke.fireEvent = ke.fire, ke.hasEventListeners = ke.listens;
    var Ae = re.extend(ke);
    function pe(i, s, d) {
      this.x = d ? Math.round(i) : i, this.y = d ? Math.round(s) : s;
    }
    var Ye = Math.trunc || function(i) {
      return i > 0 ? Math.floor(i) : Math.ceil(i);
    };
    pe.prototype = {
      // @method clone(): Point
      // Returns a copy of the current point.
      clone: function() {
        return new pe(this.x, this.y);
      },
      // @method add(otherPoint: Point): Point
      // Returns the result of addition of the current and the given points.
      add: function(i) {
        return this.clone()._add(ue(i));
      },
      _add: function(i) {
        return this.x += i.x, this.y += i.y, this;
      },
      // @method subtract(otherPoint: Point): Point
      // Returns the result of subtraction of the given point from the current.
      subtract: function(i) {
        return this.clone()._subtract(ue(i));
      },
      _subtract: function(i) {
        return this.x -= i.x, this.y -= i.y, this;
      },
      // @method divideBy(num: Number): Point
      // Returns the result of division of the current point by the given number.
      divideBy: function(i) {
        return this.clone()._divideBy(i);
      },
      _divideBy: function(i) {
        return this.x /= i, this.y /= i, this;
      },
      // @method multiplyBy(num: Number): Point
      // Returns the result of multiplication of the current point by the given number.
      multiplyBy: function(i) {
        return this.clone()._multiplyBy(i);
      },
      _multiplyBy: function(i) {
        return this.x *= i, this.y *= i, this;
      },
      // @method scaleBy(scale: Point): Point
      // Multiply each coordinate of the current point by each coordinate of
      // `scale`. In linear algebra terms, multiply the point by the
      // [scaling matrix](https://en.wikipedia.org/wiki/Scaling_%28geometry%29#Matrix_representation)
      // defined by `scale`.
      scaleBy: function(i) {
        return new pe(this.x * i.x, this.y * i.y);
      },
      // @method unscaleBy(scale: Point): Point
      // Inverse of `scaleBy`. Divide each coordinate of the current point by
      // each coordinate of `scale`.
      unscaleBy: function(i) {
        return new pe(this.x / i.x, this.y / i.y);
      },
      // @method round(): Point
      // Returns a copy of the current point with rounded coordinates.
      round: function() {
        return this.clone()._round();
      },
      _round: function() {
        return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
      },
      // @method floor(): Point
      // Returns a copy of the current point with floored coordinates (rounded down).
      floor: function() {
        return this.clone()._floor();
      },
      _floor: function() {
        return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this;
      },
      // @method ceil(): Point
      // Returns a copy of the current point with ceiled coordinates (rounded up).
      ceil: function() {
        return this.clone()._ceil();
      },
      _ceil: function() {
        return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this;
      },
      // @method trunc(): Point
      // Returns a copy of the current point with truncated coordinates (rounded towards zero).
      trunc: function() {
        return this.clone()._trunc();
      },
      _trunc: function() {
        return this.x = Ye(this.x), this.y = Ye(this.y), this;
      },
      // @method distanceTo(otherPoint: Point): Number
      // Returns the cartesian distance between the current and the given points.
      distanceTo: function(i) {
        i = ue(i);
        var s = i.x - this.x, d = i.y - this.y;
        return Math.sqrt(s * s + d * d);
      },
      // @method equals(otherPoint: Point): Boolean
      // Returns `true` if the given point has the same coordinates.
      equals: function(i) {
        return i = ue(i), i.x === this.x && i.y === this.y;
      },
      // @method contains(otherPoint: Point): Boolean
      // Returns `true` if both coordinates of the given point are less than the corresponding current point coordinates (in absolute values).
      contains: function(i) {
        return i = ue(i), Math.abs(i.x) <= Math.abs(this.x) && Math.abs(i.y) <= Math.abs(this.y);
      },
      // @method toString(): String
      // Returns a string representation of the point for debugging purposes.
      toString: function() {
        return "Point(" + k(this.x) + ", " + k(this.y) + ")";
      }
    };
    function ue(i, s, d) {
      return i instanceof pe ? i : A(i) ? new pe(i[0], i[1]) : i == null ? i : typeof i == "object" && "x" in i && "y" in i ? new pe(i.x, i.y) : new pe(i, s, d);
    }
    function Fe(i, s) {
      if (i)
        for (var d = s ? [i, s] : i, g = 0, b = d.length; g < b; g++)
          this.extend(d[g]);
    }
    Fe.prototype = {
      // @method extend(point: Point): this
      // Extends the bounds to contain the given point.
      // @alternative
      // @method extend(otherBounds: Bounds): this
      // Extend the bounds to contain the given bounds
      extend: function(i) {
        var s, d;
        if (!i)
          return this;
        if (i instanceof pe || typeof i[0] == "number" || "x" in i)
          s = d = ue(i);
        else if (i = Pe(i), s = i.min, d = i.max, !s || !d)
          return this;
        return !this.min && !this.max ? (this.min = s.clone(), this.max = d.clone()) : (this.min.x = Math.min(s.x, this.min.x), this.max.x = Math.max(d.x, this.max.x), this.min.y = Math.min(s.y, this.min.y), this.max.y = Math.max(d.y, this.max.y)), this;
      },
      // @method getCenter(round?: Boolean): Point
      // Returns the center point of the bounds.
      getCenter: function(i) {
        return ue(
          (this.min.x + this.max.x) / 2,
          (this.min.y + this.max.y) / 2,
          i
        );
      },
      // @method getBottomLeft(): Point
      // Returns the bottom-left point of the bounds.
      getBottomLeft: function() {
        return ue(this.min.x, this.max.y);
      },
      // @method getTopRight(): Point
      // Returns the top-right point of the bounds.
      getTopRight: function() {
        return ue(this.max.x, this.min.y);
      },
      // @method getTopLeft(): Point
      // Returns the top-left point of the bounds (i.e. [`this.min`](#bounds-min)).
      getTopLeft: function() {
        return this.min;
      },
      // @method getBottomRight(): Point
      // Returns the bottom-right point of the bounds (i.e. [`this.max`](#bounds-max)).
      getBottomRight: function() {
        return this.max;
      },
      // @method getSize(): Point
      // Returns the size of the given bounds
      getSize: function() {
        return this.max.subtract(this.min);
      },
      // @method contains(otherBounds: Bounds): Boolean
      // Returns `true` if the rectangle contains the given one.
      // @alternative
      // @method contains(point: Point): Boolean
      // Returns `true` if the rectangle contains the given point.
      contains: function(i) {
        var s, d;
        return typeof i[0] == "number" || i instanceof pe ? i = ue(i) : i = Pe(i), i instanceof Fe ? (s = i.min, d = i.max) : s = d = i, s.x >= this.min.x && d.x <= this.max.x && s.y >= this.min.y && d.y <= this.max.y;
      },
      // @method intersects(otherBounds: Bounds): Boolean
      // Returns `true` if the rectangle intersects the given bounds. Two bounds
      // intersect if they have at least one point in common.
      intersects: function(i) {
        i = Pe(i);
        var s = this.min, d = this.max, g = i.min, b = i.max, I = b.x >= s.x && g.x <= d.x, W = b.y >= s.y && g.y <= d.y;
        return I && W;
      },
      // @method overlaps(otherBounds: Bounds): Boolean
      // Returns `true` if the rectangle overlaps the given bounds. Two bounds
      // overlap if their intersection is an area.
      overlaps: function(i) {
        i = Pe(i);
        var s = this.min, d = this.max, g = i.min, b = i.max, I = b.x > s.x && g.x < d.x, W = b.y > s.y && g.y < d.y;
        return I && W;
      },
      // @method isValid(): Boolean
      // Returns `true` if the bounds are properly initialized.
      isValid: function() {
        return !!(this.min && this.max);
      },
      // @method pad(bufferRatio: Number): Bounds
      // Returns bounds created by extending or retracting the current bounds by a given ratio in each direction.
      // For example, a ratio of 0.5 extends the bounds by 50% in each direction.
      // Negative values will retract the bounds.
      pad: function(i) {
        var s = this.min, d = this.max, g = Math.abs(s.x - d.x) * i, b = Math.abs(s.y - d.y) * i;
        return Pe(
          ue(s.x - g, s.y - b),
          ue(d.x + g, d.y + b)
        );
      },
      // @method equals(otherBounds: Bounds): Boolean
      // Returns `true` if the rectangle is equivalent to the given bounds.
      equals: function(i) {
        return i ? (i = Pe(i), this.min.equals(i.getTopLeft()) && this.max.equals(i.getBottomRight())) : !1;
      }
    };
    function Pe(i, s) {
      return !i || i instanceof Fe ? i : new Fe(i, s);
    }
    function nt(i, s) {
      if (i)
        for (var d = s ? [i, s] : i, g = 0, b = d.length; g < b; g++)
          this.extend(d[g]);
    }
    nt.prototype = {
      // @method extend(latlng: LatLng): this
      // Extend the bounds to contain the given point
      // @alternative
      // @method extend(otherBounds: LatLngBounds): this
      // Extend the bounds to contain the given bounds
      extend: function(i) {
        var s = this._southWest, d = this._northEast, g, b;
        if (i instanceof Ze)
          g = i, b = i;
        else if (i instanceof nt) {
          if (g = i._southWest, b = i._northEast, !g || !b)
            return this;
        } else
          return i ? this.extend(Ne(i) || Ve(i)) : this;
        return !s && !d ? (this._southWest = new Ze(g.lat, g.lng), this._northEast = new Ze(b.lat, b.lng)) : (s.lat = Math.min(g.lat, s.lat), s.lng = Math.min(g.lng, s.lng), d.lat = Math.max(b.lat, d.lat), d.lng = Math.max(b.lng, d.lng)), this;
      },
      // @method pad(bufferRatio: Number): LatLngBounds
      // Returns bounds created by extending or retracting the current bounds by a given ratio in each direction.
      // For example, a ratio of 0.5 extends the bounds by 50% in each direction.
      // Negative values will retract the bounds.
      pad: function(i) {
        var s = this._southWest, d = this._northEast, g = Math.abs(s.lat - d.lat) * i, b = Math.abs(s.lng - d.lng) * i;
        return new nt(
          new Ze(s.lat - g, s.lng - b),
          new Ze(d.lat + g, d.lng + b)
        );
      },
      // @method getCenter(): LatLng
      // Returns the center point of the bounds.
      getCenter: function() {
        return new Ze(
          (this._southWest.lat + this._northEast.lat) / 2,
          (this._southWest.lng + this._northEast.lng) / 2
        );
      },
      // @method getSouthWest(): LatLng
      // Returns the south-west point of the bounds.
      getSouthWest: function() {
        return this._southWest;
      },
      // @method getNorthEast(): LatLng
      // Returns the north-east point of the bounds.
      getNorthEast: function() {
        return this._northEast;
      },
      // @method getNorthWest(): LatLng
      // Returns the north-west point of the bounds.
      getNorthWest: function() {
        return new Ze(this.getNorth(), this.getWest());
      },
      // @method getSouthEast(): LatLng
      // Returns the south-east point of the bounds.
      getSouthEast: function() {
        return new Ze(this.getSouth(), this.getEast());
      },
      // @method getWest(): Number
      // Returns the west longitude of the bounds
      getWest: function() {
        return this._southWest.lng;
      },
      // @method getSouth(): Number
      // Returns the south latitude of the bounds
      getSouth: function() {
        return this._southWest.lat;
      },
      // @method getEast(): Number
      // Returns the east longitude of the bounds
      getEast: function() {
        return this._northEast.lng;
      },
      // @method getNorth(): Number
      // Returns the north latitude of the bounds
      getNorth: function() {
        return this._northEast.lat;
      },
      // @method contains(otherBounds: LatLngBounds): Boolean
      // Returns `true` if the rectangle contains the given one.
      // @alternative
      // @method contains (latlng: LatLng): Boolean
      // Returns `true` if the rectangle contains the given point.
      contains: function(i) {
        typeof i[0] == "number" || i instanceof Ze || "lat" in i ? i = Ne(i) : i = Ve(i);
        var s = this._southWest, d = this._northEast, g, b;
        return i instanceof nt ? (g = i.getSouthWest(), b = i.getNorthEast()) : g = b = i, g.lat >= s.lat && b.lat <= d.lat && g.lng >= s.lng && b.lng <= d.lng;
      },
      // @method intersects(otherBounds: LatLngBounds): Boolean
      // Returns `true` if the rectangle intersects the given bounds. Two bounds intersect if they have at least one point in common.
      intersects: function(i) {
        i = Ve(i);
        var s = this._southWest, d = this._northEast, g = i.getSouthWest(), b = i.getNorthEast(), I = b.lat >= s.lat && g.lat <= d.lat, W = b.lng >= s.lng && g.lng <= d.lng;
        return I && W;
      },
      // @method overlaps(otherBounds: LatLngBounds): Boolean
      // Returns `true` if the rectangle overlaps the given bounds. Two bounds overlap if their intersection is an area.
      overlaps: function(i) {
        i = Ve(i);
        var s = this._southWest, d = this._northEast, g = i.getSouthWest(), b = i.getNorthEast(), I = b.lat > s.lat && g.lat < d.lat, W = b.lng > s.lng && g.lng < d.lng;
        return I && W;
      },
      // @method toBBoxString(): String
      // Returns a string with bounding box coordinates in a 'southwest_lng,southwest_lat,northeast_lng,northeast_lat' format. Useful for sending requests to web services that return geo data.
      toBBoxString: function() {
        return [this.getWest(), this.getSouth(), this.getEast(), this.getNorth()].join(",");
      },
      // @method equals(otherBounds: LatLngBounds, maxMargin?: Number): Boolean
      // Returns `true` if the rectangle is equivalent (within a small margin of error) to the given bounds. The margin of error can be overridden by setting `maxMargin` to a small number.
      equals: function(i, s) {
        return i ? (i = Ve(i), this._southWest.equals(i.getSouthWest(), s) && this._northEast.equals(i.getNorthEast(), s)) : !1;
      },
      // @method isValid(): Boolean
      // Returns `true` if the bounds are properly initialized.
      isValid: function() {
        return !!(this._southWest && this._northEast);
      }
    };
    function Ve(i, s) {
      return i instanceof nt ? i : new nt(i, s);
    }
    function Ze(i, s, d) {
      if (isNaN(i) || isNaN(s))
        throw new Error("Invalid LatLng object: (" + i + ", " + s + ")");
      this.lat = +i, this.lng = +s, d !== void 0 && (this.alt = +d);
    }
    Ze.prototype = {
      // @method equals(otherLatLng: LatLng, maxMargin?: Number): Boolean
      // Returns `true` if the given `LatLng` point is at the same position (within a small margin of error). The margin of error can be overridden by setting `maxMargin` to a small number.
      equals: function(i, s) {
        if (!i)
          return !1;
        i = Ne(i);
        var d = Math.max(
          Math.abs(this.lat - i.lat),
          Math.abs(this.lng - i.lng)
        );
        return d <= (s === void 0 ? 1e-9 : s);
      },
      // @method toString(): String
      // Returns a string representation of the point (for debugging purposes).
      toString: function(i) {
        return "LatLng(" + k(this.lat, i) + ", " + k(this.lng, i) + ")";
      },
      // @method distanceTo(otherLatLng: LatLng): Number
      // Returns the distance (in meters) to the given `LatLng` calculated using the [Spherical Law of Cosines](https://en.wikipedia.org/wiki/Spherical_law_of_cosines).
      distanceTo: function(i) {
        return pt.distance(this, Ne(i));
      },
      // @method wrap(): LatLng
      // Returns a new `LatLng` object with the longitude wrapped so it's always between -180 and +180 degrees.
      wrap: function() {
        return pt.wrapLatLng(this);
      },
      // @method toBounds(sizeInMeters: Number): LatLngBounds
      // Returns a new `LatLngBounds` object in which each boundary is `sizeInMeters/2` meters apart from the `LatLng`.
      toBounds: function(i) {
        var s = 180 * i / 40075017, d = s / Math.cos(Math.PI / 180 * this.lat);
        return Ve(
          [this.lat - s, this.lng - d],
          [this.lat + s, this.lng + d]
        );
      },
      clone: function() {
        return new Ze(this.lat, this.lng, this.alt);
      }
    };
    function Ne(i, s, d) {
      return i instanceof Ze ? i : A(i) && typeof i[0] != "object" ? i.length === 3 ? new Ze(i[0], i[1], i[2]) : i.length === 2 ? new Ze(i[0], i[1]) : null : i == null ? i : typeof i == "object" && "lat" in i ? new Ze(i.lat, "lng" in i ? i.lng : i.lon, i.alt) : s === void 0 ? null : new Ze(i, s, d);
    }
    var ft = {
      // @method latLngToPoint(latlng: LatLng, zoom: Number): Point
      // Projects geographical coordinates into pixel coordinates for a given zoom.
      latLngToPoint: function(i, s) {
        var d = this.projection.project(i), g = this.scale(s);
        return this.transformation._transform(d, g);
      },
      // @method pointToLatLng(point: Point, zoom: Number): LatLng
      // The inverse of `latLngToPoint`. Projects pixel coordinates on a given
      // zoom into geographical coordinates.
      pointToLatLng: function(i, s) {
        var d = this.scale(s), g = this.transformation.untransform(i, d);
        return this.projection.unproject(g);
      },
      // @method project(latlng: LatLng): Point
      // Projects geographical coordinates into coordinates in units accepted for
      // this CRS (e.g. meters for EPSG:3857, for passing it to WMS services).
      project: function(i) {
        return this.projection.project(i);
      },
      // @method unproject(point: Point): LatLng
      // Given a projected coordinate returns the corresponding LatLng.
      // The inverse of `project`.
      unproject: function(i) {
        return this.projection.unproject(i);
      },
      // @method scale(zoom: Number): Number
      // Returns the scale used when transforming projected coordinates into
      // pixel coordinates for a particular zoom. For example, it returns
      // `256 * 2^zoom` for Mercator-based CRS.
      scale: function(i) {
        return 256 * Math.pow(2, i);
      },
      // @method zoom(scale: Number): Number
      // Inverse of `scale()`, returns the zoom level corresponding to a scale
      // factor of `scale`.
      zoom: function(i) {
        return Math.log(i / 256) / Math.LN2;
      },
      // @method getProjectedBounds(zoom: Number): Bounds
      // Returns the projection's bounds scaled and transformed for the provided `zoom`.
      getProjectedBounds: function(i) {
        if (this.infinite)
          return null;
        var s = this.projection.bounds, d = this.scale(i), g = this.transformation.transform(s.min, d), b = this.transformation.transform(s.max, d);
        return new Fe(g, b);
      },
      // @method distance(latlng1: LatLng, latlng2: LatLng): Number
      // Returns the distance between two geographical coordinates.
      // @property code: String
      // Standard code name of the CRS passed into WMS services (e.g. `'EPSG:3857'`)
      //
      // @property wrapLng: Number[]
      // An array of two numbers defining whether the longitude (horizontal) coordinate
      // axis wraps around a given range and how. Defaults to `[-180, 180]` in most
      // geographical CRSs. If `undefined`, the longitude axis does not wrap around.
      //
      // @property wrapLat: Number[]
      // Like `wrapLng`, but for the latitude (vertical) axis.
      // wrapLng: [min, max],
      // wrapLat: [min, max],
      // @property infinite: Boolean
      // If true, the coordinate space will be unbounded (infinite in both axes)
      infinite: !1,
      // @method wrapLatLng(latlng: LatLng): LatLng
      // Returns a `LatLng` where lat and lng has been wrapped according to the
      // CRS's `wrapLat` and `wrapLng` properties, if they are outside the CRS's bounds.
      wrapLatLng: function(i) {
        var s = this.wrapLng ? v(i.lng, this.wrapLng, !0) : i.lng, d = this.wrapLat ? v(i.lat, this.wrapLat, !0) : i.lat, g = i.alt;
        return new Ze(d, s, g);
      },
      // @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
      // Returns a `LatLngBounds` with the same size as the given one, ensuring
      // that its center is within the CRS's bounds.
      // Only accepts actual `L.LatLngBounds` instances, not arrays.
      wrapLatLngBounds: function(i) {
        var s = i.getCenter(), d = this.wrapLatLng(s), g = s.lat - d.lat, b = s.lng - d.lng;
        if (g === 0 && b === 0)
          return i;
        var I = i.getSouthWest(), W = i.getNorthEast(), le = new Ze(I.lat - g, I.lng - b), de = new Ze(W.lat - g, W.lng - b);
        return new nt(le, de);
      }
    }, pt = a({}, ft, {
      wrapLng: [-180, 180],
      // Mean Earth Radius, as recommended for use by
      // the International Union of Geodesy and Geophysics,
      // see https://rosettacode.org/wiki/Haversine_formula
      R: 6371e3,
      // distance between two geographical points using spherical law of cosines approximation
      distance: function(i, s) {
        var d = Math.PI / 180, g = i.lat * d, b = s.lat * d, I = Math.sin((s.lat - i.lat) * d / 2), W = Math.sin((s.lng - i.lng) * d / 2), le = I * I + Math.cos(g) * Math.cos(b) * W * W, de = 2 * Math.atan2(Math.sqrt(le), Math.sqrt(1 - le));
        return this.R * de;
      }
    }), Wt = 6378137, an = {
      R: Wt,
      MAX_LATITUDE: 85.0511287798,
      project: function(i) {
        var s = Math.PI / 180, d = this.MAX_LATITUDE, g = Math.max(Math.min(d, i.lat), -d), b = Math.sin(g * s);
        return new pe(
          this.R * i.lng * s,
          this.R * Math.log((1 + b) / (1 - b)) / 2
        );
      },
      unproject: function(i) {
        var s = 180 / Math.PI;
        return new Ze(
          (2 * Math.atan(Math.exp(i.y / this.R)) - Math.PI / 2) * s,
          i.x * s / this.R
        );
      },
      bounds: function() {
        var i = Wt * Math.PI;
        return new Fe([-i, -i], [i, i]);
      }()
    };
    function on(i, s, d, g) {
      if (A(i)) {
        this._a = i[0], this._b = i[1], this._c = i[2], this._d = i[3];
        return;
      }
      this._a = i, this._b = s, this._c = d, this._d = g;
    }
    on.prototype = {
      // @method transform(point: Point, scale?: Number): Point
      // Returns a transformed point, optionally multiplied by the given scale.
      // Only accepts actual `L.Point` instances, not arrays.
      transform: function(i, s) {
        return this._transform(i.clone(), s);
      },
      // destructive transform (faster)
      _transform: function(i, s) {
        return s = s || 1, i.x = s * (this._a * i.x + this._b), i.y = s * (this._c * i.y + this._d), i;
      },
      // @method untransform(point: Point, scale?: Number): Point
      // Returns the reverse transformation of the given point, optionally divided
      // by the given scale. Only accepts actual `L.Point` instances, not arrays.
      untransform: function(i, s) {
        return s = s || 1, new pe(
          (i.x / s - this._b) / this._a,
          (i.y / s - this._d) / this._c
        );
      }
    };
    function Dt(i, s, d, g) {
      return new on(i, s, d, g);
    }
    var Zt = a({}, pt, {
      code: "EPSG:3857",
      projection: an,
      transformation: function() {
        var i = 0.5 / (Math.PI * an.R);
        return Dt(i, 0.5, -i, 0.5);
      }()
    }), It = a({}, Zt, {
      code: "EPSG:900913"
    });
    function bn(i) {
      return document.createElementNS("http://www.w3.org/2000/svg", i);
    }
    function qt(i, s) {
      var d = "", g, b, I, W, le, de;
      for (g = 0, I = i.length; g < I; g++) {
        for (le = i[g], b = 0, W = le.length; b < W; b++)
          de = le[b], d += (b ? "L" : "M") + de.x + " " + de.y;
        d += s ? Be.svg ? "z" : "x" : "";
      }
      return d || "M0 0";
    }
    var cn = document.documentElement.style, sn = "ActiveXObject" in window, H = sn && !document.addEventListener, S = "msLaunchUri" in navigator && !("documentMode" in document), E = Lt("webkit"), z = Lt("android"), q = Lt("android 2") || Lt("android 3"), J = parseInt(/WebKit\/([0-9]+)|$/.exec(navigator.userAgent)[1], 10), me = z && Lt("Google") && J < 537 && !("AudioNode" in window), ye = !!window.opera, Oe = !S && Lt("chrome"), Ue = Lt("gecko") && !E && !ye && !sn, at = !Oe && Lt("safari"), Xe = Lt("phantom"), We = "OTransition" in cn, xt = navigator.platform.indexOf("Win") === 0, lt = sn && "transition" in cn, bt = "WebKitCSSMatrix" in window && "m11" in new window.WebKitCSSMatrix() && !q, At = "MozPerspective" in cn, Rt = !window.L_DISABLE_3D && (lt || bt || At) && !We && !Xe, be = typeof orientation < "u" || Lt("mobile"), j = be && E, ge = be && bt, De = !window.PointerEvent && window.MSPointerEvent, N = !!(window.PointerEvent || De), U = "ontouchstart" in window || !!window.TouchEvent, ie = !window.L_NO_TOUCH && (U || N), ve = be && ye, Ee = be && Ue, Ce = (window.devicePixelRatio || window.screen.deviceXDPI / window.screen.logicalXDPI) > 1, He = function() {
      var i = !1;
      try {
        var s = Object.defineProperty({}, "passive", {
          get: function() {
            i = !0;
          }
        });
        window.addEventListener("testPassiveEventSupport", y, s), window.removeEventListener("testPassiveEventSupport", y, s);
      } catch {
      }
      return i;
    }(), Re = function() {
      return !!document.createElement("canvas").getContext;
    }(), mt = !!(document.createElementNS && bn("svg").createSVGRect), ht = !!mt && function() {
      var i = document.createElement("div");
      return i.innerHTML = "<svg/>", (i.firstChild && i.firstChild.namespaceURI) === "http://www.w3.org/2000/svg";
    }(), wt = !mt && function() {
      try {
        var i = document.createElement("div");
        i.innerHTML = '<v:shape adj="1"/>';
        var s = i.firstChild;
        return s.style.behavior = "url(#default#VML)", s && typeof s.adj == "object";
      } catch {
        return !1;
      }
    }(), ct = navigator.platform.indexOf("Mac") === 0, ut = navigator.platform.indexOf("Linux") === 0;
    function Lt(i) {
      return navigator.userAgent.toLowerCase().indexOf(i) >= 0;
    }
    var Be = {
      ie: sn,
      ielt9: H,
      edge: S,
      webkit: E,
      android: z,
      android23: q,
      androidStock: me,
      opera: ye,
      chrome: Oe,
      gecko: Ue,
      safari: at,
      phantom: Xe,
      opera12: We,
      win: xt,
      ie3d: lt,
      webkit3d: bt,
      gecko3d: At,
      any3d: Rt,
      mobile: be,
      mobileWebkit: j,
      mobileWebkit3d: ge,
      msPointer: De,
      pointer: N,
      touch: ie,
      touchNative: U,
      mobileOpera: ve,
      mobileGecko: Ee,
      retina: Ce,
      passiveEvents: He,
      canvas: Re,
      svg: mt,
      vml: wt,
      inlineSvg: ht,
      mac: ct,
      linux: ut
    }, Nt = Be.msPointer ? "MSPointerDown" : "pointerdown", Kt = Be.msPointer ? "MSPointerMove" : "pointermove", vi = Be.msPointer ? "MSPointerUp" : "pointerup", _i = Be.msPointer ? "MSPointerCancel" : "pointercancel", yi = {
      touchstart: Nt,
      touchmove: Kt,
      touchend: vi,
      touchcancel: _i
    }, Vi = {
      touchstart: To,
      touchmove: jr,
      touchend: jr,
      touchcancel: jr
    }, Pn = {}, Yi = !1;
    function Hi(i, s, d) {
      return s === "touchstart" && dr(), Vi[s] ? (d = Vi[s].bind(this, d), i.addEventListener(yi[s], d, !1), d) : (console.warn("wrong event specified:", s), y);
    }
    function cl(i, s, d) {
      if (!yi[s]) {
        console.warn("wrong event specified:", s);
        return;
      }
      i.removeEventListener(yi[s], d, !1);
    }
    function Fr(i) {
      Pn[i.pointerId] = i;
    }
    function Oo(i) {
      Pn[i.pointerId] && (Pn[i.pointerId] = i);
    }
    function Eo(i) {
      delete Pn[i.pointerId];
    }
    function dr() {
      Yi || (document.addEventListener(Nt, Fr, !0), document.addEventListener(Kt, Oo, !0), document.addEventListener(vi, Eo, !0), document.addEventListener(_i, Eo, !0), Yi = !0);
    }
    function jr(i, s) {
      if (s.pointerType !== (s.MSPOINTER_TYPE_MOUSE || "mouse")) {
        s.touches = [];
        for (var d in Pn)
          s.touches.push(Pn[d]);
        s.changedTouches = [s], i(s);
      }
    }
    function To(i, s) {
      s.MSPOINTER_TYPE_TOUCH && s.pointerType === s.MSPOINTER_TYPE_TOUCH && Ie(s), jr(i, s);
    }
    function Ta(i) {
      var s = {}, d, g;
      for (g in i)
        d = i[g], s[g] = d && d.bind ? d.bind(i) : d;
      return i = s, s.type = "dblclick", s.detail = 2, s.isTrusted = !1, s._simulated = !0, s;
    }
    var hl = 200;
    function dl(i, s) {
      i.addEventListener("dblclick", s);
      var d = 0, g;
      function b(I) {
        if (I.detail !== 1) {
          g = I.detail;
          return;
        }
        if (!(I.pointerType === "mouse" || I.sourceCapabilities && !I.sourceCapabilities.firesTouchEvents)) {
          var W = ot(I);
          if (!(W.some(function(de) {
            return de instanceof HTMLLabelElement && de.attributes.for;
          }) && !W.some(function(de) {
            return de instanceof HTMLInputElement || de instanceof HTMLSelectElement;
          }))) {
            var le = Date.now();
            le - d <= hl ? (g++, g === 2 && s(Ta(I))) : g = 1, d = le;
          }
        }
      }
      return i.addEventListener("click", b), {
        dblclick: s,
        simDblclick: b
      };
    }
    function Do(i, s) {
      i.removeEventListener("dblclick", s.dblclick), i.removeEventListener("click", s.simDblclick);
    }
    var Ui = Hr(
      ["transform", "webkitTransform", "OTransform", "MozTransform", "msTransform"]
    ), ui = Hr(
      ["webkitTransition", "transition", "OTransition", "MozTransition", "msTransition"]
    ), Da = ui === "webkitTransition" || ui === "OTransition" ? ui + "End" : "transitionend";
    function Ia(i) {
      return typeof i == "string" ? document.getElementById(i) : i;
    }
    function Zi(i, s) {
      var d = i.style[s] || i.currentStyle && i.currentStyle[s];
      if ((!d || d === "auto") && document.defaultView) {
        var g = document.defaultView.getComputedStyle(i, null);
        d = g ? g[s] : null;
      }
      return d === "auto" ? null : d;
    }
    function yt(i, s, d) {
      var g = document.createElement(i);
      return g.className = s || "", d && d.appendChild(g), g;
    }
    function jt(i) {
      var s = i.parentNode;
      s && s.removeChild(i);
    }
    function Vr(i) {
      for (; i.firstChild; )
        i.removeChild(i.firstChild);
    }
    function Wi(i) {
      var s = i.parentNode;
      s && s.lastChild !== i && s.appendChild(i);
    }
    function bi(i) {
      var s = i.parentNode;
      s && s.firstChild !== i && s.insertBefore(i, s.firstChild);
    }
    function Aa(i, s) {
      if (i.classList !== void 0)
        return i.classList.contains(s);
      var d = Zn(i);
      return d.length > 0 && new RegExp("(^|\\s)" + s + "(\\s|$)").test(d);
    }
    function it(i, s) {
      if (i.classList !== void 0)
        for (var d = M(s), g = 0, b = d.length; g < b; g++)
          i.classList.add(d[g]);
      else if (!Aa(i, s)) {
        var I = Zn(i);
        Yr(i, (I ? I + " " : "") + s);
      }
    }
    function Gt(i, s) {
      i.classList !== void 0 ? i.classList.remove(s) : Yr(i, x((" " + Zn(i) + " ").replace(" " + s + " ", " ")));
    }
    function Yr(i, s) {
      i.className.baseVal === void 0 ? i.className = s : i.className.baseVal = s;
    }
    function Zn(i) {
      return i.correspondingElement && (i = i.correspondingElement), i.className.baseVal === void 0 ? i.className : i.className.baseVal;
    }
    function dn(i, s) {
      "opacity" in i.style ? i.style.opacity = s : "filter" in i.style && fl(i, s);
    }
    function fl(i, s) {
      var d = !1, g = "DXImageTransform.Microsoft.Alpha";
      try {
        d = i.filters.item(g);
      } catch {
        if (s === 1)
          return;
      }
      s = Math.round(s * 100), d ? (d.Enabled = s !== 100, d.Opacity = s) : i.style.filter += " progid:" + g + "(opacity=" + s + ")";
    }
    function Hr(i) {
      for (var s = document.documentElement.style, d = 0; d < i.length; d++)
        if (i[d] in s)
          return i[d];
      return !1;
    }
    function Ft(i, s, d) {
      var g = s || new pe(0, 0);
      i.style[Ui] = (Be.ie3d ? "translate(" + g.x + "px," + g.y + "px)" : "translate3d(" + g.x + "px," + g.y + "px,0)") + (d ? " scale(" + d + ")" : "");
    }
    function Vt(i, s) {
      i._leaflet_pos = s, Be.any3d ? Ft(i, s) : (i.style.left = s.x + "px", i.style.top = s.y + "px");
    }
    function Wn(i) {
      return i._leaflet_pos || new pe(0, 0);
    }
    var fr, pr, Ur;
    if ("onselectstart" in document)
      fr = function() {
        w(window, "selectstart", Ie);
      }, pr = function() {
        F(window, "selectstart", Ie);
      };
    else {
      var mr = Hr(
        ["userSelect", "WebkitUserSelect", "OUserSelect", "MozUserSelect", "msUserSelect"]
      );
      fr = function() {
        if (mr) {
          var i = document.documentElement.style;
          Ur = i[mr], i[mr] = "none";
        }
      }, pr = function() {
        mr && (document.documentElement.style[mr] = Ur, Ur = void 0);
      };
    }
    function gr() {
      w(window, "dragstart", Ie);
    }
    function vr() {
      F(window, "dragstart", Ie);
    }
    var Zr, Ra;
    function Ba(i) {
      for (; i.tabIndex === -1; )
        i = i.parentNode;
      i.style && (o(), Zr = i, Ra = i.style.outlineStyle, i.style.outlineStyle = "none", w(window, "keydown", o));
    }
    function o() {
      Zr && (Zr.style.outlineStyle = Ra, Zr = void 0, Ra = void 0, F(window, "keydown", o));
    }
    function c(i) {
      do
        i = i.parentNode;
      while ((!i.offsetWidth || !i.offsetHeight) && i !== document.body);
      return i;
    }
    function p(i) {
      var s = i.getBoundingClientRect();
      return {
        x: s.width / i.offsetWidth || 1,
        y: s.height / i.offsetHeight || 1,
        boundingClientRect: s
      };
    }
    var _ = {
      __proto__: null,
      TRANSFORM: Ui,
      TRANSITION: ui,
      TRANSITION_END: Da,
      get: Ia,
      getStyle: Zi,
      create: yt,
      remove: jt,
      empty: Vr,
      toFront: Wi,
      toBack: bi,
      hasClass: Aa,
      addClass: it,
      removeClass: Gt,
      setClass: Yr,
      getClass: Zn,
      setOpacity: dn,
      testProp: Hr,
      setTransform: Ft,
      setPosition: Vt,
      getPosition: Wn,
      get disableTextSelection() {
        return fr;
      },
      get enableTextSelection() {
        return pr;
      },
      disableImageDrag: gr,
      enableImageDrag: vr,
      preventOutline: Ba,
      restoreOutline: o,
      getSizedParentNode: c,
      getScale: p
    };
    function w(i, s, d, g) {
      if (s && typeof s == "object")
        for (var b in s)
          K(i, b, s[b], d);
      else {
        s = M(s);
        for (var I = 0, W = s.length; I < W; I++)
          K(i, s[I], d, g);
      }
      return this;
    }
    var B = "_leaflet_events";
    function F(i, s, d, g) {
      if (arguments.length === 1)
        Z(i), delete i[B];
      else if (s && typeof s == "object")
        for (var b in s)
          oe(i, b, s[b], d);
      else if (s = M(s), arguments.length === 2)
        Z(i, function(le) {
          return P(s, le) !== -1;
        });
      else
        for (var I = 0, W = s.length; I < W; I++)
          oe(i, s[I], d, g);
      return this;
    }
    function Z(i, s) {
      for (var d in i[B]) {
        var g = d.split(/\d/)[0];
        (!s || s(g)) && oe(i, g, null, null, d);
      }
    }
    var V = {
      mouseenter: "mouseover",
      mouseleave: "mouseout",
      wheel: !("onwheel" in window) && "mousewheel"
    };
    function K(i, s, d, g) {
      var b = s + f(d) + (g ? "_" + f(g) : "");
      if (i[B] && i[B][b])
        return this;
      var I = function(le) {
        return d.call(g || i, le || window.event);
      }, W = I;
      !Be.touchNative && Be.pointer && s.indexOf("touch") === 0 ? I = Hi(i, s, I) : Be.touch && s === "dblclick" ? I = dl(i, I) : "addEventListener" in i ? s === "touchstart" || s === "touchmove" || s === "wheel" || s === "mousewheel" ? i.addEventListener(V[s] || s, I, Be.passiveEvents ? { passive: !1 } : !1) : s === "mouseenter" || s === "mouseleave" ? (I = function(le) {
        le = le || window.event, pn(i, le) && W(le);
      }, i.addEventListener(V[s], I, !1)) : i.addEventListener(s, W, !1) : i.attachEvent("on" + s, I), i[B] = i[B] || {}, i[B][b] = I;
    }
    function oe(i, s, d, g, b) {
      b = b || s + f(d) + (g ? "_" + f(g) : "");
      var I = i[B] && i[B][b];
      if (!I)
        return this;
      !Be.touchNative && Be.pointer && s.indexOf("touch") === 0 ? cl(i, s, I) : Be.touch && s === "dblclick" ? Do(i, I) : "removeEventListener" in i ? i.removeEventListener(V[s] || s, I, !1) : i.detachEvent("on" + s, I), i[B][b] = null;
    }
    function _e(i) {
      return i.stopPropagation ? i.stopPropagation() : i.originalEvent ? i.originalEvent._stopped = !0 : i.cancelBubble = !0, this;
    }
    function fe(i) {
      return K(i, "wheel", _e), this;
    }
    function Me(i) {
      return w(i, "mousedown touchstart dblclick contextmenu", _e), i._leaflet_disable_click = !0, this;
    }
    function Ie(i) {
      return i.preventDefault ? i.preventDefault() : i.returnValue = !1, this;
    }
    function qe(i) {
      return Ie(i), _e(i), this;
    }
    function ot(i) {
      if (i.composedPath)
        return i.composedPath();
      for (var s = [], d = i.target; d; )
        s.push(d), d = d.parentNode;
      return s;
    }
    function Tt(i, s) {
      if (!s)
        return new pe(i.clientX, i.clientY);
      var d = p(s), g = d.boundingClientRect;
      return new pe(
        // offset.left/top values are in page scale (like clientX/Y),
        // whereas clientLeft/Top (border width) values are the original values (before CSS scale applies).
        (i.clientX - g.left) / d.x - s.clientLeft,
        (i.clientY - g.top) / d.y - s.clientTop
      );
    }
    var Ct = Be.linux && Be.chrome ? window.devicePixelRatio : Be.mac ? window.devicePixelRatio * 3 : window.devicePixelRatio > 0 ? 2 * window.devicePixelRatio : 1;
    function Yt(i) {
      return Be.edge ? i.wheelDeltaY / 2 : (
        // Don't trust window-geometry-based delta
        i.deltaY && i.deltaMode === 0 ? -i.deltaY / Ct : (
          // Pixels
          i.deltaY && i.deltaMode === 1 ? -i.deltaY * 20 : (
            // Lines
            i.deltaY && i.deltaMode === 2 ? -i.deltaY * 60 : (
              // Pages
              i.deltaX || i.deltaZ ? 0 : (
                // Skip horizontal/depth wheel events
                i.wheelDelta ? (i.wheelDeltaY || i.wheelDelta) / 2 : (
                  // Legacy IE pixels
                  i.detail && Math.abs(i.detail) < 32765 ? -i.detail * 20 : (
                    // Legacy Moz lines
                    i.detail ? i.detail / -32765 * 60 : (
                      // Legacy Moz pages
                      0
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
    function pn(i, s) {
      var d = s.relatedTarget;
      if (!d)
        return !0;
      try {
        for (; d && d !== i; )
          d = d.parentNode;
      } catch {
        return !1;
      }
      return d !== i;
    }
    var mn = {
      __proto__: null,
      on: w,
      off: F,
      stopPropagation: _e,
      disableScrollPropagation: fe,
      disableClickPropagation: Me,
      preventDefault: Ie,
      stop: qe,
      getPropagationPath: ot,
      getMousePosition: Tt,
      getWheelDelta: Yt,
      isExternalTarget: pn,
      addListener: w,
      removeListener: F
    }, Wr = Ae.extend({
      // @method run(el: HTMLElement, newPos: Point, duration?: Number, easeLinearity?: Number)
      // Run an animation of a given element to a new position, optionally setting
      // duration in seconds (`0.25` by default) and easing linearity factor (3rd
      // argument of the [cubic bezier curve](https://cubic-bezier.com/#0,0,.5,1),
      // `0.5` by default).
      run: function(i, s, d, g) {
        this.stop(), this._el = i, this._inProgress = !0, this._duration = d || 0.25, this._easeOutPower = 1 / Math.max(g || 0.5, 0.2), this._startPos = Wn(i), this._offset = s.subtract(this._startPos), this._startTime = +/* @__PURE__ */ new Date(), this.fire("start"), this._animate();
      },
      // @method stop()
      // Stops the animation (if currently running).
      stop: function() {
        this._inProgress && (this._step(!0), this._complete());
      },
      _animate: function() {
        this._animId = ae(this._animate, this), this._step();
      },
      _step: function(i) {
        var s = +/* @__PURE__ */ new Date() - this._startTime, d = this._duration * 1e3;
        s < d ? this._runFrame(this._easeOut(s / d), i) : (this._runFrame(1), this._complete());
      },
      _runFrame: function(i, s) {
        var d = this._startPos.add(this._offset.multiplyBy(i));
        s && d._round(), Vt(this._el, d), this.fire("step");
      },
      _complete: function() {
        ne(this._animId), this._inProgress = !1, this.fire("end");
      },
      _easeOut: function(i) {
        return 1 - Math.pow(1 - i, this._easeOutPower);
      }
    }), st = Ae.extend({
      options: {
        // @section Map State Options
        // @option crs: CRS = L.CRS.EPSG3857
        // The [Coordinate Reference System](#crs) to use. Don't change this if you're not
        // sure what it means.
        crs: Zt,
        // @option center: LatLng = undefined
        // Initial geographic center of the map
        center: void 0,
        // @option zoom: Number = undefined
        // Initial map zoom level
        zoom: void 0,
        // @option minZoom: Number = *
        // Minimum zoom level of the map.
        // If not specified and at least one `GridLayer` or `TileLayer` is in the map,
        // the lowest of their `minZoom` options will be used instead.
        minZoom: void 0,
        // @option maxZoom: Number = *
        // Maximum zoom level of the map.
        // If not specified and at least one `GridLayer` or `TileLayer` is in the map,
        // the highest of their `maxZoom` options will be used instead.
        maxZoom: void 0,
        // @option layers: Layer[] = []
        // Array of layers that will be added to the map initially
        layers: [],
        // @option maxBounds: LatLngBounds = null
        // When this option is set, the map restricts the view to the given
        // geographical bounds, bouncing the user back if the user tries to pan
        // outside the view. To set the restriction dynamically, use
        // [`setMaxBounds`](#map-setmaxbounds) method.
        maxBounds: void 0,
        // @option renderer: Renderer = *
        // The default method for drawing vector layers on the map. `L.SVG`
        // or `L.Canvas` by default depending on browser support.
        renderer: void 0,
        // @section Animation Options
        // @option zoomAnimation: Boolean = true
        // Whether the map zoom animation is enabled. By default it's enabled
        // in all browsers that support CSS3 Transitions except Android.
        zoomAnimation: !0,
        // @option zoomAnimationThreshold: Number = 4
        // Won't animate zoom if the zoom difference exceeds this value.
        zoomAnimationThreshold: 4,
        // @option fadeAnimation: Boolean = true
        // Whether the tile fade animation is enabled. By default it's enabled
        // in all browsers that support CSS3 Transitions except Android.
        fadeAnimation: !0,
        // @option markerZoomAnimation: Boolean = true
        // Whether markers animate their zoom with the zoom animation, if disabled
        // they will disappear for the length of the animation. By default it's
        // enabled in all browsers that support CSS3 Transitions except Android.
        markerZoomAnimation: !0,
        // @option transform3DLimit: Number = 2^23
        // Defines the maximum size of a CSS translation transform. The default
        // value should not be changed unless a web browser positions layers in
        // the wrong place after doing a large `panBy`.
        transform3DLimit: 8388608,
        // Precision limit of a 32-bit float
        // @section Interaction Options
        // @option zoomSnap: Number = 1
        // Forces the map's zoom level to always be a multiple of this, particularly
        // right after a [`fitBounds()`](#map-fitbounds) or a pinch-zoom.
        // By default, the zoom level snaps to the nearest integer; lower values
        // (e.g. `0.5` or `0.1`) allow for greater granularity. A value of `0`
        // means the zoom level will not be snapped after `fitBounds` or a pinch-zoom.
        zoomSnap: 1,
        // @option zoomDelta: Number = 1
        // Controls how much the map's zoom level will change after a
        // [`zoomIn()`](#map-zoomin), [`zoomOut()`](#map-zoomout), pressing `+`
        // or `-` on the keyboard, or using the [zoom controls](#control-zoom).
        // Values smaller than `1` (e.g. `0.5`) allow for greater granularity.
        zoomDelta: 1,
        // @option trackResize: Boolean = true
        // Whether the map automatically handles browser window resize to update itself.
        trackResize: !0
      },
      initialize: function(i, s) {
        s = O(this, s), this._handlers = [], this._layers = {}, this._zoomBoundLayers = {}, this._sizeChanged = !0, this._initContainer(i), this._initLayout(), this._onResize = u(this._onResize, this), this._initEvents(), s.maxBounds && this.setMaxBounds(s.maxBounds), s.zoom !== void 0 && (this._zoom = this._limitZoom(s.zoom)), s.center && s.zoom !== void 0 && this.setView(Ne(s.center), s.zoom, { reset: !0 }), this.callInitHooks(), this._zoomAnimated = ui && Be.any3d && !Be.mobileOpera && this.options.zoomAnimation, this._zoomAnimated && (this._createAnimProxy(), w(this._proxy, Da, this._catchTransitionEnd, this)), this._addLayers(this.options.layers);
      },
      // @section Methods for modifying map state
      // @method setView(center: LatLng, zoom: Number, options?: Zoom/pan options): this
      // Sets the view of the map (geographical center and zoom) with the given
      // animation options.
      setView: function(i, s, d) {
        if (s = s === void 0 ? this._zoom : this._limitZoom(s), i = this._limitCenter(Ne(i), s, this.options.maxBounds), d = d || {}, this._stop(), this._loaded && !d.reset && d !== !0) {
          d.animate !== void 0 && (d.zoom = a({ animate: d.animate }, d.zoom), d.pan = a({ animate: d.animate, duration: d.duration }, d.pan));
          var g = this._zoom !== s ? this._tryAnimatedZoom && this._tryAnimatedZoom(i, s, d.zoom) : this._tryAnimatedPan(i, d.pan);
          if (g)
            return clearTimeout(this._sizeTimer), this;
        }
        return this._resetView(i, s, d.pan && d.pan.noMoveStart), this;
      },
      // @method setZoom(zoom: Number, options?: Zoom/pan options): this
      // Sets the zoom of the map.
      setZoom: function(i, s) {
        return this._loaded ? this.setView(this.getCenter(), i, { zoom: s }) : (this._zoom = i, this);
      },
      // @method zoomIn(delta?: Number, options?: Zoom options): this
      // Increases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
      zoomIn: function(i, s) {
        return i = i || (Be.any3d ? this.options.zoomDelta : 1), this.setZoom(this._zoom + i, s);
      },
      // @method zoomOut(delta?: Number, options?: Zoom options): this
      // Decreases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
      zoomOut: function(i, s) {
        return i = i || (Be.any3d ? this.options.zoomDelta : 1), this.setZoom(this._zoom - i, s);
      },
      // @method setZoomAround(latlng: LatLng, zoom: Number, options: Zoom options): this
      // Zooms the map while keeping a specified geographical point on the map
      // stationary (e.g. used internally for scroll zoom and double-click zoom).
      // @alternative
      // @method setZoomAround(offset: Point, zoom: Number, options: Zoom options): this
      // Zooms the map while keeping a specified pixel on the map (relative to the top-left corner) stationary.
      setZoomAround: function(i, s, d) {
        var g = this.getZoomScale(s), b = this.getSize().divideBy(2), I = i instanceof pe ? i : this.latLngToContainerPoint(i), W = I.subtract(b).multiplyBy(1 - 1 / g), le = this.containerPointToLatLng(b.add(W));
        return this.setView(le, s, { zoom: d });
      },
      _getBoundsCenterZoom: function(i, s) {
        s = s || {}, i = i.getBounds ? i.getBounds() : Ve(i);
        var d = ue(s.paddingTopLeft || s.padding || [0, 0]), g = ue(s.paddingBottomRight || s.padding || [0, 0]), b = this.getBoundsZoom(i, !1, d.add(g));
        if (b = typeof s.maxZoom == "number" ? Math.min(s.maxZoom, b) : b, b === 1 / 0)
          return {
            center: i.getCenter(),
            zoom: b
          };
        var I = g.subtract(d).divideBy(2), W = this.project(i.getSouthWest(), b), le = this.project(i.getNorthEast(), b), de = this.unproject(W.add(le).divideBy(2).add(I), b);
        return {
          center: de,
          zoom: b
        };
      },
      // @method fitBounds(bounds: LatLngBounds, options?: fitBounds options): this
      // Sets a map view that contains the given geographical bounds with the
      // maximum zoom level possible.
      fitBounds: function(i, s) {
        if (i = Ve(i), !i.isValid())
          throw new Error("Bounds are not valid.");
        var d = this._getBoundsCenterZoom(i, s);
        return this.setView(d.center, d.zoom, s);
      },
      // @method fitWorld(options?: fitBounds options): this
      // Sets a map view that mostly contains the whole world with the maximum
      // zoom level possible.
      fitWorld: function(i) {
        return this.fitBounds([[-90, -180], [90, 180]], i);
      },
      // @method panTo(latlng: LatLng, options?: Pan options): this
      // Pans the map to a given center.
      panTo: function(i, s) {
        return this.setView(i, this._zoom, { pan: s });
      },
      // @method panBy(offset: Point, options?: Pan options): this
      // Pans the map by a given number of pixels (animated).
      panBy: function(i, s) {
        if (i = ue(i).round(), s = s || {}, !i.x && !i.y)
          return this.fire("moveend");
        if (s.animate !== !0 && !this.getSize().contains(i))
          return this._resetView(this.unproject(this.project(this.getCenter()).add(i)), this.getZoom()), this;
        if (this._panAnim || (this._panAnim = new Wr(), this._panAnim.on({
          step: this._onPanTransitionStep,
          end: this._onPanTransitionEnd
        }, this)), s.noMoveStart || this.fire("movestart"), s.animate !== !1) {
          it(this._mapPane, "leaflet-pan-anim");
          var d = this._getMapPanePos().subtract(i).round();
          this._panAnim.run(this._mapPane, d, s.duration || 0.25, s.easeLinearity);
        } else
          this._rawPanBy(i), this.fire("move").fire("moveend");
        return this;
      },
      // @method flyTo(latlng: LatLng, zoom?: Number, options?: Zoom/pan options): this
      // Sets the view of the map (geographical center and zoom) performing a smooth
      // pan-zoom animation.
      flyTo: function(i, s, d) {
        if (d = d || {}, d.animate === !1 || !Be.any3d)
          return this.setView(i, s, d);
        this._stop();
        var g = this.project(this.getCenter()), b = this.project(i), I = this.getSize(), W = this._zoom;
        i = Ne(i), s = s === void 0 ? W : s;
        var le = Math.max(I.x, I.y), de = le * this.getZoomScale(W, s), Le = b.distanceTo(g) || 1, ze = 1.42, Ke = ze * ze;
        function dt(ln) {
          var Wo = ln ? -1 : 1, Cv = ln ? de : le, Ov = de * de - le * le + Wo * Ke * Ke * Le * Le, Ev = 2 * Cv * Ke * Le, Ll = Ov / Ev, Yc = Math.sqrt(Ll * Ll + 1) - Ll, Tv = Yc < 1e-9 ? -18 : Math.log(Yc);
          return Tv;
        }
        function kn(ln) {
          return (Math.exp(ln) - Math.exp(-ln)) / 2;
        }
        function hn(ln) {
          return (Math.exp(ln) + Math.exp(-ln)) / 2;
        }
        function Rn(ln) {
          return kn(ln) / hn(ln);
        }
        var Cn = dt(0);
        function Qr(ln) {
          return le * (hn(Cn) / hn(Cn + ze * ln));
        }
        function Lv(ln) {
          return le * (hn(Cn) * Rn(Cn + ze * ln) - kn(Cn)) / Ke;
        }
        function Mv(ln) {
          return 1 - Math.pow(1 - ln, 1.5);
        }
        var Sv = Date.now(), jc = (dt(1) - Cn) / ze, Pv = d.duration ? 1e3 * d.duration : 1e3 * jc * 0.8;
        function Vc() {
          var ln = (Date.now() - Sv) / Pv, Wo = Mv(ln) * jc;
          ln <= 1 ? (this._flyToFrame = ae(Vc, this), this._move(
            this.unproject(g.add(b.subtract(g).multiplyBy(Lv(Wo) / Le)), W),
            this.getScaleZoom(le / Qr(Wo), W),
            { flyTo: !0 }
          )) : this._move(i, s)._moveEnd(!0);
        }
        return this._moveStart(!0, d.noMoveStart), Vc.call(this), this;
      },
      // @method flyToBounds(bounds: LatLngBounds, options?: fitBounds options): this
      // Sets the view of the map with a smooth animation like [`flyTo`](#map-flyto),
      // but takes a bounds parameter like [`fitBounds`](#map-fitbounds).
      flyToBounds: function(i, s) {
        var d = this._getBoundsCenterZoom(i, s);
        return this.flyTo(d.center, d.zoom, s);
      },
      // @method setMaxBounds(bounds: LatLngBounds): this
      // Restricts the map view to the given bounds (see the [maxBounds](#map-maxbounds) option).
      setMaxBounds: function(i) {
        return i = Ve(i), this.listens("moveend", this._panInsideMaxBounds) && this.off("moveend", this._panInsideMaxBounds), i.isValid() ? (this.options.maxBounds = i, this._loaded && this._panInsideMaxBounds(), this.on("moveend", this._panInsideMaxBounds)) : (this.options.maxBounds = null, this);
      },
      // @method setMinZoom(zoom: Number): this
      // Sets the lower limit for the available zoom levels (see the [minZoom](#map-minzoom) option).
      setMinZoom: function(i) {
        var s = this.options.minZoom;
        return this.options.minZoom = i, this._loaded && s !== i && (this.fire("zoomlevelschange"), this.getZoom() < this.options.minZoom) ? this.setZoom(i) : this;
      },
      // @method setMaxZoom(zoom: Number): this
      // Sets the upper limit for the available zoom levels (see the [maxZoom](#map-maxzoom) option).
      setMaxZoom: function(i) {
        var s = this.options.maxZoom;
        return this.options.maxZoom = i, this._loaded && s !== i && (this.fire("zoomlevelschange"), this.getZoom() > this.options.maxZoom) ? this.setZoom(i) : this;
      },
      // @method panInsideBounds(bounds: LatLngBounds, options?: Pan options): this
      // Pans the map to the closest view that would lie inside the given bounds (if it's not already), controlling the animation using the options specific, if any.
      panInsideBounds: function(i, s) {
        this._enforcingBounds = !0;
        var d = this.getCenter(), g = this._limitCenter(d, this._zoom, Ve(i));
        return d.equals(g) || this.panTo(g, s), this._enforcingBounds = !1, this;
      },
      // @method panInside(latlng: LatLng, options?: padding options): this
      // Pans the map the minimum amount to make the `latlng` visible. Use
      // padding options to fit the display to more restricted bounds.
      // If `latlng` is already within the (optionally padded) display bounds,
      // the map will not be panned.
      panInside: function(i, s) {
        s = s || {};
        var d = ue(s.paddingTopLeft || s.padding || [0, 0]), g = ue(s.paddingBottomRight || s.padding || [0, 0]), b = this.project(this.getCenter()), I = this.project(i), W = this.getPixelBounds(), le = Pe([W.min.add(d), W.max.subtract(g)]), de = le.getSize();
        if (!le.contains(I)) {
          this._enforcingBounds = !0;
          var Le = I.subtract(le.getCenter()), ze = le.extend(I).getSize().subtract(de);
          b.x += Le.x < 0 ? -ze.x : ze.x, b.y += Le.y < 0 ? -ze.y : ze.y, this.panTo(this.unproject(b), s), this._enforcingBounds = !1;
        }
        return this;
      },
      // @method invalidateSize(options: Zoom/pan options): this
      // Checks if the map container size changed and updates the map if so —
      // call it after you've changed the map size dynamically, also animating
      // pan by default. If `options.pan` is `false`, panning will not occur.
      // If `options.debounceMoveend` is `true`, it will delay `moveend` event so
      // that it doesn't happen often even if the method is called many
      // times in a row.
      // @alternative
      // @method invalidateSize(animate: Boolean): this
      // Checks if the map container size changed and updates the map if so —
      // call it after you've changed the map size dynamically, also animating
      // pan by default.
      invalidateSize: function(i) {
        if (!this._loaded)
          return this;
        i = a({
          animate: !1,
          pan: !0
        }, i === !0 ? { animate: !0 } : i);
        var s = this.getSize();
        this._sizeChanged = !0, this._lastCenter = null;
        var d = this.getSize(), g = s.divideBy(2).round(), b = d.divideBy(2).round(), I = g.subtract(b);
        return !I.x && !I.y ? this : (i.animate && i.pan ? this.panBy(I) : (i.pan && this._rawPanBy(I), this.fire("move"), i.debounceMoveend ? (clearTimeout(this._sizeTimer), this._sizeTimer = setTimeout(u(this.fire, this, "moveend"), 200)) : this.fire("moveend")), this.fire("resize", {
          oldSize: s,
          newSize: d
        }));
      },
      // @section Methods for modifying map state
      // @method stop(): this
      // Stops the currently running `panTo` or `flyTo` animation, if any.
      stop: function() {
        return this.setZoom(this._limitZoom(this._zoom)), this.options.zoomSnap || this.fire("viewreset"), this._stop();
      },
      // @section Geolocation methods
      // @method locate(options?: Locate options): this
      // Tries to locate the user using the Geolocation API, firing a [`locationfound`](#map-locationfound)
      // event with location data on success or a [`locationerror`](#map-locationerror) event on failure,
      // and optionally sets the map view to the user's location with respect to
      // detection accuracy (or to the world view if geolocation failed).
      // Note that, if your page doesn't use HTTPS, this method will fail in
      // modern browsers ([Chrome 50 and newer](https://sites.google.com/a/chromium.org/dev/Home/chromium-security/deprecating-powerful-features-on-insecure-origins))
      // See `Locate options` for more details.
      locate: function(i) {
        if (i = this._locateOptions = a({
          timeout: 1e4,
          watch: !1
          // setView: false
          // maxZoom: <Number>
          // maximumAge: 0
          // enableHighAccuracy: false
        }, i), !("geolocation" in navigator))
          return this._handleGeolocationError({
            code: 0,
            message: "Geolocation not supported."
          }), this;
        var s = u(this._handleGeolocationResponse, this), d = u(this._handleGeolocationError, this);
        return i.watch ? this._locationWatchId = navigator.geolocation.watchPosition(s, d, i) : navigator.geolocation.getCurrentPosition(s, d, i), this;
      },
      // @method stopLocate(): this
      // Stops watching location previously initiated by `map.locate({watch: true})`
      // and aborts resetting the map view if map.locate was called with
      // `{setView: true}`.
      stopLocate: function() {
        return navigator.geolocation && navigator.geolocation.clearWatch && navigator.geolocation.clearWatch(this._locationWatchId), this._locateOptions && (this._locateOptions.setView = !1), this;
      },
      _handleGeolocationError: function(i) {
        if (this._container._leaflet_id) {
          var s = i.code, d = i.message || (s === 1 ? "permission denied" : s === 2 ? "position unavailable" : "timeout");
          this._locateOptions.setView && !this._loaded && this.fitWorld(), this.fire("locationerror", {
            code: s,
            message: "Geolocation error: " + d + "."
          });
        }
      },
      _handleGeolocationResponse: function(i) {
        if (this._container._leaflet_id) {
          var s = i.coords.latitude, d = i.coords.longitude, g = new Ze(s, d), b = g.toBounds(i.coords.accuracy * 2), I = this._locateOptions;
          if (I.setView) {
            var W = this.getBoundsZoom(b);
            this.setView(g, I.maxZoom ? Math.min(W, I.maxZoom) : W);
          }
          var le = {
            latlng: g,
            bounds: b,
            timestamp: i.timestamp
          };
          for (var de in i.coords)
            typeof i.coords[de] == "number" && (le[de] = i.coords[de]);
          this.fire("locationfound", le);
        }
      },
      // TODO Appropriate docs section?
      // @section Other Methods
      // @method addHandler(name: String, HandlerClass: Function): this
      // Adds a new `Handler` to the map, given its name and constructor function.
      addHandler: function(i, s) {
        if (!s)
          return this;
        var d = this[i] = new s(this);
        return this._handlers.push(d), this.options[i] && d.enable(), this;
      },
      // @method remove(): this
      // Destroys the map and clears all related event listeners.
      remove: function() {
        if (this._initEvents(!0), this.options.maxBounds && this.off("moveend", this._panInsideMaxBounds), this._containerId !== this._container._leaflet_id)
          throw new Error("Map container is being reused by another instance");
        try {
          delete this._container._leaflet_id, delete this._containerId;
        } catch {
          this._container._leaflet_id = void 0, this._containerId = void 0;
        }
        this._locationWatchId !== void 0 && this.stopLocate(), this._stop(), jt(this._mapPane), this._clearControlPos && this._clearControlPos(), this._resizeRequest && (ne(this._resizeRequest), this._resizeRequest = null), this._clearHandlers(), this._loaded && this.fire("unload");
        var i;
        for (i in this._layers)
          this._layers[i].remove();
        for (i in this._panes)
          jt(this._panes[i]);
        return this._layers = [], this._panes = [], delete this._mapPane, delete this._renderer, this;
      },
      // @section Other Methods
      // @method createPane(name: String, container?: HTMLElement): HTMLElement
      // Creates a new [map pane](#map-pane) with the given name if it doesn't exist already,
      // then returns it. The pane is created as a child of `container`, or
      // as a child of the main map pane if not set.
      createPane: function(i, s) {
        var d = "leaflet-pane" + (i ? " leaflet-" + i.replace("Pane", "") + "-pane" : ""), g = yt("div", d, s || this._mapPane);
        return i && (this._panes[i] = g), g;
      },
      // @section Methods for Getting Map State
      // @method getCenter(): LatLng
      // Returns the geographical center of the map view
      getCenter: function() {
        return this._checkIfLoaded(), this._lastCenter && !this._moved() ? this._lastCenter.clone() : this.layerPointToLatLng(this._getCenterLayerPoint());
      },
      // @method getZoom(): Number
      // Returns the current zoom level of the map view
      getZoom: function() {
        return this._zoom;
      },
      // @method getBounds(): LatLngBounds
      // Returns the geographical bounds visible in the current map view
      getBounds: function() {
        var i = this.getPixelBounds(), s = this.unproject(i.getBottomLeft()), d = this.unproject(i.getTopRight());
        return new nt(s, d);
      },
      // @method getMinZoom(): Number
      // Returns the minimum zoom level of the map (if set in the `minZoom` option of the map or of any layers), or `0` by default.
      getMinZoom: function() {
        return this.options.minZoom === void 0 ? this._layersMinZoom || 0 : this.options.minZoom;
      },
      // @method getMaxZoom(): Number
      // Returns the maximum zoom level of the map (if set in the `maxZoom` option of the map or of any layers).
      getMaxZoom: function() {
        return this.options.maxZoom === void 0 ? this._layersMaxZoom === void 0 ? 1 / 0 : this._layersMaxZoom : this.options.maxZoom;
      },
      // @method getBoundsZoom(bounds: LatLngBounds, inside?: Boolean, padding?: Point): Number
      // Returns the maximum zoom level on which the given bounds fit to the map
      // view in its entirety. If `inside` (optional) is set to `true`, the method
      // instead returns the minimum zoom level on which the map view fits into
      // the given bounds in its entirety.
      getBoundsZoom: function(i, s, d) {
        i = Ve(i), d = ue(d || [0, 0]);
        var g = this.getZoom() || 0, b = this.getMinZoom(), I = this.getMaxZoom(), W = i.getNorthWest(), le = i.getSouthEast(), de = this.getSize().subtract(d), Le = Pe(this.project(le, g), this.project(W, g)).getSize(), ze = Be.any3d ? this.options.zoomSnap : 1, Ke = de.x / Le.x, dt = de.y / Le.y, kn = s ? Math.max(Ke, dt) : Math.min(Ke, dt);
        return g = this.getScaleZoom(kn, g), ze && (g = Math.round(g / (ze / 100)) * (ze / 100), g = s ? Math.ceil(g / ze) * ze : Math.floor(g / ze) * ze), Math.max(b, Math.min(I, g));
      },
      // @method getSize(): Point
      // Returns the current size of the map container (in pixels).
      getSize: function() {
        return (!this._size || this._sizeChanged) && (this._size = new pe(
          this._container.clientWidth || 0,
          this._container.clientHeight || 0
        ), this._sizeChanged = !1), this._size.clone();
      },
      // @method getPixelBounds(): Bounds
      // Returns the bounds of the current map view in projected pixel
      // coordinates (sometimes useful in layer and overlay implementations).
      getPixelBounds: function(i, s) {
        var d = this._getTopLeftPoint(i, s);
        return new Fe(d, d.add(this.getSize()));
      },
      // TODO: Check semantics - isn't the pixel origin the 0,0 coord relative to
      // the map pane? "left point of the map layer" can be confusing, specially
      // since there can be negative offsets.
      // @method getPixelOrigin(): Point
      // Returns the projected pixel coordinates of the top left point of
      // the map layer (useful in custom layer and overlay implementations).
      getPixelOrigin: function() {
        return this._checkIfLoaded(), this._pixelOrigin;
      },
      // @method getPixelWorldBounds(zoom?: Number): Bounds
      // Returns the world's bounds in pixel coordinates for zoom level `zoom`.
      // If `zoom` is omitted, the map's current zoom level is used.
      getPixelWorldBounds: function(i) {
        return this.options.crs.getProjectedBounds(i === void 0 ? this.getZoom() : i);
      },
      // @section Other Methods
      // @method getPane(pane: String|HTMLElement): HTMLElement
      // Returns a [map pane](#map-pane), given its name or its HTML element (its identity).
      getPane: function(i) {
        return typeof i == "string" ? this._panes[i] : i;
      },
      // @method getPanes(): Object
      // Returns a plain object containing the names of all [panes](#map-pane) as keys and
      // the panes as values.
      getPanes: function() {
        return this._panes;
      },
      // @method getContainer: HTMLElement
      // Returns the HTML element that contains the map.
      getContainer: function() {
        return this._container;
      },
      // @section Conversion Methods
      // @method getZoomScale(toZoom: Number, fromZoom: Number): Number
      // Returns the scale factor to be applied to a map transition from zoom level
      // `fromZoom` to `toZoom`. Used internally to help with zoom animations.
      getZoomScale: function(i, s) {
        var d = this.options.crs;
        return s = s === void 0 ? this._zoom : s, d.scale(i) / d.scale(s);
      },
      // @method getScaleZoom(scale: Number, fromZoom: Number): Number
      // Returns the zoom level that the map would end up at, if it is at `fromZoom`
      // level and everything is scaled by a factor of `scale`. Inverse of
      // [`getZoomScale`](#map-getZoomScale).
      getScaleZoom: function(i, s) {
        var d = this.options.crs;
        s = s === void 0 ? this._zoom : s;
        var g = d.zoom(i * d.scale(s));
        return isNaN(g) ? 1 / 0 : g;
      },
      // @method project(latlng: LatLng, zoom: Number): Point
      // Projects a geographical coordinate `LatLng` according to the projection
      // of the map's CRS, then scales it according to `zoom` and the CRS's
      // `Transformation`. The result is pixel coordinate relative to
      // the CRS origin.
      project: function(i, s) {
        return s = s === void 0 ? this._zoom : s, this.options.crs.latLngToPoint(Ne(i), s);
      },
      // @method unproject(point: Point, zoom: Number): LatLng
      // Inverse of [`project`](#map-project).
      unproject: function(i, s) {
        return s = s === void 0 ? this._zoom : s, this.options.crs.pointToLatLng(ue(i), s);
      },
      // @method layerPointToLatLng(point: Point): LatLng
      // Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
      // returns the corresponding geographical coordinate (for the current zoom level).
      layerPointToLatLng: function(i) {
        var s = ue(i).add(this.getPixelOrigin());
        return this.unproject(s);
      },
      // @method latLngToLayerPoint(latlng: LatLng): Point
      // Given a geographical coordinate, returns the corresponding pixel coordinate
      // relative to the [origin pixel](#map-getpixelorigin).
      latLngToLayerPoint: function(i) {
        var s = this.project(Ne(i))._round();
        return s._subtract(this.getPixelOrigin());
      },
      // @method wrapLatLng(latlng: LatLng): LatLng
      // Returns a `LatLng` where `lat` and `lng` has been wrapped according to the
      // map's CRS's `wrapLat` and `wrapLng` properties, if they are outside the
      // CRS's bounds.
      // By default this means longitude is wrapped around the dateline so its
      // value is between -180 and +180 degrees.
      wrapLatLng: function(i) {
        return this.options.crs.wrapLatLng(Ne(i));
      },
      // @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
      // Returns a `LatLngBounds` with the same size as the given one, ensuring that
      // its center is within the CRS's bounds.
      // By default this means the center longitude is wrapped around the dateline so its
      // value is between -180 and +180 degrees, and the majority of the bounds
      // overlaps the CRS's bounds.
      wrapLatLngBounds: function(i) {
        return this.options.crs.wrapLatLngBounds(Ve(i));
      },
      // @method distance(latlng1: LatLng, latlng2: LatLng): Number
      // Returns the distance between two geographical coordinates according to
      // the map's CRS. By default this measures distance in meters.
      distance: function(i, s) {
        return this.options.crs.distance(Ne(i), Ne(s));
      },
      // @method containerPointToLayerPoint(point: Point): Point
      // Given a pixel coordinate relative to the map container, returns the corresponding
      // pixel coordinate relative to the [origin pixel](#map-getpixelorigin).
      containerPointToLayerPoint: function(i) {
        return ue(i).subtract(this._getMapPanePos());
      },
      // @method layerPointToContainerPoint(point: Point): Point
      // Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
      // returns the corresponding pixel coordinate relative to the map container.
      layerPointToContainerPoint: function(i) {
        return ue(i).add(this._getMapPanePos());
      },
      // @method containerPointToLatLng(point: Point): LatLng
      // Given a pixel coordinate relative to the map container, returns
      // the corresponding geographical coordinate (for the current zoom level).
      containerPointToLatLng: function(i) {
        var s = this.containerPointToLayerPoint(ue(i));
        return this.layerPointToLatLng(s);
      },
      // @method latLngToContainerPoint(latlng: LatLng): Point
      // Given a geographical coordinate, returns the corresponding pixel coordinate
      // relative to the map container.
      latLngToContainerPoint: function(i) {
        return this.layerPointToContainerPoint(this.latLngToLayerPoint(Ne(i)));
      },
      // @method mouseEventToContainerPoint(ev: MouseEvent): Point
      // Given a MouseEvent object, returns the pixel coordinate relative to the
      // map container where the event took place.
      mouseEventToContainerPoint: function(i) {
        return Tt(i, this._container);
      },
      // @method mouseEventToLayerPoint(ev: MouseEvent): Point
      // Given a MouseEvent object, returns the pixel coordinate relative to
      // the [origin pixel](#map-getpixelorigin) where the event took place.
      mouseEventToLayerPoint: function(i) {
        return this.containerPointToLayerPoint(this.mouseEventToContainerPoint(i));
      },
      // @method mouseEventToLatLng(ev: MouseEvent): LatLng
      // Given a MouseEvent object, returns geographical coordinate where the
      // event took place.
      mouseEventToLatLng: function(i) {
        return this.layerPointToLatLng(this.mouseEventToLayerPoint(i));
      },
      // map initialization methods
      _initContainer: function(i) {
        var s = this._container = Ia(i);
        if (s) {
          if (s._leaflet_id)
            throw new Error("Map container is already initialized.");
        } else
          throw new Error("Map container not found.");
        w(s, "scroll", this._onScroll, this), this._containerId = f(s);
      },
      _initLayout: function() {
        var i = this._container;
        this._fadeAnimated = this.options.fadeAnimation && Be.any3d, it(i, "leaflet-container" + (Be.touch ? " leaflet-touch" : "") + (Be.retina ? " leaflet-retina" : "") + (Be.ielt9 ? " leaflet-oldie" : "") + (Be.safari ? " leaflet-safari" : "") + (this._fadeAnimated ? " leaflet-fade-anim" : ""));
        var s = Zi(i, "position");
        s !== "absolute" && s !== "relative" && s !== "fixed" && s !== "sticky" && (i.style.position = "relative"), this._initPanes(), this._initControlPos && this._initControlPos();
      },
      _initPanes: function() {
        var i = this._panes = {};
        this._paneRenderers = {}, this._mapPane = this.createPane("mapPane", this._container), Vt(this._mapPane, new pe(0, 0)), this.createPane("tilePane"), this.createPane("overlayPane"), this.createPane("shadowPane"), this.createPane("markerPane"), this.createPane("tooltipPane"), this.createPane("popupPane"), this.options.markerZoomAnimation || (it(i.markerPane, "leaflet-zoom-hide"), it(i.shadowPane, "leaflet-zoom-hide"));
      },
      // private methods that modify map state
      // @section Map state change events
      _resetView: function(i, s, d) {
        Vt(this._mapPane, new pe(0, 0));
        var g = !this._loaded;
        this._loaded = !0, s = this._limitZoom(s), this.fire("viewprereset");
        var b = this._zoom !== s;
        this._moveStart(b, d)._move(i, s)._moveEnd(b), this.fire("viewreset"), g && this.fire("load");
      },
      _moveStart: function(i, s) {
        return i && this.fire("zoomstart"), s || this.fire("movestart"), this;
      },
      _move: function(i, s, d, g) {
        s === void 0 && (s = this._zoom);
        var b = this._zoom !== s;
        return this._zoom = s, this._lastCenter = i, this._pixelOrigin = this._getNewPixelOrigin(i), g ? d && d.pinch && this.fire("zoom", d) : ((b || d && d.pinch) && this.fire("zoom", d), this.fire("move", d)), this;
      },
      _moveEnd: function(i) {
        return i && this.fire("zoomend"), this.fire("moveend");
      },
      _stop: function() {
        return ne(this._flyToFrame), this._panAnim && this._panAnim.stop(), this;
      },
      _rawPanBy: function(i) {
        Vt(this._mapPane, this._getMapPanePos().subtract(i));
      },
      _getZoomSpan: function() {
        return this.getMaxZoom() - this.getMinZoom();
      },
      _panInsideMaxBounds: function() {
        this._enforcingBounds || this.panInsideBounds(this.options.maxBounds);
      },
      _checkIfLoaded: function() {
        if (!this._loaded)
          throw new Error("Set map center and zoom first.");
      },
      // DOM event handling
      // @section Interaction events
      _initEvents: function(i) {
        this._targets = {}, this._targets[f(this._container)] = this;
        var s = i ? F : w;
        s(this._container, "click dblclick mousedown mouseup mouseover mouseout mousemove contextmenu keypress keydown keyup", this._handleDOMEvent, this), this.options.trackResize && s(window, "resize", this._onResize, this), Be.any3d && this.options.transform3DLimit && (i ? this.off : this.on).call(this, "moveend", this._onMoveEnd);
      },
      _onResize: function() {
        ne(this._resizeRequest), this._resizeRequest = ae(
          function() {
            this.invalidateSize({ debounceMoveend: !0 });
          },
          this
        );
      },
      _onScroll: function() {
        this._container.scrollTop = 0, this._container.scrollLeft = 0;
      },
      _onMoveEnd: function() {
        var i = this._getMapPanePos();
        Math.max(Math.abs(i.x), Math.abs(i.y)) >= this.options.transform3DLimit && this._resetView(this.getCenter(), this.getZoom());
      },
      _findEventTargets: function(i, s) {
        for (var d = [], g, b = s === "mouseout" || s === "mouseover", I = i.target || i.srcElement, W = !1; I; ) {
          if (g = this._targets[f(I)], g && (s === "click" || s === "preclick") && this._draggableMoved(g)) {
            W = !0;
            break;
          }
          if (g && g.listens(s, !0) && (b && !pn(I, i) || (d.push(g), b)) || I === this._container)
            break;
          I = I.parentNode;
        }
        return !d.length && !W && !b && this.listens(s, !0) && (d = [this]), d;
      },
      _isClickDisabled: function(i) {
        for (; i && i !== this._container; ) {
          if (i._leaflet_disable_click)
            return !0;
          i = i.parentNode;
        }
      },
      _handleDOMEvent: function(i) {
        var s = i.target || i.srcElement;
        if (!(!this._loaded || s._leaflet_disable_events || i.type === "click" && this._isClickDisabled(s))) {
          var d = i.type;
          d === "mousedown" && Ba(s), this._fireDOMEvent(i, d);
        }
      },
      _mouseEvents: ["click", "dblclick", "mouseover", "mouseout", "contextmenu"],
      _fireDOMEvent: function(i, s, d) {
        if (i.type === "click") {
          var g = a({}, i);
          g.type = "preclick", this._fireDOMEvent(g, g.type, d);
        }
        var b = this._findEventTargets(i, s);
        if (d) {
          for (var I = [], W = 0; W < d.length; W++)
            d[W].listens(s, !0) && I.push(d[W]);
          b = I.concat(b);
        }
        if (b.length) {
          s === "contextmenu" && Ie(i);
          var le = b[0], de = {
            originalEvent: i
          };
          if (i.type !== "keypress" && i.type !== "keydown" && i.type !== "keyup") {
            var Le = le.getLatLng && (!le._radius || le._radius <= 10);
            de.containerPoint = Le ? this.latLngToContainerPoint(le.getLatLng()) : this.mouseEventToContainerPoint(i), de.layerPoint = this.containerPointToLayerPoint(de.containerPoint), de.latlng = Le ? le.getLatLng() : this.layerPointToLatLng(de.layerPoint);
          }
          for (W = 0; W < b.length; W++)
            if (b[W].fire(s, de, !0), de.originalEvent._stopped || b[W].options.bubblingMouseEvents === !1 && P(this._mouseEvents, s) !== -1)
              return;
        }
      },
      _draggableMoved: function(i) {
        return i = i.dragging && i.dragging.enabled() ? i : this, i.dragging && i.dragging.moved() || this.boxZoom && this.boxZoom.moved();
      },
      _clearHandlers: function() {
        for (var i = 0, s = this._handlers.length; i < s; i++)
          this._handlers[i].disable();
      },
      // @section Other Methods
      // @method whenReady(fn: Function, context?: Object): this
      // Runs the given function `fn` when the map gets initialized with
      // a view (center and zoom) and at least one layer, or immediately
      // if it's already initialized, optionally passing a function context.
      whenReady: function(i, s) {
        return this._loaded ? i.call(s || this, { target: this }) : this.on("load", i, s), this;
      },
      // private methods for getting map state
      _getMapPanePos: function() {
        return Wn(this._mapPane) || new pe(0, 0);
      },
      _moved: function() {
        var i = this._getMapPanePos();
        return i && !i.equals([0, 0]);
      },
      _getTopLeftPoint: function(i, s) {
        var d = i && s !== void 0 ? this._getNewPixelOrigin(i, s) : this.getPixelOrigin();
        return d.subtract(this._getMapPanePos());
      },
      _getNewPixelOrigin: function(i, s) {
        var d = this.getSize()._divideBy(2);
        return this.project(i, s)._subtract(d)._add(this._getMapPanePos())._round();
      },
      _latLngToNewLayerPoint: function(i, s, d) {
        var g = this._getNewPixelOrigin(d, s);
        return this.project(i, s)._subtract(g);
      },
      _latLngBoundsToNewLayerBounds: function(i, s, d) {
        var g = this._getNewPixelOrigin(d, s);
        return Pe([
          this.project(i.getSouthWest(), s)._subtract(g),
          this.project(i.getNorthWest(), s)._subtract(g),
          this.project(i.getSouthEast(), s)._subtract(g),
          this.project(i.getNorthEast(), s)._subtract(g)
        ]);
      },
      // layer point of the current center
      _getCenterLayerPoint: function() {
        return this.containerPointToLayerPoint(this.getSize()._divideBy(2));
      },
      // offset of the specified place to the current center in pixels
      _getCenterOffset: function(i) {
        return this.latLngToLayerPoint(i).subtract(this._getCenterLayerPoint());
      },
      // adjust center for view to get inside bounds
      _limitCenter: function(i, s, d) {
        if (!d)
          return i;
        var g = this.project(i, s), b = this.getSize().divideBy(2), I = new Fe(g.subtract(b), g.add(b)), W = this._getBoundsOffset(I, d, s);
        return Math.abs(W.x) <= 1 && Math.abs(W.y) <= 1 ? i : this.unproject(g.add(W), s);
      },
      // adjust offset for view to get inside bounds
      _limitOffset: function(i, s) {
        if (!s)
          return i;
        var d = this.getPixelBounds(), g = new Fe(d.min.add(i), d.max.add(i));
        return i.add(this._getBoundsOffset(g, s));
      },
      // returns offset needed for pxBounds to get inside maxBounds at a specified zoom
      _getBoundsOffset: function(i, s, d) {
        var g = Pe(
          this.project(s.getNorthEast(), d),
          this.project(s.getSouthWest(), d)
        ), b = g.min.subtract(i.min), I = g.max.subtract(i.max), W = this._rebound(b.x, -I.x), le = this._rebound(b.y, -I.y);
        return new pe(W, le);
      },
      _rebound: function(i, s) {
        return i + s > 0 ? Math.round(i - s) / 2 : Math.max(0, Math.ceil(i)) - Math.max(0, Math.floor(s));
      },
      _limitZoom: function(i) {
        var s = this.getMinZoom(), d = this.getMaxZoom(), g = Be.any3d ? this.options.zoomSnap : 1;
        return g && (i = Math.round(i / g) * g), Math.max(s, Math.min(d, i));
      },
      _onPanTransitionStep: function() {
        this.fire("move");
      },
      _onPanTransitionEnd: function() {
        Gt(this._mapPane, "leaflet-pan-anim"), this.fire("moveend");
      },
      _tryAnimatedPan: function(i, s) {
        var d = this._getCenterOffset(i)._trunc();
        return (s && s.animate) !== !0 && !this.getSize().contains(d) ? !1 : (this.panBy(d, s), !0);
      },
      _createAnimProxy: function() {
        var i = this._proxy = yt("div", "leaflet-proxy leaflet-zoom-animated");
        this._panes.mapPane.appendChild(i), this.on("zoomanim", function(s) {
          var d = Ui, g = this._proxy.style[d];
          Ft(this._proxy, this.project(s.center, s.zoom), this.getZoomScale(s.zoom, 1)), g === this._proxy.style[d] && this._animatingZoom && this._onZoomTransitionEnd();
        }, this), this.on("load moveend", this._animMoveEnd, this), this._on("unload", this._destroyAnimProxy, this);
      },
      _destroyAnimProxy: function() {
        jt(this._proxy), this.off("load moveend", this._animMoveEnd, this), delete this._proxy;
      },
      _animMoveEnd: function() {
        var i = this.getCenter(), s = this.getZoom();
        Ft(this._proxy, this.project(i, s), this.getZoomScale(s, 1));
      },
      _catchTransitionEnd: function(i) {
        this._animatingZoom && i.propertyName.indexOf("transform") >= 0 && this._onZoomTransitionEnd();
      },
      _nothingToAnimate: function() {
        return !this._container.getElementsByClassName("leaflet-zoom-animated").length;
      },
      _tryAnimatedZoom: function(i, s, d) {
        if (this._animatingZoom)
          return !0;
        if (d = d || {}, !this._zoomAnimated || d.animate === !1 || this._nothingToAnimate() || Math.abs(s - this._zoom) > this.options.zoomAnimationThreshold)
          return !1;
        var g = this.getZoomScale(s), b = this._getCenterOffset(i)._divideBy(1 - 1 / g);
        return d.animate !== !0 && !this.getSize().contains(b) ? !1 : (ae(function() {
          this._moveStart(!0, d.noMoveStart || !1)._animateZoom(i, s, !0);
        }, this), !0);
      },
      _animateZoom: function(i, s, d, g) {
        this._mapPane && (d && (this._animatingZoom = !0, this._animateToCenter = i, this._animateToZoom = s, it(this._mapPane, "leaflet-zoom-anim")), this.fire("zoomanim", {
          center: i,
          zoom: s,
          noUpdate: g
        }), this._tempFireZoomEvent || (this._tempFireZoomEvent = this._zoom !== this._animateToZoom), this._move(this._animateToCenter, this._animateToZoom, void 0, !0), setTimeout(u(this._onZoomTransitionEnd, this), 250));
      },
      _onZoomTransitionEnd: function() {
        this._animatingZoom && (this._mapPane && Gt(this._mapPane, "leaflet-zoom-anim"), this._animatingZoom = !1, this._move(this._animateToCenter, this._animateToZoom, void 0, !0), this._tempFireZoomEvent && this.fire("zoom"), delete this._tempFireZoomEvent, this.fire("move"), this._moveEnd(!0));
      }
    });
    function Io(i, s) {
      return new st(i, s);
    }
    var wn = re.extend({
      // @section
      // @aka Control Options
      options: {
        // @option position: String = 'topright'
        // The position of the control (one of the map corners). Possible values are `'topleft'`,
        // `'topright'`, `'bottomleft'` or `'bottomright'`
        position: "topright"
      },
      initialize: function(i) {
        O(this, i);
      },
      /* @section
       * Classes extending L.Control will inherit the following methods:
       *
       * @method getPosition: string
       * Returns the position of the control.
       */
      getPosition: function() {
        return this.options.position;
      },
      // @method setPosition(position: string): this
      // Sets the position of the control.
      setPosition: function(i) {
        var s = this._map;
        return s && s.removeControl(this), this.options.position = i, s && s.addControl(this), this;
      },
      // @method getContainer: HTMLElement
      // Returns the HTMLElement that contains the control.
      getContainer: function() {
        return this._container;
      },
      // @method addTo(map: Map): this
      // Adds the control to the given map.
      addTo: function(i) {
        this.remove(), this._map = i;
        var s = this._container = this.onAdd(i), d = this.getPosition(), g = i._controlCorners[d];
        return it(s, "leaflet-control"), d.indexOf("bottom") !== -1 ? g.insertBefore(s, g.firstChild) : g.appendChild(s), this._map.on("unload", this.remove, this), this;
      },
      // @method remove: this
      // Removes the control from the map it is currently active on.
      remove: function() {
        return this._map ? (jt(this._container), this.onRemove && this.onRemove(this._map), this._map.off("unload", this.remove, this), this._map = null, this) : this;
      },
      _refocusOnMap: function(i) {
        this._map && i && i.screenX > 0 && i.screenY > 0 && this._map.getContainer().focus();
      }
    }), En = function(i) {
      return new wn(i);
    };
    st.include({
      // @method addControl(control: Control): this
      // Adds the given control to the map
      addControl: function(i) {
        return i.addTo(this), this;
      },
      // @method removeControl(control: Control): this
      // Removes the given control from the map
      removeControl: function(i) {
        return i.remove(), this;
      },
      _initControlPos: function() {
        var i = this._controlCorners = {}, s = "leaflet-", d = this._controlContainer = yt("div", s + "control-container", this._container);
        function g(b, I) {
          var W = s + b + " " + s + I;
          i[b + I] = yt("div", W, d);
        }
        g("top", "left"), g("top", "right"), g("bottom", "left"), g("bottom", "right");
      },
      _clearControlPos: function() {
        for (var i in this._controlCorners)
          jt(this._controlCorners[i]);
        jt(this._controlContainer), delete this._controlCorners, delete this._controlContainer;
      }
    });
    var $a = wn.extend({
      // @section
      // @aka Control.Layers options
      options: {
        // @option collapsed: Boolean = true
        // If `true`, the control will be collapsed into an icon and expanded on mouse hover, touch, or keyboard activation.
        collapsed: !0,
        position: "topright",
        // @option autoZIndex: Boolean = true
        // If `true`, the control will assign zIndexes in increasing order to all of its layers so that the order is preserved when switching them on/off.
        autoZIndex: !0,
        // @option hideSingleBase: Boolean = false
        // If `true`, the base layers in the control will be hidden when there is only one.
        hideSingleBase: !1,
        // @option sortLayers: Boolean = false
        // Whether to sort the layers. When `false`, layers will keep the order
        // in which they were added to the control.
        sortLayers: !1,
        // @option sortFunction: Function = *
        // A [compare function](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/sort)
        // that will be used for sorting the layers, when `sortLayers` is `true`.
        // The function receives both the `L.Layer` instances and their names, as in
        // `sortFunction(layerA, layerB, nameA, nameB)`.
        // By default, it sorts layers alphabetically by their name.
        sortFunction: function(i, s, d, g) {
          return d < g ? -1 : g < d ? 1 : 0;
        }
      },
      initialize: function(i, s, d) {
        O(this, d), this._layerControlInputs = [], this._layers = [], this._lastZIndex = 0, this._handlingClick = !1, this._preventClick = !1;
        for (var g in i)
          this._addLayer(i[g], g);
        for (g in s)
          this._addLayer(s[g], g, !0);
      },
      onAdd: function(i) {
        this._initLayout(), this._update(), this._map = i, i.on("zoomend", this._checkDisabledLayers, this);
        for (var s = 0; s < this._layers.length; s++)
          this._layers[s].layer.on("add remove", this._onLayerChange, this);
        return this._container;
      },
      addTo: function(i) {
        return wn.prototype.addTo.call(this, i), this._expandIfNotCollapsed();
      },
      onRemove: function() {
        this._map.off("zoomend", this._checkDisabledLayers, this);
        for (var i = 0; i < this._layers.length; i++)
          this._layers[i].layer.off("add remove", this._onLayerChange, this);
      },
      // @method addBaseLayer(layer: Layer, name: String): this
      // Adds a base layer (radio button entry) with the given name to the control.
      addBaseLayer: function(i, s) {
        return this._addLayer(i, s), this._map ? this._update() : this;
      },
      // @method addOverlay(layer: Layer, name: String): this
      // Adds an overlay (checkbox entry) with the given name to the control.
      addOverlay: function(i, s) {
        return this._addLayer(i, s, !0), this._map ? this._update() : this;
      },
      // @method removeLayer(layer: Layer): this
      // Remove the given layer from the control.
      removeLayer: function(i) {
        i.off("add remove", this._onLayerChange, this);
        var s = this._getLayer(f(i));
        return s && this._layers.splice(this._layers.indexOf(s), 1), this._map ? this._update() : this;
      },
      // @method expand(): this
      // Expand the control container if collapsed.
      expand: function() {
        it(this._container, "leaflet-control-layers-expanded"), this._section.style.height = null;
        var i = this._map.getSize().y - (this._container.offsetTop + 50);
        return i < this._section.clientHeight ? (it(this._section, "leaflet-control-layers-scrollbar"), this._section.style.height = i + "px") : Gt(this._section, "leaflet-control-layers-scrollbar"), this._checkDisabledLayers(), this;
      },
      // @method collapse(): this
      // Collapse the control container if expanded.
      collapse: function() {
        return Gt(this._container, "leaflet-control-layers-expanded"), this;
      },
      _initLayout: function() {
        var i = "leaflet-control-layers", s = this._container = yt("div", i), d = this.options.collapsed;
        s.setAttribute("aria-haspopup", !0), Me(s), fe(s);
        var g = this._section = yt("section", i + "-list");
        d && (this._map.on("click", this.collapse, this), w(s, {
          mouseenter: this._expandSafely,
          mouseleave: this.collapse
        }, this));
        var b = this._layersLink = yt("a", i + "-toggle", s);
        b.href = "#", b.title = "Layers", b.setAttribute("role", "button"), w(b, {
          keydown: function(I) {
            I.keyCode === 13 && this._expandSafely();
          },
          // Certain screen readers intercept the key event and instead send a click event
          click: function(I) {
            Ie(I), this._expandSafely();
          }
        }, this), d || this.expand(), this._baseLayersList = yt("div", i + "-base", g), this._separator = yt("div", i + "-separator", g), this._overlaysList = yt("div", i + "-overlays", g), s.appendChild(g);
      },
      _getLayer: function(i) {
        for (var s = 0; s < this._layers.length; s++)
          if (this._layers[s] && f(this._layers[s].layer) === i)
            return this._layers[s];
      },
      _addLayer: function(i, s, d) {
        this._map && i.on("add remove", this._onLayerChange, this), this._layers.push({
          layer: i,
          name: s,
          overlay: d
        }), this.options.sortLayers && this._layers.sort(u(function(g, b) {
          return this.options.sortFunction(g.layer, b.layer, g.name, b.name);
        }, this)), this.options.autoZIndex && i.setZIndex && (this._lastZIndex++, i.setZIndex(this._lastZIndex)), this._expandIfNotCollapsed();
      },
      _update: function() {
        if (!this._container)
          return this;
        Vr(this._baseLayersList), Vr(this._overlaysList), this._layerControlInputs = [];
        var i, s, d, g, b = 0;
        for (d = 0; d < this._layers.length; d++)
          g = this._layers[d], this._addItem(g), s = s || g.overlay, i = i || !g.overlay, b += g.overlay ? 0 : 1;
        return this.options.hideSingleBase && (i = i && b > 1, this._baseLayersList.style.display = i ? "" : "none"), this._separator.style.display = s && i ? "" : "none", this;
      },
      _onLayerChange: function(i) {
        this._handlingClick || this._update();
        var s = this._getLayer(f(i.target)), d = s.overlay ? i.type === "add" ? "overlayadd" : "overlayremove" : i.type === "add" ? "baselayerchange" : null;
        d && this._map.fire(d, s);
      },
      // IE7 bugs out if you create a radio dynamically, so you have to do it this hacky way (see https://stackoverflow.com/a/119079)
      _createRadioElement: function(i, s) {
        var d = '<input type="radio" class="leaflet-control-layers-selector" name="' + i + '"' + (s ? ' checked="checked"' : "") + "/>", g = document.createElement("div");
        return g.innerHTML = d, g.firstChild;
      },
      _addItem: function(i) {
        var s = document.createElement("label"), d = this._map.hasLayer(i.layer), g;
        i.overlay ? (g = document.createElement("input"), g.type = "checkbox", g.className = "leaflet-control-layers-selector", g.defaultChecked = d) : g = this._createRadioElement("leaflet-base-layers_" + f(this), d), this._layerControlInputs.push(g), g.layerId = f(i.layer), w(g, "click", this._onInputClick, this);
        var b = document.createElement("span");
        b.innerHTML = " " + i.name;
        var I = document.createElement("span");
        s.appendChild(I), I.appendChild(g), I.appendChild(b);
        var W = i.overlay ? this._overlaysList : this._baseLayersList;
        return W.appendChild(s), this._checkDisabledLayers(), s;
      },
      _onInputClick: function() {
        if (!this._preventClick) {
          var i = this._layerControlInputs, s, d, g = [], b = [];
          this._handlingClick = !0;
          for (var I = i.length - 1; I >= 0; I--)
            s = i[I], d = this._getLayer(s.layerId).layer, s.checked ? g.push(d) : s.checked || b.push(d);
          for (I = 0; I < b.length; I++)
            this._map.hasLayer(b[I]) && this._map.removeLayer(b[I]);
          for (I = 0; I < g.length; I++)
            this._map.hasLayer(g[I]) || this._map.addLayer(g[I]);
          this._handlingClick = !1, this._refocusOnMap();
        }
      },
      _checkDisabledLayers: function() {
        for (var i = this._layerControlInputs, s, d, g = this._map.getZoom(), b = i.length - 1; b >= 0; b--)
          s = i[b], d = this._getLayer(s.layerId).layer, s.disabled = d.options.minZoom !== void 0 && g < d.options.minZoom || d.options.maxZoom !== void 0 && g > d.options.maxZoom;
      },
      _expandIfNotCollapsed: function() {
        return this._map && !this.options.collapsed && this.expand(), this;
      },
      _expandSafely: function() {
        var i = this._section;
        this._preventClick = !0, w(i, "click", Ie), this.expand();
        var s = this;
        setTimeout(function() {
          F(i, "click", Ie), s._preventClick = !1;
        });
      }
    }), Ao = function(i, s, d) {
      return new $a(i, s, d);
    }, Na = wn.extend({
      // @section
      // @aka Control.Zoom options
      options: {
        position: "topleft",
        // @option zoomInText: String = '<span aria-hidden="true">+</span>'
        // The text set on the 'zoom in' button.
        zoomInText: '<span aria-hidden="true">+</span>',
        // @option zoomInTitle: String = 'Zoom in'
        // The title set on the 'zoom in' button.
        zoomInTitle: "Zoom in",
        // @option zoomOutText: String = '<span aria-hidden="true">&#x2212;</span>'
        // The text set on the 'zoom out' button.
        zoomOutText: '<span aria-hidden="true">&#x2212;</span>',
        // @option zoomOutTitle: String = 'Zoom out'
        // The title set on the 'zoom out' button.
        zoomOutTitle: "Zoom out"
      },
      onAdd: function(i) {
        var s = "leaflet-control-zoom", d = yt("div", s + " leaflet-bar"), g = this.options;
        return this._zoomInButton = this._createButton(
          g.zoomInText,
          g.zoomInTitle,
          s + "-in",
          d,
          this._zoomIn
        ), this._zoomOutButton = this._createButton(
          g.zoomOutText,
          g.zoomOutTitle,
          s + "-out",
          d,
          this._zoomOut
        ), this._updateDisabled(), i.on("zoomend zoomlevelschange", this._updateDisabled, this), d;
      },
      onRemove: function(i) {
        i.off("zoomend zoomlevelschange", this._updateDisabled, this);
      },
      disable: function() {
        return this._disabled = !0, this._updateDisabled(), this;
      },
      enable: function() {
        return this._disabled = !1, this._updateDisabled(), this;
      },
      _zoomIn: function(i) {
        !this._disabled && this._map._zoom < this._map.getMaxZoom() && this._map.zoomIn(this._map.options.zoomDelta * (i.shiftKey ? 3 : 1));
      },
      _zoomOut: function(i) {
        !this._disabled && this._map._zoom > this._map.getMinZoom() && this._map.zoomOut(this._map.options.zoomDelta * (i.shiftKey ? 3 : 1));
      },
      _createButton: function(i, s, d, g, b) {
        var I = yt("a", d, g);
        return I.innerHTML = i, I.href = "#", I.title = s, I.setAttribute("role", "button"), I.setAttribute("aria-label", s), Me(I), w(I, "click", qe), w(I, "click", b, this), w(I, "click", this._refocusOnMap, this), I;
      },
      _updateDisabled: function() {
        var i = this._map, s = "leaflet-disabled";
        Gt(this._zoomInButton, s), Gt(this._zoomOutButton, s), this._zoomInButton.setAttribute("aria-disabled", "false"), this._zoomOutButton.setAttribute("aria-disabled", "false"), (this._disabled || i._zoom === i.getMinZoom()) && (it(this._zoomOutButton, s), this._zoomOutButton.setAttribute("aria-disabled", "true")), (this._disabled || i._zoom === i.getMaxZoom()) && (it(this._zoomInButton, s), this._zoomInButton.setAttribute("aria-disabled", "true"));
      }
    });
    st.mergeOptions({
      zoomControl: !0
    }), st.addInitHook(function() {
      this.options.zoomControl && (this.zoomControl = new Na(), this.addControl(this.zoomControl));
    });
    var za = function(i) {
      return new Na(i);
    }, Ro = wn.extend({
      // @section
      // @aka Control.Scale options
      options: {
        position: "bottomleft",
        // @option maxWidth: Number = 100
        // Maximum width of the control in pixels. The width is set dynamically to show round values (e.g. 100, 200, 500).
        maxWidth: 100,
        // @option metric: Boolean = True
        // Whether to show the metric scale line (m/km).
        metric: !0,
        // @option imperial: Boolean = True
        // Whether to show the imperial scale line (mi/ft).
        imperial: !0
        // @option updateWhenIdle: Boolean = false
        // If `true`, the control is updated on [`moveend`](#map-moveend), otherwise it's always up-to-date (updated on [`move`](#map-move)).
      },
      onAdd: function(i) {
        var s = "leaflet-control-scale", d = yt("div", s), g = this.options;
        return this._addScales(g, s + "-line", d), i.on(g.updateWhenIdle ? "moveend" : "move", this._update, this), i.whenReady(this._update, this), d;
      },
      onRemove: function(i) {
        i.off(this.options.updateWhenIdle ? "moveend" : "move", this._update, this);
      },
      _addScales: function(i, s, d) {
        i.metric && (this._mScale = yt("div", s, d)), i.imperial && (this._iScale = yt("div", s, d));
      },
      _update: function() {
        var i = this._map, s = i.getSize().y / 2, d = i.distance(
          i.containerPointToLatLng([0, s]),
          i.containerPointToLatLng([this.options.maxWidth, s])
        );
        this._updateScales(d);
      },
      _updateScales: function(i) {
        this.options.metric && i && this._updateMetric(i), this.options.imperial && i && this._updateImperial(i);
      },
      _updateMetric: function(i) {
        var s = this._getRoundNum(i), d = s < 1e3 ? s + " m" : s / 1e3 + " km";
        this._updateScale(this._mScale, d, s / i);
      },
      _updateImperial: function(i) {
        var s = i * 3.2808399, d, g, b;
        s > 5280 ? (d = s / 5280, g = this._getRoundNum(d), this._updateScale(this._iScale, g + " mi", g / d)) : (b = this._getRoundNum(s), this._updateScale(this._iScale, b + " ft", b / s));
      },
      _updateScale: function(i, s, d) {
        i.style.width = Math.round(this.options.maxWidth * d) + "px", i.innerHTML = s;
      },
      _getRoundNum: function(i) {
        var s = Math.pow(10, (Math.floor(i) + "").length - 1), d = i / s;
        return d = d >= 10 ? 10 : d >= 5 ? 5 : d >= 3 ? 3 : d >= 2 ? 2 : 1, s * d;
      }
    }), pl = function(i) {
      return new Ro(i);
    }, Ug = '<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 12 8" class="leaflet-attribution-flag"><path fill="#4C7BE1" d="M0 0h12v4H0z"/><path fill="#FFD500" d="M0 4h12v3H0z"/><path fill="#E0BC00" d="M0 7h12v1H0z"/></svg>', ml = wn.extend({
      // @section
      // @aka Control.Attribution options
      options: {
        position: "bottomright",
        // @option prefix: String|false = 'Leaflet'
        // The HTML text shown before the attributions. Pass `false` to disable.
        prefix: '<a href="https://leafletjs.com" title="A JavaScript library for interactive maps">' + (Be.inlineSvg ? Ug + " " : "") + "Leaflet</a>"
      },
      initialize: function(i) {
        O(this, i), this._attributions = {};
      },
      onAdd: function(i) {
        i.attributionControl = this, this._container = yt("div", "leaflet-control-attribution"), Me(this._container);
        for (var s in i._layers)
          i._layers[s].getAttribution && this.addAttribution(i._layers[s].getAttribution());
        return this._update(), i.on("layeradd", this._addAttribution, this), this._container;
      },
      onRemove: function(i) {
        i.off("layeradd", this._addAttribution, this);
      },
      _addAttribution: function(i) {
        i.layer.getAttribution && (this.addAttribution(i.layer.getAttribution()), i.layer.once("remove", function() {
          this.removeAttribution(i.layer.getAttribution());
        }, this));
      },
      // @method setPrefix(prefix: String|false): this
      // The HTML text shown before the attributions. Pass `false` to disable.
      setPrefix: function(i) {
        return this.options.prefix = i, this._update(), this;
      },
      // @method addAttribution(text: String): this
      // Adds an attribution text (e.g. `'&copy; OpenStreetMap contributors'`).
      addAttribution: function(i) {
        return i ? (this._attributions[i] || (this._attributions[i] = 0), this._attributions[i]++, this._update(), this) : this;
      },
      // @method removeAttribution(text: String): this
      // Removes an attribution text.
      removeAttribution: function(i) {
        return i ? (this._attributions[i] && (this._attributions[i]--, this._update()), this) : this;
      },
      _update: function() {
        if (this._map) {
          var i = [];
          for (var s in this._attributions)
            this._attributions[s] && i.push(s);
          var d = [];
          this.options.prefix && d.push(this.options.prefix), i.length && d.push(i.join(", ")), this._container.innerHTML = d.join(' <span aria-hidden="true">|</span> ');
        }
      }
    });
    st.mergeOptions({
      attributionControl: !0
    }), st.addInitHook(function() {
      this.options.attributionControl && new ml().addTo(this);
    });
    var Zg = function(i) {
      return new ml(i);
    };
    wn.Layers = $a, wn.Zoom = Na, wn.Scale = Ro, wn.Attribution = ml, En.layers = Ao, En.zoom = za, En.scale = pl, En.attribution = Zg;
    var ci = re.extend({
      initialize: function(i) {
        this._map = i;
      },
      // @method enable(): this
      // Enables the handler
      enable: function() {
        return this._enabled ? this : (this._enabled = !0, this.addHooks(), this);
      },
      // @method disable(): this
      // Disables the handler
      disable: function() {
        return this._enabled ? (this._enabled = !1, this.removeHooks(), this) : this;
      },
      // @method enabled(): Boolean
      // Returns `true` if the handler is enabled
      enabled: function() {
        return !!this._enabled;
      }
      // @section Extension methods
      // Classes inheriting from `Handler` must implement the two following methods:
      // @method addHooks()
      // Called when the handler is enabled, should add event hooks.
      // @method removeHooks()
      // Called when the handler is disabled, should remove the event hooks added previously.
    });
    ci.addTo = function(i, s) {
      return i.addHandler(s, this), this;
    };
    var Wg = { Events: ke }, dc = Be.touch ? "touchstart mousedown" : "mousedown", Gi = Ae.extend({
      options: {
        // @section
        // @aka Draggable options
        // @option clickTolerance: Number = 3
        // The max number of pixels a user can shift the mouse pointer during a click
        // for it to be considered a valid click (as opposed to a mouse drag).
        clickTolerance: 3
      },
      // @constructor L.Draggable(el: HTMLElement, dragHandle?: HTMLElement, preventOutline?: Boolean, options?: Draggable options)
      // Creates a `Draggable` object for moving `el` when you start dragging the `dragHandle` element (equals `el` itself by default).
      initialize: function(i, s, d, g) {
        O(this, g), this._element = i, this._dragStartTarget = s || i, this._preventOutline = d;
      },
      // @method enable()
      // Enables the dragging ability
      enable: function() {
        this._enabled || (w(this._dragStartTarget, dc, this._onDown, this), this._enabled = !0);
      },
      // @method disable()
      // Disables the dragging ability
      disable: function() {
        this._enabled && (Gi._dragging === this && this.finishDrag(!0), F(this._dragStartTarget, dc, this._onDown, this), this._enabled = !1, this._moved = !1);
      },
      _onDown: function(i) {
        if (this._enabled && (this._moved = !1, !Aa(this._element, "leaflet-zoom-anim"))) {
          if (i.touches && i.touches.length !== 1) {
            Gi._dragging === this && this.finishDrag();
            return;
          }
          if (!(Gi._dragging || i.shiftKey || i.which !== 1 && i.button !== 1 && !i.touches) && (Gi._dragging = this, this._preventOutline && Ba(this._element), gr(), fr(), !this._moving)) {
            this.fire("down");
            var s = i.touches ? i.touches[0] : i, d = c(this._element);
            this._startPoint = new pe(s.clientX, s.clientY), this._startPos = Wn(this._element), this._parentScale = p(d);
            var g = i.type === "mousedown";
            w(document, g ? "mousemove" : "touchmove", this._onMove, this), w(document, g ? "mouseup" : "touchend touchcancel", this._onUp, this);
          }
        }
      },
      _onMove: function(i) {
        if (this._enabled) {
          if (i.touches && i.touches.length > 1) {
            this._moved = !0;
            return;
          }
          var s = i.touches && i.touches.length === 1 ? i.touches[0] : i, d = new pe(s.clientX, s.clientY)._subtract(this._startPoint);
          !d.x && !d.y || Math.abs(d.x) + Math.abs(d.y) < this.options.clickTolerance || (d.x /= this._parentScale.x, d.y /= this._parentScale.y, Ie(i), this._moved || (this.fire("dragstart"), this._moved = !0, it(document.body, "leaflet-dragging"), this._lastTarget = i.target || i.srcElement, window.SVGElementInstance && this._lastTarget instanceof window.SVGElementInstance && (this._lastTarget = this._lastTarget.correspondingUseElement), it(this._lastTarget, "leaflet-drag-target")), this._newPos = this._startPos.add(d), this._moving = !0, this._lastEvent = i, this._updatePosition());
        }
      },
      _updatePosition: function() {
        var i = { originalEvent: this._lastEvent };
        this.fire("predrag", i), Vt(this._element, this._newPos), this.fire("drag", i);
      },
      _onUp: function() {
        this._enabled && this.finishDrag();
      },
      finishDrag: function(i) {
        Gt(document.body, "leaflet-dragging"), this._lastTarget && (Gt(this._lastTarget, "leaflet-drag-target"), this._lastTarget = null), F(document, "mousemove touchmove", this._onMove, this), F(document, "mouseup touchend touchcancel", this._onUp, this), vr(), pr();
        var s = this._moved && this._moving;
        this._moving = !1, Gi._dragging = !1, s && this.fire("dragend", {
          noInertia: i,
          distance: this._newPos.distanceTo(this._startPos)
        });
      }
    });
    function fc(i, s, d) {
      var g, b = [1, 4, 2, 8], I, W, le, de, Le, ze, Ke, dt;
      for (I = 0, ze = i.length; I < ze; I++)
        i[I]._code = _r(i[I], s);
      for (le = 0; le < 4; le++) {
        for (Ke = b[le], g = [], I = 0, ze = i.length, W = ze - 1; I < ze; W = I++)
          de = i[I], Le = i[W], de._code & Ke ? Le._code & Ke || (dt = Bo(Le, de, Ke, s, d), dt._code = _r(dt, s), g.push(dt)) : (Le._code & Ke && (dt = Bo(Le, de, Ke, s, d), dt._code = _r(dt, s), g.push(dt)), g.push(de));
        i = g;
      }
      return i;
    }
    function pc(i, s) {
      var d, g, b, I, W, le, de, Le, ze;
      if (!i || i.length === 0)
        throw new Error("latlngs not passed");
      An(i) || (console.warn("latlngs are not flat! Only the first ring will be used"), i = i[0]);
      var Ke = Ne([0, 0]), dt = Ve(i), kn = dt.getNorthWest().distanceTo(dt.getSouthWest()) * dt.getNorthEast().distanceTo(dt.getNorthWest());
      kn < 1700 && (Ke = gl(i));
      var hn = i.length, Rn = [];
      for (d = 0; d < hn; d++) {
        var Cn = Ne(i[d]);
        Rn.push(s.project(Ne([Cn.lat - Ke.lat, Cn.lng - Ke.lng])));
      }
      for (le = de = Le = 0, d = 0, g = hn - 1; d < hn; g = d++)
        b = Rn[d], I = Rn[g], W = b.y * I.x - I.y * b.x, de += (b.x + I.x) * W, Le += (b.y + I.y) * W, le += W * 3;
      le === 0 ? ze = Rn[0] : ze = [de / le, Le / le];
      var Qr = s.unproject(ue(ze));
      return Ne([Qr.lat + Ke.lat, Qr.lng + Ke.lng]);
    }
    function gl(i) {
      for (var s = 0, d = 0, g = 0, b = 0; b < i.length; b++) {
        var I = Ne(i[b]);
        s += I.lat, d += I.lng, g++;
      }
      return Ne([s / g, d / g]);
    }
    var Gg = {
      __proto__: null,
      clipPolygon: fc,
      polygonCenter: pc,
      centroid: gl
    };
    function mc(i, s) {
      if (!s || !i.length)
        return i.slice();
      var d = s * s;
      return i = Jg(i, d), i = Kg(i, d), i;
    }
    function gc(i, s, d) {
      return Math.sqrt(Fa(i, s, d, !0));
    }
    function qg(i, s, d) {
      return Fa(i, s, d);
    }
    function Kg(i, s) {
      var d = i.length, g = typeof Uint8Array < "u" ? Uint8Array : Array, b = new g(d);
      b[0] = b[d - 1] = 1, vl(i, b, s, 0, d - 1);
      var I, W = [];
      for (I = 0; I < d; I++)
        b[I] && W.push(i[I]);
      return W;
    }
    function vl(i, s, d, g, b) {
      var I = 0, W, le, de;
      for (le = g + 1; le <= b - 1; le++)
        de = Fa(i[le], i[g], i[b], !0), de > I && (W = le, I = de);
      I > d && (s[W] = 1, vl(i, s, d, g, W), vl(i, s, d, W, b));
    }
    function Jg(i, s) {
      for (var d = [i[0]], g = 1, b = 0, I = i.length; g < I; g++)
        Xg(i[g], i[b]) > s && (d.push(i[g]), b = g);
      return b < I - 1 && d.push(i[I - 1]), d;
    }
    var vc;
    function _c(i, s, d, g, b) {
      var I = g ? vc : _r(i, d), W = _r(s, d), le, de, Le;
      for (vc = W; ; ) {
        if (!(I | W))
          return [i, s];
        if (I & W)
          return !1;
        le = I || W, de = Bo(i, s, le, d, b), Le = _r(de, d), le === I ? (i = de, I = Le) : (s = de, W = Le);
      }
    }
    function Bo(i, s, d, g, b) {
      var I = s.x - i.x, W = s.y - i.y, le = g.min, de = g.max, Le, ze;
      return d & 8 ? (Le = i.x + I * (de.y - i.y) / W, ze = de.y) : d & 4 ? (Le = i.x + I * (le.y - i.y) / W, ze = le.y) : d & 2 ? (Le = de.x, ze = i.y + W * (de.x - i.x) / I) : d & 1 && (Le = le.x, ze = i.y + W * (le.x - i.x) / I), new pe(Le, ze, b);
    }
    function _r(i, s) {
      var d = 0;
      return i.x < s.min.x ? d |= 1 : i.x > s.max.x && (d |= 2), i.y < s.min.y ? d |= 4 : i.y > s.max.y && (d |= 8), d;
    }
    function Xg(i, s) {
      var d = s.x - i.x, g = s.y - i.y;
      return d * d + g * g;
    }
    function Fa(i, s, d, g) {
      var b = s.x, I = s.y, W = d.x - b, le = d.y - I, de = W * W + le * le, Le;
      return de > 0 && (Le = ((i.x - b) * W + (i.y - I) * le) / de, Le > 1 ? (b = d.x, I = d.y) : Le > 0 && (b += W * Le, I += le * Le)), W = i.x - b, le = i.y - I, g ? W * W + le * le : new pe(b, I);
    }
    function An(i) {
      return !A(i[0]) || typeof i[0][0] != "object" && typeof i[0][0] < "u";
    }
    function yc(i) {
      return console.warn("Deprecated use of _flat, please use L.LineUtil.isFlat instead."), An(i);
    }
    function bc(i, s) {
      var d, g, b, I, W, le, de, Le;
      if (!i || i.length === 0)
        throw new Error("latlngs not passed");
      An(i) || (console.warn("latlngs are not flat! Only the first ring will be used"), i = i[0]);
      var ze = Ne([0, 0]), Ke = Ve(i), dt = Ke.getNorthWest().distanceTo(Ke.getSouthWest()) * Ke.getNorthEast().distanceTo(Ke.getNorthWest());
      dt < 1700 && (ze = gl(i));
      var kn = i.length, hn = [];
      for (d = 0; d < kn; d++) {
        var Rn = Ne(i[d]);
        hn.push(s.project(Ne([Rn.lat - ze.lat, Rn.lng - ze.lng])));
      }
      for (d = 0, g = 0; d < kn - 1; d++)
        g += hn[d].distanceTo(hn[d + 1]) / 2;
      if (g === 0)
        Le = hn[0];
      else
        for (d = 0, I = 0; d < kn - 1; d++)
          if (W = hn[d], le = hn[d + 1], b = W.distanceTo(le), I += b, I > g) {
            de = (I - g) / b, Le = [
              le.x - de * (le.x - W.x),
              le.y - de * (le.y - W.y)
            ];
            break;
          }
      var Cn = s.unproject(ue(Le));
      return Ne([Cn.lat + ze.lat, Cn.lng + ze.lng]);
    }
    var Qg = {
      __proto__: null,
      simplify: mc,
      pointToSegmentDistance: gc,
      closestPointOnSegment: qg,
      clipSegment: _c,
      _getEdgeIntersection: Bo,
      _getBitCode: _r,
      _sqClosestPointOnSegment: Fa,
      isFlat: An,
      _flat: yc,
      polylineCenter: bc
    }, _l = {
      project: function(i) {
        return new pe(i.lng, i.lat);
      },
      unproject: function(i) {
        return new Ze(i.y, i.x);
      },
      bounds: new Fe([-180, -90], [180, 90])
    }, yl = {
      R: 6378137,
      R_MINOR: 6356752314245179e-9,
      bounds: new Fe([-2003750834279e-5, -1549657073972e-5], [2003750834279e-5, 1876465623138e-5]),
      project: function(i) {
        var s = Math.PI / 180, d = this.R, g = i.lat * s, b = this.R_MINOR / d, I = Math.sqrt(1 - b * b), W = I * Math.sin(g), le = Math.tan(Math.PI / 4 - g / 2) / Math.pow((1 - W) / (1 + W), I / 2);
        return g = -d * Math.log(Math.max(le, 1e-10)), new pe(i.lng * s * d, g);
      },
      unproject: function(i) {
        for (var s = 180 / Math.PI, d = this.R, g = this.R_MINOR / d, b = Math.sqrt(1 - g * g), I = Math.exp(-i.y / d), W = Math.PI / 2 - 2 * Math.atan(I), le = 0, de = 0.1, Le; le < 15 && Math.abs(de) > 1e-7; le++)
          Le = b * Math.sin(W), Le = Math.pow((1 - Le) / (1 + Le), b / 2), de = Math.PI / 2 - 2 * Math.atan(I * Le) - W, W += de;
        return new Ze(W * s, i.x * s / d);
      }
    }, ev = {
      __proto__: null,
      LonLat: _l,
      Mercator: yl,
      SphericalMercator: an
    }, tv = a({}, pt, {
      code: "EPSG:3395",
      projection: yl,
      transformation: function() {
        var i = 0.5 / (Math.PI * yl.R);
        return Dt(i, 0.5, -i, 0.5);
      }()
    }), wc = a({}, pt, {
      code: "EPSG:4326",
      projection: _l,
      transformation: Dt(1 / 180, 1, -1 / 180, 0.5)
    }), nv = a({}, ft, {
      projection: _l,
      transformation: Dt(1, 0, -1, 0),
      scale: function(i) {
        return Math.pow(2, i);
      },
      zoom: function(i) {
        return Math.log(i) / Math.LN2;
      },
      distance: function(i, s) {
        var d = s.lng - i.lng, g = s.lat - i.lat;
        return Math.sqrt(d * d + g * g);
      },
      infinite: !0
    });
    ft.Earth = pt, ft.EPSG3395 = tv, ft.EPSG3857 = Zt, ft.EPSG900913 = It, ft.EPSG4326 = wc, ft.Simple = nv;
    var Gn = Ae.extend({
      // Classes extending `L.Layer` will inherit the following options:
      options: {
        // @option pane: String = 'overlayPane'
        // By default the layer will be added to the map's [overlay pane](#map-overlaypane). Overriding this option will cause the layer to be placed on another pane by default.
        pane: "overlayPane",
        // @option attribution: String = null
        // String to be shown in the attribution control, e.g. "© OpenStreetMap contributors". It describes the layer data and is often a legal obligation towards copyright holders and tile providers.
        attribution: null,
        bubblingMouseEvents: !0
      },
      /* @section
       * Classes extending `L.Layer` will inherit the following methods:
       *
       * @method addTo(map: Map|LayerGroup): this
       * Adds the layer to the given map or layer group.
       */
      addTo: function(i) {
        return i.addLayer(this), this;
      },
      // @method remove: this
      // Removes the layer from the map it is currently active on.
      remove: function() {
        return this.removeFrom(this._map || this._mapToAdd);
      },
      // @method removeFrom(map: Map): this
      // Removes the layer from the given map
      //
      // @alternative
      // @method removeFrom(group: LayerGroup): this
      // Removes the layer from the given `LayerGroup`
      removeFrom: function(i) {
        return i && i.removeLayer(this), this;
      },
      // @method getPane(name? : String): HTMLElement
      // Returns the `HTMLElement` representing the named pane on the map. If `name` is omitted, returns the pane for this layer.
      getPane: function(i) {
        return this._map.getPane(i ? this.options[i] || i : this.options.pane);
      },
      addInteractiveTarget: function(i) {
        return this._map._targets[f(i)] = this, this;
      },
      removeInteractiveTarget: function(i) {
        return delete this._map._targets[f(i)], this;
      },
      // @method getAttribution: String
      // Used by the `attribution control`, returns the [attribution option](#gridlayer-attribution).
      getAttribution: function() {
        return this.options.attribution;
      },
      _layerAdd: function(i) {
        var s = i.target;
        if (s.hasLayer(this)) {
          if (this._map = s, this._zoomAnimated = s._zoomAnimated, this.getEvents) {
            var d = this.getEvents();
            s.on(d, this), this.once("remove", function() {
              s.off(d, this);
            }, this);
          }
          this.onAdd(s), this.fire("add"), s.fire("layeradd", { layer: this });
        }
      }
    });
    st.include({
      // @method addLayer(layer: Layer): this
      // Adds the given layer to the map
      addLayer: function(i) {
        if (!i._layerAdd)
          throw new Error("The provided object is not a Layer.");
        var s = f(i);
        return this._layers[s] ? this : (this._layers[s] = i, i._mapToAdd = this, i.beforeAdd && i.beforeAdd(this), this.whenReady(i._layerAdd, i), this);
      },
      // @method removeLayer(layer: Layer): this
      // Removes the given layer from the map.
      removeLayer: function(i) {
        var s = f(i);
        return this._layers[s] ? (this._loaded && i.onRemove(this), delete this._layers[s], this._loaded && (this.fire("layerremove", { layer: i }), i.fire("remove")), i._map = i._mapToAdd = null, this) : this;
      },
      // @method hasLayer(layer: Layer): Boolean
      // Returns `true` if the given layer is currently added to the map
      hasLayer: function(i) {
        return f(i) in this._layers;
      },
      /* @method eachLayer(fn: Function, context?: Object): this
       * Iterates over the layers of the map, optionally specifying context of the iterator function.
       * ```
       * map.eachLayer(function(layer){
       *     layer.bindPopup('Hello');
       * });
       * ```
       */
      eachLayer: function(i, s) {
        for (var d in this._layers)
          i.call(s, this._layers[d]);
        return this;
      },
      _addLayers: function(i) {
        i = i ? A(i) ? i : [i] : [];
        for (var s = 0, d = i.length; s < d; s++)
          this.addLayer(i[s]);
      },
      _addZoomLimit: function(i) {
        (!isNaN(i.options.maxZoom) || !isNaN(i.options.minZoom)) && (this._zoomBoundLayers[f(i)] = i, this._updateZoomLevels());
      },
      _removeZoomLimit: function(i) {
        var s = f(i);
        this._zoomBoundLayers[s] && (delete this._zoomBoundLayers[s], this._updateZoomLevels());
      },
      _updateZoomLevels: function() {
        var i = 1 / 0, s = -1 / 0, d = this._getZoomSpan();
        for (var g in this._zoomBoundLayers) {
          var b = this._zoomBoundLayers[g].options;
          i = b.minZoom === void 0 ? i : Math.min(i, b.minZoom), s = b.maxZoom === void 0 ? s : Math.max(s, b.maxZoom);
        }
        this._layersMaxZoom = s === -1 / 0 ? void 0 : s, this._layersMinZoom = i === 1 / 0 ? void 0 : i, d !== this._getZoomSpan() && this.fire("zoomlevelschange"), this.options.maxZoom === void 0 && this._layersMaxZoom && this.getZoom() > this._layersMaxZoom && this.setZoom(this._layersMaxZoom), this.options.minZoom === void 0 && this._layersMinZoom && this.getZoom() < this._layersMinZoom && this.setZoom(this._layersMinZoom);
      }
    });
    var Gr = Gn.extend({
      initialize: function(i, s) {
        O(this, s), this._layers = {};
        var d, g;
        if (i)
          for (d = 0, g = i.length; d < g; d++)
            this.addLayer(i[d]);
      },
      // @method addLayer(layer: Layer): this
      // Adds the given layer to the group.
      addLayer: function(i) {
        var s = this.getLayerId(i);
        return this._layers[s] = i, this._map && this._map.addLayer(i), this;
      },
      // @method removeLayer(layer: Layer): this
      // Removes the given layer from the group.
      // @alternative
      // @method removeLayer(id: Number): this
      // Removes the layer with the given internal ID from the group.
      removeLayer: function(i) {
        var s = i in this._layers ? i : this.getLayerId(i);
        return this._map && this._layers[s] && this._map.removeLayer(this._layers[s]), delete this._layers[s], this;
      },
      // @method hasLayer(layer: Layer): Boolean
      // Returns `true` if the given layer is currently added to the group.
      // @alternative
      // @method hasLayer(id: Number): Boolean
      // Returns `true` if the given internal ID is currently added to the group.
      hasLayer: function(i) {
        var s = typeof i == "number" ? i : this.getLayerId(i);
        return s in this._layers;
      },
      // @method clearLayers(): this
      // Removes all the layers from the group.
      clearLayers: function() {
        return this.eachLayer(this.removeLayer, this);
      },
      // @method invoke(methodName: String, …): this
      // Calls `methodName` on every layer contained in this group, passing any
      // additional parameters. Has no effect if the layers contained do not
      // implement `methodName`.
      invoke: function(i) {
        var s = Array.prototype.slice.call(arguments, 1), d, g;
        for (d in this._layers)
          g = this._layers[d], g[i] && g[i].apply(g, s);
        return this;
      },
      onAdd: function(i) {
        this.eachLayer(i.addLayer, i);
      },
      onRemove: function(i) {
        this.eachLayer(i.removeLayer, i);
      },
      // @method eachLayer(fn: Function, context?: Object): this
      // Iterates over the layers of the group, optionally specifying context of the iterator function.
      // ```js
      // group.eachLayer(function (layer) {
      // 	layer.bindPopup('Hello');
      // });
      // ```
      eachLayer: function(i, s) {
        for (var d in this._layers)
          i.call(s, this._layers[d]);
        return this;
      },
      // @method getLayer(id: Number): Layer
      // Returns the layer with the given internal ID.
      getLayer: function(i) {
        return this._layers[i];
      },
      // @method getLayers(): Layer[]
      // Returns an array of all the layers added to the group.
      getLayers: function() {
        var i = [];
        return this.eachLayer(i.push, i), i;
      },
      // @method setZIndex(zIndex: Number): this
      // Calls `setZIndex` on every layer contained in this group, passing the z-index.
      setZIndex: function(i) {
        return this.invoke("setZIndex", i);
      },
      // @method getLayerId(layer: Layer): Number
      // Returns the internal ID for a layer
      getLayerId: function(i) {
        return f(i);
      }
    }), iv = function(i, s) {
      return new Gr(i, s);
    }, wi = Gr.extend({
      addLayer: function(i) {
        return this.hasLayer(i) ? this : (i.addEventParent(this), Gr.prototype.addLayer.call(this, i), this.fire("layeradd", { layer: i }));
      },
      removeLayer: function(i) {
        return this.hasLayer(i) ? (i in this._layers && (i = this._layers[i]), i.removeEventParent(this), Gr.prototype.removeLayer.call(this, i), this.fire("layerremove", { layer: i })) : this;
      },
      // @method setStyle(style: Path options): this
      // Sets the given path options to each layer of the group that has a `setStyle` method.
      setStyle: function(i) {
        return this.invoke("setStyle", i);
      },
      // @method bringToFront(): this
      // Brings the layer group to the top of all other layers
      bringToFront: function() {
        return this.invoke("bringToFront");
      },
      // @method bringToBack(): this
      // Brings the layer group to the back of all other layers
      bringToBack: function() {
        return this.invoke("bringToBack");
      },
      // @method getBounds(): LatLngBounds
      // Returns the LatLngBounds of the Feature Group (created from bounds and coordinates of its children).
      getBounds: function() {
        var i = new nt();
        for (var s in this._layers) {
          var d = this._layers[s];
          i.extend(d.getBounds ? d.getBounds() : d.getLatLng());
        }
        return i;
      }
    }), rv = function(i, s) {
      return new wi(i, s);
    }, qr = re.extend({
      /* @section
       * @aka Icon options
       *
       * @option iconUrl: String = null
       * **(required)** The URL to the icon image (absolute or relative to your script path).
       *
       * @option iconRetinaUrl: String = null
       * The URL to a retina sized version of the icon image (absolute or relative to your
       * script path). Used for Retina screen devices.
       *
       * @option iconSize: Point = null
       * Size of the icon image in pixels.
       *
       * @option iconAnchor: Point = null
       * The coordinates of the "tip" of the icon (relative to its top left corner). The icon
       * will be aligned so that this point is at the marker's geographical location. Centered
       * by default if size is specified, also can be set in CSS with negative margins.
       *
       * @option popupAnchor: Point = [0, 0]
       * The coordinates of the point from which popups will "open", relative to the icon anchor.
       *
       * @option tooltipAnchor: Point = [0, 0]
       * The coordinates of the point from which tooltips will "open", relative to the icon anchor.
       *
       * @option shadowUrl: String = null
       * The URL to the icon shadow image. If not specified, no shadow image will be created.
       *
       * @option shadowRetinaUrl: String = null
       *
       * @option shadowSize: Point = null
       * Size of the shadow image in pixels.
       *
       * @option shadowAnchor: Point = null
       * The coordinates of the "tip" of the shadow (relative to its top left corner) (the same
       * as iconAnchor if not specified).
       *
       * @option className: String = ''
       * A custom class name to assign to both icon and shadow images. Empty by default.
       */
      options: {
        popupAnchor: [0, 0],
        tooltipAnchor: [0, 0],
        // @option crossOrigin: Boolean|String = false
        // Whether the crossOrigin attribute will be added to the tiles.
        // If a String is provided, all tiles will have their crossOrigin attribute set to the String provided. This is needed if you want to access tile pixel data.
        // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
        crossOrigin: !1
      },
      initialize: function(i) {
        O(this, i);
      },
      // @method createIcon(oldIcon?: HTMLElement): HTMLElement
      // Called internally when the icon has to be shown, returns a `<img>` HTML element
      // styled according to the options.
      createIcon: function(i) {
        return this._createIcon("icon", i);
      },
      // @method createShadow(oldIcon?: HTMLElement): HTMLElement
      // As `createIcon`, but for the shadow beneath it.
      createShadow: function(i) {
        return this._createIcon("shadow", i);
      },
      _createIcon: function(i, s) {
        var d = this._getIconUrl(i);
        if (!d) {
          if (i === "icon")
            throw new Error("iconUrl not set in Icon options (see the docs).");
          return null;
        }
        var g = this._createImg(d, s && s.tagName === "IMG" ? s : null);
        return this._setIconStyles(g, i), (this.options.crossOrigin || this.options.crossOrigin === "") && (g.crossOrigin = this.options.crossOrigin === !0 ? "" : this.options.crossOrigin), g;
      },
      _setIconStyles: function(i, s) {
        var d = this.options, g = d[s + "Size"];
        typeof g == "number" && (g = [g, g]);
        var b = ue(g), I = ue(s === "shadow" && d.shadowAnchor || d.iconAnchor || b && b.divideBy(2, !0));
        i.className = "leaflet-marker-" + s + " " + (d.className || ""), I && (i.style.marginLeft = -I.x + "px", i.style.marginTop = -I.y + "px"), b && (i.style.width = b.x + "px", i.style.height = b.y + "px");
      },
      _createImg: function(i, s) {
        return s = s || document.createElement("img"), s.src = i, s;
      },
      _getIconUrl: function(i) {
        return Be.retina && this.options[i + "RetinaUrl"] || this.options[i + "Url"];
      }
    });
    function av(i) {
      return new qr(i);
    }
    var ja = qr.extend({
      options: {
        iconUrl: "marker-icon.png",
        iconRetinaUrl: "marker-icon-2x.png",
        shadowUrl: "marker-shadow.png",
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        tooltipAnchor: [16, -28],
        shadowSize: [41, 41]
      },
      _getIconUrl: function(i) {
        return typeof ja.imagePath != "string" && (ja.imagePath = this._detectIconPath()), (this.options.imagePath || ja.imagePath) + qr.prototype._getIconUrl.call(this, i);
      },
      _stripUrl: function(i) {
        var s = function(d, g, b) {
          var I = g.exec(d);
          return I && I[b];
        };
        return i = s(i, /^url\((['"])?(.+)\1\)$/, 2), i && s(i, /^(.*)marker-icon\.png$/, 1);
      },
      _detectIconPath: function() {
        var i = yt("div", "leaflet-default-icon-path", document.body), s = Zi(i, "background-image") || Zi(i, "backgroundImage");
        if (document.body.removeChild(i), s = this._stripUrl(s), s)
          return s;
        var d = document.querySelector('link[href$="leaflet.css"]');
        return d ? d.href.substring(0, d.href.length - 11 - 1) : "";
      }
    }), kc = ci.extend({
      initialize: function(i) {
        this._marker = i;
      },
      addHooks: function() {
        var i = this._marker._icon;
        this._draggable || (this._draggable = new Gi(i, i, !0)), this._draggable.on({
          dragstart: this._onDragStart,
          predrag: this._onPreDrag,
          drag: this._onDrag,
          dragend: this._onDragEnd
        }, this).enable(), it(i, "leaflet-marker-draggable");
      },
      removeHooks: function() {
        this._draggable.off({
          dragstart: this._onDragStart,
          predrag: this._onPreDrag,
          drag: this._onDrag,
          dragend: this._onDragEnd
        }, this).disable(), this._marker._icon && Gt(this._marker._icon, "leaflet-marker-draggable");
      },
      moved: function() {
        return this._draggable && this._draggable._moved;
      },
      _adjustPan: function(i) {
        var s = this._marker, d = s._map, g = this._marker.options.autoPanSpeed, b = this._marker.options.autoPanPadding, I = Wn(s._icon), W = d.getPixelBounds(), le = d.getPixelOrigin(), de = Pe(
          W.min._subtract(le).add(b),
          W.max._subtract(le).subtract(b)
        );
        if (!de.contains(I)) {
          var Le = ue(
            (Math.max(de.max.x, I.x) - de.max.x) / (W.max.x - de.max.x) - (Math.min(de.min.x, I.x) - de.min.x) / (W.min.x - de.min.x),
            (Math.max(de.max.y, I.y) - de.max.y) / (W.max.y - de.max.y) - (Math.min(de.min.y, I.y) - de.min.y) / (W.min.y - de.min.y)
          ).multiplyBy(g);
          d.panBy(Le, { animate: !1 }), this._draggable._newPos._add(Le), this._draggable._startPos._add(Le), Vt(s._icon, this._draggable._newPos), this._onDrag(i), this._panRequest = ae(this._adjustPan.bind(this, i));
        }
      },
      _onDragStart: function() {
        this._oldLatLng = this._marker.getLatLng(), this._marker.closePopup && this._marker.closePopup(), this._marker.fire("movestart").fire("dragstart");
      },
      _onPreDrag: function(i) {
        this._marker.options.autoPan && (ne(this._panRequest), this._panRequest = ae(this._adjustPan.bind(this, i)));
      },
      _onDrag: function(i) {
        var s = this._marker, d = s._shadow, g = Wn(s._icon), b = s._map.layerPointToLatLng(g);
        d && Vt(d, g), s._latlng = b, i.latlng = b, i.oldLatLng = this._oldLatLng, s.fire("move", i).fire("drag", i);
      },
      _onDragEnd: function(i) {
        ne(this._panRequest), delete this._oldLatLng, this._marker.fire("moveend").fire("dragend", i);
      }
    }), $o = Gn.extend({
      // @section
      // @aka Marker options
      options: {
        // @option icon: Icon = *
        // Icon instance to use for rendering the marker.
        // See [Icon documentation](#L.Icon) for details on how to customize the marker icon.
        // If not specified, a common instance of `L.Icon.Default` is used.
        icon: new ja(),
        // Option inherited from "Interactive layer" abstract class
        interactive: !0,
        // @option keyboard: Boolean = true
        // Whether the marker can be tabbed to with a keyboard and clicked by pressing enter.
        keyboard: !0,
        // @option title: String = ''
        // Text for the browser tooltip that appear on marker hover (no tooltip by default).
        // [Useful for accessibility](https://leafletjs.com/examples/accessibility/#markers-must-be-labelled).
        title: "",
        // @option alt: String = 'Marker'
        // Text for the `alt` attribute of the icon image.
        // [Useful for accessibility](https://leafletjs.com/examples/accessibility/#markers-must-be-labelled).
        alt: "Marker",
        // @option zIndexOffset: Number = 0
        // By default, marker images zIndex is set automatically based on its latitude. Use this option if you want to put the marker on top of all others (or below), specifying a high value like `1000` (or high negative value, respectively).
        zIndexOffset: 0,
        // @option opacity: Number = 1.0
        // The opacity of the marker.
        opacity: 1,
        // @option riseOnHover: Boolean = false
        // If `true`, the marker will get on top of others when you hover the mouse over it.
        riseOnHover: !1,
        // @option riseOffset: Number = 250
        // The z-index offset used for the `riseOnHover` feature.
        riseOffset: 250,
        // @option pane: String = 'markerPane'
        // `Map pane` where the markers icon will be added.
        pane: "markerPane",
        // @option shadowPane: String = 'shadowPane'
        // `Map pane` where the markers shadow will be added.
        shadowPane: "shadowPane",
        // @option bubblingMouseEvents: Boolean = false
        // When `true`, a mouse event on this marker will trigger the same event on the map
        // (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
        bubblingMouseEvents: !1,
        // @option autoPanOnFocus: Boolean = true
        // When `true`, the map will pan whenever the marker is focused (via
        // e.g. pressing `tab` on the keyboard) to ensure the marker is
        // visible within the map's bounds
        autoPanOnFocus: !0,
        // @section Draggable marker options
        // @option draggable: Boolean = false
        // Whether the marker is draggable with mouse/touch or not.
        draggable: !1,
        // @option autoPan: Boolean = false
        // Whether to pan the map when dragging this marker near its edge or not.
        autoPan: !1,
        // @option autoPanPadding: Point = Point(50, 50)
        // Distance (in pixels to the left/right and to the top/bottom) of the
        // map edge to start panning the map.
        autoPanPadding: [50, 50],
        // @option autoPanSpeed: Number = 10
        // Number of pixels the map should pan by.
        autoPanSpeed: 10
      },
      /* @section
       *
       * In addition to [shared layer methods](#Layer) like `addTo()` and `remove()` and [popup methods](#Popup) like bindPopup() you can also use the following methods:
       */
      initialize: function(i, s) {
        O(this, s), this._latlng = Ne(i);
      },
      onAdd: function(i) {
        this._zoomAnimated = this._zoomAnimated && i.options.markerZoomAnimation, this._zoomAnimated && i.on("zoomanim", this._animateZoom, this), this._initIcon(), this.update();
      },
      onRemove: function(i) {
        this.dragging && this.dragging.enabled() && (this.options.draggable = !0, this.dragging.removeHooks()), delete this.dragging, this._zoomAnimated && i.off("zoomanim", this._animateZoom, this), this._removeIcon(), this._removeShadow();
      },
      getEvents: function() {
        return {
          zoom: this.update,
          viewreset: this.update
        };
      },
      // @method getLatLng: LatLng
      // Returns the current geographical position of the marker.
      getLatLng: function() {
        return this._latlng;
      },
      // @method setLatLng(latlng: LatLng): this
      // Changes the marker position to the given point.
      setLatLng: function(i) {
        var s = this._latlng;
        return this._latlng = Ne(i), this.update(), this.fire("move", { oldLatLng: s, latlng: this._latlng });
      },
      // @method setZIndexOffset(offset: Number): this
      // Changes the [zIndex offset](#marker-zindexoffset) of the marker.
      setZIndexOffset: function(i) {
        return this.options.zIndexOffset = i, this.update();
      },
      // @method getIcon: Icon
      // Returns the current icon used by the marker
      getIcon: function() {
        return this.options.icon;
      },
      // @method setIcon(icon: Icon): this
      // Changes the marker icon.
      setIcon: function(i) {
        return this.options.icon = i, this._map && (this._initIcon(), this.update()), this._popup && this.bindPopup(this._popup, this._popup.options), this;
      },
      getElement: function() {
        return this._icon;
      },
      update: function() {
        if (this._icon && this._map) {
          var i = this._map.latLngToLayerPoint(this._latlng).round();
          this._setPos(i);
        }
        return this;
      },
      _initIcon: function() {
        var i = this.options, s = "leaflet-zoom-" + (this._zoomAnimated ? "animated" : "hide"), d = i.icon.createIcon(this._icon), g = !1;
        d !== this._icon && (this._icon && this._removeIcon(), g = !0, i.title && (d.title = i.title), d.tagName === "IMG" && (d.alt = i.alt || "")), it(d, s), i.keyboard && (d.tabIndex = "0", d.setAttribute("role", "button")), this._icon = d, i.riseOnHover && this.on({
          mouseover: this._bringToFront,
          mouseout: this._resetZIndex
        }), this.options.autoPanOnFocus && w(d, "focus", this._panOnFocus, this);
        var b = i.icon.createShadow(this._shadow), I = !1;
        b !== this._shadow && (this._removeShadow(), I = !0), b && (it(b, s), b.alt = ""), this._shadow = b, i.opacity < 1 && this._updateOpacity(), g && this.getPane().appendChild(this._icon), this._initInteraction(), b && I && this.getPane(i.shadowPane).appendChild(this._shadow);
      },
      _removeIcon: function() {
        this.options.riseOnHover && this.off({
          mouseover: this._bringToFront,
          mouseout: this._resetZIndex
        }), this.options.autoPanOnFocus && F(this._icon, "focus", this._panOnFocus, this), jt(this._icon), this.removeInteractiveTarget(this._icon), this._icon = null;
      },
      _removeShadow: function() {
        this._shadow && jt(this._shadow), this._shadow = null;
      },
      _setPos: function(i) {
        this._icon && Vt(this._icon, i), this._shadow && Vt(this._shadow, i), this._zIndex = i.y + this.options.zIndexOffset, this._resetZIndex();
      },
      _updateZIndex: function(i) {
        this._icon && (this._icon.style.zIndex = this._zIndex + i);
      },
      _animateZoom: function(i) {
        var s = this._map._latLngToNewLayerPoint(this._latlng, i.zoom, i.center).round();
        this._setPos(s);
      },
      _initInteraction: function() {
        if (this.options.interactive && (it(this._icon, "leaflet-interactive"), this.addInteractiveTarget(this._icon), kc)) {
          var i = this.options.draggable;
          this.dragging && (i = this.dragging.enabled(), this.dragging.disable()), this.dragging = new kc(this), i && this.dragging.enable();
        }
      },
      // @method setOpacity(opacity: Number): this
      // Changes the opacity of the marker.
      setOpacity: function(i) {
        return this.options.opacity = i, this._map && this._updateOpacity(), this;
      },
      _updateOpacity: function() {
        var i = this.options.opacity;
        this._icon && dn(this._icon, i), this._shadow && dn(this._shadow, i);
      },
      _bringToFront: function() {
        this._updateZIndex(this.options.riseOffset);
      },
      _resetZIndex: function() {
        this._updateZIndex(0);
      },
      _panOnFocus: function() {
        var i = this._map;
        if (i) {
          var s = this.options.icon.options, d = s.iconSize ? ue(s.iconSize) : ue(0, 0), g = s.iconAnchor ? ue(s.iconAnchor) : ue(0, 0);
          i.panInside(this._latlng, {
            paddingTopLeft: g,
            paddingBottomRight: d.subtract(g)
          });
        }
      },
      _getPopupAnchor: function() {
        return this.options.icon.options.popupAnchor;
      },
      _getTooltipAnchor: function() {
        return this.options.icon.options.tooltipAnchor;
      }
    });
    function ov(i, s) {
      return new $o(i, s);
    }
    var qi = Gn.extend({
      // @section
      // @aka Path options
      options: {
        // @option stroke: Boolean = true
        // Whether to draw stroke along the path. Set it to `false` to disable borders on polygons or circles.
        stroke: !0,
        // @option color: String = '#3388ff'
        // Stroke color
        color: "#3388ff",
        // @option weight: Number = 3
        // Stroke width in pixels
        weight: 3,
        // @option opacity: Number = 1.0
        // Stroke opacity
        opacity: 1,
        // @option lineCap: String= 'round'
        // A string that defines [shape to be used at the end](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linecap) of the stroke.
        lineCap: "round",
        // @option lineJoin: String = 'round'
        // A string that defines [shape to be used at the corners](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linejoin) of the stroke.
        lineJoin: "round",
        // @option dashArray: String = null
        // A string that defines the stroke [dash pattern](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dasharray). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
        dashArray: null,
        // @option dashOffset: String = null
        // A string that defines the [distance into the dash pattern to start the dash](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dashoffset). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
        dashOffset: null,
        // @option fill: Boolean = depends
        // Whether to fill the path with color. Set it to `false` to disable filling on polygons or circles.
        fill: !1,
        // @option fillColor: String = *
        // Fill color. Defaults to the value of the [`color`](#path-color) option
        fillColor: null,
        // @option fillOpacity: Number = 0.2
        // Fill opacity.
        fillOpacity: 0.2,
        // @option fillRule: String = 'evenodd'
        // A string that defines [how the inside of a shape](https://developer.mozilla.org/docs/Web/SVG/Attribute/fill-rule) is determined.
        fillRule: "evenodd",
        // className: '',
        // Option inherited from "Interactive layer" abstract class
        interactive: !0,
        // @option bubblingMouseEvents: Boolean = true
        // When `true`, a mouse event on this path will trigger the same event on the map
        // (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
        bubblingMouseEvents: !0
      },
      beforeAdd: function(i) {
        this._renderer = i.getRenderer(this);
      },
      onAdd: function() {
        this._renderer._initPath(this), this._reset(), this._renderer._addPath(this);
      },
      onRemove: function() {
        this._renderer._removePath(this);
      },
      // @method redraw(): this
      // Redraws the layer. Sometimes useful after you changed the coordinates that the path uses.
      redraw: function() {
        return this._map && this._renderer._updatePath(this), this;
      },
      // @method setStyle(style: Path options): this
      // Changes the appearance of a Path based on the options in the `Path options` object.
      setStyle: function(i) {
        return O(this, i), this._renderer && (this._renderer._updateStyle(this), this.options.stroke && i && Object.prototype.hasOwnProperty.call(i, "weight") && this._updateBounds()), this;
      },
      // @method bringToFront(): this
      // Brings the layer to the top of all path layers.
      bringToFront: function() {
        return this._renderer && this._renderer._bringToFront(this), this;
      },
      // @method bringToBack(): this
      // Brings the layer to the bottom of all path layers.
      bringToBack: function() {
        return this._renderer && this._renderer._bringToBack(this), this;
      },
      getElement: function() {
        return this._path;
      },
      _reset: function() {
        this._project(), this._update();
      },
      _clickTolerance: function() {
        return (this.options.stroke ? this.options.weight / 2 : 0) + (this._renderer.options.tolerance || 0);
      }
    }), No = qi.extend({
      // @section
      // @aka CircleMarker options
      options: {
        fill: !0,
        // @option radius: Number = 10
        // Radius of the circle marker, in pixels
        radius: 10
      },
      initialize: function(i, s) {
        O(this, s), this._latlng = Ne(i), this._radius = this.options.radius;
      },
      // @method setLatLng(latLng: LatLng): this
      // Sets the position of a circle marker to a new location.
      setLatLng: function(i) {
        var s = this._latlng;
        return this._latlng = Ne(i), this.redraw(), this.fire("move", { oldLatLng: s, latlng: this._latlng });
      },
      // @method getLatLng(): LatLng
      // Returns the current geographical position of the circle marker
      getLatLng: function() {
        return this._latlng;
      },
      // @method setRadius(radius: Number): this
      // Sets the radius of a circle marker. Units are in pixels.
      setRadius: function(i) {
        return this.options.radius = this._radius = i, this.redraw();
      },
      // @method getRadius(): Number
      // Returns the current radius of the circle
      getRadius: function() {
        return this._radius;
      },
      setStyle: function(i) {
        var s = i && i.radius || this._radius;
        return qi.prototype.setStyle.call(this, i), this.setRadius(s), this;
      },
      _project: function() {
        this._point = this._map.latLngToLayerPoint(this._latlng), this._updateBounds();
      },
      _updateBounds: function() {
        var i = this._radius, s = this._radiusY || i, d = this._clickTolerance(), g = [i + d, s + d];
        this._pxBounds = new Fe(this._point.subtract(g), this._point.add(g));
      },
      _update: function() {
        this._map && this._updatePath();
      },
      _updatePath: function() {
        this._renderer._updateCircle(this);
      },
      _empty: function() {
        return this._radius && !this._renderer._bounds.intersects(this._pxBounds);
      },
      // Needed by the `Canvas` renderer for interactivity
      _containsPoint: function(i) {
        return i.distanceTo(this._point) <= this._radius + this._clickTolerance();
      }
    });
    function sv(i, s) {
      return new No(i, s);
    }
    var bl = No.extend({
      initialize: function(i, s, d) {
        if (typeof s == "number" && (s = a({}, d, { radius: s })), O(this, s), this._latlng = Ne(i), isNaN(this.options.radius))
          throw new Error("Circle radius cannot be NaN");
        this._mRadius = this.options.radius;
      },
      // @method setRadius(radius: Number): this
      // Sets the radius of a circle. Units are in meters.
      setRadius: function(i) {
        return this._mRadius = i, this.redraw();
      },
      // @method getRadius(): Number
      // Returns the current radius of a circle. Units are in meters.
      getRadius: function() {
        return this._mRadius;
      },
      // @method getBounds(): LatLngBounds
      // Returns the `LatLngBounds` of the path.
      getBounds: function() {
        var i = [this._radius, this._radiusY || this._radius];
        return new nt(
          this._map.layerPointToLatLng(this._point.subtract(i)),
          this._map.layerPointToLatLng(this._point.add(i))
        );
      },
      setStyle: qi.prototype.setStyle,
      _project: function() {
        var i = this._latlng.lng, s = this._latlng.lat, d = this._map, g = d.options.crs;
        if (g.distance === pt.distance) {
          var b = Math.PI / 180, I = this._mRadius / pt.R / b, W = d.project([s + I, i]), le = d.project([s - I, i]), de = W.add(le).divideBy(2), Le = d.unproject(de).lat, ze = Math.acos((Math.cos(I * b) - Math.sin(s * b) * Math.sin(Le * b)) / (Math.cos(s * b) * Math.cos(Le * b))) / b;
          (isNaN(ze) || ze === 0) && (ze = I / Math.cos(Math.PI / 180 * s)), this._point = de.subtract(d.getPixelOrigin()), this._radius = isNaN(ze) ? 0 : de.x - d.project([Le, i - ze]).x, this._radiusY = de.y - W.y;
        } else {
          var Ke = g.unproject(g.project(this._latlng).subtract([this._mRadius, 0]));
          this._point = d.latLngToLayerPoint(this._latlng), this._radius = this._point.x - d.latLngToLayerPoint(Ke).x;
        }
        this._updateBounds();
      }
    });
    function lv(i, s, d) {
      return new bl(i, s, d);
    }
    var ki = qi.extend({
      // @section
      // @aka Polyline options
      options: {
        // @option smoothFactor: Number = 1.0
        // How much to simplify the polyline on each zoom level. More means
        // better performance and smoother look, and less means more accurate representation.
        smoothFactor: 1,
        // @option noClip: Boolean = false
        // Disable polyline clipping.
        noClip: !1
      },
      initialize: function(i, s) {
        O(this, s), this._setLatLngs(i);
      },
      // @method getLatLngs(): LatLng[]
      // Returns an array of the points in the path, or nested arrays of points in case of multi-polyline.
      getLatLngs: function() {
        return this._latlngs;
      },
      // @method setLatLngs(latlngs: LatLng[]): this
      // Replaces all the points in the polyline with the given array of geographical points.
      setLatLngs: function(i) {
        return this._setLatLngs(i), this.redraw();
      },
      // @method isEmpty(): Boolean
      // Returns `true` if the Polyline has no LatLngs.
      isEmpty: function() {
        return !this._latlngs.length;
      },
      // @method closestLayerPoint(p: Point): Point
      // Returns the point closest to `p` on the Polyline.
      closestLayerPoint: function(i) {
        for (var s = 1 / 0, d = null, g = Fa, b, I, W = 0, le = this._parts.length; W < le; W++)
          for (var de = this._parts[W], Le = 1, ze = de.length; Le < ze; Le++) {
            b = de[Le - 1], I = de[Le];
            var Ke = g(i, b, I, !0);
            Ke < s && (s = Ke, d = g(i, b, I));
          }
        return d && (d.distance = Math.sqrt(s)), d;
      },
      // @method getCenter(): LatLng
      // Returns the center ([centroid](https://en.wikipedia.org/wiki/Centroid)) of the polyline.
      getCenter: function() {
        if (!this._map)
          throw new Error("Must add layer to map before using getCenter()");
        return bc(this._defaultShape(), this._map.options.crs);
      },
      // @method getBounds(): LatLngBounds
      // Returns the `LatLngBounds` of the path.
      getBounds: function() {
        return this._bounds;
      },
      // @method addLatLng(latlng: LatLng, latlngs?: LatLng[]): this
      // Adds a given point to the polyline. By default, adds to the first ring of
      // the polyline in case of a multi-polyline, but can be overridden by passing
      // a specific ring as a LatLng array (that you can earlier access with [`getLatLngs`](#polyline-getlatlngs)).
      addLatLng: function(i, s) {
        return s = s || this._defaultShape(), i = Ne(i), s.push(i), this._bounds.extend(i), this.redraw();
      },
      _setLatLngs: function(i) {
        this._bounds = new nt(), this._latlngs = this._convertLatLngs(i);
      },
      _defaultShape: function() {
        return An(this._latlngs) ? this._latlngs : this._latlngs[0];
      },
      // recursively convert latlngs input into actual LatLng instances; calculate bounds along the way
      _convertLatLngs: function(i) {
        for (var s = [], d = An(i), g = 0, b = i.length; g < b; g++)
          d ? (s[g] = Ne(i[g]), this._bounds.extend(s[g])) : s[g] = this._convertLatLngs(i[g]);
        return s;
      },
      _project: function() {
        var i = new Fe();
        this._rings = [], this._projectLatlngs(this._latlngs, this._rings, i), this._bounds.isValid() && i.isValid() && (this._rawPxBounds = i, this._updateBounds());
      },
      _updateBounds: function() {
        var i = this._clickTolerance(), s = new pe(i, i);
        this._rawPxBounds && (this._pxBounds = new Fe([
          this._rawPxBounds.min.subtract(s),
          this._rawPxBounds.max.add(s)
        ]));
      },
      // recursively turns latlngs into a set of rings with projected coordinates
      _projectLatlngs: function(i, s, d) {
        var g = i[0] instanceof Ze, b = i.length, I, W;
        if (g) {
          for (W = [], I = 0; I < b; I++)
            W[I] = this._map.latLngToLayerPoint(i[I]), d.extend(W[I]);
          s.push(W);
        } else
          for (I = 0; I < b; I++)
            this._projectLatlngs(i[I], s, d);
      },
      // clip polyline by renderer bounds so that we have less to render for performance
      _clipPoints: function() {
        var i = this._renderer._bounds;
        if (this._parts = [], !(!this._pxBounds || !this._pxBounds.intersects(i))) {
          if (this.options.noClip) {
            this._parts = this._rings;
            return;
          }
          var s = this._parts, d, g, b, I, W, le, de;
          for (d = 0, b = 0, I = this._rings.length; d < I; d++)
            for (de = this._rings[d], g = 0, W = de.length; g < W - 1; g++)
              le = _c(de[g], de[g + 1], i, g, !0), le && (s[b] = s[b] || [], s[b].push(le[0]), (le[1] !== de[g + 1] || g === W - 2) && (s[b].push(le[1]), b++));
        }
      },
      // simplify each clipped part of the polyline for performance
      _simplifyPoints: function() {
        for (var i = this._parts, s = this.options.smoothFactor, d = 0, g = i.length; d < g; d++)
          i[d] = mc(i[d], s);
      },
      _update: function() {
        this._map && (this._clipPoints(), this._simplifyPoints(), this._updatePath());
      },
      _updatePath: function() {
        this._renderer._updatePoly(this);
      },
      // Needed by the `Canvas` renderer for interactivity
      _containsPoint: function(i, s) {
        var d, g, b, I, W, le, de = this._clickTolerance();
        if (!this._pxBounds || !this._pxBounds.contains(i))
          return !1;
        for (d = 0, I = this._parts.length; d < I; d++)
          for (le = this._parts[d], g = 0, W = le.length, b = W - 1; g < W; b = g++)
            if (!(!s && g === 0) && gc(i, le[b], le[g]) <= de)
              return !0;
        return !1;
      }
    });
    function uv(i, s) {
      return new ki(i, s);
    }
    ki._flat = yc;
    var Kr = ki.extend({
      options: {
        fill: !0
      },
      isEmpty: function() {
        return !this._latlngs.length || !this._latlngs[0].length;
      },
      // @method getCenter(): LatLng
      // Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the Polygon.
      getCenter: function() {
        if (!this._map)
          throw new Error("Must add layer to map before using getCenter()");
        return pc(this._defaultShape(), this._map.options.crs);
      },
      _convertLatLngs: function(i) {
        var s = ki.prototype._convertLatLngs.call(this, i), d = s.length;
        return d >= 2 && s[0] instanceof Ze && s[0].equals(s[d - 1]) && s.pop(), s;
      },
      _setLatLngs: function(i) {
        ki.prototype._setLatLngs.call(this, i), An(this._latlngs) && (this._latlngs = [this._latlngs]);
      },
      _defaultShape: function() {
        return An(this._latlngs[0]) ? this._latlngs[0] : this._latlngs[0][0];
      },
      _clipPoints: function() {
        var i = this._renderer._bounds, s = this.options.weight, d = new pe(s, s);
        if (i = new Fe(i.min.subtract(d), i.max.add(d)), this._parts = [], !(!this._pxBounds || !this._pxBounds.intersects(i))) {
          if (this.options.noClip) {
            this._parts = this._rings;
            return;
          }
          for (var g = 0, b = this._rings.length, I; g < b; g++)
            I = fc(this._rings[g], i, !0), I.length && this._parts.push(I);
        }
      },
      _updatePath: function() {
        this._renderer._updatePoly(this, !0);
      },
      // Needed by the `Canvas` renderer for interactivity
      _containsPoint: function(i) {
        var s = !1, d, g, b, I, W, le, de, Le;
        if (!this._pxBounds || !this._pxBounds.contains(i))
          return !1;
        for (I = 0, de = this._parts.length; I < de; I++)
          for (d = this._parts[I], W = 0, Le = d.length, le = Le - 1; W < Le; le = W++)
            g = d[W], b = d[le], g.y > i.y != b.y > i.y && i.x < (b.x - g.x) * (i.y - g.y) / (b.y - g.y) + g.x && (s = !s);
        return s || ki.prototype._containsPoint.call(this, i, !0);
      }
    });
    function cv(i, s) {
      return new Kr(i, s);
    }
    var xi = wi.extend({
      /* @section
       * @aka GeoJSON options
       *
       * @option pointToLayer: Function = *
       * A `Function` defining how GeoJSON points spawn Leaflet layers. It is internally
       * called when data is added, passing the GeoJSON point feature and its `LatLng`.
       * The default is to spawn a default `Marker`:
       * ```js
       * function(geoJsonPoint, latlng) {
       * 	return L.marker(latlng);
       * }
       * ```
       *
       * @option style: Function = *
       * A `Function` defining the `Path options` for styling GeoJSON lines and polygons,
       * called internally when data is added.
       * The default value is to not override any defaults:
       * ```js
       * function (geoJsonFeature) {
       * 	return {}
       * }
       * ```
       *
       * @option onEachFeature: Function = *
       * A `Function` that will be called once for each created `Feature`, after it has
       * been created and styled. Useful for attaching events and popups to features.
       * The default is to do nothing with the newly created layers:
       * ```js
       * function (feature, layer) {}
       * ```
       *
       * @option filter: Function = *
       * A `Function` that will be used to decide whether to include a feature or not.
       * The default is to include all features:
       * ```js
       * function (geoJsonFeature) {
       * 	return true;
       * }
       * ```
       * Note: dynamically changing the `filter` option will have effect only on newly
       * added data. It will _not_ re-evaluate already included features.
       *
       * @option coordsToLatLng: Function = *
       * A `Function` that will be used for converting GeoJSON coordinates to `LatLng`s.
       * The default is the `coordsToLatLng` static method.
       *
       * @option markersInheritOptions: Boolean = false
       * Whether default Markers for "Point" type Features inherit from group options.
       */
      initialize: function(i, s) {
        O(this, s), this._layers = {}, i && this.addData(i);
      },
      // @method addData( <GeoJSON> data ): this
      // Adds a GeoJSON object to the layer.
      addData: function(i) {
        var s = A(i) ? i : i.features, d, g, b;
        if (s) {
          for (d = 0, g = s.length; d < g; d++)
            b = s[d], (b.geometries || b.geometry || b.features || b.coordinates) && this.addData(b);
          return this;
        }
        var I = this.options;
        if (I.filter && !I.filter(i))
          return this;
        var W = zo(i, I);
        return W ? (W.feature = Vo(i), W.defaultOptions = W.options, this.resetStyle(W), I.onEachFeature && I.onEachFeature(i, W), this.addLayer(W)) : this;
      },
      // @method resetStyle( <Path> layer? ): this
      // Resets the given vector layer's style to the original GeoJSON style, useful for resetting style after hover events.
      // If `layer` is omitted, the style of all features in the current layer is reset.
      resetStyle: function(i) {
        return i === void 0 ? this.eachLayer(this.resetStyle, this) : (i.options = a({}, i.defaultOptions), this._setLayerStyle(i, this.options.style), this);
      },
      // @method setStyle( <Function> style ): this
      // Changes styles of GeoJSON vector layers with the given style function.
      setStyle: function(i) {
        return this.eachLayer(function(s) {
          this._setLayerStyle(s, i);
        }, this);
      },
      _setLayerStyle: function(i, s) {
        i.setStyle && (typeof s == "function" && (s = s(i.feature)), i.setStyle(s));
      }
    });
    function zo(i, s) {
      var d = i.type === "Feature" ? i.geometry : i, g = d ? d.coordinates : null, b = [], I = s && s.pointToLayer, W = s && s.coordsToLatLng || wl, le, de, Le, ze;
      if (!g && !d)
        return null;
      switch (d.type) {
        case "Point":
          return le = W(g), xc(I, i, le, s);
        case "MultiPoint":
          for (Le = 0, ze = g.length; Le < ze; Le++)
            le = W(g[Le]), b.push(xc(I, i, le, s));
          return new wi(b);
        case "LineString":
        case "MultiLineString":
          return de = Fo(g, d.type === "LineString" ? 0 : 1, W), new ki(de, s);
        case "Polygon":
        case "MultiPolygon":
          return de = Fo(g, d.type === "Polygon" ? 1 : 2, W), new Kr(de, s);
        case "GeometryCollection":
          for (Le = 0, ze = d.geometries.length; Le < ze; Le++) {
            var Ke = zo({
              geometry: d.geometries[Le],
              type: "Feature",
              properties: i.properties
            }, s);
            Ke && b.push(Ke);
          }
          return new wi(b);
        case "FeatureCollection":
          for (Le = 0, ze = d.features.length; Le < ze; Le++) {
            var dt = zo(d.features[Le], s);
            dt && b.push(dt);
          }
          return new wi(b);
        default:
          throw new Error("Invalid GeoJSON object.");
      }
    }
    function xc(i, s, d, g) {
      return i ? i(s, d) : new $o(d, g && g.markersInheritOptions && g);
    }
    function wl(i) {
      return new Ze(i[1], i[0], i[2]);
    }
    function Fo(i, s, d) {
      for (var g = [], b = 0, I = i.length, W; b < I; b++)
        W = s ? Fo(i[b], s - 1, d) : (d || wl)(i[b]), g.push(W);
      return g;
    }
    function kl(i, s) {
      return i = Ne(i), i.alt !== void 0 ? [k(i.lng, s), k(i.lat, s), k(i.alt, s)] : [k(i.lng, s), k(i.lat, s)];
    }
    function jo(i, s, d, g) {
      for (var b = [], I = 0, W = i.length; I < W; I++)
        b.push(s ? jo(i[I], An(i[I]) ? 0 : s - 1, d, g) : kl(i[I], g));
      return !s && d && b.length > 0 && b.push(b[0].slice()), b;
    }
    function Jr(i, s) {
      return i.feature ? a({}, i.feature, { geometry: s }) : Vo(s);
    }
    function Vo(i) {
      return i.type === "Feature" || i.type === "FeatureCollection" ? i : {
        type: "Feature",
        properties: {},
        geometry: i
      };
    }
    var xl = {
      toGeoJSON: function(i) {
        return Jr(this, {
          type: "Point",
          coordinates: kl(this.getLatLng(), i)
        });
      }
    };
    $o.include(xl), bl.include(xl), No.include(xl), ki.include({
      toGeoJSON: function(i) {
        var s = !An(this._latlngs), d = jo(this._latlngs, s ? 1 : 0, !1, i);
        return Jr(this, {
          type: (s ? "Multi" : "") + "LineString",
          coordinates: d
        });
      }
    }), Kr.include({
      toGeoJSON: function(i) {
        var s = !An(this._latlngs), d = s && !An(this._latlngs[0]), g = jo(this._latlngs, d ? 2 : s ? 1 : 0, !0, i);
        return s || (g = [g]), Jr(this, {
          type: (d ? "Multi" : "") + "Polygon",
          coordinates: g
        });
      }
    }), Gr.include({
      toMultiPoint: function(i) {
        var s = [];
        return this.eachLayer(function(d) {
          s.push(d.toGeoJSON(i).geometry.coordinates);
        }), Jr(this, {
          type: "MultiPoint",
          coordinates: s
        });
      },
      // @method toGeoJSON(precision?: Number|false): Object
      // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
      // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the layer group (as a GeoJSON `FeatureCollection`, `GeometryCollection`, or `MultiPoint`).
      toGeoJSON: function(i) {
        var s = this.feature && this.feature.geometry && this.feature.geometry.type;
        if (s === "MultiPoint")
          return this.toMultiPoint(i);
        var d = s === "GeometryCollection", g = [];
        return this.eachLayer(function(b) {
          if (b.toGeoJSON) {
            var I = b.toGeoJSON(i);
            if (d)
              g.push(I.geometry);
            else {
              var W = Vo(I);
              W.type === "FeatureCollection" ? g.push.apply(g, W.features) : g.push(W);
            }
          }
        }), d ? Jr(this, {
          geometries: g,
          type: "GeometryCollection"
        }) : {
          type: "FeatureCollection",
          features: g
        };
      }
    });
    function Lc(i, s) {
      return new xi(i, s);
    }
    var hv = Lc, Yo = Gn.extend({
      // @section
      // @aka ImageOverlay options
      options: {
        // @option opacity: Number = 1.0
        // The opacity of the image overlay.
        opacity: 1,
        // @option alt: String = ''
        // Text for the `alt` attribute of the image (useful for accessibility).
        alt: "",
        // @option interactive: Boolean = false
        // If `true`, the image overlay will emit [mouse events](#interactive-layer) when clicked or hovered.
        interactive: !1,
        // @option crossOrigin: Boolean|String = false
        // Whether the crossOrigin attribute will be added to the image.
        // If a String is provided, the image will have its crossOrigin attribute set to the String provided. This is needed if you want to access image pixel data.
        // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
        crossOrigin: !1,
        // @option errorOverlayUrl: String = ''
        // URL to the overlay image to show in place of the overlay that failed to load.
        errorOverlayUrl: "",
        // @option zIndex: Number = 1
        // The explicit [zIndex](https://developer.mozilla.org/docs/Web/CSS/CSS_Positioning/Understanding_z_index) of the overlay layer.
        zIndex: 1,
        // @option className: String = ''
        // A custom class name to assign to the image. Empty by default.
        className: ""
      },
      initialize: function(i, s, d) {
        this._url = i, this._bounds = Ve(s), O(this, d);
      },
      onAdd: function() {
        this._image || (this._initImage(), this.options.opacity < 1 && this._updateOpacity()), this.options.interactive && (it(this._image, "leaflet-interactive"), this.addInteractiveTarget(this._image)), this.getPane().appendChild(this._image), this._reset();
      },
      onRemove: function() {
        jt(this._image), this.options.interactive && this.removeInteractiveTarget(this._image);
      },
      // @method setOpacity(opacity: Number): this
      // Sets the opacity of the overlay.
      setOpacity: function(i) {
        return this.options.opacity = i, this._image && this._updateOpacity(), this;
      },
      setStyle: function(i) {
        return i.opacity && this.setOpacity(i.opacity), this;
      },
      // @method bringToFront(): this
      // Brings the layer to the top of all overlays.
      bringToFront: function() {
        return this._map && Wi(this._image), this;
      },
      // @method bringToBack(): this
      // Brings the layer to the bottom of all overlays.
      bringToBack: function() {
        return this._map && bi(this._image), this;
      },
      // @method setUrl(url: String): this
      // Changes the URL of the image.
      setUrl: function(i) {
        return this._url = i, this._image && (this._image.src = i), this;
      },
      // @method setBounds(bounds: LatLngBounds): this
      // Update the bounds that this ImageOverlay covers
      setBounds: function(i) {
        return this._bounds = Ve(i), this._map && this._reset(), this;
      },
      getEvents: function() {
        var i = {
          zoom: this._reset,
          viewreset: this._reset
        };
        return this._zoomAnimated && (i.zoomanim = this._animateZoom), i;
      },
      // @method setZIndex(value: Number): this
      // Changes the [zIndex](#imageoverlay-zindex) of the image overlay.
      setZIndex: function(i) {
        return this.options.zIndex = i, this._updateZIndex(), this;
      },
      // @method getBounds(): LatLngBounds
      // Get the bounds that this ImageOverlay covers
      getBounds: function() {
        return this._bounds;
      },
      // @method getElement(): HTMLElement
      // Returns the instance of [`HTMLImageElement`](https://developer.mozilla.org/docs/Web/API/HTMLImageElement)
      // used by this overlay.
      getElement: function() {
        return this._image;
      },
      _initImage: function() {
        var i = this._url.tagName === "IMG", s = this._image = i ? this._url : yt("img");
        if (it(s, "leaflet-image-layer"), this._zoomAnimated && it(s, "leaflet-zoom-animated"), this.options.className && it(s, this.options.className), s.onselectstart = y, s.onmousemove = y, s.onload = u(this.fire, this, "load"), s.onerror = u(this._overlayOnError, this, "error"), (this.options.crossOrigin || this.options.crossOrigin === "") && (s.crossOrigin = this.options.crossOrigin === !0 ? "" : this.options.crossOrigin), this.options.zIndex && this._updateZIndex(), i) {
          this._url = s.src;
          return;
        }
        s.src = this._url, s.alt = this.options.alt;
      },
      _animateZoom: function(i) {
        var s = this._map.getZoomScale(i.zoom), d = this._map._latLngBoundsToNewLayerBounds(this._bounds, i.zoom, i.center).min;
        Ft(this._image, d, s);
      },
      _reset: function() {
        var i = this._image, s = new Fe(
          this._map.latLngToLayerPoint(this._bounds.getNorthWest()),
          this._map.latLngToLayerPoint(this._bounds.getSouthEast())
        ), d = s.getSize();
        Vt(i, s.min), i.style.width = d.x + "px", i.style.height = d.y + "px";
      },
      _updateOpacity: function() {
        dn(this._image, this.options.opacity);
      },
      _updateZIndex: function() {
        this._image && this.options.zIndex !== void 0 && this.options.zIndex !== null && (this._image.style.zIndex = this.options.zIndex);
      },
      _overlayOnError: function() {
        this.fire("error");
        var i = this.options.errorOverlayUrl;
        i && this._url !== i && (this._url = i, this._image.src = i);
      },
      // @method getCenter(): LatLng
      // Returns the center of the ImageOverlay.
      getCenter: function() {
        return this._bounds.getCenter();
      }
    }), dv = function(i, s, d) {
      return new Yo(i, s, d);
    }, Mc = Yo.extend({
      // @section
      // @aka VideoOverlay options
      options: {
        // @option autoplay: Boolean = true
        // Whether the video starts playing automatically when loaded.
        // On some browsers autoplay will only work with `muted: true`
        autoplay: !0,
        // @option loop: Boolean = true
        // Whether the video will loop back to the beginning when played.
        loop: !0,
        // @option keepAspectRatio: Boolean = true
        // Whether the video will save aspect ratio after the projection.
        // Relevant for supported browsers. See [browser compatibility](https://developer.mozilla.org/en-US/docs/Web/CSS/object-fit)
        keepAspectRatio: !0,
        // @option muted: Boolean = false
        // Whether the video starts on mute when loaded.
        muted: !1,
        // @option playsInline: Boolean = true
        // Mobile browsers will play the video right where it is instead of open it up in fullscreen mode.
        playsInline: !0
      },
      _initImage: function() {
        var i = this._url.tagName === "VIDEO", s = this._image = i ? this._url : yt("video");
        if (it(s, "leaflet-image-layer"), this._zoomAnimated && it(s, "leaflet-zoom-animated"), this.options.className && it(s, this.options.className), s.onselectstart = y, s.onmousemove = y, s.onloadeddata = u(this.fire, this, "load"), i) {
          for (var d = s.getElementsByTagName("source"), g = [], b = 0; b < d.length; b++)
            g.push(d[b].src);
          this._url = d.length > 0 ? g : [s.src];
          return;
        }
        A(this._url) || (this._url = [this._url]), !this.options.keepAspectRatio && Object.prototype.hasOwnProperty.call(s.style, "objectFit") && (s.style.objectFit = "fill"), s.autoplay = !!this.options.autoplay, s.loop = !!this.options.loop, s.muted = !!this.options.muted, s.playsInline = !!this.options.playsInline;
        for (var I = 0; I < this._url.length; I++) {
          var W = yt("source");
          W.src = this._url[I], s.appendChild(W);
        }
      }
      // @method getElement(): HTMLVideoElement
      // Returns the instance of [`HTMLVideoElement`](https://developer.mozilla.org/docs/Web/API/HTMLVideoElement)
      // used by this overlay.
    });
    function fv(i, s, d) {
      return new Mc(i, s, d);
    }
    var Sc = Yo.extend({
      _initImage: function() {
        var i = this._image = this._url;
        it(i, "leaflet-image-layer"), this._zoomAnimated && it(i, "leaflet-zoom-animated"), this.options.className && it(i, this.options.className), i.onselectstart = y, i.onmousemove = y;
      }
      // @method getElement(): SVGElement
      // Returns the instance of [`SVGElement`](https://developer.mozilla.org/docs/Web/API/SVGElement)
      // used by this overlay.
    });
    function pv(i, s, d) {
      return new Sc(i, s, d);
    }
    var hi = Gn.extend({
      // @section
      // @aka DivOverlay options
      options: {
        // @option interactive: Boolean = false
        // If true, the popup/tooltip will listen to the mouse events.
        interactive: !1,
        // @option offset: Point = Point(0, 0)
        // The offset of the overlay position.
        offset: [0, 0],
        // @option className: String = ''
        // A custom CSS class name to assign to the overlay.
        className: "",
        // @option pane: String = undefined
        // `Map pane` where the overlay will be added.
        pane: void 0,
        // @option content: String|HTMLElement|Function = ''
        // Sets the HTML content of the overlay while initializing. If a function is passed the source layer will be
        // passed to the function. The function should return a `String` or `HTMLElement` to be used in the overlay.
        content: ""
      },
      initialize: function(i, s) {
        i && (i instanceof Ze || A(i)) ? (this._latlng = Ne(i), O(this, s)) : (O(this, i), this._source = s), this.options.content && (this._content = this.options.content);
      },
      // @method openOn(map: Map): this
      // Adds the overlay to the map.
      // Alternative to `map.openPopup(popup)`/`.openTooltip(tooltip)`.
      openOn: function(i) {
        return i = arguments.length ? i : this._source._map, i.hasLayer(this) || i.addLayer(this), this;
      },
      // @method close(): this
      // Closes the overlay.
      // Alternative to `map.closePopup(popup)`/`.closeTooltip(tooltip)`
      // and `layer.closePopup()`/`.closeTooltip()`.
      close: function() {
        return this._map && this._map.removeLayer(this), this;
      },
      // @method toggle(layer?: Layer): this
      // Opens or closes the overlay bound to layer depending on its current state.
      // Argument may be omitted only for overlay bound to layer.
      // Alternative to `layer.togglePopup()`/`.toggleTooltip()`.
      toggle: function(i) {
        return this._map ? this.close() : (arguments.length ? this._source = i : i = this._source, this._prepareOpen(), this.openOn(i._map)), this;
      },
      onAdd: function(i) {
        this._zoomAnimated = i._zoomAnimated, this._container || this._initLayout(), i._fadeAnimated && dn(this._container, 0), clearTimeout(this._removeTimeout), this.getPane().appendChild(this._container), this.update(), i._fadeAnimated && dn(this._container, 1), this.bringToFront(), this.options.interactive && (it(this._container, "leaflet-interactive"), this.addInteractiveTarget(this._container));
      },
      onRemove: function(i) {
        i._fadeAnimated ? (dn(this._container, 0), this._removeTimeout = setTimeout(u(jt, void 0, this._container), 200)) : jt(this._container), this.options.interactive && (Gt(this._container, "leaflet-interactive"), this.removeInteractiveTarget(this._container));
      },
      // @namespace DivOverlay
      // @method getLatLng: LatLng
      // Returns the geographical point of the overlay.
      getLatLng: function() {
        return this._latlng;
      },
      // @method setLatLng(latlng: LatLng): this
      // Sets the geographical point where the overlay will open.
      setLatLng: function(i) {
        return this._latlng = Ne(i), this._map && (this._updatePosition(), this._adjustPan()), this;
      },
      // @method getContent: String|HTMLElement
      // Returns the content of the overlay.
      getContent: function() {
        return this._content;
      },
      // @method setContent(htmlContent: String|HTMLElement|Function): this
      // Sets the HTML content of the overlay. If a function is passed the source layer will be passed to the function.
      // The function should return a `String` or `HTMLElement` to be used in the overlay.
      setContent: function(i) {
        return this._content = i, this.update(), this;
      },
      // @method getElement: String|HTMLElement
      // Returns the HTML container of the overlay.
      getElement: function() {
        return this._container;
      },
      // @method update: null
      // Updates the overlay content, layout and position. Useful for updating the overlay after something inside changed, e.g. image loaded.
      update: function() {
        this._map && (this._container.style.visibility = "hidden", this._updateContent(), this._updateLayout(), this._updatePosition(), this._container.style.visibility = "", this._adjustPan());
      },
      getEvents: function() {
        var i = {
          zoom: this._updatePosition,
          viewreset: this._updatePosition
        };
        return this._zoomAnimated && (i.zoomanim = this._animateZoom), i;
      },
      // @method isOpen: Boolean
      // Returns `true` when the overlay is visible on the map.
      isOpen: function() {
        return !!this._map && this._map.hasLayer(this);
      },
      // @method bringToFront: this
      // Brings this overlay in front of other overlays (in the same map pane).
      bringToFront: function() {
        return this._map && Wi(this._container), this;
      },
      // @method bringToBack: this
      // Brings this overlay to the back of other overlays (in the same map pane).
      bringToBack: function() {
        return this._map && bi(this._container), this;
      },
      // prepare bound overlay to open: update latlng pos / content source (for FeatureGroup)
      _prepareOpen: function(i) {
        var s = this._source;
        if (!s._map)
          return !1;
        if (s instanceof wi) {
          s = null;
          var d = this._source._layers;
          for (var g in d)
            if (d[g]._map) {
              s = d[g];
              break;
            }
          if (!s)
            return !1;
          this._source = s;
        }
        if (!i)
          if (s.getCenter)
            i = s.getCenter();
          else if (s.getLatLng)
            i = s.getLatLng();
          else if (s.getBounds)
            i = s.getBounds().getCenter();
          else
            throw new Error("Unable to get source layer LatLng.");
        return this.setLatLng(i), this._map && this.update(), !0;
      },
      _updateContent: function() {
        if (this._content) {
          var i = this._contentNode, s = typeof this._content == "function" ? this._content(this._source || this) : this._content;
          if (typeof s == "string")
            i.innerHTML = s;
          else {
            for (; i.hasChildNodes(); )
              i.removeChild(i.firstChild);
            i.appendChild(s);
          }
          this.fire("contentupdate");
        }
      },
      _updatePosition: function() {
        if (this._map) {
          var i = this._map.latLngToLayerPoint(this._latlng), s = ue(this.options.offset), d = this._getAnchor();
          this._zoomAnimated ? Vt(this._container, i.add(d)) : s = s.add(i).add(d);
          var g = this._containerBottom = -s.y, b = this._containerLeft = -Math.round(this._containerWidth / 2) + s.x;
          this._container.style.bottom = g + "px", this._container.style.left = b + "px";
        }
      },
      _getAnchor: function() {
        return [0, 0];
      }
    });
    st.include({
      _initOverlay: function(i, s, d, g) {
        var b = s;
        return b instanceof i || (b = new i(g).setContent(s)), d && b.setLatLng(d), b;
      }
    }), Gn.include({
      _initOverlay: function(i, s, d, g) {
        var b = d;
        return b instanceof i ? (O(b, g), b._source = this) : (b = s && !g ? s : new i(g, this), b.setContent(d)), b;
      }
    });
    var Ho = hi.extend({
      // @section
      // @aka Popup options
      options: {
        // @option pane: String = 'popupPane'
        // `Map pane` where the popup will be added.
        pane: "popupPane",
        // @option offset: Point = Point(0, 7)
        // The offset of the popup position.
        offset: [0, 7],
        // @option maxWidth: Number = 300
        // Max width of the popup, in pixels.
        maxWidth: 300,
        // @option minWidth: Number = 50
        // Min width of the popup, in pixels.
        minWidth: 50,
        // @option maxHeight: Number = null
        // If set, creates a scrollable container of the given height
        // inside a popup if its content exceeds it.
        // The scrollable container can be styled using the
        // `leaflet-popup-scrolled` CSS class selector.
        maxHeight: null,
        // @option autoPan: Boolean = true
        // Set it to `false` if you don't want the map to do panning animation
        // to fit the opened popup.
        autoPan: !0,
        // @option autoPanPaddingTopLeft: Point = null
        // The margin between the popup and the top left corner of the map
        // view after autopanning was performed.
        autoPanPaddingTopLeft: null,
        // @option autoPanPaddingBottomRight: Point = null
        // The margin between the popup and the bottom right corner of the map
        // view after autopanning was performed.
        autoPanPaddingBottomRight: null,
        // @option autoPanPadding: Point = Point(5, 5)
        // Equivalent of setting both top left and bottom right autopan padding to the same value.
        autoPanPadding: [5, 5],
        // @option keepInView: Boolean = false
        // Set it to `true` if you want to prevent users from panning the popup
        // off of the screen while it is open.
        keepInView: !1,
        // @option closeButton: Boolean = true
        // Controls the presence of a close button in the popup.
        closeButton: !0,
        // @option autoClose: Boolean = true
        // Set it to `false` if you want to override the default behavior of
        // the popup closing when another popup is opened.
        autoClose: !0,
        // @option closeOnEscapeKey: Boolean = true
        // Set it to `false` if you want to override the default behavior of
        // the ESC key for closing of the popup.
        closeOnEscapeKey: !0,
        // @option closeOnClick: Boolean = *
        // Set it if you want to override the default behavior of the popup closing when user clicks
        // on the map. Defaults to the map's [`closePopupOnClick`](#map-closepopuponclick) option.
        // @option className: String = ''
        // A custom CSS class name to assign to the popup.
        className: ""
      },
      // @namespace Popup
      // @method openOn(map: Map): this
      // Alternative to `map.openPopup(popup)`.
      // Adds the popup to the map and closes the previous one.
      openOn: function(i) {
        return i = arguments.length ? i : this._source._map, !i.hasLayer(this) && i._popup && i._popup.options.autoClose && i.removeLayer(i._popup), i._popup = this, hi.prototype.openOn.call(this, i);
      },
      onAdd: function(i) {
        hi.prototype.onAdd.call(this, i), i.fire("popupopen", { popup: this }), this._source && (this._source.fire("popupopen", { popup: this }, !0), this._source instanceof qi || this._source.on("preclick", _e));
      },
      onRemove: function(i) {
        hi.prototype.onRemove.call(this, i), i.fire("popupclose", { popup: this }), this._source && (this._source.fire("popupclose", { popup: this }, !0), this._source instanceof qi || this._source.off("preclick", _e));
      },
      getEvents: function() {
        var i = hi.prototype.getEvents.call(this);
        return (this.options.closeOnClick !== void 0 ? this.options.closeOnClick : this._map.options.closePopupOnClick) && (i.preclick = this.close), this.options.keepInView && (i.moveend = this._adjustPan), i;
      },
      _initLayout: function() {
        var i = "leaflet-popup", s = this._container = yt(
          "div",
          i + " " + (this.options.className || "") + " leaflet-zoom-animated"
        ), d = this._wrapper = yt("div", i + "-content-wrapper", s);
        if (this._contentNode = yt("div", i + "-content", d), Me(s), fe(this._contentNode), w(s, "contextmenu", _e), this._tipContainer = yt("div", i + "-tip-container", s), this._tip = yt("div", i + "-tip", this._tipContainer), this.options.closeButton) {
          var g = this._closeButton = yt("a", i + "-close-button", s);
          g.setAttribute("role", "button"), g.setAttribute("aria-label", "Close popup"), g.href = "#close", g.innerHTML = '<span aria-hidden="true">&#215;</span>', w(g, "click", function(b) {
            Ie(b), this.close();
          }, this);
        }
      },
      _updateLayout: function() {
        var i = this._contentNode, s = i.style;
        s.width = "", s.whiteSpace = "nowrap";
        var d = i.offsetWidth;
        d = Math.min(d, this.options.maxWidth), d = Math.max(d, this.options.minWidth), s.width = d + 1 + "px", s.whiteSpace = "", s.height = "";
        var g = i.offsetHeight, b = this.options.maxHeight, I = "leaflet-popup-scrolled";
        b && g > b ? (s.height = b + "px", it(i, I)) : Gt(i, I), this._containerWidth = this._container.offsetWidth;
      },
      _animateZoom: function(i) {
        var s = this._map._latLngToNewLayerPoint(this._latlng, i.zoom, i.center), d = this._getAnchor();
        Vt(this._container, s.add(d));
      },
      _adjustPan: function() {
        if (this.options.autoPan) {
          if (this._map._panAnim && this._map._panAnim.stop(), this._autopanning) {
            this._autopanning = !1;
            return;
          }
          var i = this._map, s = parseInt(Zi(this._container, "marginBottom"), 10) || 0, d = this._container.offsetHeight + s, g = this._containerWidth, b = new pe(this._containerLeft, -d - this._containerBottom);
          b._add(Wn(this._container));
          var I = i.layerPointToContainerPoint(b), W = ue(this.options.autoPanPadding), le = ue(this.options.autoPanPaddingTopLeft || W), de = ue(this.options.autoPanPaddingBottomRight || W), Le = i.getSize(), ze = 0, Ke = 0;
          I.x + g + de.x > Le.x && (ze = I.x + g - Le.x + de.x), I.x - ze - le.x < 0 && (ze = I.x - le.x), I.y + d + de.y > Le.y && (Ke = I.y + d - Le.y + de.y), I.y - Ke - le.y < 0 && (Ke = I.y - le.y), (ze || Ke) && (this.options.keepInView && (this._autopanning = !0), i.fire("autopanstart").panBy([ze, Ke]));
        }
      },
      _getAnchor: function() {
        return ue(this._source && this._source._getPopupAnchor ? this._source._getPopupAnchor() : [0, 0]);
      }
    }), mv = function(i, s) {
      return new Ho(i, s);
    };
    st.mergeOptions({
      closePopupOnClick: !0
    }), st.include({
      // @method openPopup(popup: Popup): this
      // Opens the specified popup while closing the previously opened (to make sure only one is opened at one time for usability).
      // @alternative
      // @method openPopup(content: String|HTMLElement, latlng: LatLng, options?: Popup options): this
      // Creates a popup with the specified content and options and opens it in the given point on a map.
      openPopup: function(i, s, d) {
        return this._initOverlay(Ho, i, s, d).openOn(this), this;
      },
      // @method closePopup(popup?: Popup): this
      // Closes the popup previously opened with [openPopup](#map-openpopup) (or the given one).
      closePopup: function(i) {
        return i = arguments.length ? i : this._popup, i && i.close(), this;
      }
    }), Gn.include({
      // @method bindPopup(content: String|HTMLElement|Function|Popup, options?: Popup options): this
      // Binds a popup to the layer with the passed `content` and sets up the
      // necessary event listeners. If a `Function` is passed it will receive
      // the layer as the first argument and should return a `String` or `HTMLElement`.
      bindPopup: function(i, s) {
        return this._popup = this._initOverlay(Ho, this._popup, i, s), this._popupHandlersAdded || (this.on({
          click: this._openPopup,
          keypress: this._onKeyPress,
          remove: this.closePopup,
          move: this._movePopup
        }), this._popupHandlersAdded = !0), this;
      },
      // @method unbindPopup(): this
      // Removes the popup previously bound with `bindPopup`.
      unbindPopup: function() {
        return this._popup && (this.off({
          click: this._openPopup,
          keypress: this._onKeyPress,
          remove: this.closePopup,
          move: this._movePopup
        }), this._popupHandlersAdded = !1, this._popup = null), this;
      },
      // @method openPopup(latlng?: LatLng): this
      // Opens the bound popup at the specified `latlng` or at the default popup anchor if no `latlng` is passed.
      openPopup: function(i) {
        return this._popup && (this instanceof wi || (this._popup._source = this), this._popup._prepareOpen(i || this._latlng) && this._popup.openOn(this._map)), this;
      },
      // @method closePopup(): this
      // Closes the popup bound to this layer if it is open.
      closePopup: function() {
        return this._popup && this._popup.close(), this;
      },
      // @method togglePopup(): this
      // Opens or closes the popup bound to this layer depending on its current state.
      togglePopup: function() {
        return this._popup && this._popup.toggle(this), this;
      },
      // @method isPopupOpen(): boolean
      // Returns `true` if the popup bound to this layer is currently open.
      isPopupOpen: function() {
        return this._popup ? this._popup.isOpen() : !1;
      },
      // @method setPopupContent(content: String|HTMLElement|Popup): this
      // Sets the content of the popup bound to this layer.
      setPopupContent: function(i) {
        return this._popup && this._popup.setContent(i), this;
      },
      // @method getPopup(): Popup
      // Returns the popup bound to this layer.
      getPopup: function() {
        return this._popup;
      },
      _openPopup: function(i) {
        if (!(!this._popup || !this._map)) {
          qe(i);
          var s = i.layer || i.target;
          if (this._popup._source === s && !(s instanceof qi)) {
            this._map.hasLayer(this._popup) ? this.closePopup() : this.openPopup(i.latlng);
            return;
          }
          this._popup._source = s, this.openPopup(i.latlng);
        }
      },
      _movePopup: function(i) {
        this._popup.setLatLng(i.latlng);
      },
      _onKeyPress: function(i) {
        i.originalEvent.keyCode === 13 && this._openPopup(i);
      }
    });
    var Uo = hi.extend({
      // @section
      // @aka Tooltip options
      options: {
        // @option pane: String = 'tooltipPane'
        // `Map pane` where the tooltip will be added.
        pane: "tooltipPane",
        // @option offset: Point = Point(0, 0)
        // Optional offset of the tooltip position.
        offset: [0, 0],
        // @option direction: String = 'auto'
        // Direction where to open the tooltip. Possible values are: `right`, `left`,
        // `top`, `bottom`, `center`, `auto`.
        // `auto` will dynamically switch between `right` and `left` according to the tooltip
        // position on the map.
        direction: "auto",
        // @option permanent: Boolean = false
        // Whether to open the tooltip permanently or only on mouseover.
        permanent: !1,
        // @option sticky: Boolean = false
        // If true, the tooltip will follow the mouse instead of being fixed at the feature center.
        sticky: !1,
        // @option opacity: Number = 0.9
        // Tooltip container opacity.
        opacity: 0.9
      },
      onAdd: function(i) {
        hi.prototype.onAdd.call(this, i), this.setOpacity(this.options.opacity), i.fire("tooltipopen", { tooltip: this }), this._source && (this.addEventParent(this._source), this._source.fire("tooltipopen", { tooltip: this }, !0));
      },
      onRemove: function(i) {
        hi.prototype.onRemove.call(this, i), i.fire("tooltipclose", { tooltip: this }), this._source && (this.removeEventParent(this._source), this._source.fire("tooltipclose", { tooltip: this }, !0));
      },
      getEvents: function() {
        var i = hi.prototype.getEvents.call(this);
        return this.options.permanent || (i.preclick = this.close), i;
      },
      _initLayout: function() {
        var i = "leaflet-tooltip", s = i + " " + (this.options.className || "") + " leaflet-zoom-" + (this._zoomAnimated ? "animated" : "hide");
        this._contentNode = this._container = yt("div", s), this._container.setAttribute("role", "tooltip"), this._container.setAttribute("id", "leaflet-tooltip-" + f(this));
      },
      _updateLayout: function() {
      },
      _adjustPan: function() {
      },
      _setPosition: function(i) {
        var s, d, g = this._map, b = this._container, I = g.latLngToContainerPoint(g.getCenter()), W = g.layerPointToContainerPoint(i), le = this.options.direction, de = b.offsetWidth, Le = b.offsetHeight, ze = ue(this.options.offset), Ke = this._getAnchor();
        le === "top" ? (s = de / 2, d = Le) : le === "bottom" ? (s = de / 2, d = 0) : le === "center" ? (s = de / 2, d = Le / 2) : le === "right" ? (s = 0, d = Le / 2) : le === "left" ? (s = de, d = Le / 2) : W.x < I.x ? (le = "right", s = 0, d = Le / 2) : (le = "left", s = de + (ze.x + Ke.x) * 2, d = Le / 2), i = i.subtract(ue(s, d, !0)).add(ze).add(Ke), Gt(b, "leaflet-tooltip-right"), Gt(b, "leaflet-tooltip-left"), Gt(b, "leaflet-tooltip-top"), Gt(b, "leaflet-tooltip-bottom"), it(b, "leaflet-tooltip-" + le), Vt(b, i);
      },
      _updatePosition: function() {
        var i = this._map.latLngToLayerPoint(this._latlng);
        this._setPosition(i);
      },
      setOpacity: function(i) {
        this.options.opacity = i, this._container && dn(this._container, i);
      },
      _animateZoom: function(i) {
        var s = this._map._latLngToNewLayerPoint(this._latlng, i.zoom, i.center);
        this._setPosition(s);
      },
      _getAnchor: function() {
        return ue(this._source && this._source._getTooltipAnchor && !this.options.sticky ? this._source._getTooltipAnchor() : [0, 0]);
      }
    }), gv = function(i, s) {
      return new Uo(i, s);
    };
    st.include({
      // @method openTooltip(tooltip: Tooltip): this
      // Opens the specified tooltip.
      // @alternative
      // @method openTooltip(content: String|HTMLElement, latlng: LatLng, options?: Tooltip options): this
      // Creates a tooltip with the specified content and options and open it.
      openTooltip: function(i, s, d) {
        return this._initOverlay(Uo, i, s, d).openOn(this), this;
      },
      // @method closeTooltip(tooltip: Tooltip): this
      // Closes the tooltip given as parameter.
      closeTooltip: function(i) {
        return i.close(), this;
      }
    }), Gn.include({
      // @method bindTooltip(content: String|HTMLElement|Function|Tooltip, options?: Tooltip options): this
      // Binds a tooltip to the layer with the passed `content` and sets up the
      // necessary event listeners. If a `Function` is passed it will receive
      // the layer as the first argument and should return a `String` or `HTMLElement`.
      bindTooltip: function(i, s) {
        return this._tooltip && this.isTooltipOpen() && this.unbindTooltip(), this._tooltip = this._initOverlay(Uo, this._tooltip, i, s), this._initTooltipInteractions(), this._tooltip.options.permanent && this._map && this._map.hasLayer(this) && this.openTooltip(), this;
      },
      // @method unbindTooltip(): this
      // Removes the tooltip previously bound with `bindTooltip`.
      unbindTooltip: function() {
        return this._tooltip && (this._initTooltipInteractions(!0), this.closeTooltip(), this._tooltip = null), this;
      },
      _initTooltipInteractions: function(i) {
        if (!(!i && this._tooltipHandlersAdded)) {
          var s = i ? "off" : "on", d = {
            remove: this.closeTooltip,
            move: this._moveTooltip
          };
          this._tooltip.options.permanent ? d.add = this._openTooltip : (d.mouseover = this._openTooltip, d.mouseout = this.closeTooltip, d.click = this._openTooltip, this._map ? this._addFocusListeners() : d.add = this._addFocusListeners), this._tooltip.options.sticky && (d.mousemove = this._moveTooltip), this[s](d), this._tooltipHandlersAdded = !i;
        }
      },
      // @method openTooltip(latlng?: LatLng): this
      // Opens the bound tooltip at the specified `latlng` or at the default tooltip anchor if no `latlng` is passed.
      openTooltip: function(i) {
        return this._tooltip && (this instanceof wi || (this._tooltip._source = this), this._tooltip._prepareOpen(i) && (this._tooltip.openOn(this._map), this.getElement ? this._setAriaDescribedByOnLayer(this) : this.eachLayer && this.eachLayer(this._setAriaDescribedByOnLayer, this))), this;
      },
      // @method closeTooltip(): this
      // Closes the tooltip bound to this layer if it is open.
      closeTooltip: function() {
        if (this._tooltip)
          return this._tooltip.close();
      },
      // @method toggleTooltip(): this
      // Opens or closes the tooltip bound to this layer depending on its current state.
      toggleTooltip: function() {
        return this._tooltip && this._tooltip.toggle(this), this;
      },
      // @method isTooltipOpen(): boolean
      // Returns `true` if the tooltip bound to this layer is currently open.
      isTooltipOpen: function() {
        return this._tooltip.isOpen();
      },
      // @method setTooltipContent(content: String|HTMLElement|Tooltip): this
      // Sets the content of the tooltip bound to this layer.
      setTooltipContent: function(i) {
        return this._tooltip && this._tooltip.setContent(i), this;
      },
      // @method getTooltip(): Tooltip
      // Returns the tooltip bound to this layer.
      getTooltip: function() {
        return this._tooltip;
      },
      _addFocusListeners: function() {
        this.getElement ? this._addFocusListenersOnLayer(this) : this.eachLayer && this.eachLayer(this._addFocusListenersOnLayer, this);
      },
      _addFocusListenersOnLayer: function(i) {
        var s = typeof i.getElement == "function" && i.getElement();
        s && (w(s, "focus", function() {
          this._tooltip._source = i, this.openTooltip();
        }, this), w(s, "blur", this.closeTooltip, this));
      },
      _setAriaDescribedByOnLayer: function(i) {
        var s = typeof i.getElement == "function" && i.getElement();
        s && s.setAttribute("aria-describedby", this._tooltip._container.id);
      },
      _openTooltip: function(i) {
        if (!(!this._tooltip || !this._map)) {
          if (this._map.dragging && this._map.dragging.moving() && !this._openOnceFlag) {
            this._openOnceFlag = !0;
            var s = this;
            this._map.once("moveend", function() {
              s._openOnceFlag = !1, s._openTooltip(i);
            });
            return;
          }
          this._tooltip._source = i.layer || i.target, this.openTooltip(this._tooltip.options.sticky ? i.latlng : void 0);
        }
      },
      _moveTooltip: function(i) {
        var s = i.latlng, d, g;
        this._tooltip.options.sticky && i.originalEvent && (d = this._map.mouseEventToContainerPoint(i.originalEvent), g = this._map.containerPointToLayerPoint(d), s = this._map.layerPointToLatLng(g)), this._tooltip.setLatLng(s);
      }
    });
    var Pc = qr.extend({
      options: {
        // @section
        // @aka DivIcon options
        iconSize: [12, 12],
        // also can be set through CSS
        // iconAnchor: (Point),
        // popupAnchor: (Point),
        // @option html: String|HTMLElement = ''
        // Custom HTML code to put inside the div element, empty by default. Alternatively,
        // an instance of `HTMLElement`.
        html: !1,
        // @option bgPos: Point = [0, 0]
        // Optional relative position of the background, in pixels
        bgPos: null,
        className: "leaflet-div-icon"
      },
      createIcon: function(i) {
        var s = i && i.tagName === "DIV" ? i : document.createElement("div"), d = this.options;
        if (d.html instanceof Element ? (Vr(s), s.appendChild(d.html)) : s.innerHTML = d.html !== !1 ? d.html : "", d.bgPos) {
          var g = ue(d.bgPos);
          s.style.backgroundPosition = -g.x + "px " + -g.y + "px";
        }
        return this._setIconStyles(s, "icon"), s;
      },
      createShadow: function() {
        return null;
      }
    });
    function vv(i) {
      return new Pc(i);
    }
    qr.Default = ja;
    var Va = Gn.extend({
      // @section
      // @aka GridLayer options
      options: {
        // @option tileSize: Number|Point = 256
        // Width and height of tiles in the grid. Use a number if width and height are equal, or `L.point(width, height)` otherwise.
        tileSize: 256,
        // @option opacity: Number = 1.0
        // Opacity of the tiles. Can be used in the `createTile()` function.
        opacity: 1,
        // @option updateWhenIdle: Boolean = (depends)
        // Load new tiles only when panning ends.
        // `true` by default on mobile browsers, in order to avoid too many requests and keep smooth navigation.
        // `false` otherwise in order to display new tiles _during_ panning, since it is easy to pan outside the
        // [`keepBuffer`](#gridlayer-keepbuffer) option in desktop browsers.
        updateWhenIdle: Be.mobile,
        // @option updateWhenZooming: Boolean = true
        // By default, a smooth zoom animation (during a [touch zoom](#map-touchzoom) or a [`flyTo()`](#map-flyto)) will update grid layers every integer zoom level. Setting this option to `false` will update the grid layer only when the smooth animation ends.
        updateWhenZooming: !0,
        // @option updateInterval: Number = 200
        // Tiles will not update more than once every `updateInterval` milliseconds when panning.
        updateInterval: 200,
        // @option zIndex: Number = 1
        // The explicit zIndex of the tile layer.
        zIndex: 1,
        // @option bounds: LatLngBounds = undefined
        // If set, tiles will only be loaded inside the set `LatLngBounds`.
        bounds: null,
        // @option minZoom: Number = 0
        // The minimum zoom level down to which this layer will be displayed (inclusive).
        minZoom: 0,
        // @option maxZoom: Number = undefined
        // The maximum zoom level up to which this layer will be displayed (inclusive).
        maxZoom: void 0,
        // @option maxNativeZoom: Number = undefined
        // Maximum zoom number the tile source has available. If it is specified,
        // the tiles on all zoom levels higher than `maxNativeZoom` will be loaded
        // from `maxNativeZoom` level and auto-scaled.
        maxNativeZoom: void 0,
        // @option minNativeZoom: Number = undefined
        // Minimum zoom number the tile source has available. If it is specified,
        // the tiles on all zoom levels lower than `minNativeZoom` will be loaded
        // from `minNativeZoom` level and auto-scaled.
        minNativeZoom: void 0,
        // @option noWrap: Boolean = false
        // Whether the layer is wrapped around the antimeridian. If `true`, the
        // GridLayer will only be displayed once at low zoom levels. Has no
        // effect when the [map CRS](#map-crs) doesn't wrap around. Can be used
        // in combination with [`bounds`](#gridlayer-bounds) to prevent requesting
        // tiles outside the CRS limits.
        noWrap: !1,
        // @option pane: String = 'tilePane'
        // `Map pane` where the grid layer will be added.
        pane: "tilePane",
        // @option className: String = ''
        // A custom class name to assign to the tile layer. Empty by default.
        className: "",
        // @option keepBuffer: Number = 2
        // When panning the map, keep this many rows and columns of tiles before unloading them.
        keepBuffer: 2
      },
      initialize: function(i) {
        O(this, i);
      },
      onAdd: function() {
        this._initContainer(), this._levels = {}, this._tiles = {}, this._resetView();
      },
      beforeAdd: function(i) {
        i._addZoomLimit(this);
      },
      onRemove: function(i) {
        this._removeAllTiles(), jt(this._container), i._removeZoomLimit(this), this._container = null, this._tileZoom = void 0;
      },
      // @method bringToFront: this
      // Brings the tile layer to the top of all tile layers.
      bringToFront: function() {
        return this._map && (Wi(this._container), this._setAutoZIndex(Math.max)), this;
      },
      // @method bringToBack: this
      // Brings the tile layer to the bottom of all tile layers.
      bringToBack: function() {
        return this._map && (bi(this._container), this._setAutoZIndex(Math.min)), this;
      },
      // @method getContainer: HTMLElement
      // Returns the HTML element that contains the tiles for this layer.
      getContainer: function() {
        return this._container;
      },
      // @method setOpacity(opacity: Number): this
      // Changes the [opacity](#gridlayer-opacity) of the grid layer.
      setOpacity: function(i) {
        return this.options.opacity = i, this._updateOpacity(), this;
      },
      // @method setZIndex(zIndex: Number): this
      // Changes the [zIndex](#gridlayer-zindex) of the grid layer.
      setZIndex: function(i) {
        return this.options.zIndex = i, this._updateZIndex(), this;
      },
      // @method isLoading: Boolean
      // Returns `true` if any tile in the grid layer has not finished loading.
      isLoading: function() {
        return this._loading;
      },
      // @method redraw: this
      // Causes the layer to clear all the tiles and request them again.
      redraw: function() {
        if (this._map) {
          this._removeAllTiles();
          var i = this._clampZoom(this._map.getZoom());
          i !== this._tileZoom && (this._tileZoom = i, this._updateLevels()), this._update();
        }
        return this;
      },
      getEvents: function() {
        var i = {
          viewprereset: this._invalidateAll,
          viewreset: this._resetView,
          zoom: this._resetView,
          moveend: this._onMoveEnd
        };
        return this.options.updateWhenIdle || (this._onMove || (this._onMove = m(this._onMoveEnd, this.options.updateInterval, this)), i.move = this._onMove), this._zoomAnimated && (i.zoomanim = this._animateZoom), i;
      },
      // @section Extension methods
      // Layers extending `GridLayer` shall reimplement the following method.
      // @method createTile(coords: Object, done?: Function): HTMLElement
      // Called only internally, must be overridden by classes extending `GridLayer`.
      // Returns the `HTMLElement` corresponding to the given `coords`. If the `done` callback
      // is specified, it must be called when the tile has finished loading and drawing.
      createTile: function() {
        return document.createElement("div");
      },
      // @section
      // @method getTileSize: Point
      // Normalizes the [tileSize option](#gridlayer-tilesize) into a point. Used by the `createTile()` method.
      getTileSize: function() {
        var i = this.options.tileSize;
        return i instanceof pe ? i : new pe(i, i);
      },
      _updateZIndex: function() {
        this._container && this.options.zIndex !== void 0 && this.options.zIndex !== null && (this._container.style.zIndex = this.options.zIndex);
      },
      _setAutoZIndex: function(i) {
        for (var s = this.getPane().children, d = -i(-1 / 0, 1 / 0), g = 0, b = s.length, I; g < b; g++)
          I = s[g].style.zIndex, s[g] !== this._container && I && (d = i(d, +I));
        isFinite(d) && (this.options.zIndex = d + i(-1, 1), this._updateZIndex());
      },
      _updateOpacity: function() {
        if (this._map && !Be.ielt9) {
          dn(this._container, this.options.opacity);
          var i = +/* @__PURE__ */ new Date(), s = !1, d = !1;
          for (var g in this._tiles) {
            var b = this._tiles[g];
            if (!(!b.current || !b.loaded)) {
              var I = Math.min(1, (i - b.loaded) / 200);
              dn(b.el, I), I < 1 ? s = !0 : (b.active ? d = !0 : this._onOpaqueTile(b), b.active = !0);
            }
          }
          d && !this._noPrune && this._pruneTiles(), s && (ne(this._fadeFrame), this._fadeFrame = ae(this._updateOpacity, this));
        }
      },
      _onOpaqueTile: y,
      _initContainer: function() {
        this._container || (this._container = yt("div", "leaflet-layer " + (this.options.className || "")), this._updateZIndex(), this.options.opacity < 1 && this._updateOpacity(), this.getPane().appendChild(this._container));
      },
      _updateLevels: function() {
        var i = this._tileZoom, s = this.options.maxZoom;
        if (i !== void 0) {
          for (var d in this._levels)
            d = Number(d), this._levels[d].el.children.length || d === i ? (this._levels[d].el.style.zIndex = s - Math.abs(i - d), this._onUpdateLevel(d)) : (jt(this._levels[d].el), this._removeTilesAtZoom(d), this._onRemoveLevel(d), delete this._levels[d]);
          var g = this._levels[i], b = this._map;
          return g || (g = this._levels[i] = {}, g.el = yt("div", "leaflet-tile-container leaflet-zoom-animated", this._container), g.el.style.zIndex = s, g.origin = b.project(b.unproject(b.getPixelOrigin()), i).round(), g.zoom = i, this._setZoomTransform(g, b.getCenter(), b.getZoom()), y(g.el.offsetWidth), this._onCreateLevel(g)), this._level = g, g;
        }
      },
      _onUpdateLevel: y,
      _onRemoveLevel: y,
      _onCreateLevel: y,
      _pruneTiles: function() {
        if (this._map) {
          var i, s, d = this._map.getZoom();
          if (d > this.options.maxZoom || d < this.options.minZoom) {
            this._removeAllTiles();
            return;
          }
          for (i in this._tiles)
            s = this._tiles[i], s.retain = s.current;
          for (i in this._tiles)
            if (s = this._tiles[i], s.current && !s.active) {
              var g = s.coords;
              this._retainParent(g.x, g.y, g.z, g.z - 5) || this._retainChildren(g.x, g.y, g.z, g.z + 2);
            }
          for (i in this._tiles)
            this._tiles[i].retain || this._removeTile(i);
        }
      },
      _removeTilesAtZoom: function(i) {
        for (var s in this._tiles)
          this._tiles[s].coords.z === i && this._removeTile(s);
      },
      _removeAllTiles: function() {
        for (var i in this._tiles)
          this._removeTile(i);
      },
      _invalidateAll: function() {
        for (var i in this._levels)
          jt(this._levels[i].el), this._onRemoveLevel(Number(i)), delete this._levels[i];
        this._removeAllTiles(), this._tileZoom = void 0;
      },
      _retainParent: function(i, s, d, g) {
        var b = Math.floor(i / 2), I = Math.floor(s / 2), W = d - 1, le = new pe(+b, +I);
        le.z = +W;
        var de = this._tileCoordsToKey(le), Le = this._tiles[de];
        return Le && Le.active ? (Le.retain = !0, !0) : (Le && Le.loaded && (Le.retain = !0), W > g ? this._retainParent(b, I, W, g) : !1);
      },
      _retainChildren: function(i, s, d, g) {
        for (var b = 2 * i; b < 2 * i + 2; b++)
          for (var I = 2 * s; I < 2 * s + 2; I++) {
            var W = new pe(b, I);
            W.z = d + 1;
            var le = this._tileCoordsToKey(W), de = this._tiles[le];
            if (de && de.active) {
              de.retain = !0;
              continue;
            } else
              de && de.loaded && (de.retain = !0);
            d + 1 < g && this._retainChildren(b, I, d + 1, g);
          }
      },
      _resetView: function(i) {
        var s = i && (i.pinch || i.flyTo);
        this._setView(this._map.getCenter(), this._map.getZoom(), s, s);
      },
      _animateZoom: function(i) {
        this._setView(i.center, i.zoom, !0, i.noUpdate);
      },
      _clampZoom: function(i) {
        var s = this.options;
        return s.minNativeZoom !== void 0 && i < s.minNativeZoom ? s.minNativeZoom : s.maxNativeZoom !== void 0 && s.maxNativeZoom < i ? s.maxNativeZoom : i;
      },
      _setView: function(i, s, d, g) {
        var b = Math.round(s);
        this.options.maxZoom !== void 0 && b > this.options.maxZoom || this.options.minZoom !== void 0 && b < this.options.minZoom ? b = void 0 : b = this._clampZoom(b);
        var I = this.options.updateWhenZooming && b !== this._tileZoom;
        (!g || I) && (this._tileZoom = b, this._abortLoading && this._abortLoading(), this._updateLevels(), this._resetGrid(), b !== void 0 && this._update(i), d || this._pruneTiles(), this._noPrune = !!d), this._setZoomTransforms(i, s);
      },
      _setZoomTransforms: function(i, s) {
        for (var d in this._levels)
          this._setZoomTransform(this._levels[d], i, s);
      },
      _setZoomTransform: function(i, s, d) {
        var g = this._map.getZoomScale(d, i.zoom), b = i.origin.multiplyBy(g).subtract(this._map._getNewPixelOrigin(s, d)).round();
        Be.any3d ? Ft(i.el, b, g) : Vt(i.el, b);
      },
      _resetGrid: function() {
        var i = this._map, s = i.options.crs, d = this._tileSize = this.getTileSize(), g = this._tileZoom, b = this._map.getPixelWorldBounds(this._tileZoom);
        b && (this._globalTileRange = this._pxBoundsToTileRange(b)), this._wrapX = s.wrapLng && !this.options.noWrap && [
          Math.floor(i.project([0, s.wrapLng[0]], g).x / d.x),
          Math.ceil(i.project([0, s.wrapLng[1]], g).x / d.y)
        ], this._wrapY = s.wrapLat && !this.options.noWrap && [
          Math.floor(i.project([s.wrapLat[0], 0], g).y / d.x),
          Math.ceil(i.project([s.wrapLat[1], 0], g).y / d.y)
        ];
      },
      _onMoveEnd: function() {
        !this._map || this._map._animatingZoom || this._update();
      },
      _getTiledPixelBounds: function(i) {
        var s = this._map, d = s._animatingZoom ? Math.max(s._animateToZoom, s.getZoom()) : s.getZoom(), g = s.getZoomScale(d, this._tileZoom), b = s.project(i, this._tileZoom).floor(), I = s.getSize().divideBy(g * 2);
        return new Fe(b.subtract(I), b.add(I));
      },
      // Private method to load tiles in the grid's active zoom level according to map bounds
      _update: function(i) {
        var s = this._map;
        if (s) {
          var d = this._clampZoom(s.getZoom());
          if (i === void 0 && (i = s.getCenter()), this._tileZoom !== void 0) {
            var g = this._getTiledPixelBounds(i), b = this._pxBoundsToTileRange(g), I = b.getCenter(), W = [], le = this.options.keepBuffer, de = new Fe(
              b.getBottomLeft().subtract([le, -le]),
              b.getTopRight().add([le, -le])
            );
            if (!(isFinite(b.min.x) && isFinite(b.min.y) && isFinite(b.max.x) && isFinite(b.max.y)))
              throw new Error("Attempted to load an infinite number of tiles");
            for (var Le in this._tiles) {
              var ze = this._tiles[Le].coords;
              (ze.z !== this._tileZoom || !de.contains(new pe(ze.x, ze.y))) && (this._tiles[Le].current = !1);
            }
            if (Math.abs(d - this._tileZoom) > 1) {
              this._setView(i, d);
              return;
            }
            for (var Ke = b.min.y; Ke <= b.max.y; Ke++)
              for (var dt = b.min.x; dt <= b.max.x; dt++) {
                var kn = new pe(dt, Ke);
                if (kn.z = this._tileZoom, !!this._isValidTile(kn)) {
                  var hn = this._tiles[this._tileCoordsToKey(kn)];
                  hn ? hn.current = !0 : W.push(kn);
                }
              }
            if (W.sort(function(Cn, Qr) {
              return Cn.distanceTo(I) - Qr.distanceTo(I);
            }), W.length !== 0) {
              this._loading || (this._loading = !0, this.fire("loading"));
              var Rn = document.createDocumentFragment();
              for (dt = 0; dt < W.length; dt++)
                this._addTile(W[dt], Rn);
              this._level.el.appendChild(Rn);
            }
          }
        }
      },
      _isValidTile: function(i) {
        var s = this._map.options.crs;
        if (!s.infinite) {
          var d = this._globalTileRange;
          if (!s.wrapLng && (i.x < d.min.x || i.x > d.max.x) || !s.wrapLat && (i.y < d.min.y || i.y > d.max.y))
            return !1;
        }
        if (!this.options.bounds)
          return !0;
        var g = this._tileCoordsToBounds(i);
        return Ve(this.options.bounds).overlaps(g);
      },
      _keyToBounds: function(i) {
        return this._tileCoordsToBounds(this._keyToTileCoords(i));
      },
      _tileCoordsToNwSe: function(i) {
        var s = this._map, d = this.getTileSize(), g = i.scaleBy(d), b = g.add(d), I = s.unproject(g, i.z), W = s.unproject(b, i.z);
        return [I, W];
      },
      // converts tile coordinates to its geographical bounds
      _tileCoordsToBounds: function(i) {
        var s = this._tileCoordsToNwSe(i), d = new nt(s[0], s[1]);
        return this.options.noWrap || (d = this._map.wrapLatLngBounds(d)), d;
      },
      // converts tile coordinates to key for the tile cache
      _tileCoordsToKey: function(i) {
        return i.x + ":" + i.y + ":" + i.z;
      },
      // converts tile cache key to coordinates
      _keyToTileCoords: function(i) {
        var s = i.split(":"), d = new pe(+s[0], +s[1]);
        return d.z = +s[2], d;
      },
      _removeTile: function(i) {
        var s = this._tiles[i];
        s && (jt(s.el), delete this._tiles[i], this.fire("tileunload", {
          tile: s.el,
          coords: this._keyToTileCoords(i)
        }));
      },
      _initTile: function(i) {
        it(i, "leaflet-tile");
        var s = this.getTileSize();
        i.style.width = s.x + "px", i.style.height = s.y + "px", i.onselectstart = y, i.onmousemove = y, Be.ielt9 && this.options.opacity < 1 && dn(i, this.options.opacity);
      },
      _addTile: function(i, s) {
        var d = this._getTilePos(i), g = this._tileCoordsToKey(i), b = this.createTile(this._wrapCoords(i), u(this._tileReady, this, i));
        this._initTile(b), this.createTile.length < 2 && ae(u(this._tileReady, this, i, null, b)), Vt(b, d), this._tiles[g] = {
          el: b,
          coords: i,
          current: !0
        }, s.appendChild(b), this.fire("tileloadstart", {
          tile: b,
          coords: i
        });
      },
      _tileReady: function(i, s, d) {
        s && this.fire("tileerror", {
          error: s,
          tile: d,
          coords: i
        });
        var g = this._tileCoordsToKey(i);
        d = this._tiles[g], d && (d.loaded = +/* @__PURE__ */ new Date(), this._map._fadeAnimated ? (dn(d.el, 0), ne(this._fadeFrame), this._fadeFrame = ae(this._updateOpacity, this)) : (d.active = !0, this._pruneTiles()), s || (it(d.el, "leaflet-tile-loaded"), this.fire("tileload", {
          tile: d.el,
          coords: i
        })), this._noTilesToLoad() && (this._loading = !1, this.fire("load"), Be.ielt9 || !this._map._fadeAnimated ? ae(this._pruneTiles, this) : setTimeout(u(this._pruneTiles, this), 250)));
      },
      _getTilePos: function(i) {
        return i.scaleBy(this.getTileSize()).subtract(this._level.origin);
      },
      _wrapCoords: function(i) {
        var s = new pe(
          this._wrapX ? v(i.x, this._wrapX) : i.x,
          this._wrapY ? v(i.y, this._wrapY) : i.y
        );
        return s.z = i.z, s;
      },
      _pxBoundsToTileRange: function(i) {
        var s = this.getTileSize();
        return new Fe(
          i.min.unscaleBy(s).floor(),
          i.max.unscaleBy(s).ceil().subtract([1, 1])
        );
      },
      _noTilesToLoad: function() {
        for (var i in this._tiles)
          if (!this._tiles[i].loaded)
            return !1;
        return !0;
      }
    });
    function _v(i) {
      return new Va(i);
    }
    var Xr = Va.extend({
      // @section
      // @aka TileLayer options
      options: {
        // @option minZoom: Number = 0
        // The minimum zoom level down to which this layer will be displayed (inclusive).
        minZoom: 0,
        // @option maxZoom: Number = 18
        // The maximum zoom level up to which this layer will be displayed (inclusive).
        maxZoom: 18,
        // @option subdomains: String|String[] = 'abc'
        // Subdomains of the tile service. Can be passed in the form of one string (where each letter is a subdomain name) or an array of strings.
        subdomains: "abc",
        // @option errorTileUrl: String = ''
        // URL to the tile image to show in place of the tile that failed to load.
        errorTileUrl: "",
        // @option zoomOffset: Number = 0
        // The zoom number used in tile URLs will be offset with this value.
        zoomOffset: 0,
        // @option tms: Boolean = false
        // If `true`, inverses Y axis numbering for tiles (turn this on for [TMS](https://en.wikipedia.org/wiki/Tile_Map_Service) services).
        tms: !1,
        // @option zoomReverse: Boolean = false
        // If set to true, the zoom number used in tile URLs will be reversed (`maxZoom - zoom` instead of `zoom`)
        zoomReverse: !1,
        // @option detectRetina: Boolean = false
        // If `true` and user is on a retina display, it will request four tiles of half the specified size and a bigger zoom level in place of one to utilize the high resolution.
        detectRetina: !1,
        // @option crossOrigin: Boolean|String = false
        // Whether the crossOrigin attribute will be added to the tiles.
        // If a String is provided, all tiles will have their crossOrigin attribute set to the String provided. This is needed if you want to access tile pixel data.
        // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
        crossOrigin: !1,
        // @option referrerPolicy: Boolean|String = false
        // Whether the referrerPolicy attribute will be added to the tiles.
        // If a String is provided, all tiles will have their referrerPolicy attribute set to the String provided.
        // This may be needed if your map's rendering context has a strict default but your tile provider expects a valid referrer
        // (e.g. to validate an API token).
        // Refer to [HTMLImageElement.referrerPolicy](https://developer.mozilla.org/en-US/docs/Web/API/HTMLImageElement/referrerPolicy) for valid String values.
        referrerPolicy: !1
      },
      initialize: function(i, s) {
        this._url = i, s = O(this, s), s.detectRetina && Be.retina && s.maxZoom > 0 ? (s.tileSize = Math.floor(s.tileSize / 2), s.zoomReverse ? (s.zoomOffset--, s.minZoom = Math.min(s.maxZoom, s.minZoom + 1)) : (s.zoomOffset++, s.maxZoom = Math.max(s.minZoom, s.maxZoom - 1)), s.minZoom = Math.max(0, s.minZoom)) : s.zoomReverse ? s.minZoom = Math.min(s.maxZoom, s.minZoom) : s.maxZoom = Math.max(s.minZoom, s.maxZoom), typeof s.subdomains == "string" && (s.subdomains = s.subdomains.split("")), this.on("tileunload", this._onTileRemove);
      },
      // @method setUrl(url: String, noRedraw?: Boolean): this
      // Updates the layer's URL template and redraws it (unless `noRedraw` is set to `true`).
      // If the URL does not change, the layer will not be redrawn unless
      // the noRedraw parameter is set to false.
      setUrl: function(i, s) {
        return this._url === i && s === void 0 && (s = !0), this._url = i, s || this.redraw(), this;
      },
      // @method createTile(coords: Object, done?: Function): HTMLElement
      // Called only internally, overrides GridLayer's [`createTile()`](#gridlayer-createtile)
      // to return an `<img>` HTML element with the appropriate image URL given `coords`. The `done`
      // callback is called when the tile has been loaded.
      createTile: function(i, s) {
        var d = document.createElement("img");
        return w(d, "load", u(this._tileOnLoad, this, s, d)), w(d, "error", u(this._tileOnError, this, s, d)), (this.options.crossOrigin || this.options.crossOrigin === "") && (d.crossOrigin = this.options.crossOrigin === !0 ? "" : this.options.crossOrigin), typeof this.options.referrerPolicy == "string" && (d.referrerPolicy = this.options.referrerPolicy), d.alt = "", d.src = this.getTileUrl(i), d;
      },
      // @section Extension methods
      // @uninheritable
      // Layers extending `TileLayer` might reimplement the following method.
      // @method getTileUrl(coords: Object): String
      // Called only internally, returns the URL for a tile given its coordinates.
      // Classes extending `TileLayer` can override this function to provide custom tile URL naming schemes.
      getTileUrl: function(i) {
        var s = {
          r: Be.retina ? "@2x" : "",
          s: this._getSubdomain(i),
          x: i.x,
          y: i.y,
          z: this._getZoomForUrl()
        };
        if (this._map && !this._map.options.crs.infinite) {
          var d = this._globalTileRange.max.y - i.y;
          this.options.tms && (s.y = d), s["-y"] = d;
        }
        return T(this._url, a(s, this.options));
      },
      _tileOnLoad: function(i, s) {
        Be.ielt9 ? setTimeout(u(i, this, null, s), 0) : i(null, s);
      },
      _tileOnError: function(i, s, d) {
        var g = this.options.errorTileUrl;
        g && s.getAttribute("src") !== g && (s.src = g), i(d, s);
      },
      _onTileRemove: function(i) {
        i.tile.onload = null;
      },
      _getZoomForUrl: function() {
        var i = this._tileZoom, s = this.options.maxZoom, d = this.options.zoomReverse, g = this.options.zoomOffset;
        return d && (i = s - i), i + g;
      },
      _getSubdomain: function(i) {
        var s = Math.abs(i.x + i.y) % this.options.subdomains.length;
        return this.options.subdomains[s];
      },
      // stops loading all tiles in the background layer
      _abortLoading: function() {
        var i, s;
        for (i in this._tiles)
          if (this._tiles[i].coords.z !== this._tileZoom && (s = this._tiles[i].el, s.onload = y, s.onerror = y, !s.complete)) {
            s.src = D;
            var d = this._tiles[i].coords;
            jt(s), delete this._tiles[i], this.fire("tileabort", {
              tile: s,
              coords: d
            });
          }
      },
      _removeTile: function(i) {
        var s = this._tiles[i];
        if (s)
          return s.el.setAttribute("src", D), Va.prototype._removeTile.call(this, i);
      },
      _tileReady: function(i, s, d) {
        if (!(!this._map || d && d.getAttribute("src") === D))
          return Va.prototype._tileReady.call(this, i, s, d);
      }
    });
    function Cc(i, s) {
      return new Xr(i, s);
    }
    var Oc = Xr.extend({
      // @section
      // @aka TileLayer.WMS options
      // If any custom options not documented here are used, they will be sent to the
      // WMS server as extra parameters in each request URL. This can be useful for
      // [non-standard vendor WMS parameters](https://docs.geoserver.org/stable/en/user/services/wms/vendor.html).
      defaultWmsParams: {
        service: "WMS",
        request: "GetMap",
        // @option layers: String = ''
        // **(required)** Comma-separated list of WMS layers to show.
        layers: "",
        // @option styles: String = ''
        // Comma-separated list of WMS styles.
        styles: "",
        // @option format: String = 'image/jpeg'
        // WMS image format (use `'image/png'` for layers with transparency).
        format: "image/jpeg",
        // @option transparent: Boolean = false
        // If `true`, the WMS service will return images with transparency.
        transparent: !1,
        // @option version: String = '1.1.1'
        // Version of the WMS service to use
        version: "1.1.1"
      },
      options: {
        // @option crs: CRS = null
        // Coordinate Reference System to use for the WMS requests, defaults to
        // map CRS. Don't change this if you're not sure what it means.
        crs: null,
        // @option uppercase: Boolean = false
        // If `true`, WMS request parameter keys will be uppercase.
        uppercase: !1
      },
      initialize: function(i, s) {
        this._url = i;
        var d = a({}, this.defaultWmsParams);
        for (var g in s)
          g in this.options || (d[g] = s[g]);
        s = O(this, s);
        var b = s.detectRetina && Be.retina ? 2 : 1, I = this.getTileSize();
        d.width = I.x * b, d.height = I.y * b, this.wmsParams = d;
      },
      onAdd: function(i) {
        this._crs = this.options.crs || i.options.crs, this._wmsVersion = parseFloat(this.wmsParams.version);
        var s = this._wmsVersion >= 1.3 ? "crs" : "srs";
        this.wmsParams[s] = this._crs.code, Xr.prototype.onAdd.call(this, i);
      },
      getTileUrl: function(i) {
        var s = this._tileCoordsToNwSe(i), d = this._crs, g = Pe(d.project(s[0]), d.project(s[1])), b = g.min, I = g.max, W = (this._wmsVersion >= 1.3 && this._crs === wc ? [b.y, b.x, I.y, I.x] : [b.x, b.y, I.x, I.y]).join(","), le = Xr.prototype.getTileUrl.call(this, i);
        return le + R(this.wmsParams, le, this.options.uppercase) + (this.options.uppercase ? "&BBOX=" : "&bbox=") + W;
      },
      // @method setParams(params: Object, noRedraw?: Boolean): this
      // Merges an object with the new parameters and re-requests tiles on the current screen (unless `noRedraw` was set to true).
      setParams: function(i, s) {
        return a(this.wmsParams, i), s || this.redraw(), this;
      }
    });
    function yv(i, s) {
      return new Oc(i, s);
    }
    Xr.WMS = Oc, Cc.wms = yv;
    var Li = Gn.extend({
      // @section
      // @aka Renderer options
      options: {
        // @option padding: Number = 0.1
        // How much to extend the clip area around the map view (relative to its size)
        // e.g. 0.1 would be 10% of map view in each direction
        padding: 0.1
      },
      initialize: function(i) {
        O(this, i), f(this), this._layers = this._layers || {};
      },
      onAdd: function() {
        this._container || (this._initContainer(), it(this._container, "leaflet-zoom-animated")), this.getPane().appendChild(this._container), this._update(), this.on("update", this._updatePaths, this);
      },
      onRemove: function() {
        this.off("update", this._updatePaths, this), this._destroyContainer();
      },
      getEvents: function() {
        var i = {
          viewreset: this._reset,
          zoom: this._onZoom,
          moveend: this._update,
          zoomend: this._onZoomEnd
        };
        return this._zoomAnimated && (i.zoomanim = this._onAnimZoom), i;
      },
      _onAnimZoom: function(i) {
        this._updateTransform(i.center, i.zoom);
      },
      _onZoom: function() {
        this._updateTransform(this._map.getCenter(), this._map.getZoom());
      },
      _updateTransform: function(i, s) {
        var d = this._map.getZoomScale(s, this._zoom), g = this._map.getSize().multiplyBy(0.5 + this.options.padding), b = this._map.project(this._center, s), I = g.multiplyBy(-d).add(b).subtract(this._map._getNewPixelOrigin(i, s));
        Be.any3d ? Ft(this._container, I, d) : Vt(this._container, I);
      },
      _reset: function() {
        this._update(), this._updateTransform(this._center, this._zoom);
        for (var i in this._layers)
          this._layers[i]._reset();
      },
      _onZoomEnd: function() {
        for (var i in this._layers)
          this._layers[i]._project();
      },
      _updatePaths: function() {
        for (var i in this._layers)
          this._layers[i]._update();
      },
      _update: function() {
        var i = this.options.padding, s = this._map.getSize(), d = this._map.containerPointToLayerPoint(s.multiplyBy(-i)).round();
        this._bounds = new Fe(d, d.add(s.multiplyBy(1 + i * 2)).round()), this._center = this._map.getCenter(), this._zoom = this._map.getZoom();
      }
    }), Ec = Li.extend({
      // @section
      // @aka Canvas options
      options: {
        // @option tolerance: Number = 0
        // How much to extend the click tolerance around a path/object on the map.
        tolerance: 0
      },
      getEvents: function() {
        var i = Li.prototype.getEvents.call(this);
        return i.viewprereset = this._onViewPreReset, i;
      },
      _onViewPreReset: function() {
        this._postponeUpdatePaths = !0;
      },
      onAdd: function() {
        Li.prototype.onAdd.call(this), this._draw();
      },
      _initContainer: function() {
        var i = this._container = document.createElement("canvas");
        w(i, "mousemove", this._onMouseMove, this), w(i, "click dblclick mousedown mouseup contextmenu", this._onClick, this), w(i, "mouseout", this._handleMouseOut, this), i._leaflet_disable_events = !0, this._ctx = i.getContext("2d");
      },
      _destroyContainer: function() {
        ne(this._redrawRequest), delete this._ctx, jt(this._container), F(this._container), delete this._container;
      },
      _updatePaths: function() {
        if (!this._postponeUpdatePaths) {
          var i;
          this._redrawBounds = null;
          for (var s in this._layers)
            i = this._layers[s], i._update();
          this._redraw();
        }
      },
      _update: function() {
        if (!(this._map._animatingZoom && this._bounds)) {
          Li.prototype._update.call(this);
          var i = this._bounds, s = this._container, d = i.getSize(), g = Be.retina ? 2 : 1;
          Vt(s, i.min), s.width = g * d.x, s.height = g * d.y, s.style.width = d.x + "px", s.style.height = d.y + "px", Be.retina && this._ctx.scale(2, 2), this._ctx.translate(-i.min.x, -i.min.y), this.fire("update");
        }
      },
      _reset: function() {
        Li.prototype._reset.call(this), this._postponeUpdatePaths && (this._postponeUpdatePaths = !1, this._updatePaths());
      },
      _initPath: function(i) {
        this._updateDashArray(i), this._layers[f(i)] = i;
        var s = i._order = {
          layer: i,
          prev: this._drawLast,
          next: null
        };
        this._drawLast && (this._drawLast.next = s), this._drawLast = s, this._drawFirst = this._drawFirst || this._drawLast;
      },
      _addPath: function(i) {
        this._requestRedraw(i);
      },
      _removePath: function(i) {
        var s = i._order, d = s.next, g = s.prev;
        d ? d.prev = g : this._drawLast = g, g ? g.next = d : this._drawFirst = d, delete i._order, delete this._layers[f(i)], this._requestRedraw(i);
      },
      _updatePath: function(i) {
        this._extendRedrawBounds(i), i._project(), i._update(), this._requestRedraw(i);
      },
      _updateStyle: function(i) {
        this._updateDashArray(i), this._requestRedraw(i);
      },
      _updateDashArray: function(i) {
        if (typeof i.options.dashArray == "string") {
          var s = i.options.dashArray.split(/[, ]+/), d = [], g, b;
          for (b = 0; b < s.length; b++) {
            if (g = Number(s[b]), isNaN(g))
              return;
            d.push(g);
          }
          i.options._dashArray = d;
        } else
          i.options._dashArray = i.options.dashArray;
      },
      _requestRedraw: function(i) {
        this._map && (this._extendRedrawBounds(i), this._redrawRequest = this._redrawRequest || ae(this._redraw, this));
      },
      _extendRedrawBounds: function(i) {
        if (i._pxBounds) {
          var s = (i.options.weight || 0) + 1;
          this._redrawBounds = this._redrawBounds || new Fe(), this._redrawBounds.extend(i._pxBounds.min.subtract([s, s])), this._redrawBounds.extend(i._pxBounds.max.add([s, s]));
        }
      },
      _redraw: function() {
        this._redrawRequest = null, this._redrawBounds && (this._redrawBounds.min._floor(), this._redrawBounds.max._ceil()), this._clear(), this._draw(), this._redrawBounds = null;
      },
      _clear: function() {
        var i = this._redrawBounds;
        if (i) {
          var s = i.getSize();
          this._ctx.clearRect(i.min.x, i.min.y, s.x, s.y);
        } else
          this._ctx.save(), this._ctx.setTransform(1, 0, 0, 1, 0, 0), this._ctx.clearRect(0, 0, this._container.width, this._container.height), this._ctx.restore();
      },
      _draw: function() {
        var i, s = this._redrawBounds;
        if (this._ctx.save(), s) {
          var d = s.getSize();
          this._ctx.beginPath(), this._ctx.rect(s.min.x, s.min.y, d.x, d.y), this._ctx.clip();
        }
        this._drawing = !0;
        for (var g = this._drawFirst; g; g = g.next)
          i = g.layer, (!s || i._pxBounds && i._pxBounds.intersects(s)) && i._updatePath();
        this._drawing = !1, this._ctx.restore();
      },
      _updatePoly: function(i, s) {
        if (this._drawing) {
          var d, g, b, I, W = i._parts, le = W.length, de = this._ctx;
          if (le) {
            for (de.beginPath(), d = 0; d < le; d++) {
              for (g = 0, b = W[d].length; g < b; g++)
                I = W[d][g], de[g ? "lineTo" : "moveTo"](I.x, I.y);
              s && de.closePath();
            }
            this._fillStroke(de, i);
          }
        }
      },
      _updateCircle: function(i) {
        if (!(!this._drawing || i._empty())) {
          var s = i._point, d = this._ctx, g = Math.max(Math.round(i._radius), 1), b = (Math.max(Math.round(i._radiusY), 1) || g) / g;
          b !== 1 && (d.save(), d.scale(1, b)), d.beginPath(), d.arc(s.x, s.y / b, g, 0, Math.PI * 2, !1), b !== 1 && d.restore(), this._fillStroke(d, i);
        }
      },
      _fillStroke: function(i, s) {
        var d = s.options;
        d.fill && (i.globalAlpha = d.fillOpacity, i.fillStyle = d.fillColor || d.color, i.fill(d.fillRule || "evenodd")), d.stroke && d.weight !== 0 && (i.setLineDash && i.setLineDash(s.options && s.options._dashArray || []), i.globalAlpha = d.opacity, i.lineWidth = d.weight, i.strokeStyle = d.color, i.lineCap = d.lineCap, i.lineJoin = d.lineJoin, i.stroke());
      },
      // Canvas obviously doesn't have mouse events for individual drawn objects,
      // so we emulate that by calculating what's under the mouse on mousemove/click manually
      _onClick: function(i) {
        for (var s = this._map.mouseEventToLayerPoint(i), d, g, b = this._drawFirst; b; b = b.next)
          d = b.layer, d.options.interactive && d._containsPoint(s) && (!(i.type === "click" || i.type === "preclick") || !this._map._draggableMoved(d)) && (g = d);
        this._fireEvent(g ? [g] : !1, i);
      },
      _onMouseMove: function(i) {
        if (!(!this._map || this._map.dragging.moving() || this._map._animatingZoom)) {
          var s = this._map.mouseEventToLayerPoint(i);
          this._handleMouseHover(i, s);
        }
      },
      _handleMouseOut: function(i) {
        var s = this._hoveredLayer;
        s && (Gt(this._container, "leaflet-interactive"), this._fireEvent([s], i, "mouseout"), this._hoveredLayer = null, this._mouseHoverThrottled = !1);
      },
      _handleMouseHover: function(i, s) {
        if (!this._mouseHoverThrottled) {
          for (var d, g, b = this._drawFirst; b; b = b.next)
            d = b.layer, d.options.interactive && d._containsPoint(s) && (g = d);
          g !== this._hoveredLayer && (this._handleMouseOut(i), g && (it(this._container, "leaflet-interactive"), this._fireEvent([g], i, "mouseover"), this._hoveredLayer = g)), this._fireEvent(this._hoveredLayer ? [this._hoveredLayer] : !1, i), this._mouseHoverThrottled = !0, setTimeout(u(function() {
            this._mouseHoverThrottled = !1;
          }, this), 32);
        }
      },
      _fireEvent: function(i, s, d) {
        this._map._fireDOMEvent(s, d || s.type, i);
      },
      _bringToFront: function(i) {
        var s = i._order;
        if (s) {
          var d = s.next, g = s.prev;
          if (d)
            d.prev = g;
          else
            return;
          g ? g.next = d : d && (this._drawFirst = d), s.prev = this._drawLast, this._drawLast.next = s, s.next = null, this._drawLast = s, this._requestRedraw(i);
        }
      },
      _bringToBack: function(i) {
        var s = i._order;
        if (s) {
          var d = s.next, g = s.prev;
          if (g)
            g.next = d;
          else
            return;
          d ? d.prev = g : g && (this._drawLast = g), s.prev = null, s.next = this._drawFirst, this._drawFirst.prev = s, this._drawFirst = s, this._requestRedraw(i);
        }
      }
    });
    function Tc(i) {
      return Be.canvas ? new Ec(i) : null;
    }
    var Ya = function() {
      try {
        return document.namespaces.add("lvml", "urn:schemas-microsoft-com:vml"), function(i) {
          return document.createElement("<lvml:" + i + ' class="lvml">');
        };
      } catch {
      }
      return function(i) {
        return document.createElement("<" + i + ' xmlns="urn:schemas-microsoft.com:vml" class="lvml">');
      };
    }(), bv = {
      _initContainer: function() {
        this._container = yt("div", "leaflet-vml-container");
      },
      _update: function() {
        this._map._animatingZoom || (Li.prototype._update.call(this), this.fire("update"));
      },
      _initPath: function(i) {
        var s = i._container = Ya("shape");
        it(s, "leaflet-vml-shape " + (this.options.className || "")), s.coordsize = "1 1", i._path = Ya("path"), s.appendChild(i._path), this._updateStyle(i), this._layers[f(i)] = i;
      },
      _addPath: function(i) {
        var s = i._container;
        this._container.appendChild(s), i.options.interactive && i.addInteractiveTarget(s);
      },
      _removePath: function(i) {
        var s = i._container;
        jt(s), i.removeInteractiveTarget(s), delete this._layers[f(i)];
      },
      _updateStyle: function(i) {
        var s = i._stroke, d = i._fill, g = i.options, b = i._container;
        b.stroked = !!g.stroke, b.filled = !!g.fill, g.stroke ? (s || (s = i._stroke = Ya("stroke")), b.appendChild(s), s.weight = g.weight + "px", s.color = g.color, s.opacity = g.opacity, g.dashArray ? s.dashStyle = A(g.dashArray) ? g.dashArray.join(" ") : g.dashArray.replace(/( *, *)/g, " ") : s.dashStyle = "", s.endcap = g.lineCap.replace("butt", "flat"), s.joinstyle = g.lineJoin) : s && (b.removeChild(s), i._stroke = null), g.fill ? (d || (d = i._fill = Ya("fill")), b.appendChild(d), d.color = g.fillColor || g.color, d.opacity = g.fillOpacity) : d && (b.removeChild(d), i._fill = null);
      },
      _updateCircle: function(i) {
        var s = i._point.round(), d = Math.round(i._radius), g = Math.round(i._radiusY || d);
        this._setPath(i, i._empty() ? "M0 0" : "AL " + s.x + "," + s.y + " " + d + "," + g + " 0," + 65535 * 360);
      },
      _setPath: function(i, s) {
        i._path.v = s;
      },
      _bringToFront: function(i) {
        Wi(i._container);
      },
      _bringToBack: function(i) {
        bi(i._container);
      }
    }, Zo = Be.vml ? Ya : bn, Ha = Li.extend({
      _initContainer: function() {
        this._container = Zo("svg"), this._container.setAttribute("pointer-events", "none"), this._rootGroup = Zo("g"), this._container.appendChild(this._rootGroup);
      },
      _destroyContainer: function() {
        jt(this._container), F(this._container), delete this._container, delete this._rootGroup, delete this._svgSize;
      },
      _update: function() {
        if (!(this._map._animatingZoom && this._bounds)) {
          Li.prototype._update.call(this);
          var i = this._bounds, s = i.getSize(), d = this._container;
          (!this._svgSize || !this._svgSize.equals(s)) && (this._svgSize = s, d.setAttribute("width", s.x), d.setAttribute("height", s.y)), Vt(d, i.min), d.setAttribute("viewBox", [i.min.x, i.min.y, s.x, s.y].join(" ")), this.fire("update");
        }
      },
      // methods below are called by vector layers implementations
      _initPath: function(i) {
        var s = i._path = Zo("path");
        i.options.className && it(s, i.options.className), i.options.interactive && it(s, "leaflet-interactive"), this._updateStyle(i), this._layers[f(i)] = i;
      },
      _addPath: function(i) {
        this._rootGroup || this._initContainer(), this._rootGroup.appendChild(i._path), i.addInteractiveTarget(i._path);
      },
      _removePath: function(i) {
        jt(i._path), i.removeInteractiveTarget(i._path), delete this._layers[f(i)];
      },
      _updatePath: function(i) {
        i._project(), i._update();
      },
      _updateStyle: function(i) {
        var s = i._path, d = i.options;
        s && (d.stroke ? (s.setAttribute("stroke", d.color), s.setAttribute("stroke-opacity", d.opacity), s.setAttribute("stroke-width", d.weight), s.setAttribute("stroke-linecap", d.lineCap), s.setAttribute("stroke-linejoin", d.lineJoin), d.dashArray ? s.setAttribute("stroke-dasharray", d.dashArray) : s.removeAttribute("stroke-dasharray"), d.dashOffset ? s.setAttribute("stroke-dashoffset", d.dashOffset) : s.removeAttribute("stroke-dashoffset")) : s.setAttribute("stroke", "none"), d.fill ? (s.setAttribute("fill", d.fillColor || d.color), s.setAttribute("fill-opacity", d.fillOpacity), s.setAttribute("fill-rule", d.fillRule || "evenodd")) : s.setAttribute("fill", "none"));
      },
      _updatePoly: function(i, s) {
        this._setPath(i, qt(i._parts, s));
      },
      _updateCircle: function(i) {
        var s = i._point, d = Math.max(Math.round(i._radius), 1), g = Math.max(Math.round(i._radiusY), 1) || d, b = "a" + d + "," + g + " 0 1,0 ", I = i._empty() ? "M0 0" : "M" + (s.x - d) + "," + s.y + b + d * 2 + ",0 " + b + -d * 2 + ",0 ";
        this._setPath(i, I);
      },
      _setPath: function(i, s) {
        i._path.setAttribute("d", s);
      },
      // SVG does not have the concept of zIndex so we resort to changing the DOM order of elements
      _bringToFront: function(i) {
        Wi(i._path);
      },
      _bringToBack: function(i) {
        bi(i._path);
      }
    });
    Be.vml && Ha.include(bv);
    function Dc(i) {
      return Be.svg || Be.vml ? new Ha(i) : null;
    }
    st.include({
      // @namespace Map; @method getRenderer(layer: Path): Renderer
      // Returns the instance of `Renderer` that should be used to render the given
      // `Path`. It will ensure that the `renderer` options of the map and paths
      // are respected, and that the renderers do exist on the map.
      getRenderer: function(i) {
        var s = i.options.renderer || this._getPaneRenderer(i.options.pane) || this.options.renderer || this._renderer;
        return s || (s = this._renderer = this._createRenderer()), this.hasLayer(s) || this.addLayer(s), s;
      },
      _getPaneRenderer: function(i) {
        if (i === "overlayPane" || i === void 0)
          return !1;
        var s = this._paneRenderers[i];
        return s === void 0 && (s = this._createRenderer({ pane: i }), this._paneRenderers[i] = s), s;
      },
      _createRenderer: function(i) {
        return this.options.preferCanvas && Tc(i) || Dc(i);
      }
    });
    var Ic = Kr.extend({
      initialize: function(i, s) {
        Kr.prototype.initialize.call(this, this._boundsToLatLngs(i), s);
      },
      // @method setBounds(latLngBounds: LatLngBounds): this
      // Redraws the rectangle with the passed bounds.
      setBounds: function(i) {
        return this.setLatLngs(this._boundsToLatLngs(i));
      },
      _boundsToLatLngs: function(i) {
        return i = Ve(i), [
          i.getSouthWest(),
          i.getNorthWest(),
          i.getNorthEast(),
          i.getSouthEast()
        ];
      }
    });
    function wv(i, s) {
      return new Ic(i, s);
    }
    Ha.create = Zo, Ha.pointsToPath = qt, xi.geometryToLayer = zo, xi.coordsToLatLng = wl, xi.coordsToLatLngs = Fo, xi.latLngToCoords = kl, xi.latLngsToCoords = jo, xi.getFeature = Jr, xi.asFeature = Vo, st.mergeOptions({
      // @option boxZoom: Boolean = true
      // Whether the map can be zoomed to a rectangular area specified by
      // dragging the mouse while pressing the shift key.
      boxZoom: !0
    });
    var Ac = ci.extend({
      initialize: function(i) {
        this._map = i, this._container = i._container, this._pane = i._panes.overlayPane, this._resetStateTimeout = 0, i.on("unload", this._destroy, this);
      },
      addHooks: function() {
        w(this._container, "mousedown", this._onMouseDown, this);
      },
      removeHooks: function() {
        F(this._container, "mousedown", this._onMouseDown, this);
      },
      moved: function() {
        return this._moved;
      },
      _destroy: function() {
        jt(this._pane), delete this._pane;
      },
      _resetState: function() {
        this._resetStateTimeout = 0, this._moved = !1;
      },
      _clearDeferredResetState: function() {
        this._resetStateTimeout !== 0 && (clearTimeout(this._resetStateTimeout), this._resetStateTimeout = 0);
      },
      _onMouseDown: function(i) {
        if (!i.shiftKey || i.which !== 1 && i.button !== 1)
          return !1;
        this._clearDeferredResetState(), this._resetState(), fr(), gr(), this._startPoint = this._map.mouseEventToContainerPoint(i), w(document, {
          contextmenu: qe,
          mousemove: this._onMouseMove,
          mouseup: this._onMouseUp,
          keydown: this._onKeyDown
        }, this);
      },
      _onMouseMove: function(i) {
        this._moved || (this._moved = !0, this._box = yt("div", "leaflet-zoom-box", this._container), it(this._container, "leaflet-crosshair"), this._map.fire("boxzoomstart")), this._point = this._map.mouseEventToContainerPoint(i);
        var s = new Fe(this._point, this._startPoint), d = s.getSize();
        Vt(this._box, s.min), this._box.style.width = d.x + "px", this._box.style.height = d.y + "px";
      },
      _finish: function() {
        this._moved && (jt(this._box), Gt(this._container, "leaflet-crosshair")), pr(), vr(), F(document, {
          contextmenu: qe,
          mousemove: this._onMouseMove,
          mouseup: this._onMouseUp,
          keydown: this._onKeyDown
        }, this);
      },
      _onMouseUp: function(i) {
        if (!(i.which !== 1 && i.button !== 1) && (this._finish(), !!this._moved)) {
          this._clearDeferredResetState(), this._resetStateTimeout = setTimeout(u(this._resetState, this), 0);
          var s = new nt(
            this._map.containerPointToLatLng(this._startPoint),
            this._map.containerPointToLatLng(this._point)
          );
          this._map.fitBounds(s).fire("boxzoomend", { boxZoomBounds: s });
        }
      },
      _onKeyDown: function(i) {
        i.keyCode === 27 && (this._finish(), this._clearDeferredResetState(), this._resetState());
      }
    });
    st.addInitHook("addHandler", "boxZoom", Ac), st.mergeOptions({
      // @option doubleClickZoom: Boolean|String = true
      // Whether the map can be zoomed in by double clicking on it and
      // zoomed out by double clicking while holding shift. If passed
      // `'center'`, double-click zoom will zoom to the center of the
      //  view regardless of where the mouse was.
      doubleClickZoom: !0
    });
    var Rc = ci.extend({
      addHooks: function() {
        this._map.on("dblclick", this._onDoubleClick, this);
      },
      removeHooks: function() {
        this._map.off("dblclick", this._onDoubleClick, this);
      },
      _onDoubleClick: function(i) {
        var s = this._map, d = s.getZoom(), g = s.options.zoomDelta, b = i.originalEvent.shiftKey ? d - g : d + g;
        s.options.doubleClickZoom === "center" ? s.setZoom(b) : s.setZoomAround(i.containerPoint, b);
      }
    });
    st.addInitHook("addHandler", "doubleClickZoom", Rc), st.mergeOptions({
      // @option dragging: Boolean = true
      // Whether the map is draggable with mouse/touch or not.
      dragging: !0,
      // @section Panning Inertia Options
      // @option inertia: Boolean = *
      // If enabled, panning of the map will have an inertia effect where
      // the map builds momentum while dragging and continues moving in
      // the same direction for some time. Feels especially nice on touch
      // devices. Enabled by default.
      inertia: !0,
      // @option inertiaDeceleration: Number = 3000
      // The rate with which the inertial movement slows down, in pixels/second².
      inertiaDeceleration: 3400,
      // px/s^2
      // @option inertiaMaxSpeed: Number = Infinity
      // Max speed of the inertial movement, in pixels/second.
      inertiaMaxSpeed: 1 / 0,
      // px/s
      // @option easeLinearity: Number = 0.2
      easeLinearity: 0.2,
      // TODO refactor, move to CRS
      // @option worldCopyJump: Boolean = false
      // With this option enabled, the map tracks when you pan to another "copy"
      // of the world and seamlessly jumps to the original one so that all overlays
      // like markers and vector layers are still visible.
      worldCopyJump: !1,
      // @option maxBoundsViscosity: Number = 0.0
      // If `maxBounds` is set, this option will control how solid the bounds
      // are when dragging the map around. The default value of `0.0` allows the
      // user to drag outside the bounds at normal speed, higher values will
      // slow down map dragging outside bounds, and `1.0` makes the bounds fully
      // solid, preventing the user from dragging outside the bounds.
      maxBoundsViscosity: 0
    });
    var Bc = ci.extend({
      addHooks: function() {
        if (!this._draggable) {
          var i = this._map;
          this._draggable = new Gi(i._mapPane, i._container), this._draggable.on({
            dragstart: this._onDragStart,
            drag: this._onDrag,
            dragend: this._onDragEnd
          }, this), this._draggable.on("predrag", this._onPreDragLimit, this), i.options.worldCopyJump && (this._draggable.on("predrag", this._onPreDragWrap, this), i.on("zoomend", this._onZoomEnd, this), i.whenReady(this._onZoomEnd, this));
        }
        it(this._map._container, "leaflet-grab leaflet-touch-drag"), this._draggable.enable(), this._positions = [], this._times = [];
      },
      removeHooks: function() {
        Gt(this._map._container, "leaflet-grab"), Gt(this._map._container, "leaflet-touch-drag"), this._draggable.disable();
      },
      moved: function() {
        return this._draggable && this._draggable._moved;
      },
      moving: function() {
        return this._draggable && this._draggable._moving;
      },
      _onDragStart: function() {
        var i = this._map;
        if (i._stop(), this._map.options.maxBounds && this._map.options.maxBoundsViscosity) {
          var s = Ve(this._map.options.maxBounds);
          this._offsetLimit = Pe(
            this._map.latLngToContainerPoint(s.getNorthWest()).multiplyBy(-1),
            this._map.latLngToContainerPoint(s.getSouthEast()).multiplyBy(-1).add(this._map.getSize())
          ), this._viscosity = Math.min(1, Math.max(0, this._map.options.maxBoundsViscosity));
        } else
          this._offsetLimit = null;
        i.fire("movestart").fire("dragstart"), i.options.inertia && (this._positions = [], this._times = []);
      },
      _onDrag: function(i) {
        if (this._map.options.inertia) {
          var s = this._lastTime = +/* @__PURE__ */ new Date(), d = this._lastPos = this._draggable._absPos || this._draggable._newPos;
          this._positions.push(d), this._times.push(s), this._prunePositions(s);
        }
        this._map.fire("move", i).fire("drag", i);
      },
      _prunePositions: function(i) {
        for (; this._positions.length > 1 && i - this._times[0] > 50; )
          this._positions.shift(), this._times.shift();
      },
      _onZoomEnd: function() {
        var i = this._map.getSize().divideBy(2), s = this._map.latLngToLayerPoint([0, 0]);
        this._initialWorldOffset = s.subtract(i).x, this._worldWidth = this._map.getPixelWorldBounds().getSize().x;
      },
      _viscousLimit: function(i, s) {
        return i - (i - s) * this._viscosity;
      },
      _onPreDragLimit: function() {
        if (!(!this._viscosity || !this._offsetLimit)) {
          var i = this._draggable._newPos.subtract(this._draggable._startPos), s = this._offsetLimit;
          i.x < s.min.x && (i.x = this._viscousLimit(i.x, s.min.x)), i.y < s.min.y && (i.y = this._viscousLimit(i.y, s.min.y)), i.x > s.max.x && (i.x = this._viscousLimit(i.x, s.max.x)), i.y > s.max.y && (i.y = this._viscousLimit(i.y, s.max.y)), this._draggable._newPos = this._draggable._startPos.add(i);
        }
      },
      _onPreDragWrap: function() {
        var i = this._worldWidth, s = Math.round(i / 2), d = this._initialWorldOffset, g = this._draggable._newPos.x, b = (g - s + d) % i + s - d, I = (g + s + d) % i - s - d, W = Math.abs(b + d) < Math.abs(I + d) ? b : I;
        this._draggable._absPos = this._draggable._newPos.clone(), this._draggable._newPos.x = W;
      },
      _onDragEnd: function(i) {
        var s = this._map, d = s.options, g = !d.inertia || i.noInertia || this._times.length < 2;
        if (s.fire("dragend", i), g)
          s.fire("moveend");
        else {
          this._prunePositions(+/* @__PURE__ */ new Date());
          var b = this._lastPos.subtract(this._positions[0]), I = (this._lastTime - this._times[0]) / 1e3, W = d.easeLinearity, le = b.multiplyBy(W / I), de = le.distanceTo([0, 0]), Le = Math.min(d.inertiaMaxSpeed, de), ze = le.multiplyBy(Le / de), Ke = Le / (d.inertiaDeceleration * W), dt = ze.multiplyBy(-Ke / 2).round();
          !dt.x && !dt.y ? s.fire("moveend") : (dt = s._limitOffset(dt, s.options.maxBounds), ae(function() {
            s.panBy(dt, {
              duration: Ke,
              easeLinearity: W,
              noMoveStart: !0,
              animate: !0
            });
          }));
        }
      }
    });
    st.addInitHook("addHandler", "dragging", Bc), st.mergeOptions({
      // @option keyboard: Boolean = true
      // Makes the map focusable and allows users to navigate the map with keyboard
      // arrows and `+`/`-` keys.
      keyboard: !0,
      // @option keyboardPanDelta: Number = 80
      // Amount of pixels to pan when pressing an arrow key.
      keyboardPanDelta: 80
    });
    var $c = ci.extend({
      keyCodes: {
        left: [37],
        right: [39],
        down: [40],
        up: [38],
        zoomIn: [187, 107, 61, 171],
        zoomOut: [189, 109, 54, 173]
      },
      initialize: function(i) {
        this._map = i, this._setPanDelta(i.options.keyboardPanDelta), this._setZoomDelta(i.options.zoomDelta);
      },
      addHooks: function() {
        var i = this._map._container;
        i.tabIndex <= 0 && (i.tabIndex = "0"), w(i, {
          focus: this._onFocus,
          blur: this._onBlur,
          mousedown: this._onMouseDown
        }, this), this._map.on({
          focus: this._addHooks,
          blur: this._removeHooks
        }, this);
      },
      removeHooks: function() {
        this._removeHooks(), F(this._map._container, {
          focus: this._onFocus,
          blur: this._onBlur,
          mousedown: this._onMouseDown
        }, this), this._map.off({
          focus: this._addHooks,
          blur: this._removeHooks
        }, this);
      },
      _onMouseDown: function() {
        if (!this._focused) {
          var i = document.body, s = document.documentElement, d = i.scrollTop || s.scrollTop, g = i.scrollLeft || s.scrollLeft;
          this._map._container.focus(), window.scrollTo(g, d);
        }
      },
      _onFocus: function() {
        this._focused = !0, this._map.fire("focus");
      },
      _onBlur: function() {
        this._focused = !1, this._map.fire("blur");
      },
      _setPanDelta: function(i) {
        var s = this._panKeys = {}, d = this.keyCodes, g, b;
        for (g = 0, b = d.left.length; g < b; g++)
          s[d.left[g]] = [-1 * i, 0];
        for (g = 0, b = d.right.length; g < b; g++)
          s[d.right[g]] = [i, 0];
        for (g = 0, b = d.down.length; g < b; g++)
          s[d.down[g]] = [0, i];
        for (g = 0, b = d.up.length; g < b; g++)
          s[d.up[g]] = [0, -1 * i];
      },
      _setZoomDelta: function(i) {
        var s = this._zoomKeys = {}, d = this.keyCodes, g, b;
        for (g = 0, b = d.zoomIn.length; g < b; g++)
          s[d.zoomIn[g]] = i;
        for (g = 0, b = d.zoomOut.length; g < b; g++)
          s[d.zoomOut[g]] = -i;
      },
      _addHooks: function() {
        w(document, "keydown", this._onKeyDown, this);
      },
      _removeHooks: function() {
        F(document, "keydown", this._onKeyDown, this);
      },
      _onKeyDown: function(i) {
        if (!(i.altKey || i.ctrlKey || i.metaKey)) {
          var s = i.keyCode, d = this._map, g;
          if (s in this._panKeys) {
            if (!d._panAnim || !d._panAnim._inProgress)
              if (g = this._panKeys[s], i.shiftKey && (g = ue(g).multiplyBy(3)), d.options.maxBounds && (g = d._limitOffset(ue(g), d.options.maxBounds)), d.options.worldCopyJump) {
                var b = d.wrapLatLng(d.unproject(d.project(d.getCenter()).add(g)));
                d.panTo(b);
              } else
                d.panBy(g);
          } else if (s in this._zoomKeys)
            d.setZoom(d.getZoom() + (i.shiftKey ? 3 : 1) * this._zoomKeys[s]);
          else if (s === 27 && d._popup && d._popup.options.closeOnEscapeKey)
            d.closePopup();
          else
            return;
          qe(i);
        }
      }
    });
    st.addInitHook("addHandler", "keyboard", $c), st.mergeOptions({
      // @section Mouse wheel options
      // @option scrollWheelZoom: Boolean|String = true
      // Whether the map can be zoomed by using the mouse wheel. If passed `'center'`,
      // it will zoom to the center of the view regardless of where the mouse was.
      scrollWheelZoom: !0,
      // @option wheelDebounceTime: Number = 40
      // Limits the rate at which a wheel can fire (in milliseconds). By default
      // user can't zoom via wheel more often than once per 40 ms.
      wheelDebounceTime: 40,
      // @option wheelPxPerZoomLevel: Number = 60
      // How many scroll pixels (as reported by [L.DomEvent.getWheelDelta](#domevent-getwheeldelta))
      // mean a change of one full zoom level. Smaller values will make wheel-zooming
      // faster (and vice versa).
      wheelPxPerZoomLevel: 60
    });
    var Nc = ci.extend({
      addHooks: function() {
        w(this._map._container, "wheel", this._onWheelScroll, this), this._delta = 0;
      },
      removeHooks: function() {
        F(this._map._container, "wheel", this._onWheelScroll, this);
      },
      _onWheelScroll: function(i) {
        var s = Yt(i), d = this._map.options.wheelDebounceTime;
        this._delta += s, this._lastMousePos = this._map.mouseEventToContainerPoint(i), this._startTime || (this._startTime = +/* @__PURE__ */ new Date());
        var g = Math.max(d - (+/* @__PURE__ */ new Date() - this._startTime), 0);
        clearTimeout(this._timer), this._timer = setTimeout(u(this._performZoom, this), g), qe(i);
      },
      _performZoom: function() {
        var i = this._map, s = i.getZoom(), d = this._map.options.zoomSnap || 0;
        i._stop();
        var g = this._delta / (this._map.options.wheelPxPerZoomLevel * 4), b = 4 * Math.log(2 / (1 + Math.exp(-Math.abs(g)))) / Math.LN2, I = d ? Math.ceil(b / d) * d : b, W = i._limitZoom(s + (this._delta > 0 ? I : -I)) - s;
        this._delta = 0, this._startTime = null, W && (i.options.scrollWheelZoom === "center" ? i.setZoom(s + W) : i.setZoomAround(this._lastMousePos, s + W));
      }
    });
    st.addInitHook("addHandler", "scrollWheelZoom", Nc);
    var kv = 600;
    st.mergeOptions({
      // @section Touch interaction options
      // @option tapHold: Boolean
      // Enables simulation of `contextmenu` event, default is `true` for mobile Safari.
      tapHold: Be.touchNative && Be.safari && Be.mobile,
      // @option tapTolerance: Number = 15
      // The max number of pixels a user can shift his finger during touch
      // for it to be considered a valid tap.
      tapTolerance: 15
    });
    var zc = ci.extend({
      addHooks: function() {
        w(this._map._container, "touchstart", this._onDown, this);
      },
      removeHooks: function() {
        F(this._map._container, "touchstart", this._onDown, this);
      },
      _onDown: function(i) {
        if (clearTimeout(this._holdTimeout), i.touches.length === 1) {
          var s = i.touches[0];
          this._startPos = this._newPos = new pe(s.clientX, s.clientY), this._holdTimeout = setTimeout(u(function() {
            this._cancel(), this._isTapValid() && (w(document, "touchend", Ie), w(document, "touchend touchcancel", this._cancelClickPrevent), this._simulateEvent("contextmenu", s));
          }, this), kv), w(document, "touchend touchcancel contextmenu", this._cancel, this), w(document, "touchmove", this._onMove, this);
        }
      },
      _cancelClickPrevent: function i() {
        F(document, "touchend", Ie), F(document, "touchend touchcancel", i);
      },
      _cancel: function() {
        clearTimeout(this._holdTimeout), F(document, "touchend touchcancel contextmenu", this._cancel, this), F(document, "touchmove", this._onMove, this);
      },
      _onMove: function(i) {
        var s = i.touches[0];
        this._newPos = new pe(s.clientX, s.clientY);
      },
      _isTapValid: function() {
        return this._newPos.distanceTo(this._startPos) <= this._map.options.tapTolerance;
      },
      _simulateEvent: function(i, s) {
        var d = new MouseEvent(i, {
          bubbles: !0,
          cancelable: !0,
          view: window,
          // detail: 1,
          screenX: s.screenX,
          screenY: s.screenY,
          clientX: s.clientX,
          clientY: s.clientY
          // button: 2,
          // buttons: 2
        });
        d._simulated = !0, s.target.dispatchEvent(d);
      }
    });
    st.addInitHook("addHandler", "tapHold", zc), st.mergeOptions({
      // @section Touch interaction options
      // @option touchZoom: Boolean|String = *
      // Whether the map can be zoomed by touch-dragging with two fingers. If
      // passed `'center'`, it will zoom to the center of the view regardless of
      // where the touch events (fingers) were. Enabled for touch-capable web
      // browsers.
      touchZoom: Be.touch,
      // @option bounceAtZoomLimits: Boolean = true
      // Set it to false if you don't want the map to zoom beyond min/max zoom
      // and then bounce back when pinch-zooming.
      bounceAtZoomLimits: !0
    });
    var Fc = ci.extend({
      addHooks: function() {
        it(this._map._container, "leaflet-touch-zoom"), w(this._map._container, "touchstart", this._onTouchStart, this);
      },
      removeHooks: function() {
        Gt(this._map._container, "leaflet-touch-zoom"), F(this._map._container, "touchstart", this._onTouchStart, this);
      },
      _onTouchStart: function(i) {
        var s = this._map;
        if (!(!i.touches || i.touches.length !== 2 || s._animatingZoom || this._zooming)) {
          var d = s.mouseEventToContainerPoint(i.touches[0]), g = s.mouseEventToContainerPoint(i.touches[1]);
          this._centerPoint = s.getSize()._divideBy(2), this._startLatLng = s.containerPointToLatLng(this._centerPoint), s.options.touchZoom !== "center" && (this._pinchStartLatLng = s.containerPointToLatLng(d.add(g)._divideBy(2))), this._startDist = d.distanceTo(g), this._startZoom = s.getZoom(), this._moved = !1, this._zooming = !0, s._stop(), w(document, "touchmove", this._onTouchMove, this), w(document, "touchend touchcancel", this._onTouchEnd, this), Ie(i);
        }
      },
      _onTouchMove: function(i) {
        if (!(!i.touches || i.touches.length !== 2 || !this._zooming)) {
          var s = this._map, d = s.mouseEventToContainerPoint(i.touches[0]), g = s.mouseEventToContainerPoint(i.touches[1]), b = d.distanceTo(g) / this._startDist;
          if (this._zoom = s.getScaleZoom(b, this._startZoom), !s.options.bounceAtZoomLimits && (this._zoom < s.getMinZoom() && b < 1 || this._zoom > s.getMaxZoom() && b > 1) && (this._zoom = s._limitZoom(this._zoom)), s.options.touchZoom === "center") {
            if (this._center = this._startLatLng, b === 1)
              return;
          } else {
            var I = d._add(g)._divideBy(2)._subtract(this._centerPoint);
            if (b === 1 && I.x === 0 && I.y === 0)
              return;
            this._center = s.unproject(s.project(this._pinchStartLatLng, this._zoom).subtract(I), this._zoom);
          }
          this._moved || (s._moveStart(!0, !1), this._moved = !0), ne(this._animRequest);
          var W = u(s._move, s, this._center, this._zoom, { pinch: !0, round: !1 }, void 0);
          this._animRequest = ae(W, this, !0), Ie(i);
        }
      },
      _onTouchEnd: function() {
        if (!this._moved || !this._zooming) {
          this._zooming = !1;
          return;
        }
        this._zooming = !1, ne(this._animRequest), F(document, "touchmove", this._onTouchMove, this), F(document, "touchend touchcancel", this._onTouchEnd, this), this._map.options.zoomAnimation ? this._map._animateZoom(this._center, this._map._limitZoom(this._zoom), !0, this._map.options.zoomSnap) : this._map._resetView(this._center, this._map._limitZoom(this._zoom));
      }
    });
    st.addInitHook("addHandler", "touchZoom", Fc), st.BoxZoom = Ac, st.DoubleClickZoom = Rc, st.Drag = Bc, st.Keyboard = $c, st.ScrollWheelZoom = Nc, st.TapHold = zc, st.TouchZoom = Fc, n.Bounds = Fe, n.Browser = Be, n.CRS = ft, n.Canvas = Ec, n.Circle = bl, n.CircleMarker = No, n.Class = re, n.Control = wn, n.DivIcon = Pc, n.DivOverlay = hi, n.DomEvent = mn, n.DomUtil = _, n.Draggable = Gi, n.Evented = Ae, n.FeatureGroup = wi, n.GeoJSON = xi, n.GridLayer = Va, n.Handler = ci, n.Icon = qr, n.ImageOverlay = Yo, n.LatLng = Ze, n.LatLngBounds = nt, n.Layer = Gn, n.LayerGroup = Gr, n.LineUtil = Qg, n.Map = st, n.Marker = $o, n.Mixin = Wg, n.Path = qi, n.Point = pe, n.PolyUtil = Gg, n.Polygon = Kr, n.Polyline = ki, n.Popup = Ho, n.PosAnimation = Wr, n.Projection = ev, n.Rectangle = Ic, n.Renderer = Li, n.SVG = Ha, n.SVGOverlay = Sc, n.TileLayer = Xr, n.Tooltip = Uo, n.Transformation = on, n.Util = se, n.VideoOverlay = Mc, n.bind = u, n.bounds = Pe, n.canvas = Tc, n.circle = lv, n.circleMarker = sv, n.control = En, n.divIcon = vv, n.extend = a, n.featureGroup = rv, n.geoJSON = Lc, n.geoJson = hv, n.gridLayer = _v, n.icon = av, n.imageOverlay = dv, n.latLng = Ne, n.latLngBounds = Ve, n.layerGroup = iv, n.map = Io, n.marker = ov, n.point = ue, n.polygon = cv, n.polyline = uv, n.popup = mv, n.rectangle = wv, n.setOptions = O, n.stamp = f, n.svg = Dc, n.svgOverlay = pv, n.tileLayer = Cc, n.tooltip = gv, n.transformation = Dt, n.version = r, n.videoOverlay = fv;
    var xv = window.L;
    n.noConflict = function() {
      return window.L = xv, this;
    }, window.L = n;
  });
})(Ul, Ul.exports);
var oy = Ul.exports;
const qn = /* @__PURE__ */ Ff(oy);
(() => {
  var e = { 9705: (r, a, l) => {
    var u = l(1540);
    function h(f) {
      var m = [1 / 0, 1 / 0, -1 / 0, -1 / 0];
      return u.coordEach(f, function(v) {
        m[0] > v[0] && (m[0] = v[0]), m[1] > v[1] && (m[1] = v[1]), m[2] < v[0] && (m[2] = v[0]), m[3] < v[1] && (m[3] = v[1]);
      }), m;
    }
    h.default = h, a.Z = h;
  }, 4102: (r, a) => {
    function l(C, T, A) {
      A === void 0 && (A = {});
      var P = { type: "Feature" };
      return (A.id === 0 || A.id) && (P.id = A.id), A.bbox && (P.bbox = A.bbox), P.properties = T || {}, P.geometry = C, P;
    }
    function u(C, T, A) {
      if (A === void 0 && (A = {}), !C)
        throw new Error("coordinates is required");
      if (!Array.isArray(C))
        throw new Error("coordinates must be an Array");
      if (C.length < 2)
        throw new Error("coordinates must be at least 2 numbers long");
      if (!R(C[0]) || !R(C[1]))
        throw new Error("coordinates must contain numbers");
      return l({ type: "Point", coordinates: C }, T, A);
    }
    function h(C, T, A) {
      A === void 0 && (A = {});
      for (var P = 0, D = C; P < D.length; P++) {
        var $ = D[P];
        if ($.length < 4)
          throw new Error("Each LinearRing of a Polygon must have 4 or more Positions.");
        for (var Y = 0; Y < $[$.length - 1].length; Y++)
          if ($[$.length - 1][Y] !== $[0][Y])
            throw new Error("First and last Position are not equivalent.");
      }
      return l({ type: "Polygon", coordinates: C }, T, A);
    }
    function f(C, T, A) {
      if (A === void 0 && (A = {}), C.length < 2)
        throw new Error("coordinates must be an array of two or more positions");
      return l({ type: "LineString", coordinates: C }, T, A);
    }
    function m(C, T) {
      T === void 0 && (T = {});
      var A = { type: "FeatureCollection" };
      return T.id && (A.id = T.id), T.bbox && (A.bbox = T.bbox), A.features = C, A;
    }
    function v(C, T, A) {
      return A === void 0 && (A = {}), l({ type: "MultiLineString", coordinates: C }, T, A);
    }
    function y(C, T, A) {
      return A === void 0 && (A = {}), l({ type: "MultiPoint", coordinates: C }, T, A);
    }
    function k(C, T, A) {
      return A === void 0 && (A = {}), l({ type: "MultiPolygon", coordinates: C }, T, A);
    }
    function x(C, T) {
      T === void 0 && (T = "kilometers");
      var A = a.factors[T];
      if (!A)
        throw new Error(T + " units is invalid");
      return C * A;
    }
    function M(C, T) {
      T === void 0 && (T = "kilometers");
      var A = a.factors[T];
      if (!A)
        throw new Error(T + " units is invalid");
      return C / A;
    }
    function O(C) {
      return 180 * (C % (2 * Math.PI)) / Math.PI;
    }
    function R(C) {
      return !isNaN(C) && C !== null && !Array.isArray(C);
    }
    Object.defineProperty(a, "__esModule", { value: !0 }), a.earthRadius = 63710088e-1, a.factors = { centimeters: 100 * a.earthRadius, centimetres: 100 * a.earthRadius, degrees: a.earthRadius / 111325, feet: 3.28084 * a.earthRadius, inches: 39.37 * a.earthRadius, kilometers: a.earthRadius / 1e3, kilometres: a.earthRadius / 1e3, meters: a.earthRadius, metres: a.earthRadius, miles: a.earthRadius / 1609.344, millimeters: 1e3 * a.earthRadius, millimetres: 1e3 * a.earthRadius, nauticalmiles: a.earthRadius / 1852, radians: 1, yards: 1.0936 * a.earthRadius }, a.unitsFactors = { centimeters: 100, centimetres: 100, degrees: 8982708286548395e-21, feet: 3.28084, inches: 39.37, kilometers: 1e-3, kilometres: 1e-3, meters: 1, metres: 1, miles: 6213711922373339e-19, millimeters: 1e3, millimetres: 1e3, nauticalmiles: 5399568034557236e-19, radians: 1 / a.earthRadius, yards: 1.0936133 }, a.areaFactors = { acres: 247105e-9, centimeters: 1e4, centimetres: 1e4, feet: 10.763910417, hectares: 1e-4, inches: 1550.003100006, kilometers: 1e-6, kilometres: 1e-6, meters: 1, metres: 1, miles: 386e-9, millimeters: 1e6, millimetres: 1e6, yards: 1.195990046 }, a.feature = l, a.geometry = function(C, T, A) {
      switch (C) {
        case "Point":
          return u(T).geometry;
        case "LineString":
          return f(T).geometry;
        case "Polygon":
          return h(T).geometry;
        case "MultiPoint":
          return y(T).geometry;
        case "MultiLineString":
          return v(T).geometry;
        case "MultiPolygon":
          return k(T).geometry;
        default:
          throw new Error(C + " is invalid");
      }
    }, a.point = u, a.points = function(C, T, A) {
      return A === void 0 && (A = {}), m(C.map(function(P) {
        return u(P, T);
      }), A);
    }, a.polygon = h, a.polygons = function(C, T, A) {
      return A === void 0 && (A = {}), m(C.map(function(P) {
        return h(P, T);
      }), A);
    }, a.lineString = f, a.lineStrings = function(C, T, A) {
      return A === void 0 && (A = {}), m(C.map(function(P) {
        return f(P, T);
      }), A);
    }, a.featureCollection = m, a.multiLineString = v, a.multiPoint = y, a.multiPolygon = k, a.geometryCollection = function(C, T, A) {
      return A === void 0 && (A = {}), l({ type: "GeometryCollection", geometries: C }, T, A);
    }, a.round = function(C, T) {
      if (T === void 0 && (T = 0), T && !(T >= 0))
        throw new Error("precision must be a positive number");
      var A = Math.pow(10, T || 0);
      return Math.round(C * A) / A;
    }, a.radiansToLength = x, a.lengthToRadians = M, a.lengthToDegrees = function(C, T) {
      return O(M(C, T));
    }, a.bearingToAzimuth = function(C) {
      var T = C % 360;
      return T < 0 && (T += 360), T;
    }, a.radiansToDegrees = O, a.degreesToRadians = function(C) {
      return C % 360 * Math.PI / 180;
    }, a.convertLength = function(C, T, A) {
      if (T === void 0 && (T = "kilometers"), A === void 0 && (A = "kilometers"), !(C >= 0))
        throw new Error("length must be a positive number");
      return x(M(C, T), A);
    }, a.convertArea = function(C, T, A) {
      if (T === void 0 && (T = "meters"), A === void 0 && (A = "kilometers"), !(C >= 0))
        throw new Error("area must be a positive number");
      var P = a.areaFactors[T];
      if (!P)
        throw new Error("invalid original units");
      var D = a.areaFactors[A];
      if (!D)
        throw new Error("invalid final units");
      return C / P * D;
    }, a.isNumber = R, a.isObject = function(C) {
      return !!C && C.constructor === Object;
    }, a.validateBBox = function(C) {
      if (!C)
        throw new Error("bbox is required");
      if (!Array.isArray(C))
        throw new Error("bbox must be an Array");
      if (C.length !== 4 && C.length !== 6)
        throw new Error("bbox must be an Array of 4 or 6 numbers");
      C.forEach(function(T) {
        if (!R(T))
          throw new Error("bbox must only contain numbers");
      });
    }, a.validateId = function(C) {
      if (!C)
        throw new Error("id is required");
      if (["string", "number"].indexOf(typeof C) === -1)
        throw new Error("id must be a number or a string");
    };
  }, 1540: (r, a, l) => {
    Object.defineProperty(a, "__esModule", { value: !0 });
    var u = l(4102);
    function h(M, O, R) {
      if (M !== null)
        for (var C, T, A, P, D, $, Y, G, ee = 0, X = 0, ae = M.type, ne = ae === "FeatureCollection", se = ae === "Feature", re = ne ? M.features.length : 1, Q = 0; Q < re; Q++) {
          D = (G = !!(Y = ne ? M.features[Q].geometry : se ? M.geometry : M) && Y.type === "GeometryCollection") ? Y.geometries.length : 1;
          for (var ke = 0; ke < D; ke++) {
            var Ae = 0, pe = 0;
            if ((P = G ? Y.geometries[ke] : Y) !== null) {
              $ = P.coordinates;
              var Ye = P.type;
              switch (ee = !R || Ye !== "Polygon" && Ye !== "MultiPolygon" ? 0 : 1, Ye) {
                case null:
                  break;
                case "Point":
                  if (O($, X, Q, Ae, pe) === !1)
                    return !1;
                  X++, Ae++;
                  break;
                case "LineString":
                case "MultiPoint":
                  for (C = 0; C < $.length; C++) {
                    if (O($[C], X, Q, Ae, pe) === !1)
                      return !1;
                    X++, Ye === "MultiPoint" && Ae++;
                  }
                  Ye === "LineString" && Ae++;
                  break;
                case "Polygon":
                case "MultiLineString":
                  for (C = 0; C < $.length; C++) {
                    for (T = 0; T < $[C].length - ee; T++) {
                      if (O($[C][T], X, Q, Ae, pe) === !1)
                        return !1;
                      X++;
                    }
                    Ye === "MultiLineString" && Ae++, Ye === "Polygon" && pe++;
                  }
                  Ye === "Polygon" && Ae++;
                  break;
                case "MultiPolygon":
                  for (C = 0; C < $.length; C++) {
                    for (pe = 0, T = 0; T < $[C].length; T++) {
                      for (A = 0; A < $[C][T].length - ee; A++) {
                        if (O($[C][T][A], X, Q, Ae, pe) === !1)
                          return !1;
                        X++;
                      }
                      pe++;
                    }
                    Ae++;
                  }
                  break;
                case "GeometryCollection":
                  for (C = 0; C < P.geometries.length; C++)
                    if (h(P.geometries[C], O, R) === !1)
                      return !1;
                  break;
                default:
                  throw new Error("Unknown Geometry Type");
              }
            }
          }
        }
    }
    function f(M, O) {
      var R;
      switch (M.type) {
        case "FeatureCollection":
          for (R = 0; R < M.features.length && O(M.features[R].properties, R) !== !1; R++)
            ;
          break;
        case "Feature":
          O(M.properties, 0);
      }
    }
    function m(M, O) {
      if (M.type === "Feature")
        O(M, 0);
      else if (M.type === "FeatureCollection")
        for (var R = 0; R < M.features.length && O(M.features[R], R) !== !1; R++)
          ;
    }
    function v(M, O) {
      var R, C, T, A, P, D, $, Y, G, ee, X = 0, ae = M.type === "FeatureCollection", ne = M.type === "Feature", se = ae ? M.features.length : 1;
      for (R = 0; R < se; R++) {
        for (D = ae ? M.features[R].geometry : ne ? M.geometry : M, Y = ae ? M.features[R].properties : ne ? M.properties : {}, G = ae ? M.features[R].bbox : ne ? M.bbox : void 0, ee = ae ? M.features[R].id : ne ? M.id : void 0, P = ($ = !!D && D.type === "GeometryCollection") ? D.geometries.length : 1, T = 0; T < P; T++)
          if ((A = $ ? D.geometries[T] : D) !== null)
            switch (A.type) {
              case "Point":
              case "LineString":
              case "MultiPoint":
              case "Polygon":
              case "MultiLineString":
              case "MultiPolygon":
                if (O(A, X, Y, G, ee) === !1)
                  return !1;
                break;
              case "GeometryCollection":
                for (C = 0; C < A.geometries.length; C++)
                  if (O(A.geometries[C], X, Y, G, ee) === !1)
                    return !1;
                break;
              default:
                throw new Error("Unknown Geometry Type");
            }
          else if (O(null, X, Y, G, ee) === !1)
            return !1;
        X++;
      }
    }
    function y(M, O) {
      v(M, function(R, C, T, A, P) {
        var D, $ = R === null ? null : R.type;
        switch ($) {
          case null:
          case "Point":
          case "LineString":
          case "Polygon":
            return O(u.feature(R, T, { bbox: A, id: P }), C, 0) !== !1 && void 0;
        }
        switch ($) {
          case "MultiPoint":
            D = "Point";
            break;
          case "MultiLineString":
            D = "LineString";
            break;
          case "MultiPolygon":
            D = "Polygon";
        }
        for (var Y = 0; Y < R.coordinates.length; Y++) {
          var G = { type: D, coordinates: R.coordinates[Y] };
          if (O(u.feature(G, T), C, Y) === !1)
            return !1;
        }
      });
    }
    function k(M, O) {
      y(M, function(R, C, T) {
        var A = 0;
        if (R.geometry) {
          var P = R.geometry.type;
          if (P !== "Point" && P !== "MultiPoint") {
            var D, $ = 0, Y = 0, G = 0;
            return h(R, function(ee, X, ae, ne, se) {
              if (D === void 0 || C > $ || ne > Y || se > G)
                return D = ee, $ = C, Y = ne, G = se, void (A = 0);
              var re = u.lineString([D, ee], R.properties);
              if (O(re, C, T, se, A) === !1)
                return !1;
              A++, D = ee;
            }) !== !1 && void 0;
          }
        }
      });
    }
    function x(M, O) {
      if (!M)
        throw new Error("geojson is required");
      y(M, function(R, C, T) {
        if (R.geometry !== null) {
          var A = R.geometry.type, P = R.geometry.coordinates;
          switch (A) {
            case "LineString":
              if (O(R, C, T, 0, 0) === !1)
                return !1;
              break;
            case "Polygon":
              for (var D = 0; D < P.length; D++)
                if (O(u.lineString(P[D], R.properties), C, T, D) === !1)
                  return !1;
          }
        }
      });
    }
    a.coordAll = function(M) {
      var O = [];
      return h(M, function(R) {
        O.push(R);
      }), O;
    }, a.coordEach = h, a.coordReduce = function(M, O, R, C) {
      var T = R;
      return h(M, function(A, P, D, $, Y) {
        T = P === 0 && R === void 0 ? A : O(T, A, P, D, $, Y);
      }, C), T;
    }, a.featureEach = m, a.featureReduce = function(M, O, R) {
      var C = R;
      return m(M, function(T, A) {
        C = A === 0 && R === void 0 ? T : O(C, T, A);
      }), C;
    }, a.findPoint = function(M, O) {
      if (O = O || {}, !u.isObject(O))
        throw new Error("options is invalid");
      var R, C = O.featureIndex || 0, T = O.multiFeatureIndex || 0, A = O.geometryIndex || 0, P = O.coordIndex || 0, D = O.properties;
      switch (M.type) {
        case "FeatureCollection":
          C < 0 && (C = M.features.length + C), D = D || M.features[C].properties, R = M.features[C].geometry;
          break;
        case "Feature":
          D = D || M.properties, R = M.geometry;
          break;
        case "Point":
        case "MultiPoint":
          return null;
        case "LineString":
        case "Polygon":
        case "MultiLineString":
        case "MultiPolygon":
          R = M;
          break;
        default:
          throw new Error("geojson is invalid");
      }
      if (R === null)
        return null;
      var $ = R.coordinates;
      switch (R.type) {
        case "Point":
          return u.point($, D, O);
        case "MultiPoint":
          return T < 0 && (T = $.length + T), u.point($[T], D, O);
        case "LineString":
          return P < 0 && (P = $.length + P), u.point($[P], D, O);
        case "Polygon":
          return A < 0 && (A = $.length + A), P < 0 && (P = $[A].length + P), u.point($[A][P], D, O);
        case "MultiLineString":
          return T < 0 && (T = $.length + T), P < 0 && (P = $[T].length + P), u.point($[T][P], D, O);
        case "MultiPolygon":
          return T < 0 && (T = $.length + T), A < 0 && (A = $[T].length + A), P < 0 && (P = $[T][A].length - P), u.point($[T][A][P], D, O);
      }
      throw new Error("geojson is invalid");
    }, a.findSegment = function(M, O) {
      if (O = O || {}, !u.isObject(O))
        throw new Error("options is invalid");
      var R, C = O.featureIndex || 0, T = O.multiFeatureIndex || 0, A = O.geometryIndex || 0, P = O.segmentIndex || 0, D = O.properties;
      switch (M.type) {
        case "FeatureCollection":
          C < 0 && (C = M.features.length + C), D = D || M.features[C].properties, R = M.features[C].geometry;
          break;
        case "Feature":
          D = D || M.properties, R = M.geometry;
          break;
        case "Point":
        case "MultiPoint":
          return null;
        case "LineString":
        case "Polygon":
        case "MultiLineString":
        case "MultiPolygon":
          R = M;
          break;
        default:
          throw new Error("geojson is invalid");
      }
      if (R === null)
        return null;
      var $ = R.coordinates;
      switch (R.type) {
        case "Point":
        case "MultiPoint":
          return null;
        case "LineString":
          return P < 0 && (P = $.length + P - 1), u.lineString([$[P], $[P + 1]], D, O);
        case "Polygon":
          return A < 0 && (A = $.length + A), P < 0 && (P = $[A].length + P - 1), u.lineString([$[A][P], $[A][P + 1]], D, O);
        case "MultiLineString":
          return T < 0 && (T = $.length + T), P < 0 && (P = $[T].length + P - 1), u.lineString([$[T][P], $[T][P + 1]], D, O);
        case "MultiPolygon":
          return T < 0 && (T = $.length + T), A < 0 && (A = $[T].length + A), P < 0 && (P = $[T][A].length - P - 1), u.lineString([$[T][A][P], $[T][A][P + 1]], D, O);
      }
      throw new Error("geojson is invalid");
    }, a.flattenEach = y, a.flattenReduce = function(M, O, R) {
      var C = R;
      return y(M, function(T, A, P) {
        C = A === 0 && P === 0 && R === void 0 ? T : O(C, T, A, P);
      }), C;
    }, a.geomEach = v, a.geomReduce = function(M, O, R) {
      var C = R;
      return v(M, function(T, A, P, D, $) {
        C = A === 0 && R === void 0 ? T : O(C, T, A, P, D, $);
      }), C;
    }, a.lineEach = x, a.lineReduce = function(M, O, R) {
      var C = R;
      return x(M, function(T, A, P, D) {
        C = A === 0 && R === void 0 ? T : O(C, T, A, P, D);
      }), C;
    }, a.propEach = f, a.propReduce = function(M, O, R) {
      var C = R;
      return f(M, function(T, A) {
        C = A === 0 && R === void 0 ? T : O(C, T, A);
      }), C;
    }, a.segmentEach = k, a.segmentReduce = function(M, O, R) {
      var C = R, T = !1;
      return k(M, function(A, P, D, $, Y) {
        C = T === !1 && R === void 0 ? A : O(C, A, P, D, $, Y), T = !0;
      }), C;
    };
  }, 7107: () => {
    Array.prototype.findIndex = Array.prototype.findIndex || function(r) {
      if (this === null)
        throw new TypeError("Array.prototype.findIndex called on null or undefined");
      if (typeof r != "function")
        throw new TypeError("callback must be a function");
      for (var a = Object(this), l = a.length >>> 0, u = arguments[1], h = 0; h < l; h++)
        if (r.call(u, a[h], h, a))
          return h;
      return -1;
    }, Array.prototype.find = Array.prototype.find || function(r) {
      if (this === null)
        throw new TypeError("Array.prototype.find called on null or undefined");
      if (typeof r != "function")
        throw new TypeError("callback must be a function");
      for (var a = Object(this), l = a.length >>> 0, u = arguments[1], h = 0; h < l; h++) {
        var f = a[h];
        if (r.call(u, f, h, a))
          return f;
      }
    }, typeof Object.assign != "function" && (Object.assign = function(r) {
      if (r == null)
        throw new TypeError("Cannot convert undefined or null to object");
      r = Object(r);
      for (var a = 1; a < arguments.length; a++) {
        var l = arguments[a];
        if (l != null)
          for (var u in l)
            Object.prototype.hasOwnProperty.call(l, u) && (r[u] = l[u]);
      }
      return r;
    }), [Element.prototype, CharacterData.prototype, DocumentType.prototype].forEach(function(r) {
      r.hasOwnProperty("remove") || Object.defineProperty(r, "remove", { configurable: !0, enumerable: !0, writable: !0, value: function() {
        this.parentNode.removeChild(this);
      } });
    }), Array.prototype.includes || Object.defineProperty(Array.prototype, "includes", { value: function(r, a) {
      if (this == null)
        throw new TypeError('"this" is null or not defined');
      var l = Object(this), u = l.length >>> 0;
      if (u === 0)
        return !1;
      for (var h, f, m = 0 | a, v = Math.max(m >= 0 ? m : u - Math.abs(m), 0); v < u; ) {
        if ((h = l[v]) === (f = r) || typeof h == "number" && typeof f == "number" && isNaN(h) && isNaN(f))
          return !0;
        v++;
      }
      return !1;
    } });
  }, 1787: (r, a, l) => {
    var u = l(2582), h = l(4102), f = l(1540), m = l(9705).Z, v = f.featureEach, y = (f.coordEach, h.polygon, h.featureCollection);
    function k(x) {
      var M = new u(x);
      return M.insert = function(O) {
        if (O.type !== "Feature")
          throw new Error("invalid feature");
        return O.bbox = O.bbox ? O.bbox : m(O), u.prototype.insert.call(this, O);
      }, M.load = function(O) {
        var R = [];
        return Array.isArray(O) ? O.forEach(function(C) {
          if (C.type !== "Feature")
            throw new Error("invalid features");
          C.bbox = C.bbox ? C.bbox : m(C), R.push(C);
        }) : v(O, function(C) {
          if (C.type !== "Feature")
            throw new Error("invalid features");
          C.bbox = C.bbox ? C.bbox : m(C), R.push(C);
        }), u.prototype.load.call(this, R);
      }, M.remove = function(O, R) {
        if (O.type !== "Feature")
          throw new Error("invalid feature");
        return O.bbox = O.bbox ? O.bbox : m(O), u.prototype.remove.call(this, O, R);
      }, M.clear = function() {
        return u.prototype.clear.call(this);
      }, M.search = function(O) {
        var R = u.prototype.search.call(this, this.toBBox(O));
        return y(R);
      }, M.collides = function(O) {
        return u.prototype.collides.call(this, this.toBBox(O));
      }, M.all = function() {
        var O = u.prototype.all.call(this);
        return y(O);
      }, M.toJSON = function() {
        return u.prototype.toJSON.call(this);
      }, M.fromJSON = function(O) {
        return u.prototype.fromJSON.call(this, O);
      }, M.toBBox = function(O) {
        var R;
        if (O.bbox)
          R = O.bbox;
        else if (Array.isArray(O) && O.length === 4)
          R = O;
        else if (Array.isArray(O) && O.length === 6)
          R = [O[0], O[1], O[3], O[4]];
        else if (O.type === "Feature")
          R = m(O);
        else {
          if (O.type !== "FeatureCollection")
            throw new Error("invalid geojson");
          R = m(O);
        }
        return { minX: R[0], minY: R[1], maxX: R[2], maxY: R[3] };
      }, M;
    }
    r.exports = k, r.exports.default = k;
  }, 1989: (r, a, l) => {
    var u = l(1789), h = l(401), f = l(7667), m = l(1327), v = l(1866);
    function y(k) {
      var x = -1, M = k == null ? 0 : k.length;
      for (this.clear(); ++x < M; ) {
        var O = k[x];
        this.set(O[0], O[1]);
      }
    }
    y.prototype.clear = u, y.prototype.delete = h, y.prototype.get = f, y.prototype.has = m, y.prototype.set = v, r.exports = y;
  }, 8407: (r, a, l) => {
    var u = l(7040), h = l(4125), f = l(2117), m = l(7518), v = l(4705);
    function y(k) {
      var x = -1, M = k == null ? 0 : k.length;
      for (this.clear(); ++x < M; ) {
        var O = k[x];
        this.set(O[0], O[1]);
      }
    }
    y.prototype.clear = u, y.prototype.delete = h, y.prototype.get = f, y.prototype.has = m, y.prototype.set = v, r.exports = y;
  }, 7071: (r, a, l) => {
    var u = l(852)(l(5639), "Map");
    r.exports = u;
  }, 3369: (r, a, l) => {
    var u = l(4785), h = l(1285), f = l(6e3), m = l(9916), v = l(5265);
    function y(k) {
      var x = -1, M = k == null ? 0 : k.length;
      for (this.clear(); ++x < M; ) {
        var O = k[x];
        this.set(O[0], O[1]);
      }
    }
    y.prototype.clear = u, y.prototype.delete = h, y.prototype.get = f, y.prototype.has = m, y.prototype.set = v, r.exports = y;
  }, 6384: (r, a, l) => {
    var u = l(8407), h = l(7465), f = l(3779), m = l(7599), v = l(4758), y = l(4309);
    function k(x) {
      var M = this.__data__ = new u(x);
      this.size = M.size;
    }
    k.prototype.clear = h, k.prototype.delete = f, k.prototype.get = m, k.prototype.has = v, k.prototype.set = y, r.exports = k;
  }, 2705: (r, a, l) => {
    var u = l(5639).Symbol;
    r.exports = u;
  }, 1149: (r, a, l) => {
    var u = l(5639).Uint8Array;
    r.exports = u;
  }, 6874: (r) => {
    r.exports = function(a, l, u) {
      switch (u.length) {
        case 0:
          return a.call(l);
        case 1:
          return a.call(l, u[0]);
        case 2:
          return a.call(l, u[0], u[1]);
        case 3:
          return a.call(l, u[0], u[1], u[2]);
      }
      return a.apply(l, u);
    };
  }, 4636: (r, a, l) => {
    var u = l(2545), h = l(5694), f = l(1469), m = l(4144), v = l(5776), y = l(6719), k = Object.prototype.hasOwnProperty;
    r.exports = function(x, M) {
      var O = f(x), R = !O && h(x), C = !O && !R && m(x), T = !O && !R && !C && y(x), A = O || R || C || T, P = A ? u(x.length, String) : [], D = P.length;
      for (var $ in x)
        !M && !k.call(x, $) || A && ($ == "length" || C && ($ == "offset" || $ == "parent") || T && ($ == "buffer" || $ == "byteLength" || $ == "byteOffset") || v($, D)) || P.push($);
      return P;
    };
  }, 9932: (r) => {
    r.exports = function(a, l) {
      for (var u = -1, h = a == null ? 0 : a.length, f = Array(h); ++u < h; )
        f[u] = l(a[u], u, a);
      return f;
    };
  }, 6556: (r, a, l) => {
    var u = l(9465), h = l(7813);
    r.exports = function(f, m, v) {
      (v !== void 0 && !h(f[m], v) || v === void 0 && !(m in f)) && u(f, m, v);
    };
  }, 4865: (r, a, l) => {
    var u = l(9465), h = l(7813), f = Object.prototype.hasOwnProperty;
    r.exports = function(m, v, y) {
      var k = m[v];
      f.call(m, v) && h(k, y) && (y !== void 0 || v in m) || u(m, v, y);
    };
  }, 8470: (r, a, l) => {
    var u = l(7813);
    r.exports = function(h, f) {
      for (var m = h.length; m--; )
        if (u(h[m][0], f))
          return m;
      return -1;
    };
  }, 9465: (r, a, l) => {
    var u = l(8777);
    r.exports = function(h, f, m) {
      f == "__proto__" && u ? u(h, f, { configurable: !0, enumerable: !0, value: m, writable: !0 }) : h[f] = m;
    };
  }, 3118: (r, a, l) => {
    var u = l(3218), h = Object.create, f = /* @__PURE__ */ function() {
      function m() {
      }
      return function(v) {
        if (!u(v))
          return {};
        if (h)
          return h(v);
        m.prototype = v;
        var y = new m();
        return m.prototype = void 0, y;
      };
    }();
    r.exports = f;
  }, 8483: (r, a, l) => {
    var u = l(5063)();
    r.exports = u;
  }, 7786: (r, a, l) => {
    var u = l(1811), h = l(327);
    r.exports = function(f, m) {
      for (var v = 0, y = (m = u(m, f)).length; f != null && v < y; )
        f = f[h(m[v++])];
      return v && v == y ? f : void 0;
    };
  }, 4239: (r, a, l) => {
    var u = l(2705), h = l(9607), f = l(2333), m = u ? u.toStringTag : void 0;
    r.exports = function(v) {
      return v == null ? v === void 0 ? "[object Undefined]" : "[object Null]" : m && m in Object(v) ? h(v) : f(v);
    };
  }, 8565: (r) => {
    var a = Object.prototype.hasOwnProperty;
    r.exports = function(l, u) {
      return l != null && a.call(l, u);
    };
  }, 9454: (r, a, l) => {
    var u = l(4239), h = l(7005);
    r.exports = function(f) {
      return h(f) && u(f) == "[object Arguments]";
    };
  }, 8458: (r, a, l) => {
    var u = l(3560), h = l(5346), f = l(3218), m = l(346), v = /^\[object .+?Constructor\]$/, y = Function.prototype, k = Object.prototype, x = y.toString, M = k.hasOwnProperty, O = RegExp("^" + x.call(M).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
    r.exports = function(R) {
      return !(!f(R) || h(R)) && (u(R) ? O : v).test(m(R));
    };
  }, 8749: (r, a, l) => {
    var u = l(4239), h = l(1780), f = l(7005), m = {};
    m["[object Float32Array]"] = m["[object Float64Array]"] = m["[object Int8Array]"] = m["[object Int16Array]"] = m["[object Int32Array]"] = m["[object Uint8Array]"] = m["[object Uint8ClampedArray]"] = m["[object Uint16Array]"] = m["[object Uint32Array]"] = !0, m["[object Arguments]"] = m["[object Array]"] = m["[object ArrayBuffer]"] = m["[object Boolean]"] = m["[object DataView]"] = m["[object Date]"] = m["[object Error]"] = m["[object Function]"] = m["[object Map]"] = m["[object Number]"] = m["[object Object]"] = m["[object RegExp]"] = m["[object Set]"] = m["[object String]"] = m["[object WeakMap]"] = !1, r.exports = function(v) {
      return f(v) && h(v.length) && !!m[u(v)];
    };
  }, 313: (r, a, l) => {
    var u = l(3218), h = l(5726), f = l(3498), m = Object.prototype.hasOwnProperty;
    r.exports = function(v) {
      if (!u(v))
        return f(v);
      var y = h(v), k = [];
      for (var x in v)
        (x != "constructor" || !y && m.call(v, x)) && k.push(x);
      return k;
    };
  }, 2980: (r, a, l) => {
    var u = l(6384), h = l(6556), f = l(8483), m = l(9783), v = l(3218), y = l(1704), k = l(6390);
    r.exports = function x(M, O, R, C, T) {
      M !== O && f(O, function(A, P) {
        if (T || (T = new u()), v(A))
          m(M, O, P, R, x, C, T);
        else {
          var D = C ? C(k(M, P), A, P + "", M, O, T) : void 0;
          D === void 0 && (D = A), h(M, P, D);
        }
      }, y);
    };
  }, 9783: (r, a, l) => {
    var u = l(6556), h = l(4626), f = l(7133), m = l(278), v = l(8517), y = l(5694), k = l(1469), x = l(9246), M = l(4144), O = l(3560), R = l(3218), C = l(8630), T = l(6719), A = l(6390), P = l(9881);
    r.exports = function(D, $, Y, G, ee, X, ae) {
      var ne = A(D, Y), se = A($, Y), re = ae.get(se);
      if (re)
        u(D, Y, re);
      else {
        var Q = X ? X(ne, se, Y + "", D, $, ae) : void 0, ke = Q === void 0;
        if (ke) {
          var Ae = k(se), pe = !Ae && M(se), Ye = !Ae && !pe && T(se);
          Q = se, Ae || pe || Ye ? k(ne) ? Q = ne : x(ne) ? Q = m(ne) : pe ? (ke = !1, Q = h(se, !0)) : Ye ? (ke = !1, Q = f(se, !0)) : Q = [] : C(se) || y(se) ? (Q = ne, y(ne) ? Q = P(ne) : R(ne) && !O(ne) || (Q = v(se))) : ke = !1;
        }
        ke && (ae.set(se, Q), ee(Q, se, G, X, ae), ae.delete(se)), u(D, Y, Q);
      }
    };
  }, 5976: (r, a, l) => {
    var u = l(6557), h = l(5357), f = l(61);
    r.exports = function(m, v) {
      return f(h(m, v, u), m + "");
    };
  }, 6560: (r, a, l) => {
    var u = l(5703), h = l(8777), f = l(6557), m = h ? function(v, y) {
      return h(v, "toString", { configurable: !0, enumerable: !1, value: u(y), writable: !0 });
    } : f;
    r.exports = m;
  }, 2545: (r) => {
    r.exports = function(a, l) {
      for (var u = -1, h = Array(a); ++u < a; )
        h[u] = l(u);
      return h;
    };
  }, 531: (r, a, l) => {
    var u = l(2705), h = l(9932), f = l(1469), m = l(3448), v = u ? u.prototype : void 0, y = v ? v.toString : void 0;
    r.exports = function k(x) {
      if (typeof x == "string")
        return x;
      if (f(x))
        return h(x, k) + "";
      if (m(x))
        return y ? y.call(x) : "";
      var M = x + "";
      return M == "0" && 1 / x == -1 / 0 ? "-0" : M;
    };
  }, 1717: (r) => {
    r.exports = function(a) {
      return function(l) {
        return a(l);
      };
    };
  }, 1811: (r, a, l) => {
    var u = l(1469), h = l(5403), f = l(5514), m = l(9833);
    r.exports = function(v, y) {
      return u(v) ? v : h(v, y) ? [v] : f(m(v));
    };
  }, 4318: (r, a, l) => {
    var u = l(1149);
    r.exports = function(h) {
      var f = new h.constructor(h.byteLength);
      return new u(f).set(new u(h)), f;
    };
  }, 4626: (r, a, l) => {
    r = l.nmd(r);
    var u = l(5639), h = a && !a.nodeType && a, f = h && r && !r.nodeType && r, m = f && f.exports === h ? u.Buffer : void 0, v = m ? m.allocUnsafe : void 0;
    r.exports = function(y, k) {
      if (k)
        return y.slice();
      var x = y.length, M = v ? v(x) : new y.constructor(x);
      return y.copy(M), M;
    };
  }, 7133: (r, a, l) => {
    var u = l(4318);
    r.exports = function(h, f) {
      var m = f ? u(h.buffer) : h.buffer;
      return new h.constructor(m, h.byteOffset, h.length);
    };
  }, 278: (r) => {
    r.exports = function(a, l) {
      var u = -1, h = a.length;
      for (l || (l = Array(h)); ++u < h; )
        l[u] = a[u];
      return l;
    };
  }, 8363: (r, a, l) => {
    var u = l(4865), h = l(9465);
    r.exports = function(f, m, v, y) {
      var k = !v;
      v || (v = {});
      for (var x = -1, M = m.length; ++x < M; ) {
        var O = m[x], R = y ? y(v[O], f[O], O, v, f) : void 0;
        R === void 0 && (R = f[O]), k ? h(v, O, R) : u(v, O, R);
      }
      return v;
    };
  }, 4429: (r, a, l) => {
    var u = l(5639)["__core-js_shared__"];
    r.exports = u;
  }, 1463: (r, a, l) => {
    var u = l(5976), h = l(6612);
    r.exports = function(f) {
      return u(function(m, v) {
        var y = -1, k = v.length, x = k > 1 ? v[k - 1] : void 0, M = k > 2 ? v[2] : void 0;
        for (x = f.length > 3 && typeof x == "function" ? (k--, x) : void 0, M && h(v[0], v[1], M) && (x = k < 3 ? void 0 : x, k = 1), m = Object(m); ++y < k; ) {
          var O = v[y];
          O && f(m, O, y, x);
        }
        return m;
      });
    };
  }, 5063: (r) => {
    r.exports = function(a) {
      return function(l, u, h) {
        for (var f = -1, m = Object(l), v = h(l), y = v.length; y--; ) {
          var k = v[a ? y : ++f];
          if (u(m[k], k, m) === !1)
            break;
        }
        return l;
      };
    };
  }, 8777: (r, a, l) => {
    var u = l(852), h = function() {
      try {
        var f = u(Object, "defineProperty");
        return f({}, "", {}), f;
      } catch {
      }
    }();
    r.exports = h;
  }, 1957: (r, a, l) => {
    var u = typeof l.g == "object" && l.g && l.g.Object === Object && l.g;
    r.exports = u;
  }, 5050: (r, a, l) => {
    var u = l(7019);
    r.exports = function(h, f) {
      var m = h.__data__;
      return u(f) ? m[typeof f == "string" ? "string" : "hash"] : m.map;
    };
  }, 852: (r, a, l) => {
    var u = l(8458), h = l(7801);
    r.exports = function(f, m) {
      var v = h(f, m);
      return u(v) ? v : void 0;
    };
  }, 5924: (r, a, l) => {
    var u = l(5569)(Object.getPrototypeOf, Object);
    r.exports = u;
  }, 9607: (r, a, l) => {
    var u = l(2705), h = Object.prototype, f = h.hasOwnProperty, m = h.toString, v = u ? u.toStringTag : void 0;
    r.exports = function(y) {
      var k = f.call(y, v), x = y[v];
      try {
        y[v] = void 0;
        var M = !0;
      } catch {
      }
      var O = m.call(y);
      return M && (k ? y[v] = x : delete y[v]), O;
    };
  }, 7801: (r) => {
    r.exports = function(a, l) {
      return a == null ? void 0 : a[l];
    };
  }, 222: (r, a, l) => {
    var u = l(1811), h = l(5694), f = l(1469), m = l(5776), v = l(1780), y = l(327);
    r.exports = function(k, x, M) {
      for (var O = -1, R = (x = u(x, k)).length, C = !1; ++O < R; ) {
        var T = y(x[O]);
        if (!(C = k != null && M(k, T)))
          break;
        k = k[T];
      }
      return C || ++O != R ? C : !!(R = k == null ? 0 : k.length) && v(R) && m(T, R) && (f(k) || h(k));
    };
  }, 1789: (r, a, l) => {
    var u = l(4536);
    r.exports = function() {
      this.__data__ = u ? u(null) : {}, this.size = 0;
    };
  }, 401: (r) => {
    r.exports = function(a) {
      var l = this.has(a) && delete this.__data__[a];
      return this.size -= l ? 1 : 0, l;
    };
  }, 7667: (r, a, l) => {
    var u = l(4536), h = Object.prototype.hasOwnProperty;
    r.exports = function(f) {
      var m = this.__data__;
      if (u) {
        var v = m[f];
        return v === "__lodash_hash_undefined__" ? void 0 : v;
      }
      return h.call(m, f) ? m[f] : void 0;
    };
  }, 1327: (r, a, l) => {
    var u = l(4536), h = Object.prototype.hasOwnProperty;
    r.exports = function(f) {
      var m = this.__data__;
      return u ? m[f] !== void 0 : h.call(m, f);
    };
  }, 1866: (r, a, l) => {
    var u = l(4536);
    r.exports = function(h, f) {
      var m = this.__data__;
      return this.size += this.has(h) ? 0 : 1, m[h] = u && f === void 0 ? "__lodash_hash_undefined__" : f, this;
    };
  }, 8517: (r, a, l) => {
    var u = l(3118), h = l(5924), f = l(5726);
    r.exports = function(m) {
      return typeof m.constructor != "function" || f(m) ? {} : u(h(m));
    };
  }, 5776: (r) => {
    var a = /^(?:0|[1-9]\d*)$/;
    r.exports = function(l, u) {
      var h = typeof l;
      return !!(u = u ?? 9007199254740991) && (h == "number" || h != "symbol" && a.test(l)) && l > -1 && l % 1 == 0 && l < u;
    };
  }, 6612: (r, a, l) => {
    var u = l(7813), h = l(8612), f = l(5776), m = l(3218);
    r.exports = function(v, y, k) {
      if (!m(k))
        return !1;
      var x = typeof y;
      return !!(x == "number" ? h(k) && f(y, k.length) : x == "string" && y in k) && u(k[y], v);
    };
  }, 5403: (r, a, l) => {
    var u = l(1469), h = l(3448), f = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, m = /^\w*$/;
    r.exports = function(v, y) {
      if (u(v))
        return !1;
      var k = typeof v;
      return !(k != "number" && k != "symbol" && k != "boolean" && v != null && !h(v)) || m.test(v) || !f.test(v) || y != null && v in Object(y);
    };
  }, 7019: (r) => {
    r.exports = function(a) {
      var l = typeof a;
      return l == "string" || l == "number" || l == "symbol" || l == "boolean" ? a !== "__proto__" : a === null;
    };
  }, 5346: (r, a, l) => {
    var u, h = l(4429), f = (u = /[^.]+$/.exec(h && h.keys && h.keys.IE_PROTO || "")) ? "Symbol(src)_1." + u : "";
    r.exports = function(m) {
      return !!f && f in m;
    };
  }, 5726: (r) => {
    var a = Object.prototype;
    r.exports = function(l) {
      var u = l && l.constructor;
      return l === (typeof u == "function" && u.prototype || a);
    };
  }, 7040: (r) => {
    r.exports = function() {
      this.__data__ = [], this.size = 0;
    };
  }, 4125: (r, a, l) => {
    var u = l(8470), h = Array.prototype.splice;
    r.exports = function(f) {
      var m = this.__data__, v = u(m, f);
      return !(v < 0) && (v == m.length - 1 ? m.pop() : h.call(m, v, 1), --this.size, !0);
    };
  }, 2117: (r, a, l) => {
    var u = l(8470);
    r.exports = function(h) {
      var f = this.__data__, m = u(f, h);
      return m < 0 ? void 0 : f[m][1];
    };
  }, 7518: (r, a, l) => {
    var u = l(8470);
    r.exports = function(h) {
      return u(this.__data__, h) > -1;
    };
  }, 4705: (r, a, l) => {
    var u = l(8470);
    r.exports = function(h, f) {
      var m = this.__data__, v = u(m, h);
      return v < 0 ? (++this.size, m.push([h, f])) : m[v][1] = f, this;
    };
  }, 4785: (r, a, l) => {
    var u = l(1989), h = l(8407), f = l(7071);
    r.exports = function() {
      this.size = 0, this.__data__ = { hash: new u(), map: new (f || h)(), string: new u() };
    };
  }, 1285: (r, a, l) => {
    var u = l(5050);
    r.exports = function(h) {
      var f = u(this, h).delete(h);
      return this.size -= f ? 1 : 0, f;
    };
  }, 6e3: (r, a, l) => {
    var u = l(5050);
    r.exports = function(h) {
      return u(this, h).get(h);
    };
  }, 9916: (r, a, l) => {
    var u = l(5050);
    r.exports = function(h) {
      return u(this, h).has(h);
    };
  }, 5265: (r, a, l) => {
    var u = l(5050);
    r.exports = function(h, f) {
      var m = u(this, h), v = m.size;
      return m.set(h, f), this.size += m.size == v ? 0 : 1, this;
    };
  }, 4523: (r, a, l) => {
    var u = l(8306);
    r.exports = function(h) {
      var f = u(h, function(v) {
        return m.size === 500 && m.clear(), v;
      }), m = f.cache;
      return f;
    };
  }, 4536: (r, a, l) => {
    var u = l(852)(Object, "create");
    r.exports = u;
  }, 3498: (r) => {
    r.exports = function(a) {
      var l = [];
      if (a != null)
        for (var u in Object(a))
          l.push(u);
      return l;
    };
  }, 1167: (r, a, l) => {
    r = l.nmd(r);
    var u = l(1957), h = a && !a.nodeType && a, f = h && r && !r.nodeType && r, m = f && f.exports === h && u.process, v = function() {
      try {
        var y = f && f.require && f.require("util").types;
        return y || m && m.binding && m.binding("util");
      } catch {
      }
    }();
    r.exports = v;
  }, 2333: (r) => {
    var a = Object.prototype.toString;
    r.exports = function(l) {
      return a.call(l);
    };
  }, 5569: (r) => {
    r.exports = function(a, l) {
      return function(u) {
        return a(l(u));
      };
    };
  }, 5357: (r, a, l) => {
    var u = l(6874), h = Math.max;
    r.exports = function(f, m, v) {
      return m = h(m === void 0 ? f.length - 1 : m, 0), function() {
        for (var y = arguments, k = -1, x = h(y.length - m, 0), M = Array(x); ++k < x; )
          M[k] = y[m + k];
        k = -1;
        for (var O = Array(m + 1); ++k < m; )
          O[k] = y[k];
        return O[m] = v(M), u(f, this, O);
      };
    };
  }, 5639: (r, a, l) => {
    var u = l(1957), h = typeof self == "object" && self && self.Object === Object && self, f = u || h || Function("return this")();
    r.exports = f;
  }, 6390: (r) => {
    r.exports = function(a, l) {
      if ((l !== "constructor" || typeof a[l] != "function") && l != "__proto__")
        return a[l];
    };
  }, 61: (r, a, l) => {
    var u = l(6560), h = l(1275)(u);
    r.exports = h;
  }, 1275: (r) => {
    var a = Date.now;
    r.exports = function(l) {
      var u = 0, h = 0;
      return function() {
        var f = a(), m = 16 - (f - h);
        if (h = f, m > 0) {
          if (++u >= 800)
            return arguments[0];
        } else
          u = 0;
        return l.apply(void 0, arguments);
      };
    };
  }, 7465: (r, a, l) => {
    var u = l(8407);
    r.exports = function() {
      this.__data__ = new u(), this.size = 0;
    };
  }, 3779: (r) => {
    r.exports = function(a) {
      var l = this.__data__, u = l.delete(a);
      return this.size = l.size, u;
    };
  }, 7599: (r) => {
    r.exports = function(a) {
      return this.__data__.get(a);
    };
  }, 4758: (r) => {
    r.exports = function(a) {
      return this.__data__.has(a);
    };
  }, 4309: (r, a, l) => {
    var u = l(8407), h = l(7071), f = l(3369);
    r.exports = function(m, v) {
      var y = this.__data__;
      if (y instanceof u) {
        var k = y.__data__;
        if (!h || k.length < 199)
          return k.push([m, v]), this.size = ++y.size, this;
        y = this.__data__ = new f(k);
      }
      return y.set(m, v), this.size = y.size, this;
    };
  }, 5514: (r, a, l) => {
    var u = l(4523), h = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, f = /\\(\\)?/g, m = u(function(v) {
      var y = [];
      return v.charCodeAt(0) === 46 && y.push(""), v.replace(h, function(k, x, M, O) {
        y.push(M ? O.replace(f, "$1") : x || k);
      }), y;
    });
    r.exports = m;
  }, 327: (r, a, l) => {
    var u = l(3448);
    r.exports = function(h) {
      if (typeof h == "string" || u(h))
        return h;
      var f = h + "";
      return f == "0" && 1 / h == -1 / 0 ? "-0" : f;
    };
  }, 346: (r) => {
    var a = Function.prototype.toString;
    r.exports = function(l) {
      if (l != null) {
        try {
          return a.call(l);
        } catch {
        }
        try {
          return l + "";
        } catch {
        }
      }
      return "";
    };
  }, 5703: (r) => {
    r.exports = function(a) {
      return function() {
        return a;
      };
    };
  }, 7813: (r) => {
    r.exports = function(a, l) {
      return a === l || a != a && l != l;
    };
  }, 7361: (r, a, l) => {
    var u = l(7786);
    r.exports = function(h, f, m) {
      var v = h == null ? void 0 : u(h, f);
      return v === void 0 ? m : v;
    };
  }, 8721: (r, a, l) => {
    var u = l(8565), h = l(222);
    r.exports = function(f, m) {
      return f != null && h(f, m, u);
    };
  }, 6557: (r) => {
    r.exports = function(a) {
      return a;
    };
  }, 5694: (r, a, l) => {
    var u = l(9454), h = l(7005), f = Object.prototype, m = f.hasOwnProperty, v = f.propertyIsEnumerable, y = u(/* @__PURE__ */ function() {
      return arguments;
    }()) ? u : function(k) {
      return h(k) && m.call(k, "callee") && !v.call(k, "callee");
    };
    r.exports = y;
  }, 1469: (r) => {
    var a = Array.isArray;
    r.exports = a;
  }, 8612: (r, a, l) => {
    var u = l(3560), h = l(1780);
    r.exports = function(f) {
      return f != null && h(f.length) && !u(f);
    };
  }, 9246: (r, a, l) => {
    var u = l(8612), h = l(7005);
    r.exports = function(f) {
      return h(f) && u(f);
    };
  }, 4144: (r, a, l) => {
    r = l.nmd(r);
    var u = l(5639), h = l(5062), f = a && !a.nodeType && a, m = f && r && !r.nodeType && r, v = m && m.exports === f ? u.Buffer : void 0, y = (v ? v.isBuffer : void 0) || h;
    r.exports = y;
  }, 3560: (r, a, l) => {
    var u = l(4239), h = l(3218);
    r.exports = function(f) {
      if (!h(f))
        return !1;
      var m = u(f);
      return m == "[object Function]" || m == "[object GeneratorFunction]" || m == "[object AsyncFunction]" || m == "[object Proxy]";
    };
  }, 1780: (r) => {
    r.exports = function(a) {
      return typeof a == "number" && a > -1 && a % 1 == 0 && a <= 9007199254740991;
    };
  }, 3218: (r) => {
    r.exports = function(a) {
      var l = typeof a;
      return a != null && (l == "object" || l == "function");
    };
  }, 7005: (r) => {
    r.exports = function(a) {
      return a != null && typeof a == "object";
    };
  }, 8630: (r, a, l) => {
    var u = l(4239), h = l(5924), f = l(7005), m = Function.prototype, v = Object.prototype, y = m.toString, k = v.hasOwnProperty, x = y.call(Object);
    r.exports = function(M) {
      if (!f(M) || u(M) != "[object Object]")
        return !1;
      var O = h(M);
      if (O === null)
        return !0;
      var R = k.call(O, "constructor") && O.constructor;
      return typeof R == "function" && R instanceof R && y.call(R) == x;
    };
  }, 3448: (r, a, l) => {
    var u = l(4239), h = l(7005);
    r.exports = function(f) {
      return typeof f == "symbol" || h(f) && u(f) == "[object Symbol]";
    };
  }, 6719: (r, a, l) => {
    var u = l(8749), h = l(1717), f = l(1167), m = f && f.isTypedArray, v = m ? h(m) : u;
    r.exports = v;
  }, 1704: (r, a, l) => {
    var u = l(4636), h = l(313), f = l(8612);
    r.exports = function(m) {
      return f(m) ? u(m, !0) : h(m);
    };
  }, 8306: (r, a, l) => {
    var u = l(3369);
    function h(f, m) {
      if (typeof f != "function" || m != null && typeof m != "function")
        throw new TypeError("Expected a function");
      var v = function() {
        var y = arguments, k = m ? m.apply(this, y) : y[0], x = v.cache;
        if (x.has(k))
          return x.get(k);
        var M = f.apply(this, y);
        return v.cache = x.set(k, M) || x, M;
      };
      return v.cache = new (h.Cache || u)(), v;
    }
    h.Cache = u, r.exports = h;
  }, 2492: (r, a, l) => {
    var u = l(2980), h = l(1463)(function(f, m, v) {
      u(f, m, v);
    });
    r.exports = h;
  }, 5062: (r) => {
    r.exports = function() {
      return !1;
    };
  }, 9881: (r, a, l) => {
    var u = l(8363), h = l(1704);
    r.exports = function(f) {
      return u(f, h(f));
    };
  }, 9833: (r, a, l) => {
    var u = l(531);
    r.exports = function(h) {
      return h == null ? "" : u(h);
    };
  }, 2676: function(r) {
    r.exports = function() {
      function a(H, S) {
        if (!(H instanceof S))
          throw new TypeError("Cannot call a class as a function");
      }
      function l(H, S) {
        for (var E = 0; E < S.length; E++) {
          var z = S[E];
          z.enumerable = z.enumerable || !1, z.configurable = !0, "value" in z && (z.writable = !0), Object.defineProperty(H, z.key, z);
        }
      }
      function u(H, S, E) {
        return S && l(H.prototype, S), E && l(H, E), H;
      }
      var h = /* @__PURE__ */ function() {
        function H(S, E) {
          this.next = null, this.key = S, this.data = E, this.left = null, this.right = null;
        }
        return H;
      }();
      function f(H, S) {
        return H > S ? 1 : H < S ? -1 : 0;
      }
      function m(H, S, E) {
        for (var z = new h(null, null), q = z, J = z; ; ) {
          var me = E(H, S.key);
          if (me < 0) {
            if (S.left === null)
              break;
            if (E(H, S.left.key) < 0) {
              var ye = S.left;
              if (S.left = ye.right, ye.right = S, (S = ye).left === null)
                break;
            }
            J.left = S, J = S, S = S.left;
          } else {
            if (!(me > 0) || S.right === null || E(H, S.right.key) > 0 && (ye = S.right, S.right = ye.left, ye.left = S, (S = ye).right === null))
              break;
            q.right = S, q = S, S = S.right;
          }
        }
        return q.right = S.left, J.left = S.right, S.left = z.right, S.right = z.left, S;
      }
      function v(H, S, E, z) {
        var q = new h(H, S);
        if (E === null)
          return q.left = q.right = null, q;
        var J = z(H, (E = m(H, E, z)).key);
        return J < 0 ? (q.left = E.left, q.right = E, E.left = null) : J >= 0 && (q.right = E.right, q.left = E, E.right = null), q;
      }
      function y(H, S, E) {
        var z = null, q = null;
        if (S) {
          var J = E((S = m(H, S, E)).key, H);
          J === 0 ? (z = S.left, q = S.right) : J < 0 ? (q = S.right, S.right = null, z = S) : (z = S.left, S.left = null, q = S);
        }
        return { left: z, right: q };
      }
      function k(H, S, E) {
        return S === null ? H : (H === null || ((S = m(H.key, S, E)).left = H), S);
      }
      function x(H, S, E, z, q) {
        if (H) {
          z(S + (E ? "└── " : "├── ") + q(H) + `
`);
          var J = S + (E ? "    " : "│   ");
          H.left && x(H.left, J, !1, z, q), H.right && x(H.right, J, !0, z, q);
        }
      }
      var M = function() {
        function H(S) {
          S === void 0 && (S = f), this._root = null, this._size = 0, this._comparator = S;
        }
        return H.prototype.insert = function(S, E) {
          return this._size++, this._root = v(S, E, this._root, this._comparator);
        }, H.prototype.add = function(S, E) {
          var z = new h(S, E);
          this._root === null && (z.left = z.right = null, this._size++, this._root = z);
          var q = this._comparator, J = m(S, this._root, q), me = q(S, J.key);
          return me === 0 ? this._root = J : (me < 0 ? (z.left = J.left, z.right = J, J.left = null) : me > 0 && (z.right = J.right, z.left = J, J.right = null), this._size++, this._root = z), this._root;
        }, H.prototype.remove = function(S) {
          this._root = this._remove(S, this._root, this._comparator);
        }, H.prototype._remove = function(S, E, z) {
          var q;
          return E === null ? null : z(S, (E = m(S, E, z)).key) === 0 ? (E.left === null ? q = E.right : (q = m(S, E.left, z)).right = E.right, this._size--, q) : E;
        }, H.prototype.pop = function() {
          var S = this._root;
          if (S) {
            for (; S.left; )
              S = S.left;
            return this._root = m(S.key, this._root, this._comparator), this._root = this._remove(S.key, this._root, this._comparator), { key: S.key, data: S.data };
          }
          return null;
        }, H.prototype.findStatic = function(S) {
          for (var E = this._root, z = this._comparator; E; ) {
            var q = z(S, E.key);
            if (q === 0)
              return E;
            E = q < 0 ? E.left : E.right;
          }
          return null;
        }, H.prototype.find = function(S) {
          return this._root && (this._root = m(S, this._root, this._comparator), this._comparator(S, this._root.key) !== 0) ? null : this._root;
        }, H.prototype.contains = function(S) {
          for (var E = this._root, z = this._comparator; E; ) {
            var q = z(S, E.key);
            if (q === 0)
              return !0;
            E = q < 0 ? E.left : E.right;
          }
          return !1;
        }, H.prototype.forEach = function(S, E) {
          for (var z = this._root, q = [], J = !1; !J; )
            z !== null ? (q.push(z), z = z.left) : q.length !== 0 ? (z = q.pop(), S.call(E, z), z = z.right) : J = !0;
          return this;
        }, H.prototype.range = function(S, E, z, q) {
          for (var J = [], me = this._comparator, ye = this._root; J.length !== 0 || ye; )
            if (ye)
              J.push(ye), ye = ye.left;
            else {
              if (me((ye = J.pop()).key, E) > 0)
                break;
              if (me(ye.key, S) >= 0 && z.call(q, ye))
                return this;
              ye = ye.right;
            }
          return this;
        }, H.prototype.keys = function() {
          var S = [];
          return this.forEach(function(E) {
            var z = E.key;
            return S.push(z);
          }), S;
        }, H.prototype.values = function() {
          var S = [];
          return this.forEach(function(E) {
            var z = E.data;
            return S.push(z);
          }), S;
        }, H.prototype.min = function() {
          return this._root ? this.minNode(this._root).key : null;
        }, H.prototype.max = function() {
          return this._root ? this.maxNode(this._root).key : null;
        }, H.prototype.minNode = function(S) {
          if (S === void 0 && (S = this._root), S)
            for (; S.left; )
              S = S.left;
          return S;
        }, H.prototype.maxNode = function(S) {
          if (S === void 0 && (S = this._root), S)
            for (; S.right; )
              S = S.right;
          return S;
        }, H.prototype.at = function(S) {
          for (var E = this._root, z = !1, q = 0, J = []; !z; )
            if (E)
              J.push(E), E = E.left;
            else if (J.length > 0) {
              if (E = J.pop(), q === S)
                return E;
              q++, E = E.right;
            } else
              z = !0;
          return null;
        }, H.prototype.next = function(S) {
          var E = this._root, z = null;
          if (S.right) {
            for (z = S.right; z.left; )
              z = z.left;
            return z;
          }
          for (var q = this._comparator; E; ) {
            var J = q(S.key, E.key);
            if (J === 0)
              break;
            J < 0 ? (z = E, E = E.left) : E = E.right;
          }
          return z;
        }, H.prototype.prev = function(S) {
          var E = this._root, z = null;
          if (S.left !== null) {
            for (z = S.left; z.right; )
              z = z.right;
            return z;
          }
          for (var q = this._comparator; E; ) {
            var J = q(S.key, E.key);
            if (J === 0)
              break;
            J < 0 ? E = E.left : (z = E, E = E.right);
          }
          return z;
        }, H.prototype.clear = function() {
          return this._root = null, this._size = 0, this;
        }, H.prototype.toList = function() {
          return C(this._root);
        }, H.prototype.load = function(S, E, z) {
          E === void 0 && (E = []), z === void 0 && (z = !1);
          var q = S.length, J = this._comparator;
          if (z && P(S, E, 0, q - 1, J), this._root === null)
            this._root = O(S, E, 0, q), this._size = q;
          else {
            var me = A(this.toList(), R(S, E), J);
            q = this._size + q, this._root = T({ head: me }, 0, q);
          }
          return this;
        }, H.prototype.isEmpty = function() {
          return this._root === null;
        }, Object.defineProperty(H.prototype, "size", { get: function() {
          return this._size;
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(H.prototype, "root", { get: function() {
          return this._root;
        }, enumerable: !0, configurable: !0 }), H.prototype.toString = function(S) {
          S === void 0 && (S = function(z) {
            return String(z.key);
          });
          var E = [];
          return x(this._root, "", !0, function(z) {
            return E.push(z);
          }, S), E.join("");
        }, H.prototype.update = function(S, E, z) {
          var q = this._comparator, J = y(S, this._root, q), me = J.left, ye = J.right;
          q(S, E) < 0 ? ye = v(E, z, ye, q) : me = v(E, z, me, q), this._root = k(me, ye, q);
        }, H.prototype.split = function(S) {
          return y(S, this._root, this._comparator);
        }, H;
      }();
      function O(H, S, E, z) {
        var q = z - E;
        if (q > 0) {
          var J = E + Math.floor(q / 2), me = H[J], ye = S[J], Oe = new h(me, ye);
          return Oe.left = O(H, S, E, J), Oe.right = O(H, S, J + 1, z), Oe;
        }
        return null;
      }
      function R(H, S) {
        for (var E = new h(null, null), z = E, q = 0; q < H.length; q++)
          z = z.next = new h(H[q], S[q]);
        return z.next = null, E.next;
      }
      function C(H) {
        for (var S = H, E = [], z = !1, q = new h(null, null), J = q; !z; )
          S ? (E.push(S), S = S.left) : E.length > 0 ? S = (S = J = J.next = E.pop()).right : z = !0;
        return J.next = null, q.next;
      }
      function T(H, S, E) {
        var z = E - S;
        if (z > 0) {
          var q = S + Math.floor(z / 2), J = T(H, S, q), me = H.head;
          return me.left = J, H.head = H.head.next, me.right = T(H, q + 1, E), me;
        }
        return null;
      }
      function A(H, S, E) {
        for (var z = new h(null, null), q = z, J = H, me = S; J !== null && me !== null; )
          E(J.key, me.key) < 0 ? (q.next = J, J = J.next) : (q.next = me, me = me.next), q = q.next;
        return J !== null ? q.next = J : me !== null && (q.next = me), z.next;
      }
      function P(H, S, E, z, q) {
        if (!(E >= z)) {
          for (var J = H[E + z >> 1], me = E - 1, ye = z + 1; ; ) {
            do
              me++;
            while (q(H[me], J) < 0);
            do
              ye--;
            while (q(H[ye], J) > 0);
            if (me >= ye)
              break;
            var Oe = H[me];
            H[me] = H[ye], H[ye] = Oe, Oe = S[me], S[me] = S[ye], S[ye] = Oe;
          }
          P(H, S, E, ye, q), P(H, S, ye + 1, z, q);
        }
      }
      var D = function(H, S) {
        return H.ll.x <= S.x && S.x <= H.ur.x && H.ll.y <= S.y && S.y <= H.ur.y;
      }, $ = function(H, S) {
        if (S.ur.x < H.ll.x || H.ur.x < S.ll.x || S.ur.y < H.ll.y || H.ur.y < S.ll.y)
          return null;
        var E = H.ll.x < S.ll.x ? S.ll.x : H.ll.x, z = H.ur.x < S.ur.x ? H.ur.x : S.ur.x;
        return { ll: { x: E, y: H.ll.y < S.ll.y ? S.ll.y : H.ll.y }, ur: { x: z, y: H.ur.y < S.ur.y ? H.ur.y : S.ur.y } };
      }, Y = Number.EPSILON;
      Y === void 0 && (Y = Math.pow(2, -52));
      var G = Y * Y, ee = function(H, S) {
        if (-Y < H && H < Y && -Y < S && S < Y)
          return 0;
        var E = H - S;
        return E * E < G * H * S ? 0 : H < S ? -1 : 1;
      }, X = function() {
        function H() {
          a(this, H), this.reset();
        }
        return u(H, [{ key: "reset", value: function() {
          this.xRounder = new ae(), this.yRounder = new ae();
        } }, { key: "round", value: function(S, E) {
          return { x: this.xRounder.round(S), y: this.yRounder.round(E) };
        } }]), H;
      }(), ae = function() {
        function H() {
          a(this, H), this.tree = new M(), this.round(0);
        }
        return u(H, [{ key: "round", value: function(S) {
          var E = this.tree.add(S), z = this.tree.prev(E);
          if (z !== null && ee(E.key, z.key) === 0)
            return this.tree.remove(S), z.key;
          var q = this.tree.next(E);
          return q !== null && ee(E.key, q.key) === 0 ? (this.tree.remove(S), q.key) : S;
        } }]), H;
      }(), ne = new X(), se = function(H, S) {
        return H.x * S.y - H.y * S.x;
      }, re = function(H, S) {
        return H.x * S.x + H.y * S.y;
      }, Q = function(H, S, E) {
        var z = { x: S.x - H.x, y: S.y - H.y }, q = { x: E.x - H.x, y: E.y - H.y }, J = se(z, q);
        return ee(J, 0);
      }, ke = function(H) {
        return Math.sqrt(re(H, H));
      }, Ae = function(H, S, E) {
        var z = { x: S.x - H.x, y: S.y - H.y }, q = { x: E.x - H.x, y: E.y - H.y };
        return se(q, z) / ke(q) / ke(z);
      }, pe = function(H, S, E) {
        var z = { x: S.x - H.x, y: S.y - H.y }, q = { x: E.x - H.x, y: E.y - H.y };
        return re(q, z) / ke(q) / ke(z);
      }, Ye = function(H, S, E) {
        return S.y === 0 ? null : { x: H.x + S.x / S.y * (E - H.y), y: E };
      }, ue = function(H, S, E) {
        return S.x === 0 ? null : { x: E, y: H.y + S.y / S.x * (E - H.x) };
      }, Fe = function(H, S, E, z) {
        if (S.x === 0)
          return ue(E, z, H.x);
        if (z.x === 0)
          return ue(H, S, E.x);
        if (S.y === 0)
          return Ye(E, z, H.y);
        if (z.y === 0)
          return Ye(H, S, E.y);
        var q = se(S, z);
        if (q == 0)
          return null;
        var J = { x: E.x - H.x, y: E.y - H.y }, me = se(J, S) / q, ye = se(J, z) / q;
        return { x: (H.x + ye * S.x + (E.x + me * z.x)) / 2, y: (H.y + ye * S.y + (E.y + me * z.y)) / 2 };
      }, Pe = function() {
        function H(S, E) {
          a(this, H), S.events === void 0 ? S.events = [this] : S.events.push(this), this.point = S, this.isLeft = E;
        }
        return u(H, null, [{ key: "compare", value: function(S, E) {
          var z = H.comparePoints(S.point, E.point);
          return z !== 0 ? z : (S.point !== E.point && S.link(E), S.isLeft !== E.isLeft ? S.isLeft ? 1 : -1 : Ve.compare(S.segment, E.segment));
        } }, { key: "comparePoints", value: function(S, E) {
          return S.x < E.x ? -1 : S.x > E.x ? 1 : S.y < E.y ? -1 : S.y > E.y ? 1 : 0;
        } }]), u(H, [{ key: "link", value: function(S) {
          if (S.point === this.point)
            throw new Error("Tried to link already linked events");
          for (var E = S.point.events, z = 0, q = E.length; z < q; z++) {
            var J = E[z];
            this.point.events.push(J), J.point = this.point;
          }
          this.checkForConsuming();
        } }, { key: "checkForConsuming", value: function() {
          for (var S = this.point.events.length, E = 0; E < S; E++) {
            var z = this.point.events[E];
            if (z.segment.consumedBy === void 0)
              for (var q = E + 1; q < S; q++) {
                var J = this.point.events[q];
                J.consumedBy === void 0 && z.otherSE.point.events === J.otherSE.point.events && z.segment.consume(J.segment);
              }
          }
        } }, { key: "getAvailableLinkedEvents", value: function() {
          for (var S = [], E = 0, z = this.point.events.length; E < z; E++) {
            var q = this.point.events[E];
            q !== this && !q.segment.ringOut && q.segment.isInResult() && S.push(q);
          }
          return S;
        } }, { key: "getLeftmostComparator", value: function(S) {
          var E = this, z = /* @__PURE__ */ new Map(), q = function(J) {
            var me = J.otherSE;
            z.set(J, { sine: Ae(E.point, S.point, me.point), cosine: pe(E.point, S.point, me.point) });
          };
          return function(J, me) {
            z.has(J) || q(J), z.has(me) || q(me);
            var ye = z.get(J), Oe = ye.sine, Ue = ye.cosine, at = z.get(me), Xe = at.sine, We = at.cosine;
            return Oe >= 0 && Xe >= 0 ? Ue < We ? 1 : Ue > We ? -1 : 0 : Oe < 0 && Xe < 0 ? Ue < We ? -1 : Ue > We ? 1 : 0 : Xe < Oe ? -1 : Xe > Oe ? 1 : 0;
          };
        } }]), H;
      }(), nt = 0, Ve = function() {
        function H(S, E, z, q) {
          a(this, H), this.id = ++nt, this.leftSE = S, S.segment = this, S.otherSE = E, this.rightSE = E, E.segment = this, E.otherSE = S, this.rings = z, this.windings = q;
        }
        return u(H, null, [{ key: "compare", value: function(S, E) {
          var z = S.leftSE.point.x, q = E.leftSE.point.x, J = S.rightSE.point.x, me = E.rightSE.point.x;
          if (me < z)
            return 1;
          if (J < q)
            return -1;
          var ye = S.leftSE.point.y, Oe = E.leftSE.point.y, Ue = S.rightSE.point.y, at = E.rightSE.point.y;
          if (z < q) {
            if (Oe < ye && Oe < Ue)
              return 1;
            if (Oe > ye && Oe > Ue)
              return -1;
            var Xe = S.comparePoint(E.leftSE.point);
            if (Xe < 0)
              return 1;
            if (Xe > 0)
              return -1;
            var We = E.comparePoint(S.rightSE.point);
            return We !== 0 ? We : -1;
          }
          if (z > q) {
            if (ye < Oe && ye < at)
              return -1;
            if (ye > Oe && ye > at)
              return 1;
            var xt = E.comparePoint(S.leftSE.point);
            if (xt !== 0)
              return xt;
            var lt = S.comparePoint(E.rightSE.point);
            return lt < 0 ? 1 : lt > 0 ? -1 : 1;
          }
          if (ye < Oe)
            return -1;
          if (ye > Oe)
            return 1;
          if (J < me) {
            var bt = E.comparePoint(S.rightSE.point);
            if (bt !== 0)
              return bt;
          }
          if (J > me) {
            var At = S.comparePoint(E.rightSE.point);
            if (At < 0)
              return 1;
            if (At > 0)
              return -1;
          }
          if (J !== me) {
            var Rt = Ue - ye, be = J - z, j = at - Oe, ge = me - q;
            if (Rt > be && j < ge)
              return 1;
            if (Rt < be && j > ge)
              return -1;
          }
          return J > me ? 1 : J < me || Ue < at ? -1 : Ue > at ? 1 : S.id < E.id ? -1 : S.id > E.id ? 1 : 0;
        } }]), u(H, [{ key: "replaceRightSE", value: function(S) {
          this.rightSE = S, this.rightSE.segment = this, this.rightSE.otherSE = this.leftSE, this.leftSE.otherSE = this.rightSE;
        } }, { key: "bbox", value: function() {
          var S = this.leftSE.point.y, E = this.rightSE.point.y;
          return { ll: { x: this.leftSE.point.x, y: S < E ? S : E }, ur: { x: this.rightSE.point.x, y: S > E ? S : E } };
        } }, { key: "vector", value: function() {
          return { x: this.rightSE.point.x - this.leftSE.point.x, y: this.rightSE.point.y - this.leftSE.point.y };
        } }, { key: "isAnEndpoint", value: function(S) {
          return S.x === this.leftSE.point.x && S.y === this.leftSE.point.y || S.x === this.rightSE.point.x && S.y === this.rightSE.point.y;
        } }, { key: "comparePoint", value: function(S) {
          if (this.isAnEndpoint(S))
            return 0;
          var E = this.leftSE.point, z = this.rightSE.point, q = this.vector();
          if (E.x === z.x)
            return S.x === E.x ? 0 : S.x < E.x ? 1 : -1;
          var J = (S.y - E.y) / q.y, me = E.x + J * q.x;
          if (S.x === me)
            return 0;
          var ye = (S.x - E.x) / q.x, Oe = E.y + ye * q.y;
          return S.y === Oe ? 0 : S.y < Oe ? -1 : 1;
        } }, { key: "getIntersection", value: function(S) {
          var E = this.bbox(), z = S.bbox(), q = $(E, z);
          if (q === null)
            return null;
          var J = this.leftSE.point, me = this.rightSE.point, ye = S.leftSE.point, Oe = S.rightSE.point, Ue = D(E, ye) && this.comparePoint(ye) === 0, at = D(z, J) && S.comparePoint(J) === 0, Xe = D(E, Oe) && this.comparePoint(Oe) === 0, We = D(z, me) && S.comparePoint(me) === 0;
          if (at && Ue)
            return We && !Xe ? me : !We && Xe ? Oe : null;
          if (at)
            return Xe && J.x === Oe.x && J.y === Oe.y ? null : J;
          if (Ue)
            return We && me.x === ye.x && me.y === ye.y ? null : ye;
          if (We && Xe)
            return null;
          if (We)
            return me;
          if (Xe)
            return Oe;
          var xt = Fe(J, this.vector(), ye, S.vector());
          return xt === null ? null : D(q, xt) ? ne.round(xt.x, xt.y) : null;
        } }, { key: "split", value: function(S) {
          var E = [], z = S.events !== void 0, q = new Pe(S, !0), J = new Pe(S, !1), me = this.rightSE;
          this.replaceRightSE(J), E.push(J), E.push(q);
          var ye = new H(q, me, this.rings.slice(), this.windings.slice());
          return Pe.comparePoints(ye.leftSE.point, ye.rightSE.point) > 0 && ye.swapEvents(), Pe.comparePoints(this.leftSE.point, this.rightSE.point) > 0 && this.swapEvents(), z && (q.checkForConsuming(), J.checkForConsuming()), E;
        } }, { key: "swapEvents", value: function() {
          var S = this.rightSE;
          this.rightSE = this.leftSE, this.leftSE = S, this.leftSE.isLeft = !0, this.rightSE.isLeft = !1;
          for (var E = 0, z = this.windings.length; E < z; E++)
            this.windings[E] *= -1;
        } }, { key: "consume", value: function(S) {
          for (var E = this, z = S; E.consumedBy; )
            E = E.consumedBy;
          for (; z.consumedBy; )
            z = z.consumedBy;
          var q = H.compare(E, z);
          if (q !== 0) {
            if (q > 0) {
              var J = E;
              E = z, z = J;
            }
            if (E.prev === z) {
              var me = E;
              E = z, z = me;
            }
            for (var ye = 0, Oe = z.rings.length; ye < Oe; ye++) {
              var Ue = z.rings[ye], at = z.windings[ye], Xe = E.rings.indexOf(Ue);
              Xe === -1 ? (E.rings.push(Ue), E.windings.push(at)) : E.windings[Xe] += at;
            }
            z.rings = null, z.windings = null, z.consumedBy = E, z.leftSE.consumedBy = E.leftSE, z.rightSE.consumedBy = E.rightSE;
          }
        } }, { key: "prevInResult", value: function() {
          return this._prevInResult !== void 0 || (this.prev ? this.prev.isInResult() ? this._prevInResult = this.prev : this._prevInResult = this.prev.prevInResult() : this._prevInResult = null), this._prevInResult;
        } }, { key: "beforeState", value: function() {
          if (this._beforeState !== void 0)
            return this._beforeState;
          if (this.prev) {
            var S = this.prev.consumedBy || this.prev;
            this._beforeState = S.afterState();
          } else
            this._beforeState = { rings: [], windings: [], multiPolys: [] };
          return this._beforeState;
        } }, { key: "afterState", value: function() {
          if (this._afterState !== void 0)
            return this._afterState;
          var S = this.beforeState();
          this._afterState = { rings: S.rings.slice(0), windings: S.windings.slice(0), multiPolys: [] };
          for (var E = this._afterState.rings, z = this._afterState.windings, q = this._afterState.multiPolys, J = 0, me = this.rings.length; J < me; J++) {
            var ye = this.rings[J], Oe = this.windings[J], Ue = E.indexOf(ye);
            Ue === -1 ? (E.push(ye), z.push(Oe)) : z[Ue] += Oe;
          }
          for (var at = [], Xe = [], We = 0, xt = E.length; We < xt; We++)
            if (z[We] !== 0) {
              var lt = E[We], bt = lt.poly;
              if (Xe.indexOf(bt) === -1)
                if (lt.isExterior)
                  at.push(bt);
                else {
                  Xe.indexOf(bt) === -1 && Xe.push(bt);
                  var At = at.indexOf(lt.poly);
                  At !== -1 && at.splice(At, 1);
                }
            }
          for (var Rt = 0, be = at.length; Rt < be; Rt++) {
            var j = at[Rt].multiPoly;
            q.indexOf(j) === -1 && q.push(j);
          }
          return this._afterState;
        } }, { key: "isInResult", value: function() {
          if (this.consumedBy)
            return !1;
          if (this._isInResult !== void 0)
            return this._isInResult;
          var S = this.beforeState().multiPolys, E = this.afterState().multiPolys;
          switch (It.type) {
            case "union":
              var z = S.length === 0, q = E.length === 0;
              this._isInResult = z !== q;
              break;
            case "intersection":
              var J, me;
              S.length < E.length ? (J = S.length, me = E.length) : (J = E.length, me = S.length), this._isInResult = me === It.numMultiPolys && J < me;
              break;
            case "xor":
              var ye = Math.abs(S.length - E.length);
              this._isInResult = ye % 2 == 1;
              break;
            case "difference":
              var Oe = function(Ue) {
                return Ue.length === 1 && Ue[0].isSubject;
              };
              this._isInResult = Oe(S) !== Oe(E);
              break;
            default:
              throw new Error("Unrecognized operation type found ".concat(It.type));
          }
          return this._isInResult;
        } }], [{ key: "fromRing", value: function(S, E, z) {
          var q, J, me, ye = Pe.comparePoints(S, E);
          if (ye < 0)
            q = S, J = E, me = 1;
          else {
            if (!(ye > 0))
              throw new Error("Tried to create degenerate segment at [".concat(S.x, ", ").concat(S.y, "]"));
            q = E, J = S, me = -1;
          }
          return new H(new Pe(q, !0), new Pe(J, !1), [z], [me]);
        } }]), H;
      }(), Ze = function() {
        function H(S, E, z) {
          if (a(this, H), !Array.isArray(S) || S.length === 0)
            throw new Error("Input geometry is not a valid Polygon or MultiPolygon");
          if (this.poly = E, this.isExterior = z, this.segments = [], typeof S[0][0] != "number" || typeof S[0][1] != "number")
            throw new Error("Input geometry is not a valid Polygon or MultiPolygon");
          var q = ne.round(S[0][0], S[0][1]);
          this.bbox = { ll: { x: q.x, y: q.y }, ur: { x: q.x, y: q.y } };
          for (var J = q, me = 1, ye = S.length; me < ye; me++) {
            if (typeof S[me][0] != "number" || typeof S[me][1] != "number")
              throw new Error("Input geometry is not a valid Polygon or MultiPolygon");
            var Oe = ne.round(S[me][0], S[me][1]);
            Oe.x === J.x && Oe.y === J.y || (this.segments.push(Ve.fromRing(J, Oe, this)), Oe.x < this.bbox.ll.x && (this.bbox.ll.x = Oe.x), Oe.y < this.bbox.ll.y && (this.bbox.ll.y = Oe.y), Oe.x > this.bbox.ur.x && (this.bbox.ur.x = Oe.x), Oe.y > this.bbox.ur.y && (this.bbox.ur.y = Oe.y), J = Oe);
          }
          q.x === J.x && q.y === J.y || this.segments.push(Ve.fromRing(J, q, this));
        }
        return u(H, [{ key: "getSweepEvents", value: function() {
          for (var S = [], E = 0, z = this.segments.length; E < z; E++) {
            var q = this.segments[E];
            S.push(q.leftSE), S.push(q.rightSE);
          }
          return S;
        } }]), H;
      }(), Ne = function() {
        function H(S, E) {
          if (a(this, H), !Array.isArray(S))
            throw new Error("Input geometry is not a valid Polygon or MultiPolygon");
          this.exteriorRing = new Ze(S[0], this, !0), this.bbox = { ll: { x: this.exteriorRing.bbox.ll.x, y: this.exteriorRing.bbox.ll.y }, ur: { x: this.exteriorRing.bbox.ur.x, y: this.exteriorRing.bbox.ur.y } }, this.interiorRings = [];
          for (var z = 1, q = S.length; z < q; z++) {
            var J = new Ze(S[z], this, !1);
            J.bbox.ll.x < this.bbox.ll.x && (this.bbox.ll.x = J.bbox.ll.x), J.bbox.ll.y < this.bbox.ll.y && (this.bbox.ll.y = J.bbox.ll.y), J.bbox.ur.x > this.bbox.ur.x && (this.bbox.ur.x = J.bbox.ur.x), J.bbox.ur.y > this.bbox.ur.y && (this.bbox.ur.y = J.bbox.ur.y), this.interiorRings.push(J);
          }
          this.multiPoly = E;
        }
        return u(H, [{ key: "getSweepEvents", value: function() {
          for (var S = this.exteriorRing.getSweepEvents(), E = 0, z = this.interiorRings.length; E < z; E++)
            for (var q = this.interiorRings[E].getSweepEvents(), J = 0, me = q.length; J < me; J++)
              S.push(q[J]);
          return S;
        } }]), H;
      }(), ft = function() {
        function H(S, E) {
          if (a(this, H), !Array.isArray(S))
            throw new Error("Input geometry is not a valid Polygon or MultiPolygon");
          try {
            typeof S[0][0][0] == "number" && (S = [S]);
          } catch {
          }
          this.polys = [], this.bbox = { ll: { x: Number.POSITIVE_INFINITY, y: Number.POSITIVE_INFINITY }, ur: { x: Number.NEGATIVE_INFINITY, y: Number.NEGATIVE_INFINITY } };
          for (var z = 0, q = S.length; z < q; z++) {
            var J = new Ne(S[z], this);
            J.bbox.ll.x < this.bbox.ll.x && (this.bbox.ll.x = J.bbox.ll.x), J.bbox.ll.y < this.bbox.ll.y && (this.bbox.ll.y = J.bbox.ll.y), J.bbox.ur.x > this.bbox.ur.x && (this.bbox.ur.x = J.bbox.ur.x), J.bbox.ur.y > this.bbox.ur.y && (this.bbox.ur.y = J.bbox.ur.y), this.polys.push(J);
          }
          this.isSubject = E;
        }
        return u(H, [{ key: "getSweepEvents", value: function() {
          for (var S = [], E = 0, z = this.polys.length; E < z; E++)
            for (var q = this.polys[E].getSweepEvents(), J = 0, me = q.length; J < me; J++)
              S.push(q[J]);
          return S;
        } }]), H;
      }(), pt = function() {
        function H(S) {
          a(this, H), this.events = S;
          for (var E = 0, z = S.length; E < z; E++)
            S[E].segment.ringOut = this;
          this.poly = null;
        }
        return u(H, null, [{ key: "factory", value: function(S) {
          for (var E = [], z = 0, q = S.length; z < q; z++) {
            var J = S[z];
            if (J.isInResult() && !J.ringOut) {
              for (var me = null, ye = J.leftSE, Oe = J.rightSE, Ue = [ye], at = ye.point, Xe = []; me = ye, ye = Oe, Ue.push(ye), ye.point !== at; )
                for (; ; ) {
                  var We = ye.getAvailableLinkedEvents();
                  if (We.length === 0) {
                    var xt = Ue[0].point, lt = Ue[Ue.length - 1].point;
                    throw new Error("Unable to complete output ring starting at [".concat(xt.x, ",") + " ".concat(xt.y, "]. Last matching segment found ends at") + " [".concat(lt.x, ", ").concat(lt.y, "]."));
                  }
                  if (We.length === 1) {
                    Oe = We[0].otherSE;
                    break;
                  }
                  for (var bt = null, At = 0, Rt = Xe.length; At < Rt; At++)
                    if (Xe[At].point === ye.point) {
                      bt = At;
                      break;
                    }
                  if (bt === null) {
                    Xe.push({ index: Ue.length, point: ye.point });
                    var be = ye.getLeftmostComparator(me);
                    Oe = We.sort(be)[0].otherSE;
                    break;
                  }
                  var j = Xe.splice(bt)[0], ge = Ue.splice(j.index);
                  ge.unshift(ge[0].otherSE), E.push(new H(ge.reverse()));
                }
              E.push(new H(Ue));
            }
          }
          return E;
        } }]), u(H, [{ key: "getGeom", value: function() {
          for (var S = this.events[0].point, E = [S], z = 1, q = this.events.length - 1; z < q; z++) {
            var J = this.events[z].point, me = this.events[z + 1].point;
            Q(J, S, me) !== 0 && (E.push(J), S = J);
          }
          if (E.length === 1)
            return null;
          var ye = E[0], Oe = E[1];
          Q(ye, S, Oe) === 0 && E.shift(), E.push(E[0]);
          for (var Ue = this.isExteriorRing() ? 1 : -1, at = this.isExteriorRing() ? 0 : E.length - 1, Xe = this.isExteriorRing() ? E.length : -1, We = [], xt = at; xt != Xe; xt += Ue)
            We.push([E[xt].x, E[xt].y]);
          return We;
        } }, { key: "isExteriorRing", value: function() {
          if (this._isExteriorRing === void 0) {
            var S = this.enclosingRing();
            this._isExteriorRing = !S || !S.isExteriorRing();
          }
          return this._isExteriorRing;
        } }, { key: "enclosingRing", value: function() {
          return this._enclosingRing === void 0 && (this._enclosingRing = this._calcEnclosingRing()), this._enclosingRing;
        } }, { key: "_calcEnclosingRing", value: function() {
          for (var S = this.events[0], E = 1, z = this.events.length; E < z; E++) {
            var q = this.events[E];
            Pe.compare(S, q) > 0 && (S = q);
          }
          for (var J = S.segment.prevInResult(), me = J ? J.prevInResult() : null; ; ) {
            if (!J)
              return null;
            if (!me)
              return J.ringOut;
            if (me.ringOut !== J.ringOut)
              return me.ringOut.enclosingRing() !== J.ringOut ? J.ringOut : J.ringOut.enclosingRing();
            J = me.prevInResult(), me = J ? J.prevInResult() : null;
          }
        } }]), H;
      }(), Wt = function() {
        function H(S) {
          a(this, H), this.exteriorRing = S, S.poly = this, this.interiorRings = [];
        }
        return u(H, [{ key: "addInterior", value: function(S) {
          this.interiorRings.push(S), S.poly = this;
        } }, { key: "getGeom", value: function() {
          var S = [this.exteriorRing.getGeom()];
          if (S[0] === null)
            return null;
          for (var E = 0, z = this.interiorRings.length; E < z; E++) {
            var q = this.interiorRings[E].getGeom();
            q !== null && S.push(q);
          }
          return S;
        } }]), H;
      }(), an = function() {
        function H(S) {
          a(this, H), this.rings = S, this.polys = this._composePolys(S);
        }
        return u(H, [{ key: "getGeom", value: function() {
          for (var S = [], E = 0, z = this.polys.length; E < z; E++) {
            var q = this.polys[E].getGeom();
            q !== null && S.push(q);
          }
          return S;
        } }, { key: "_composePolys", value: function(S) {
          for (var E = [], z = 0, q = S.length; z < q; z++) {
            var J = S[z];
            if (!J.poly)
              if (J.isExteriorRing())
                E.push(new Wt(J));
              else {
                var me = J.enclosingRing();
                me.poly || E.push(new Wt(me)), me.poly.addInterior(J);
              }
          }
          return E;
        } }]), H;
      }(), on = function() {
        function H(S) {
          var E = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Ve.compare;
          a(this, H), this.queue = S, this.tree = new M(E), this.segments = [];
        }
        return u(H, [{ key: "process", value: function(S) {
          var E = S.segment, z = [];
          if (S.consumedBy)
            return S.isLeft ? this.queue.remove(S.otherSE) : this.tree.remove(E), z;
          var q = S.isLeft ? this.tree.insert(E) : this.tree.find(E);
          if (!q)
            throw new Error("Unable to find segment #".concat(E.id, " ") + "[".concat(E.leftSE.point.x, ", ").concat(E.leftSE.point.y, "] -> ") + "[".concat(E.rightSE.point.x, ", ").concat(E.rightSE.point.y, "] ") + "in SweepLine tree. Please submit a bug report.");
          for (var J = q, me = q, ye = void 0, Oe = void 0; ye === void 0; )
            (J = this.tree.prev(J)) === null ? ye = null : J.key.consumedBy === void 0 && (ye = J.key);
          for (; Oe === void 0; )
            (me = this.tree.next(me)) === null ? Oe = null : me.key.consumedBy === void 0 && (Oe = me.key);
          if (S.isLeft) {
            var Ue = null;
            if (ye) {
              var at = ye.getIntersection(E);
              if (at !== null && (E.isAnEndpoint(at) || (Ue = at), !ye.isAnEndpoint(at)))
                for (var Xe = this._splitSafely(ye, at), We = 0, xt = Xe.length; We < xt; We++)
                  z.push(Xe[We]);
            }
            var lt = null;
            if (Oe) {
              var bt = Oe.getIntersection(E);
              if (bt !== null && (E.isAnEndpoint(bt) || (lt = bt), !Oe.isAnEndpoint(bt)))
                for (var At = this._splitSafely(Oe, bt), Rt = 0, be = At.length; Rt < be; Rt++)
                  z.push(At[Rt]);
            }
            if (Ue !== null || lt !== null) {
              var j = null;
              j = Ue === null ? lt : lt === null || Pe.comparePoints(Ue, lt) <= 0 ? Ue : lt, this.queue.remove(E.rightSE), z.push(E.rightSE);
              for (var ge = E.split(j), De = 0, N = ge.length; De < N; De++)
                z.push(ge[De]);
            }
            z.length > 0 ? (this.tree.remove(E), z.push(S)) : (this.segments.push(E), E.prev = ye);
          } else {
            if (ye && Oe) {
              var U = ye.getIntersection(Oe);
              if (U !== null) {
                if (!ye.isAnEndpoint(U))
                  for (var ie = this._splitSafely(ye, U), ve = 0, Ee = ie.length; ve < Ee; ve++)
                    z.push(ie[ve]);
                if (!Oe.isAnEndpoint(U))
                  for (var Ce = this._splitSafely(Oe, U), He = 0, Re = Ce.length; He < Re; He++)
                    z.push(Ce[He]);
              }
            }
            this.tree.remove(E);
          }
          return z;
        } }, { key: "_splitSafely", value: function(S, E) {
          this.tree.remove(S);
          var z = S.rightSE;
          this.queue.remove(z);
          var q = S.split(E);
          return q.push(z), S.consumedBy === void 0 && this.tree.insert(S), q;
        } }]), H;
      }(), Dt = typeof process < "u" && process.env.POLYGON_CLIPPING_MAX_QUEUE_SIZE || 1e6, Zt = typeof process < "u" && process.env.POLYGON_CLIPPING_MAX_SWEEPLINE_SEGMENTS || 1e6, It = new (function() {
        function H() {
          a(this, H);
        }
        return u(H, [{ key: "run", value: function(S, E, z) {
          It.type = S, ne.reset();
          for (var q = [new ft(E, !0)], J = 0, me = z.length; J < me; J++)
            q.push(new ft(z[J], !1));
          if (It.numMultiPolys = q.length, It.type === "difference")
            for (var ye = q[0], Oe = 1; Oe < q.length; )
              $(q[Oe].bbox, ye.bbox) !== null ? Oe++ : q.splice(Oe, 1);
          if (It.type === "intersection") {
            for (var Ue = 0, at = q.length; Ue < at; Ue++)
              for (var Xe = q[Ue], We = Ue + 1, xt = q.length; We < xt; We++)
                if ($(Xe.bbox, q[We].bbox) === null)
                  return [];
          }
          for (var lt = new M(Pe.compare), bt = 0, At = q.length; bt < At; bt++)
            for (var Rt = q[bt].getSweepEvents(), be = 0, j = Rt.length; be < j; be++)
              if (lt.insert(Rt[be]), lt.size > Dt)
                throw new Error("Infinite loop when putting segment endpoints in a priority queue (queue size too big). Please file a bug report.");
          for (var ge = new on(lt), De = lt.size, N = lt.pop(); N; ) {
            var U = N.key;
            if (lt.size === De) {
              var ie = U.segment;
              throw new Error("Unable to pop() ".concat(U.isLeft ? "left" : "right", " SweepEvent ") + "[".concat(U.point.x, ", ").concat(U.point.y, "] from segment #").concat(ie.id, " ") + "[".concat(ie.leftSE.point.x, ", ").concat(ie.leftSE.point.y, "] -> ") + "[".concat(ie.rightSE.point.x, ", ").concat(ie.rightSE.point.y, "] from queue. ") + "Please file a bug report.");
            }
            if (lt.size > Dt)
              throw new Error("Infinite loop when passing sweep line over endpoints (queue size too big). Please file a bug report.");
            if (ge.segments.length > Zt)
              throw new Error("Infinite loop when passing sweep line over endpoints (too many sweep line segments). Please file a bug report.");
            for (var ve = ge.process(U), Ee = 0, Ce = ve.length; Ee < Ce; Ee++) {
              var He = ve[Ee];
              He.consumedBy === void 0 && lt.insert(He);
            }
            De = lt.size, N = lt.pop();
          }
          ne.reset();
          var Re = pt.factory(ge.segments);
          return new an(Re).getGeom();
        } }]), H;
      }())(), bn = function(H) {
        for (var S = arguments.length, E = new Array(S > 1 ? S - 1 : 0), z = 1; z < S; z++)
          E[z - 1] = arguments[z];
        return It.run("union", H, E);
      }, qt = function(H) {
        for (var S = arguments.length, E = new Array(S > 1 ? S - 1 : 0), z = 1; z < S; z++)
          E[z - 1] = arguments[z];
        return It.run("intersection", H, E);
      }, cn = function(H) {
        for (var S = arguments.length, E = new Array(S > 1 ? S - 1 : 0), z = 1; z < S; z++)
          E[z - 1] = arguments[z];
        return It.run("xor", H, E);
      }, sn = function(H) {
        for (var S = arguments.length, E = new Array(S > 1 ? S - 1 : 0), z = 1; z < S; z++)
          E[z - 1] = arguments[z];
        return It.run("difference", H, E);
      };
      return { union: bn, intersection: qt, xor: cn, difference: sn };
    }();
  }, 2582: function(r) {
    r.exports = function() {
      function a(P, D, $, Y, G) {
        (function ee(X, ae, ne, se, re) {
          for (; se > ne; ) {
            if (se - ne > 600) {
              var Q = se - ne + 1, ke = ae - ne + 1, Ae = Math.log(Q), pe = 0.5 * Math.exp(2 * Ae / 3), Ye = 0.5 * Math.sqrt(Ae * pe * (Q - pe) / Q) * (ke - Q / 2 < 0 ? -1 : 1);
              ee(X, ae, Math.max(ne, Math.floor(ae - ke * pe / Q + Ye)), Math.min(se, Math.floor(ae + (Q - ke) * pe / Q + Ye)), re);
            }
            var ue = X[ae], Fe = ne, Pe = se;
            for (l(X, ne, ae), re(X[se], ue) > 0 && l(X, ne, se); Fe < Pe; ) {
              for (l(X, Fe, Pe), Fe++, Pe--; re(X[Fe], ue) < 0; )
                Fe++;
              for (; re(X[Pe], ue) > 0; )
                Pe--;
            }
            re(X[ne], ue) === 0 ? l(X, ne, Pe) : l(X, ++Pe, se), Pe <= ae && (ne = Pe + 1), ae <= Pe && (se = Pe - 1);
          }
        })(P, D, $ || 0, Y || P.length - 1, G || u);
      }
      function l(P, D, $) {
        var Y = P[D];
        P[D] = P[$], P[$] = Y;
      }
      function u(P, D) {
        return P < D ? -1 : P > D ? 1 : 0;
      }
      var h = function(P) {
        P === void 0 && (P = 9), this._maxEntries = Math.max(4, P), this._minEntries = Math.max(2, Math.ceil(0.4 * this._maxEntries)), this.clear();
      };
      function f(P, D, $) {
        if (!$)
          return D.indexOf(P);
        for (var Y = 0; Y < D.length; Y++)
          if ($(P, D[Y]))
            return Y;
        return -1;
      }
      function m(P, D) {
        v(P, 0, P.children.length, D, P);
      }
      function v(P, D, $, Y, G) {
        G || (G = T(null)), G.minX = 1 / 0, G.minY = 1 / 0, G.maxX = -1 / 0, G.maxY = -1 / 0;
        for (var ee = D; ee < $; ee++) {
          var X = P.children[ee];
          y(G, P.leaf ? Y(X) : X);
        }
        return G;
      }
      function y(P, D) {
        return P.minX = Math.min(P.minX, D.minX), P.minY = Math.min(P.minY, D.minY), P.maxX = Math.max(P.maxX, D.maxX), P.maxY = Math.max(P.maxY, D.maxY), P;
      }
      function k(P, D) {
        return P.minX - D.minX;
      }
      function x(P, D) {
        return P.minY - D.minY;
      }
      function M(P) {
        return (P.maxX - P.minX) * (P.maxY - P.minY);
      }
      function O(P) {
        return P.maxX - P.minX + (P.maxY - P.minY);
      }
      function R(P, D) {
        return P.minX <= D.minX && P.minY <= D.minY && D.maxX <= P.maxX && D.maxY <= P.maxY;
      }
      function C(P, D) {
        return D.minX <= P.maxX && D.minY <= P.maxY && D.maxX >= P.minX && D.maxY >= P.minY;
      }
      function T(P) {
        return { children: P, height: 1, leaf: !0, minX: 1 / 0, minY: 1 / 0, maxX: -1 / 0, maxY: -1 / 0 };
      }
      function A(P, D, $, Y, G) {
        for (var ee = [D, $]; ee.length; )
          if (!(($ = ee.pop()) - (D = ee.pop()) <= Y)) {
            var X = D + Math.ceil(($ - D) / Y / 2) * Y;
            a(P, X, D, $, G), ee.push(D, X, X, $);
          }
      }
      return h.prototype.all = function() {
        return this._all(this.data, []);
      }, h.prototype.search = function(P) {
        var D = this.data, $ = [];
        if (!C(P, D))
          return $;
        for (var Y = this.toBBox, G = []; D; ) {
          for (var ee = 0; ee < D.children.length; ee++) {
            var X = D.children[ee], ae = D.leaf ? Y(X) : X;
            C(P, ae) && (D.leaf ? $.push(X) : R(P, ae) ? this._all(X, $) : G.push(X));
          }
          D = G.pop();
        }
        return $;
      }, h.prototype.collides = function(P) {
        var D = this.data;
        if (!C(P, D))
          return !1;
        for (var $ = []; D; ) {
          for (var Y = 0; Y < D.children.length; Y++) {
            var G = D.children[Y], ee = D.leaf ? this.toBBox(G) : G;
            if (C(P, ee)) {
              if (D.leaf || R(P, ee))
                return !0;
              $.push(G);
            }
          }
          D = $.pop();
        }
        return !1;
      }, h.prototype.load = function(P) {
        if (!P || !P.length)
          return this;
        if (P.length < this._minEntries) {
          for (var D = 0; D < P.length; D++)
            this.insert(P[D]);
          return this;
        }
        var $ = this._build(P.slice(), 0, P.length - 1, 0);
        if (this.data.children.length)
          if (this.data.height === $.height)
            this._splitRoot(this.data, $);
          else {
            if (this.data.height < $.height) {
              var Y = this.data;
              this.data = $, $ = Y;
            }
            this._insert($, this.data.height - $.height - 1, !0);
          }
        else
          this.data = $;
        return this;
      }, h.prototype.insert = function(P) {
        return P && this._insert(P, this.data.height - 1), this;
      }, h.prototype.clear = function() {
        return this.data = T([]), this;
      }, h.prototype.remove = function(P, D) {
        if (!P)
          return this;
        for (var $, Y, G, ee = this.data, X = this.toBBox(P), ae = [], ne = []; ee || ae.length; ) {
          if (ee || (ee = ae.pop(), Y = ae[ae.length - 1], $ = ne.pop(), G = !0), ee.leaf) {
            var se = f(P, ee.children, D);
            if (se !== -1)
              return ee.children.splice(se, 1), ae.push(ee), this._condense(ae), this;
          }
          G || ee.leaf || !R(ee, X) ? Y ? ($++, ee = Y.children[$], G = !1) : ee = null : (ae.push(ee), ne.push($), $ = 0, Y = ee, ee = ee.children[0]);
        }
        return this;
      }, h.prototype.toBBox = function(P) {
        return P;
      }, h.prototype.compareMinX = function(P, D) {
        return P.minX - D.minX;
      }, h.prototype.compareMinY = function(P, D) {
        return P.minY - D.minY;
      }, h.prototype.toJSON = function() {
        return this.data;
      }, h.prototype.fromJSON = function(P) {
        return this.data = P, this;
      }, h.prototype._all = function(P, D) {
        for (var $ = []; P; )
          P.leaf ? D.push.apply(D, P.children) : $.push.apply($, P.children), P = $.pop();
        return D;
      }, h.prototype._build = function(P, D, $, Y) {
        var G, ee = $ - D + 1, X = this._maxEntries;
        if (ee <= X)
          return m(G = T(P.slice(D, $ + 1)), this.toBBox), G;
        Y || (Y = Math.ceil(Math.log(ee) / Math.log(X)), X = Math.ceil(ee / Math.pow(X, Y - 1))), (G = T([])).leaf = !1, G.height = Y;
        var ae = Math.ceil(ee / X), ne = ae * Math.ceil(Math.sqrt(X));
        A(P, D, $, ne, this.compareMinX);
        for (var se = D; se <= $; se += ne) {
          var re = Math.min(se + ne - 1, $);
          A(P, se, re, ae, this.compareMinY);
          for (var Q = se; Q <= re; Q += ae) {
            var ke = Math.min(Q + ae - 1, re);
            G.children.push(this._build(P, Q, ke, Y - 1));
          }
        }
        return m(G, this.toBBox), G;
      }, h.prototype._chooseSubtree = function(P, D, $, Y) {
        for (; Y.push(D), !D.leaf && Y.length - 1 !== $; ) {
          for (var G = 1 / 0, ee = 1 / 0, X = void 0, ae = 0; ae < D.children.length; ae++) {
            var ne = D.children[ae], se = M(ne), re = (Q = P, ke = ne, (Math.max(ke.maxX, Q.maxX) - Math.min(ke.minX, Q.minX)) * (Math.max(ke.maxY, Q.maxY) - Math.min(ke.minY, Q.minY)) - se);
            re < ee ? (ee = re, G = se < G ? se : G, X = ne) : re === ee && se < G && (G = se, X = ne);
          }
          D = X || D.children[0];
        }
        var Q, ke;
        return D;
      }, h.prototype._insert = function(P, D, $) {
        var Y = $ ? P : this.toBBox(P), G = [], ee = this._chooseSubtree(Y, this.data, D, G);
        for (ee.children.push(P), y(ee, Y); D >= 0 && G[D].children.length > this._maxEntries; )
          this._split(G, D), D--;
        this._adjustParentBBoxes(Y, G, D);
      }, h.prototype._split = function(P, D) {
        var $ = P[D], Y = $.children.length, G = this._minEntries;
        this._chooseSplitAxis($, G, Y);
        var ee = this._chooseSplitIndex($, G, Y), X = T($.children.splice(ee, $.children.length - ee));
        X.height = $.height, X.leaf = $.leaf, m($, this.toBBox), m(X, this.toBBox), D ? P[D - 1].children.push(X) : this._splitRoot($, X);
      }, h.prototype._splitRoot = function(P, D) {
        this.data = T([P, D]), this.data.height = P.height + 1, this.data.leaf = !1, m(this.data, this.toBBox);
      }, h.prototype._chooseSplitIndex = function(P, D, $) {
        for (var Y, G, ee, X, ae, ne, se, re = 1 / 0, Q = 1 / 0, ke = D; ke <= $ - D; ke++) {
          var Ae = v(P, 0, ke, this.toBBox), pe = v(P, ke, $, this.toBBox), Ye = (G = Ae, ee = pe, X = void 0, ae = void 0, ne = void 0, se = void 0, X = Math.max(G.minX, ee.minX), ae = Math.max(G.minY, ee.minY), ne = Math.min(G.maxX, ee.maxX), se = Math.min(G.maxY, ee.maxY), Math.max(0, ne - X) * Math.max(0, se - ae)), ue = M(Ae) + M(pe);
          Ye < re ? (re = Ye, Y = ke, Q = ue < Q ? ue : Q) : Ye === re && ue < Q && (Q = ue, Y = ke);
        }
        return Y || $ - D;
      }, h.prototype._chooseSplitAxis = function(P, D, $) {
        var Y = P.leaf ? this.compareMinX : k, G = P.leaf ? this.compareMinY : x;
        this._allDistMargin(P, D, $, Y) < this._allDistMargin(P, D, $, G) && P.children.sort(Y);
      }, h.prototype._allDistMargin = function(P, D, $, Y) {
        P.children.sort(Y);
        for (var G = this.toBBox, ee = v(P, 0, D, G), X = v(P, $ - D, $, G), ae = O(ee) + O(X), ne = D; ne < $ - D; ne++) {
          var se = P.children[ne];
          y(ee, P.leaf ? G(se) : se), ae += O(ee);
        }
        for (var re = $ - D - 1; re >= D; re--) {
          var Q = P.children[re];
          y(X, P.leaf ? G(Q) : Q), ae += O(X);
        }
        return ae;
      }, h.prototype._adjustParentBBoxes = function(P, D, $) {
        for (var Y = $; Y >= 0; Y--)
          y(D[Y], P);
      }, h.prototype._condense = function(P) {
        for (var D = P.length - 1, $ = void 0; D >= 0; D--)
          P[D].children.length === 0 ? D > 0 ? ($ = P[D - 1].children).splice($.indexOf(P[D]), 1) : this.clear() : m(P[D], this.toBBox);
      }, h;
    }();
  } }, t = {};
  function n(r) {
    var a = t[r];
    if (a !== void 0)
      return a.exports;
    var l = t[r] = { id: r, loaded: !1, exports: {} };
    return e[r].call(l.exports, l, l.exports, n), l.loaded = !0, l.exports;
  }
  n.n = (r) => {
    var a = r && r.__esModule ? () => r.default : () => r;
    return n.d(a, { a }), a;
  }, n.d = (r, a) => {
    for (var l in a)
      n.o(a, l) && !n.o(r, l) && Object.defineProperty(r, l, { enumerable: !0, get: a[l] });
  }, n.g = function() {
    if (typeof globalThis == "object")
      return globalThis;
    try {
      return this || new Function("return this")();
    } catch {
      if (typeof window == "object")
        return window;
    }
  }(), n.o = (r, a) => Object.prototype.hasOwnProperty.call(r, a), n.nmd = (r) => (r.paths = [], r.children || (r.children = []), r), (() => {
    n(7107);
    var r = n(2492), a = n.n(r);
    const l = JSON.parse('{"tooltips":{"placeMarker":"Click to place marker","firstVertex":"Click to place first vertex","continueLine":"Click to continue drawing","finishLine":"Click any existing marker to finish","finishPoly":"Click first marker to finish","finishRect":"Click to finish","startCircle":"Click to place circle center","finishCircle":"Click to finish circle","placeCircleMarker":"Click to place circle marker","placeText":"Click to place text"},"actions":{"finish":"Finish","cancel":"Cancel","removeLastVertex":"Remove Last Vertex"},"buttonTitles":{"drawMarkerButton":"Draw Marker","drawPolyButton":"Draw Polygons","drawLineButton":"Draw Polyline","drawCircleButton":"Draw Circle","drawRectButton":"Draw Rectangle","editButton":"Edit Layers","dragButton":"Drag Layers","cutButton":"Cut Layers","deleteButton":"Remove Layers","drawCircleMarkerButton":"Draw Circle Marker","snappingButton":"Snap dragged marker to other layers and vertices","pinningButton":"Pin shared vertices together","rotateButton":"Rotate Layers","drawTextButton":"Draw Text","scaleButton":"Scale Layers","autoTracingButton":"Auto trace Line"},"measurements":{"totalLength":"Length","segmentLength":"Segment length","area":"Area","radius":"Radius","perimeter":"Perimeter","height":"Height","width":"Width","coordinates":"Position","coordinatesMarker":"Position Marker"}}'), u = JSON.parse('{"tooltips":{"placeMarker":"Platziere den Marker mit Klick","firstVertex":"Platziere den ersten Marker mit Klick","continueLine":"Klicke, um weiter zu zeichnen","finishLine":"Beende mit Klick auf existierenden Marker","finishPoly":"Beende mit Klick auf ersten Marker","finishRect":"Beende mit Klick","startCircle":"Platziere das Kreiszentrum mit Klick","finishCircle":"Beende den Kreis mit Klick","placeCircleMarker":"Platziere den Kreismarker mit Klick","placeText":"Platziere den Text mit Klick"},"actions":{"finish":"Beenden","cancel":"Abbrechen","removeLastVertex":"Letzten Vertex löschen"},"buttonTitles":{"drawMarkerButton":"Marker zeichnen","drawPolyButton":"Polygon zeichnen","drawLineButton":"Polyline zeichnen","drawCircleButton":"Kreis zeichnen","drawRectButton":"Rechteck zeichnen","editButton":"Layer editieren","dragButton":"Layer bewegen","cutButton":"Layer schneiden","deleteButton":"Layer löschen","drawCircleMarkerButton":"Kreismarker zeichnen","snappingButton":"Bewegter Layer an andere Layer oder Vertexe einhacken","pinningButton":"Vertexe an der gleichen Position verknüpfen","rotateButton":"Layer drehen","drawTextButton":"Text zeichnen","scaleButton":"Layer skalieren","autoTracingButton":"Linie automatisch nachzeichen"},"measurements":{"totalLength":"Länge","segmentLength":"Segment Länge","area":"Fläche","radius":"Radius","perimeter":"Umfang","height":"Höhe","width":"Breite","coordinates":"Position","coordinatesMarker":"Position Marker"}}'), h = JSON.parse(`{"tooltips":{"placeMarker":"Clicca per posizionare un Marker","firstVertex":"Clicca per posizionare il primo vertice","continueLine":"Clicca per continuare a disegnare","finishLine":"Clicca qualsiasi marker esistente per terminare","finishPoly":"Clicca il primo marker per terminare","finishRect":"Clicca per terminare","startCircle":"Clicca per posizionare il punto centrale del cerchio","finishCircle":"Clicca per terminare il cerchio","placeCircleMarker":"Clicca per posizionare un Marker del cherchio"},"actions":{"finish":"Termina","cancel":"Annulla","removeLastVertex":"Rimuovi l'ultimo vertice"},"buttonTitles":{"drawMarkerButton":"Disegna Marker","drawPolyButton":"Disegna Poligoni","drawLineButton":"Disegna Polilinea","drawCircleButton":"Disegna Cerchio","drawRectButton":"Disegna Rettangolo","editButton":"Modifica Livelli","dragButton":"Sposta Livelli","cutButton":"Ritaglia Livelli","deleteButton":"Elimina Livelli","drawCircleMarkerButton":"Disegna Marker del Cerchio","snappingButton":"Snap ha trascinato il pennarello su altri strati e vertici","pinningButton":"Pin condiviso vertici insieme"}}`), f = JSON.parse('{"tooltips":{"placeMarker":"Klik untuk menempatkan marker","firstVertex":"Klik untuk menempatkan vertex pertama","continueLine":"Klik untuk meneruskan digitasi","finishLine":"Klik pada sembarang marker yang ada untuk mengakhiri","finishPoly":"Klik marker pertama untuk mengakhiri","finishRect":"Klik untuk mengakhiri","startCircle":"Klik untuk menempatkan titik pusat lingkaran","finishCircle":"Klik untuk mengakhiri lingkaran","placeCircleMarker":"Klik untuk menempatkan penanda lingkarann"},"actions":{"finish":"Selesai","cancel":"Batal","removeLastVertex":"Hilangkan Vertex Terakhir"},"buttonTitles":{"drawMarkerButton":"Digitasi Marker","drawPolyButton":"Digitasi Polygon","drawLineButton":"Digitasi Polyline","drawCircleButton":"Digitasi Lingkaran","drawRectButton":"Digitasi Segi Empat","editButton":"Edit Layer","dragButton":"Geser Layer","cutButton":"Potong Layer","deleteButton":"Hilangkan Layer","drawCircleMarkerButton":"Digitasi Penanda Lingkaran","snappingButton":"Jepretkan penanda yang ditarik ke lapisan dan simpul lain","pinningButton":"Sematkan simpul bersama bersama"}}'), m = JSON.parse('{"tooltips":{"placeMarker":"Adaugă un punct","firstVertex":"Apasă aici pentru a adăuga primul Vertex","continueLine":"Apasă aici pentru a continua desenul","finishLine":"Apasă pe orice obiect pentru a finisa desenul","finishPoly":"Apasă pe primul obiect pentru a finisa","finishRect":"Apasă pentru a finisa","startCircle":"Apasă pentru a desena un cerc","finishCircle":"Apasă pentru a finisa un cerc","placeCircleMarker":"Adaugă un punct"},"actions":{"finish":"Termină","cancel":"Anulează","removeLastVertex":"Șterge ultimul Vertex"},"buttonTitles":{"drawMarkerButton":"Adaugă o bulină","drawPolyButton":"Desenează un poligon","drawLineButton":"Desenează o linie","drawCircleButton":"Desenează un cerc","drawRectButton":"Desenează un dreptunghi","editButton":"Editează straturile","dragButton":"Mută straturile","cutButton":"Taie straturile","deleteButton":"Șterge straturile","drawCircleMarkerButton":"Desenează marcatorul cercului","snappingButton":"Fixați marcatorul glisat pe alte straturi și vârfuri","pinningButton":"Fixați vârfurile partajate împreună"}}'), v = JSON.parse('{"tooltips":{"placeMarker":"Нажмите, чтобы нанести маркер","firstVertex":"Нажмите, чтобы нанести первый объект","continueLine":"Нажмите, чтобы продолжить рисование","finishLine":"Нажмите любой существующий маркер для завершения","finishPoly":"Выберите первую точку, чтобы закончить","finishRect":"Нажмите, чтобы закончить","startCircle":"Нажмите, чтобы добавить центр круга","finishCircle":"Нажмите, чтобы задать радиус","placeCircleMarker":"Нажмите, чтобы нанести круговой маркер"},"actions":{"finish":"Завершить","cancel":"Отменить","removeLastVertex":"Отменить последнее действие"},"buttonTitles":{"drawMarkerButton":"Добавить маркер","drawPolyButton":"Рисовать полигон","drawLineButton":"Рисовать кривую","drawCircleButton":"Рисовать круг","drawRectButton":"Рисовать прямоугольник","editButton":"Редактировать слой","dragButton":"Перенести слой","cutButton":"Вырезать слой","deleteButton":"Удалить слой","drawCircleMarkerButton":"Добавить круговой маркер","snappingButton":"Привязать перетаскиваемый маркер к другим слоям и вершинам","pinningButton":"Связать общие точки вместе"}}'), y = JSON.parse('{"tooltips":{"placeMarker":"Presiona para colocar un marcador","firstVertex":"Presiona para colocar el primer vértice","continueLine":"Presiona para continuar dibujando","finishLine":"Presiona cualquier marcador existente para finalizar","finishPoly":"Presiona el primer marcador para finalizar","finishRect":"Presiona para finalizar","startCircle":"Presiona para colocar el centro del círculo","finishCircle":"Presiona para finalizar el círculo","placeCircleMarker":"Presiona para colocar un marcador de círculo"},"actions":{"finish":"Finalizar","cancel":"Cancelar","removeLastVertex":"Eliminar último vértice"},"buttonTitles":{"drawMarkerButton":"Dibujar Marcador","drawPolyButton":"Dibujar Polígono","drawLineButton":"Dibujar Línea","drawCircleButton":"Dibujar Círculo","drawRectButton":"Dibujar Rectángulo","editButton":"Editar Capas","dragButton":"Arrastrar Capas","cutButton":"Cortar Capas","deleteButton":"Eliminar Capas","drawCircleMarkerButton":"Dibujar Marcador de Círculo","snappingButton":"El marcador de Snap arrastrado a otras capas y vértices","pinningButton":"Fijar juntos los vértices compartidos"}}'), k = JSON.parse('{"tooltips":{"placeMarker":"Klik om een marker te plaatsen","firstVertex":"Klik om het eerste punt te plaatsen","continueLine":"Klik om te blijven tekenen","finishLine":"Klik op een bestaand punt om te beëindigen","finishPoly":"Klik op het eerst punt om te beëindigen","finishRect":"Klik om te beëindigen","startCircle":"Klik om het middelpunt te plaatsen","finishCircle":"Klik om de cirkel te beëindigen","placeCircleMarker":"Klik om een marker te plaatsen"},"actions":{"finish":"Bewaar","cancel":"Annuleer","removeLastVertex":"Verwijder laatste punt"},"buttonTitles":{"drawMarkerButton":"Plaats Marker","drawPolyButton":"Teken een vlak","drawLineButton":"Teken een lijn","drawCircleButton":"Teken een cirkel","drawRectButton":"Teken een vierkant","editButton":"Bewerk","dragButton":"Verplaats","cutButton":"Knip","deleteButton":"Verwijder","drawCircleMarkerButton":"Plaats Marker","snappingButton":"Snap gesleepte marker naar andere lagen en hoekpunten","pinningButton":"Speld gedeelde hoekpunten samen"}}'), x = JSON.parse(`{"tooltips":{"placeMarker":"Cliquez pour placer un marqueur","firstVertex":"Cliquez pour placer le premier sommet","continueLine":"Cliquez pour continuer à dessiner","finishLine":"Cliquez sur n'importe quel marqueur pour terminer","finishPoly":"Cliquez sur le premier marqueur pour terminer","finishRect":"Cliquez pour terminer","startCircle":"Cliquez pour placer le centre du cercle","finishCircle":"Cliquez pour finir le cercle","placeCircleMarker":"Cliquez pour placer le marqueur circulaire"},"actions":{"finish":"Terminer","cancel":"Annuler","removeLastVertex":"Retirer le dernier sommet"},"buttonTitles":{"drawMarkerButton":"Placer des marqueurs","drawPolyButton":"Dessiner des polygones","drawLineButton":"Dessiner des polylignes","drawCircleButton":"Dessiner un cercle","drawRectButton":"Dessiner un rectangle","editButton":"Éditer des calques","dragButton":"Déplacer des calques","cutButton":"Couper des calques","deleteButton":"Supprimer des calques","drawCircleMarkerButton":"Dessiner un marqueur circulaire","snappingButton":"Glisser le marqueur vers d'autres couches et sommets","pinningButton":"Épingler ensemble les sommets partagés","rotateButton":"Tourner des calques"}}`), M = JSON.parse('{"tooltips":{"placeMarker":"单击放置标记","firstVertex":"单击放置首个顶点","continueLine":"单击继续绘制","finishLine":"单击任何存在的标记以完成","finishPoly":"单击第一个标记以完成","finishRect":"单击完成","startCircle":"单击放置圆心","finishCircle":"单击完成圆形","placeCircleMarker":"点击放置圆形标记"},"actions":{"finish":"完成","cancel":"取消","removeLastVertex":"移除最后的顶点"},"buttonTitles":{"drawMarkerButton":"绘制标记","drawPolyButton":"绘制多边形","drawLineButton":"绘制线段","drawCircleButton":"绘制圆形","drawRectButton":"绘制长方形","editButton":"编辑图层","dragButton":"拖拽图层","cutButton":"剪切图层","deleteButton":"删除图层","drawCircleMarkerButton":"画圆圈标记","snappingButton":"将拖动的标记捕捉到其他图层和顶点","pinningButton":"将共享顶点固定在一起"}}'), O = JSON.parse('{"tooltips":{"placeMarker":"單擊放置標記","firstVertex":"單擊放置第一個頂點","continueLine":"單擊繼續繪製","finishLine":"單擊任何存在的標記以完成","finishPoly":"單擊第一個標記以完成","finishRect":"單擊完成","startCircle":"單擊放置圓心","finishCircle":"單擊完成圓形","placeCircleMarker":"點擊放置圓形標記"},"actions":{"finish":"完成","cancel":"取消","removeLastVertex":"移除最後一個頂點"},"buttonTitles":{"drawMarkerButton":"放置標記","drawPolyButton":"繪製多邊形","drawLineButton":"繪製線段","drawCircleButton":"繪製圓形","drawRectButton":"繪製方形","editButton":"編輯圖形","dragButton":"移動圖形","cutButton":"裁切圖形","deleteButton":"刪除圖形","drawCircleMarkerButton":"畫圓圈標記","snappingButton":"將拖動的標記對齊到其他圖層和頂點","pinningButton":"將共享頂點固定在一起"}}'), R = { en: l, de: u, it: h, id: f, ro: m, ru: v, es: y, nl: k, fr: x, pt_br: JSON.parse('{"tooltips":{"placeMarker":"Clique para posicionar o marcador","firstVertex":"Clique para posicionar o primeiro vértice","continueLine":"Clique para continuar desenhando","finishLine":"Clique em qualquer marcador existente para finalizar","finishPoly":"Clique no primeiro ponto para fechar o polígono","finishRect":"Clique para finalizar","startCircle":"Clique para posicionar o centro do círculo","finishCircle":"Clique para fechar o círculo","placeCircleMarker":"Clique para posicionar o marcador circular"},"actions":{"finish":"Finalizar","cancel":"Cancelar","removeLastVertex":"Remover último vértice"},"buttonTitles":{"drawMarkerButton":"Desenhar um marcador","drawPolyButton":"Desenhar um polígono","drawLineButton":"Desenhar uma polilinha","drawCircleButton":"Desenhar um círculo","drawRectButton":"Desenhar um retângulo","editButton":"Editar camada(s)","dragButton":"Mover camada(s)","cutButton":"Recortar camada(s)","deleteButton":"Remover camada(s)","drawCircleMarkerButton":"Marcador de círculos de desenho","snappingButton":"Marcador arrastado para outras camadas e vértices","pinningButton":"Vértices compartilhados de pinos juntos"}}'), zh: M, zh_tw: O, pl: JSON.parse('{"tooltips":{"placeMarker":"Kliknij, aby umieścić znacznik","firstVertex":"Kliknij, aby umieścić pierwszy wierzchołek","continueLine":"Kliknij, aby kontynuować rysowanie","finishLine":"Kliknij dowolny istniejący znacznik, aby zakończyć","finishPoly":"Kliknij pierwszy znacznik, aby zakończyć","finishRect":"Kliknij, aby zakończyć","startCircle":"Kliknij, aby umieścić środek okręgu","finishCircle":"Kliknij, aby zakończyć okrąg","placeCircleMarker":"Kliknij, aby umieścić znacznik okręgu","placeText":"Kliknij, aby umieścić tekst"},"actions":{"finish":"Zakończ","cancel":"Anuluj","removeLastVertex":"Usuń ostatni wierzchołek"},"buttonTitles":{"drawMarkerButton":"Rysuj znacznik","drawPolyButton":"Rysuj wielokąt","drawLineButton":"Rysuj linię","drawCircleButton":"Rysuj okrąg","drawRectButton":"Rysuj prostokąt","editButton":"Edytuj warstwy","dragButton":"Przeciągnij warstwy","cutButton":"Wytnij warstwy","deleteButton":"Usuń warstwy","drawCircleMarkerButton":"Rysuj znacznik okrągły","snappingButton":"Przyciągnij przenoszony znacznik do innych warstw i wierzchołków","pinningButton":"Przypnij wspólne wierzchołki razem","rotateButton":"Obróć warstwy","drawTextButton":"Rysuj tekst","scaleButton":"Skaluj warstwy","autoTracingButton":"Automatyczne śledzenie linii"},"measurements":{"totalLength":"Długość","segmentLength":"Długość odcinka","area":"Obszar","radius":"Promień","perimeter":"Obwód","height":"Wysokość","width":"Szerokość","coordinates":"Pozycja","coordinatesMarker":"Znacznik pozycji"}}'), sv: JSON.parse('{"tooltips":{"placeMarker":"Klicka för att placera markör","firstVertex":"Klicka för att placera första hörnet","continueLine":"Klicka för att fortsätta rita","finishLine":"Klicka på en existerande punkt för att slutföra","finishPoly":"Klicka på den första punkten för att slutföra","finishRect":"Klicka för att slutföra","startCircle":"Klicka för att placera cirkelns centrum","finishCircle":"Klicka för att slutföra cirkeln","placeCircleMarker":"Klicka för att placera cirkelmarkör"},"actions":{"finish":"Slutför","cancel":"Avbryt","removeLastVertex":"Ta bort sista hörnet"},"buttonTitles":{"drawMarkerButton":"Rita Markör","drawPolyButton":"Rita Polygoner","drawLineButton":"Rita Linje","drawCircleButton":"Rita Cirkel","drawRectButton":"Rita Rektangel","editButton":"Redigera Lager","dragButton":"Dra Lager","cutButton":"Klipp i Lager","deleteButton":"Ta bort Lager","drawCircleMarkerButton":"Rita Cirkelmarkör","snappingButton":"Snäpp dra markören till andra lager och hörn","pinningButton":"Fäst delade hörn tillsammans"}}'), el: JSON.parse('{"tooltips":{"placeMarker":"Κάντε κλικ για να τοποθετήσετε Δείκτη","firstVertex":"Κάντε κλικ για να τοποθετήσετε το πρώτο σημείο","continueLine":"Κάντε κλικ για να συνεχίσετε να σχεδιάζετε","finishLine":"Κάντε κλικ σε οποιονδήποτε υπάρχον σημείο για να ολοκληρωθεί","finishPoly":"Κάντε κλικ στο πρώτο σημείο για να τελειώσετε","finishRect":"Κάντε κλικ για να τελειώσετε","startCircle":"Κάντε κλικ για να τοποθετήσετε κέντρο Κύκλου","finishCircle":"Κάντε κλικ για να ολοκληρώσετε τον Κύκλο","placeCircleMarker":"Κάντε κλικ για να τοποθετήσετε Κυκλικό Δείκτη"},"actions":{"finish":"Τέλος","cancel":"Ακύρωση","removeLastVertex":"Κατάργηση τελευταίου σημείου"},"buttonTitles":{"drawMarkerButton":"Σχεδίαση Δείκτη","drawPolyButton":"Σχεδίαση Πολυγώνου","drawLineButton":"Σχεδίαση Γραμμής","drawCircleButton":"Σχεδίαση Κύκλου","drawRectButton":"Σχεδίαση Ορθογωνίου","editButton":"Επεξεργασία Επιπέδων","dragButton":"Μεταφορά Επιπέδων","cutButton":"Αποκοπή Επιπέδων","deleteButton":"Κατάργηση Επιπέδων","drawCircleMarkerButton":"Σχεδίαση Κυκλικού Δείκτη","snappingButton":"Προσκόλληση του Δείκτη μεταφοράς σε άλλα Επίπεδα και Κορυφές","pinningButton":"Περικοπή κοινών κορυφών μαζί"}}'), hu: JSON.parse('{"tooltips":{"placeMarker":"Kattintson a jelölő elhelyezéséhez","firstVertex":"Kattintson az első pont elhelyezéséhez","continueLine":"Kattintson a következő pont elhelyezéséhez","finishLine":"A befejezéshez kattintson egy meglévő pontra","finishPoly":"A befejezéshez kattintson az első pontra","finishRect":"Kattintson a befejezéshez","startCircle":"Kattintson a kör középpontjának elhelyezéséhez","finishCircle":"Kattintson a kör befejezéséhez","placeCircleMarker":"Kattintson a körjelölő elhelyezéséhez"},"actions":{"finish":"Befejezés","cancel":"Mégse","removeLastVertex":"Utolsó pont eltávolítása"},"buttonTitles":{"drawMarkerButton":"Jelölő rajzolása","drawPolyButton":"Poligon rajzolása","drawLineButton":"Vonal rajzolása","drawCircleButton":"Kör rajzolása","drawRectButton":"Négyzet rajzolása","editButton":"Elemek szerkesztése","dragButton":"Elemek mozgatása","cutButton":"Elemek vágása","deleteButton":"Elemek törlése","drawCircleMarkerButton":"Kör jelölő rajzolása","snappingButton":"Kapcsolja a jelöltőt másik elemhez vagy ponthoz","pinningButton":"Közös pontok összekötése"}}'), da: JSON.parse('{"tooltips":{"placeMarker":"Tryk for at placere en markør","firstVertex":"Tryk for at placere det første punkt","continueLine":"Tryk for at fortsætte linjen","finishLine":"Tryk på et eksisterende punkt for at afslutte","finishPoly":"Tryk på det første punkt for at afslutte","finishRect":"Tryk for at afslutte","startCircle":"Tryk for at placere cirklens center","finishCircle":"Tryk for at afslutte cirklen","placeCircleMarker":"Tryk for at placere en cirkelmarkør"},"actions":{"finish":"Afslut","cancel":"Afbryd","removeLastVertex":"Fjern sidste punkt"},"buttonTitles":{"drawMarkerButton":"Placer markør","drawPolyButton":"Tegn polygon","drawLineButton":"Tegn linje","drawCircleButton":"Tegn cirkel","drawRectButton":"Tegn firkant","editButton":"Rediger","dragButton":"Træk","cutButton":"Klip","deleteButton":"Fjern","drawCircleMarkerButton":"Tegn cirkelmarkør","snappingButton":"Fastgør trukket markør til andre elementer","pinningButton":"Sammenlæg delte elementer"}}'), no: JSON.parse('{"tooltips":{"placeMarker":"Klikk for å plassere punkt","firstVertex":"Klikk for å plassere første punkt","continueLine":"Klikk for å tegne videre","finishLine":"Klikk på et eksisterende punkt for å fullføre","finishPoly":"Klikk første punkt for å fullføre","finishRect":"Klikk for å fullføre","startCircle":"Klikk for å sette sirkel midtpunkt","finishCircle":"Klikk for å fullføre sirkel","placeCircleMarker":"Klikk for å plassere sirkel","placeText":"Klikk for å plassere tekst"},"actions":{"finish":"Fullfør","cancel":"Kanseller","removeLastVertex":"Fjern forrige punkt"},"buttonTitles":{"drawMarkerButton":"Tegn punkt","drawPolyButton":"Tegn flate","drawLineButton":"Tegn linje","drawCircleButton":"Tegn sirkel","drawRectButton":"Tegn rektangel","editButton":"Rediger objekter","dragButton":"Dra objekter","cutButton":"Kutt objekter","deleteButton":"Fjern objekter","drawCircleMarkerButton":"Tegn sirkel-punkt","snappingButton":"Fest dratt punkt til andre objekter og punkt","pinningButton":"Pin delte punkter sammen","rotateButton":"Rotér objekter","drawTextButton":"Tegn tekst","scaleButton":"Skalér objekter","autoTracingButton":"Automatisk sporing av linje"},"measurements":{"totalLength":"Lengde","segmentLength":"Segmentlengde","area":"Område","radius":"Radius","perimeter":"Omriss","height":"Høyde","width":"Bredde","coordinates":"Posisjon","coordinatesMarker":"Posisjonsmarkør"}}'), fa: JSON.parse('{"tooltips":{"placeMarker":"کلیک برای جانمایی نشان","firstVertex":"کلیک برای رسم اولین رأس","continueLine":"کلیک برای ادامه رسم","finishLine":"کلیک روی هر نشان موجود برای پایان","finishPoly":"کلیک روی اولین نشان برای پایان","finishRect":"کلیک برای پایان","startCircle":"کلیک برای رسم مرکز دایره","finishCircle":"کلیک برای پایان رسم دایره","placeCircleMarker":"کلیک برای رسم نشان دایره","placeText":"کلیک برای نوشتن متن"},"actions":{"finish":"پایان","cancel":"لفو","removeLastVertex":"حذف آخرین رأس"},"buttonTitles":{"drawMarkerButton":"درج نشان","drawPolyButton":"رسم چندضلعی","drawLineButton":"رسم خط","drawCircleButton":"رسم دایره","drawRectButton":"رسم چهارضلعی","editButton":"ویرایش لایه‌ها","dragButton":"جابجایی لایه‌ها","cutButton":"برش لایه‌ها","deleteButton":"حذف لایه‌ها","drawCircleMarkerButton":"رسم نشان دایره","snappingButton":"نشانگر را به لایه‌ها و رئوس دیگر بکشید","pinningButton":"رئوس مشترک را با هم پین کنید","rotateButton":"چرخش لایه","drawTextButton":"رسم متن","scaleButton":"مقیاس‌گذاری","autoTracingButton":"ردیاب خودکار"},"measurements":{"totalLength":"طول","segmentLength":"طول بخش","area":"ناحیه","radius":"شعاع","perimeter":"محیط","height":"ارتفاع","width":"عرض","coordinates":"موقعیت","coordinatesMarker":"موقعیت نشان"}}'), ua: JSON.parse(`{"tooltips":{"placeMarker":"Натисніть, щоб нанести маркер","firstVertex":"Натисніть, щоб нанести першу вершину","continueLine":"Натисніть, щоб продовжити малювати","finishLine":"Натисніть будь-який існуючий маркер для завершення","finishPoly":"Виберіть перший маркер, щоб завершити","finishRect":"Натисніть, щоб завершити","startCircle":"Натисніть, щоб додати центр кола","finishCircle":"Натисніть, щоб завершити коло","placeCircleMarker":"Натисніть, щоб нанести круговий маркер"},"actions":{"finish":"Завершити","cancel":"Відмінити","removeLastVertex":"Видалити попередню вершину"},"buttonTitles":{"drawMarkerButton":"Малювати маркер","drawPolyButton":"Малювати полігон","drawLineButton":"Малювати криву","drawCircleButton":"Малювати коло","drawRectButton":"Малювати прямокутник","editButton":"Редагувати шари","dragButton":"Перенести шари","cutButton":"Вирізати шари","deleteButton":"Видалити шари","drawCircleMarkerButton":"Малювати круговий маркер","snappingButton":"Прив’язати перетягнутий маркер до інших шарів та вершин","pinningButton":"Зв'язати спільні вершини разом"}}`), tr: JSON.parse('{"tooltips":{"placeMarker":"İşaretçi yerleştirmek için tıklayın","firstVertex":"İlk tepe noktasını yerleştirmek için tıklayın","continueLine":"Çizime devam etmek için tıklayın","finishLine":"Bitirmek için mevcut herhangi bir işaretçiyi tıklayın","finishPoly":"Bitirmek için ilk işaretçiyi tıklayın","finishRect":"Bitirmek için tıklayın","startCircle":"Daire merkezine yerleştirmek için tıklayın","finishCircle":"Daireyi bitirmek için tıklayın","placeCircleMarker":"Daire işaretçisi yerleştirmek için tıklayın"},"actions":{"finish":"Bitir","cancel":"İptal","removeLastVertex":"Son köşeyi kaldır"},"buttonTitles":{"drawMarkerButton":"Çizim İşaretçisi","drawPolyButton":"Çokgenler çiz","drawLineButton":"Çoklu çizgi çiz","drawCircleButton":"Çember çiz","drawRectButton":"Dikdörtgen çiz","editButton":"Katmanları düzenle","dragButton":"Katmanları sürükle","cutButton":"Katmanları kes","deleteButton":"Katmanları kaldır","drawCircleMarkerButton":"Daire işaretçisi çiz","snappingButton":"Sürüklenen işaretçiyi diğer katmanlara ve köşelere yapıştır","pinningButton":"Paylaşılan köşeleri birbirine sabitle"}}'), cz: JSON.parse('{"tooltips":{"placeMarker":"Kliknutím vytvoříte značku","firstVertex":"Kliknutím vytvoříte první objekt","continueLine":"Kliknutím pokračujte v kreslení","finishLine":"Kliknutí na libovolnou existující značku pro dokončení","finishPoly":"Vyberte první bod pro dokončení","finishRect":"Klikněte pro dokončení","startCircle":"Kliknutím přidejte střed kruhu","finishCircle":"Нажмите, чтобы задать радиус","placeCircleMarker":"Kliknutím nastavte poloměr"},"actions":{"finish":"Dokončit","cancel":"Zrušit","removeLastVertex":"Zrušit poslední akci"},"buttonTitles":{"drawMarkerButton":"Přidat značku","drawPolyButton":"Nakreslit polygon","drawLineButton":"Nakreslit křivku","drawCircleButton":"Nakreslit kruh","drawRectButton":"Nakreslit obdélník","editButton":"Upravit vrstvu","dragButton":"Přeneste vrstvu","cutButton":"Vyjmout vrstvu","deleteButton":"Smazat vrstvu","drawCircleMarkerButton":"Přidat kruhovou značku","snappingButton":"Navázat tažnou značku k dalším vrstvám a vrcholům","pinningButton":"Spojit společné body dohromady"}}'), ja: JSON.parse('{"tooltips":{"placeMarker":"クリックしてマーカーを配置","firstVertex":"クリックして最初の頂点を配置","continueLine":"クリックして描画を続ける","finishLine":"任意のマーカーをクリックして終了","finishPoly":"最初のマーカーをクリックして終了","finishRect":"クリックして終了","startCircle":"クリックして円の中心を配置","finishCircle":"クリックして円の描画を終了","placeCircleMarker":"クリックして円マーカーを配置","placeText":"クリックしてテキストを配置"},"actions":{"finish":"終了","cancel":"キャンセル","removeLastVertex":"最後の頂点を削除"},"buttonTitles":{"drawMarkerButton":"マーカーを描画","drawPolyButton":"ポリゴンを描画","drawLineButton":"折れ線を描画","drawCircleButton":"円を描画","drawRectButton":"矩形を描画","editButton":"レイヤーを編集","dragButton":"レイヤーをドラッグ","cutButton":"レイヤーを切り取り","deleteButton":"レイヤーを削除","drawCircleMarkerButton":"円マーカーを描画","snappingButton":"ドラッグしたマーカーを他のレイヤーや頂点にスナップする","pinningButton":"共有する頂点を同時に動かす","rotateButton":"レイヤーを回転","drawTextButton":"テキストを描画"}}'), fi: JSON.parse('{"tooltips":{"placeMarker":"Klikkaa asettaaksesi merkin","firstVertex":"Klikkaa asettaakseni ensimmäisen osuuden","continueLine":"Klikkaa jatkaaksesi piirtämistä","finishLine":"Klikkaa olemassa olevaa merkkiä lopettaaksesi","finishPoly":"Klikkaa ensimmäistä merkkiä lopettaaksesi","finishRect":"Klikkaa lopettaaksesi","startCircle":"Klikkaa asettaaksesi ympyrän keskipisteen","finishCircle":"Klikkaa lopettaaksesi ympyrän","placeCircleMarker":"Klikkaa asettaaksesi ympyrämerkin","placeText":"Klikkaa asettaaksesi tekstin"},"actions":{"finish":"Valmis","cancel":"Peruuta","removeLastVertex":"Poista viimeinen osuus"},"buttonTitles":{"drawMarkerButton":"Piirrä merkkejä","drawPolyButton":"Piirrä monikulmioita","drawLineButton":"Piirrä viivoja","drawCircleButton":"Piirrä ympyrä","drawRectButton":"Piirrä neliskulmioita","editButton":"Muokkaa","dragButton":"Siirrä","cutButton":"Leikkaa","deleteButton":"Poista","drawCircleMarkerButton":"Piirrä ympyrämerkki","snappingButton":"Kiinnitä siirrettävä merkki toisiin muotoihin","pinningButton":"Kiinnitä jaetut muodot yhteen","rotateButton":"Käännä","drawTextButton":"Piirrä tekstiä"}}'), ko: JSON.parse('{"tooltips":{"placeMarker":"마커 위치를 클릭하세요","firstVertex":"첫번째 꼭지점 위치을 클릭하세요","continueLine":"계속 그리려면 클릭하세요","finishLine":"끝내려면 기존 마커를 클릭하세요","finishPoly":"끝내려면 처음 마커를 클릭하세요","finishRect":"끝내려면 클릭하세요","startCircle":"원의 중심이 될 위치를 클릭하세요","finishCircle":"원을 끝내려면 클릭하세요","placeCircleMarker":"원 마커 위치를 클릭하세요","placeText":"텍스트 위치를 클릭하세요"},"actions":{"finish":"끝내기","cancel":"취소","removeLastVertex":"마지막 꼭지점 제거"},"buttonTitles":{"drawMarkerButton":"마커 그리기","drawPolyButton":"다각형 그리기","drawLineButton":"다각선 그리기","drawCircleButton":"원 그리기","drawRectButton":"직사각형 그리기","editButton":"레이어 편집하기","dragButton":"레이어 끌기","cutButton":"레이어 자르기","deleteButton":"레이어 제거하기","drawCircleMarkerButton":"원 마커 그리기","snappingButton":"잡아끈 마커를 다른 레이어 및 꼭지점에 들러붙게 하기","pinningButton":"공유 꼭지점을 함께 찍기","rotateButton":"레이어 회전하기","drawTextButton":"텍스트 그리기"}}') };
    function C(o, c) {
      var p = Object.keys(o);
      if (Object.getOwnPropertySymbols) {
        var _ = Object.getOwnPropertySymbols(o);
        c && (_ = _.filter(function(w) {
          return Object.getOwnPropertyDescriptor(o, w).enumerable;
        })), p.push.apply(p, _);
      }
      return p;
    }
    function T(o) {
      for (var c = 1; c < arguments.length; c++) {
        var p = arguments[c] != null ? arguments[c] : {};
        c % 2 ? C(Object(p), !0).forEach(function(_) {
          A(o, _, p[_]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(p)) : C(Object(p)).forEach(function(_) {
          Object.defineProperty(o, _, Object.getOwnPropertyDescriptor(p, _));
        });
      }
      return o;
    }
    function A(o, c, p) {
      return c in o ? Object.defineProperty(o, c, { value: p, enumerable: !0, configurable: !0, writable: !0 }) : o[c] = p, o;
    }
    const P = { _globalEditModeEnabled: !1, enableGlobalEditMode: function(o) {
      var c = this, p = T({}, o);
      this._globalEditModeEnabled = !0, this.Toolbar.toggleButton("editMode", this.globalEditModeEnabled()), L.PM.Utils.findLayers(this.map).forEach(function(_) {
        c._isRelevantForEdit(_) && _.pm.enable(p);
      }), this.throttledReInitEdit || (this.throttledReInitEdit = L.Util.throttle(this.handleLayerAdditionInGlobalEditMode, 100, this)), this._addedLayersEdit = {}, this.map.on("layeradd", this._layerAddedEdit, this), this.map.on("layeradd", this.throttledReInitEdit, this), this._fireGlobalEditModeToggled(!0);
    }, disableGlobalEditMode: function() {
      this._globalEditModeEnabled = !1, L.PM.Utils.findLayers(this.map).forEach(function(o) {
        o.pm.disable();
      }), this.map.off("layeradd", this._layerAddedEdit, this), this.map.off("layeradd", this.throttledReInitEdit, this), this.Toolbar.toggleButton("editMode", this.globalEditModeEnabled()), this._fireGlobalEditModeToggled(!1);
    }, globalEditEnabled: function() {
      return this.globalEditModeEnabled();
    }, globalEditModeEnabled: function() {
      return this._globalEditModeEnabled;
    }, toggleGlobalEditMode: function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.globalOptions;
      this.globalEditModeEnabled() ? this.disableGlobalEditMode() : this.enableGlobalEditMode(o);
    }, handleLayerAdditionInGlobalEditMode: function() {
      var o = this._addedLayersEdit;
      if (this._addedLayersEdit = {}, this.globalEditModeEnabled())
        for (var c in o) {
          var p = o[c];
          this._isRelevantForEdit(p) && p.pm.enable(T({}, this.globalOptions));
        }
    }, _layerAddedEdit: function(o) {
      var c = o.layer;
      this._addedLayersEdit[L.stamp(c)] = c;
    }, _isRelevantForEdit: function(o) {
      return o.pm && !(o instanceof L.LayerGroup) && (!L.PM.optIn && !o.options.pmIgnore || L.PM.optIn && o.options.pmIgnore === !1) && !o._pmTempLayer && o.pm.options.allowEditing;
    } }, D = { _globalDragModeEnabled: !1, enableGlobalDragMode: function() {
      var o = this, c = L.PM.Utils.findLayers(this.map);
      this._globalDragModeEnabled = !0, this._addedLayersDrag = {}, c.forEach(function(p) {
        o._isRelevantForDrag(p) && p.pm.enableLayerDrag();
      }), this.throttledReInitDrag || (this.throttledReInitDrag = L.Util.throttle(this.reinitGlobalDragMode, 100, this)), this.map.on("layeradd", this._layerAddedDrag, this), this.map.on("layeradd", this.throttledReInitDrag, this), this.Toolbar.toggleButton("dragMode", this.globalDragModeEnabled()), this._fireGlobalDragModeToggled(!0);
    }, disableGlobalDragMode: function() {
      var o = L.PM.Utils.findLayers(this.map);
      this._globalDragModeEnabled = !1, o.forEach(function(c) {
        c.pm.disableLayerDrag();
      }), this.map.off("layeradd", this._layerAddedDrag, this), this.map.off("layeradd", this.throttledReInitDrag, this), this.Toolbar.toggleButton("dragMode", this.globalDragModeEnabled()), this._fireGlobalDragModeToggled(!1);
    }, globalDragModeEnabled: function() {
      return !!this._globalDragModeEnabled;
    }, toggleGlobalDragMode: function() {
      this.globalDragModeEnabled() ? this.disableGlobalDragMode() : this.enableGlobalDragMode();
    }, reinitGlobalDragMode: function() {
      var o = this._addedLayersDrag;
      if (this._addedLayersDrag = {}, this.globalDragModeEnabled())
        for (var c in o) {
          var p = o[c];
          this._isRelevantForDrag(p) && p.pm.enableLayerDrag();
        }
    }, _layerAddedDrag: function(o) {
      var c = o.layer;
      this._addedLayersDrag[L.stamp(c)] = c;
    }, _isRelevantForDrag: function(o) {
      return o.pm && !(o instanceof L.LayerGroup) && (!L.PM.optIn && !o.options.pmIgnore || L.PM.optIn && o.options.pmIgnore === !1) && !o._pmTempLayer && o.pm.options.draggable;
    } }, $ = { _globalRemovalModeEnabled: !1, enableGlobalRemovalMode: function() {
      var o = this;
      this._globalRemovalModeEnabled = !0, this.map.eachLayer(function(c) {
        o._isRelevantForRemoval(c) && (c.pm.enabled() && c.pm.disable(), c.on("click", o.removeLayer, o));
      }), this.throttledReInitRemoval || (this.throttledReInitRemoval = L.Util.throttle(this.handleLayerAdditionInGlobalRemovalMode, 100, this)), this._addedLayersRemoval = {}, this.map.on("layeradd", this._layerAddedRemoval, this), this.map.on("layeradd", this.throttledReInitRemoval, this), this.Toolbar.toggleButton("removalMode", this.globalRemovalModeEnabled()), this._fireGlobalRemovalModeToggled(!0);
    }, disableGlobalRemovalMode: function() {
      var o = this;
      this._globalRemovalModeEnabled = !1, this.map.eachLayer(function(c) {
        c.off("click", o.removeLayer, o);
      }), this.map.off("layeradd", this._layerAddedRemoval, this), this.map.off("layeradd", this.throttledReInitRemoval, this), this.Toolbar.toggleButton("removalMode", this.globalRemovalModeEnabled()), this._fireGlobalRemovalModeToggled(!1);
    }, globalRemovalEnabled: function() {
      return this.globalRemovalModeEnabled();
    }, globalRemovalModeEnabled: function() {
      return !!this._globalRemovalModeEnabled;
    }, toggleGlobalRemovalMode: function() {
      this.globalRemovalModeEnabled() ? this.disableGlobalRemovalMode() : this.enableGlobalRemovalMode();
    }, removeLayer: function(o) {
      var c = o.target;
      this._isRelevantForRemoval(c) && !c.pm.dragging() && (c.removeFrom(this.map.pm._getContainingLayer()), c.remove(), c instanceof L.LayerGroup ? (this._fireRemoveLayerGroup(c), this._fireRemoveLayerGroup(this.map, c)) : (c.pm._fireRemove(c), c.pm._fireRemove(this.map, c)));
    }, _isRelevantForRemoval: function(o) {
      return o.pm && !(o instanceof L.LayerGroup) && (!L.PM.optIn && !o.options.pmIgnore || L.PM.optIn && o.options.pmIgnore === !1) && !o._pmTempLayer && o.pm.options.allowRemoval;
    }, handleLayerAdditionInGlobalRemovalMode: function() {
      var o = this._addedLayersRemoval;
      if (this._addedLayersRemoval = {}, this.globalRemovalModeEnabled())
        for (var c in o) {
          var p = o[c];
          this._isRelevantForRemoval(p) && (p.pm.enabled() && p.pm.disable(), p.on("click", this.removeLayer, this));
        }
    }, _layerAddedRemoval: function(o) {
      var c = o.layer;
      this._addedLayersRemoval[L.stamp(c)] = c;
    } }, Y = { _globalRotateModeEnabled: !1, enableGlobalRotateMode: function() {
      var o = this;
      this._globalRotateModeEnabled = !0, L.PM.Utils.findLayers(this.map).filter(function(c) {
        return c instanceof L.Polyline;
      }).forEach(function(c) {
        o._isRelevantForRotate(c) && c.pm.enableRotate();
      }), this.throttledReInitRotate || (this.throttledReInitRotate = L.Util.throttle(this.handleLayerAdditionInGlobalRotateMode, 100, this)), this._addedLayersRotate = {}, this.map.on("layeradd", this._layerAddedRotate, this), this.map.on("layeradd", this.throttledReInitRotate, this), this.Toolbar.toggleButton("rotateMode", this.globalRotateModeEnabled()), this._fireGlobalRotateModeToggled();
    }, disableGlobalRotateMode: function() {
      this._globalRotateModeEnabled = !1, L.PM.Utils.findLayers(this.map).filter(function(o) {
        return o instanceof L.Polyline;
      }).forEach(function(o) {
        o.pm.disableRotate();
      }), this.map.off("layeradd", this._layerAddedRotate, this), this.map.off("layeradd", this.throttledReInitRotate, this), this.Toolbar.toggleButton("rotateMode", this.globalRotateModeEnabled()), this._fireGlobalRotateModeToggled();
    }, globalRotateModeEnabled: function() {
      return !!this._globalRotateModeEnabled;
    }, toggleGlobalRotateMode: function() {
      this.globalRotateModeEnabled() ? this.disableGlobalRotateMode() : this.enableGlobalRotateMode();
    }, _isRelevantForRotate: function(o) {
      return o.pm && o instanceof L.Polyline && !(o instanceof L.LayerGroup) && (!L.PM.optIn && !o.options.pmIgnore || L.PM.optIn && o.options.pmIgnore === !1) && !o._pmTempLayer && o.pm.options.allowRotation;
    }, handleLayerAdditionInGlobalRotateMode: function() {
      var o = this._addedLayersRotate;
      if (this._addedLayersRotate = {}, this.globalRotateModeEnabled())
        for (var c in o) {
          var p = o[c];
          this._isRelevantForRemoval(p) && p.pm.enableRotate();
        }
    }, _layerAddedRotate: function(o) {
      var c = o.layer;
      this._addedLayersRotate[L.stamp(c)] = c;
    } };
    function G(o, c) {
      var p = Object.keys(o);
      if (Object.getOwnPropertySymbols) {
        var _ = Object.getOwnPropertySymbols(o);
        c && (_ = _.filter(function(w) {
          return Object.getOwnPropertyDescriptor(o, w).enumerable;
        })), p.push.apply(p, _);
      }
      return p;
    }
    function ee(o) {
      for (var c = 1; c < arguments.length; c++) {
        var p = arguments[c] != null ? arguments[c] : {};
        c % 2 ? G(Object(p), !0).forEach(function(_) {
          X(o, _, p[_]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(p)) : G(Object(p)).forEach(function(_) {
          Object.defineProperty(o, _, Object.getOwnPropertyDescriptor(p, _));
        });
      }
      return o;
    }
    function X(o, c, p) {
      return c in o ? Object.defineProperty(o, c, { value: p, enumerable: !0, configurable: !0, writable: !0 }) : o[c] = p, o;
    }
    var ae = { _fireDrawStart: function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "Draw", c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      this.__fire(this._map, "pm:drawstart", { shape: this._shape, workingLayer: this._layer }, o, c);
    }, _fireDrawEnd: function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "Draw", c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      this.__fire(this._map, "pm:drawend", { shape: this._shape }, o, c);
    }, _fireCreate: function(o) {
      var c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "Draw", p = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      this.__fire(this._map, "pm:create", { shape: this._shape, marker: o, layer: o }, c, p);
    }, _fireCenterPlaced: function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "Draw", c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, p = o === "Draw" ? this._layer : void 0, _ = o !== "Draw" ? this._layer : void 0;
      this.__fire(this._layer, "pm:centerplaced", { shape: this._shape, workingLayer: p, layer: _, latlng: this._layer.getLatLng() }, o, c);
    }, _fireCut: function(o, c, p) {
      var _ = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "Draw", w = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {};
      this.__fire(o, "pm:cut", { shape: this._shape, layer: c, originalLayer: p }, _, w);
    }, _fireEdit: function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this._layer, c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "Edit", p = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      this.__fire(o, "pm:edit", { layer: this._layer, shape: this.getShape() }, c, p);
    }, _fireEnable: function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "Edit", c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      this.__fire(this._layer, "pm:enable", { layer: this._layer, shape: this.getShape() }, o, c);
    }, _fireDisable: function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "Edit", c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      this.__fire(this._layer, "pm:disable", { layer: this._layer, shape: this.getShape() }, o, c);
    }, _fireUpdate: function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "Edit", c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      this.__fire(this._layer, "pm:update", { layer: this._layer, shape: this.getShape() }, o, c);
    }, _fireMarkerDragStart: function(o) {
      var c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : void 0, p = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "Edit", _ = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
      this.__fire(this._layer, "pm:markerdragstart", { layer: this._layer, markerEvent: o, shape: this.getShape(), indexPath: c }, p, _);
    }, _fireMarkerDrag: function(o) {
      var c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : void 0, p = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "Edit", _ = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
      this.__fire(this._layer, "pm:markerdrag", { layer: this._layer, markerEvent: o, shape: this.getShape(), indexPath: c }, p, _);
    }, _fireMarkerDragEnd: function(o) {
      var c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : void 0, p = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : void 0, _ = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "Edit", w = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {};
      this.__fire(this._layer, "pm:markerdragend", { layer: this._layer, markerEvent: o, shape: this.getShape(), indexPath: c, intersectionReset: p }, _, w);
    }, _fireDragStart: function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "Edit", c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      this.__fire(this._layer, "pm:dragstart", { layer: this._layer, shape: this.getShape() }, o, c);
    }, _fireDrag: function(o) {
      var c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "Edit", p = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      this.__fire(this._layer, "pm:drag", ee(ee({}, o), {}, { shape: this.getShape() }), c, p);
    }, _fireDragEnd: function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "Edit", c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      this.__fire(this._layer, "pm:dragend", { layer: this._layer, shape: this.getShape() }, o, c);
    }, _fireDragEnable: function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "Edit", c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      this.__fire(this._layer, "pm:dragenable", { layer: this._layer, shape: this.getShape() }, o, c);
    }, _fireDragDisable: function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "Edit", c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      this.__fire(this._layer, "pm:dragdisable", { layer: this._layer, shape: this.getShape() }, o, c);
    }, _fireRemove: function(o) {
      var c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : o, p = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "Edit", _ = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
      this.__fire(o, "pm:remove", { layer: c, shape: this.getShape() }, p, _);
    }, _fireVertexAdded: function(o, c, p) {
      var _ = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "Edit", w = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {};
      this.__fire(this._layer, "pm:vertexadded", { layer: this._layer, workingLayer: this._layer, marker: o, indexPath: c, latlng: p, shape: this.getShape() }, _, w);
    }, _fireVertexRemoved: function(o, c) {
      var p = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "Edit", _ = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
      this.__fire(this._layer, "pm:vertexremoved", { layer: this._layer, marker: o, indexPath: c, shape: this.getShape() }, p, _);
    }, _fireVertexClick: function(o, c) {
      var p = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "Edit", _ = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
      this.__fire(this._layer, "pm:vertexclick", { layer: this._layer, markerEvent: o, indexPath: c, shape: this.getShape() }, p, _);
    }, _fireIntersect: function(o) {
      var c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this._layer, p = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "Edit", _ = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
      this.__fire(c, "pm:intersect", { layer: this._layer, intersection: o, shape: this.getShape() }, p, _);
    }, _fireLayerReset: function(o, c) {
      var p = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "Edit", _ = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
      this.__fire(this._layer, "pm:layerreset", { layer: this._layer, markerEvent: o, indexPath: c, shape: this.getShape() }, p, _);
    }, _fireChange: function(o) {
      var c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "Edit", p = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      this.__fire(this._layer, "pm:change", { layer: this._layer, latlngs: o, shape: this.getShape() }, c, p);
    }, _fireTextChange: function(o) {
      var c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "Edit", p = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      this.__fire(this._layer, "pm:textchange", { layer: this._layer, text: o, shape: this.getShape() }, c, p);
    }, _fireTextFocus: function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "Edit", c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      this.__fire(this._layer, "pm:textfocus", { layer: this._layer, shape: this.getShape() }, o, c);
    }, _fireTextBlur: function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "Edit", c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      this.__fire(this._layer, "pm:textblur", { layer: this._layer, shape: this.getShape() }, o, c);
    }, _fireSnapDrag: function(o, c) {
      var p = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "Snapping", _ = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
      this.__fire(o, "pm:snapdrag", c, p, _);
    }, _fireSnap: function(o, c) {
      var p = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "Snapping", _ = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
      this.__fire(o, "pm:snap", c, p, _);
    }, _fireUnsnap: function(o, c) {
      var p = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "Snapping", _ = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
      this.__fire(o, "pm:unsnap", c, p, _);
    }, _fireRotationEnable: function(o, c) {
      var p = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "Rotation", _ = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
      this.__fire(o, "pm:rotateenable", { layer: this._layer, helpLayer: this._rotatePoly, shape: this.getShape() }, p, _);
    }, _fireRotationDisable: function(o) {
      var c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "Rotation", p = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      this.__fire(o, "pm:rotatedisable", { layer: this._layer, shape: this.getShape() }, c, p);
    }, _fireRotationStart: function(o, c) {
      var p = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "Rotation", _ = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
      this.__fire(o, "pm:rotatestart", { layer: this._rotationLayer, helpLayer: this._layer, startAngle: this._startAngle, originLatLngs: c }, p, _);
    }, _fireRotation: function(o, c, p) {
      var _ = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : this._rotationLayer, w = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "Rotation", B = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {};
      this.__fire(o, "pm:rotate", { layer: _, helpLayer: this._layer, startAngle: this._startAngle, angle: _.pm.getAngle(), angleDiff: c, oldLatLngs: p, newLatLngs: _.getLatLngs() }, w, B);
    }, _fireRotationEnd: function(o, c, p) {
      var _ = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "Rotation", w = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {};
      this.__fire(o, "pm:rotateend", { layer: this._rotationLayer, helpLayer: this._layer, startAngle: c, angle: this._rotationLayer.pm.getAngle(), originLatLngs: p, newLatLngs: this._rotationLayer.getLatLngs() }, _, w);
    }, _fireActionClick: function(o, c, p) {
      var _ = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "Toolbar", w = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {};
      this.__fire(this._map, "pm:actionclick", { text: o.text, action: o, btnName: c, button: p }, _, w);
    }, _fireButtonClick: function(o, c) {
      var p = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "Toolbar", _ = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
      this.__fire(this._map, "pm:buttonclick", { btnName: o, button: c }, p, _);
    }, _fireLangChange: function(o, c, p, _) {
      var w = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "Global", B = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {};
      this.__fire(this.map, "pm:langchange", { oldLang: o, activeLang: c, fallback: p, translations: _ }, w, B);
    }, _fireGlobalDragModeToggled: function(o) {
      var c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "Global", p = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      this.__fire(this.map, "pm:globaldragmodetoggled", { enabled: o, map: this.map }, c, p);
    }, _fireGlobalEditModeToggled: function(o) {
      var c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "Global", p = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      this.__fire(this.map, "pm:globaleditmodetoggled", { enabled: o, map: this.map }, c, p);
    }, _fireGlobalRemovalModeToggled: function(o) {
      var c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "Global", p = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      this.__fire(this.map, "pm:globalremovalmodetoggled", { enabled: o, map: this.map }, c, p);
    }, _fireGlobalCutModeToggled: function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "Global", c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      this.__fire(this._map, "pm:globalcutmodetoggled", { enabled: !!this._enabled, map: this._map }, o, c);
    }, _fireGlobalDrawModeToggled: function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "Global", c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      this.__fire(this._map, "pm:globaldrawmodetoggled", { enabled: this._enabled, shape: this._shape, map: this._map }, o, c);
    }, _fireGlobalRotateModeToggled: function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "Global", c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      this.__fire(this.map, "pm:globalrotatemodetoggled", { enabled: this.globalRotateModeEnabled(), map: this.map }, o, c);
    }, _fireRemoveLayerGroup: function(o) {
      var c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : o, p = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "Edit", _ = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
      this.__fire(o, "pm:remove", { layer: c, shape: void 0 }, p, _);
    }, _fireKeyeventEvent: function(o, c, p) {
      var _ = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "Global", w = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {};
      this.__fire(this.map, "pm:keyevent", { event: o, eventType: c, focusOn: p }, _, w);
    }, __fire: function(o, c, p, _) {
      var w = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {};
      p = a()(p, w, { source: _ }), L.PM.Utils._fireEvent(o, c, p);
    } };
    const ne = ae, se = { _lastEvents: { keydown: void 0, keyup: void 0, current: void 0 }, _initKeyListener: function(o) {
      this.map = o, L.DomEvent.on(document, "keydown keyup", this._onKeyListener, this), L.DomEvent.on(window, "blur", this._onBlur, this);
    }, _onKeyListener: function(o) {
      var c = "document";
      this.map.getContainer().contains(o.target) && (c = "map");
      var p = { event: o, eventType: o.type, focusOn: c };
      this._lastEvents[o.type] = p, this._lastEvents.current = p, this.map.pm._fireKeyeventEvent(o, o.type, c);
    }, _onBlur: function(o) {
      o.altKey = !1;
      var c = { event: o, eventType: o.type, focusOn: "document" };
      this._lastEvents[o.type] = c, this._lastEvents.current = c;
    }, getLastKeyEvent: function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "current";
      return this._lastEvents[o];
    }, isShiftKeyPressed: function() {
      var o;
      return (o = this._lastEvents.current) === null || o === void 0 ? void 0 : o.event.shiftKey;
    }, isAltKeyPressed: function() {
      var o;
      return (o = this._lastEvents.current) === null || o === void 0 ? void 0 : o.event.altKey;
    }, isCtrlKeyPressed: function() {
      var o;
      return (o = this._lastEvents.current) === null || o === void 0 ? void 0 : o.event.ctrlKey;
    }, isMetaKeyPressed: function() {
      var o;
      return (o = this._lastEvents.current) === null || o === void 0 ? void 0 : o.event.metaKey;
    }, getPressedKey: function() {
      var o;
      return (o = this._lastEvents.current) === null || o === void 0 ? void 0 : o.event.key;
    } };
    var re = n(7361), Q = n.n(re), ke = n(8721), Ae = n.n(ke);
    function pe(o) {
      var c = L.PM.activeLang;
      return Ae()(R, c) || (c = "en"), Q()(R[c], o);
    }
    function Ye(o) {
      for (var c = 0; c < o.length; c += 1) {
        var p = o[c];
        if (Array.isArray(p)) {
          if (Ye(p))
            return !0;
        } else if (p != null && p !== "")
          return !0;
      }
      return !1;
    }
    function ue(o) {
      return o.reduce(function(c, p) {
        if (p.length !== 0) {
          var _ = Array.isArray(p) ? ue(p) : p;
          Array.isArray(_) ? _.length !== 0 && c.push(_) : c.push(_);
        }
        return c;
      }, []);
    }
    function Fe(o, c, p) {
      for (var _, w, B, F = { a: L.CRS.Earth.R, b: 63567523142e-4, f: 1 / 298.257223563 }, Z = F.a, V = F.b, K = F.f, oe = o.lng, _e = o.lat, fe = p, Me = Math.PI, Ie = c * Me / 180, qe = Math.sin(Ie), ot = Math.cos(Ie), Tt = (1 - K) * Math.tan(_e * Me / 180), Ct = 1 / Math.sqrt(1 + Tt * Tt), Yt = Tt * Ct, pn = Math.atan2(Tt, ot), mn = Ct * qe, Wr = 1 - mn * mn, st = Wr * (Z * Z - V * V) / (V * V), Io = 1 + st / 16384 * (4096 + st * (st * (320 - 175 * st) - 768)), wn = st / 1024 * (256 + st * (st * (74 - 47 * st) - 128)), En = fe / (V * Io), $a = 2 * Math.PI; Math.abs(En - $a) > 1e-12; )
        _ = Math.cos(2 * pn + En), $a = En, En = fe / (V * Io) + wn * (w = Math.sin(En)) * (_ + wn / 4 * ((B = Math.cos(En)) * (2 * _ * _ - 1) - wn / 6 * _ * (4 * w * w - 3) * (4 * _ * _ - 3)));
      var Ao = Yt * w - Ct * B * ot, Na = Math.atan2(Yt * B + Ct * w * ot, (1 - K) * Math.sqrt(mn * mn + Ao * Ao)), za = K / 16 * Wr * (4 + K * (4 - 3 * Wr)), Ro = oe + 180 * (Math.atan2(w * qe, Ct * B - Yt * w * ot) - (1 - za) * K * mn * (En + za * w * (_ + za * B * (2 * _ * _ - 1)))) / Me, pl = 180 * Na / Me;
      return L.latLng(Ro, pl);
    }
    function Pe(o, c, p, _) {
      for (var w, B, F = !(arguments.length > 4 && arguments[4] !== void 0) || arguments[4], Z = [], V = 0; V < p; V += 1) {
        if (F)
          w = Fe(o, 360 * V / p + _, c), B = L.latLng(w.lng, w.lat);
        else {
          var K = o.lat + Math.cos(2 * V * Math.PI / p) * c, oe = o.lng + Math.sin(2 * V * Math.PI / p) * c;
          B = L.latLng(K, oe);
        }
        Z.push(B);
      }
      return Z;
    }
    function nt(o, c, p) {
      var _ = o.latLngToContainerPoint(c), w = o.latLngToContainerPoint(p), B = 180 * Math.atan2(w.y - _.y, w.x - _.x) / Math.PI + 90;
      return B += B < 0 ? 360 : 0;
    }
    function Ve(o, c, p, _) {
      return function(w, B, F) {
        B = (B + 360) % 360;
        var Z = Math.PI / 180, V = 180 / Math.PI, K = L.CRS.Earth.R, oe = w.lng * Z, _e = w.lat * Z, fe = B * Z, Me = Math.sin(_e), Ie = Math.cos(_e), qe = Math.cos(F / K), ot = Math.sin(F / K), Tt = Math.asin(Me * qe + Ie * ot * Math.cos(fe)), Ct = oe + Math.atan2(Math.sin(fe) * ot * Ie, qe - Me * Math.sin(Tt));
        return Ct = (Ct *= V) > 180 ? Ct - 360 : Ct < -180 ? Ct + 360 : Ct, L.latLng([Tt * V, Ct]);
      }(c, nt(o, c, p), _);
    }
    function Ze(o, c) {
      var p = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "asc";
      if (!c || Object.keys(c).length === 0)
        return function(V, K) {
          return V - K;
        };
      for (var _, w = Object.keys(c), B = w.length - 1, F = {}; B >= 0; )
        _ = w[B], F[_.toLowerCase()] = c[_], B -= 1;
      function Z(V) {
        return V instanceof L.Marker ? "Marker" : V instanceof L.Circle ? "Circle" : V instanceof L.CircleMarker ? "CircleMarker" : V instanceof L.Rectangle ? "Rectangle" : V instanceof L.Polygon ? "Polygon" : V instanceof L.Polyline ? "Line" : void 0;
      }
      return function(V, K) {
        var oe, _e;
        if (o === "instanceofShape") {
          if (oe = Z(V.layer).toLowerCase(), _e = Z(K.layer).toLowerCase(), !oe || !_e)
            return 0;
        } else {
          if (!V.hasOwnProperty(o) || !K.hasOwnProperty(o))
            return 0;
          oe = V[o].toLowerCase(), _e = K[o].toLowerCase();
        }
        var fe = oe in F ? F[oe] : Number.MAX_SAFE_INTEGER, Me = _e in F ? F[_e] : Number.MAX_SAFE_INTEGER, Ie = 0;
        return fe < Me ? Ie = -1 : fe > Me && (Ie = 1), p === "desc" ? -1 * Ie : Ie;
      };
    }
    function Ne(o) {
      var c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : o.getLatLngs();
      return o instanceof L.Polygon ? L.polygon(c).getLatLngs() : L.polyline(c).getLatLngs();
    }
    function ft(o, c) {
      var p, _;
      if ((p = c.options.crs) !== null && p !== void 0 && (_ = p.projection) !== null && _ !== void 0 && _.MAX_LATITUDE) {
        var w, B, F = (w = c.options.crs) === null || w === void 0 || (B = w.projection) === null || B === void 0 ? void 0 : B.MAX_LATITUDE;
        o.lat = Math.max(Math.min(F, o.lat), -F);
      }
      return o;
    }
    function pt(o) {
      return o.options.renderer || o._map && (o._map._getPaneRenderer(o.options.pane) || o._map.options.renderer || o._map._renderer) || o._renderer;
    }
    const Wt = L.Class.extend({ includes: [P, D, $, Y, ne], initialize: function(o) {
      this.map = o, this.Draw = new L.PM.Draw(o), this.Toolbar = new L.PM.Toolbar(o), this.Keyboard = se, this.globalOptions = { snappable: !0, layerGroup: void 0, snappingOrder: ["Marker", "CircleMarker", "Circle", "Line", "Polygon", "Rectangle"], panes: { vertexPane: "markerPane", layerPane: "overlayPane", markerPane: "markerPane" }, draggable: !0 }, this.Keyboard._initKeyListener(o);
    }, setLang: function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "en", c = arguments.length > 1 ? arguments[1] : void 0, p = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "en", _ = L.PM.activeLang;
      c && (R[o] = a()(R[p], c)), L.PM.activeLang = o, this.map.pm.Toolbar.reinit(), this._fireLangChange(_, o, p, R[o]);
    }, addControls: function(o) {
      this.Toolbar.addControls(o);
    }, removeControls: function() {
      this.Toolbar.removeControls();
    }, toggleControls: function() {
      this.Toolbar.toggleControls();
    }, controlsVisible: function() {
      return this.Toolbar.isVisible;
    }, enableDraw: function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "Polygon", c = arguments.length > 1 ? arguments[1] : void 0;
      o === "Poly" && (o = "Polygon"), this.Draw.enable(o, c);
    }, disableDraw: function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "Polygon";
      o === "Poly" && (o = "Polygon"), this.Draw.disable(o);
    }, setPathOptions: function(o) {
      var c = this, p = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ = p.ignoreShapes || [], w = p.merge || !1;
      this.map.pm.Draw.shapes.forEach(function(B) {
        _.indexOf(B) === -1 && c.map.pm.Draw[B].setPathOptions(o, w);
      });
    }, getGlobalOptions: function() {
      return this.globalOptions;
    }, setGlobalOptions: function(o) {
      var c = this, p = a()(this.globalOptions, o);
      p.editable && (p.resizeableCircleMarker = p.editable, delete p.editable);
      var _ = !1;
      this.map.pm.Draw.CircleMarker.enabled() && !!this.map.pm.Draw.CircleMarker.options.resizeableCircleMarker != !!p.resizeableCircleMarker && (this.map.pm.Draw.CircleMarker.disable(), _ = !0);
      var w = !1;
      this.map.pm.Draw.Circle.enabled() && !!this.map.pm.Draw.Circle.options.resizableCircle != !!p.resizableCircle && (this.map.pm.Draw.Circle.disable(), w = !0), this.map.pm.Draw.shapes.forEach(function(B) {
        c.map.pm.Draw[B].setOptions(p);
      }), _ && this.map.pm.Draw.CircleMarker.enable(), w && this.map.pm.Draw.Circle.enable(), L.PM.Utils.findLayers(this.map).forEach(function(B) {
        B.pm.setOptions(p);
      }), this.map.fire("pm:globaloptionschanged"), this.globalOptions = p, this.applyGlobalOptions();
    }, applyGlobalOptions: function() {
      L.PM.Utils.findLayers(this.map).forEach(function(o) {
        o.pm.enabled() && o.pm.applyOptions();
      });
    }, globalDrawModeEnabled: function() {
      return !!this.Draw.getActiveShape();
    }, globalCutModeEnabled: function() {
      return !!this.Draw.Cut.enabled();
    }, enableGlobalCutMode: function(o) {
      return this.Draw.Cut.enable(o);
    }, toggleGlobalCutMode: function(o) {
      return this.Draw.Cut.toggle(o);
    }, disableGlobalCutMode: function() {
      return this.Draw.Cut.disable();
    }, getGeomanLayers: function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 && arguments[0], c = L.PM.Utils.findLayers(this.map);
      if (!o)
        return c;
      var p = L.featureGroup();
      return p._pmTempLayer = !0, c.forEach(function(_) {
        p.addLayer(_);
      }), p;
    }, getGeomanDrawLayers: function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 && arguments[0], c = L.PM.Utils.findLayers(this.map).filter(function(_) {
        return _._drawnByGeoman === !0;
      });
      if (!o)
        return c;
      var p = L.featureGroup();
      return p._pmTempLayer = !0, c.forEach(function(_) {
        p.addLayer(_);
      }), p;
    }, _getContainingLayer: function() {
      return this.globalOptions.layerGroup && this.globalOptions.layerGroup instanceof L.LayerGroup ? this.globalOptions.layerGroup : this.map;
    }, _isCRSSimple: function() {
      return this.map.options.crs === L.CRS.Simple;
    }, _touchEventCounter: 0, _addTouchEvents: function(o) {
      this._touchEventCounter === 0 && (L.DomEvent.on(o, "touchmove", this._canvasTouchMove, this), L.DomEvent.on(o, "touchstart touchend touchcancel", this._canvasTouchClick, this)), this._touchEventCounter += 1;
    }, _removeTouchEvents: function(o) {
      this._touchEventCounter === 1 && (L.DomEvent.off(o, "touchmove", this._canvasTouchMove, this), L.DomEvent.off(o, "touchstart touchend touchcancel", this._canvasTouchClick, this)), this._touchEventCounter = this._touchEventCounter <= 1 ? 0 : this._touchEventCounter - 1;
    }, _canvasTouchMove: function(o) {
      pt(this.map)._onMouseMove(this._createMouseEvent("mousemove", o));
    }, _canvasTouchClick: function(o) {
      var c = "";
      o.type === "touchstart" || o.type === "pointerdown" ? c = "mousedown" : o.type === "touchend" || o.type === "pointerup" ? c = "mouseup" : o.type !== "touchcancel" && o.type !== "pointercancel" || (c = "mouseup"), c && pt(this.map)._onClick(this._createMouseEvent(c, o));
    }, _createMouseEvent: function(o, c) {
      var p, _ = c.touches[0] || c.changedTouches[0];
      try {
        p = new MouseEvent(o, { bubbles: c.bubbles, cancelable: c.cancelable, view: c.view, detail: _.detail, screenX: _.screenX, screenY: _.screenY, clientX: _.clientX, clientY: _.clientY, ctrlKey: c.ctrlKey, altKey: c.altKey, shiftKey: c.shiftKey, metaKey: c.metaKey, button: c.button, relatedTarget: c.relatedTarget });
      } catch {
        (p = document.createEvent("MouseEvents")).initMouseEvent(o, c.bubbles, c.cancelable, c.view, _.detail, _.screenX, _.screenY, _.clientX, _.clientY, c.ctrlKey, c.altKey, c.shiftKey, c.metaKey, c.button, c.relatedTarget);
      }
      return p;
    } }), an = L.Control.extend({ includes: [ne], options: { position: "topleft", disableByOtherButtons: !0 }, initialize: function(o) {
      this._button = L.Util.extend({}, this.options, o);
    }, onAdd: function(o) {
      return this._map = o, this._map.pm.Toolbar.options.oneBlock ? this._container = this._map.pm.Toolbar._createContainer(this.options.position) : this._button.tool === "edit" ? this._container = this._map.pm.Toolbar.editContainer : this._button.tool === "options" ? this._container = this._map.pm.Toolbar.optionsContainer : this._button.tool === "custom" ? this._container = this._map.pm.Toolbar.customContainer : this._container = this._map.pm.Toolbar.drawContainer, this.buttonsDomNode = this._makeButton(this._button), this._container.appendChild(this.buttonsDomNode), this._container;
    }, onRemove: function() {
      return this.buttonsDomNode.remove(), this._container;
    }, getText: function() {
      return this._button.text;
    }, getIconUrl: function() {
      return this._button.iconUrl;
    }, destroy: function() {
      this._button = {}, this._update();
    }, toggle: function(o) {
      return this._button.toggleStatus = typeof o == "boolean" ? o : !this._button.toggleStatus, this._applyStyleClasses(), this._button.toggleStatus;
    }, toggled: function() {
      return this._button.toggleStatus;
    }, onCreate: function() {
      this.toggle(!1);
    }, disable: function() {
      this.toggle(!1), this._button.disabled = !0, this._updateDisabled();
    }, enable: function() {
      this._button.disabled = !1, this._updateDisabled();
    }, _triggerClick: function(o) {
      o && o.preventDefault(), this._button.disabled || (this._button.onClick(o, { button: this, event: o }), this._clicked(o), this._button.afterClick(o, { button: this, event: o }));
    }, _makeButton: function(o) {
      var c = this, p = this.options.position.indexOf("right") > -1 ? "pos-right" : "", _ = L.DomUtil.create("div", "button-container  ".concat(p), this._container);
      o.title && _.setAttribute("title", o.title);
      var w = L.DomUtil.create("a", "leaflet-buttons-control-button", _);
      w.setAttribute("role", "button"), w.setAttribute("tabindex", "0"), w.href = "#";
      var B = L.DomUtil.create("div", "leaflet-pm-actions-container ".concat(p), _), F = o.actions, Z = { cancel: { text: pe("actions.cancel"), onClick: function() {
        this._triggerClick();
      } }, finishMode: { text: pe("actions.finish"), onClick: function() {
        this._triggerClick();
      } }, removeLastVertex: { text: pe("actions.removeLastVertex"), onClick: function() {
        this._map.pm.Draw[o.jsClass]._removeLastVertex();
      } }, finish: { text: pe("actions.finish"), onClick: function(K) {
        this._map.pm.Draw[o.jsClass]._finishShape(K);
      } } };
      F.forEach(function(K) {
        var oe, _e = typeof K == "string" ? K : K.name;
        if (Z[_e])
          oe = Z[_e];
        else {
          if (!K.text)
            return;
          oe = K;
        }
        var fe = L.DomUtil.create("a", "leaflet-pm-action ".concat(p, " action-").concat(_e), B);
        fe.setAttribute("role", "button"), fe.setAttribute("tabindex", "0"), fe.href = "#", fe.innerHTML = oe.text, L.DomEvent.disableClickPropagation(fe), L.DomEvent.on(fe, "click", L.DomEvent.stop), !o.disabled && oe.onClick && (L.DomEvent.addListener(fe, "click", function(Me) {
          Me.preventDefault();
          var Ie = "", qe = c._map.pm.Toolbar.buttons;
          for (var ot in qe)
            if (qe[ot]._button === o) {
              Ie = ot;
              break;
            }
          c._fireActionClick(oe, Ie, o);
        }, c), L.DomEvent.addListener(fe, "click", oe.onClick, c));
      }), o.toggleStatus && L.DomUtil.addClass(_, "active");
      var V = L.DomUtil.create("div", "control-icon", w);
      return o.iconUrl && V.setAttribute("src", o.iconUrl), o.className && L.DomUtil.addClass(V, o.className), L.DomEvent.disableClickPropagation(w), L.DomEvent.on(w, "click", L.DomEvent.stop), o.disabled || (L.DomEvent.addListener(w, "click", this._onBtnClick, this), L.DomEvent.addListener(w, "click", this._triggerClick, this)), o.disabled && (L.DomUtil.addClass(w, "pm-disabled"), w.setAttribute("aria-disabled", "true")), _;
    }, _applyStyleClasses: function() {
      this._container && (this._button.toggleStatus && this._button.cssToggle !== !1 ? (L.DomUtil.addClass(this.buttonsDomNode, "active"), L.DomUtil.addClass(this._container, "activeChild")) : (L.DomUtil.removeClass(this.buttonsDomNode, "active"), L.DomUtil.removeClass(this._container, "activeChild")));
    }, _onBtnClick: function() {
      this._button.disableOtherButtons && this._map.pm.Toolbar.triggerClickOnToggledButtons(this);
      var o = "", c = this._map.pm.Toolbar.buttons;
      for (var p in c)
        if (c[p]._button === this._button) {
          o = p;
          break;
        }
      this._fireButtonClick(o, this._button);
    }, _clicked: function() {
      this._button.doToggle && this.toggle();
    }, _updateDisabled: function() {
      if (this._container) {
        var o = "pm-disabled", c = this.buttonsDomNode.children[0];
        this._button.disabled ? (L.DomUtil.addClass(c, o), c.setAttribute("aria-disabled", "true"), L.DomEvent.off(c, "click", this._triggerClick, this), L.DomEvent.off(c, "click", this._onBtnClick, this)) : (L.DomUtil.removeClass(c, o), c.setAttribute("aria-disabled", "false"), L.DomEvent.on(c, "click", this._triggerClick, this), L.DomEvent.on(c, "click", this._onBtnClick, this));
      }
    } });
    function on(o, c) {
      var p = Object.keys(o);
      if (Object.getOwnPropertySymbols) {
        var _ = Object.getOwnPropertySymbols(o);
        c && (_ = _.filter(function(w) {
          return Object.getOwnPropertyDescriptor(o, w).enumerable;
        })), p.push.apply(p, _);
      }
      return p;
    }
    function Dt(o) {
      for (var c = 1; c < arguments.length; c++) {
        var p = arguments[c] != null ? arguments[c] : {};
        c % 2 ? on(Object(p), !0).forEach(function(_) {
          Zt(o, _, p[_]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(p)) : on(Object(p)).forEach(function(_) {
          Object.defineProperty(o, _, Object.getOwnPropertyDescriptor(p, _));
        });
      }
      return o;
    }
    function Zt(o, c, p) {
      return c in o ? Object.defineProperty(o, c, { value: p, enumerable: !0, configurable: !0, writable: !0 }) : o[c] = p, o;
    }
    function It(o) {
      return It = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(c) {
        return typeof c;
      } : function(c) {
        return c && typeof Symbol == "function" && c.constructor === Symbol && c !== Symbol.prototype ? "symbol" : typeof c;
      }, It(o);
    }
    L.Control.PMButton = an;
    const bn = L.Class.extend({ options: { drawMarker: !0, drawRectangle: !0, drawPolyline: !0, drawPolygon: !0, drawCircle: !0, drawCircleMarker: !0, drawText: !0, editMode: !0, dragMode: !0, cutPolygon: !0, removalMode: !0, rotateMode: !0, snappingOption: !0, drawControls: !0, editControls: !0, optionsControls: !0, customControls: !0, oneBlock: !1, position: "topleft", positions: { draw: "", edit: "", options: "", custom: "" } }, customButtons: [], initialize: function(o) {
      this.init(o);
    }, reinit: function() {
      var o = this.isVisible;
      this.removeControls(), this._defineButtons(), o && this.addControls();
    }, init: function(o) {
      this.map = o, this.buttons = {}, this.isVisible = !1, this.drawContainer = L.DomUtil.create("div", "leaflet-pm-toolbar leaflet-pm-draw leaflet-bar leaflet-control"), this.editContainer = L.DomUtil.create("div", "leaflet-pm-toolbar leaflet-pm-edit leaflet-bar leaflet-control"), this.optionsContainer = L.DomUtil.create("div", "leaflet-pm-toolbar leaflet-pm-options leaflet-bar leaflet-control"), this.customContainer = L.DomUtil.create("div", "leaflet-pm-toolbar leaflet-pm-custom leaflet-bar leaflet-control"), this._defineButtons();
    }, _createContainer: function(o) {
      var c = "".concat(o, "Container");
      return this[c] || (this[c] = L.DomUtil.create("div", "leaflet-pm-toolbar leaflet-pm-".concat(o, " leaflet-bar leaflet-control"))), this[c];
    }, getButtons: function() {
      return this.buttons;
    }, addControls: function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.options;
      typeof o.editPolygon < "u" && (o.editMode = o.editPolygon), typeof o.deleteLayer < "u" && (o.removalMode = o.deleteLayer), L.Util.setOptions(this, o), this.applyIconStyle(), this.isVisible = !0, this._showHideButtons();
    }, applyIconStyle: function() {
      var o = this.getButtons(), c = { geomanIcons: { drawMarker: "control-icon leaflet-pm-icon-marker", drawPolyline: "control-icon leaflet-pm-icon-polyline", drawRectangle: "control-icon leaflet-pm-icon-rectangle", drawPolygon: "control-icon leaflet-pm-icon-polygon", drawCircle: "control-icon leaflet-pm-icon-circle", drawCircleMarker: "control-icon leaflet-pm-icon-circle-marker", editMode: "control-icon leaflet-pm-icon-edit", dragMode: "control-icon leaflet-pm-icon-drag", cutPolygon: "control-icon leaflet-pm-icon-cut", removalMode: "control-icon leaflet-pm-icon-delete", drawText: "control-icon leaflet-pm-icon-text" } };
      for (var p in o) {
        var _ = o[p];
        L.Util.setOptions(_, { className: c.geomanIcons[p] });
      }
    }, removeControls: function() {
      var o = this.getButtons();
      for (var c in o)
        o[c].remove();
      this.isVisible = !1;
    }, toggleControls: function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.options;
      this.isVisible ? this.removeControls() : this.addControls(o);
    }, _addButton: function(o, c) {
      return this.buttons[o] = c, this.options[o] = this.options[o] || !1, this.buttons[o];
    }, triggerClickOnToggledButtons: function(o) {
      for (var c in this.buttons) {
        var p = this.buttons[c];
        p._button.disableByOtherButtons && p !== o && p.toggled() && p._triggerClick();
      }
    }, toggleButton: function(o, c) {
      var p = !(arguments.length > 2 && arguments[2] !== void 0) || arguments[2];
      return o === "editPolygon" && (o = "editMode"), o === "deleteLayer" && (o = "removalMode"), p && this.triggerClickOnToggledButtons(this.buttons[o]), !!this.buttons[o] && this.buttons[o].toggle(c);
    }, _defineButtons: function() {
      var o = this, c = { className: "control-icon leaflet-pm-icon-marker", title: pe("buttonTitles.drawMarkerButton"), jsClass: "Marker", onClick: function() {
      }, afterClick: function(Me, Ie) {
        o.map.pm.Draw[Ie.button._button.jsClass].toggle();
      }, doToggle: !0, toggleStatus: !1, disableOtherButtons: !0, position: this.options.position, actions: ["cancel"] }, p = { title: pe("buttonTitles.drawPolyButton"), className: "control-icon leaflet-pm-icon-polygon", jsClass: "Polygon", onClick: function() {
      }, afterClick: function(Me, Ie) {
        o.map.pm.Draw[Ie.button._button.jsClass].toggle();
      }, doToggle: !0, toggleStatus: !1, disableOtherButtons: !0, position: this.options.position, actions: ["finish", "removeLastVertex", "cancel"] }, _ = { className: "control-icon leaflet-pm-icon-polyline", title: pe("buttonTitles.drawLineButton"), jsClass: "Line", onClick: function() {
      }, afterClick: function(Me, Ie) {
        o.map.pm.Draw[Ie.button._button.jsClass].toggle();
      }, doToggle: !0, toggleStatus: !1, disableOtherButtons: !0, position: this.options.position, actions: ["finish", "removeLastVertex", "cancel"] }, w = { title: pe("buttonTitles.drawCircleButton"), className: "control-icon leaflet-pm-icon-circle", jsClass: "Circle", onClick: function() {
      }, afterClick: function(Me, Ie) {
        o.map.pm.Draw[Ie.button._button.jsClass].toggle();
      }, doToggle: !0, toggleStatus: !1, disableOtherButtons: !0, position: this.options.position, actions: ["cancel"] }, B = { title: pe("buttonTitles.drawCircleMarkerButton"), className: "control-icon leaflet-pm-icon-circle-marker", jsClass: "CircleMarker", onClick: function() {
      }, afterClick: function(Me, Ie) {
        o.map.pm.Draw[Ie.button._button.jsClass].toggle();
      }, doToggle: !0, toggleStatus: !1, disableOtherButtons: !0, position: this.options.position, actions: ["cancel"] }, F = { title: pe("buttonTitles.drawRectButton"), className: "control-icon leaflet-pm-icon-rectangle", jsClass: "Rectangle", onClick: function() {
      }, afterClick: function(Me, Ie) {
        o.map.pm.Draw[Ie.button._button.jsClass].toggle();
      }, doToggle: !0, toggleStatus: !1, disableOtherButtons: !0, position: this.options.position, actions: ["cancel"] }, Z = { title: pe("buttonTitles.editButton"), className: "control-icon leaflet-pm-icon-edit", onClick: function() {
      }, afterClick: function() {
        o.map.pm.toggleGlobalEditMode();
      }, doToggle: !0, toggleStatus: !1, disableOtherButtons: !0, position: this.options.position, tool: "edit", actions: ["finishMode"] }, V = { title: pe("buttonTitles.dragButton"), className: "control-icon leaflet-pm-icon-drag", onClick: function() {
      }, afterClick: function() {
        o.map.pm.toggleGlobalDragMode();
      }, doToggle: !0, toggleStatus: !1, disableOtherButtons: !0, position: this.options.position, tool: "edit", actions: ["finishMode"] }, K = { title: pe("buttonTitles.cutButton"), className: "control-icon leaflet-pm-icon-cut", jsClass: "Cut", onClick: function() {
      }, afterClick: function(Me, Ie) {
        o.map.pm.Draw[Ie.button._button.jsClass].toggle({ snappable: !0, cursorMarker: !0, allowSelfIntersection: !1 });
      }, doToggle: !0, toggleStatus: !1, disableOtherButtons: !0, position: this.options.position, tool: "edit", actions: ["finish", "removeLastVertex", "cancel"] }, oe = { title: pe("buttonTitles.deleteButton"), className: "control-icon leaflet-pm-icon-delete", onClick: function() {
      }, afterClick: function() {
        o.map.pm.toggleGlobalRemovalMode();
      }, doToggle: !0, toggleStatus: !1, disableOtherButtons: !0, position: this.options.position, tool: "edit", actions: ["finishMode"] }, _e = { title: pe("buttonTitles.rotateButton"), className: "control-icon leaflet-pm-icon-rotate", onClick: function() {
      }, afterClick: function() {
        o.map.pm.toggleGlobalRotateMode();
      }, doToggle: !0, toggleStatus: !1, disableOtherButtons: !0, position: this.options.position, tool: "edit", actions: ["finishMode"] }, fe = { className: "control-icon leaflet-pm-icon-text", title: pe("buttonTitles.drawTextButton"), jsClass: "Text", onClick: function() {
      }, afterClick: function(Me, Ie) {
        o.map.pm.Draw[Ie.button._button.jsClass].toggle();
      }, doToggle: !0, toggleStatus: !1, disableOtherButtons: !0, position: this.options.position, actions: ["cancel"] };
      this._addButton("drawMarker", new L.Control.PMButton(c)), this._addButton("drawPolyline", new L.Control.PMButton(_)), this._addButton("drawRectangle", new L.Control.PMButton(F)), this._addButton("drawPolygon", new L.Control.PMButton(p)), this._addButton("drawCircle", new L.Control.PMButton(w)), this._addButton("drawCircleMarker", new L.Control.PMButton(B)), this._addButton("drawText", new L.Control.PMButton(fe)), this._addButton("editMode", new L.Control.PMButton(Z)), this._addButton("dragMode", new L.Control.PMButton(V)), this._addButton("cutPolygon", new L.Control.PMButton(K)), this._addButton("removalMode", new L.Control.PMButton(oe)), this._addButton("rotateMode", new L.Control.PMButton(_e));
    }, _showHideButtons: function() {
      if (this.isVisible) {
        this.removeControls(), this.isVisible = !0;
        var o = this.getButtons(), c = [];
        for (var p in this.options.drawControls === !1 && (c = c.concat(Object.keys(o).filter(function(w) {
          return !o[w]._button.tool;
        }))), this.options.editControls === !1 && (c = c.concat(Object.keys(o).filter(function(w) {
          return o[w]._button.tool === "edit";
        }))), this.options.optionsControls === !1 && (c = c.concat(Object.keys(o).filter(function(w) {
          return o[w]._button.tool === "options";
        }))), this.options.customControls === !1 && (c = c.concat(Object.keys(o).filter(function(w) {
          return o[w]._button.tool === "custom";
        }))), o)
          if (this.options[p] && c.indexOf(p) === -1) {
            var _ = o[p]._button.tool;
            _ || (_ = "draw"), o[p].setPosition(this._getBtnPosition(_)), o[p].addTo(this.map);
          }
      }
    }, _getBtnPosition: function(o) {
      return this.options.positions && this.options.positions[o] ? this.options.positions[o] : this.options.position;
    }, setBlockPosition: function(o, c) {
      this.options.positions[o] = c, this._showHideButtons(), this.changeControlOrder();
    }, getBlockPositions: function() {
      return this.options.positions;
    }, copyDrawControl: function(o, c) {
      if (!c)
        throw new TypeError("Button has no name");
      It(c) !== "object" && (c = { name: c });
      var p = this._btnNameMapping(o);
      if (!c.name)
        throw new TypeError("Button has no name");
      if (this.buttons[c.name])
        throw new TypeError("Button with this name already exists");
      var _ = this.map.pm.Draw.createNewDrawInstance(c.name, p);
      return c = Dt(Dt({}, this.buttons[p]._button), c), { drawInstance: _, control: this.createCustomControl(c) };
    }, createCustomControl: function(o) {
      var c, p;
      if (!o.name)
        throw new TypeError("Button has no name");
      if (this.buttons[o.name])
        throw new TypeError("Button with this name already exists");
      o.onClick || (o.onClick = function() {
      }), o.afterClick || (o.afterClick = function() {
      }), o.toggle !== !1 && (o.toggle = !0), o.block && (o.block = o.block.toLowerCase()), o.block && o.block !== "draw" || (o.block = ""), o.className ? o.className.indexOf("control-icon") === -1 && (o.className = "control-icon ".concat(o.className)) : o.className = "control-icon";
      var _ = { tool: o.block, className: o.className, title: o.title || "", jsClass: o.name, onClick: o.onClick, afterClick: o.afterClick, doToggle: o.toggle, toggleStatus: !1, disableOtherButtons: (c = o.disableOtherButtons) === null || c === void 0 || c, disableByOtherButtons: (p = o.disableByOtherButtons) === null || p === void 0 || p, cssToggle: o.toggle, position: this.options.position, actions: o.actions || [], disabled: !!o.disabled };
      this.options[o.name] !== !1 && (this.options[o.name] = !0);
      var w = this._addButton(o.name, new L.Control.PMButton(_));
      return this.changeControlOrder(), w;
    }, changeControlOrder: function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], c = this._shapeMapping(), p = [];
      o.forEach(function(K) {
        c[K] ? p.push(c[K]) : p.push(K);
      });
      var _ = this.getButtons(), w = {};
      p.forEach(function(K) {
        _[K] && (w[K] = _[K]);
      });
      var B = Object.keys(_).filter(function(K) {
        return !_[K]._button.tool;
      });
      B.forEach(function(K) {
        p.indexOf(K) === -1 && (w[K] = _[K]);
      });
      var F = Object.keys(_).filter(function(K) {
        return _[K]._button.tool === "edit";
      });
      F.forEach(function(K) {
        p.indexOf(K) === -1 && (w[K] = _[K]);
      });
      var Z = Object.keys(_).filter(function(K) {
        return _[K]._button.tool === "options";
      });
      Z.forEach(function(K) {
        p.indexOf(K) === -1 && (w[K] = _[K]);
      });
      var V = Object.keys(_).filter(function(K) {
        return _[K]._button.tool === "custom";
      });
      V.forEach(function(K) {
        p.indexOf(K) === -1 && (w[K] = _[K]);
      }), Object.keys(_).forEach(function(K) {
        p.indexOf(K) === -1 && (w[K] = _[K]);
      }), this.map.pm.Toolbar.buttons = w, this._showHideButtons();
    }, getControlOrder: function() {
      var o = this.getButtons(), c = [];
      for (var p in o)
        c.push(p);
      return c;
    }, changeActionsOfControl: function(o, c) {
      var p = this._btnNameMapping(o);
      if (!p)
        throw new TypeError("No name passed");
      if (!c)
        throw new TypeError("No actions passed");
      if (!this.buttons[p])
        throw new TypeError("Button with this name not exists");
      this.buttons[p]._button.actions = c, this.changeControlOrder();
    }, setButtonDisabled: function(o, c) {
      var p = this._btnNameMapping(o);
      c ? this.buttons[p].disable() : this.buttons[p].enable();
    }, _shapeMapping: function() {
      return { Marker: "drawMarker", Circle: "drawCircle", Polygon: "drawPolygon", Rectangle: "drawRectangle", Polyline: "drawPolyline", Line: "drawPolyline", CircleMarker: "drawCircleMarker", Edit: "editMode", Drag: "dragMode", Cut: "cutPolygon", Removal: "removalMode", Rotate: "rotateMode", Text: "drawText" };
    }, _btnNameMapping: function(o) {
      var c = this._shapeMapping();
      return c[o] ? c[o] : o;
    } });
    function qt(o, c) {
      var p = Object.keys(o);
      if (Object.getOwnPropertySymbols) {
        var _ = Object.getOwnPropertySymbols(o);
        c && (_ = _.filter(function(w) {
          return Object.getOwnPropertyDescriptor(o, w).enumerable;
        })), p.push.apply(p, _);
      }
      return p;
    }
    function cn(o) {
      for (var c = 1; c < arguments.length; c++) {
        var p = arguments[c] != null ? arguments[c] : {};
        c % 2 ? qt(Object(p), !0).forEach(function(_) {
          sn(o, _, p[_]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(p)) : qt(Object(p)).forEach(function(_) {
          Object.defineProperty(o, _, Object.getOwnPropertyDescriptor(p, _));
        });
      }
      return o;
    }
    function sn(o, c, p) {
      return c in o ? Object.defineProperty(o, c, { value: p, enumerable: !0, configurable: !0, writable: !0 }) : o[c] = p, o;
    }
    var H = { _initSnappableMarkers: function() {
      this.options.snapDistance = this.options.snapDistance || 30, this.options.snapSegment = this.options.snapSegment === void 0 || this.options.snapSegment, this._assignEvents(this._markers), this._layer.off("pm:dragstart", this._unsnap, this), this._layer.on("pm:dragstart", this._unsnap, this);
    }, _disableSnapping: function() {
      this._layer.off("pm:dragstart", this._unsnap, this);
    }, _assignEvents: function(o) {
      var c = this;
      o.forEach(function(p) {
        Array.isArray(p) ? c._assignEvents(p) : (p.off("drag", c._handleSnapping, c), p.on("drag", c._handleSnapping, c), p.off("dragend", c._cleanupSnapping, c), p.on("dragend", c._cleanupSnapping, c));
      });
    }, _cleanupSnapping: function(o) {
      o && (o.target._snapped = !1), delete this._snapList, this.throttledList && (this._map.off("layeradd", this.throttledList, this), this.throttledList = void 0), this._map.off("layerremove", this._handleSnapLayerRemoval, this), this.debugIndicatorLines && this.debugIndicatorLines.forEach(function(c) {
        c.remove();
      });
    }, _handleThrottleSnapping: function() {
      this.throttledList && this._createSnapList();
    }, _handleSnapping: function(o) {
      var c, p, _, w = this, B = o.target;
      if (B._snapped = !1, this.throttledList || (this.throttledList = L.Util.throttle(this._handleThrottleSnapping, 100, this)), o != null && (c = o.originalEvent) !== null && c !== void 0 && c.altKey || (p = this._map) !== null && p !== void 0 && (_ = p.pm) !== null && _ !== void 0 && _.Keyboard.isAltKeyPressed() || (this._snapList === void 0 && (this._createSnapList(), this._map.off("layeradd", this.throttledList, this), this._map.on("layeradd", this.throttledList, this)), this._snapList.length <= 0))
        return !1;
      var F = this._calcClosestLayer(B.getLatLng(), this._snapList);
      if (Object.keys(F).length === 0)
        return !1;
      var Z, V = F.layer instanceof L.Marker || F.layer instanceof L.CircleMarker || !this.options.snapSegment;
      Z = V ? F.latlng : this._checkPrioritiySnapping(F);
      var K = this.options.snapDistance, oe = { marker: B, shape: this._shape, snapLatLng: Z, segment: F.segment, layer: this._layer, workingLayer: this._layer, layerInteractedWith: F.layer, distance: F.distance };
      if (this._fireSnapDrag(oe.marker, oe), this._fireSnapDrag(this._layer, oe), F.distance < K) {
        B._orgLatLng = B.getLatLng(), B.setLatLng(Z), B._snapped = !0, B._snapInfo = oe;
        var _e = this._snapLatLng || {}, fe = Z || {};
        _e.lat === fe.lat && _e.lng === fe.lng || (w._snapLatLng = Z, w._fireSnap(B, oe), w._fireSnap(w._layer, oe));
      } else
        this._snapLatLng && (this._unsnap(oe), B._snapped = !1, B._snapInfo = void 0, this._fireUnsnap(oe.marker, oe), this._fireUnsnap(this._layer, oe));
      return !0;
    }, _createSnapList: function() {
      var o = this, c = [], p = [], _ = this._map;
      _.off("layerremove", this._handleSnapLayerRemoval, this), _.on("layerremove", this._handleSnapLayerRemoval, this), _.eachLayer(function(w) {
        if ((w instanceof L.Polyline || w instanceof L.Marker || w instanceof L.CircleMarker || w instanceof L.ImageOverlay) && w.options.snapIgnore !== !0) {
          if (w.options.snapIgnore === void 0 && (!L.PM.optIn && w.options.pmIgnore === !0 || L.PM.optIn && w.options.pmIgnore !== !1))
            return;
          (w instanceof L.Circle || w instanceof L.CircleMarker) && w.pm && w.pm._hiddenPolyCircle ? c.push(w.pm._hiddenPolyCircle) : w instanceof L.ImageOverlay && (w = L.rectangle(w.getBounds())), c.push(w);
          var B = L.polyline([], { color: "red", pmIgnore: !0 });
          B._pmTempLayer = !0, p.push(B), (w instanceof L.Circle || w instanceof L.CircleMarker) && p.push(B);
        }
      }), c = (c = (c = c.filter(function(w) {
        return o._layer !== w;
      })).filter(function(w) {
        return w._latlng || w._latlngs && Ye(w._latlngs);
      })).filter(function(w) {
        return !w._pmTempLayer;
      }), this._otherSnapLayers ? (this._otherSnapLayers.forEach(function() {
        var w = L.polyline([], { color: "red", pmIgnore: !0 });
        w._pmTempLayer = !0, p.push(w);
      }), this._snapList = c.concat(this._otherSnapLayers)) : this._snapList = c, this.debugIndicatorLines = p;
    }, _handleSnapLayerRemoval: function(o) {
      var c = o.layer;
      if (c._leaflet_id) {
        var p = this._snapList.findIndex(function(_) {
          return _._leaflet_id === c._leaflet_id;
        });
        p > -1 && this._snapList.splice(p, 1);
      }
    }, _calcClosestLayer: function(o, c) {
      return this._calcClosestLayers(o, c, 1)[0];
    }, _calcClosestLayers: function(o, c) {
      var p = this, _ = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, w = [], B = {};
      c.forEach(function(Z, V) {
        if (!Z._parentCopy || Z._parentCopy !== p._layer) {
          var K = p._calcLayerDistances(o, Z);
          if (K.distance = Math.floor(K.distance), p.debugIndicatorLines) {
            if (!p.debugIndicatorLines[V]) {
              var oe = L.polyline([], { color: "red", pmIgnore: !0 });
              oe._pmTempLayer = !0, p.debugIndicatorLines[V] = oe;
            }
            p.debugIndicatorLines[V].setLatLngs([o, K.latlng]);
          }
          _ === 1 && (B.distance === void 0 || K.distance <= B.distance) ? (K.distance < B.distance && (w = []), (B = K).layer = Z, w.push(B)) : _ !== 1 && (B = {}, (B = K).layer = Z, w.push(B));
        }
      }), _ !== 1 && (w = w.sort(function(Z, V) {
        return Z.distance - V.distance;
      })), _ === -1 && (_ = w.length);
      var F = this._getClosestLayerByPriority(w, _);
      return L.Util.isArray(F) ? F : [F];
    }, _calcLayerDistances: function(o, c) {
      var p = this._map, _ = c instanceof L.Marker || c instanceof L.CircleMarker, w = c instanceof L.Polygon, B = o;
      if (_) {
        var F = c.getLatLng();
        return { latlng: cn({}, F), distance: this._getDistance(p, F, B) };
      }
      return this._calcLatLngDistances(B, c.getLatLngs(), p, w);
    }, _calcLatLngDistances: function(o, c, p) {
      var _, w, B, F = this, Z = arguments.length > 3 && arguments[3] !== void 0 && arguments[3], V = function oe(_e) {
        _e.forEach(function(fe, Me) {
          if (Array.isArray(fe))
            oe(fe);
          else if (F.options.snapSegment) {
            var Ie, qe = fe;
            Ie = Z ? Me + 1 === _e.length ? 0 : Me + 1 : Me + 1 === _e.length ? void 0 : Me + 1;
            var ot = _e[Ie];
            if (ot) {
              var Tt = F._getDistanceToSegment(p, o, qe, ot);
              (w === void 0 || Tt < w) && (w = Tt, B = [qe, ot]);
            }
          } else {
            var Ct = F._getDistance(p, o, fe);
            (w === void 0 || Ct < w) && (w = Ct, _ = fe);
          }
        });
      };
      if (V(c), this.options.snapSegment) {
        var K = this._getClosestPointOnSegment(p, o, B[0], B[1]);
        return { latlng: cn({}, K), segment: B, distance: w };
      }
      return { latlng: _, distance: w };
    }, _getClosestLayerByPriority: function(o) {
      var c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
      o = o.sort(function(F, Z) {
        return F._leaflet_id - Z._leaflet_id;
      });
      var p = ["Marker", "CircleMarker", "Circle", "Line", "Polygon", "Rectangle"], _ = this._map.pm.globalOptions.snappingOrder || [], w = 0, B = {};
      return _.concat(p).forEach(function(F) {
        B[F] || (w += 1, B[F] = w);
      }), o.sort(Ze("instanceofShape", B)), c === 1 ? o[0] || {} : o.slice(0, c);
    }, _checkPrioritiySnapping: function(o) {
      var c = this._map, p = o.segment[0], _ = o.segment[1], w = o.latlng, B = this._getDistance(c, p, w), F = this._getDistance(c, _, w), Z = B < F ? p : _, V = B < F ? B : F;
      if (this.options.snapMiddle) {
        var K = L.PM.Utils.calcMiddleLatLng(c, p, _), oe = this._getDistance(c, K, w);
        oe < B && oe < F && (Z = K, V = oe);
      }
      return cn({}, V < this.options.snapDistance ? Z : w);
    }, _unsnap: function() {
      delete this._snapLatLng;
    }, _getClosestPointOnSegment: function(o, c, p, _) {
      var w = o.getMaxZoom();
      w === 1 / 0 && (w = o.getZoom());
      var B = o.project(c, w), F = o.project(p, w), Z = o.project(_, w), V = L.LineUtil.closestPointOnSegment(B, F, Z);
      return o.unproject(V, w);
    }, _getDistanceToSegment: function(o, c, p, _) {
      var w = o.latLngToLayerPoint(c), B = o.latLngToLayerPoint(p), F = o.latLngToLayerPoint(_);
      return L.LineUtil.pointToSegmentDistance(w, B, F);
    }, _getDistance: function(o, c, p) {
      return o.latLngToLayerPoint(c).distanceTo(o.latLngToLayerPoint(p));
    } };
    const S = H, E = L.Class.extend({ includes: [S, ne], options: { snappable: !0, snapDistance: 20, snapMiddle: !1, allowSelfIntersection: !0, tooltips: !0, templineStyle: {}, hintlineStyle: { color: "#3388ff", dashArray: "5,5" }, pathOptions: null, cursorMarker: !0, finishOn: null, markerStyle: { draggable: !0, icon: L.icon() }, hideMiddleMarkers: !1, minRadiusCircle: null, maxRadiusCircle: null, minRadiusCircleMarker: null, maxRadiusCircleMarker: null, resizeableCircleMarker: !1, resizableCircle: !0, markerEditable: !0, continueDrawing: !1, snapSegment: !0, requireSnapToFinish: !1, rectangleAngle: 0 }, setOptions: function(o) {
      L.Util.setOptions(this, o), this.setStyle(this.options);
    }, setStyle: function() {
    }, getOptions: function() {
      return this.options;
    }, initialize: function(o) {
      var c = this, p = new L.Icon.Default();
      p.options.tooltipAnchor = [0, 0], this.options.markerStyle.icon = p, this._map = o, this.shapes = ["Marker", "CircleMarker", "Line", "Polygon", "Rectangle", "Circle", "Cut", "Text"], this.shapes.forEach(function(_) {
        c[_] = new L.PM.Draw[_](c._map);
      }), this.Marker.setOptions({ continueDrawing: !0 }), this.CircleMarker.setOptions({ continueDrawing: !0 });
    }, setPathOptions: function(o) {
      var c = arguments.length > 1 && arguments[1] !== void 0 && arguments[1];
      this.options.pathOptions = c ? a()(this.options.pathOptions, o) : o;
    }, getShapes: function() {
      return this.shapes;
    }, getShape: function() {
      return this._shape;
    }, enable: function(o, c) {
      if (!o)
        throw new Error("Error: Please pass a shape as a parameter. Possible shapes are: ".concat(this.getShapes().join(",")));
      this.disable(), this[o].enable(c);
    }, disable: function() {
      var o = this;
      this.shapes.forEach(function(c) {
        o[c].disable();
      });
    }, addControls: function() {
      var o = this;
      this.shapes.forEach(function(c) {
        o[c].addButton();
      });
    }, getActiveShape: function() {
      var o, c = this;
      return this.shapes.forEach(function(p) {
        c[p]._enabled && (o = p);
      }), o;
    }, _setGlobalDrawMode: function() {
      this._shape === "Cut" ? this._fireGlobalCutModeToggled() : this._fireGlobalDrawModeToggled();
      var o = L.PM.Utils.findLayers(this._map);
      this._enabled ? o.forEach(function(c) {
        L.PM.Utils.disablePopup(c);
      }) : o.forEach(function(c) {
        L.PM.Utils.enablePopup(c);
      });
    }, createNewDrawInstance: function(o, c) {
      var p = this._getShapeFromBtnName(c);
      if (this[o])
        throw new TypeError("Draw Type already exists");
      if (!L.PM.Draw[p])
        throw new TypeError("There is no class L.PM.Draw.".concat(p));
      return this[o] = new L.PM.Draw[p](this._map), this[o].toolbarButtonName = o, this[o]._shape = o, this.shapes.push(o), this[c] && this[o].setOptions(this[c].options), this[o].setOptions(this[o].options), this[o];
    }, _getShapeFromBtnName: function(o) {
      var c = { drawMarker: "Marker", drawCircle: "Circle", drawPolygon: "Polygon", drawPolyline: "Line", drawRectangle: "Rectangle", drawCircleMarker: "CircleMarker", editMode: "Edit", dragMode: "Drag", cutPolygon: "Cut", removalMode: "Removal", rotateMode: "Rotate", drawText: "Text" };
      return c[o] ? c[o] : this[o] ? this[o]._shape : o;
    }, _finishLayer: function(o) {
      o.pm && (o.pm.setOptions(this.options), o.pm._shape = this._shape, o.pm._map = this._map), this._addDrawnLayerProp(o);
    }, _addDrawnLayerProp: function(o) {
      o._drawnByGeoman = !0;
    }, _setPane: function(o, c) {
      c === "layerPane" ? o.options.pane = this._map.pm.globalOptions.panes && this._map.pm.globalOptions.panes.layerPane || "overlayPane" : c === "vertexPane" ? o.options.pane = this._map.pm.globalOptions.panes && this._map.pm.globalOptions.panes.vertexPane || "markerPane" : c === "markerPane" && (o.options.pane = this._map.pm.globalOptions.panes && this._map.pm.globalOptions.panes.markerPane || "markerPane");
    }, _isFirstLayer: function() {
      return (this._map || this._layer._map).pm.getGeomanLayers().length === 0;
    } });
    E.Marker = E.extend({ initialize: function(o) {
      this._map = o, this._shape = "Marker", this.toolbarButtonName = "drawMarker";
    }, enable: function(o) {
      var c = this;
      L.Util.setOptions(this, o), this._enabled = !0, this._map.getContainer().classList.add("geoman-draw-cursor"), this._map.on("click", this._createMarker, this), this._map.pm.Toolbar.toggleButton(this.toolbarButtonName, !0), this._hintMarker = L.marker(this._map.getCenter(), this.options.markerStyle), this._setPane(this._hintMarker, "markerPane"), this._hintMarker._pmTempLayer = !0, this._hintMarker.addTo(this._map), this.options.tooltips && this._hintMarker.bindTooltip(pe("tooltips.placeMarker"), { permanent: !0, offset: L.point(0, 10), direction: "bottom", opacity: 0.8 }).openTooltip(), this._layer = this._hintMarker, this._map.on("mousemove", this._syncHintMarker, this), this.options.markerEditable && this._map.eachLayer(function(p) {
        c.isRelevantMarker(p) && p.pm.enable();
      }), this._fireDrawStart(), this._setGlobalDrawMode();
    }, disable: function() {
      var o = this;
      this._enabled && (this._enabled = !1, this._map.getContainer().classList.remove("geoman-draw-cursor"), this._map.off("click", this._createMarker, this), this._hintMarker.remove(), this._map.off("mousemove", this._syncHintMarker, this), this._map.eachLayer(function(c) {
        o.isRelevantMarker(c) && c.pm.disable();
      }), this._map.pm.Toolbar.toggleButton(this.toolbarButtonName, !1), this.options.snappable && this._cleanupSnapping(), this._fireDrawEnd(), this._setGlobalDrawMode());
    }, enabled: function() {
      return this._enabled;
    }, toggle: function(o) {
      this.enabled() ? this.disable() : this.enable(o);
    }, isRelevantMarker: function(o) {
      return o instanceof L.Marker && o.pm && !o._pmTempLayer && !o.pm._initTextMarker;
    }, _syncHintMarker: function(o) {
      if (this._hintMarker.setLatLng(o.latlng), this.options.snappable) {
        var c = o;
        c.target = this._hintMarker, this._handleSnapping(c);
      }
      this._fireChange(this._hintMarker.getLatLng(), "Draw");
    }, _createMarker: function(o) {
      if (o.latlng && (!this.options.requireSnapToFinish || this._hintMarker._snapped || this._isFirstLayer())) {
        this._hintMarker._snapped || this._hintMarker.setLatLng(o.latlng);
        var c = this._hintMarker.getLatLng(), p = new L.Marker(c, this.options.markerStyle);
        this._setPane(p, "markerPane"), this._finishLayer(p), p.pm || (p.options.draggable = !1), p.addTo(this._map.pm._getContainingLayer()), p.pm && this.options.markerEditable ? p.pm.enable() : p.dragging && p.dragging.disable(), this._fireCreate(p), this._cleanupSnapping(), this.options.continueDrawing || this.disable();
      }
    }, setStyle: function() {
      var o, c;
      (o = this.options.markerStyle) !== null && o !== void 0 && o.icon && ((c = this._hintMarker) === null || c === void 0 || c.setIcon(this.options.markerStyle.icon));
    } });
    var z = 63710088e-1, q = { centimeters: 637100880, centimetres: 637100880, degrees: 57.22891354143274, feet: 20902260511392e-6, inches: 39.37 * z, kilometers: 6371.0088, kilometres: 6371.0088, meters: z, metres: z, miles: 3958.761333810546, millimeters: 6371008800, millimetres: 6371008800, nauticalmiles: z / 1852, radians: 1, yards: 6967335223679999e-9 };
    function J(o, c, p) {
      p === void 0 && (p = {});
      var _ = { type: "Feature" };
      return (p.id === 0 || p.id) && (_.id = p.id), p.bbox && (_.bbox = p.bbox), _.properties = c || {}, _.geometry = o, _;
    }
    function me(o, c, p) {
      if (p === void 0 && (p = {}), !o)
        throw new Error("coordinates is required");
      if (!Array.isArray(o))
        throw new Error("coordinates must be an Array");
      if (o.length < 2)
        throw new Error("coordinates must be at least 2 numbers long");
      if (!xt(o[0]) || !xt(o[1]))
        throw new Error("coordinates must contain numbers");
      return J({ type: "Point", coordinates: o }, c, p);
    }
    function ye(o, c, p) {
      if (p === void 0 && (p = {}), o.length < 2)
        throw new Error("coordinates must be an array of two or more positions");
      return J({ type: "LineString", coordinates: o }, c, p);
    }
    function Oe(o, c) {
      c === void 0 && (c = {});
      var p = { type: "FeatureCollection" };
      return c.id && (p.id = c.id), c.bbox && (p.bbox = c.bbox), p.features = o, p;
    }
    function Ue(o, c) {
      c === void 0 && (c = "kilometers");
      var p = q[c];
      if (!p)
        throw new Error(c + " units is invalid");
      return o * p;
    }
    function at(o, c) {
      c === void 0 && (c = "kilometers");
      var p = q[c];
      if (!p)
        throw new Error(c + " units is invalid");
      return o / p;
    }
    function Xe(o) {
      return 180 * (o % (2 * Math.PI)) / Math.PI;
    }
    function We(o) {
      return o % 360 * Math.PI / 180;
    }
    function xt(o) {
      return !isNaN(o) && o !== null && !Array.isArray(o);
    }
    function lt(o) {
      var c, p, _ = { type: "FeatureCollection", features: [] };
      if ((p = o.type === "Feature" ? o.geometry : o).type === "LineString")
        c = [p.coordinates];
      else if (p.type === "MultiLineString")
        c = p.coordinates;
      else if (p.type === "MultiPolygon")
        c = [].concat.apply([], p.coordinates);
      else {
        if (p.type !== "Polygon")
          throw new Error("Input must be a LineString, MultiLineString, Polygon, or MultiPolygon Feature or Geometry");
        c = p.coordinates;
      }
      return c.forEach(function(w) {
        c.forEach(function(B) {
          for (var F = 0; F < w.length - 1; F++)
            for (var Z = F; Z < B.length - 1; Z++)
              if (!(w === B && (Math.abs(F - Z) === 1 || F === 0 && Z === w.length - 2 && w[F][0] === w[w.length - 1][0] && w[F][1] === w[w.length - 1][1]))) {
                var V = bt(w[F][0], w[F][1], w[F + 1][0], w[F + 1][1], B[Z][0], B[Z][1], B[Z + 1][0], B[Z + 1][1]);
                V && _.features.push(me([V[0], V[1]]));
              }
        });
      }), _;
    }
    function bt(o, c, p, _, w, B, F, Z) {
      var V, K, oe, _e, fe = { x: null, y: null, onLine1: !1, onLine2: !1 };
      return (V = (Z - B) * (p - o) - (F - w) * (_ - c)) === 0 ? fe.x !== null && fe.y !== null && fe : (_e = (p - o) * (K = c - B) - (_ - c) * (oe = o - w), K = ((F - w) * K - (Z - B) * oe) / V, oe = _e / V, fe.x = o + K * (p - o), fe.y = c + K * (_ - c), K >= 0 && K <= 1 && (fe.onLine1 = !0), oe >= 0 && oe <= 1 && (fe.onLine2 = !0), !(!fe.onLine1 || !fe.onLine2) && [fe.x, fe.y]);
    }
    function At(o, c) {
      var p = Object.keys(o);
      if (Object.getOwnPropertySymbols) {
        var _ = Object.getOwnPropertySymbols(o);
        c && (_ = _.filter(function(w) {
          return Object.getOwnPropertyDescriptor(o, w).enumerable;
        })), p.push.apply(p, _);
      }
      return p;
    }
    function Rt(o) {
      for (var c = 1; c < arguments.length; c++) {
        var p = arguments[c] != null ? arguments[c] : {};
        c % 2 ? At(Object(p), !0).forEach(function(_) {
          be(o, _, p[_]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(p)) : At(Object(p)).forEach(function(_) {
          Object.defineProperty(o, _, Object.getOwnPropertyDescriptor(p, _));
        });
      }
      return o;
    }
    function be(o, c, p) {
      return c in o ? Object.defineProperty(o, c, { value: p, enumerable: !0, configurable: !0, writable: !0 }) : o[c] = p, o;
    }
    function j(o, c) {
      var p = Object.keys(o);
      if (Object.getOwnPropertySymbols) {
        var _ = Object.getOwnPropertySymbols(o);
        c && (_ = _.filter(function(w) {
          return Object.getOwnPropertyDescriptor(o, w).enumerable;
        })), p.push.apply(p, _);
      }
      return p;
    }
    function ge(o) {
      for (var c = 1; c < arguments.length; c++) {
        var p = arguments[c] != null ? arguments[c] : {};
        c % 2 ? j(Object(p), !0).forEach(function(_) {
          De(o, _, p[_]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(p)) : j(Object(p)).forEach(function(_) {
          Object.defineProperty(o, _, Object.getOwnPropertyDescriptor(p, _));
        });
      }
      return o;
    }
    function De(o, c, p) {
      return c in o ? Object.defineProperty(o, c, { value: p, enumerable: !0, configurable: !0, writable: !0 }) : o[c] = p, o;
    }
    function N(o) {
      if (!o)
        throw new Error("coord is required");
      if (!Array.isArray(o)) {
        if (o.type === "Feature" && o.geometry !== null && o.geometry.type === "Point")
          return o.geometry.coordinates;
        if (o.type === "Point")
          return o.coordinates;
      }
      if (Array.isArray(o) && o.length >= 2 && !Array.isArray(o[0]) && !Array.isArray(o[1]))
        return o;
      throw new Error("coord must be GeoJSON Point or an Array of numbers");
    }
    function U(o) {
      if (Array.isArray(o))
        return o;
      if (o.type === "Feature") {
        if (o.geometry !== null)
          return o.geometry.coordinates;
      } else if (o.coordinates)
        return o.coordinates;
      throw new Error("coords must be GeoJSON Feature, Geometry Object or an Array");
    }
    function ie(o) {
      return o.type === "Feature" ? o.geometry : o;
    }
    function ve(o, c) {
      return o.type === "FeatureCollection" ? "FeatureCollection" : o.type === "GeometryCollection" ? "GeometryCollection" : o.type === "Feature" && o.geometry !== null ? o.geometry.type : o.type;
    }
    function Ee(o, c, p) {
      if (o !== null)
        for (var _, w, B, F, Z, V, K, oe, _e = 0, fe = 0, Me = o.type, Ie = Me === "FeatureCollection", qe = Me === "Feature", ot = Ie ? o.features.length : 1, Tt = 0; Tt < ot; Tt++) {
          Z = (oe = !!(K = Ie ? o.features[Tt].geometry : qe ? o.geometry : o) && K.type === "GeometryCollection") ? K.geometries.length : 1;
          for (var Ct = 0; Ct < Z; Ct++) {
            var Yt = 0, pn = 0;
            if ((F = oe ? K.geometries[Ct] : K) !== null) {
              V = F.coordinates;
              var mn = F.type;
              switch (_e = !p || mn !== "Polygon" && mn !== "MultiPolygon" ? 0 : 1, mn) {
                case null:
                  break;
                case "Point":
                  if (c(V, fe, Tt, Yt, pn) === !1)
                    return !1;
                  fe++, Yt++;
                  break;
                case "LineString":
                case "MultiPoint":
                  for (_ = 0; _ < V.length; _++) {
                    if (c(V[_], fe, Tt, Yt, pn) === !1)
                      return !1;
                    fe++, mn === "MultiPoint" && Yt++;
                  }
                  mn === "LineString" && Yt++;
                  break;
                case "Polygon":
                case "MultiLineString":
                  for (_ = 0; _ < V.length; _++) {
                    for (w = 0; w < V[_].length - _e; w++) {
                      if (c(V[_][w], fe, Tt, Yt, pn) === !1)
                        return !1;
                      fe++;
                    }
                    mn === "MultiLineString" && Yt++, mn === "Polygon" && pn++;
                  }
                  mn === "Polygon" && Yt++;
                  break;
                case "MultiPolygon":
                  for (_ = 0; _ < V.length; _++) {
                    for (pn = 0, w = 0; w < V[_].length; w++) {
                      for (B = 0; B < V[_][w].length - _e; B++) {
                        if (c(V[_][w][B], fe, Tt, Yt, pn) === !1)
                          return !1;
                        fe++;
                      }
                      pn++;
                    }
                    Yt++;
                  }
                  break;
                case "GeometryCollection":
                  for (_ = 0; _ < F.geometries.length; _++)
                    if (Ee(F.geometries[_], c, p) === !1)
                      return !1;
                  break;
                default:
                  throw new Error("Unknown Geometry Type");
              }
            }
          }
        }
    }
    function Ce(o, c) {
      if (o.type === "Feature")
        c(o, 0);
      else if (o.type === "FeatureCollection")
        for (var p = 0; p < o.features.length && c(o.features[p], p) !== !1; p++)
          ;
    }
    function He(o, c) {
      var p, _, w, B, F, Z, V, K, oe, _e, fe = 0, Me = o.type === "FeatureCollection", Ie = o.type === "Feature", qe = Me ? o.features.length : 1;
      for (p = 0; p < qe; p++) {
        for (Z = Me ? o.features[p].geometry : Ie ? o.geometry : o, K = Me ? o.features[p].properties : Ie ? o.properties : {}, oe = Me ? o.features[p].bbox : Ie ? o.bbox : void 0, _e = Me ? o.features[p].id : Ie ? o.id : void 0, F = (V = !!Z && Z.type === "GeometryCollection") ? Z.geometries.length : 1, w = 0; w < F; w++)
          if ((B = V ? Z.geometries[w] : Z) !== null)
            switch (B.type) {
              case "Point":
              case "LineString":
              case "MultiPoint":
              case "Polygon":
              case "MultiLineString":
              case "MultiPolygon":
                if (c(B, fe, K, oe, _e) === !1)
                  return !1;
                break;
              case "GeometryCollection":
                for (_ = 0; _ < B.geometries.length; _++)
                  if (c(B.geometries[_], fe, K, oe, _e) === !1)
                    return !1;
                break;
              default:
                throw new Error("Unknown Geometry Type");
            }
          else if (c(null, fe, K, oe, _e) === !1)
            return !1;
        fe++;
      }
    }
    function Re(o, c) {
      He(o, function(p, _, w, B, F) {
        var Z, V = p === null ? null : p.type;
        switch (V) {
          case null:
          case "Point":
          case "LineString":
          case "Polygon":
            return c(J(p, w, { bbox: B, id: F }), _, 0) !== !1 && void 0;
        }
        switch (V) {
          case "MultiPoint":
            Z = "Point";
            break;
          case "MultiLineString":
            Z = "LineString";
            break;
          case "MultiPolygon":
            Z = "Polygon";
        }
        for (var K = 0; K < p.coordinates.length; K++) {
          var oe = p.coordinates[K];
          if (c(J({ type: Z, coordinates: oe }, w), _, K) === !1)
            return !1;
        }
      });
    }
    E.Line = E.extend({ initialize: function(o) {
      this._map = o, this._shape = "Line", this.toolbarButtonName = "drawPolyline", this._doesSelfIntersect = !1;
    }, enable: function(o) {
      L.Util.setOptions(this, o), this._enabled = !0, this._markers = [], this._layerGroup = new L.FeatureGroup(), this._layerGroup._pmTempLayer = !0, this._layerGroup.addTo(this._map), this._layer = L.polyline([], Rt(Rt({}, this.options.templineStyle), {}, { pmIgnore: !1 })), this._setPane(this._layer, "layerPane"), this._layer._pmTempLayer = !0, this._layerGroup.addLayer(this._layer), this._hintline = L.polyline([], this.options.hintlineStyle), this._setPane(this._hintline, "layerPane"), this._hintline._pmTempLayer = !0, this._layerGroup.addLayer(this._hintline), this._hintMarker = L.marker(this._map.getCenter(), { interactive: !1, zIndexOffset: 100, icon: L.divIcon({ className: "marker-icon cursor-marker" }) }), this._setPane(this._hintMarker, "vertexPane"), this._hintMarker._pmTempLayer = !0, this._layerGroup.addLayer(this._hintMarker), this.options.cursorMarker && L.DomUtil.addClass(this._hintMarker._icon, "visible"), this.options.tooltips && this._hintMarker.bindTooltip(pe("tooltips.firstVertex"), { permanent: !0, offset: L.point(0, 10), direction: "bottom", opacity: 0.8 }).openTooltip(), this._map.getContainer().classList.add("geoman-draw-cursor"), this._map.on("click", this._createVertex, this), this.options.finishOn && this.options.finishOn !== "snap" && this._map.on(this.options.finishOn, this._finishShape, this), this.options.finishOn === "dblclick" && (this.tempMapDoubleClickZoomState = this._map.doubleClickZoom._enabled, this.tempMapDoubleClickZoomState && this._map.doubleClickZoom.disable()), this._map.on("mousemove", this._syncHintMarker, this), this._hintMarker.on("move", this._syncHintLine, this), this._map.pm.Toolbar.toggleButton(this.toolbarButtonName, !0), this._otherSnapLayers = [], this.isRed = !1, this._fireDrawStart(), this._setGlobalDrawMode();
    }, disable: function() {
      this._enabled && (this._enabled = !1, this._map.getContainer().classList.remove("geoman-draw-cursor"), this._map.off("click", this._createVertex, this), this._map.off("mousemove", this._syncHintMarker, this), this.options.finishOn && this.options.finishOn !== "snap" && this._map.off(this.options.finishOn, this._finishShape, this), this.tempMapDoubleClickZoomState && this._map.doubleClickZoom.enable(), this._map.removeLayer(this._layerGroup), this._map.pm.Toolbar.toggleButton(this.toolbarButtonName, !1), this.options.snappable && this._cleanupSnapping(), this._fireDrawEnd(), this._setGlobalDrawMode());
    }, enabled: function() {
      return this._enabled;
    }, toggle: function(o) {
      this.enabled() ? this.disable() : this.enable(o);
    }, _syncHintLine: function() {
      var o = this._layer.getLatLngs();
      if (o.length > 0) {
        var c = o[o.length - 1];
        this._hintline.setLatLngs([c, this._hintMarker.getLatLng()]);
      }
    }, _syncHintMarker: function(o) {
      if (this._hintMarker.setLatLng(o.latlng), this.options.snappable) {
        var c = o;
        c.target = this._hintMarker, this._handleSnapping(c);
      }
      this.options.allowSelfIntersection || this._handleSelfIntersection(!0, this._hintMarker.getLatLng());
      var p = this._layer._defaultShape().slice();
      p.push(this._hintMarker.getLatLng()), this._change(p);
    }, hasSelfIntersection: function() {
      return lt(this._layer.toGeoJSON(15)).features.length > 0;
    }, _handleSelfIntersection: function(o, c) {
      var p = L.polyline(this._layer.getLatLngs());
      o && (c || (c = this._hintMarker.getLatLng()), p.addLatLng(c));
      var _ = lt(p.toGeoJSON(15));
      this._doesSelfIntersect = _.features.length > 0, this._doesSelfIntersect ? this.isRed || (this.isRed = !0, this._hintline.setStyle({ color: "#f00000ff" }), this._fireIntersect(_, this._map, "Draw")) : this._hintline.isEmpty() || (this.isRed = !1, this._hintline.setStyle(this.options.hintlineStyle));
    }, _createVertex: function(o) {
      if (this.options.allowSelfIntersection || (this._handleSelfIntersection(!0, o.latlng), !this._doesSelfIntersect)) {
        this._hintMarker._snapped || this._hintMarker.setLatLng(o.latlng);
        var c = this._hintMarker.getLatLng(), p = this._layer.getLatLngs(), _ = p[p.length - 1];
        if (c.equals(p[0]) || p.length > 0 && c.equals(_))
          this._finishShape();
        else {
          this._layer._latlngInfo = this._layer._latlngInfo || [], this._layer._latlngInfo.push({ latlng: c, snapInfo: this._hintMarker._snapInfo }), this._layer.addLatLng(c);
          var w = this._createMarker(c);
          this._setTooltipText(), this._setHintLineAfterNewVertex(c), this._fireVertexAdded(w, void 0, c, "Draw"), this._change(this._layer.getLatLngs()), this.options.finishOn === "snap" && this._hintMarker._snapped && this._finishShape(o);
        }
      }
    }, _setHintLineAfterNewVertex: function(o) {
      this._hintline.setLatLngs([o, o]);
    }, _removeLastVertex: function() {
      var o = this._markers;
      if (o.length <= 1)
        this.disable();
      else {
        var c = this._layer.getLatLngs(), p = o[o.length - 1], _ = L.PM.Utils.findDeepMarkerIndex(o, p).indexPath;
        o.pop(), this._layerGroup.removeLayer(p);
        var w = o[o.length - 1], B = c.indexOf(w.getLatLng());
        c = c.slice(0, B + 1), this._layer.setLatLngs(c), this._layer._latlngInfo.pop(), this._syncHintLine(), this._setTooltipText(), this._fireVertexRemoved(p, _, "Draw"), this._change(this._layer.getLatLngs());
      }
    }, _finishShape: function() {
      if ((this.options.allowSelfIntersection || (this._handleSelfIntersection(!1), !this._doesSelfIntersect)) && (!this.options.requireSnapToFinish || this._hintMarker._snapped || this._isFirstLayer())) {
        var o = this._layer.getLatLngs();
        if (!(o.length <= 1)) {
          var c = L.polyline(o, this.options.pathOptions);
          this._setPane(c, "layerPane"), this._finishLayer(c), c.addTo(this._map.pm._getContainingLayer()), this._fireCreate(c), this.options.snappable && this._cleanupSnapping(), this.disable(), this.options.continueDrawing && this.enable();
        }
      }
    }, _createMarker: function(o) {
      var c = new L.Marker(o, { draggable: !1, icon: L.divIcon({ className: "marker-icon" }) });
      return this._setPane(c, "vertexPane"), c._pmTempLayer = !0, this._layerGroup.addLayer(c), this._markers.push(c), c.on("click", this._finishShape, this), c;
    }, _setTooltipText: function() {
      var o = "";
      o = pe(this._layer.getLatLngs().flat().length <= 1 ? "tooltips.continueLine" : "tooltips.finishLine"), this._hintMarker.setTooltipContent(o);
    }, _change: function(o) {
      this._fireChange(o, "Draw");
    }, setStyle: function() {
      var o, c;
      (o = this._layer) === null || o === void 0 || o.setStyle(this.options.templineStyle), (c = this._hintline) === null || c === void 0 || c.setStyle(this.options.hintlineStyle);
    } }), E.Polygon = E.Line.extend({ initialize: function(o) {
      this._map = o, this._shape = "Polygon", this.toolbarButtonName = "drawPolygon";
    }, enable: function(o) {
      L.PM.Draw.Line.prototype.enable.call(this, o), this._layer.pm._shape = "Polygon";
    }, _createMarker: function(o) {
      var c = new L.Marker(o, { draggable: !1, icon: L.divIcon({ className: "marker-icon" }) });
      return this._setPane(c, "vertexPane"), c._pmTempLayer = !0, this._layerGroup.addLayer(c), this._markers.push(c), this._layer.getLatLngs().flat().length === 1 ? (c.on("click", this._finishShape, this), this._tempSnapLayerIndex = this._otherSnapLayers.push(c) - 1, this.options.snappable && this._cleanupSnapping()) : c.on("click", function() {
        return 1;
      }), c;
    }, _setTooltipText: function() {
      var o = "";
      o = pe(this._layer.getLatLngs().flat().length <= 2 ? "tooltips.continueLine" : "tooltips.finishPoly"), this._hintMarker.setTooltipContent(o);
    }, _finishShape: function() {
      if ((this.options.allowSelfIntersection || (this._handleSelfIntersection(!0, this._layer.getLatLngs()[0]), !this._doesSelfIntersect)) && (!this.options.requireSnapToFinish || this._hintMarker._snapped || this._isFirstLayer())) {
        var o = this._layer.getLatLngs();
        if (!(o.length <= 2)) {
          var c = L.polygon(o, this.options.pathOptions);
          this._setPane(c, "layerPane"), this._finishLayer(c), c.addTo(this._map.pm._getContainingLayer()), this._fireCreate(c), this._cleanupSnapping(), this._otherSnapLayers.splice(this._tempSnapLayerIndex, 1), delete this._tempSnapLayerIndex, this.disable(), this.options.continueDrawing && this.enable();
        }
      }
    } }), E.Rectangle = E.extend({ initialize: function(o) {
      this._map = o, this._shape = "Rectangle", this.toolbarButtonName = "drawRectangle";
    }, enable: function(o) {
      if (L.Util.setOptions(this, o), this._enabled = !0, this._layerGroup = new L.FeatureGroup(), this._layerGroup._pmTempLayer = !0, this._layerGroup.addTo(this._map), this._layer = L.rectangle([[0, 0], [0, 0]], this.options.pathOptions), this._setPane(this._layer, "layerPane"), this._layer._pmTempLayer = !0, this._startMarker = L.marker(this._map.getCenter(), { icon: L.divIcon({ className: "marker-icon rect-start-marker" }), draggable: !1, zIndexOffset: -100, opacity: this.options.cursorMarker ? 1 : 0 }), this._setPane(this._startMarker, "vertexPane"), this._startMarker._pmTempLayer = !0, this._layerGroup.addLayer(this._startMarker), this._hintMarker = L.marker(this._map.getCenter(), { zIndexOffset: 150, icon: L.divIcon({ className: "marker-icon cursor-marker" }) }), this._setPane(this._hintMarker, "vertexPane"), this._hintMarker._pmTempLayer = !0, this._layerGroup.addLayer(this._hintMarker), this.options.cursorMarker && L.DomUtil.addClass(this._hintMarker._icon, "visible"), this.options.tooltips && this._hintMarker.bindTooltip(pe("tooltips.firstVertex"), { permanent: !0, offset: L.point(0, 10), direction: "bottom", opacity: 0.8 }).openTooltip(), this.options.cursorMarker) {
        this._styleMarkers = [];
        for (var c = 0; c < 2; c += 1) {
          var p = L.marker(this._map.getCenter(), { icon: L.divIcon({ className: "marker-icon rect-style-marker" }), draggable: !1, zIndexOffset: 100 });
          this._setPane(p, "vertexPane"), p._pmTempLayer = !0, this._layerGroup.addLayer(p), this._styleMarkers.push(p);
        }
      }
      this._map.getContainer().classList.add("geoman-draw-cursor"), this._map.on("click", this._placeStartingMarkers, this), this._map.on("mousemove", this._syncHintMarker, this), this._map.pm.Toolbar.toggleButton(this.toolbarButtonName, !0), this._otherSnapLayers = [], this._fireDrawStart(), this._setGlobalDrawMode();
    }, disable: function() {
      this._enabled && (this._enabled = !1, this._map.getContainer().classList.remove("geoman-draw-cursor"), this._map.off("click", this._finishShape, this), this._map.off("click", this._placeStartingMarkers, this), this._map.off("mousemove", this._syncHintMarker, this), this._map.removeLayer(this._layerGroup), this._map.pm.Toolbar.toggleButton(this.toolbarButtonName, !1), this.options.snappable && this._cleanupSnapping(), this._fireDrawEnd(), this._setGlobalDrawMode());
    }, enabled: function() {
      return this._enabled;
    }, toggle: function(o) {
      this.enabled() ? this.disable() : this.enable(o);
    }, _placeStartingMarkers: function(o) {
      this._hintMarker._snapped || this._hintMarker.setLatLng(o.latlng);
      var c = this._hintMarker.getLatLng();
      L.DomUtil.addClass(this._startMarker._icon, "visible"), this._startMarker.setLatLng(c), this.options.cursorMarker && this._styleMarkers && this._styleMarkers.forEach(function(p) {
        L.DomUtil.addClass(p._icon, "visible"), p.setLatLng(c);
      }), this._map.off("click", this._placeStartingMarkers, this), this._map.on("click", this._finishShape, this), this._hintMarker.setTooltipContent(pe("tooltips.finishRect")), this._setRectangleOrigin();
    }, _setRectangleOrigin: function() {
      var o = this._startMarker.getLatLng();
      o && (this._layerGroup.addLayer(this._layer), this._layer.setLatLngs([o, o]), this._hintMarker.on("move", this._syncRectangleSize, this));
    }, _syncHintMarker: function(o) {
      if (this._hintMarker.setLatLng(o.latlng), this.options.snappable) {
        var c = o;
        c.target = this._hintMarker, this._handleSnapping(c);
      }
      var p = this._layerGroup && this._layerGroup.hasLayer(this._layer) ? this._layer.getLatLngs() : [this._hintMarker.getLatLng()];
      this._fireChange(p, "Draw");
    }, _syncRectangleSize: function() {
      var o = this, c = ft(this._startMarker.getLatLng(), this._map), p = ft(this._hintMarker.getLatLng(), this._map), _ = L.PM.Utils._getRotatedRectangle(c, p, this.options.rectangleAngle || 0, this._map);
      if (this._layer.setLatLngs(_), this.options.cursorMarker && this._styleMarkers) {
        var w = [];
        _.forEach(function(B) {
          B.equals(c, 1e-8) || B.equals(p, 1e-8) || w.push(B);
        }), w.forEach(function(B, F) {
          try {
            o._styleMarkers[F].setLatLng(B);
          } catch {
          }
        });
      }
    }, _findCorners: function() {
      var o = this._layer.getLatLngs()[0];
      return L.PM.Utils._getRotatedRectangle(o[0], o[2], this.options.rectangleAngle || 0, this._map);
    }, _finishShape: function(o) {
      this._hintMarker._snapped || this._hintMarker.setLatLng(o.latlng);
      var c = this._hintMarker.getLatLng(), p = this._startMarker.getLatLng();
      if (!this.options.requireSnapToFinish || this._hintMarker._snapped || this._isFirstLayer()) {
        var _ = L.rectangle([p, c], this.options.pathOptions);
        if (this.options.rectangleAngle) {
          var w = L.PM.Utils._getRotatedRectangle(p, c, this.options.rectangleAngle || 0, this._map);
          _.setLatLngs(w), _.pm && _.pm._setAngle(this.options.rectangleAngle || 0);
        }
        this._setPane(_, "layerPane"), this._finishLayer(_), _.addTo(this._map.pm._getContainingLayer()), this._fireCreate(_), this.disable(), this.options.continueDrawing && this.enable();
      }
    }, setStyle: function() {
      var o;
      (o = this._layer) === null || o === void 0 || o.setStyle(this.options.pathOptions);
    } }), E.CircleMarker = E.extend({ initialize: function(o) {
      this._map = o, this._shape = "CircleMarker", this.toolbarButtonName = "drawCircleMarker", this._layerIsDragging = !1, this._BaseCircleClass = L.CircleMarker, this._minRadiusOption = "minRadiusCircleMarker", this._maxRadiusOption = "maxRadiusCircleMarker", this._editableOption = "resizeableCircleMarker", this._defaultRadius = 10;
    }, enable: function(o) {
      if (L.Util.setOptions(this, o), this.options.editable && (this.options.resizeableCircleMarker = this.options.editable, delete this.options.editable), this._enabled = !0, this._map.pm.Toolbar.toggleButton(this.toolbarButtonName, !0), this._map.getContainer().classList.add("geoman-draw-cursor"), this.options[this._editableOption]) {
        var c = {};
        L.extend(c, this.options.templineStyle), c.radius = 0, this._layerGroup = new L.FeatureGroup(), this._layerGroup._pmTempLayer = !0, this._layerGroup.addTo(this._map), this._layer = new this._BaseCircleClass(this._map.getCenter(), c), this._setPane(this._layer, "layerPane"), this._layer._pmTempLayer = !0, this._centerMarker = L.marker(this._map.getCenter(), { icon: L.divIcon({ className: "marker-icon" }), draggable: !1, zIndexOffset: 100 }), this._setPane(this._centerMarker, "vertexPane"), this._centerMarker._pmTempLayer = !0, this._hintMarker = L.marker(this._map.getCenter(), { zIndexOffset: 110, icon: L.divIcon({ className: "marker-icon cursor-marker" }) }), this._setPane(this._hintMarker, "vertexPane"), this._hintMarker._pmTempLayer = !0, this._layerGroup.addLayer(this._hintMarker), this.options.cursorMarker && L.DomUtil.addClass(this._hintMarker._icon, "visible"), this.options.tooltips && this._hintMarker.bindTooltip(pe("tooltips.startCircle"), { permanent: !0, offset: L.point(0, 10), direction: "bottom", opacity: 0.8 }).openTooltip(), this._hintline = L.polyline([], this.options.hintlineStyle), this._setPane(this._hintline, "layerPane"), this._hintline._pmTempLayer = !0, this._layerGroup.addLayer(this._hintline), this._map.on("click", this._placeCenterMarker, this);
      } else
        this._map.on("click", this._createMarker, this), this._hintMarker = new this._BaseCircleClass(this._map.getCenter(), ge({ radius: this._defaultRadius }, this.options.templineStyle)), this._setPane(this._hintMarker, "layerPane"), this._hintMarker._pmTempLayer = !0, this._hintMarker.addTo(this._map), this._layer = this._hintMarker, this.options.tooltips && this._hintMarker.bindTooltip(pe("tooltips.placeCircleMarker"), { permanent: !0, offset: L.point(0, 10), direction: "bottom", opacity: 0.8 }).openTooltip();
      this._map.on("mousemove", this._syncHintMarker, this), this._extendingEnable(), this._otherSnapLayers = [], this._fireDrawStart(), this._setGlobalDrawMode();
    }, _extendingEnable: function() {
      var o = this;
      !this.options[this._editableOption] && this.options.markerEditable && this._map.eachLayer(function(c) {
        o.isRelevantMarker(c) && c.pm.enable();
      }), this._layer.bringToBack();
    }, disable: function() {
      this._enabled && (this._enabled = !1, this._map.getContainer().classList.remove("geoman-draw-cursor"), this.options[this._editableOption] ? (this._map.off("click", this._finishShape, this), this._map.off("click", this._placeCenterMarker, this), this._map.removeLayer(this._layerGroup)) : (this._map.off("click", this._createMarker, this), this._extendingDisable(), this._hintMarker.remove()), this._map.off("mousemove", this._syncHintMarker, this), this._map.pm.Toolbar.toggleButton(this.toolbarButtonName, !1), this.options.snappable && this._cleanupSnapping(), this._fireDrawEnd(), this._setGlobalDrawMode());
    }, _extendingDisable: function() {
      var o = this;
      this._map.eachLayer(function(c) {
        o.isRelevantMarker(c) && c.pm.disable();
      });
    }, enabled: function() {
      return this._enabled;
    }, toggle: function(o) {
      this.enabled() ? this.disable() : this.enable(o);
    }, _placeCenterMarker: function(o) {
      this._layerGroup.addLayer(this._layer), this._layerGroup.addLayer(this._centerMarker), this._hintMarker._snapped || this._hintMarker.setLatLng(o.latlng);
      var c = this._hintMarker.getLatLng();
      this._layerGroup.addLayer(this._layer), this._centerMarker.setLatLng(c), this._map.off("click", this._placeCenterMarker, this), this._map.on("click", this._finishShape, this), this._placeCircleCenter();
    }, _placeCircleCenter: function() {
      var o = this._centerMarker.getLatLng();
      o && (this._layer.setLatLng(o), this._hintMarker.on("move", this._syncHintLine, this), this._hintMarker.on("move", this._syncCircleRadius, this), this._hintMarker.setTooltipContent(pe("tooltips.finishCircle")), this._fireCenterPlaced(), this._fireChange(this._layer.getLatLng(), "Draw"));
    }, _syncHintLine: function() {
      var o = this._centerMarker.getLatLng(), c = this._getNewDestinationOfHintMarker();
      this._hintline.setLatLngs([o, c]);
    }, _syncCircleRadius: function() {
      var o = this._centerMarker.getLatLng(), c = this._hintMarker.getLatLng(), p = this._distanceCalculation(o, c);
      this.options[this._minRadiusOption] && p < this.options[this._minRadiusOption] ? this._layer.setRadius(this.options[this._minRadiusOption]) : this.options[this._maxRadiusOption] && p > this.options[this._maxRadiusOption] ? this._layer.setRadius(this.options[this._maxRadiusOption]) : this._layer.setRadius(p);
    }, _syncHintMarker: function(o) {
      if (this._hintMarker.setLatLng(o.latlng), this._hintMarker.setLatLng(this._getNewDestinationOfHintMarker()), this.options.snappable) {
        var c = o;
        c.target = this._hintMarker, this._handleSnapping(c);
      }
      this._handleHintMarkerSnapping();
      var p = this._layerGroup && this._layerGroup.hasLayer(this._centerMarker) ? this._centerMarker.getLatLng() : this._hintMarker.getLatLng();
      this._fireChange(p, "Draw");
    }, isRelevantMarker: function(o) {
      return o instanceof L.CircleMarker && !(o instanceof L.Circle) && o.pm && !o._pmTempLayer;
    }, _createMarker: function(o) {
      if ((!this.options.requireSnapToFinish || this._hintMarker._snapped || this._isFirstLayer()) && o.latlng && !this._layerIsDragging) {
        this._hintMarker._snapped || this._hintMarker.setLatLng(o.latlng);
        var c = this._hintMarker.getLatLng(), p = new this._BaseCircleClass(c, ge({ radius: this._defaultRadius }, this.options.pathOptions));
        this._setPane(p, "layerPane"), this._finishLayer(p), p.addTo(this._map.pm._getContainingLayer()), this._extendingCreateMarker(p), this._fireCreate(p), this._cleanupSnapping(), this.options.continueDrawing || this.disable();
      }
    }, _extendingCreateMarker: function(o) {
      o.pm && this.options.markerEditable && o.pm.enable();
    }, _finishShape: function(o) {
      if (!this.options.requireSnapToFinish || this._hintMarker._snapped || this._isFirstLayer()) {
        this._hintMarker._snapped || this._hintMarker.setLatLng(o.latlng);
        var c = this._centerMarker.getLatLng(), p = this._defaultRadius;
        if (this.options[this._editableOption]) {
          var _ = this._hintMarker.getLatLng();
          p = this._distanceCalculation(c, _), this.options[this._minRadiusOption] && p < this.options[this._minRadiusOption] ? p = this.options[this._minRadiusOption] : this.options[this._maxRadiusOption] && p > this.options[this._maxRadiusOption] && (p = this.options[this._maxRadiusOption]);
        }
        var w = ge(ge({}, this.options.pathOptions), {}, { radius: p }), B = new this._BaseCircleClass(c, w);
        this._setPane(B, "layerPane"), this._finishLayer(B), B.addTo(this._map.pm._getContainingLayer()), B.pm && B.pm._updateHiddenPolyCircle(), this._fireCreate(B), this.disable(), this.options.continueDrawing && this.enable();
      }
    }, _getNewDestinationOfHintMarker: function() {
      var o = this._hintMarker.getLatLng();
      if (this.options[this._editableOption]) {
        if (!this._layerGroup.hasLayer(this._centerMarker))
          return o;
        var c = this._centerMarker.getLatLng(), p = this._distanceCalculation(c, o);
        this.options[this._minRadiusOption] && p < this.options[this._minRadiusOption] ? o = Ve(this._map, c, o, this._getMinDistanceInMeter()) : this.options[this._maxRadiusOption] && p > this.options[this._maxRadiusOption] && (o = Ve(this._map, c, o, this._getMaxDistanceInMeter()));
      }
      return o;
    }, _getMinDistanceInMeter: function() {
      return L.PM.Utils.pxRadiusToMeterRadius(this.options[this._minRadiusOption], this._map, this._centerMarker.getLatLng());
    }, _getMaxDistanceInMeter: function() {
      return L.PM.Utils.pxRadiusToMeterRadius(this.options[this._maxRadiusOption], this._map, this._centerMarker.getLatLng());
    }, _handleHintMarkerSnapping: function() {
      if (this.options[this._editableOption]) {
        if (this._hintMarker._snapped) {
          var o = this._centerMarker.getLatLng(), c = this._hintMarker.getLatLng(), p = this._distanceCalculation(o, c);
          this._layerGroup.hasLayer(this._centerMarker) && (this.options[this._minRadiusOption] && p < this.options[this._minRadiusOption] || this.options[this._maxRadiusOption] && p > this.options[this._maxRadiusOption]) && this._hintMarker.setLatLng(this._hintMarker._orgLatLng);
        }
        this._hintMarker.setLatLng(this._getNewDestinationOfHintMarker());
      }
    }, setStyle: function() {
      var o, c, p = {};
      L.extend(p, this.options.templineStyle), this.options[this._editableOption] && (p.radius = 0), (o = this._layer) === null || o === void 0 || o.setStyle(p), (c = this._hintline) === null || c === void 0 || c.setStyle(this.options.hintlineStyle);
    }, _distanceCalculation: function(o, c) {
      return this._map.project(o).distanceTo(this._map.project(c));
    } }), E.Circle = E.CircleMarker.extend({ initialize: function(o) {
      this._map = o, this._shape = "Circle", this.toolbarButtonName = "drawCircle", this._BaseCircleClass = L.Circle, this._minRadiusOption = "minRadiusCircle", this._maxRadiusOption = "maxRadiusCircle", this._editableOption = "resizableCircle", this._defaultRadius = 100;
    }, _extendingEnable: function() {
    }, _extendingDisable: function() {
    }, _extendingCreateMarker: function() {
    }, isRelevantMarker: function() {
    }, _getMinDistanceInMeter: function() {
      return this.options[this._minRadiusOption];
    }, _getMaxDistanceInMeter: function() {
      return this.options[this._maxRadiusOption];
    }, _distanceCalculation: function(o, c) {
      return this._map.distance(o, c);
    } });
    const mt = function(o) {
      if (!o)
        throw new Error("geojson is required");
      var c = [];
      return Re(o, function(p) {
        (function(_, w) {
          var B = [], F = _.geometry;
          if (F !== null) {
            switch (F.type) {
              case "Polygon":
                B = U(F);
                break;
              case "LineString":
                B = [U(F)];
            }
            B.forEach(function(Z) {
              var V = function(K, oe) {
                var _e = [];
                return K.reduce(function(fe, Me) {
                  var Ie, qe, ot, Tt, Ct, Yt, pn = ye([fe, Me], oe);
                  return pn.bbox = (qe = Me, ot = (Ie = fe)[0], Tt = Ie[1], Ct = qe[0], Yt = qe[1], [ot < Ct ? ot : Ct, Tt < Yt ? Tt : Yt, ot > Ct ? ot : Ct, Tt > Yt ? Tt : Yt]), _e.push(pn), Me;
                }), _e;
              }(Z, _.properties);
              V.forEach(function(K) {
                K.id = w.length, w.push(K);
              });
            });
          }
        })(p, c);
      }), Oe(c);
    };
    var ht = n(1787);
    function wt(o, c) {
      var p = U(o), _ = U(c);
      if (p.length !== 2)
        throw new Error("<intersects> line1 must only contain 2 coordinates");
      if (_.length !== 2)
        throw new Error("<intersects> line2 must only contain 2 coordinates");
      var w = p[0][0], B = p[0][1], F = p[1][0], Z = p[1][1], V = _[0][0], K = _[0][1], oe = _[1][0], _e = _[1][1], fe = (_e - K) * (F - w) - (oe - V) * (Z - B), Me = (oe - V) * (B - K) - (_e - K) * (w - V), Ie = (F - w) * (B - K) - (Z - B) * (w - V);
      if (fe === 0)
        return null;
      var qe = Me / fe, ot = Ie / fe;
      return qe >= 0 && qe <= 1 && ot >= 0 && ot <= 1 ? me([w + qe * (F - w), B + qe * (Z - B)]) : null;
    }
    const ct = function(o, c) {
      var p = {}, _ = [];
      if (o.type === "LineString" && (o = J(o)), c.type === "LineString" && (c = J(c)), o.type === "Feature" && c.type === "Feature" && o.geometry !== null && c.geometry !== null && o.geometry.type === "LineString" && c.geometry.type === "LineString" && o.geometry.coordinates.length === 2 && c.geometry.coordinates.length === 2) {
        var w = wt(o, c);
        return w && _.push(w), Oe(_);
      }
      var B = ht();
      return B.load(mt(c)), Ce(mt(o), function(F) {
        Ce(B.search(F), function(Z) {
          var V = wt(F, Z);
          if (V) {
            var K = U(V).join(",");
            p[K] || (p[K] = !0, _.push(V));
          }
        });
      }), Oe(_);
    }, ut = function(o, c, p) {
      p === void 0 && (p = {});
      var _ = N(o), w = N(c), B = We(w[1] - _[1]), F = We(w[0] - _[0]), Z = We(_[1]), V = We(w[1]), K = Math.pow(Math.sin(B / 2), 2) + Math.pow(Math.sin(F / 2), 2) * Math.cos(Z) * Math.cos(V);
      return Ue(2 * Math.atan2(Math.sqrt(K), Math.sqrt(1 - K)), p.units);
    }, Lt = function(o) {
      var c = o[0], p = o[1], _ = o[2], w = o[3];
      if (ut(o.slice(0, 2), [_, p]) >= ut(o.slice(0, 2), [c, w])) {
        var B = (p + w) / 2;
        return [c, B - (_ - c) / 2, _, B + (_ - c) / 2];
      }
      var F = (c + _) / 2;
      return [F - (w - p) / 2, p, F + (w - p) / 2, w];
    };
    function Be(o) {
      var c = [1 / 0, 1 / 0, -1 / 0, -1 / 0];
      return Ee(o, function(p) {
        c[0] > p[0] && (c[0] = p[0]), c[1] > p[1] && (c[1] = p[1]), c[2] < p[0] && (c[2] = p[0]), c[3] < p[1] && (c[3] = p[1]);
      }), c;
    }
    Be.default = Be;
    const Nt = Be, Kt = function(o, c) {
      c === void 0 && (c = {});
      var p = c.precision, _ = c.coordinates, w = c.mutate;
      if (p = p == null || isNaN(p) ? 6 : p, _ = _ == null || isNaN(_) ? 3 : _, !o)
        throw new Error("<geojson> is required");
      if (typeof p != "number")
        throw new Error("<precision> must be a number");
      if (typeof _ != "number")
        throw new Error("<coordinates> must be a number");
      w !== !1 && w !== void 0 || (o = JSON.parse(JSON.stringify(o)));
      var B = Math.pow(10, p);
      return Ee(o, function(F) {
        (function(Z, V, K) {
          Z.length > K && Z.splice(K, Z.length);
          for (var oe = 0; oe < Z.length; oe++)
            Z[oe] = Math.round(Z[oe] * V) / V;
        })(F, B, _);
      }), o;
    };
    function vi(o, c, p) {
      if (p === void 0 && (p = {}), p.final === !0)
        return function(_e, fe) {
          var Me = vi(fe, _e);
          return Me = (Me + 180) % 360;
        }(o, c);
      var _ = N(o), w = N(c), B = We(_[0]), F = We(w[0]), Z = We(_[1]), V = We(w[1]), K = Math.sin(F - B) * Math.cos(V), oe = Math.cos(Z) * Math.sin(V) - Math.sin(Z) * Math.cos(V) * Math.cos(F - B);
      return Xe(Math.atan2(K, oe));
    }
    function _i(o, c, p, _) {
      _ === void 0 && (_ = {});
      var w = N(o), B = We(w[0]), F = We(w[1]), Z = We(p), V = at(c, _.units), K = Math.asin(Math.sin(F) * Math.cos(V) + Math.cos(F) * Math.sin(V) * Math.cos(Z));
      return me([Xe(B + Math.atan2(Math.sin(Z) * Math.sin(V) * Math.cos(F), Math.cos(V) - Math.sin(F) * Math.sin(K))), Xe(K)], _.properties);
    }
    const yi = function(o, c, p) {
      p === void 0 && (p = {});
      var _ = me([1 / 0, 1 / 0], { dist: 1 / 0 }), w = 0;
      return Re(o, function(B) {
        for (var F = U(B), Z = 0; Z < F.length - 1; Z++) {
          var V = me(F[Z]);
          V.properties.dist = ut(c, V, p);
          var K = me(F[Z + 1]);
          K.properties.dist = ut(c, K, p);
          var oe = ut(V, K, p), _e = Math.max(V.properties.dist, K.properties.dist), fe = vi(V, K), Me = _i(c, _e, fe + 90, p), Ie = _i(c, _e, fe - 90, p), qe = ct(ye([Me.geometry.coordinates, Ie.geometry.coordinates]), ye([V.geometry.coordinates, K.geometry.coordinates])), ot = null;
          qe.features.length > 0 && ((ot = qe.features[0]).properties.dist = ut(c, ot, p), ot.properties.location = w + ut(V, ot, p)), V.properties.dist < _.properties.dist && ((_ = V).properties.index = Z, _.properties.location = w), K.properties.dist < _.properties.dist && ((_ = K).properties.index = Z + 1, _.properties.location = w + oe), ot && ot.properties.dist < _.properties.dist && ((_ = ot).properties.index = Z), w += oe;
        }
      }), _;
    };
    function Vi(o, c) {
      var p = [], _ = ht();
      return Re(c, function(w) {
        if (p.forEach(function(Z, V) {
          Z.id = V;
        }), p.length) {
          var B = _.search(w);
          if (B.features.length) {
            var F = Yi(w, B);
            p = p.filter(function(Z) {
              return Z.id !== F.id;
            }), _.remove(F), Ce(Pn(F, w), function(Z) {
              p.push(Z), _.insert(Z);
            });
          }
        } else
          (p = Pn(o, w).features).forEach(function(Z) {
            Z.bbox || (Z.bbox = Lt(Nt(Z)));
          }), _.load(Oe(p));
      }), Oe(p);
    }
    function Pn(o, c) {
      var p = [], _ = U(o)[0], w = U(o)[o.geometry.coordinates.length - 1];
      if (Hi(_, N(c)) || Hi(w, N(c)))
        return Oe([o]);
      var B = ht(), F = mt(o);
      B.load(F);
      var Z = B.search(c);
      if (!Z.features.length)
        return Oe([o]);
      var V = Yi(c, Z), K = function(oe, _e, fe) {
        var Me = fe;
        return Ce(oe, function(Ie, qe) {
          Me = qe === 0 && fe === void 0 ? Ie : _e(Me, Ie, qe);
        }), Me;
      }(F, function(oe, _e, fe) {
        var Me = U(_e)[1], Ie = N(c);
        return fe === V.id ? (oe.push(Ie), p.push(ye(oe)), Hi(Ie, Me) ? [Ie] : [Ie, Me]) : (oe.push(Me), oe);
      }, [_]);
      return K.length > 1 && p.push(ye(K)), Oe(p);
    }
    function Yi(o, c) {
      if (!c.features.length)
        throw new Error("lines must contain features");
      if (c.features.length === 1)
        return c.features[0];
      var p, _ = 1 / 0;
      return Ce(c, function(w) {
        var B = yi(w, o).properties.dist;
        B < _ && (p = w, _ = B);
      }), p;
    }
    function Hi(o, c) {
      return o[0] === c[0] && o[1] === c[1];
    }
    const cl = function(o, c) {
      if (!o)
        throw new Error("line is required");
      if (!c)
        throw new Error("splitter is required");
      var p = ve(o), _ = ve(c);
      if (p !== "LineString")
        throw new Error("line must be LineString");
      if (_ === "FeatureCollection")
        throw new Error("splitter cannot be a FeatureCollection");
      if (_ === "GeometryCollection")
        throw new Error("splitter cannot be a GeometryCollection");
      var w = Kt(c, { precision: 7 });
      switch (_) {
        case "Point":
          return Pn(o, w);
        case "MultiPoint":
          return Vi(o, w);
        case "LineString":
        case "MultiLineString":
        case "Polygon":
        case "MultiPolygon":
          return Vi(o, ct(o, w));
      }
    };
    function Fr(o, c, p) {
      if (p === void 0 && (p = {}), !o)
        throw new Error("point is required");
      if (!c)
        throw new Error("polygon is required");
      var _ = N(o), w = ie(c), B = w.type, F = c.bbox, Z = w.coordinates;
      if (F && function(fe, Me) {
        return Me[0] <= fe[0] && Me[1] <= fe[1] && Me[2] >= fe[0] && Me[3] >= fe[1];
      }(_, F) === !1)
        return !1;
      B === "Polygon" && (Z = [Z]);
      for (var V = !1, K = 0; K < Z.length && !V; K++)
        if (Oo(_, Z[K][0], p.ignoreBoundary)) {
          for (var oe = !1, _e = 1; _e < Z[K].length && !oe; )
            Oo(_, Z[K][_e], !p.ignoreBoundary) && (oe = !0), _e++;
          oe || (V = !0);
        }
      return V;
    }
    function Oo(o, c, p) {
      var _ = !1;
      c[0][0] === c[c.length - 1][0] && c[0][1] === c[c.length - 1][1] && (c = c.slice(0, c.length - 1));
      for (var w = 0, B = c.length - 1; w < c.length; B = w++) {
        var F = c[w][0], Z = c[w][1], V = c[B][0], K = c[B][1];
        if (o[1] * (F - V) + Z * (V - o[0]) + K * (o[0] - F) == 0 && (F - o[0]) * (V - o[0]) <= 0 && (Z - o[1]) * (K - o[1]) <= 0)
          return !p;
        Z > o[1] != K > o[1] && o[0] < (V - F) * (o[1] - Z) / (K - Z) + F && (_ = !_);
      }
      return _;
    }
    function Eo(o, c, p, _, w) {
      var B = p[0], F = p[1], Z = o[0], V = o[1], K = c[0], oe = c[1], _e = K - Z, fe = oe - V, Me = (p[0] - Z) * fe - (p[1] - V) * _e;
      if (w !== null) {
        if (Math.abs(Me) > w)
          return !1;
      } else if (Me !== 0)
        return !1;
      return _ ? _ === "start" ? Math.abs(_e) >= Math.abs(fe) ? _e > 0 ? Z < B && B <= K : K <= B && B < Z : fe > 0 ? V < F && F <= oe : oe <= F && F < V : _ === "end" ? Math.abs(_e) >= Math.abs(fe) ? _e > 0 ? Z <= B && B < K : K < B && B <= Z : fe > 0 ? V <= F && F < oe : oe < F && F <= V : _ === "both" && (Math.abs(_e) >= Math.abs(fe) ? _e > 0 ? Z < B && B < K : K < B && B < Z : fe > 0 ? V < F && F < oe : oe < F && F < V) : Math.abs(_e) >= Math.abs(fe) ? _e > 0 ? Z <= B && B <= K : K <= B && B <= Z : fe > 0 ? V <= F && F <= oe : oe <= F && F <= V;
    }
    const dr = function(o, c, p) {
      p === void 0 && (p = {});
      for (var _ = N(o), w = U(c), B = 0; B < w.length - 1; B++) {
        var F = !1;
        if (p.ignoreEndVertices && (B === 0 && (F = "start"), B === w.length - 2 && (F = "end"), B === 0 && B + 1 === w.length - 1 && (F = "both")), Eo(w[B], w[B + 1], _, F, typeof p.epsilon > "u" ? null : p.epsilon))
          return !0;
      }
      return !1;
    };
    function jr(o, c) {
      var p = ie(o), _ = ie(c), w = p.type, B = _.type, F = p.coordinates, Z = _.coordinates;
      switch (w) {
        case "Point":
          if (B === "Point")
            return Ta(F, Z);
          throw new Error("feature2 " + B + " geometry not supported");
        case "MultiPoint":
          switch (B) {
            case "Point":
              return function(V, K) {
                var oe, _e = !1;
                for (oe = 0; oe < V.coordinates.length; oe++)
                  if (Ta(V.coordinates[oe], K.coordinates)) {
                    _e = !0;
                    break;
                  }
                return _e;
              }(p, _);
            case "MultiPoint":
              return function(V, K) {
                for (var oe = 0, _e = K.coordinates; oe < _e.length; oe++) {
                  for (var fe = _e[oe], Me = !1, Ie = 0, qe = V.coordinates; Ie < qe.length; Ie++)
                    if (Ta(fe, qe[Ie])) {
                      Me = !0;
                      break;
                    }
                  if (!Me)
                    return !1;
                }
                return !0;
              }(p, _);
            default:
              throw new Error("feature2 " + B + " geometry not supported");
          }
        case "LineString":
          switch (B) {
            case "Point":
              return dr(_, p, { ignoreEndVertices: !0 });
            case "LineString":
              return function(V, K) {
                for (var oe = !1, _e = 0, fe = K.coordinates; _e < fe.length; _e++) {
                  var Me = fe[_e];
                  if (dr({ type: "Point", coordinates: Me }, V, { ignoreEndVertices: !0 }) && (oe = !0), !dr({ type: "Point", coordinates: Me }, V, { ignoreEndVertices: !1 }))
                    return !1;
                }
                return oe;
              }(p, _);
            case "MultiPoint":
              return function(V, K) {
                for (var oe = !1, _e = 0, fe = K.coordinates; _e < fe.length; _e++) {
                  var Me = fe[_e];
                  if (dr(Me, V, { ignoreEndVertices: !0 }) && (oe = !0), !dr(Me, V))
                    return !1;
                }
                return !!oe;
              }(p, _);
            default:
              throw new Error("feature2 " + B + " geometry not supported");
          }
        case "Polygon":
          switch (B) {
            case "Point":
              return Fr(_, p, { ignoreBoundary: !0 });
            case "LineString":
              return function(V, K) {
                var oe = !1, _e = 0, fe = Nt(V), Me = Nt(K);
                if (!To(fe, Me))
                  return !1;
                for (; _e < K.coordinates.length - 1; _e++)
                  if (Fr({ type: "Point", coordinates: hl(K.coordinates[_e], K.coordinates[_e + 1]) }, V, { ignoreBoundary: !0 })) {
                    oe = !0;
                    break;
                  }
                return oe;
              }(p, _);
            case "Polygon":
              return function(V, K) {
                if (V.type === "Feature" && V.geometry === null || K.type === "Feature" && K.geometry === null)
                  return !1;
                var oe = Nt(V), _e = Nt(K);
                if (!To(oe, _e))
                  return !1;
                for (var fe = ie(K).coordinates, Me = 0, Ie = fe; Me < Ie.length; Me++)
                  for (var qe = 0, ot = Ie[Me]; qe < ot.length; qe++)
                    if (!Fr(ot[qe], V))
                      return !1;
                return !0;
              }(p, _);
            case "MultiPoint":
              return function(V, K) {
                for (var oe = 0, _e = K.coordinates; oe < _e.length; oe++)
                  if (!Fr(_e[oe], V, { ignoreBoundary: !0 }))
                    return !1;
                return !0;
              }(p, _);
            default:
              throw new Error("feature2 " + B + " geometry not supported");
          }
        default:
          throw new Error("feature1 " + w + " geometry not supported");
      }
    }
    function To(o, c) {
      return !(o[0] > c[0]) && !(o[2] < c[2]) && !(o[1] > c[1]) && !(o[3] < c[3]);
    }
    function Ta(o, c) {
      return o[0] === c[0] && o[1] === c[1];
    }
    function hl(o, c) {
      return [(o[0] + c[0]) / 2, (o[1] + c[1]) / 2];
    }
    var dl = n(2676), Do = n.n(dl);
    function Ui(o) {
      var c = { type: "Feature" };
      return c.geometry = o, c;
    }
    function ui(o) {
      return o.type === "Feature" ? o.geometry : o;
    }
    function Da(o) {
      return o && o.geometry && o.geometry.coordinates ? o.geometry.coordinates : o;
    }
    function Ia(o) {
      return Ui({ type: "Polygon", coordinates: o });
    }
    function Zi(o) {
      return Ui({ type: "MultiPolygon", coordinates: o });
    }
    function yt(o) {
      return Array.isArray(o) ? 1 + yt(o[0]) : -1;
    }
    function jt(o) {
      o instanceof L.Polyline && (o = o.toGeoJSON(15));
      var c = Da(o), p = yt(c), _ = [];
      return p > 1 ? c.forEach(function(w) {
        _.push(function(B) {
          return Ui({ type: "LineString", coordinates: B });
        }(w));
      }) : _.push(o), _;
    }
    function Vr(o) {
      var c = [];
      return o.eachLayer(function(p) {
        c.push(Da(p.toGeoJSON(15)));
      }), function(p) {
        return Ui({ type: "MultiLineString", coordinates: p });
      }(c);
    }
    function Wi(o, c) {
      return function(p) {
        if (Array.isArray(p))
          return p;
      }(o) || function(p, _) {
        var w = p == null ? null : typeof Symbol < "u" && p[Symbol.iterator] || p["@@iterator"];
        if (w != null) {
          var B, F, Z = [], V = !0, K = !1;
          try {
            for (w = w.call(p); !(V = (B = w.next()).done) && (Z.push(B.value), !_ || Z.length !== _); V = !0)
              ;
          } catch (oe) {
            K = !0, F = oe;
          } finally {
            try {
              V || w.return == null || w.return();
            } finally {
              if (K)
                throw F;
            }
          }
          return Z;
        }
      }(o, c) || function(p, _) {
        if (p) {
          if (typeof p == "string")
            return bi(p, _);
          var w = Object.prototype.toString.call(p).slice(8, -1);
          if (w === "Object" && p.constructor && (w = p.constructor.name), w === "Map" || w === "Set")
            return Array.from(p);
          if (w === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(w))
            return bi(p, _);
        }
      }(o, c) || function() {
        throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
      }();
    }
    function bi(o, c) {
      (c == null || c > o.length) && (c = o.length);
      for (var p = 0, _ = new Array(c); p < c; p++)
        _[p] = o[p];
      return _;
    }
    function Aa(o) {
      return function(c) {
        if (Array.isArray(c))
          return it(c);
      }(o) || function(c) {
        if (typeof Symbol < "u" && c[Symbol.iterator] != null || c["@@iterator"] != null)
          return Array.from(c);
      }(o) || function(c, p) {
        if (c) {
          if (typeof c == "string")
            return it(c, p);
          var _ = Object.prototype.toString.call(c).slice(8, -1);
          if (_ === "Object" && c.constructor && (_ = c.constructor.name), _ === "Map" || _ === "Set")
            return Array.from(c);
          if (_ === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(_))
            return it(c, p);
        }
      }(o) || function() {
        throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
      }();
    }
    function it(o, c) {
      (c == null || c > o.length) && (c = o.length);
      for (var p = 0, _ = new Array(c); p < c; p++)
        _[p] = o[p];
      return _;
    }
    E.Cut = E.Polygon.extend({ initialize: function(o) {
      this._map = o, this._shape = "Cut", this.toolbarButtonName = "cutPolygon";
    }, _finishShape: function() {
      var o = this;
      if (this._editedLayers = [], (this.options.allowSelfIntersection || (this._handleSelfIntersection(!0, this._layer.getLatLngs()[0]), !this._doesSelfIntersect)) && (!this.options.requireSnapToFinish || this._hintMarker._snapped || this._isFirstLayer())) {
        var c = this._layer.getLatLngs();
        if (!(c.length <= 2)) {
          var p = L.polygon(c, this.options.pathOptions);
          p._latlngInfos = this._layer._latlngInfo, this.cut(p), this._cleanupSnapping(), this._otherSnapLayers.splice(this._tempSnapLayerIndex, 1), delete this._tempSnapLayerIndex, this._editedLayers.forEach(function(_) {
            var w = _.layer, B = _.originalLayer;
            o._fireCut(B, w, B), o._fireCut(o._map, w, B), B.pm._fireEdit();
          }), this._editedLayers = [], this.disable(), this.options.continueDrawing && this.enable();
        }
      }
    }, cut: function(o) {
      var c = this, p = this._map._layers, _ = o._latlngInfos || [];
      Object.keys(p).map(function(w) {
        return p[w];
      }).filter(function(w) {
        return w.pm;
      }).filter(function(w) {
        return !w._pmTempLayer;
      }).filter(function(w) {
        return !L.PM.optIn && !w.options.pmIgnore || L.PM.optIn && w.options.pmIgnore === !1;
      }).filter(function(w) {
        return w instanceof L.Polyline;
      }).filter(function(w) {
        return w !== o;
      }).filter(function(w) {
        return w.pm.options.allowCutting;
      }).filter(function(w) {
        return !(c.options.layersToCut && L.Util.isArray(c.options.layersToCut) && c.options.layersToCut.length > 0) || c.options.layersToCut.indexOf(w) > -1;
      }).filter(function(w) {
        return !c._layerGroup.hasLayer(w);
      }).filter(function(w) {
        try {
          var B = !!ct(o.toGeoJSON(15), w.toGeoJSON(15)).features.length > 0;
          return B || w instanceof L.Polyline && !(w instanceof L.Polygon) ? B : (F = o.toGeoJSON(15), Z = w.toGeoJSON(15), V = ui(F), K = ui(Z), !((oe = Do().intersection(V.coordinates, K.coordinates)).length === 0 || !(oe.length === 1 ? Ia(oe[0]) : Zi(oe))));
        } catch {
          return w instanceof L.Polygon && console.error("You can't cut polygons with self-intersections"), !1;
        }
        var F, Z, V, K, oe;
      }).forEach(function(w) {
        var B;
        if (w instanceof L.Polygon) {
          var F = (B = L.polygon(w.getLatLngs())).getLatLngs();
          _.forEach(function(fe) {
            if (fe && fe.snapInfo) {
              var Me = fe.latlng, Ie = c._calcClosestLayer(Me, [B]);
              if (Ie && Ie.segment && Ie.distance < c.options.snapDistance) {
                var qe = Ie.segment;
                if (qe && qe.length === 2) {
                  var ot = L.PM.Utils._getIndexFromSegment(F, qe), Tt = ot.indexPath, Ct = ot.parentPath, Yt = ot.newIndex;
                  (Tt.length > 1 ? Q()(F, Ct) : F).splice(Yt, 0, Me);
                }
              }
            }
          });
        } else
          B = w;
        var Z = c._cutLayer(o, B), V = L.geoJSON(Z, w.options);
        if (V.getLayers().length === 1) {
          var K = V.getLayers();
          V = Wi(K, 1)[0];
        }
        c._setPane(V, "layerPane");
        var oe = V.addTo(c._map.pm._getContainingLayer());
        if (oe.pm.enable(w.pm.options), oe.pm.disable(), w._pmTempLayer = !0, o._pmTempLayer = !0, w.remove(), w.removeFrom(c._map.pm._getContainingLayer()), o.remove(), o.removeFrom(c._map.pm._getContainingLayer()), oe.getLayers && oe.getLayers().length === 0 && c._map.pm.removeLayer({ target: oe }), oe instanceof L.LayerGroup && oe.eachLayer(function(fe) {
          c._addDrawnLayerProp(fe);
        }), c._addDrawnLayerProp(oe), c.options.layersToCut && L.Util.isArray(c.options.layersToCut) && c.options.layersToCut.length > 0) {
          var _e = c.options.layersToCut.indexOf(w);
          _e > -1 && c.options.layersToCut.splice(_e, 1);
        }
        c._editedLayers.push({ layer: oe, originalLayer: w });
      });
    }, _cutLayer: function(o, c) {
      var p, _, w, B, F, Z, V = L.geoJSON();
      if (c instanceof L.Polygon)
        _ = c.toGeoJSON(15), w = o.toGeoJSON(15), B = ui(_), F = ui(w), p = (Z = Do().difference(B.coordinates, F.coordinates)).length === 0 ? null : Z.length === 1 ? Ia(Z[0]) : Zi(Z);
      else {
        var K = jt(c);
        K.forEach(function(oe) {
          var _e = cl(oe, o.toGeoJSON(15));
          (_e && _e.features.length > 0 ? L.geoJSON(_e) : L.geoJSON(oe)).getLayers().forEach(function(fe) {
            jr(o.toGeoJSON(15), fe.toGeoJSON(15)) || fe.addTo(V);
          });
        }), p = K.length > 1 ? Vr(V) : V.toGeoJSON(15);
      }
      return p;
    }, _change: L.Util.falseFn }), E.Text = E.extend({ initialize: function(o) {
      this._map = o, this._shape = "Text", this.toolbarButtonName = "drawText";
    }, enable: function(o) {
      L.Util.setOptions(this, o), this._enabled = !0, this._map.on("click", this._createMarker, this), this._map.pm.Toolbar.toggleButton(this.toolbarButtonName, !0), this._hintMarker = L.marker(this._map.getCenter(), { interactive: !1, zIndexOffset: 100, icon: L.divIcon({ className: "marker-icon cursor-marker" }) }), this._setPane(this._hintMarker, "vertexPane"), this._hintMarker._pmTempLayer = !0, this._hintMarker.addTo(this._map), this.options.cursorMarker && L.DomUtil.addClass(this._hintMarker._icon, "visible"), this.options.tooltips && this._hintMarker.bindTooltip(pe("tooltips.placeText"), { permanent: !0, offset: L.point(0, 10), direction: "bottom", opacity: 0.8 }).openTooltip(), this._layer = this._hintMarker, this._map.on("mousemove", this._syncHintMarker, this), this._map.getContainer().classList.add("geoman-draw-cursor"), this._fireDrawStart(), this._setGlobalDrawMode();
    }, disable: function() {
      this._enabled && (this._enabled = !1, this._map.off("click", this._createMarker, this), this._hintMarker.remove(), this._map.getContainer().classList.remove("geoman-draw-cursor"), this._map.off("mousemove", this._syncHintMarker, this), this._map.pm.Toolbar.toggleButton(this.toolbarButtonName, !1), this.options.snappable && this._cleanupSnapping(), this._fireDrawEnd(), this._setGlobalDrawMode());
    }, enabled: function() {
      return this._enabled;
    }, toggle: function(o) {
      this.enabled() ? this.disable() : this.enable(o);
    }, _syncHintMarker: function(o) {
      if (this._hintMarker.setLatLng(o.latlng), this.options.snappable) {
        var c = o;
        c.target = this._hintMarker, this._handleSnapping(c);
      }
    }, _createMarker: function(o) {
      var c;
      if (o.latlng && (!this.options.requireSnapToFinish || this._hintMarker._snapped || this._isFirstLayer())) {
        this._hintMarker._snapped || this._hintMarker.setLatLng(o.latlng);
        var p = this._hintMarker.getLatLng();
        if (this.textArea = this._createTextArea(), (c = this.options.textOptions) !== null && c !== void 0 && c.className) {
          var _, w = this.options.textOptions.className.split(" ");
          (_ = this.textArea.classList).add.apply(_, Aa(w));
        }
        var B = this._createTextIcon(this.textArea), F = new L.Marker(p, { textMarker: !0, _textMarkerOverPM: !0, icon: B });
        if (this._setPane(F, "markerPane"), this._finishLayer(F), F.pm || (F.options.draggable = !1), F.addTo(this._map.pm._getContainingLayer()), F.pm) {
          var Z, V, K, oe, _e;
          F.pm.textArea = this.textArea, L.setOptions(F.pm, { removeIfEmpty: (Z = (V = this.options.textOptions) === null || V === void 0 ? void 0 : V.removeIfEmpty) === null || Z === void 0 || Z });
          var fe = (K = (oe = this.options.textOptions) === null || oe === void 0 ? void 0 : oe.focusAfterDraw) === null || K === void 0 || K;
          F.pm._createTextMarker(fe), (_e = this.options.textOptions) !== null && _e !== void 0 && _e.text && F.pm.setText(this.options.textOptions.text);
        }
        this._fireCreate(F), this._cleanupSnapping(), this.disable(), this.options.continueDrawing && this.enable();
      }
    }, _createTextArea: function() {
      var o = document.createElement("textarea");
      return o.readOnly = !0, o.classList.add("pm-textarea", "pm-disabled"), o;
    }, _createTextIcon: function(o) {
      return L.divIcon({ className: "pm-text-marker", html: o });
    } });
    const Gt = { enableLayerDrag: function() {
      if (this.options.draggable && this._layer._map) {
        this.disable(), this._layerDragEnabled = !0, this._map || (this._map = this._layer._map), (this._layer instanceof L.Marker || this._layer instanceof L.ImageOverlay) && L.DomEvent.on(this._getDOMElem(), "dragstart", this._stopDOMImageDrag), this._layer.dragging && this._layer.dragging.disable(), this._tempDragCoord = null, pt(this._layer) instanceof L.Canvas ? (this._layer.on("mouseout", this.removeDraggingClass, this), this._layer.on("mouseover", this.addDraggingClass, this)) : this.addDraggingClass(), this._originalMapDragState = this._layer._map.dragging._enabled, this._safeToCacheDragState = !0;
        var o = this._getDOMElem();
        o && (pt(this._layer) instanceof L.Canvas ? (this._layer.on("touchstart mousedown", this._dragMixinOnMouseDown, this), this._map.pm._addTouchEvents(o)) : L.DomEvent.on(o, "touchstart mousedown", this._simulateMouseDownEvent, this)), this._fireDragEnable();
      }
    }, disableLayerDrag: function() {
      this._layerDragEnabled = !1, pt(this._layer) instanceof L.Canvas ? (this._layer.off("mouseout", this.removeDraggingClass, this), this._layer.off("mouseover", this.addDraggingClass, this)) : this.removeDraggingClass(), this._originalMapDragState && this._dragging && this._map.dragging.enable(), this._safeToCacheDragState = !1, this._layer.dragging && this._layer.dragging.disable();
      var o = this._getDOMElem();
      o && (pt(this._layer) instanceof L.Canvas ? (this._layer.off("touchstart mousedown", this._dragMixinOnMouseDown, this), this._map.pm._removeTouchEvents(o)) : L.DomEvent.off(o, "touchstart mousedown", this._simulateMouseDownEvent, this)), this._layerDragged && this._fireUpdate(), this._layerDragged = !1, this._fireDragDisable();
    }, dragging: function() {
      return this._dragging;
    }, layerDragEnabled: function() {
      return !!this._layerDragEnabled;
    }, _simulateMouseDownEvent: function(o) {
      var c = o.touches ? o.touches[0] : o, p = { originalEvent: c, target: this._layer };
      return p.containerPoint = this._map.mouseEventToContainerPoint(c), p.latlng = this._map.containerPointToLatLng(p.containerPoint), this._dragMixinOnMouseDown(p), !1;
    }, _simulateMouseMoveEvent: function(o) {
      var c = o.touches ? o.touches[0] : o, p = { originalEvent: c, target: this._layer };
      return p.containerPoint = this._map.mouseEventToContainerPoint(c), p.latlng = this._map.containerPointToLatLng(p.containerPoint), this._dragMixinOnMouseMove(p), !1;
    }, _simulateMouseUpEvent: function(o) {
      var c = { originalEvent: o.touches ? o.touches[0] : o, target: this._layer };
      return o.type.indexOf("touch") === -1 && (c.containerPoint = this._map.mouseEventToContainerPoint(o), c.latlng = this._map.containerPointToLatLng(c.containerPoint)), this._dragMixinOnMouseUp(c), !1;
    }, _dragMixinOnMouseDown: function(o) {
      if (!(o.originalEvent.button > 0)) {
        this._overwriteEventIfItComesFromMarker(o);
        var c = o._fromLayerSync, p = this._syncLayers("_dragMixinOnMouseDown", o);
        if (this._layer instanceof L.Marker && (!this.options.snappable || c || p ? this._disableSnapping() : this._initSnappableMarkers()), this._layer instanceof L.CircleMarker) {
          var _ = "resizeableCircleMarker";
          this._layer instanceof L.Circle && (_ = "resizableCircle"), !this.options.snappable || c || p ? this._layer.pm.options[_] ? this._layer.pm._disableSnapping() : this._layer.pm._disableSnappingDrag() : this._layer.pm.options[_] || this._initSnappableMarkersDrag();
        }
        this._safeToCacheDragState && (this._originalMapDragState = this._layer._map.dragging._enabled, this._safeToCacheDragState = !1), this._tempDragCoord = o.latlng, L.DomEvent.on(this._map.getContainer(), "touchend mouseup", this._simulateMouseUpEvent, this), L.DomEvent.on(this._map.getContainer(), "touchmove mousemove", this._simulateMouseMoveEvent, this);
      }
    }, _dragMixinOnMouseMove: function(o) {
      this._overwriteEventIfItComesFromMarker(o);
      var c = this._getDOMElem();
      this._syncLayers("_dragMixinOnMouseMove", o), this._dragging || (this._dragging = !0, L.DomUtil.addClass(c, "leaflet-pm-dragging"), this._layer instanceof L.Marker || this._layer.bringToFront(), this._originalMapDragState && this._map.dragging.disable(), this._fireDragStart()), this._tempDragCoord || (this._tempDragCoord = o.latlng), this._onLayerDrag(o), this._layer instanceof L.CircleMarker && this._layer.pm._updateHiddenPolyCircle();
    }, _dragMixinOnMouseUp: function(o) {
      var c = this, p = this._getDOMElem();
      return this._syncLayers("_dragMixinOnMouseUp", o), this._originalMapDragState && this._map.dragging.enable(), this._safeToCacheDragState = !0, L.DomEvent.off(this._map.getContainer(), "touchmove mousemove", this._simulateMouseMoveEvent, this), L.DomEvent.off(this._map.getContainer(), "touchend mouseup", this._simulateMouseUpEvent, this), !!this._dragging && (this._layer instanceof L.CircleMarker && this._layer.pm._updateHiddenPolyCircle(), this._layerDragged = !0, window.setTimeout(function() {
        c._dragging = !1, p && L.DomUtil.removeClass(p, "leaflet-pm-dragging"), c._fireDragEnd(), c._fireEdit(), c._layerEdited = !0;
      }, 10), !0);
    }, _onLayerDrag: function(o) {
      var c = o.latlng, p = c.lat - this._tempDragCoord.lat, _ = c.lng - this._tempDragCoord.lng, w = function oe(_e) {
        return _e.map(function(fe) {
          if (Array.isArray(fe))
            return oe(fe);
          var Me = { lat: fe.lat + p, lng: fe.lng + _ };
          return (fe.alt || fe.alt === 0) && (Me.alt = fe.alt), Me;
        });
      };
      if (this._layer instanceof L.Circle && this._layer.options.resizableCircle || this._layer instanceof L.CircleMarker && this._layer.options.resizeableCircleMarker) {
        var B = w([this._layer.getLatLng()]);
        this._layer.setLatLng(B[0]), this._fireChange(this._layer.getLatLng(), "Edit");
      } else if (this._layer instanceof L.CircleMarker || this._layer instanceof L.Marker) {
        var F = this._layer.getLatLng();
        this._layer._snapped && (F = this._layer._orgLatLng);
        var Z = w([F]);
        this._layer.setLatLng(Z[0]), this._fireChange(this._layer.getLatLng(), "Edit");
      } else if (this._layer instanceof L.ImageOverlay) {
        var V = w([this._layer.getBounds().getNorthWest(), this._layer.getBounds().getSouthEast()]);
        this._layer.setBounds(V), this._fireChange(this._layer.getBounds(), "Edit");
      } else {
        var K = w(this._layer.getLatLngs());
        this._layer.setLatLngs(K), this._fireChange(this._layer.getLatLngs(), "Edit");
      }
      this._tempDragCoord = c, o.layer = this._layer, this._fireDrag(o);
    }, addDraggingClass: function() {
      var o = this._getDOMElem();
      o && L.DomUtil.addClass(o, "leaflet-pm-draggable");
    }, removeDraggingClass: function() {
      var o = this._getDOMElem();
      o && L.DomUtil.removeClass(o, "leaflet-pm-draggable");
    }, _getDOMElem: function() {
      var o = null;
      return this._layer._path ? o = this._layer._path : this._layer._renderer && this._layer._renderer._container ? o = this._layer._renderer._container : this._layer._image ? o = this._layer._image : this._layer._icon && (o = this._layer._icon), o;
    }, _overwriteEventIfItComesFromMarker: function(o) {
      o.target.getLatLng && (!o.target._radius || o.target._radius <= 10) && (o.containerPoint = this._map.mouseEventToContainerPoint(o.originalEvent), o.latlng = this._map.containerPointToLatLng(o.containerPoint));
    }, _syncLayers: function(o, c) {
      var p = this;
      if (this.enabled())
        return !1;
      if (!c._fromLayerSync && this._layer === c.target && this.options.syncLayersOnDrag) {
        c._fromLayerSync = !0;
        var _ = [];
        if (L.Util.isArray(this.options.syncLayersOnDrag))
          _ = this.options.syncLayersOnDrag, this.options.syncLayersOnDrag.forEach(function(F) {
            F instanceof L.LayerGroup && (_ = _.concat(F.pm.getLayers(!0)));
          });
        else if (this.options.syncLayersOnDrag === !0 && this._parentLayerGroup)
          for (var w in this._parentLayerGroup) {
            var B = this._parentLayerGroup[w];
            B.pm && (_ = B.pm.getLayers(!0));
          }
        return L.Util.isArray(_) && _.length > 0 && (_ = _.filter(function(F) {
          return !!F.pm;
        }).filter(function(F) {
          return !!F.pm.options.draggable;
        })).forEach(function(F) {
          F !== p._layer && F.pm[o] && (F._snapped = !1, F.pm[o](c));
        }), _.length > 0;
      }
      return !1;
    }, _stopDOMImageDrag: function(o) {
      return o.preventDefault(), !1;
    } };
    function Yr(o, c, p) {
      var _ = p.getMaxZoom();
      if (_ === 1 / 0 && (_ = p.getZoom()), L.Util.isArray(o)) {
        var w = [];
        return o.forEach(function(B) {
          w.push(Yr(B, c, p));
        }), w;
      }
      return o instanceof L.LatLng ? function(B, F, Z, V) {
        return Z.unproject(F.transform(Z.project(B, V)), V);
      }(o, c, p, _) : null;
    }
    function Zn(o, c) {
      c instanceof L.Layer && (c = c.getLatLng());
      var p = o.getMaxZoom();
      return p === 1 / 0 && (p = o.getZoom()), o.project(c, p);
    }
    function dn(o, c) {
      var p = o.getMaxZoom();
      return p === 1 / 0 && (p = o.getZoom()), o.unproject(c, p);
    }
    var fl = { _onRotateStart: function(o) {
      this._preventRenderingMarkers(!0), this._rotationOriginLatLng = this._getRotationCenter().clone(), this._rotationOriginPoint = Zn(this._map, this._rotationOriginLatLng), this._rotationStartPoint = Zn(this._map, o.target.getLatLng()), this._initialRotateLatLng = Ne(this._layer), this._startAngle = this.getAngle();
      var c = Ne(this._rotationLayer, this._rotationLayer.pm._rotateOrgLatLng);
      this._fireRotationStart(this._rotationLayer, c), this._fireRotationStart(this._map, c);
    }, _onRotate: function(o) {
      var c = Zn(this._map, o.target.getLatLng()), p = this._rotationStartPoint, _ = this._rotationOriginPoint, w = Math.atan2(c.y - _.y, c.x - _.x) - Math.atan2(p.y - _.y, p.x - _.x);
      this._layer.setLatLngs(this._rotateLayer(w, this._initialRotateLatLng, this._rotationOriginLatLng, L.PM.Matrix.init(), this._map));
      var B = this;
      (function K(oe) {
        var _e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], fe = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : -1;
        if (fe > -1 && _e.push(fe), L.Util.isArray(oe[0]))
          oe.forEach(function(Ie, qe) {
            return K(Ie, _e.slice(), qe);
          });
        else {
          var Me = Q()(B._markers, _e);
          oe.forEach(function(Ie, qe) {
            Me[qe].setLatLng(Ie);
          });
        }
      })(this._layer.getLatLngs());
      var F = Ne(this._rotationLayer);
      this._rotationLayer.setLatLngs(this._rotateLayer(w, this._rotationLayer.pm._rotateOrgLatLng, this._rotationOriginLatLng, L.PM.Matrix.init(), this._map));
      var Z = 180 * w / Math.PI, V = (Z = Z < 0 ? Z + 360 : Z) + this._startAngle;
      this._setAngle(V), this._rotationLayer.pm._setAngle(V), this._fireRotation(this._rotationLayer, Z, F), this._fireRotation(this._map, Z, F), this._rotationLayer.pm._fireChange(this._rotationLayer.getLatLngs(), "Rotation");
    }, _onRotateEnd: function() {
      var o = this._startAngle;
      delete this._rotationOriginLatLng, delete this._rotationOriginPoint, delete this._rotationStartPoint, delete this._initialRotateLatLng, delete this._startAngle;
      var c = Ne(this._rotationLayer, this._rotationLayer.pm._rotateOrgLatLng);
      this._rotationLayer.pm._rotateOrgLatLng = Ne(this._rotationLayer), this._fireRotationEnd(this._rotationLayer, o, c), this._fireRotationEnd(this._map, o, c), this._rotationLayer.pm._fireEdit(this._rotationLayer, "Rotation"), this._preventRenderingMarkers(!1), this._layerRotated = !0;
    }, _rotateLayer: function(o, c, p, _, w) {
      var B = Zn(w, p);
      return this._matrix = _.clone().rotate(o, B).flip(), Yr(c, this._matrix, w);
    }, _setAngle: function(o) {
      o = o < 0 ? o + 360 : o, this._angle = o % 360;
    }, _getRotationCenter: function() {
      if (this._rotationCenter)
        return this._rotationCenter;
      var o = L.polygon(this._layer.getLatLngs(), { stroke: !1, fill: !1, pmIgnore: !0 }).addTo(this._layer._map), c = o.getCenter();
      return o.removeFrom(this._layer._map), c;
    }, enableRotate: function() {
      this.options.allowRotation ? (this.rotateEnabled() && this.disableRotate(), this._layer instanceof L.Rectangle && this._angle === void 0 && this.setInitAngle(nt(this._layer._map, this._layer.getLatLngs()[0][0], this._layer.getLatLngs()[0][1]) || 0), this._rotatePoly = L.polygon(this._layer.getLatLngs(), { fill: !1, stroke: !1, pmIgnore: !1, snapIgnore: !0 }), this._rotatePoly._pmTempLayer = !0, this._rotatePoly.addTo(this._layer._map), this._rotatePoly.pm._setAngle(this.getAngle()), this._rotatePoly.pm.setRotationCenter(this.getRotationCenter()), this._rotatePoly.pm.setOptions(this._layer._map.pm.getGlobalOptions()), this._rotatePoly.pm.setOptions({ rotate: !0, snappable: !1, hideMiddleMarkers: !0 }), this._rotatePoly.pm._rotationLayer = this._layer, this._rotatePoly.pm.enable(), this._rotateOrgLatLng = Ne(this._layer), this._rotateEnabled = !0, this._layer.on("remove", this.disableRotate, this), this._fireRotationEnable(this._layer), this._fireRotationEnable(this._layer._map)) : this.disableRotate();
    }, disableRotate: function() {
      this.rotateEnabled() && (this._rotatePoly.pm._layerRotated && this._fireUpdate(), this._rotatePoly.pm._layerRotated = !1, this._rotatePoly.pm.disable(), this._rotatePoly.remove(), this._rotatePoly.pm.setOptions({ rotate: !1 }), this._rotatePoly = void 0, this._rotateOrgLatLng = void 0, this._layer.off("remove", this.disableRotate, this), this._rotateEnabled = !1, this._fireRotationDisable(this._layer), this._fireRotationDisable(this._layer._map));
    }, rotateEnabled: function() {
      return this._rotateEnabled;
    }, rotateLayer: function(o) {
      var c = this.getAngle(), p = this._layer.getLatLngs(), _ = o * (Math.PI / 180);
      this._layer.setLatLngs(this._rotateLayer(_, this._layer.getLatLngs(), this._getRotationCenter(), L.PM.Matrix.init(), this._layer._map)), this._rotateOrgLatLng = L.polygon(this._layer.getLatLngs()).getLatLngs(), this._setAngle(this.getAngle() + o), this.rotateEnabled() && this._rotatePoly && this._rotatePoly.pm.enabled() && (this._rotatePoly.setLatLngs(this._rotateLayer(_, this._rotatePoly.getLatLngs(), this._getRotationCenter(), L.PM.Matrix.init(), this._rotatePoly._map)), this._rotatePoly.pm._initMarkers());
      var w = this.getAngle() - c;
      w = w < 0 ? w + 360 : w, this._startAngle = c, this._fireRotation(this._layer, w, p, this._layer), this._fireRotation(this._map || this._layer._map, w, p, this._layer), delete this._startAngle, this._fireChange(this._layer.getLatLngs(), "Rotation");
    }, rotateLayerToAngle: function(o) {
      var c = o - this.getAngle();
      this.rotateLayer(c);
    }, getAngle: function() {
      return this._angle || 0;
    }, setInitAngle: function(o) {
      this._setAngle(o);
    }, getRotationCenter: function() {
      return this._getRotationCenter();
    }, setRotationCenter: function(o) {
      this._rotationCenter = o, this._rotatePoly && this._rotatePoly.pm.setRotationCenter(o);
    } };
    const Hr = fl, Ft = L.Class.extend({ includes: [Gt, S, Hr, ne], options: { snappable: !0, snapDistance: 20, allowSelfIntersection: !0, allowSelfIntersectionEdit: !1, preventMarkerRemoval: !1, removeLayerBelowMinVertexCount: !0, limitMarkersToCount: -1, hideMiddleMarkers: !1, snapSegment: !0, syncLayersOnDrag: !1, draggable: !0, allowEditing: !0, allowRemoval: !0, allowCutting: !0, allowRotation: !0, addVertexOn: "click", removeVertexOn: "contextmenu", removeVertexValidation: void 0, addVertexValidation: void 0, moveVertexValidation: void 0, resizeableCircleMarker: !1, resizableCircle: !0 }, setOptions: function(o) {
      L.Util.setOptions(this, o);
    }, getOptions: function() {
      return this.options;
    }, applyOptions: function() {
    }, isPolygon: function() {
      return this._layer instanceof L.Polygon;
    }, getShape: function() {
      return this._shape;
    }, _setPane: function(o, c) {
      c === "layerPane" ? o.options.pane = this._map.pm.globalOptions.panes && this._map.pm.globalOptions.panes.layerPane || "overlayPane" : c === "vertexPane" ? o.options.pane = this._map.pm.globalOptions.panes && this._map.pm.globalOptions.panes.vertexPane || "markerPane" : c === "markerPane" && (o.options.pane = this._map.pm.globalOptions.panes && this._map.pm.globalOptions.panes.markerPane || "markerPane");
    }, remove: function() {
      (this._map || this._layer._map).pm.removeLayer({ target: this._layer });
    }, _vertexValidation: function(o, c) {
      var p = c.target, _ = { layer: this._layer, marker: p, event: c }, w = "";
      return o === "move" ? w = "moveVertexValidation" : o === "add" ? w = "addVertexValidation" : o === "remove" && (w = "removeVertexValidation"), this.options[w] && typeof this.options[w] == "function" && !this.options[w](_) ? (o === "move" && (p._cancelDragEventChain = p.getLatLng()), !1) : (p._cancelDragEventChain = null, !0);
    }, _vertexValidationDrag: function(o) {
      return !o._cancelDragEventChain || (o._latlng = o._cancelDragEventChain, o.update(), !1);
    }, _vertexValidationDragEnd: function(o) {
      return !o._cancelDragEventChain || (o._cancelDragEventChain = null, !1);
    } });
    function Vt(o) {
      return function(c) {
        if (Array.isArray(c))
          return Wn(c);
      }(o) || function(c) {
        if (typeof Symbol < "u" && c[Symbol.iterator] != null || c["@@iterator"] != null)
          return Array.from(c);
      }(o) || function(c, p) {
        if (c) {
          if (typeof c == "string")
            return Wn(c, p);
          var _ = Object.prototype.toString.call(c).slice(8, -1);
          if (_ === "Object" && c.constructor && (_ = c.constructor.name), _ === "Map" || _ === "Set")
            return Array.from(c);
          if (_ === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(_))
            return Wn(c, p);
        }
      }(o) || function() {
        throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
      }();
    }
    function Wn(o, c) {
      (c == null || c > o.length) && (c = o.length);
      for (var p = 0, _ = new Array(c); p < c; p++)
        _[p] = o[p];
      return _;
    }
    Ft.LayerGroup = L.Class.extend({ initialize: function(o) {
      var c = this;
      this._layerGroup = o, this._layers = this.getLayers(), this._getMap(), this._layers.forEach(function(p) {
        return c._initLayer(p);
      }), this._layerGroup.on("layeradd", L.Util.throttle(function(p) {
        if (!p.layer._pmTempLayer) {
          c._layers = c.getLayers();
          var _ = c._layers.filter(function(w) {
            return !w.pm._parentLayerGroup || !(c._layerGroup._leaflet_id in w.pm._parentLayerGroup);
          });
          _.forEach(function(w) {
            c._initLayer(w);
          }), _.length > 0 && c._getMap() && c._getMap().pm.globalEditModeEnabled() && c.enabled() && c.enable(c.getOptions());
        }
      }, 100, this), this), this._layerGroup.on("layerremove", function(p) {
        c._removeLayerFromGroup(p.target);
      }, this), this._layerGroup.on("layerremove", L.Util.throttle(function(p) {
        p.target._pmTempLayer || (c._layers = c.getLayers());
      }, 100, this), this);
    }, enable: function(o) {
      var c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
      c.length === 0 && (this._layers = this.getLayers()), this._options = o, this._layers.forEach(function(p) {
        p instanceof L.LayerGroup ? c.indexOf(p._leaflet_id) === -1 && (c.push(p._leaflet_id), p.pm.enable(o, c)) : p.pm.enable(o);
      });
    }, disable: function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
      o.length === 0 && (this._layers = this.getLayers()), this._layers.forEach(function(c) {
        c instanceof L.LayerGroup ? o.indexOf(c._leaflet_id) === -1 && (o.push(c._leaflet_id), c.pm.disable(o)) : c.pm.disable();
      });
    }, enabled: function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
      o.length === 0 && (this._layers = this.getLayers());
      var c = this._layers.find(function(p) {
        return p instanceof L.LayerGroup ? o.indexOf(p._leaflet_id) === -1 && (o.push(p._leaflet_id), p.pm.enabled(o)) : p.pm.enabled();
      });
      return !!c;
    }, toggleEdit: function(o) {
      var c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
      c.length === 0 && (this._layers = this.getLayers()), this._options = o, this._layers.forEach(function(p) {
        p instanceof L.LayerGroup ? c.indexOf(p._leaflet_id) === -1 && (c.push(p._leaflet_id), p.pm.toggleEdit(o, c)) : p.pm.toggleEdit(o);
      });
    }, _initLayer: function(o) {
      var c = L.Util.stamp(this._layerGroup);
      o.pm._parentLayerGroup || (o.pm._parentLayerGroup = {}), o.pm._parentLayerGroup[c] = this._layerGroup;
    }, _removeLayerFromGroup: function(o) {
      if (o.pm && o.pm._layerGroup) {
        var c = L.Util.stamp(this._layerGroup);
        delete o.pm._layerGroup[c];
      }
    }, dragging: function() {
      if (this._layers = this.getLayers(), this._layers) {
        var o = this._layers.find(function(c) {
          return c.pm.dragging();
        });
        return !!o;
      }
      return !1;
    }, getOptions: function() {
      return this.options;
    }, _getMap: function() {
      var o;
      return this._map || ((o = this._layers.find(function(c) {
        return !!c._map;
      })) === null || o === void 0 ? void 0 : o._map) || null;
    }, getLayers: function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 && arguments[0], c = !(arguments.length > 1 && arguments[1] !== void 0) || arguments[1], p = !(arguments.length > 2 && arguments[2] !== void 0) || arguments[2], _ = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : [], w = [];
      return o ? this._layerGroup.getLayers().forEach(function(B) {
        w.push(B), B instanceof L.LayerGroup && _.indexOf(B._leaflet_id) === -1 && (_.push(B._leaflet_id), w = w.concat(B.pm.getLayers(!0, !0, !0, _)));
      }) : w = this._layerGroup.getLayers(), p && (w = w.filter(function(B) {
        return !(B instanceof L.LayerGroup);
      })), c && (w = (w = (w = w.filter(function(B) {
        return !!B.pm;
      })).filter(function(B) {
        return !B._pmTempLayer;
      })).filter(function(B) {
        return !L.PM.optIn && !B.options.pmIgnore || L.PM.optIn && B.options.pmIgnore === !1;
      })), w;
    }, setOptions: function(o) {
      var c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
      c.length === 0 && (this._layers = this.getLayers()), this.options = o, this._layers.forEach(function(p) {
        p.pm && (p instanceof L.LayerGroup ? c.indexOf(p._leaflet_id) === -1 && (c.push(p._leaflet_id), p.pm.setOptions(o, c)) : p.pm.setOptions(o));
      });
    } }), Ft.Marker = Ft.extend({ _shape: "Marker", initialize: function(o) {
      this._layer = o, this._enabled = !1, this._layer.on("dragend", this._onDragEnd, this);
    }, enable: function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : { draggable: !0 };
      L.Util.setOptions(this, o), this.options.allowEditing && this._layer._map ? (this._map = this._layer._map, this.enabled() && this.disable(), this.applyOptions(), this._layer.on("remove", this.disable, this), this._enabled = !0, this._fireEnable()) : this.disable();
    }, disable: function() {
      this.enabled() && (this.disableLayerDrag(), this._layer.off("remove", this.disable, this), this._layer.off("contextmenu", this._removeMarker, this), this._layerEdited && this._fireUpdate(), this._layerEdited = !1, this._fireDisable(), this._enabled = !1);
    }, enabled: function() {
      return this._enabled;
    }, toggleEdit: function(o) {
      this.enabled() ? this.disable() : this.enable(o);
    }, applyOptions: function() {
      this.options.snappable ? this._initSnappableMarkers() : this._disableSnapping(), this.options.draggable ? this.enableLayerDrag() : this.disableLayerDrag(), this.options.preventMarkerRemoval || this._layer.on("contextmenu", this._removeMarker, this);
    }, _removeMarker: function(o) {
      var c = o.target;
      c.remove(), this._fireRemove(c), this._fireRemove(this._map, c);
    }, _onDragEnd: function() {
      this._fireEdit(), this._layerEdited = !0;
    }, _initSnappableMarkers: function() {
      var o = this._layer;
      this.options.snapDistance = this.options.snapDistance || 30, this.options.snapSegment = this.options.snapSegment === void 0 || this.options.snapSegment, o.off("pm:drag", this._handleSnapping, this), o.on("pm:drag", this._handleSnapping, this), o.off("pm:dragend", this._cleanupSnapping, this), o.on("pm:dragend", this._cleanupSnapping, this), o.off("pm:dragstart", this._unsnap, this), o.on("pm:dragstart", this._unsnap, this);
    }, _disableSnapping: function() {
      var o = this._layer;
      o.off("pm:drag", this._handleSnapping, this), o.off("pm:dragend", this._cleanupSnapping, this), o.off("pm:dragstart", this._unsnap, this);
    } });
    const fr = { filterMarkerGroup: function() {
      this.markerCache = [], this.createCache(), this._layer.on("pm:edit", this.createCache, this), this.applyLimitFilters({}), this.throttledApplyLimitFilters || (this.throttledApplyLimitFilters = L.Util.throttle(this.applyLimitFilters, 100, this)), this._layer.on("pm:disable", this._removeMarkerLimitEvents, this), this.options.limitMarkersToCount > -1 && (this._layer.on("pm:vertexremoved", this._initMarkers, this), this._map.on("mousemove", this.throttledApplyLimitFilters, this));
    }, _removeMarkerLimitEvents: function() {
      this._map.off("mousemove", this.throttledApplyLimitFilters, this), this._layer.off("pm:edit", this.createCache, this), this._layer.off("pm:disable", this._removeMarkerLimitEvents, this), this._layer.off("pm:vertexremoved", this._initMarkers, this);
    }, createCache: function() {
      var o = [].concat(Vt(this._markerGroup.getLayers()), Vt(this.markerCache));
      this.markerCache = o.filter(function(c, p, _) {
        return _.indexOf(c) === p;
      });
    }, renderLimits: function(o) {
      var c = this;
      this.markerCache.forEach(function(p) {
        o.includes(p) ? c._markerGroup.addLayer(p) : c._markerGroup.removeLayer(p);
      });
    }, applyLimitFilters: function(o) {
      var c = o.latlng, p = c === void 0 ? { lat: 0, lng: 0 } : c;
      if (!this._preventRenderMarkers) {
        var _ = Vt(this._filterClosestMarkers(p));
        this.renderLimits(_);
      }
    }, _filterClosestMarkers: function(o) {
      var c = Vt(this.markerCache), p = this.options.limitMarkersToCount;
      return p === -1 ? c : (c.sort(function(_, w) {
        return _._latlng.distanceTo(o) - w._latlng.distanceTo(o);
      }), c.filter(function(_, w) {
        return !(p > -1) || w < p;
      }));
    }, _preventRenderMarkers: !1, _preventRenderingMarkers: function(o) {
      this._preventRenderMarkers = !!o;
    } };
    function pr(o, c) {
      return function(p) {
        if (Array.isArray(p))
          return p;
      }(o) || function(p, _) {
        var w = p == null ? null : typeof Symbol < "u" && p[Symbol.iterator] || p["@@iterator"];
        if (w != null) {
          var B, F, Z = [], V = !0, K = !1;
          try {
            for (w = w.call(p); !(V = (B = w.next()).done) && (Z.push(B.value), !_ || Z.length !== _); V = !0)
              ;
          } catch (oe) {
            K = !0, F = oe;
          } finally {
            try {
              V || w.return == null || w.return();
            } finally {
              if (K)
                throw F;
            }
          }
          return Z;
        }
      }(o, c) || function(p, _) {
        if (p) {
          if (typeof p == "string")
            return Ur(p, _);
          var w = Object.prototype.toString.call(p).slice(8, -1);
          if (w === "Object" && p.constructor && (w = p.constructor.name), w === "Map" || w === "Set")
            return Array.from(p);
          if (w === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(w))
            return Ur(p, _);
        }
      }(o, c) || function() {
        throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
      }();
    }
    function Ur(o, c) {
      (c == null || c > o.length) && (c = o.length);
      for (var p = 0, _ = new Array(c); p < c; p++)
        _[p] = o[p];
      return _;
    }
    function mr(o) {
      return function(c) {
        if (Array.isArray(c))
          return gr(c);
      }(o) || function(c) {
        if (typeof Symbol < "u" && c[Symbol.iterator] != null || c["@@iterator"] != null)
          return Array.from(c);
      }(o) || function(c, p) {
        if (c) {
          if (typeof c == "string")
            return gr(c, p);
          var _ = Object.prototype.toString.call(c).slice(8, -1);
          if (_ === "Object" && c.constructor && (_ = c.constructor.name), _ === "Map" || _ === "Set")
            return Array.from(c);
          if (_ === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(_))
            return gr(c, p);
        }
      }(o) || function() {
        throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
      }();
    }
    function gr(o, c) {
      (c == null || c > o.length) && (c = o.length);
      for (var p = 0, _ = new Array(c); p < c; p++)
        _[p] = o[p];
      return _;
    }
    Ft.Line = Ft.extend({ includes: [fr], _shape: "Line", initialize: function(o) {
      this._layer = o, this._enabled = !1;
    }, enable: function(o) {
      L.Util.setOptions(this, o), this._map = this._layer._map, this._map && (this.options.allowEditing ? (this.enabled() && this.disable(), this._enabled = !0, this._initMarkers(), this.applyOptions(), this._layer.on("remove", this.disable, this), this.options.allowSelfIntersection || this._layer.on("pm:vertexremoved", this._handleSelfIntersectionOnVertexRemoval, this), this.options.allowSelfIntersection ? this.cachedColor = void 0 : (this._layer.options.color !== "#f00000ff" ? (this.cachedColor = this._layer.options.color, this.isRed = !1) : this.isRed = !0, this._handleLayerStyle()), this._fireEnable()) : this.disable());
    }, disable: function() {
      if (this.enabled() && !this._dragging) {
        this._enabled = !1, this._markerGroup.clearLayers(), this._markerGroup.removeFrom(this._map), this._layer.off("remove", this.disable, this), this.options.allowSelfIntersection || this._layer.off("pm:vertexremoved", this._handleSelfIntersectionOnVertexRemoval, this);
        var o = this._layer._path ? this._layer._path : this._layer._renderer._container;
        L.DomUtil.removeClass(o, "leaflet-pm-draggable"), this._layerEdited && this._fireUpdate(), this._layerEdited = !1, this._fireDisable();
      }
    }, enabled: function() {
      return this._enabled;
    }, toggleEdit: function(o) {
      return this.enabled() ? this.disable() : this.enable(o), this.enabled();
    }, applyOptions: function() {
      this.options.snappable ? this._initSnappableMarkers() : this._disableSnapping();
    }, _initMarkers: function() {
      var o = this, c = this._map, p = this._layer.getLatLngs();
      this._markerGroup && this._markerGroup.clearLayers(), this._markerGroup = new L.FeatureGroup(), this._markerGroup._pmTempLayer = !0, this._markers = function _(w) {
        if (Array.isArray(w[0]))
          return w.map(_, o);
        var B = w.map(o._createMarker, o);
        return o.options.hideMiddleMarkers !== !0 && w.map(function(F, Z) {
          var V = o.isPolygon() ? (Z + 1) % w.length : Z + 1;
          return o._createMiddleMarker(B[Z], B[V]);
        }), B;
      }(p), this.filterMarkerGroup(), c.addLayer(this._markerGroup);
    }, _createMarker: function(o) {
      var c = new L.Marker(o, { draggable: !0, icon: L.divIcon({ className: "marker-icon" }) });
      return this._setPane(c, "vertexPane"), c._pmTempLayer = !0, this.options.rotate ? (c.on("dragstart", this._onRotateStart, this), c.on("drag", this._onRotate, this), c.on("dragend", this._onRotateEnd, this)) : (c.on("click", this._onVertexClick, this), c.on("dragstart", this._onMarkerDragStart, this), c.on("move", this._onMarkerDrag, this), c.on("dragend", this._onMarkerDragEnd, this), this.options.preventMarkerRemoval || c.on(this.options.removeVertexOn, this._removeMarker, this)), this._markerGroup.addLayer(c), c;
    }, _createMiddleMarker: function(o, c) {
      if (!o || !c)
        return !1;
      var p = L.PM.Utils.calcMiddleLatLng(this._map, o.getLatLng(), c.getLatLng()), _ = this._createMarker(p), w = L.divIcon({ className: "marker-icon marker-icon-middle" });
      return _.setIcon(w), _.leftM = o, _.rightM = c, o._middleMarkerNext = _, c._middleMarkerPrev = _, _.on(this.options.addVertexOn, this._onMiddleMarkerClick, this), _.on("movestart", this._onMiddleMarkerMoveStart, this), _;
    }, _onMiddleMarkerClick: function(o) {
      var c = o.target;
      if (this._vertexValidation("add", o)) {
        var p = L.divIcon({ className: "marker-icon" });
        c.setIcon(p), this._addMarker(c, c.leftM, c.rightM);
      }
    }, _onMiddleMarkerMoveStart: function(o) {
      var c = o.target;
      c.on("moveend", this._onMiddleMarkerMoveEnd, this), this._vertexValidation("add", o) ? (c._dragging = !0, this._addMarker(c, c.leftM, c.rightM)) : c.on("move", this._onMiddleMarkerMovePrevent, this);
    }, _onMiddleMarkerMovePrevent: function(o) {
      var c = o.target;
      this._vertexValidationDrag(c);
    }, _onMiddleMarkerMoveEnd: function(o) {
      var c = o.target;
      if (c.off("move", this._onMiddleMarkerMovePrevent, this), c.off("moveend", this._onMiddleMarkerMoveEnd, this), this._vertexValidationDragEnd(c)) {
        var p = L.divIcon({ className: "marker-icon" });
        c.setIcon(p), setTimeout(function() {
          delete c._dragging;
        }, 100);
      }
    }, _addMarker: function(o, c, p) {
      o.off("movestart", this._onMiddleMarkerMoveStart, this), o.off(this.options.addVertexOn, this._onMiddleMarkerClick, this);
      var _ = o.getLatLng(), w = this._layer._latlngs;
      delete o.leftM, delete o.rightM;
      var B = L.PM.Utils.findDeepMarkerIndex(this._markers, c), F = B.indexPath, Z = B.index, V = B.parentPath, K = F.length > 1 ? Q()(w, V) : w, oe = F.length > 1 ? Q()(this._markers, V) : this._markers;
      K.splice(Z + 1, 0, _), oe.splice(Z + 1, 0, o), this._layer.setLatLngs(w), this.options.hideMiddleMarkers !== !0 && (this._createMiddleMarker(c, o), this._createMiddleMarker(o, p)), this._fireEdit(), this._layerEdited = !0, this._fireChange(this._layer.getLatLngs(), "Edit"), this._fireVertexAdded(o, L.PM.Utils.findDeepMarkerIndex(this._markers, o).indexPath, _), this.options.snappable && this._initSnappableMarkers();
    }, hasSelfIntersection: function() {
      return lt(this._layer.toGeoJSON(15)).features.length > 0;
    }, _handleSelfIntersectionOnVertexRemoval: function() {
      this._handleLayerStyle(!0) && (this._layer.setLatLngs(this._coordsBeforeEdit), this._coordsBeforeEdit = null, this._initMarkers());
    }, _handleLayerStyle: function(o) {
      var c, p, _ = this._layer;
      if (c = !this.options.allowSelfIntersection && (p = lt(this._layer.toGeoJSON(15))).features.length > 0) {
        if (!this.options.allowSelfIntersection && this.options.allowSelfIntersectionEdit && this._updateDisabledMarkerStyle(this._markers, !0), this.isRed)
          return c;
        o ? this._flashLayer() : (_.setStyle({ color: "#f00000ff" }), this.isRed = !0), this._fireIntersect(p);
      } else
        _.setStyle({ color: this.cachedColor }), this.isRed = !1, !this.options.allowSelfIntersection && this.options.allowSelfIntersectionEdit && this._updateDisabledMarkerStyle(this._markers, !1);
      return c;
    }, _flashLayer: function() {
      var o = this;
      this.cachedColor || (this.cachedColor = this._layer.options.color), this._layer.setStyle({ color: "#f00000ff" }), this.isRed = !0, window.setTimeout(function() {
        o._layer.setStyle({ color: o.cachedColor }), o.isRed = !1;
      }, 200);
    }, _updateDisabledMarkerStyle: function(o, c) {
      var p = this;
      o.forEach(function(_) {
        Array.isArray(_) ? p._updateDisabledMarkerStyle(_, c) : _._icon && (c && !p._checkMarkerAllowedToDrag(_) ? L.DomUtil.addClass(_._icon, "vertexmarker-disabled") : L.DomUtil.removeClass(_._icon, "vertexmarker-disabled"));
      });
    }, _removeMarker: function(o) {
      var c = o.target;
      if (this._vertexValidation("remove", o)) {
        this.options.allowSelfIntersection || (this._coordsBeforeEdit = Ne(this._layer, this._layer.getLatLngs()));
        var p = this._layer.getLatLngs(), _ = L.PM.Utils.findDeepMarkerIndex(this._markers, c), w = _.indexPath, B = _.index, F = _.parentPath;
        if (w) {
          var Z = w.length > 1 ? Q()(p, F) : p, V = w.length > 1 ? Q()(this._markers, F) : this._markers;
          if (this.options.removeLayerBelowMinVertexCount || !(Z.length <= 2 || this.isPolygon() && Z.length <= 3)) {
            Z.splice(B, 1), this._layer.setLatLngs(p), this.isPolygon() && Z.length <= 2 && Z.splice(0, Z.length);
            var K = !1;
            if (Z.length <= 1 && (Z.splice(0, Z.length), F.length > 1 && w.length > 1 && (p = ue(p)), this._layer.setLatLngs(p), this._initMarkers(), K = !0), Ye(p) || this._layer.remove(), p = ue(p), this._layer.setLatLngs(p), this._markers = ue(this._markers), !K && (V = w.length > 1 ? Q()(this._markers, F) : this._markers, c._middleMarkerPrev && this._markerGroup.removeLayer(c._middleMarkerPrev), c._middleMarkerNext && this._markerGroup.removeLayer(c._middleMarkerNext), this._markerGroup.removeLayer(c), V)) {
              var oe, _e;
              if (this.isPolygon() ? (oe = (B + 1) % V.length, _e = (B + (V.length - 1)) % V.length) : (_e = B - 1 < 0 ? void 0 : B - 1, oe = B + 1 >= V.length ? void 0 : B + 1), oe !== _e) {
                var fe = V[_e], Me = V[oe];
                this.options.hideMiddleMarkers !== !0 && this._createMiddleMarker(fe, Me);
              }
              V.splice(B, 1);
            }
            this._fireEdit(), this._layerEdited = !0, this._fireVertexRemoved(c, w), this._fireChange(this._layer.getLatLngs(), "Edit");
          } else
            this._flashLayer();
        }
      }
    }, updatePolygonCoordsFromMarkerDrag: function(o) {
      var c = this._layer.getLatLngs(), p = o.getLatLng(), _ = L.PM.Utils.findDeepMarkerIndex(this._markers, o), w = _.indexPath, B = _.index, F = _.parentPath;
      (w.length > 1 ? Q()(c, F) : c).splice(B, 1, p), this._layer.setLatLngs(c);
    }, _getNeighborMarkers: function(o) {
      var c = L.PM.Utils.findDeepMarkerIndex(this._markers, o), p = c.indexPath, _ = c.index, w = c.parentPath, B = p.length > 1 ? Q()(this._markers, w) : this._markers, F = (_ + 1) % B.length;
      return { prevMarker: B[(_ + (B.length - 1)) % B.length], nextMarker: B[F] };
    }, _checkMarkerAllowedToDrag: function(o) {
      var c = this._getNeighborMarkers(o), p = c.prevMarker, _ = c.nextMarker, w = L.polyline([p.getLatLng(), o.getLatLng()]), B = L.polyline([o.getLatLng(), _.getLatLng()]), F = ct(this._layer.toGeoJSON(15), w.toGeoJSON(15)).features.length, Z = ct(this._layer.toGeoJSON(15), B.toGeoJSON(15)).features.length;
      return o.getLatLng() === this._markers[0][0].getLatLng() ? Z += 1 : o.getLatLng() === this._markers[0][this._markers[0].length - 1].getLatLng() && (F += 1), !(F <= 2 && Z <= 2);
    }, _onMarkerDragStart: function(o) {
      var c = o.target;
      if (this.cachedColor || (this.cachedColor = this._layer.options.color), this._vertexValidation("move", o)) {
        var p = L.PM.Utils.findDeepMarkerIndex(this._markers, c).indexPath;
        this._fireMarkerDragStart(o, p), this.options.allowSelfIntersection || (this._coordsBeforeEdit = Ne(this._layer, this._layer.getLatLngs())), !this.options.allowSelfIntersection && this.options.allowSelfIntersectionEdit && this.hasSelfIntersection() ? this._markerAllowedToDrag = this._checkMarkerAllowedToDrag(c) : this._markerAllowedToDrag = null;
      }
    }, _onMarkerDrag: function(o) {
      var c = o.target;
      if (this._vertexValidationDrag(c)) {
        var p = L.PM.Utils.findDeepMarkerIndex(this._markers, c), _ = p.indexPath, w = p.index, B = p.parentPath;
        if (_) {
          if (!this.options.allowSelfIntersection && this.options.allowSelfIntersectionEdit && this.hasSelfIntersection() && this._markerAllowedToDrag === !1)
            return this._layer.setLatLngs(this._coordsBeforeEdit), this._initMarkers(), void this._handleLayerStyle();
          this.updatePolygonCoordsFromMarkerDrag(c);
          var F = _.length > 1 ? Q()(this._markers, B) : this._markers, Z = (w + 1) % F.length, V = (w + (F.length - 1)) % F.length, K = c.getLatLng(), oe = F[V].getLatLng(), _e = F[Z].getLatLng();
          if (c._middleMarkerNext) {
            var fe = L.PM.Utils.calcMiddleLatLng(this._map, K, _e);
            c._middleMarkerNext.setLatLng(fe);
          }
          if (c._middleMarkerPrev) {
            var Me = L.PM.Utils.calcMiddleLatLng(this._map, K, oe);
            c._middleMarkerPrev.setLatLng(Me);
          }
          this.options.allowSelfIntersection || this._handleLayerStyle(), this._fireMarkerDrag(o, _), this._fireChange(this._layer.getLatLngs(), "Edit");
        }
      }
    }, _onMarkerDragEnd: function(o) {
      var c = o.target;
      if (this._vertexValidationDragEnd(c)) {
        var p = L.PM.Utils.findDeepMarkerIndex(this._markers, c).indexPath, _ = this.hasSelfIntersection();
        _ && this.options.allowSelfIntersectionEdit && this._markerAllowedToDrag && (_ = !1);
        var w = !this.options.allowSelfIntersection && _;
        if (this._fireMarkerDragEnd(o, p, w), w)
          return this._layer.setLatLngs(this._coordsBeforeEdit), this._coordsBeforeEdit = null, this._initMarkers(), this.options.snappable && this._initSnappableMarkers(), this._handleLayerStyle(), void this._fireLayerReset(o, p);
        !this.options.allowSelfIntersection && this.options.allowSelfIntersectionEdit && this._handleLayerStyle(), this._fireEdit(), this._layerEdited = !0, this._fireChange(this._layer.getLatLngs(), "Edit");
      }
    }, _onVertexClick: function(o) {
      var c = o.target;
      if (!c._dragging) {
        var p = L.PM.Utils.findDeepMarkerIndex(this._markers, c).indexPath;
        this._fireVertexClick(o, p);
      }
    } }), Ft.Polygon = Ft.Line.extend({ _shape: "Polygon", _checkMarkerAllowedToDrag: function(o) {
      var c = this._getNeighborMarkers(o), p = c.prevMarker, _ = c.nextMarker, w = L.polyline([p.getLatLng(), o.getLatLng()]), B = L.polyline([o.getLatLng(), _.getLatLng()]), F = ct(this._layer.toGeoJSON(15), w.toGeoJSON(15)).features.length, Z = ct(this._layer.toGeoJSON(15), B.toGeoJSON(15)).features.length;
      return !(F <= 2 && Z <= 2);
    } }), Ft.Rectangle = Ft.Polygon.extend({ _shape: "Rectangle", _initMarkers: function() {
      var o = this, c = this._map, p = this._findCorners();
      this._markerGroup && this._markerGroup.clearLayers(), this._markerGroup = new L.FeatureGroup(), this._markerGroup._pmTempLayer = !0, c.addLayer(this._markerGroup), this._markers = [], this._markers[0] = p.map(this._createMarker, this);
      var _ = pr(this._markers, 1);
      this._cornerMarkers = _[0], this._layer.getLatLngs()[0].forEach(function(w, B) {
        var F = o._cornerMarkers.find(function(Z) {
          return Z._index === B;
        });
        F && F.setLatLng(w);
      });
    }, applyOptions: function() {
      this.options.snappable ? this._initSnappableMarkers() : this._disableSnapping(), this._addMarkerEvents();
    }, _createMarker: function(o, c) {
      var p = new L.Marker(o, { draggable: !0, icon: L.divIcon({ className: "marker-icon" }) });
      return this._setPane(p, "vertexPane"), p._origLatLng = o, p._index = c, p._pmTempLayer = !0, p.on("click", this._onVertexClick, this), this._markerGroup.addLayer(p), p;
    }, _addMarkerEvents: function() {
      var o = this;
      this._markers[0].forEach(function(c) {
        c.on("dragstart", o._onMarkerDragStart, o), c.on("drag", o._onMarkerDrag, o), c.on("dragend", o._onMarkerDragEnd, o), o.options.preventMarkerRemoval || c.on("contextmenu", o._removeMarker, o);
      });
    }, _removeMarker: function() {
      return null;
    }, _onMarkerDragStart: function(o) {
      if (this._vertexValidation("move", o)) {
        var c = o.target, p = this._cornerMarkers;
        c._oppositeCornerLatLng = p.find(function(_) {
          return _._index === (c._index + 2) % 4;
        }).getLatLng(), c._snapped = !1, this._fireMarkerDragStart(o);
      }
    }, _onMarkerDrag: function(o) {
      var c = o.target;
      this._vertexValidationDrag(c) && c._index !== void 0 && (this._adjustRectangleForMarkerMove(c), this._fireMarkerDrag(o), this._fireChange(this._layer.getLatLngs(), "Edit"));
    }, _onMarkerDragEnd: function(o) {
      var c = o.target;
      this._vertexValidationDragEnd(c) && (this._cornerMarkers.forEach(function(p) {
        delete p._oppositeCornerLatLng;
      }), this._fireMarkerDragEnd(o), this._fireEdit(), this._layerEdited = !0, this._fireChange(this._layer.getLatLngs(), "Edit"));
    }, _adjustRectangleForMarkerMove: function(o) {
      L.extend(o._origLatLng, o._latlng);
      var c = L.PM.Utils._getRotatedRectangle(o.getLatLng(), o._oppositeCornerLatLng, this.getAngle(), this._map);
      this._layer.setLatLngs(c), this._adjustAllMarkers(), this._layer.redraw();
    }, _adjustAllMarkers: function() {
      var o = this, c = this._layer.getLatLngs()[0];
      c && c.length !== 4 && c.length > 0 ? (c.forEach(function(p, _) {
        o._cornerMarkers[_].setLatLng(p);
      }), this._cornerMarkers.slice(c.length).forEach(function(p) {
        p.setLatLng(c[0]);
      })) : c && c.length ? this._cornerMarkers.forEach(function(p) {
        p.setLatLng(c[p._index]);
      }) : console.error("The layer has no LatLngs");
    }, _findCorners: function() {
      this._angle === void 0 && this.setInitAngle(nt(this._map, this._layer.getLatLngs()[0][0], this._layer.getLatLngs()[0][1]) || 0);
      var o = this._layer.getLatLngs()[0];
      return L.PM.Utils._getRotatedRectangle(o[0], o[2], this.getAngle(), this._map || this);
    } }), Ft.CircleMarker = Ft.extend({ _shape: "CircleMarker", initialize: function(o) {
      this._layer = o, this._enabled = !1, this._minRadiusOption = "minRadiusCircleMarker", this._maxRadiusOption = "maxRadiusCircleMarker", this._editableOption = "resizeableCircleMarker", this._updateHiddenPolyCircle();
    }, enable: function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : { draggable: !0, snappable: !0 };
      L.Util.setOptions(this, o), this.options.editable && (this.options.resizeableCircleMarker = this.options.editable, delete this.options.editable), this.options.allowEditing && this._layer._map ? (this._map = this._layer._map, this.enabled() && this.disable(), this.applyOptions(), this._layer.on("remove", this.disable, this), this._enabled = !0, this._extendingEnable(), this._updateHiddenPolyCircle(), this._fireEnable()) : this.disable();
    }, _extendingEnable: function() {
      this._layer.on("pm:dragstart", this._onDragStart, this), this._layer.on("pm:drag", this._onMarkerDrag, this), this._layer.on("pm:dragend", this._onMarkerDragEnd, this);
    }, disable: function() {
      this.dragging() || (this._map || (this._map = this._layer._map), this._map && this.enabled() && (this.layerDragEnabled() && this.disableLayerDrag(), this.options[this._editableOption] ? (this._helperLayers && this._helperLayers.clearLayers(), this._map.off("move", this._syncMarkers, this), this._outerMarker.off("drag", this._handleOuterMarkerSnapping, this)) : this._map.off("move", this._updateHiddenPolyCircle, this), this._extendingDisable(), this._layer.off("remove", this.disable, this), this._layerEdited && this._fireUpdate(), this._layerEdited = !1, this._fireDisable(), this._enabled = !1));
    }, _extendingDisable: function() {
      this._layer.off("contextmenu", this._removeMarker, this);
    }, enabled: function() {
      return this._enabled;
    }, toggleEdit: function(o) {
      this.enabled() ? this.disable() : this.enable(o);
    }, applyOptions: function() {
      this.options[this._editableOption] ? (this._initMarkers(), this._map.on("move", this._syncMarkers, this), this.options.snappable ? (this._initSnappableMarkers(), this._outerMarker.on("drag", this._handleOuterMarkerSnapping, this), this._outerMarker.on("move", this._syncHintLine, this), this._outerMarker.on("move", this._syncCircleRadius, this), this._centerMarker.on("move", this._moveCircle, this)) : this._disableSnapping()) : (this.options.draggable && this.enableLayerDrag(), this._map.on("move", this._updateHiddenPolyCircle, this), this.options.snappable ? this._initSnappableMarkersDrag() : this._disableSnappingDrag()), this._extendingApplyOptions();
    }, _extendingApplyOptions: function() {
      this.options.preventMarkerRemoval || this._layer.on("contextmenu", this._removeMarker, this);
    }, _initMarkers: function() {
      var o = this._map;
      this._helperLayers && this._helperLayers.clearLayers(), this._helperLayers = new L.FeatureGroup(), this._helperLayers._pmTempLayer = !0, this._helperLayers.addTo(o);
      var c = this._layer.getLatLng(), p = this._layer._radius, _ = this._getLatLngOnCircle(c, p);
      this._centerMarker = this._createCenterMarker(c), this._outerMarker = this._createOuterMarker(_), this._markers = [this._centerMarker, this._outerMarker], this._createHintLine(this._centerMarker, this._outerMarker);
    }, _getLatLngOnCircle: function(o, c) {
      var p = this._map.project(o), _ = L.point(p.x + c, p.y);
      return this._map.unproject(_);
    }, _createHintLine: function(o, c) {
      var p = o.getLatLng(), _ = c.getLatLng();
      this._hintline = L.polyline([p, _], this.options.hintlineStyle), this._setPane(this._hintline, "layerPane"), this._hintline._pmTempLayer = !0, this._helperLayers.addLayer(this._hintline);
    }, _createCenterMarker: function(o) {
      var c = this._createMarker(o);
      return this.options.draggable ? L.DomUtil.addClass(c._icon, "leaflet-pm-draggable") : c.dragging.disable(), c;
    }, _createOuterMarker: function(o) {
      var c = this._createMarker(o);
      return c.on("drag", this._resizeCircle, this), c;
    }, _createMarker: function(o) {
      var c = new L.Marker(o, { draggable: !0, icon: L.divIcon({ className: "marker-icon" }) });
      return this._setPane(c, "vertexPane"), c._origLatLng = o, c._pmTempLayer = !0, c.on("dragstart", this._onMarkerDragStart, this), c.on("drag", this._onMarkerDrag, this), c.on("dragend", this._onMarkerDragEnd, this), c.on("click", this._onVertexClick, this), this._helperLayers.addLayer(c), c;
    }, _moveCircle: function(o) {
      if (!o.target._cancelDragEventChain) {
        var c = this._centerMarker.getLatLng();
        this._layer.setLatLng(c);
        var p = this._layer._radius, _ = this._getLatLngOnCircle(c, p);
        this._outerMarker._latlng = _, this._outerMarker.update(), this._syncHintLine(), this._updateHiddenPolyCircle(), this._fireCenterPlaced("Edit"), this._fireChange(this._layer.getLatLng(), "Edit");
      }
    }, _syncMarkers: function() {
      var o = this._layer.getLatLng(), c = this._layer._radius, p = this._getLatLngOnCircle(o, c);
      this._outerMarker.setLatLng(p), this._centerMarker.setLatLng(o), this._syncHintLine(), this._updateHiddenPolyCircle();
    }, _resizeCircle: function() {
      this._outerMarker.setLatLng(this._getNewDestinationOfOuterMarker()), this._syncHintLine(), this._syncCircleRadius();
    }, _syncCircleRadius: function() {
      var o = this._centerMarker.getLatLng(), c = this._outerMarker.getLatLng(), p = this._distanceCalculation(o, c);
      this.options[this._minRadiusOption] && p < this.options[this._minRadiusOption] ? this._layer.setRadius(this.options[this._minRadiusOption]) : this.options[this._maxRadiusOption] && p > this.options[this._maxRadiusOption] ? this._layer.setRadius(this.options[this._maxRadiusOption]) : this._layer.setRadius(p), this._updateHiddenPolyCircle(), this._fireChange(this._layer.getLatLng(), "Edit");
    }, _syncHintLine: function() {
      var o = this._centerMarker.getLatLng(), c = this._outerMarker.getLatLng();
      this._hintline.setLatLngs([o, c]);
    }, _removeMarker: function() {
      this.options[this._editableOption] && this.disable(), this._layer.remove(), this._fireRemove(this._layer), this._fireRemove(this._map, this._layer);
    }, _onDragStart: function() {
      this._map.pm.Draw.CircleMarker._layerIsDragging = !0;
    }, _onMarkerDragStart: function(o) {
      this._vertexValidation("move", o) && this._fireMarkerDragStart(o);
    }, _onMarkerDrag: function(o) {
      var c = o.target;
      c instanceof L.Marker && !this._vertexValidationDrag(c) || this._fireMarkerDrag(o);
    }, _onMarkerDragEnd: function(o) {
      this._extedingMarkerDragEnd();
      var c = o.target;
      this._vertexValidationDragEnd(c) && (this.options[this._editableOption] && (this._fireEdit(), this._layerEdited = !0), this._fireMarkerDragEnd(o));
    }, _extedingMarkerDragEnd: function() {
      this._map.pm.Draw.CircleMarker._layerIsDragging = !1;
    }, _initSnappableMarkersDrag: function() {
      var o = this._layer;
      this.options.snapDistance = this.options.snapDistance || 30, this.options.snapSegment = this.options.snapSegment === void 0 || this.options.snapSegment, o.off("pm:drag", this._handleSnapping, this), o.on("pm:drag", this._handleSnapping, this), o.off("pm:dragend", this._cleanupSnapping, this), o.on("pm:dragend", this._cleanupSnapping, this), o.off("pm:dragstart", this._unsnap, this), o.on("pm:dragstart", this._unsnap, this);
    }, _disableSnappingDrag: function() {
      var o = this._layer;
      o.off("pm:drag", this._handleSnapping, this), o.off("pm:dragend", this._cleanupSnapping, this), o.off("pm:dragstart", this._unsnap, this);
    }, _updateHiddenPolyCircle: function() {
      var o = this._layer._map || this._map;
      if (o) {
        var c = L.PM.Utils.pxRadiusToMeterRadius(this._layer.getRadius(), o, this._layer.getLatLng()), p = L.circle(this._layer.getLatLng(), this._layer.options);
        p.setRadius(c);
        var _ = o && o.pm._isCRSSimple();
        this._hiddenPolyCircle ? this._hiddenPolyCircle.setLatLngs(L.PM.Utils.circleToPolygon(p, 200, !_).getLatLngs()) : this._hiddenPolyCircle = L.PM.Utils.circleToPolygon(p, 200, !_), this._hiddenPolyCircle._parentCopy || (this._hiddenPolyCircle._parentCopy = this._layer);
      }
    }, _getNewDestinationOfOuterMarker: function() {
      var o = this._centerMarker.getLatLng(), c = this._outerMarker.getLatLng(), p = this._distanceCalculation(o, c);
      return this.options[this._minRadiusOption] && p < this.options[this._minRadiusOption] ? c = Ve(this._map, o, c, this._getMinDistanceInMeter(o)) : this.options[this._maxRadiusOption] && p > this.options[this._maxRadiusOption] && (c = Ve(this._map, o, c, this._getMaxDistanceInMeter(o))), c;
    }, _handleOuterMarkerSnapping: function() {
      if (this._outerMarker._snapped) {
        var o = this._centerMarker.getLatLng(), c = this._outerMarker.getLatLng(), p = this._distanceCalculation(o, c);
        (this.options[this._minRadiusOption] && p < this.options[this._minRadiusOption] || this.options[this._maxRadiusOption] && p > this.options[this._maxRadiusOption]) && this._outerMarker.setLatLng(this._outerMarker._orgLatLng);
      }
      this._outerMarker.setLatLng(this._getNewDestinationOfOuterMarker());
    }, _distanceCalculation: function(o, c) {
      return this._map.project(o).distanceTo(this._map.project(c));
    }, _getMinDistanceInMeter: function(o) {
      return L.PM.Utils.pxRadiusToMeterRadius(this.options[this._minRadiusOption], this._map, o);
    }, _getMaxDistanceInMeter: function(o) {
      return L.PM.Utils.pxRadiusToMeterRadius(this.options[this._maxRadiusOption], this._map, o);
    }, _onVertexClick: function(o) {
      o.target._dragging || this._fireVertexClick(o, void 0);
    } }), Ft.Circle = Ft.CircleMarker.extend({ _shape: "Circle", initialize: function(o) {
      this._layer = o, this._enabled = !1, this._minRadiusOption = "minRadiusCircle", this._maxRadiusOption = "maxRadiusCircle", this._editableOption = "resizableCircle", this._updateHiddenPolyCircle();
    }, enable: function(o) {
      L.PM.Edit.CircleMarker.prototype.enable.call(this, o || {});
    }, _extendingEnable: function() {
    }, _extendingDisable: function() {
      this._layer.off("remove", this.disable, this);
      var o = this._layer._path ? this._layer._path : this._layer._renderer._container;
      L.DomUtil.removeClass(o, "leaflet-pm-draggable");
    }, _extendingApplyOptions: function() {
    }, _syncMarkers: function() {
    }, _removeMarker: function() {
    }, _onDragStart: function() {
    }, _extedingMarkerDragEnd: function() {
    }, _updateHiddenPolyCircle: function() {
      var o = this._map && this._map.pm._isCRSSimple();
      this._hiddenPolyCircle ? this._hiddenPolyCircle.setLatLngs(L.PM.Utils.circleToPolygon(this._layer, 200, !o).getLatLngs()) : this._hiddenPolyCircle = L.PM.Utils.circleToPolygon(this._layer, 200, !o), this._hiddenPolyCircle._parentCopy || (this._hiddenPolyCircle._parentCopy = this._layer);
    }, _distanceCalculation: function(o, c) {
      return this._map.distance(o, c);
    }, _getMinDistanceInMeter: function() {
      return this.options[this._minRadiusOption];
    }, _getMaxDistanceInMeter: function() {
      return this.options[this._maxRadiusOption];
    }, _onVertexClick: function(o) {
      o.target._dragging || this._fireVertexClick(o, void 0);
    } }), Ft.ImageOverlay = Ft.extend({ _shape: "ImageOverlay", initialize: function(o) {
      this._layer = o, this._enabled = !1;
    }, toggleEdit: function(o) {
      this.enabled() ? this.disable() : this.enable(o);
    }, enabled: function() {
      return this._enabled;
    }, enable: function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : { draggable: !0, snappable: !0 };
      L.Util.setOptions(this, o), this._map = this._layer._map, this._map && (this.options.allowEditing ? (this.enabled() || this.disable(), this.enableLayerDrag(), this._layer.on("remove", this.disable, this), this._enabled = !0, this._otherSnapLayers = this._findCorners(), this._fireEnable()) : this.disable());
    }, disable: function() {
      this._dragging || (this._map || (this._map = this._layer._map), this.disableLayerDrag(), this._layer.off("remove", this.disable, this), this.enabled() || (this._layerEdited && this._fireUpdate(), this._layerEdited = !1, this._fireDisable()), this._enabled = !1);
    }, _findCorners: function() {
      var o = this._layer.getBounds();
      return [o.getNorthWest(), o.getNorthEast(), o.getSouthEast(), o.getSouthWest()];
    } }), Ft.Text = Ft.extend({ _shape: "Text", initialize: function(o) {
      this._layer = o, this._enabled = !1;
    }, enable: function(o) {
      L.Util.setOptions(this, o), this.textArea && (this.options.allowEditing && this._layer._map ? (this._map = this._layer._map, this.enabled() && this.disable(), this.applyOptions(), this._safeToCacheDragState = !0, this._focusChange(), this.textArea.readOnly = !1, this.textArea.classList.remove("pm-disabled"), this._layer.on("remove", this.disable, this), L.DomEvent.on(this.textArea, "input", this._autoResize, this), L.DomEvent.on(this.textArea, "focus", this._focusChange, this), L.DomEvent.on(this.textArea, "blur", this._focusChange, this), this._layer.on("dblclick", L.DomEvent.stop), L.DomEvent.off(this.textArea, "mousedown", this._preventTextSelection), this._enabled = !0, this._fireEnable()) : this.disable());
    }, disable: function() {
      if (this.enabled()) {
        this._layer.off("remove", this.disable, this), L.DomEvent.off(this.textArea, "input", this._autoResize, this), L.DomEvent.off(this.textArea, "focus", this._focusChange, this), L.DomEvent.off(this.textArea, "blur", this._focusChange, this), L.DomEvent.off(document, "click", this._documentClick, this), this._focusChange(), this.textArea.readOnly = !0, this.textArea.classList.add("pm-disabled");
        var o = document.activeElement;
        this.textArea.focus(), this.textArea.selectionStart = 0, this.textArea.selectionEnd = 0, L.DomEvent.on(this.textArea, "mousedown", this._preventTextSelection), o.focus(), this._disableOnBlurActive = !1, this._layerEdited && this._fireUpdate(), this._layerEdited = !1, this._fireDisable(), this._enabled = !1;
      }
    }, enabled: function() {
      return this._enabled;
    }, toggleEdit: function(o) {
      this.enabled() ? this.disable() : this.enable(o);
    }, applyOptions: function() {
      this.options.snappable ? this._initSnappableMarkers() : this._disableSnapping();
    }, _initSnappableMarkers: function() {
      var o = this._layer;
      this.options.snapDistance = this.options.snapDistance || 30, this.options.snapSegment = this.options.snapSegment === void 0 || this.options.snapSegment, o.off("pm:drag", this._handleSnapping, this), o.on("pm:drag", this._handleSnapping, this), o.off("pm:dragend", this._cleanupSnapping, this), o.on("pm:dragend", this._cleanupSnapping, this), o.off("pm:dragstart", this._unsnap, this), o.on("pm:dragstart", this._unsnap, this);
    }, _disableSnapping: function() {
      var o = this._layer;
      o.off("pm:drag", this._handleSnapping, this), o.off("pm:dragend", this._cleanupSnapping, this), o.off("pm:dragstart", this._unsnap, this);
    }, _autoResize: function() {
      this.textArea.style.height = "1px", this.textArea.style.width = "1px";
      var o = this.textArea.scrollHeight > 21 ? this.textArea.scrollHeight : 21, c = this.textArea.scrollWidth > 16 ? this.textArea.scrollWidth : 16;
      this.textArea.style.height = "".concat(o, "px"), this.textArea.style.width = "".concat(c, "px"), this._layer.options.text = this.getText(), this._fireTextChange(this.getText());
    }, _disableOnBlur: function() {
      var o = this;
      this._disableOnBlurActive = !0, setTimeout(function() {
        o.enabled() && L.DomEvent.on(document, "click", o._documentClick, o);
      }, 100);
    }, _documentClick: function(o) {
      o.target !== this.textArea && (this.disable(), !this.getText() && this.options.removeIfEmpty && this.remove());
    }, _focusChange: function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, c = this._hasFocus;
      this._hasFocus = o.type === "focus", !c != !this._hasFocus && (this._hasFocus ? (this._applyFocus(), this._focusText = this.getText(), this._fireTextFocus()) : (this._removeFocus(), this._fireTextBlur(), this._focusText !== this.getText() && (this._fireEdit(), this._layerEdited = !0)));
    }, _applyFocus: function() {
      this.textArea.classList.add("pm-hasfocus"), this._map.dragging && (this._safeToCacheDragState && (this._originalMapDragState = this._map.dragging._enabled, this._safeToCacheDragState = !1), this._map.dragging.disable());
    }, _removeFocus: function() {
      this._map.dragging && (this._originalMapDragState && this._map.dragging.enable(), this._safeToCacheDragState = !0), this.textArea.classList.remove("pm-hasfocus");
    }, focus: function() {
      if (!this.enabled())
        throw new TypeError("Layer is not enabled");
      this.textArea.focus();
    }, blur: function() {
      if (!this.enabled())
        throw new TypeError("Layer is not enabled");
      this.textArea.blur(), this._disableOnBlurActive && this.disable();
    }, hasFocus: function() {
      return this._hasFocus;
    }, getElement: function() {
      return this.textArea;
    }, setText: function(o) {
      this.textArea.value = o, this._autoResize();
    }, getText: function() {
      return this.textArea.value;
    }, _initTextMarker: function() {
      if (this.textArea = L.PM.Draw.Text.prototype._createTextArea.call(this), this.options.className) {
        var o, c = this.options.className.split(" ");
        (o = this.textArea.classList).add.apply(o, mr(c));
      }
      var p = L.PM.Draw.Text.prototype._createTextIcon.call(this, this.textArea);
      this._layer.setIcon(p), this._layer.once("add", this._createTextMarker, this);
    }, _createTextMarker: function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 && arguments[0];
      this._layer.off("add", this._createTextMarker, this), this._layer.getElement().tabIndex = -1, this.textArea.wrap = "off", this.textArea.style.overflow = "hidden", this.textArea.style.height = L.DomUtil.getStyle(this.textArea, "font-size"), this.textArea.style.width = "1px", this._layer.options.text && this.setText(this._layer.options.text), this._autoResize(), o === !0 && (this.enable(), this.focus(), this._disableOnBlur());
    }, _preventTextSelection: function(o) {
      o.preventDefault();
    } });
    var vr = function(o, c, p, _, w, B) {
      this._matrix = [o, c, p, _, w, B];
    };
    vr.init = function() {
      return new L.PM.Matrix(1, 0, 0, 1, 0, 0);
    }, vr.prototype = { transform: function(o) {
      return this._transform(o.clone());
    }, _transform: function(o) {
      var c = this._matrix, p = o.x, _ = o.y;
      return o.x = c[0] * p + c[1] * _ + c[4], o.y = c[2] * p + c[3] * _ + c[5], o;
    }, untransform: function(o) {
      var c = this._matrix;
      return new L.Point((o.x / c[0] - c[4]) / c[0], (o.y / c[2] - c[5]) / c[2]);
    }, clone: function() {
      var o = this._matrix;
      return new L.PM.Matrix(o[0], o[1], o[2], o[3], o[4], o[5]);
    }, translate: function(o) {
      return o === void 0 ? new L.Point(this._matrix[4], this._matrix[5]) : (typeof o == "number" ? (c = o, p = o) : (c = o.x, p = o.y), this._add(1, 0, 0, 1, c, p));
      var c, p;
    }, scale: function(o, c) {
      return o === void 0 ? new L.Point(this._matrix[0], this._matrix[3]) : (c = c || L.point(0, 0), typeof o == "number" ? (p = o, _ = o) : (p = o.x, _ = o.y), this._add(p, 0, 0, _, c.x, c.y)._add(1, 0, 0, 1, -c.x, -c.y));
      var p, _;
    }, rotate: function(o, c) {
      var p = Math.cos(o), _ = Math.sin(o);
      return c = c || new L.Point(0, 0), this._add(p, _, -_, p, c.x, c.y)._add(1, 0, 0, 1, -c.x, -c.y);
    }, flip: function() {
      return this._matrix[1] *= -1, this._matrix[2] *= -1, this;
    }, _add: function(o, c, p, _, w, B) {
      var F, Z = [[], [], []], V = this._matrix, K = [[V[0], V[2], V[4]], [V[1], V[3], V[5]], [0, 0, 1]], oe = [[o, p, w], [c, _, B], [0, 0, 1]];
      o && o instanceof L.PM.Matrix && (oe = [[(V = o._matrix)[0], V[2], V[4]], [V[1], V[3], V[5]], [0, 0, 1]]);
      for (var _e = 0; _e < 3; _e += 1)
        for (var fe = 0; fe < 3; fe += 1) {
          F = 0;
          for (var Me = 0; Me < 3; Me += 1)
            F += K[_e][Me] * oe[Me][fe];
          Z[_e][fe] = F;
        }
      return this._matrix = [Z[0][0], Z[1][0], Z[0][1], Z[1][1], Z[0][2], Z[1][2]], this;
    } };
    const Zr = vr;
    var Ra = { calcMiddleLatLng: function(o, c, p) {
      var _ = o.project(c), w = o.project(p);
      return o.unproject(_._add(w)._divideBy(2));
    }, findLayers: function(o) {
      var c = [];
      return o.eachLayer(function(p) {
        (p instanceof L.Polyline || p instanceof L.Marker || p instanceof L.Circle || p instanceof L.CircleMarker || p instanceof L.ImageOverlay) && c.push(p);
      }), c = (c = (c = c.filter(function(p) {
        return !!p.pm;
      })).filter(function(p) {
        return !p._pmTempLayer;
      })).filter(function(p) {
        return !L.PM.optIn && !p.options.pmIgnore || L.PM.optIn && p.options.pmIgnore === !1;
      });
    }, circleToPolygon: function(o) {
      for (var c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 60, p = !(arguments.length > 2 && arguments[2] !== void 0) || arguments[2], _ = o.getLatLng(), w = o.getRadius(), B = Pe(_, w, c, 0, p), F = [], Z = 0; Z < B.length; Z += 1) {
        var V = [B[Z].lat, B[Z].lng];
        F.push(V);
      }
      return L.polygon(F, o.options);
    }, disablePopup: function(o) {
      o.getPopup() && (o._tempPopupCopy = o.getPopup(), o.unbindPopup());
    }, enablePopup: function(o) {
      o._tempPopupCopy && (o.bindPopup(o._tempPopupCopy), delete o._tempPopupCopy);
    }, _fireEvent: function(o, c, p) {
      var _ = arguments.length > 3 && arguments[3] !== void 0 && arguments[3];
      o.fire(c, p, _);
      var w = this.getAllParentGroups(o), B = w.groups;
      B.forEach(function(F) {
        F.fire(c, p, _);
      });
    }, getAllParentGroups: function(o) {
      var c = [], p = [];
      return !o._pmLastGroupFetch || !o._pmLastGroupFetch.time || (/* @__PURE__ */ new Date()).getTime() - o._pmLastGroupFetch.time > 1e3 ? (function _(w) {
        for (var B in w._eventParents)
          if (c.indexOf(B) === -1) {
            c.push(B);
            var F = w._eventParents[B];
            p.push(F), _(F);
          }
      }(o), o._pmLastGroupFetch = { time: (/* @__PURE__ */ new Date()).getTime(), groups: p, groupIds: c }, { groupIds: c, groups: p }) : { groups: o._pmLastGroupFetch.groups, groupIds: o._pmLastGroupFetch.groupIds };
    }, createGeodesicPolygon: Pe, getTranslation: pe, findDeepCoordIndex: function(o, c) {
      var p, _ = !(arguments.length > 2 && arguments[2] !== void 0) || arguments[2], w = function F(Z) {
        return function(V, K) {
          var oe = Z.concat(K);
          if (_) {
            if (V.lat && V.lat === c.lat && V.lng === c.lng)
              return p = oe, !0;
          } else if (V.lat && L.latLng(V).equals(c))
            return p = oe, !0;
          return Array.isArray(V) && V.some(F(oe));
        };
      };
      o.some(w([]));
      var B = {};
      return p && (B = { indexPath: p, index: p[p.length - 1], parentPath: p.slice(0, p.length - 1) }), B;
    }, findDeepMarkerIndex: function(o, c) {
      var p;
      o.some(/* @__PURE__ */ function w(B) {
        return function(F, Z) {
          var V = B.concat(Z);
          return F._leaflet_id === c._leaflet_id ? (p = V, !0) : Array.isArray(F) && F.some(w(V));
        };
      }([]));
      var _ = {};
      return p && (_ = { indexPath: p, index: p[p.length - 1], parentPath: p.slice(0, p.length - 1) }), _;
    }, _getIndexFromSegment: function(o, c) {
      if (c && c.length === 2) {
        var p = this.findDeepCoordIndex(o, c[0]), _ = this.findDeepCoordIndex(o, c[1]), w = Math.max(p.index, _.index);
        return p.index !== 0 && _.index !== 0 || w === 1 || (w += 1), { indexA: p, indexB: _, newIndex: w, indexPath: p.indexPath, parentPath: p.parentPath };
      }
      return null;
    }, _getRotatedRectangle: function(o, c, p, _) {
      var w = Zn(_, o), B = Zn(_, c), F = p * Math.PI / 180, Z = Math.cos(F), V = Math.sin(F), K = (B.x - w.x) * Z + (B.y - w.y) * V, oe = (B.y - w.y) * Z - (B.x - w.x) * V, _e = K * Z + w.x, fe = K * V + w.y, Me = -oe * V + w.x, Ie = oe * Z + w.y;
      return [dn(_, w), dn(_, { x: _e, y: fe }), dn(_, B), dn(_, { x: Me, y: Ie })];
    }, pxRadiusToMeterRadius: function(o, c, p) {
      var _ = c.project(p), w = L.point(_.x + o, _.y);
      return c.distance(c.unproject(w), p);
    } };
    const Ba = Ra;
    L.PM = L.PM || { version: "2.15.0", Map: Wt, Toolbar: bn, Draw: E, Edit: Ft, Utils: Ba, Matrix: Zr, activeLang: "en", optIn: !1, initialize: function(o) {
      this.addInitHooks(o);
    }, setOptIn: function(o) {
      this.optIn = !!o;
    }, addInitHooks: function() {
      L.Map.addInitHook(function() {
        this.pm = void 0, L.PM.optIn ? this.options.pmIgnore === !1 && (this.pm = new L.PM.Map(this)) : this.options.pmIgnore || (this.pm = new L.PM.Map(this)), this.pm && this.pm.setGlobalOptions({});
      }), L.LayerGroup.addInitHook(function() {
        this.pm = void 0, L.PM.optIn ? this.options.pmIgnore === !1 && (this.pm = new L.PM.Edit.LayerGroup(this)) : this.options.pmIgnore || (this.pm = new L.PM.Edit.LayerGroup(this));
      }), L.Marker.addInitHook(function() {
        this.pm = void 0, L.PM.optIn ? this.options.pmIgnore === !1 && (this.options.textMarker ? (this.pm = new L.PM.Edit.Text(this), this.options._textMarkerOverPM || this.pm._initTextMarker(), delete this.options._textMarkerOverPM) : this.pm = new L.PM.Edit.Marker(this)) : this.options.pmIgnore || (this.options.textMarker ? (this.pm = new L.PM.Edit.Text(this), this.options._textMarkerOverPM || this.pm._initTextMarker(), delete this.options._textMarkerOverPM) : this.pm = new L.PM.Edit.Marker(this));
      }), L.CircleMarker.addInitHook(function() {
        this.pm = void 0, L.PM.optIn ? this.options.pmIgnore === !1 && (this.pm = new L.PM.Edit.CircleMarker(this)) : this.options.pmIgnore || (this.pm = new L.PM.Edit.CircleMarker(this));
      }), L.Polyline.addInitHook(function() {
        this.pm = void 0, L.PM.optIn ? this.options.pmIgnore === !1 && (this.pm = new L.PM.Edit.Line(this)) : this.options.pmIgnore || (this.pm = new L.PM.Edit.Line(this));
      }), L.Polygon.addInitHook(function() {
        this.pm = void 0, L.PM.optIn ? this.options.pmIgnore === !1 && (this.pm = new L.PM.Edit.Polygon(this)) : this.options.pmIgnore || (this.pm = new L.PM.Edit.Polygon(this));
      }), L.Rectangle.addInitHook(function() {
        this.pm = void 0, L.PM.optIn ? this.options.pmIgnore === !1 && (this.pm = new L.PM.Edit.Rectangle(this)) : this.options.pmIgnore || (this.pm = new L.PM.Edit.Rectangle(this));
      }), L.Circle.addInitHook(function() {
        this.pm = void 0, L.PM.optIn ? this.options.pmIgnore === !1 && (this.pm = new L.PM.Edit.Circle(this)) : this.options.pmIgnore || (this.pm = new L.PM.Edit.Circle(this));
      }), L.ImageOverlay.addInitHook(function() {
        this.pm = void 0, L.PM.optIn ? this.options.pmIgnore === !1 && (this.pm = new L.PM.Edit.ImageOverlay(this)) : this.options.pmIgnore || (this.pm = new L.PM.Edit.ImageOverlay(this));
      });
    }, reInitLayer: function(o) {
      var c = this;
      o instanceof L.LayerGroup && o.eachLayer(function(p) {
        c.reInitLayer(p);
      }), o.pm || L.PM.optIn && o.options.pmIgnore !== !1 || o.options.pmIgnore || (o instanceof L.Map ? o.pm = new L.PM.Map(o) : o instanceof L.Marker ? o.options.textMarker ? (o.pm = new L.PM.Edit.Text(o), o.pm._initTextMarker(), o.pm._createTextMarker(!1)) : o.pm = new L.PM.Edit.Marker(o) : o instanceof L.Circle ? o.pm = new L.PM.Edit.Circle(o) : o instanceof L.CircleMarker ? o.pm = new L.PM.Edit.CircleMarker(o) : o instanceof L.Rectangle ? o.pm = new L.PM.Edit.Rectangle(o) : o instanceof L.Polygon ? o.pm = new L.PM.Edit.Polygon(o) : o instanceof L.Polyline ? o.pm = new L.PM.Edit.Line(o) : o instanceof L.LayerGroup ? o.pm = new L.PM.Edit.LayerGroup(o) : o instanceof L.ImageOverlay && (o.pm = new L.PM.Edit.ImageOverlay(o)));
    } }, L.version === "1.7.1" && L.Canvas.include({ _onClick: function(o) {
      for (var c, p, _ = this._map.mouseEventToLayerPoint(o), w = this._drawFirst; w; w = w.next)
        (c = w.layer).options.interactive && c._containsPoint(_) && (o.type !== "click" && o.type !== "preclick" || !this._map._draggableMoved(c)) && (p = c);
      p && (L.DomEvent.fakeStop(o), this._fireEvent([p], o));
    } }), L.PM.initialize();
  })();
})();
function sy(e) {
  return e === void 0 ? void 0 : JSON.parse(JSON.stringify(e));
}
function ly(e) {
  return typeof e == "number" ? e : e ? parseFloat(e.toString()) : !1;
}
function uy(e, t = 2) {
  if (e = ly(e), typeof e == "boolean")
    return !1;
  if (e === 0)
    return { size: 0, unit: "Bytes" };
  const n = 1024, r = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"], a = Math.floor(Math.log(e) / Math.log(n));
  return { size: parseFloat((e / Math.pow(n, a)).toFixed(t)), unit: r[a] };
}
function eh(e) {
  const t = e.split(" ");
  if (t.length < 2)
    return parseInt(e);
  const n = t[1], r = parseInt(t[0]), a = 1024, u = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"].findIndex((h) => h.toLowerCase() === n.toLowerCase());
  return r * Math.pow(a, u);
}
const cy = (e) => (mu("data-v-5988a3d6"), e = e(), gu(), e), hy = { class: "result-map__container" }, dy = /* @__PURE__ */ cy(() => /* @__PURE__ */ xe("div", {
  id: "map-container",
  class: "voyager-map-container",
  style: { height: "100%" },
  "data-ts": "map-container"
}, null, -1)), fy = /* @__PURE__ */ tt({
  __name: "VoyagerMap",
  props: {
    results: {
      type: Array,
      required: !1,
      default: () => []
    },
    context: {
      type: String,
      required: !1,
      default: "search"
    },
    baseLayers: {
      type: Array,
      required: !1,
      default: () => []
    },
    overlays: {
      type: Array,
      required: !1,
      default: () => []
    },
    mapOptions: {
      type: Object,
      required: !1,
      default: () => ({
        defaultExtent: [46.05, 11.05],
        defaultZoomLevel: 5,
        drawStrokeColor: "#fa6603",
        drawFillColor: "lightblue",
        drawFillOpacity: 0
      })
    },
    cartListIds: {
      type: Array,
      required: !1,
      default: () => []
    }
  },
  emits: ["drawEvent", "geomClick", "ready", "hoverStart", "hoverEnd", "userAction"],
  setup(e, { expose: t, emit: n }) {
    const r = je(null), a = /* @__PURE__ */ new Map(), l = /* @__PURE__ */ new Map(), u = je({ visible: !1, result: void 0, popup: void 0 });
    let h, f;
    const m = e, v = (re, Q) => {
      var ke;
      return (ke = r.value) == null ? void 0 : ke.setView(re, Q);
    }, y = (re, Q) => {
      re && (re.label = Q), r.value && (re == null || re.addTo(tn(r.value)));
    }, k = (re) => {
      ae(re), l.delete(re._leaflet_id);
    }, x = (re) => {
      l.forEach((Q) => {
        Q._leaflet_id !== re._leaflet_id && k(Q);
      });
    }, M = (re) => {
      x(re), l.set(re._leaflet_id, re), y(re);
    }, O = te(() => u.value.result ? m.cartListIds.includes(u.value.result.id) : !1), R = n, C = () => {
      var re, Q, ke, Ae;
      (re = r.value) == null || re.on(
        "pm:drawend layeradd pm:globaleditmodetoggled pm:globaldragmodetoggled pm:globaldrawmodetoggled layerremove pm:remove",
        () => {
        }
      ), (Q = r.value) == null || Q.on("pm:drawstart", ({ workingLayer: pe }) => {
        pe.on("pm:vertexadded pm:snapdrag pm:snap pm:unsnap pm:centerplaced", () => {
        }), x(pe);
      }), (ke = r.value) == null || ke.on("pm:create", ({ shape: pe, layer: Ye }) => {
        Ye.on("pm:remove", () => {
        }), l.set(Ye._leaflet_id, Ye), R("drawEvent", { shape: pe, layer: Ye });
      }), (Ae = r.value) == null || Ae.on("popupclose", () => {
        u.value.visible = !1;
      });
    };
    je([]);
    const T = () => {
      var Q, ke, Ae, pe;
      const re = new qn.LayerGroup();
      y(re), (Q = r.value) == null || Q.pm.setGlobalOptions({ layerGroup: re }), (ke = r.value) == null || ke.pm.Toolbar.setBlockPosition("draw", "topright"), (Ae = r.value) == null || Ae.pm.setPathOptions({
        color: m.mapOptions.drawStrokeColor,
        fillColor: m.mapOptions.drawFillColor,
        fillOpacity: m.mapOptions.drawFillOpacity
      }), (pe = r.value) == null || pe.pm.addControls({
        drawMarker: !1,
        drawPolygon: !0,
        editMode: !1,
        drawPolyline: !1,
        removalMode: !1,
        cutPolygon: !1,
        dragMode: !1,
        rotateMode: !1,
        drawText: !1,
        oneBlock: !0,
        drawCircle: !0,
        drawCircleMarker: !1
      });
    }, A = () => {
      m.baseLayers.forEach((re) => {
        y(re), re && h.addBaseLayer(re, re.name);
      });
    }, P = () => {
      m.overlays.forEach((re) => {
        y(re), re && h.addOverlay(re, re.name);
      });
    }, D = () => {
      h = qn.control.layers({}, {}, { position: "bottomright" }), r.value && h.addTo(tn(r.value));
    }, $ = () => {
      document.getElementById("map-container") !== null && (r.value = qn.map("map-container"), r.value.whenReady(() => R("ready")), v(m.mapOptions.defaultExtent, m.mapOptions.defaultZoomLevel), D(), A(), P(), T(), C());
    }, Y = ({ result: re, latlng: Q }) => {
      u.value.visible = !1, nn().then(() => {
        var ke;
        u.value.result = re, u.value.popup || (u.value.popup = qn.popup({ className: "map-card-popup", closeButton: !1 }).setContent('<div id="mapcard" style="width:14rem; height: 18rem;"></div>')), u.value.popup.setLatLng(Q), (ke = r.value) == null || ke.openPopup(u.value.popup), nn(), u.value.visible = !0;
      });
    }, G = (re) => {
      R("userAction", { action: re.action, result: re.result });
    }, ee = (re) => {
      let Q, ke, Ae;
      if (re)
        return Array.isArray(re) && (re = re[0]), re.field.includes("geojson") && (Q = qn.geoJSON(re.value)), re.field.includes("bbox") && (ke = re.value), Array.isArray(ke) || (Ae = re.value.split(" "), ke = [[Ae[1], Ae[0]], [Ae[3], Ae[2]]]), Q = new qn.Rectangle(ke), re.field.includes("point") && (Q = new qn.Marker(re.value)), re.field.includes("polygon") && (Q = new qn.Polygon(re.value)), re.field.includes("polyline") && (Q = new qn.Polyline(re.value)), Q && !re.field.includes("point") && (Q == null || Q.setStyle({ fill: !1 })), Q;
    }, X = (re) => {
      re.forEach((Q) => {
        if (re !== void 0) {
          const ke = sy(aa({ displayKey: m.context + "Map", result: Q })), Ae = ee(ke);
          Ae && (Ae.addEventListener("mouseover", () => R("hoverStart", Q)), Ae.addEventListener("mouseout", () => R("hoverEnd", Q)), Ae.addEventListener("click", () => {
            Y({ result: Q, latlng: qn.latLng([Ae.getBounds().getNorth(), Ae.getBounds().getCenter().lng]) });
          }), y(Ae), a.set(Q.id, Ae));
        }
      });
    }, ae = (re) => {
      r.value && re && re.removeFrom(r.value);
    }, ne = (re) => {
      re.forEach((Q) => {
        ae(a.get(Q)), a.delete(Q);
      });
    }, se = new ResizeObserver(() => {
      var re;
      (re = r.value) == null || re.invalidateSize();
    });
    return In(() => {
      $(), kt(() => m.results, (re) => {
        const Q = [...a.keys()];
        let ke = Q.filter((pe) => !re.map((Ye) => Ye.id).includes(pe)), Ae = re.filter((pe) => !Q.includes(pe.id));
        X(Ae), ne(ke);
      }, {
        immediate: !0,
        deep: !0
      }), kt(() => m.baseLayers.map((re) => re.name), () => {
        A();
      }, { deep: !0, immediate: !0 }), kt(() => m.overlays, () => {
        P();
      }, { deep: !0, immediate: !0 }), f = document.querySelector(".result-map__container"), f && se.observe(f);
    }), Dv(
      () => {
        var re;
        (re = r.value) == null || re.remove(), f && se.unobserve(f);
      }
    ), t({ voyagerMap: r, L: qn, setMapView: v, setDrawing: M }), (re, Q) => (we(), Te("div", hy, [
      dy,
      u.value.visible ? (we(), Ut(Iv, {
        key: 0,
        to: "#mapcard",
        disabled: !u.value.visible
      }, [
        (we(), Ut(ao(zf), {
          onUserAction: G,
          result: u.value.result,
          isInCart: O.value
        }, null, 40, ["result", "isInCart"]))
      ], 8, ["disabled"])) : vt("", !0)
    ]));
  }
}), G$ = /* @__PURE__ */ ur(fy, [["__scopeId", "data-v-5988a3d6"]]), py = { class: "details-table" }, my = { class: "row-header" }, gy = { "data-ts": "field-header" }, vy = { "data-ts": "field-value" }, _y = { class: "row-actions" }, yy = ["onClick"], by = ["onClick"], q$ = /* @__PURE__ */ tt({
  __name: "VoyagerDetailsTable",
  props: {
    loading: {
      type: Boolean,
      required: !1,
      default: !1
    },
    headers: {
      type: Array,
      required: !1,
      default: () => []
    },
    result: {
      type: Object,
      required: !1
    }
  },
  emits: ["userAction", "navigation", "query:add"],
  setup(e, { emit: t }) {
    const n = e, r = Ir({}), a = (m) => {
      var v, y;
      return ((v = r[m]) == null ? void 0 : v.valueDisplay) || ((y = r[m]) == null ? void 0 : y.value) || "";
    }, l = (m) => navigator.clipboard.writeText(m), u = (m) => f("query:add", {
      action: "addQuery",
      field: r[m]
    }), h = () => {
      n.result && n.headers.forEach((m) => {
        var y;
        let v = (y = n.result) == null ? void 0 : y.fields[m.field];
        Array.isArray(v) && (v = v[0]), Object.assign(r, { [m.field]: v });
      });
    }, f = t;
    return kt(() => n.result, () => h(), { immediate: !0, deep: !0 }), (m, v) => (we(), Te("div", py, [
      (we(!0), Te(Et, null, rn(e.headers, (y) => (we(), Te("div", {
        key: y.field,
        class: "details-table__row",
        "data-ts": "table-row"
      }, [
        a(y.field) ? (we(), Te(Et, { key: 0 }, [
          xe("div", my, [
            xe("label", gy, _t(y.fieldDisplay), 1)
          ]),
          ce(he(ku), { class: "row-value" }, {
            content: Je(() => [
              xe("div", _y, [
                xe("button", {
                  onClick: (k) => u(y.field),
                  "data-ts": "action-addQuery"
                }, [
                  ce(he(Nf)),
                  Se(" Add to Query ")
                ], 8, yy),
                xe("button", {
                  onClick: (k) => l(a(y.field).toString()),
                  "data-ts": "action-copyValue"
                }, [
                  ce(he(I_)),
                  Se(" Copy Value ")
                ], 8, by)
              ])
            ]),
            default: Je(() => [
              xe("label", vy, _t(a(y.field)), 1)
            ]),
            _: 2
          }, 1024)
        ], 64)) : vt("", !0)
      ]))), 128))
    ]));
  }
}), wy = { class: "select-filter__container" }, ky = ["onClick", "title"], xy = ["checked", "id"], Ly = ["for"], My = { class: "select-filter__value-display" }, Sy = { class: "select-filter__value-count" }, Py = {
  key: 0,
  class: "select-filter__show-all"
}, K$ = /* @__PURE__ */ tt({
  __name: "SelectFilter",
  props: /* @__PURE__ */ Ci({
    showUpTo: {
      type: Number,
      required: !1,
      default: -1
    },
    totalOptions: {
      type: Number,
      required: !1,
      default: -1
    }
  }, {
    filter: {
      default: {
        type: "multi",
        name: "",
        nameDisplay: "",
        availableValues: []
      }
    },
    filterModifiers: {}
  }),
  emits: /* @__PURE__ */ Ci(["userUpdatedFilter", "showAllFacets"], ["update:filter"]),
  setup(e, { emit: t }) {
    const n = or(e, "filter"), r = t, a = () => r("showAllFacets", n.value.name), l = (u) => {
      n.value.availableValues[u].selected = !n.value.availableValues[u].selected, n.value.availableValues[u].selected || (n.value.availableValues[u].negate = !1), r("userUpdatedFilter", n.value);
    };
    return (u, h) => (we(), Te("div", wy, [
      (we(!0), Te(Et, null, rn(n.value.availableValues, (f, m) => {
        var v, y, k;
        return we(), Te("div", {
          key: m,
          class: "select-filter__value",
          "data-ts": "filter-value"
        }, [
          e.showUpTo === -1 || m < e.showUpTo ? (we(), Te("span", {
            key: 0,
            onClick: (x) => l(m),
            class: gt([f.negate ? "negate" : "selected"]),
            title: `${f.valueDisplay} (${(v = f.count) == null ? void 0 : v.toLocaleString()})`,
            "data-ts": "filter-value-display"
          }, [
            ((y = n.value) == null ? void 0 : y.type) === "multi" ? (we(), Te("input", {
              key: 0,
              type: "checkbox",
              onClick: h[0] || (h[0] = ws(() => {
              }, ["prevent", "self"])),
              checked: f.selected,
              id: f.value
            }, null, 8, xy)) : vt("", !0),
            xe("label", {
              onClick: h[1] || (h[1] = ws(() => {
              }, ["prevent", "self"])),
              for: f.value,
              "data-ts": "filter-checkbox"
            }, null, 8, Ly),
            xe("span", My, [
              xe("label", null, _t(f.valueDisplay), 1)
            ]),
            xe("span", Sy, " (" + _t((k = f.count) == null ? void 0 : k.toLocaleString()) + ") ", 1)
          ], 10, ky)) : vt("", !0)
        ]);
      }), 128)),
      Xt(u.$slots, "default", {}, () => [
        e.totalOptions > e.showUpTo ? (we(), Te("span", Py, [
          xe("button", { onClick: a }, "Show All")
        ])) : vt("", !0)
      ])
    ]));
  }
});
var tr;
(function(e) {
  e.Range = "range", e.Steps = "steps", e.Positions = "positions", e.Count = "count", e.Values = "values";
})(tr || (tr = {}));
var xn;
(function(e) {
  e[e.None = -1] = "None", e[e.NoValue = 0] = "NoValue", e[e.LargeValue = 1] = "LargeValue", e[e.SmallValue = 2] = "SmallValue";
})(xn || (xn = {}));
function Cy(e) {
  return Cs(e) && typeof e.from == "function";
}
function Cs(e) {
  return typeof e == "object" && typeof e.to == "function";
}
function th(e) {
  e.parentElement.removeChild(e);
}
function Zl(e) {
  return e != null;
}
function nh(e) {
  e.preventDefault();
}
function Oy(e) {
  return e.filter(function(t) {
    return this[t] ? !1 : this[t] = !0;
  }, {});
}
function Ey(e, t) {
  return Math.round(e / t) * t;
}
function Ty(e, t) {
  var n = e.getBoundingClientRect(), r = e.ownerDocument, a = r.documentElement, l = jf(r);
  return /webkit.*Chrome.*Mobile/i.test(navigator.userAgent) && (l.x = 0), t ? n.top + l.y - a.clientTop : n.left + l.x - a.clientLeft;
}
function Qn(e) {
  return typeof e == "number" && !isNaN(e) && isFinite(e);
}
function ih(e, t, n) {
  n > 0 && (gn(e, t), setTimeout(function() {
    hs(e, t);
  }, n));
}
function rh(e) {
  return Math.max(Math.min(e, 100), 0);
}
function Ks(e) {
  return Array.isArray(e) ? e : [e];
}
function Dy(e) {
  e = String(e);
  var t = e.split(".");
  return t.length > 1 ? t[1].length : 0;
}
function gn(e, t) {
  e.classList && !/\s/.test(t) ? e.classList.add(t) : e.className += " " + t;
}
function hs(e, t) {
  e.classList && !/\s/.test(t) ? e.classList.remove(t) : e.className = e.className.replace(new RegExp("(^|\\b)" + t.split(" ").join("|") + "(\\b|$)", "gi"), " ");
}
function Iy(e, t) {
  return e.classList ? e.classList.contains(t) : new RegExp("\\b" + t + "\\b").test(e.className);
}
function jf(e) {
  var t = window.pageXOffset !== void 0, n = (e.compatMode || "") === "CSS1Compat", r = t ? window.pageXOffset : n ? e.documentElement.scrollLeft : e.body.scrollLeft, a = t ? window.pageYOffset : n ? e.documentElement.scrollTop : e.body.scrollTop;
  return {
    x: r,
    y: a
  };
}
function Ay() {
  return window.navigator.pointerEnabled ? {
    start: "pointerdown",
    move: "pointermove",
    end: "pointerup"
  } : window.navigator.msPointerEnabled ? {
    start: "MSPointerDown",
    move: "MSPointerMove",
    end: "MSPointerUp"
  } : {
    start: "mousedown touchstart",
    move: "mousemove touchmove",
    end: "mouseup touchend"
  };
}
function Ry() {
  var e = !1;
  try {
    var t = Object.defineProperty({}, "passive", {
      get: function() {
        e = !0;
      }
    });
    window.addEventListener("test", null, t);
  } catch {
  }
  return e;
}
function By() {
  return window.CSS && CSS.supports && CSS.supports("touch-action", "none");
}
function xu(e, t) {
  return 100 / (t - e);
}
function Wl(e, t, n) {
  return t * 100 / (e[n + 1] - e[n]);
}
function $y(e, t) {
  return Wl(e, e[0] < 0 ? t + Math.abs(e[0]) : t - e[0], 0);
}
function Ny(e, t) {
  return t * (e[1] - e[0]) / 100 + e[0];
}
function lo(e, t) {
  for (var n = 1; e >= t[n]; )
    n += 1;
  return n;
}
function zy(e, t, n) {
  if (n >= e.slice(-1)[0])
    return 100;
  var r = lo(n, e), a = e[r - 1], l = e[r], u = t[r - 1], h = t[r];
  return u + $y([a, l], n) / xu(u, h);
}
function Fy(e, t, n) {
  if (n >= 100)
    return e.slice(-1)[0];
  var r = lo(n, t), a = e[r - 1], l = e[r], u = t[r - 1], h = t[r];
  return Ny([a, l], (n - u) * xu(u, h));
}
function jy(e, t, n, r) {
  if (r === 100)
    return r;
  var a = lo(r, e), l = e[a - 1], u = e[a];
  return n ? r - l > (u - l) / 2 ? u : l : t[a - 1] ? e[a - 1] + Ey(r - e[a - 1], t[a - 1]) : r;
}
var Vf = (
  /** @class */
  function() {
    function e(t, n, r) {
      this.xPct = [], this.xVal = [], this.xSteps = [], this.xNumSteps = [], this.xHighestCompleteStep = [], this.xSteps = [r || !1], this.xNumSteps = [!1], this.snap = n;
      var a, l = [];
      for (Object.keys(t).forEach(function(u) {
        l.push([Ks(t[u]), u]);
      }), l.sort(function(u, h) {
        return u[0][0] - h[0][0];
      }), a = 0; a < l.length; a++)
        this.handleEntryPoint(l[a][1], l[a][0]);
      for (this.xNumSteps = this.xSteps.slice(0), a = 0; a < this.xNumSteps.length; a++)
        this.handleStepPoint(a, this.xNumSteps[a]);
    }
    return e.prototype.getDistance = function(t) {
      for (var n = [], r = 0; r < this.xNumSteps.length - 1; r++)
        n[r] = Wl(this.xVal, t, r);
      return n;
    }, e.prototype.getAbsoluteDistance = function(t, n, r) {
      var a = 0;
      if (t < this.xPct[this.xPct.length - 1])
        for (; t > this.xPct[a + 1]; )
          a++;
      else
        t === this.xPct[this.xPct.length - 1] && (a = this.xPct.length - 2);
      !r && t === this.xPct[a + 1] && a++, n === null && (n = []);
      var l, u = 1, h = n[a], f = 0, m = 0, v = 0, y = 0;
      for (r ? l = (t - this.xPct[a]) / (this.xPct[a + 1] - this.xPct[a]) : l = (this.xPct[a + 1] - t) / (this.xPct[a + 1] - this.xPct[a]); h > 0; )
        f = this.xPct[a + 1 + y] - this.xPct[a + y], n[a + y] * u + 100 - l * 100 > 100 ? (m = f * l, u = (h - 100 * l) / n[a + y], l = 1) : (m = n[a + y] * f / 100 * u, u = 0), r ? (v = v - m, this.xPct.length + y >= 1 && y--) : (v = v + m, this.xPct.length - y >= 1 && y++), h = n[a + y] * u;
      return t + v;
    }, e.prototype.toStepping = function(t) {
      return t = zy(this.xVal, this.xPct, t), t;
    }, e.prototype.fromStepping = function(t) {
      return Fy(this.xVal, this.xPct, t);
    }, e.prototype.getStep = function(t) {
      return t = jy(this.xPct, this.xSteps, this.snap, t), t;
    }, e.prototype.getDefaultStep = function(t, n, r) {
      var a = lo(t, this.xPct);
      return (t === 100 || n && t === this.xPct[a - 1]) && (a = Math.max(a - 1, 1)), (this.xVal[a] - this.xVal[a - 1]) / r;
    }, e.prototype.getNearbySteps = function(t) {
      var n = lo(t, this.xPct);
      return {
        stepBefore: {
          startValue: this.xVal[n - 2],
          step: this.xNumSteps[n - 2],
          highestStep: this.xHighestCompleteStep[n - 2]
        },
        thisStep: {
          startValue: this.xVal[n - 1],
          step: this.xNumSteps[n - 1],
          highestStep: this.xHighestCompleteStep[n - 1]
        },
        stepAfter: {
          startValue: this.xVal[n],
          step: this.xNumSteps[n],
          highestStep: this.xHighestCompleteStep[n]
        }
      };
    }, e.prototype.countStepDecimals = function() {
      var t = this.xNumSteps.map(Dy);
      return Math.max.apply(null, t);
    }, e.prototype.hasNoSize = function() {
      return this.xVal[0] === this.xVal[this.xVal.length - 1];
    }, e.prototype.convert = function(t) {
      return this.getStep(this.toStepping(t));
    }, e.prototype.handleEntryPoint = function(t, n) {
      var r;
      if (t === "min" ? r = 0 : t === "max" ? r = 100 : r = parseFloat(t), !Qn(r) || !Qn(n[0]))
        throw new Error("noUiSlider: 'range' value isn't numeric.");
      this.xPct.push(r), this.xVal.push(n[0]);
      var a = Number(n[1]);
      r ? this.xSteps.push(isNaN(a) ? !1 : a) : isNaN(a) || (this.xSteps[0] = a), this.xHighestCompleteStep.push(0);
    }, e.prototype.handleStepPoint = function(t, n) {
      if (n) {
        if (this.xVal[t] === this.xVal[t + 1]) {
          this.xSteps[t] = this.xHighestCompleteStep[t] = this.xVal[t];
          return;
        }
        this.xSteps[t] = Wl([this.xVal[t], this.xVal[t + 1]], n, 0) / xu(this.xPct[t], this.xPct[t + 1]);
        var r = (this.xVal[t + 1] - this.xVal[t]) / this.xNumSteps[t], a = Math.ceil(Number(r.toFixed(3)) - 1), l = this.xVal[t] + this.xNumSteps[t] * a;
        this.xHighestCompleteStep[t] = l;
      }
    }, e;
  }()
), ah = {
  to: function(e) {
    return e === void 0 ? "" : e.toFixed(2);
  },
  from: Number
}, Yf = {
  target: "target",
  base: "base",
  origin: "origin",
  handle: "handle",
  handleLower: "handle-lower",
  handleUpper: "handle-upper",
  touchArea: "touch-area",
  horizontal: "horizontal",
  vertical: "vertical",
  background: "background",
  connect: "connect",
  connects: "connects",
  ltr: "ltr",
  rtl: "rtl",
  textDirectionLtr: "txt-dir-ltr",
  textDirectionRtl: "txt-dir-rtl",
  draggable: "draggable",
  drag: "state-drag",
  tap: "state-tap",
  active: "active",
  tooltip: "tooltip",
  pips: "pips",
  pipsHorizontal: "pips-horizontal",
  pipsVertical: "pips-vertical",
  marker: "marker",
  markerHorizontal: "marker-horizontal",
  markerVertical: "marker-vertical",
  markerNormal: "marker-normal",
  markerLarge: "marker-large",
  markerSub: "marker-sub",
  value: "value",
  valueHorizontal: "value-horizontal",
  valueVertical: "value-vertical",
  valueNormal: "value-normal",
  valueLarge: "value-large",
  valueSub: "value-sub"
}, Ki = {
  tooltips: ".__tooltips",
  aria: ".__aria"
};
function Vy(e, t) {
  if (!Qn(t))
    throw new Error("noUiSlider: 'step' is not numeric.");
  e.singleStep = t;
}
function Yy(e, t) {
  if (!Qn(t))
    throw new Error("noUiSlider: 'keyboardPageMultiplier' is not numeric.");
  e.keyboardPageMultiplier = t;
}
function Hy(e, t) {
  if (!Qn(t))
    throw new Error("noUiSlider: 'keyboardMultiplier' is not numeric.");
  e.keyboardMultiplier = t;
}
function Uy(e, t) {
  if (!Qn(t))
    throw new Error("noUiSlider: 'keyboardDefaultStep' is not numeric.");
  e.keyboardDefaultStep = t;
}
function Zy(e, t) {
  if (typeof t != "object" || Array.isArray(t))
    throw new Error("noUiSlider: 'range' is not an object.");
  if (t.min === void 0 || t.max === void 0)
    throw new Error("noUiSlider: Missing 'min' or 'max' in 'range'.");
  e.spectrum = new Vf(t, e.snap || !1, e.singleStep);
}
function Wy(e, t) {
  if (t = Ks(t), !Array.isArray(t) || !t.length)
    throw new Error("noUiSlider: 'start' option is incorrect.");
  e.handles = t.length, e.start = t;
}
function Gy(e, t) {
  if (typeof t != "boolean")
    throw new Error("noUiSlider: 'snap' option must be a boolean.");
  e.snap = t;
}
function qy(e, t) {
  if (typeof t != "boolean")
    throw new Error("noUiSlider: 'animate' option must be a boolean.");
  e.animate = t;
}
function Ky(e, t) {
  if (typeof t != "number")
    throw new Error("noUiSlider: 'animationDuration' option must be a number.");
  e.animationDuration = t;
}
function Jy(e, t) {
  var n = [!1], r;
  if (t === "lower" ? t = [!0, !1] : t === "upper" && (t = [!1, !0]), t === !0 || t === !1) {
    for (r = 1; r < e.handles; r++)
      n.push(t);
    n.push(!1);
  } else {
    if (!Array.isArray(t) || !t.length || t.length !== e.handles + 1)
      throw new Error("noUiSlider: 'connect' option doesn't match handle count.");
    n = t;
  }
  e.connect = n;
}
function Xy(e, t) {
  switch (t) {
    case "horizontal":
      e.ort = 0;
      break;
    case "vertical":
      e.ort = 1;
      break;
    default:
      throw new Error("noUiSlider: 'orientation' option is invalid.");
  }
}
function Hf(e, t) {
  if (!Qn(t))
    throw new Error("noUiSlider: 'margin' option must be numeric.");
  t !== 0 && (e.margin = e.spectrum.getDistance(t));
}
function Qy(e, t) {
  if (!Qn(t))
    throw new Error("noUiSlider: 'limit' option must be numeric.");
  if (e.limit = e.spectrum.getDistance(t), !e.limit || e.handles < 2)
    throw new Error("noUiSlider: 'limit' option is only supported on linear sliders with 2 or more handles.");
}
function eb(e, t) {
  var n;
  if (!Qn(t) && !Array.isArray(t))
    throw new Error("noUiSlider: 'padding' option must be numeric or array of exactly 2 numbers.");
  if (Array.isArray(t) && !(t.length === 2 || Qn(t[0]) || Qn(t[1])))
    throw new Error("noUiSlider: 'padding' option must be numeric or array of exactly 2 numbers.");
  if (t !== 0) {
    for (Array.isArray(t) || (t = [t, t]), e.padding = [e.spectrum.getDistance(t[0]), e.spectrum.getDistance(t[1])], n = 0; n < e.spectrum.xNumSteps.length - 1; n++)
      if (e.padding[0][n] < 0 || e.padding[1][n] < 0)
        throw new Error("noUiSlider: 'padding' option must be a positive number(s).");
    var r = t[0] + t[1], a = e.spectrum.xVal[0], l = e.spectrum.xVal[e.spectrum.xVal.length - 1];
    if (r / (l - a) > 1)
      throw new Error("noUiSlider: 'padding' option must not exceed 100% of the range.");
  }
}
function tb(e, t) {
  switch (t) {
    case "ltr":
      e.dir = 0;
      break;
    case "rtl":
      e.dir = 1;
      break;
    default:
      throw new Error("noUiSlider: 'direction' option was not recognized.");
  }
}
function nb(e, t) {
  if (typeof t != "string")
    throw new Error("noUiSlider: 'behaviour' must be a string containing options.");
  var n = t.indexOf("tap") >= 0, r = t.indexOf("drag") >= 0, a = t.indexOf("fixed") >= 0, l = t.indexOf("snap") >= 0, u = t.indexOf("hover") >= 0, h = t.indexOf("unconstrained") >= 0, f = t.indexOf("drag-all") >= 0, m = t.indexOf("smooth-steps") >= 0;
  if (a) {
    if (e.handles !== 2)
      throw new Error("noUiSlider: 'fixed' behaviour must be used with 2 handles");
    Hf(e, e.start[1] - e.start[0]);
  }
  if (h && (e.margin || e.limit))
    throw new Error("noUiSlider: 'unconstrained' behaviour cannot be used with margin or limit");
  e.events = {
    tap: n || l,
    drag: r,
    dragAll: f,
    smoothSteps: m,
    fixed: a,
    snap: l,
    hover: u,
    unconstrained: h
  };
}
function ib(e, t) {
  if (t !== !1)
    if (t === !0 || Cs(t)) {
      e.tooltips = [];
      for (var n = 0; n < e.handles; n++)
        e.tooltips.push(t);
    } else {
      if (t = Ks(t), t.length !== e.handles)
        throw new Error("noUiSlider: must pass a formatter for all handles.");
      t.forEach(function(r) {
        if (typeof r != "boolean" && !Cs(r))
          throw new Error("noUiSlider: 'tooltips' must be passed a formatter or 'false'.");
      }), e.tooltips = t;
    }
}
function rb(e, t) {
  if (t.length !== e.handles)
    throw new Error("noUiSlider: must pass a attributes for all handles.");
  e.handleAttributes = t;
}
function ab(e, t) {
  if (!Cs(t))
    throw new Error("noUiSlider: 'ariaFormat' requires 'to' method.");
  e.ariaFormat = t;
}
function ob(e, t) {
  if (!Cy(t))
    throw new Error("noUiSlider: 'format' requires 'to' and 'from' methods.");
  e.format = t;
}
function sb(e, t) {
  if (typeof t != "boolean")
    throw new Error("noUiSlider: 'keyboardSupport' option must be a boolean.");
  e.keyboardSupport = t;
}
function lb(e, t) {
  e.documentElement = t;
}
function ub(e, t) {
  if (typeof t != "string" && t !== !1)
    throw new Error("noUiSlider: 'cssPrefix' must be a string or `false`.");
  e.cssPrefix = t;
}
function cb(e, t) {
  if (typeof t != "object")
    throw new Error("noUiSlider: 'cssClasses' must be an object.");
  typeof e.cssPrefix == "string" ? (e.cssClasses = {}, Object.keys(t).forEach(function(n) {
    e.cssClasses[n] = e.cssPrefix + t[n];
  })) : e.cssClasses = t;
}
function Uf(e) {
  var t = {
    margin: null,
    limit: null,
    padding: null,
    animate: !0,
    animationDuration: 300,
    ariaFormat: ah,
    format: ah
  }, n = {
    step: { r: !1, t: Vy },
    keyboardPageMultiplier: { r: !1, t: Yy },
    keyboardMultiplier: { r: !1, t: Hy },
    keyboardDefaultStep: { r: !1, t: Uy },
    start: { r: !0, t: Wy },
    connect: { r: !0, t: Jy },
    direction: { r: !0, t: tb },
    snap: { r: !1, t: Gy },
    animate: { r: !1, t: qy },
    animationDuration: { r: !1, t: Ky },
    range: { r: !0, t: Zy },
    orientation: { r: !1, t: Xy },
    margin: { r: !1, t: Hf },
    limit: { r: !1, t: Qy },
    padding: { r: !1, t: eb },
    behaviour: { r: !0, t: nb },
    ariaFormat: { r: !1, t: ab },
    format: { r: !1, t: ob },
    tooltips: { r: !1, t: ib },
    keyboardSupport: { r: !0, t: sb },
    documentElement: { r: !1, t: lb },
    cssPrefix: { r: !0, t: ub },
    cssClasses: { r: !0, t: cb },
    handleAttributes: { r: !1, t: rb }
  }, r = {
    connect: !1,
    direction: "ltr",
    behaviour: "tap",
    orientation: "horizontal",
    keyboardSupport: !0,
    cssPrefix: "noUi-",
    cssClasses: Yf,
    keyboardPageMultiplier: 5,
    keyboardMultiplier: 1,
    keyboardDefaultStep: 10
  };
  e.format && !e.ariaFormat && (e.ariaFormat = e.format), Object.keys(n).forEach(function(f) {
    if (!Zl(e[f]) && r[f] === void 0) {
      if (n[f].r)
        throw new Error("noUiSlider: '" + f + "' is required.");
      return;
    }
    n[f].t(t, Zl(e[f]) ? e[f] : r[f]);
  }), t.pips = e.pips;
  var a = document.createElement("div"), l = a.style.msTransform !== void 0, u = a.style.transform !== void 0;
  t.transformRule = u ? "transform" : l ? "msTransform" : "webkitTransform";
  var h = [
    ["left", "top"],
    ["right", "bottom"]
  ];
  return t.style = h[t.dir][t.ort], t;
}
function hb(e, t, n) {
  var r = Ay(), a = By(), l = a && Ry(), u = e, h, f, m, v, y, k = t.spectrum, x = [], M = [], O = [], R = 0, C = {}, T = e.ownerDocument, A = t.documentElement || T.documentElement, P = T.body, D = T.dir === "rtl" || t.ort === 1 ? 0 : 100;
  function $(N, U) {
    var ie = T.createElement("div");
    return U && gn(ie, U), N.appendChild(ie), ie;
  }
  function Y(N, U) {
    var ie = $(N, t.cssClasses.origin), ve = $(ie, t.cssClasses.handle);
    if ($(ve, t.cssClasses.touchArea), ve.setAttribute("data-handle", String(U)), t.keyboardSupport && (ve.setAttribute("tabindex", "0"), ve.addEventListener("keydown", function(Ce) {
      return qt(Ce, U);
    })), t.handleAttributes !== void 0) {
      var Ee = t.handleAttributes[U];
      Object.keys(Ee).forEach(function(Ce) {
        ve.setAttribute(Ce, Ee[Ce]);
      });
    }
    return ve.setAttribute("role", "slider"), ve.setAttribute("aria-orientation", t.ort ? "vertical" : "horizontal"), U === 0 ? gn(ve, t.cssClasses.handleLower) : U === t.handles - 1 && gn(ve, t.cssClasses.handleUpper), ie.handle = ve, ie;
  }
  function G(N, U) {
    return U ? $(N, t.cssClasses.connect) : !1;
  }
  function ee(N, U) {
    var ie = $(U, t.cssClasses.connects);
    f = [], m = [], m.push(G(ie, N[0]));
    for (var ve = 0; ve < t.handles; ve++)
      f.push(Y(U, ve)), O[ve] = ve, m.push(G(ie, N[ve + 1]));
  }
  function X(N) {
    gn(N, t.cssClasses.target), t.dir === 0 ? gn(N, t.cssClasses.ltr) : gn(N, t.cssClasses.rtl), t.ort === 0 ? gn(N, t.cssClasses.horizontal) : gn(N, t.cssClasses.vertical);
    var U = getComputedStyle(N).direction;
    return U === "rtl" ? gn(N, t.cssClasses.textDirectionRtl) : gn(N, t.cssClasses.textDirectionLtr), $(N, t.cssClasses.base);
  }
  function ae(N, U) {
    return !t.tooltips || !t.tooltips[U] ? !1 : $(N.firstChild, t.cssClasses.tooltip);
  }
  function ne() {
    return u.hasAttribute("disabled");
  }
  function se(N) {
    var U = f[N];
    return U.hasAttribute("disabled");
  }
  function re(N) {
    N != null ? (f[N].setAttribute("disabled", ""), f[N].handle.removeAttribute("tabindex")) : (u.setAttribute("disabled", ""), f.forEach(function(U) {
      U.handle.removeAttribute("tabindex");
    }));
  }
  function Q(N) {
    N != null ? (f[N].removeAttribute("disabled"), f[N].handle.setAttribute("tabindex", "0")) : (u.removeAttribute("disabled"), f.forEach(function(U) {
      U.removeAttribute("disabled"), U.handle.setAttribute("tabindex", "0");
    }));
  }
  function ke() {
    y && (S("update" + Ki.tooltips), y.forEach(function(N) {
      N && th(N);
    }), y = null);
  }
  function Ae() {
    ke(), y = f.map(ae), sn("update" + Ki.tooltips, function(N, U, ie) {
      if (!(!y || !t.tooltips) && y[U] !== !1) {
        var ve = N[U];
        t.tooltips[U] !== !0 && (ve = t.tooltips[U].to(ie[U])), y[U].innerHTML = ve;
      }
    });
  }
  function pe() {
    S("update" + Ki.aria), sn("update" + Ki.aria, function(N, U, ie, ve, Ee) {
      O.forEach(function(Ce) {
        var He = f[Ce], Re = z(M, Ce, 0, !0, !0, !0), mt = z(M, Ce, 100, !0, !0, !0), ht = Ee[Ce], wt = String(t.ariaFormat.to(ie[Ce]));
        Re = k.fromStepping(Re).toFixed(1), mt = k.fromStepping(mt).toFixed(1), ht = k.fromStepping(ht).toFixed(1), He.children[0].setAttribute("aria-valuemin", Re), He.children[0].setAttribute("aria-valuemax", mt), He.children[0].setAttribute("aria-valuenow", ht), He.children[0].setAttribute("aria-valuetext", wt);
      });
    });
  }
  function Ye(N) {
    if (N.mode === tr.Range || N.mode === tr.Steps)
      return k.xVal;
    if (N.mode === tr.Count) {
      if (N.values < 2)
        throw new Error("noUiSlider: 'values' (>= 2) required for mode 'count'.");
      for (var U = N.values - 1, ie = 100 / U, ve = []; U--; )
        ve[U] = U * ie;
      return ve.push(100), ue(ve, N.stepped);
    }
    return N.mode === tr.Positions ? ue(N.values, N.stepped) : N.mode === tr.Values ? N.stepped ? N.values.map(function(Ee) {
      return k.fromStepping(k.getStep(k.toStepping(Ee)));
    }) : N.values : [];
  }
  function ue(N, U) {
    return N.map(function(ie) {
      return k.fromStepping(U ? k.getStep(ie) : ie);
    });
  }
  function Fe(N) {
    function U(ht, wt) {
      return Number((ht + wt).toFixed(7));
    }
    var ie = Ye(N), ve = {}, Ee = k.xVal[0], Ce = k.xVal[k.xVal.length - 1], He = !1, Re = !1, mt = 0;
    return ie = Oy(ie.slice().sort(function(ht, wt) {
      return ht - wt;
    })), ie[0] !== Ee && (ie.unshift(Ee), He = !0), ie[ie.length - 1] !== Ce && (ie.push(Ce), Re = !0), ie.forEach(function(ht, wt) {
      var ct, ut, Lt, Be = ht, Nt = ie[wt + 1], Kt, vi, _i, yi, Vi, Pn, Yi, Hi = N.mode === tr.Steps;
      for (Hi && (ct = k.xNumSteps[wt]), ct || (ct = Nt - Be), Nt === void 0 && (Nt = Be), ct = Math.max(ct, 1e-7), ut = Be; ut <= Nt; ut = U(ut, ct)) {
        for (Kt = k.toStepping(ut), vi = Kt - mt, Vi = vi / (N.density || 1), Pn = Math.round(Vi), Yi = vi / Pn, Lt = 1; Lt <= Pn; Lt += 1)
          _i = mt + Lt * Yi, ve[_i.toFixed(5)] = [k.fromStepping(_i), 0];
        yi = ie.indexOf(ut) > -1 ? xn.LargeValue : Hi ? xn.SmallValue : xn.NoValue, !wt && He && ut !== Nt && (yi = 0), ut === Nt && Re || (ve[Kt.toFixed(5)] = [ut, yi]), mt = Kt;
      }
    }), ve;
  }
  function Pe(N, U, ie) {
    var ve, Ee, Ce = T.createElement("div"), He = (ve = {}, ve[xn.None] = "", ve[xn.NoValue] = t.cssClasses.valueNormal, ve[xn.LargeValue] = t.cssClasses.valueLarge, ve[xn.SmallValue] = t.cssClasses.valueSub, ve), Re = (Ee = {}, Ee[xn.None] = "", Ee[xn.NoValue] = t.cssClasses.markerNormal, Ee[xn.LargeValue] = t.cssClasses.markerLarge, Ee[xn.SmallValue] = t.cssClasses.markerSub, Ee), mt = [t.cssClasses.valueHorizontal, t.cssClasses.valueVertical], ht = [t.cssClasses.markerHorizontal, t.cssClasses.markerVertical];
    gn(Ce, t.cssClasses.pips), gn(Ce, t.ort === 0 ? t.cssClasses.pipsHorizontal : t.cssClasses.pipsVertical);
    function wt(ut, Lt) {
      var Be = Lt === t.cssClasses.value, Nt = Be ? mt : ht, Kt = Be ? He : Re;
      return Lt + " " + Nt[t.ort] + " " + Kt[ut];
    }
    function ct(ut, Lt, Be) {
      if (Be = U ? U(Lt, Be) : Be, Be !== xn.None) {
        var Nt = $(Ce, !1);
        Nt.className = wt(Be, t.cssClasses.marker), Nt.style[t.style] = ut + "%", Be > xn.NoValue && (Nt = $(Ce, !1), Nt.className = wt(Be, t.cssClasses.value), Nt.setAttribute("data-value", String(Lt)), Nt.style[t.style] = ut + "%", Nt.innerHTML = String(ie.to(Lt)));
      }
    }
    return Object.keys(N).forEach(function(ut) {
      ct(ut, N[ut][0], N[ut][1]);
    }), Ce;
  }
  function nt() {
    v && (th(v), v = null);
  }
  function Ve(N) {
    nt();
    var U = Fe(N), ie = N.filter, ve = N.format || {
      to: function(Ee) {
        return String(Math.round(Ee));
      }
    };
    return v = u.appendChild(Pe(U, ie, ve)), v;
  }
  function Ze() {
    var N = h.getBoundingClientRect(), U = "offset" + ["Width", "Height"][t.ort];
    return t.ort === 0 ? N.width || h[U] : N.height || h[U];
  }
  function Ne(N, U, ie, ve) {
    var Ee = function(He) {
      var Re = ft(He, ve.pageOffset, ve.target || U);
      if (!Re || ne() && !ve.doNotReject || Iy(u, t.cssClasses.tap) && !ve.doNotReject || N === r.start && Re.buttons !== void 0 && Re.buttons > 1 || ve.hover && Re.buttons)
        return !1;
      l || Re.preventDefault(), Re.calcPoint = Re.points[t.ort], ie(Re, ve);
    }, Ce = [];
    return N.split(" ").forEach(function(He) {
      U.addEventListener(He, Ee, l ? { passive: !0 } : !1), Ce.push([He, Ee]);
    }), Ce;
  }
  function ft(N, U, ie) {
    var ve = N.type.indexOf("touch") === 0, Ee = N.type.indexOf("mouse") === 0, Ce = N.type.indexOf("pointer") === 0, He = 0, Re = 0;
    if (N.type.indexOf("MSPointer") === 0 && (Ce = !0), N.type === "mousedown" && !N.buttons && !N.touches)
      return !1;
    if (ve) {
      var mt = function(ct) {
        var ut = ct.target;
        return ut === ie || ie.contains(ut) || N.composed && N.composedPath().shift() === ie;
      };
      if (N.type === "touchstart") {
        var ht = Array.prototype.filter.call(N.touches, mt);
        if (ht.length > 1)
          return !1;
        He = ht[0].pageX, Re = ht[0].pageY;
      } else {
        var wt = Array.prototype.find.call(N.changedTouches, mt);
        if (!wt)
          return !1;
        He = wt.pageX, Re = wt.pageY;
      }
    }
    return U = U || jf(T), (Ee || Ce) && (He = N.clientX + U.x, Re = N.clientY + U.y), N.pageOffset = U, N.points = [He, Re], N.cursor = Ee || Ce, N;
  }
  function pt(N) {
    var U = N - Ty(h, t.ort), ie = U * 100 / Ze();
    return ie = rh(ie), t.dir ? 100 - ie : ie;
  }
  function Wt(N) {
    var U = 100, ie = !1;
    return f.forEach(function(ve, Ee) {
      if (!se(Ee)) {
        var Ce = M[Ee], He = Math.abs(Ce - N), Re = He === 100 && U === 100, mt = He < U, ht = He <= U && N > Ce;
        (mt || ht || Re) && (ie = Ee, U = He);
      }
    }), ie;
  }
  function an(N, U) {
    N.type === "mouseout" && N.target.nodeName === "HTML" && N.relatedTarget === null && Dt(N, U);
  }
  function on(N, U) {
    if (navigator.appVersion.indexOf("MSIE 9") === -1 && N.buttons === 0 && U.buttonsProperty !== 0)
      return Dt(N, U);
    var ie = (t.dir ? -1 : 1) * (N.calcPoint - U.startCalcPoint), ve = ie * 100 / U.baseSize;
    J(ie > 0, ve, U.locations, U.handleNumbers, U.connect);
  }
  function Dt(N, U) {
    U.handle && (hs(U.handle, t.cssClasses.active), R -= 1), U.listeners.forEach(function(ie) {
      A.removeEventListener(ie[0], ie[1]);
    }), R === 0 && (hs(u, t.cssClasses.drag), Oe(), N.cursor && (P.style.cursor = "", P.removeEventListener("selectstart", nh))), t.events.smoothSteps && (U.handleNumbers.forEach(function(ie) {
      Ue(ie, M[ie], !0, !0, !1, !1);
    }), U.handleNumbers.forEach(function(ie) {
      E("update", ie);
    })), U.handleNumbers.forEach(function(ie) {
      E("change", ie), E("set", ie), E("end", ie);
    });
  }
  function Zt(N, U) {
    if (!U.handleNumbers.some(se)) {
      var ie;
      if (U.handleNumbers.length === 1) {
        var ve = f[U.handleNumbers[0]];
        ie = ve.children[0], R += 1, gn(ie, t.cssClasses.active);
      }
      N.stopPropagation();
      var Ee = [], Ce = Ne(r.move, A, on, {
        // The event target has changed so we need to propagate the original one so that we keep
        // relying on it to extract target touches.
        target: N.target,
        handle: ie,
        connect: U.connect,
        listeners: Ee,
        startCalcPoint: N.calcPoint,
        baseSize: Ze(),
        pageOffset: N.pageOffset,
        handleNumbers: U.handleNumbers,
        buttonsProperty: N.buttons,
        locations: M.slice()
      }), He = Ne(r.end, A, Dt, {
        target: N.target,
        handle: ie,
        listeners: Ee,
        doNotReject: !0,
        handleNumbers: U.handleNumbers
      }), Re = Ne("mouseout", A, an, {
        target: N.target,
        handle: ie,
        listeners: Ee,
        doNotReject: !0,
        handleNumbers: U.handleNumbers
      });
      Ee.push.apply(Ee, Ce.concat(He, Re)), N.cursor && (P.style.cursor = getComputedStyle(N.target).cursor, f.length > 1 && gn(u, t.cssClasses.drag), P.addEventListener("selectstart", nh, !1)), U.handleNumbers.forEach(function(mt) {
        E("start", mt);
      });
    }
  }
  function It(N) {
    N.stopPropagation();
    var U = pt(N.calcPoint), ie = Wt(U);
    ie !== !1 && (t.events.snap || ih(u, t.cssClasses.tap, t.animationDuration), Ue(ie, U, !0, !0), Oe(), E("slide", ie, !0), E("update", ie, !0), t.events.snap ? Zt(N, { handleNumbers: [ie] }) : (E("change", ie, !0), E("set", ie, !0)));
  }
  function bn(N) {
    var U = pt(N.calcPoint), ie = k.getStep(U), ve = k.fromStepping(ie);
    Object.keys(C).forEach(function(Ee) {
      Ee.split(".")[0] === "hover" && C[Ee].forEach(function(Ce) {
        Ce.call(De, ve);
      });
    });
  }
  function qt(N, U) {
    if (ne() || se(U))
      return !1;
    var ie = ["Left", "Right"], ve = ["Down", "Up"], Ee = ["PageDown", "PageUp"], Ce = ["Home", "End"];
    t.dir && !t.ort ? ie.reverse() : t.ort && !t.dir && (ve.reverse(), Ee.reverse());
    var He = N.key.replace("Arrow", ""), Re = He === Ee[0], mt = He === Ee[1], ht = He === ve[0] || He === ie[0] || Re, wt = He === ve[1] || He === ie[1] || mt, ct = He === Ce[0], ut = He === Ce[1];
    if (!ht && !wt && !ct && !ut)
      return !0;
    N.preventDefault();
    var Lt;
    if (wt || ht) {
      var Be = ht ? 0 : 1, Nt = Rt(U), Kt = Nt[Be];
      if (Kt === null)
        return !1;
      Kt === !1 && (Kt = k.getDefaultStep(M[U], ht, t.keyboardDefaultStep)), mt || Re ? Kt *= t.keyboardPageMultiplier : Kt *= t.keyboardMultiplier, Kt = Math.max(Kt, 1e-7), Kt = (ht ? -1 : 1) * Kt, Lt = x[U] + Kt;
    } else
      ut ? Lt = t.spectrum.xVal[t.spectrum.xVal.length - 1] : Lt = t.spectrum.xVal[0];
    return Ue(U, k.toStepping(Lt), !0, !0), E("slide", U), E("update", U), E("change", U), E("set", U), !1;
  }
  function cn(N) {
    N.fixed || f.forEach(function(U, ie) {
      Ne(r.start, U.children[0], Zt, {
        handleNumbers: [ie]
      });
    }), N.tap && Ne(r.start, h, It, {}), N.hover && Ne(r.move, h, bn, {
      hover: !0
    }), N.drag && m.forEach(function(U, ie) {
      if (!(U === !1 || ie === 0 || ie === m.length - 1)) {
        var ve = f[ie - 1], Ee = f[ie], Ce = [U], He = [ve, Ee], Re = [ie - 1, ie];
        gn(U, t.cssClasses.draggable), N.fixed && (Ce.push(ve.children[0]), Ce.push(Ee.children[0])), N.dragAll && (He = f, Re = O), Ce.forEach(function(mt) {
          Ne(r.start, mt, Zt, {
            handles: He,
            handleNumbers: Re,
            connect: U
          });
        });
      }
    });
  }
  function sn(N, U) {
    C[N] = C[N] || [], C[N].push(U), N.split(".")[0] === "update" && f.forEach(function(ie, ve) {
      E("update", ve);
    });
  }
  function H(N) {
    return N === Ki.aria || N === Ki.tooltips;
  }
  function S(N) {
    var U = N && N.split(".")[0], ie = U ? N.substring(U.length) : N;
    Object.keys(C).forEach(function(ve) {
      var Ee = ve.split(".")[0], Ce = ve.substring(Ee.length);
      (!U || U === Ee) && (!ie || ie === Ce) && (!H(Ce) || ie === Ce) && delete C[ve];
    });
  }
  function E(N, U, ie) {
    Object.keys(C).forEach(function(ve) {
      var Ee = ve.split(".")[0];
      N === Ee && C[ve].forEach(function(Ce) {
        Ce.call(
          // Use the slider public API as the scope ('this')
          De,
          // Return values as array, so arg_1[arg_2] is always valid.
          x.map(t.format.to),
          // Handle index, 0 or 1
          U,
          // Un-formatted slider values
          x.slice(),
          // Event is fired by tap, true or false
          ie || !1,
          // Left offset of the handle, in relation to the slider
          M.slice(),
          // add the slider public API to an accessible parameter when this is unavailable
          De
        );
      });
    });
  }
  function z(N, U, ie, ve, Ee, Ce, He) {
    var Re;
    return f.length > 1 && !t.events.unconstrained && (ve && U > 0 && (Re = k.getAbsoluteDistance(N[U - 1], t.margin, !1), ie = Math.max(ie, Re)), Ee && U < f.length - 1 && (Re = k.getAbsoluteDistance(N[U + 1], t.margin, !0), ie = Math.min(ie, Re))), f.length > 1 && t.limit && (ve && U > 0 && (Re = k.getAbsoluteDistance(N[U - 1], t.limit, !1), ie = Math.min(ie, Re)), Ee && U < f.length - 1 && (Re = k.getAbsoluteDistance(N[U + 1], t.limit, !0), ie = Math.max(ie, Re))), t.padding && (U === 0 && (Re = k.getAbsoluteDistance(0, t.padding[0], !1), ie = Math.max(ie, Re)), U === f.length - 1 && (Re = k.getAbsoluteDistance(100, t.padding[1], !0), ie = Math.min(ie, Re))), He || (ie = k.getStep(ie)), ie = rh(ie), ie === N[U] && !Ce ? !1 : ie;
  }
  function q(N, U) {
    var ie = t.ort;
    return (ie ? U : N) + ", " + (ie ? N : U);
  }
  function J(N, U, ie, ve, Ee) {
    var Ce = ie.slice(), He = ve[0], Re = t.events.smoothSteps, mt = [!N, N], ht = [N, !N];
    ve = ve.slice(), N && ve.reverse(), ve.length > 1 ? ve.forEach(function(ct, ut) {
      var Lt = z(Ce, ct, Ce[ct] + U, mt[ut], ht[ut], !1, Re);
      Lt === !1 ? U = 0 : (U = Lt - Ce[ct], Ce[ct] = Lt);
    }) : mt = ht = [!0];
    var wt = !1;
    ve.forEach(function(ct, ut) {
      wt = Ue(ct, ie[ct] + U, mt[ut], ht[ut], !1, Re) || wt;
    }), wt && (ve.forEach(function(ct) {
      E("update", ct), E("slide", ct);
    }), Ee != null && E("drag", He));
  }
  function me(N, U) {
    return t.dir ? 100 - N - U : N;
  }
  function ye(N, U) {
    M[N] = U, x[N] = k.fromStepping(U);
    var ie = me(U, 0) - D, ve = "translate(" + q(ie + "%", "0") + ")";
    f[N].style[t.transformRule] = ve, at(N), at(N + 1);
  }
  function Oe() {
    O.forEach(function(N) {
      var U = M[N] > 50 ? -1 : 1, ie = 3 + (f.length + U * N);
      f[N].style.zIndex = String(ie);
    });
  }
  function Ue(N, U, ie, ve, Ee, Ce) {
    return Ee || (U = z(M, N, U, ie, ve, !1, Ce)), U === !1 ? !1 : (ye(N, U), !0);
  }
  function at(N) {
    if (m[N]) {
      var U = 0, ie = 100;
      N !== 0 && (U = M[N - 1]), N !== m.length - 1 && (ie = M[N]);
      var ve = ie - U, Ee = "translate(" + q(me(U, ve) + "%", "0") + ")", Ce = "scale(" + q(ve / 100, "1") + ")";
      m[N].style[t.transformRule] = Ee + " " + Ce;
    }
  }
  function Xe(N, U) {
    return N === null || N === !1 || N === void 0 || (typeof N == "number" && (N = String(N)), N = t.format.from(N), N !== !1 && (N = k.toStepping(N)), N === !1 || isNaN(N)) ? M[U] : N;
  }
  function We(N, U, ie) {
    var ve = Ks(N), Ee = M[0] === void 0;
    U = U === void 0 ? !0 : U, t.animate && !Ee && ih(u, t.cssClasses.tap, t.animationDuration), O.forEach(function(Re) {
      Ue(Re, Xe(ve[Re], Re), !0, !1, ie);
    });
    var Ce = O.length === 1 ? 0 : 1;
    if (Ee && k.hasNoSize() && (ie = !0, M[0] = 0, O.length > 1)) {
      var He = 100 / (O.length - 1);
      O.forEach(function(Re) {
        M[Re] = Re * He;
      });
    }
    for (; Ce < O.length; ++Ce)
      O.forEach(function(Re) {
        Ue(Re, M[Re], !0, !0, ie);
      });
    Oe(), O.forEach(function(Re) {
      E("update", Re), ve[Re] !== null && U && E("set", Re);
    });
  }
  function xt(N) {
    We(t.start, N);
  }
  function lt(N, U, ie, ve) {
    if (N = Number(N), !(N >= 0 && N < O.length))
      throw new Error("noUiSlider: invalid handle number, got: " + N);
    Ue(N, Xe(U, N), !0, !0, ve), E("update", N), ie && E("set", N);
  }
  function bt(N) {
    if (N === void 0 && (N = !1), N)
      return x.length === 1 ? x[0] : x.slice(0);
    var U = x.map(t.format.to);
    return U.length === 1 ? U[0] : U;
  }
  function At() {
    for (S(Ki.aria), S(Ki.tooltips), Object.keys(t.cssClasses).forEach(function(N) {
      hs(u, t.cssClasses[N]);
    }); u.firstChild; )
      u.removeChild(u.firstChild);
    delete u.noUiSlider;
  }
  function Rt(N) {
    var U = M[N], ie = k.getNearbySteps(U), ve = x[N], Ee = ie.thisStep.step, Ce = null;
    if (t.snap)
      return [
        ve - ie.stepBefore.startValue || null,
        ie.stepAfter.startValue - ve || null
      ];
    Ee !== !1 && ve + Ee > ie.stepAfter.startValue && (Ee = ie.stepAfter.startValue - ve), ve > ie.thisStep.startValue ? Ce = ie.thisStep.step : ie.stepBefore.step === !1 ? Ce = !1 : Ce = ve - ie.stepBefore.highestStep, U === 100 ? Ee = null : U === 0 && (Ce = null);
    var He = k.countStepDecimals();
    return Ee !== null && Ee !== !1 && (Ee = Number(Ee.toFixed(He))), Ce !== null && Ce !== !1 && (Ce = Number(Ce.toFixed(He))), [Ce, Ee];
  }
  function be() {
    return O.map(Rt);
  }
  function j(N, U) {
    var ie = bt(), ve = [
      "margin",
      "limit",
      "padding",
      "range",
      "animate",
      "snap",
      "step",
      "format",
      "pips",
      "tooltips"
    ];
    ve.forEach(function(Ce) {
      N[Ce] !== void 0 && (n[Ce] = N[Ce]);
    });
    var Ee = Uf(n);
    ve.forEach(function(Ce) {
      N[Ce] !== void 0 && (t[Ce] = Ee[Ce]);
    }), k = Ee.spectrum, t.margin = Ee.margin, t.limit = Ee.limit, t.padding = Ee.padding, t.pips ? Ve(t.pips) : nt(), t.tooltips ? Ae() : ke(), M = [], We(Zl(N.start) ? N.start : ie, U);
  }
  function ge() {
    h = X(u), ee(t.connect, h), cn(t.events), We(t.start), t.pips && Ve(t.pips), t.tooltips && Ae(), pe();
  }
  ge();
  var De = {
    destroy: At,
    steps: be,
    on: sn,
    off: S,
    get: bt,
    set: We,
    setHandle: lt,
    reset: xt,
    disable: re,
    enable: Q,
    // Exposed for unit testing, don't use this in your application.
    __moveHandles: function(N, U, ie) {
      J(N, U, M, ie);
    },
    options: n,
    updateOptions: j,
    target: u,
    removePips: nt,
    removeTooltips: ke,
    getPositions: function() {
      return M.slice();
    },
    getTooltips: function() {
      return y;
    },
    getOrigins: function() {
      return f;
    },
    pips: Ve
    // Issue #594
  };
  return De;
}
function db(e, t) {
  if (!e || !e.nodeName)
    throw new Error("noUiSlider: create requires a single element, got: " + e);
  if (e.noUiSlider)
    throw new Error("noUiSlider: Slider was already initialized.");
  var n = Uf(t), r = hb(e, n, t);
  return e.noUiSlider = r, r;
}
const fb = {
  // Exposed for unit testing, don't use this in your application.
  __spectrum: Vf,
  // A reference to the default classes, allows global changes.
  // Use the cssClasses option for changes to one slider.
  cssClasses: Yf,
  create: db
};
var Zf = { exports: {} };
(function(e, t) {
  (function(n) {
    e.exports = n();
  })(function() {
    var n = [
      "decimals",
      "thousand",
      "mark",
      "prefix",
      "suffix",
      "encoder",
      "decoder",
      "negativeBefore",
      "negative",
      "edit",
      "undo"
    ];
    function r(M) {
      return M.split("").reverse().join("");
    }
    function a(M, O) {
      return M.substring(0, O.length) === O;
    }
    function l(M, O) {
      return M.slice(-1 * O.length) === O;
    }
    function u(M, O, R) {
      if ((M[O] || M[R]) && M[O] === M[R])
        throw new Error(O);
    }
    function h(M) {
      return typeof M == "number" && isFinite(M);
    }
    function f(M, O) {
      return M = M.toString().split("e"), M = Math.round(+(M[0] + "e" + (M[1] ? +M[1] + O : O))), M = M.toString().split("e"), (+(M[0] + "e" + (M[1] ? +M[1] - O : -O))).toFixed(O);
    }
    function m(M, O, R, C, T, A, P, D, $, Y, G, ee) {
      var X = ee, ae, ne, se, re = "", Q = "";
      return A && (ee = A(ee)), h(ee) ? (M !== !1 && parseFloat(ee.toFixed(M)) === 0 && (ee = 0), ee < 0 && (ae = !0, ee = Math.abs(ee)), M !== !1 && (ee = f(ee, M)), ee = ee.toString(), ee.indexOf(".") !== -1 ? (ne = ee.split("."), se = ne[0], R && (re = R + ne[1])) : se = ee, O && (se = r(se).match(/.{1,3}/g), se = r(se.join(r(O)))), ae && D && (Q += D), C && (Q += C), ae && $ && (Q += $), Q += se, Q += re, T && (Q += T), Y && (Q = Y(Q, X)), Q) : !1;
    }
    function v(M, O, R, C, T, A, P, D, $, Y, G, ee) {
      var X, ae = "";
      return G && (ee = G(ee)), !ee || typeof ee != "string" || (D && a(ee, D) && (ee = ee.replace(D, ""), X = !0), C && a(ee, C) && (ee = ee.replace(C, "")), $ && a(ee, $) && (ee = ee.replace($, ""), X = !0), T && l(ee, T) && (ee = ee.slice(0, -1 * T.length)), O && (ee = ee.split(O).join("")), R && (ee = ee.replace(R, ".")), X && (ae += "-"), ae += ee, ae = ae.replace(/[^0-9\.\-.]/g, ""), ae === "") || (ae = Number(ae), P && (ae = P(ae)), !h(ae)) ? !1 : ae;
    }
    function y(M) {
      var O, R, C, T = {};
      for (M.suffix === void 0 && (M.suffix = M.postfix), O = 0; O < n.length; O += 1)
        if (R = n[O], C = M[R], C === void 0)
          R === "negative" && !T.negativeBefore ? T[R] = "-" : R === "mark" && T.thousand !== "." ? T[R] = "." : T[R] = !1;
        else if (R === "decimals")
          if (C >= 0 && C < 8)
            T[R] = C;
          else
            throw new Error(R);
        else if (R === "encoder" || R === "decoder" || R === "edit" || R === "undo")
          if (typeof C == "function")
            T[R] = C;
          else
            throw new Error(R);
        else if (typeof C == "string")
          T[R] = C;
        else
          throw new Error(R);
      return u(T, "mark", "thousand"), u(T, "prefix", "negative"), u(T, "prefix", "negativeBefore"), T;
    }
    function k(M, O, R) {
      var C, T = [];
      for (C = 0; C < n.length; C += 1)
        T.push(M[n[C]]);
      return T.push(R), O.apply("", T);
    }
    function x(M) {
      if (!(this instanceof x))
        return new x(M);
      typeof M == "object" && (M = y(M), this.to = function(O) {
        return k(M, m, O);
      }, this.from = function(O) {
        return k(M, v, O);
      });
    }
    return x;
  });
})(Zf);
var pb = Zf.exports;
const oh = /* @__PURE__ */ Ff(pb), Wf = /* @__PURE__ */ tt({
  __name: "VoyagerButton",
  setup(e) {
    return tt({
      name: "VoyagerButton"
    }), (t, n) => (we(), Te("div", null, [
      Xt(t.$slots, "default", ua(ks(t.$attrs)))
    ]));
  }
});
/**
 * vue-virtual
 *
 * Copyright (c) TanStack
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
function Os() {
  return Os = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Os.apply(this, arguments);
}
/**
 * virtual-core
 *
 * Copyright (c) TanStack
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
function Es() {
  return Es = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Es.apply(this, arguments);
}
/**
 * virtual-core
 *
 * Copyright (c) TanStack
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
function ta(e, t, n) {
  var r, a = (r = n.initialDeps) != null ? r : [], l;
  return function() {
    var u;
    n.key && n.debug != null && n.debug() && (u = Date.now());
    var h = e(), f = h.length !== a.length || h.some(function(M, O) {
      return a[O] !== M;
    });
    if (!f)
      return l;
    a = h;
    var m;
    if (n.key && n.debug != null && n.debug() && (m = Date.now()), l = t.apply(void 0, h), n.key && n.debug != null && n.debug()) {
      var v = Math.round((Date.now() - u) * 100) / 100, y = Math.round((Date.now() - m) * 100) / 100, k = y / 16, x = function(O, R) {
        for (O = String(O); O.length < R; )
          O = " " + O;
        return O;
      };
      console.info("%c⏱ " + x(y, 5) + " /" + x(v, 5) + " ms", `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(` + Math.max(0, Math.min(120 - 120 * k, 120)) + "deg 100% 31%);", n == null ? void 0 : n.key);
    }
    return n == null || n.onChange == null || n.onChange(l), l;
  };
}
function Sl(e, t) {
  if (e === void 0)
    throw new Error("Unexpected undefined" + (t ? ": " + t : ""));
  return e;
}
var mb = function(t, n) {
  return Math.abs(t - n) < 1;
};
/**
 * virtual-core
 *
 * Copyright (c) TanStack
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
var gb = function(t) {
  return t;
}, vb = function(t) {
  for (var n = Math.max(t.startIndex - t.overscan, 0), r = Math.min(t.endIndex + t.overscan, t.count - 1), a = [], l = n; l <= r; l++)
    a.push(l);
  return a;
}, _b = function(t, n) {
  var r = t.scrollElement;
  if (r) {
    var a = function(h) {
      var f = h.width, m = h.height;
      n({
        width: Math.round(f),
        height: Math.round(m)
      });
    };
    a(r.getBoundingClientRect());
    var l = new ResizeObserver(function(u) {
      var h = u[0];
      if (h != null && h.borderBoxSize) {
        var f = h.borderBoxSize[0];
        if (f) {
          a({
            width: f.inlineSize,
            height: f.blockSize
          });
          return;
        }
      }
      a(r.getBoundingClientRect());
    });
    return l.observe(r, {
      box: "border-box"
    }), function() {
      l.unobserve(r);
    };
  }
}, yb = function(t, n) {
  var r = t.scrollElement;
  if (r) {
    var a = function() {
      n(r[t.options.horizontal ? "scrollLeft" : "scrollTop"]);
    };
    return a(), r.addEventListener("scroll", a, {
      passive: !0
    }), function() {
      r.removeEventListener("scroll", a);
    };
  }
}, bb = function(t, n, r) {
  if (n != null && n.borderBoxSize) {
    var a = n.borderBoxSize[0];
    if (a) {
      var l = Math.round(a[r.options.horizontal ? "inlineSize" : "blockSize"]);
      return l;
    }
  }
  return Math.round(t.getBoundingClientRect()[r.options.horizontal ? "width" : "height"]);
}, wb = function(t, n, r) {
  var a, l, u = n.adjustments, h = u === void 0 ? 0 : u, f = n.behavior, m = t + h;
  (a = r.scrollElement) == null || a.scrollTo == null || a.scrollTo((l = {}, l[r.options.horizontal ? "left" : "top"] = m, l.behavior = f, l));
}, kb = function(t) {
  var n = this;
  this.unsubs = [], this.scrollElement = null, this.isScrolling = !1, this.isScrollingTimeoutId = null, this.scrollToIndexTimeoutId = null, this.measurementsCache = [], this.itemSizeCache = /* @__PURE__ */ new Map(), this.pendingMeasuredCacheIndexes = [], this.scrollDirection = null, this.scrollAdjustments = 0, this.measureElementCache = /* @__PURE__ */ new Map(), this.observer = /* @__PURE__ */ function() {
    var r = null, a = function() {
      return r || (typeof ResizeObserver < "u" ? r = new ResizeObserver(function(u) {
        u.forEach(function(h) {
          n._measureElement(h.target, h);
        });
      }) : null);
    };
    return {
      disconnect: function() {
        var u;
        return (u = a()) == null ? void 0 : u.disconnect();
      },
      observe: function(u) {
        var h;
        return (h = a()) == null ? void 0 : h.observe(u, {
          box: "border-box"
        });
      },
      unobserve: function(u) {
        var h;
        return (h = a()) == null ? void 0 : h.unobserve(u);
      }
    };
  }(), this.range = null, this.setOptions = function(r) {
    Object.entries(r).forEach(function(a) {
      var l = a[0], u = a[1];
      typeof u > "u" && delete r[l];
    }), n.options = Es({
      debug: !1,
      initialOffset: 0,
      overscan: 1,
      paddingStart: 0,
      paddingEnd: 0,
      scrollPaddingStart: 0,
      scrollPaddingEnd: 0,
      horizontal: !1,
      getItemKey: gb,
      rangeExtractor: vb,
      onChange: function() {
      },
      measureElement: bb,
      initialRect: {
        width: 0,
        height: 0
      },
      scrollMargin: 0,
      scrollingDelay: 150,
      indexAttribute: "data-index",
      initialMeasurementsCache: [],
      lanes: 1
    }, r);
  }, this.notify = function(r) {
    n.options.onChange == null || n.options.onChange(n, r);
  }, this.maybeNotify = ta(function() {
    return n.calculateRange(), [n.isScrolling, n.range ? n.range.startIndex : null, n.range ? n.range.endIndex : null];
  }, function(r) {
    n.notify(r);
  }, {
    key: process.env.NODE_ENV !== "production" && "maybeNotify",
    debug: function() {
      return n.options.debug;
    },
    initialDeps: [this.isScrolling, this.range ? this.range.startIndex : null, this.range ? this.range.endIndex : null]
  }), this.cleanup = function() {
    n.unsubs.filter(Boolean).forEach(function(r) {
      return r();
    }), n.unsubs = [], n.scrollElement = null;
  }, this._didMount = function() {
    return n.measureElementCache.forEach(n.observer.observe), function() {
      n.observer.disconnect(), n.cleanup();
    };
  }, this._willUpdate = function() {
    var r = n.options.getScrollElement();
    n.scrollElement !== r && (n.cleanup(), n.scrollElement = r, n._scrollToOffset(n.scrollOffset, {
      adjustments: void 0,
      behavior: void 0
    }), n.unsubs.push(n.options.observeElementRect(n, function(a) {
      n.scrollRect = a, n.maybeNotify();
    })), n.unsubs.push(n.options.observeElementOffset(n, function(a) {
      n.scrollAdjustments = 0, n.scrollOffset !== a && (n.isScrollingTimeoutId !== null && (clearTimeout(n.isScrollingTimeoutId), n.isScrollingTimeoutId = null), n.isScrolling = !0, n.scrollDirection = n.scrollOffset < a ? "forward" : "backward", n.scrollOffset = a, n.maybeNotify(), n.isScrollingTimeoutId = setTimeout(function() {
        n.isScrollingTimeoutId = null, n.isScrolling = !1, n.scrollDirection = null, n.maybeNotify();
      }, n.options.scrollingDelay));
    })));
  }, this.getSize = function() {
    return n.scrollRect[n.options.horizontal ? "width" : "height"];
  }, this.memoOptions = ta(function() {
    return [n.options.count, n.options.paddingStart, n.options.scrollMargin, n.options.getItemKey];
  }, function(r, a, l, u) {
    return n.pendingMeasuredCacheIndexes = [], {
      count: r,
      paddingStart: a,
      scrollMargin: l,
      getItemKey: u
    };
  }, {
    key: !1
  }), this.getFurthestMeasurement = function(r, a) {
    for (var l = /* @__PURE__ */ new Map(), u = /* @__PURE__ */ new Map(), h = a - 1; h >= 0; h--) {
      var f = r[h];
      if (!l.has(f.lane)) {
        var m = u.get(f.lane);
        if (m == null || f.end > m.end ? u.set(f.lane, f) : f.end < m.end && l.set(f.lane, !0), l.size === n.options.lanes)
          break;
      }
    }
    return u.size === n.options.lanes ? Array.from(u.values()).sort(function(v, y) {
      return v.end - y.end;
    })[0] : void 0;
  }, this.getMeasurements = ta(function() {
    return [n.memoOptions(), n.itemSizeCache];
  }, function(r, a) {
    var l = r.count, u = r.paddingStart, h = r.scrollMargin, f = r.getItemKey, m = n.pendingMeasuredCacheIndexes.length > 0 ? Math.min.apply(Math, n.pendingMeasuredCacheIndexes) : 0;
    n.pendingMeasuredCacheIndexes = [];
    for (var v = n.measurementsCache.slice(0, m), y = m; y < l; y++) {
      var k = f(y), x = n.options.lanes === 1 ? v[y - 1] : n.getFurthestMeasurement(v, y), M = x ? x.end : u + h, O = a.get(k), R = typeof O == "number" ? O : n.options.estimateSize(y), C = M + R, T = x ? x.lane : y % n.options.lanes;
      v[y] = {
        index: y,
        start: M,
        size: R,
        end: C,
        key: k,
        lane: T
      };
    }
    return n.measurementsCache = v, v;
  }, {
    key: process.env.NODE_ENV !== "production" && "getMeasurements",
    debug: function() {
      return n.options.debug;
    }
  }), this.calculateRange = ta(function() {
    return [n.getMeasurements(), n.getSize(), n.scrollOffset];
  }, function(r, a, l) {
    return n.range = r.length > 0 && a > 0 ? xb({
      measurements: r,
      outerSize: a,
      scrollOffset: l
    }) : null;
  }, {
    key: process.env.NODE_ENV !== "production" && "calculateRange",
    debug: function() {
      return n.options.debug;
    }
  }), this.getIndexes = ta(function() {
    return [n.options.rangeExtractor, n.calculateRange(), n.options.overscan, n.options.count];
  }, function(r, a, l, u) {
    return a === null ? [] : r(Es({}, a, {
      overscan: l,
      count: u
    }));
  }, {
    key: process.env.NODE_ENV !== "production" && "getIndexes",
    debug: function() {
      return n.options.debug;
    }
  }), this.indexFromElement = function(r) {
    var a = n.options.indexAttribute, l = r.getAttribute(a);
    return l ? parseInt(l, 10) : (console.warn("Missing attribute name '" + a + "={index}' on measured element."), -1);
  }, this._measureElement = function(r, a) {
    var l = n.measurementsCache[n.indexFromElement(r)];
    if (!l || !r.isConnected) {
      n.measureElementCache.forEach(function(f, m) {
        f === r && (n.observer.unobserve(r), n.measureElementCache.delete(m));
      });
      return;
    }
    var u = n.measureElementCache.get(l.key);
    u !== r && (u && n.observer.unobserve(u), n.observer.observe(r), n.measureElementCache.set(l.key, r));
    var h = n.options.measureElement(r, a, n);
    n.resizeItem(l, h);
  }, this.resizeItem = function(r, a) {
    var l, u = (l = n.itemSizeCache.get(r.key)) != null ? l : r.size, h = a - u;
    h !== 0 && (r.start < n.scrollOffset && (process.env.NODE_ENV !== "production" && n.options.debug && console.info("correction", h), n._scrollToOffset(n.scrollOffset, {
      adjustments: n.scrollAdjustments += h,
      behavior: void 0
    })), n.pendingMeasuredCacheIndexes.push(r.index), n.itemSizeCache = new Map(n.itemSizeCache.set(r.key, a)), n.notify(!1));
  }, this.measureElement = function(r) {
    r && n._measureElement(r, void 0);
  }, this.getVirtualItems = ta(function() {
    return [n.getIndexes(), n.getMeasurements()];
  }, function(r, a) {
    for (var l = [], u = 0, h = r.length; u < h; u++) {
      var f = r[u], m = a[f];
      l.push(m);
    }
    return l;
  }, {
    key: process.env.NODE_ENV !== "production" && "getIndexes",
    debug: function() {
      return n.options.debug;
    }
  }), this.getVirtualItemForOffset = function(r) {
    var a = n.getMeasurements();
    return Sl(a[Gf(0, a.length - 1, function(l) {
      return Sl(a[l]).start;
    }, r)]);
  }, this.getOffsetForAlignment = function(r, a) {
    var l = n.getSize();
    a === "auto" && (r <= n.scrollOffset ? a = "start" : r >= n.scrollOffset + l ? a = "end" : a = "start"), a === "start" ? r = r : a === "end" ? r = r - l : a === "center" && (r = r - l / 2);
    var u = n.options.horizontal ? "scrollWidth" : "scrollHeight", h = n.scrollElement ? "document" in n.scrollElement ? n.scrollElement.document.documentElement[u] : n.scrollElement[u] : 0, f = h - n.getSize();
    return Math.max(Math.min(f, r), 0);
  }, this.getOffsetForIndex = function(r, a) {
    a === void 0 && (a = "auto"), r = Math.max(0, Math.min(r, n.options.count - 1));
    var l = Sl(n.getMeasurements()[r]);
    if (a === "auto")
      if (l.end >= n.scrollOffset + n.getSize() - n.options.scrollPaddingEnd)
        a = "end";
      else if (l.start <= n.scrollOffset + n.options.scrollPaddingStart)
        a = "start";
      else
        return [n.scrollOffset, a];
    var u = a === "end" ? l.end + n.options.scrollPaddingEnd : l.start - n.options.scrollPaddingStart;
    return [n.getOffsetForAlignment(u, a), a];
  }, this.isDynamicMode = function() {
    return n.measureElementCache.size > 0;
  }, this.cancelScrollToIndex = function() {
    n.scrollToIndexTimeoutId !== null && (clearTimeout(n.scrollToIndexTimeoutId), n.scrollToIndexTimeoutId = null);
  }, this.scrollToOffset = function(r, a) {
    var l = a === void 0 ? {} : a, u = l.align, h = u === void 0 ? "start" : u, f = l.behavior;
    n.cancelScrollToIndex(), f === "smooth" && n.isDynamicMode() && console.warn("The `smooth` scroll behavior is not fully supported with dynamic size."), n._scrollToOffset(n.getOffsetForAlignment(r, h), {
      adjustments: void 0,
      behavior: f
    });
  }, this.scrollToIndex = function(r, a) {
    var l = a === void 0 ? {} : a, u = l.align, h = u === void 0 ? "auto" : u, f = l.behavior;
    r = Math.max(0, Math.min(r, n.options.count - 1)), n.cancelScrollToIndex(), f === "smooth" && n.isDynamicMode() && console.warn("The `smooth` scroll behavior is not fully supported with dynamic size.");
    var m = n.getOffsetForIndex(r, h), v = m[0], y = m[1];
    n._scrollToOffset(v, {
      adjustments: void 0,
      behavior: f
    }), f !== "smooth" && n.isDynamicMode() && (n.scrollToIndexTimeoutId = setTimeout(function() {
      n.scrollToIndexTimeoutId = null;
      var k = n.measureElementCache.has(n.options.getItemKey(r));
      if (k) {
        var x = n.getOffsetForIndex(r, y), M = x[0];
        mb(M, n.scrollOffset) || n.scrollToIndex(r, {
          align: y,
          behavior: f
        });
      } else
        n.scrollToIndex(r, {
          align: y,
          behavior: f
        });
    }));
  }, this.scrollBy = function(r, a) {
    var l = a === void 0 ? {} : a, u = l.behavior;
    n.cancelScrollToIndex(), u === "smooth" && n.isDynamicMode() && console.warn("The `smooth` scroll behavior is not fully supported with dynamic size."), n._scrollToOffset(n.scrollOffset + r, {
      adjustments: void 0,
      behavior: u
    });
  }, this.getTotalSize = function() {
    var r;
    return (((r = n.getMeasurements()[n.options.count - 1]) == null ? void 0 : r.end) || n.options.paddingStart) - n.options.scrollMargin + n.options.paddingEnd;
  }, this._scrollToOffset = function(r, a) {
    var l = a.adjustments, u = a.behavior;
    n.options.scrollToFn(r, {
      behavior: u,
      adjustments: l
    }, n);
  }, this.measure = function() {
    n.itemSizeCache = /* @__PURE__ */ new Map(), n.notify(!1);
  }, this.setOptions(t), this.scrollRect = this.options.initialRect, this.scrollOffset = this.options.initialOffset, this.measurementsCache = this.options.initialMeasurementsCache, this.measurementsCache.forEach(function(r) {
    n.itemSizeCache.set(r.key, r.size);
  }), this.maybeNotify();
}, Gf = function(t, n, r, a) {
  for (; t <= n; ) {
    var l = (t + n) / 2 | 0, u = r(l);
    if (u < a)
      t = l + 1;
    else if (u > a)
      n = l - 1;
    else
      return l;
  }
  return t > 0 ? t - 1 : 0;
};
function xb(e) {
  for (var t = e.measurements, n = e.outerSize, r = e.scrollOffset, a = t.length - 1, l = function(m) {
    return t[m].start;
  }, u = Gf(0, a, l, r), h = u; h < a && t[h].end < r + n; )
    h++;
  return {
    startIndex: u,
    endIndex: h
  };
}
/**
 * vue-virtual
 *
 * Copyright (c) TanStack
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
function Lb(e) {
  var t = new kb(he(e)), n = yf(t), r = t._didMount();
  return kt(function() {
    return he(e).getScrollElement();
  }, function(a) {
    a && t._willUpdate();
  }, {
    immediate: !0
  }), kt(function() {
    return he(e);
  }, function(a) {
    t.setOptions(Os({}, a, {
      onChange: function(u, h) {
        Hc(n), a.onChange == null || a.onChange(u, h);
      }
    })), t._willUpdate(), Hc(n);
  }, {
    immediate: !0
  }), pu(r), n;
}
function Mb(e) {
  return Lb(te(function() {
    return Os({
      observeElementRect: _b,
      observeElementOffset: yb,
      scrollToFn: wb
    }, he(e));
  }));
}
function qf(e, t, n) {
  let r = je(n == null ? void 0 : n.value), a = te(() => e.value !== void 0);
  return [te(() => a.value ? e.value : r.value), function(l) {
    return a.value || (r.value = l), t == null ? void 0 : t(l);
  }];
}
let Sb = 0;
function Pb() {
  return ++Sb;
}
function Ni() {
  return Pb();
}
function Qe(e) {
  var t;
  if (e == null || e.value == null)
    return null;
  let n = (t = e.value.$el) != null ? t : e.value;
  return n instanceof Node ? n : null;
}
function fn(e, t, ...n) {
  if (e in t) {
    let a = t[e];
    return typeof a == "function" ? a(...n) : a;
  }
  let r = new Error(`Tried to handle "${e}" but there is no handler defined. Only defined handlers are: ${Object.keys(t).map((a) => `"${a}"`).join(", ")}.`);
  throw Error.captureStackTrace && Error.captureStackTrace(r, fn), r;
}
var Cb = Object.defineProperty, Ob = (e, t, n) => t in e ? Cb(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, sh = (e, t, n) => (Ob(e, typeof t != "symbol" ? t + "" : t, n), n);
let Eb = class {
  constructor() {
    sh(this, "current", this.detect()), sh(this, "currentId", 0);
  }
  set(t) {
    this.current !== t && (this.currentId = 0, this.current = t);
  }
  reset() {
    this.set(this.detect());
  }
  nextId() {
    return ++this.currentId;
  }
  get isServer() {
    return this.current === "server";
  }
  get isClient() {
    return this.current === "client";
  }
  detect() {
    return typeof window > "u" || typeof document > "u" ? "server" : "client";
  }
}, Lu = new Eb();
function Mu(e) {
  if (Lu.isServer)
    return null;
  if (e instanceof Node)
    return e.ownerDocument;
  if (e != null && e.hasOwnProperty("value")) {
    let t = Qe(e);
    if (t)
      return t.ownerDocument;
  }
  return document;
}
let lh = ["[contentEditable=true]", "[tabindex]", "a[href]", "area[href]", "button:not([disabled])", "iframe", "input:not([disabled])", "select:not([disabled])", "textarea:not([disabled])"].map((e) => `${e}:not([tabindex='-1'])`).join(",");
var Tb = ((e) => (e[e.First = 1] = "First", e[e.Previous = 2] = "Previous", e[e.Next = 4] = "Next", e[e.Last = 8] = "Last", e[e.WrapAround = 16] = "WrapAround", e[e.NoScroll = 32] = "NoScroll", e))(Tb || {}), Db = ((e) => (e[e.Error = 0] = "Error", e[e.Overflow = 1] = "Overflow", e[e.Success = 2] = "Success", e[e.Underflow = 3] = "Underflow", e))(Db || {}), Ib = ((e) => (e[e.Previous = -1] = "Previous", e[e.Next = 1] = "Next", e))(Ib || {}), Su = ((e) => (e[e.Strict = 0] = "Strict", e[e.Loose = 1] = "Loose", e))(Su || {});
function Kf(e, t = 0) {
  var n;
  return e === ((n = Mu(e)) == null ? void 0 : n.body) ? !1 : fn(t, { 0() {
    return e.matches(lh);
  }, 1() {
    let r = e;
    for (; r !== null; ) {
      if (r.matches(lh))
        return !0;
      r = r.parentElement;
    }
    return !1;
  } });
}
var Ab = ((e) => (e[e.Keyboard = 0] = "Keyboard", e[e.Mouse = 1] = "Mouse", e))(Ab || {});
typeof window < "u" && typeof document < "u" && (document.addEventListener("keydown", (e) => {
  e.metaKey || e.altKey || e.ctrlKey || (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0), document.addEventListener("click", (e) => {
  e.detail === 1 ? delete document.documentElement.dataset.headlessuiFocusVisible : e.detail === 0 && (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0));
function Jf(e, t = (n) => n) {
  return e.slice().sort((n, r) => {
    let a = t(n), l = t(r);
    if (a === null || l === null)
      return 0;
    let u = a.compareDocumentPosition(l);
    return u & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : u & Node.DOCUMENT_POSITION_PRECEDING ? 1 : 0;
  });
}
function Rb() {
  return /iPhone/gi.test(window.navigator.platform) || /Mac/gi.test(window.navigator.platform) && window.navigator.maxTouchPoints > 0;
}
function Bb() {
  return /Android/gi.test(window.navigator.userAgent);
}
function Xf() {
  return Rb() || Bb();
}
function qo(e, t, n) {
  Lu.isServer || ti((r) => {
    document.addEventListener(e, t, n), r(() => document.removeEventListener(e, t, n));
  });
}
function $b(e, t, n) {
  Lu.isServer || ti((r) => {
    window.addEventListener(e, t, n), r(() => window.removeEventListener(e, t, n));
  });
}
function Qf(e, t, n = te(() => !0)) {
  function r(l, u) {
    if (!n.value || l.defaultPrevented)
      return;
    let h = u(l);
    if (h === null || !h.getRootNode().contains(h))
      return;
    let f = function m(v) {
      return typeof v == "function" ? m(v()) : Array.isArray(v) || v instanceof Set ? v : [v];
    }(e);
    for (let m of f) {
      if (m === null)
        continue;
      let v = m instanceof HTMLElement ? m : Qe(m);
      if (v != null && v.contains(h) || l.composed && l.composedPath().includes(v))
        return;
    }
    return !Kf(h, Su.Loose) && h.tabIndex !== -1 && l.preventDefault(), t(l, h);
  }
  let a = je(null);
  qo("pointerdown", (l) => {
    var u, h;
    n.value && (a.value = ((h = (u = l.composedPath) == null ? void 0 : u.call(l)) == null ? void 0 : h[0]) || l.target);
  }, !0), qo("mousedown", (l) => {
    var u, h;
    n.value && (a.value = ((h = (u = l.composedPath) == null ? void 0 : u.call(l)) == null ? void 0 : h[0]) || l.target);
  }, !0), qo("click", (l) => {
    Xf() || a.value && (r(l, () => a.value), a.value = null);
  }, !0), qo("touchend", (l) => r(l, () => l.target instanceof HTMLElement ? l.target : null), !0), $b("blur", (l) => r(l, () => window.document.activeElement instanceof HTMLIFrameElement ? window.document.activeElement : null), !0);
}
function uh(e, t) {
  if (e)
    return e;
  let n = t ?? "button";
  if (typeof n == "string" && n.toLowerCase() === "button")
    return "button";
}
function ep(e, t) {
  let n = je(uh(e.value.type, e.value.as));
  return In(() => {
    n.value = uh(e.value.type, e.value.as);
  }), ti(() => {
    var r;
    n.value || Qe(t) && Qe(t) instanceof HTMLButtonElement && !((r = Qe(t)) != null && r.hasAttribute("type")) && (n.value = "button");
  }), n;
}
function ch(e) {
  return [e.screenX, e.screenY];
}
function tp() {
  let e = je([-1, -1]);
  return { wasMoved(t) {
    let n = ch(t);
    return e.value[0] === n[0] && e.value[1] === n[1] ? !1 : (e.value = n, !0);
  }, update(t) {
    e.value = ch(t);
  } };
}
function Nb({ container: e, accept: t, walk: n, enabled: r }) {
  ti(() => {
    let a = e.value;
    if (!a || r !== void 0 && !r.value)
      return;
    let l = Mu(e);
    if (!l)
      return;
    let u = Object.assign((f) => t(f), { acceptNode: t }), h = l.createTreeWalker(a, NodeFilter.SHOW_ELEMENT, u, !1);
    for (; h.nextNode(); )
      n(h.currentNode);
  });
}
var Tr = ((e) => (e[e.None = 0] = "None", e[e.RenderStrategy = 1] = "RenderStrategy", e[e.Static = 2] = "Static", e))(Tr || {}), zb = ((e) => (e[e.Unmount = 0] = "Unmount", e[e.Hidden = 1] = "Hidden", e))(zb || {});
function Hn({ visible: e = !0, features: t = 0, ourProps: n, theirProps: r, ...a }) {
  var l;
  let u = ip(r, n), h = Object.assign(a, { props: u });
  if (e || t & 2 && u.static)
    return Pl(h);
  if (t & 1) {
    let f = (l = u.unmount) == null || l ? 0 : 1;
    return fn(f, { 0() {
      return null;
    }, 1() {
      return Pl({ ...a, props: { ...u, hidden: !0, style: { display: "none" } } });
    } });
  }
  return Pl(h);
}
function Pl({ props: e, attrs: t, slots: n, slot: r, name: a }) {
  var l, u;
  let { as: h, ...f } = bo(e, ["unmount", "static"]), m = (l = n.default) == null ? void 0 : l.call(n, r), v = {};
  if (r) {
    let y = !1, k = [];
    for (let [x, M] of Object.entries(r))
      typeof M == "boolean" && (y = !0), M === !0 && k.push(x);
    y && (v["data-headlessui-state"] = k.join(" "));
  }
  if (h === "template") {
    if (m = np(m ?? []), Object.keys(f).length > 0 || Object.keys(t).length > 0) {
      let [y, ...k] = m ?? [];
      if (!Fb(y) || k.length > 0)
        throw new Error(['Passing props on "template"!', "", `The current component <${a} /> is rendering a "template".`, "However we need to passthrough the following props:", Object.keys(f).concat(Object.keys(t)).map((O) => O.trim()).filter((O, R, C) => C.indexOf(O) === R).sort((O, R) => O.localeCompare(R)).map((O) => `  - ${O}`).join(`
`), "", "You can apply a few solutions:", ['Add an `as="..."` prop, to ensure that we render an actual element instead of a "template".', "Render a single element as the child so that we can forward the props onto that element."].map((O) => `  - ${O}`).join(`
`)].join(`
`));
      let x = ip((u = y.props) != null ? u : {}, f, v), M = wf(y, x, !0);
      for (let O in x)
        O.startsWith("on") && (M.props || (M.props = {}), M.props[O] = x[O]);
      return M;
    }
    return Array.isArray(m) && m.length === 1 ? m[0] : m;
  }
  return Cr(h, Object.assign({}, f, v), { default: () => m });
}
function np(e) {
  return e.flatMap((t) => t.type === Et ? np(t.children) : [t]);
}
function ip(...e) {
  if (e.length === 0)
    return {};
  if (e.length === 1)
    return e[0];
  let t = {}, n = {};
  for (let r of e)
    for (let a in r)
      a.startsWith("on") && typeof r[a] == "function" ? (n[a] != null || (n[a] = []), n[a].push(r[a])) : t[a] = r[a];
  if (t.disabled || t["aria-disabled"])
    return Object.assign(t, Object.fromEntries(Object.keys(n).map((r) => [r, void 0])));
  for (let r in n)
    Object.assign(t, { [r](a, ...l) {
      let u = n[r];
      for (let h of u) {
        if (a instanceof Event && a.defaultPrevented)
          return;
        h(a, ...l);
      }
    } });
  return t;
}
function rp(e) {
  let t = Object.assign({}, e);
  for (let n in t)
    t[n] === void 0 && delete t[n];
  return t;
}
function bo(e, t = []) {
  let n = Object.assign({}, e);
  for (let r of t)
    r in n && delete n[r];
  return n;
}
function Fb(e) {
  return e == null ? !1 : typeof e.type == "string" || typeof e.type == "object" || typeof e.type == "function";
}
var Pu = ((e) => (e[e.None = 1] = "None", e[e.Focusable = 2] = "Focusable", e[e.Hidden = 4] = "Hidden", e))(Pu || {});
let ap = tt({ name: "Hidden", props: { as: { type: [Object, String], default: "div" }, features: { type: Number, default: 1 } }, setup(e, { slots: t, attrs: n }) {
  return () => {
    var r;
    let { features: a, ...l } = e, u = { "aria-hidden": (a & 2) === 2 ? !0 : (r = l["aria-hidden"]) != null ? r : void 0, style: { position: "fixed", top: 1, left: 1, width: 1, height: 0, padding: 0, margin: -1, overflow: "hidden", clip: "rect(0, 0, 0, 0)", whiteSpace: "nowrap", borderWidth: "0", ...(a & 4) === 4 && (a & 2) !== 2 && { display: "none" } } };
    return Hn({ ourProps: u, theirProps: l, slot: {}, attrs: n, slots: t, name: "Hidden" });
  };
} }), op = Symbol("Context");
var Ti = ((e) => (e[e.Open = 1] = "Open", e[e.Closed = 2] = "Closed", e[e.Closing = 4] = "Closing", e[e.Opening = 8] = "Opening", e))(Ti || {});
function sp() {
  return Ri(op, null);
}
function lp(e) {
  Bi(op, e);
}
var Ot = ((e) => (e.Space = " ", e.Enter = "Enter", e.Escape = "Escape", e.Backspace = "Backspace", e.Delete = "Delete", e.ArrowLeft = "ArrowLeft", e.ArrowUp = "ArrowUp", e.ArrowRight = "ArrowRight", e.ArrowDown = "ArrowDown", e.Home = "Home", e.End = "End", e.PageUp = "PageUp", e.PageDown = "PageDown", e.Tab = "Tab", e))(Ot || {});
function jb(e) {
  function t() {
    document.readyState !== "loading" && (e(), document.removeEventListener("DOMContentLoaded", t));
  }
  typeof window < "u" && typeof document < "u" && (document.addEventListener("DOMContentLoaded", t), t());
}
let xr = [];
jb(() => {
  function e(t) {
    t.target instanceof HTMLElement && t.target !== document.body && xr[0] !== t.target && (xr.unshift(t.target), xr = xr.filter((n) => n != null && n.isConnected), xr.splice(10));
  }
  window.addEventListener("click", e, { capture: !0 }), window.addEventListener("mousedown", e, { capture: !0 }), window.addEventListener("focus", e, { capture: !0 }), document.body.addEventListener("click", e, { capture: !0 }), document.body.addEventListener("mousedown", e, { capture: !0 }), document.body.addEventListener("focus", e, { capture: !0 });
});
function Vb(e) {
  throw new Error("Unexpected object: " + e);
}
var Pt = ((e) => (e[e.First = 0] = "First", e[e.Previous = 1] = "Previous", e[e.Next = 2] = "Next", e[e.Last = 3] = "Last", e[e.Specific = 4] = "Specific", e[e.Nothing = 5] = "Nothing", e))(Pt || {});
function Gl(e, t) {
  let n = t.resolveItems();
  if (n.length <= 0)
    return null;
  let r = t.resolveActiveIndex(), a = r ?? -1;
  switch (e.focus) {
    case 0: {
      for (let l = 0; l < n.length; ++l)
        if (!t.resolveDisabled(n[l], l, n))
          return l;
      return r;
    }
    case 1: {
      a === -1 && (a = n.length);
      for (let l = a - 1; l >= 0; --l)
        if (!t.resolveDisabled(n[l], l, n))
          return l;
      return r;
    }
    case 2: {
      for (let l = a + 1; l < n.length; ++l)
        if (!t.resolveDisabled(n[l], l, n))
          return l;
      return r;
    }
    case 3: {
      for (let l = n.length - 1; l >= 0; --l)
        if (!t.resolveDisabled(n[l], l, n))
          return l;
      return r;
    }
    case 4: {
      for (let l = 0; l < n.length; ++l)
        if (t.resolveId(n[l], l, n) === e.id)
          return l;
      return r;
    }
    case 5:
      return null;
    default:
      Vb(e);
  }
}
function Yb(e) {
  typeof queueMicrotask == "function" ? queueMicrotask(e) : Promise.resolve().then(e).catch((t) => setTimeout(() => {
    throw t;
  }));
}
function ql() {
  let e = [], t = { addEventListener(n, r, a, l) {
    return n.addEventListener(r, a, l), t.add(() => n.removeEventListener(r, a, l));
  }, requestAnimationFrame(...n) {
    let r = requestAnimationFrame(...n);
    t.add(() => cancelAnimationFrame(r));
  }, nextFrame(...n) {
    t.requestAnimationFrame(() => {
      t.requestAnimationFrame(...n);
    });
  }, setTimeout(...n) {
    let r = setTimeout(...n);
    t.add(() => clearTimeout(r));
  }, microTask(...n) {
    let r = { current: !0 };
    return Yb(() => {
      r.current && n[0]();
    }), t.add(() => {
      r.current = !1;
    });
  }, style(n, r, a) {
    let l = n.style.getPropertyValue(r);
    return Object.assign(n.style, { [r]: a }), this.add(() => {
      Object.assign(n.style, { [r]: l });
    });
  }, group(n) {
    let r = ql();
    return n(r), this.add(() => r.dispose());
  }, add(n) {
    return e.push(n), () => {
      let r = e.indexOf(n);
      if (r >= 0)
        for (let a of e.splice(r, 1))
          a();
    };
  }, dispose() {
    for (let n of e.splice(0))
      n();
  } };
  return t;
}
function Cu(e = {}, t = null, n = []) {
  for (let [r, a] of Object.entries(e))
    cp(n, up(t, r), a);
  return n;
}
function up(e, t) {
  return e ? e + "[" + t + "]" : t;
}
function cp(e, t, n) {
  if (Array.isArray(n))
    for (let [r, a] of n.entries())
      cp(e, up(t, r.toString()), a);
  else
    n instanceof Date ? e.push([t, n.toISOString()]) : typeof n == "boolean" ? e.push([t, n ? "1" : "0"]) : typeof n == "string" ? e.push([t, n]) : typeof n == "number" ? e.push([t, `${n}`]) : n == null ? e.push([t, ""]) : Cu(n, t, e);
}
function Hb(e, t) {
  return e === t;
}
var Ub = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(Ub || {}), Zb = ((e) => (e[e.Single = 0] = "Single", e[e.Multi = 1] = "Multi", e))(Zb || {}), Wb = ((e) => (e[e.Pointer = 0] = "Pointer", e[e.Focus = 1] = "Focus", e[e.Other = 2] = "Other", e))(Wb || {});
let hp = Symbol("ComboboxContext");
function Ar(e) {
  let t = Ri(hp, null);
  if (t === null) {
    let n = new Error(`<${e} /> is missing a parent <Combobox /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, Ar), n;
  }
  return t;
}
let dp = Symbol("VirtualContext"), Gb = tt({ name: "VirtualProvider", setup(e, { slots: t }) {
  let n = Ar("VirtualProvider"), r = te(() => {
    let h = Qe(n.optionsRef);
    if (!h)
      return { start: 0, end: 0 };
    let f = window.getComputedStyle(h);
    return { start: parseFloat(f.paddingBlockStart || f.paddingTop), end: parseFloat(f.paddingBlockEnd || f.paddingBottom) };
  }), a = Mb(te(() => ({ scrollPaddingStart: r.value.start, scrollPaddingEnd: r.value.end, count: n.virtual.value.options.length, estimateSize() {
    return 40;
  }, getScrollElement() {
    return Qe(n.optionsRef);
  }, overscan: 12 }))), l = te(() => {
    var h;
    return (h = n.virtual.value) == null ? void 0 : h.options;
  }), u = je(0);
  return kt([l], () => {
    u.value += 1;
  }), Bi(dp, n.virtual.value ? a : null), () => [Cr("div", { style: { position: "relative", width: "100%", height: `${a.value.getTotalSize()}px` }, ref: (h) => {
    if (h) {
      if (typeof process < "u" && process.env.JEST_WORKER_ID !== void 0 || n.activationTrigger.value === 0)
        return;
      n.activeOptionIndex.value !== null && n.virtual.value.options.length > n.activeOptionIndex.value && a.value.scrollToIndex(n.activeOptionIndex.value);
    }
  } }, a.value.getVirtualItems().map((h) => wf(t.default({ option: n.virtual.value.options[h.index], open: n.comboboxState.value === 0 })[0], { key: `${u.value}-${h.index}`, "data-index": h.index, "aria-setsize": n.virtual.value.options.length, "aria-posinset": h.index + 1, style: { position: "absolute", top: 0, left: 0, transform: `translateY(${h.start}px)`, overflowAnchor: "none" } })))];
} }), hh = tt({ name: "Combobox", emits: { "update:modelValue": (e) => !0 }, props: { as: { type: [Object, String], default: "template" }, disabled: { type: [Boolean], default: !1 }, by: { type: [String, Function], nullable: !0, default: null }, modelValue: { type: [Object, String, Number, Boolean], default: void 0 }, defaultValue: { type: [Object, String, Number, Boolean], default: void 0 }, form: { type: String, optional: !0 }, name: { type: String, optional: !0 }, nullable: { type: Boolean, default: !1 }, multiple: { type: [Boolean], default: !1 }, immediate: { type: [Boolean], default: !1 }, virtual: { type: Object, default: null } }, inheritAttrs: !1, setup(e, { slots: t, attrs: n, emit: r }) {
  let a = je(1), l = je(null), u = je(null), h = je(null), f = je(null), m = je({ static: !1, hold: !1 }), v = je([]), y = je(null), k = je(2), x = je(!1);
  function M(X = (ae) => ae) {
    let ae = y.value !== null ? v.value[y.value] : null, ne = X(v.value.slice()), se = ne.length > 0 && ne[0].dataRef.order.value !== null ? ne.sort((Q, ke) => Q.dataRef.order.value - ke.dataRef.order.value) : Jf(ne, (Q) => Qe(Q.dataRef.domRef)), re = ae ? se.indexOf(ae) : null;
    return re === -1 && (re = null), { options: se, activeOptionIndex: re };
  }
  let O = te(() => e.multiple ? 1 : 0), R = te(() => e.nullable), [C, T] = qf(te(() => e.modelValue), (X) => r("update:modelValue", X), te(() => e.defaultValue)), A = te(() => C.value === void 0 ? fn(O.value, { 1: [], 0: void 0 }) : C.value), P = null, D = null;
  function $(X) {
    return fn(O.value, { 0() {
      return T == null ? void 0 : T(X);
    }, 1: () => {
      let ae = tn(G.value.value).slice(), ne = tn(X), se = ae.findIndex((re) => G.compare(ne, tn(re)));
      return se === -1 ? ae.push(ne) : ae.splice(se, 1), T == null ? void 0 : T(ae);
    } });
  }
  let Y = te(() => {
  });
  kt([Y], ([X], [ae]) => {
    if (G.virtual.value && X && ae && y.value !== null) {
      let ne = X.indexOf(ae[y.value]);
      ne !== -1 ? y.value = ne : y.value = null;
    }
  });
  let G = { comboboxState: a, value: A, mode: O, compare(X, ae) {
    if (typeof e.by == "string") {
      let ne = e.by;
      return (X == null ? void 0 : X[ne]) === (ae == null ? void 0 : ae[ne]);
    }
    return e.by === null ? Hb(X, ae) : e.by(X, ae);
  }, calculateIndex(X) {
    return G.virtual.value ? e.by === null ? G.virtual.value.options.indexOf(X) : G.virtual.value.options.findIndex((ae) => G.compare(ae, X)) : v.value.findIndex((ae) => G.compare(ae.dataRef.value, X));
  }, defaultValue: te(() => e.defaultValue), nullable: R, immediate: te(() => !1), virtual: te(() => null), inputRef: u, labelRef: l, buttonRef: h, optionsRef: f, disabled: te(() => e.disabled), options: v, change(X) {
    T(X);
  }, activeOptionIndex: te(() => {
    if (x.value && y.value === null && (G.virtual.value ? G.virtual.value.options.length > 0 : v.value.length > 0)) {
      if (G.virtual.value) {
        let ae = G.virtual.value.options.findIndex((ne) => {
          var se;
          return !((se = G.virtual.value) != null && se.disabled(ne));
        });
        if (ae !== -1)
          return ae;
      }
      let X = v.value.findIndex((ae) => !ae.dataRef.disabled);
      if (X !== -1)
        return X;
    }
    return y.value;
  }), activationTrigger: k, optionsPropsRef: m, closeCombobox() {
    x.value = !1, !e.disabled && a.value !== 1 && (a.value = 1, y.value = null);
  }, openCombobox() {
    if (x.value = !0, !e.disabled && a.value !== 0) {
      if (G.value.value) {
        let X = G.calculateIndex(G.value.value);
        X !== -1 && (y.value = X);
      }
      a.value = 0;
    }
  }, setActivationTrigger(X) {
    k.value = X;
  }, goToOption(X, ae, ne) {
    x.value = !1, P !== null && cancelAnimationFrame(P), P = requestAnimationFrame(() => {
      if (e.disabled || f.value && !m.value.static && a.value === 1)
        return;
      if (G.virtual.value) {
        y.value = X === Pt.Specific ? ae : Gl({ focus: X }, { resolveItems: () => G.virtual.value.options, resolveActiveIndex: () => {
          var Q, ke;
          return (ke = (Q = G.activeOptionIndex.value) != null ? Q : G.virtual.value.options.findIndex((Ae) => {
            var pe;
            return !((pe = G.virtual.value) != null && pe.disabled(Ae));
          })) != null ? ke : null;
        }, resolveDisabled: (Q) => G.virtual.value.disabled(Q), resolveId() {
          throw new Error("Function not implemented.");
        } }), k.value = ne ?? 2;
        return;
      }
      let se = M();
      if (se.activeOptionIndex === null) {
        let Q = se.options.findIndex((ke) => !ke.dataRef.disabled);
        Q !== -1 && (se.activeOptionIndex = Q);
      }
      let re = X === Pt.Specific ? ae : Gl({ focus: X }, { resolveItems: () => se.options, resolveActiveIndex: () => se.activeOptionIndex, resolveId: (Q) => Q.id, resolveDisabled: (Q) => Q.dataRef.disabled });
      y.value = re, k.value = ne ?? 2, v.value = se.options;
    });
  }, selectOption(X) {
    let ae = v.value.find((se) => se.id === X);
    if (!ae)
      return;
    let { dataRef: ne } = ae;
    $(ne.value);
  }, selectActiveOption() {
    if (G.activeOptionIndex.value !== null) {
      if (G.virtual.value)
        $(G.virtual.value.options[G.activeOptionIndex.value]);
      else {
        let { dataRef: X } = v.value[G.activeOptionIndex.value];
        $(X.value);
      }
      G.goToOption(Pt.Specific, G.activeOptionIndex.value);
    }
  }, registerOption(X, ae) {
    let ne = Ir({ id: X, dataRef: ae });
    if (G.virtual.value) {
      v.value.push(ne);
      return;
    }
    D && cancelAnimationFrame(D);
    let se = M((re) => (re.push(ne), re));
    y.value === null && G.isSelected(ae.value.value) && (se.activeOptionIndex = se.options.indexOf(ne)), v.value = se.options, y.value = se.activeOptionIndex, k.value = 2, se.options.some((re) => !Qe(re.dataRef.domRef)) && (D = requestAnimationFrame(() => {
      let re = M();
      v.value = re.options, y.value = re.activeOptionIndex;
    }));
  }, unregisterOption(X, ae) {
    if (P !== null && cancelAnimationFrame(P), ae && (x.value = !0), G.virtual.value) {
      v.value = v.value.filter((se) => se.id !== X);
      return;
    }
    let ne = M((se) => {
      let re = se.findIndex((Q) => Q.id === X);
      return re !== -1 && se.splice(re, 1), se;
    });
    v.value = ne.options, y.value = ne.activeOptionIndex, k.value = 2;
  }, isSelected(X) {
    return fn(O.value, { 0: () => G.compare(tn(G.value.value), tn(X)), 1: () => tn(G.value.value).some((ae) => G.compare(tn(ae), tn(X))) });
  }, isActive(X) {
    return y.value === G.calculateIndex(X);
  } };
  Qf([u, h, f], () => G.closeCombobox(), te(() => a.value === 0)), Bi(hp, G), lp(te(() => fn(a.value, { 0: Ti.Open, 1: Ti.Closed })));
  let ee = te(() => {
    var X;
    return (X = Qe(u)) == null ? void 0 : X.closest("form");
  });
  return In(() => {
    kt([ee], () => {
      if (!ee.value || e.defaultValue === void 0)
        return;
      function X() {
        G.change(e.defaultValue);
      }
      return ee.value.addEventListener("reset", X), () => {
        var ae;
        (ae = ee.value) == null || ae.removeEventListener("reset", X);
      };
    }, { immediate: !0 });
  }), () => {
    var X, ae, ne;
    let { name: se, disabled: re, form: Q, ...ke } = e, Ae = { open: a.value === 0, disabled: re, activeIndex: G.activeOptionIndex.value, activeOption: G.activeOptionIndex.value === null ? null : G.virtual.value ? G.virtual.value.options[(X = G.activeOptionIndex.value) != null ? X : 0] : (ne = (ae = G.options.value[G.activeOptionIndex.value]) == null ? void 0 : ae.dataRef.value.value) != null ? ne : null, value: A.value };
    return Cr(Et, [...se != null && A.value != null ? Cu({ [se]: A.value }).map(([pe, Ye]) => Cr(ap, rp({ features: Pu.Hidden, key: pe, as: "input", type: "hidden", hidden: !0, readOnly: !0, form: Q, name: pe, value: Ye }))) : [], Hn({ theirProps: { ...n, ...bo(ke, ["by", "defaultValue", "immediate", "modelValue", "multiple", "nullable", "onUpdate:modelValue", "virtual"]) }, ourProps: {}, slot: Ae, slots: t, attrs: n, name: "Combobox" })]);
  };
} });
tt({ name: "ComboboxLabel", props: { as: { type: [Object, String], default: "label" }, id: { type: String, default: () => `headlessui-combobox-label-${Ni()}` } }, setup(e, { attrs: t, slots: n }) {
  let r = Ar("ComboboxLabel");
  function a() {
    var l;
    (l = Qe(r.inputRef)) == null || l.focus({ preventScroll: !0 });
  }
  return () => {
    let l = { open: r.comboboxState.value === 0, disabled: r.disabled.value }, { id: u, ...h } = e, f = { id: u, ref: r.labelRef, onClick: a };
    return Hn({ ourProps: f, theirProps: h, slot: l, attrs: t, slots: n, name: "ComboboxLabel" });
  };
} });
tt({ name: "ComboboxButton", props: { as: { type: [Object, String], default: "button" }, id: { type: String, default: () => `headlessui-combobox-button-${Ni()}` } }, setup(e, { attrs: t, slots: n, expose: r }) {
  let a = Ar("ComboboxButton");
  r({ el: a.buttonRef, $el: a.buttonRef });
  function l(f) {
    a.disabled.value || (a.comboboxState.value === 0 ? a.closeCombobox() : (f.preventDefault(), a.openCombobox()), nn(() => {
      var m;
      return (m = Qe(a.inputRef)) == null ? void 0 : m.focus({ preventScroll: !0 });
    }));
  }
  function u(f) {
    switch (f.key) {
      case Ot.ArrowDown:
        f.preventDefault(), f.stopPropagation(), a.comboboxState.value === 1 && a.openCombobox(), nn(() => {
          var m;
          return (m = a.inputRef.value) == null ? void 0 : m.focus({ preventScroll: !0 });
        });
        return;
      case Ot.ArrowUp:
        f.preventDefault(), f.stopPropagation(), a.comboboxState.value === 1 && (a.openCombobox(), nn(() => {
          a.value.value || a.goToOption(Pt.Last);
        })), nn(() => {
          var m;
          return (m = a.inputRef.value) == null ? void 0 : m.focus({ preventScroll: !0 });
        });
        return;
      case Ot.Escape:
        if (a.comboboxState.value !== 0)
          return;
        f.preventDefault(), a.optionsRef.value && !a.optionsPropsRef.value.static && f.stopPropagation(), a.closeCombobox(), nn(() => {
          var m;
          return (m = a.inputRef.value) == null ? void 0 : m.focus({ preventScroll: !0 });
        });
        return;
    }
  }
  let h = ep(te(() => ({ as: e.as, type: t.type })), a.buttonRef);
  return () => {
    var f, m;
    let v = { open: a.comboboxState.value === 0, disabled: a.disabled.value, value: a.value.value }, { id: y, ...k } = e, x = { ref: a.buttonRef, id: y, type: h.value, tabindex: "-1", "aria-haspopup": "listbox", "aria-controls": (f = Qe(a.optionsRef)) == null ? void 0 : f.id, "aria-expanded": a.comboboxState.value === 0, "aria-labelledby": a.labelRef.value ? [(m = Qe(a.labelRef)) == null ? void 0 : m.id, y].join(" ") : void 0, disabled: a.disabled.value === !0 ? !0 : void 0, onKeydown: u, onClick: l };
    return Hn({ ourProps: x, theirProps: k, slot: v, attrs: t, slots: n, name: "ComboboxButton" });
  };
} });
let dh = tt({ name: "ComboboxInput", props: { as: { type: [Object, String], default: "input" }, static: { type: Boolean, default: !1 }, unmount: { type: Boolean, default: !0 }, displayValue: { type: Function }, defaultValue: { type: String, default: void 0 }, id: { type: String, default: () => `headlessui-combobox-input-${Ni()}` } }, emits: { change: (e) => !0 }, setup(e, { emit: t, attrs: n, slots: r, expose: a }) {
  let l = Ar("ComboboxInput"), u = te(() => Mu(Qe(l.inputRef))), h = { value: !1 };
  a({ el: l.inputRef, $el: l.inputRef });
  function f() {
    l.change(null);
    let T = Qe(l.optionsRef);
    T && (T.scrollTop = 0), l.goToOption(Pt.Nothing);
  }
  let m = te(() => {
    var T;
    let A = l.value.value;
    return Qe(l.inputRef) ? typeof e.displayValue < "u" && A !== void 0 ? (T = e.displayValue(A)) != null ? T : "" : typeof A == "string" ? A : "" : "";
  });
  In(() => {
    kt([m, l.comboboxState, u], ([T, A], [P, D]) => {
      if (h.value)
        return;
      let $ = Qe(l.inputRef);
      $ && ((D === 0 && A === 1 || T !== P) && ($.value = T), requestAnimationFrame(() => {
        var Y;
        if (h.value || !$ || ((Y = u.value) == null ? void 0 : Y.activeElement) !== $)
          return;
        let { selectionStart: G, selectionEnd: ee } = $;
        Math.abs((ee ?? 0) - (G ?? 0)) === 0 && G === 0 && $.setSelectionRange($.value.length, $.value.length);
      }));
    }, { immediate: !0 }), kt([l.comboboxState], ([T], [A]) => {
      if (T === 0 && A === 1) {
        if (h.value)
          return;
        let P = Qe(l.inputRef);
        if (!P)
          return;
        let D = P.value, { selectionStart: $, selectionEnd: Y, selectionDirection: G } = P;
        P.value = "", P.value = D, G !== null ? P.setSelectionRange($, Y, G) : P.setSelectionRange($, Y);
      }
    });
  });
  let v = je(!1);
  function y() {
    v.value = !0;
  }
  function k() {
    ql().nextFrame(() => {
      v.value = !1;
    });
  }
  function x(T) {
    switch (h.value = !0, T.key) {
      case Ot.Enter:
        if (h.value = !1, l.comboboxState.value !== 0 || v.value)
          return;
        if (T.preventDefault(), T.stopPropagation(), l.activeOptionIndex.value === null) {
          l.closeCombobox();
          return;
        }
        l.selectActiveOption(), l.mode.value === 0 && l.closeCombobox();
        break;
      case Ot.ArrowDown:
        return h.value = !1, T.preventDefault(), T.stopPropagation(), fn(l.comboboxState.value, { 0: () => l.goToOption(Pt.Next), 1: () => l.openCombobox() });
      case Ot.ArrowUp:
        return h.value = !1, T.preventDefault(), T.stopPropagation(), fn(l.comboboxState.value, { 0: () => l.goToOption(Pt.Previous), 1: () => {
          l.openCombobox(), nn(() => {
            l.value.value || l.goToOption(Pt.Last);
          });
        } });
      case Ot.Home:
        if (T.shiftKey)
          break;
        return h.value = !1, T.preventDefault(), T.stopPropagation(), l.goToOption(Pt.First);
      case Ot.PageUp:
        return h.value = !1, T.preventDefault(), T.stopPropagation(), l.goToOption(Pt.First);
      case Ot.End:
        if (T.shiftKey)
          break;
        return h.value = !1, T.preventDefault(), T.stopPropagation(), l.goToOption(Pt.Last);
      case Ot.PageDown:
        return h.value = !1, T.preventDefault(), T.stopPropagation(), l.goToOption(Pt.Last);
      case Ot.Escape:
        if (h.value = !1, l.comboboxState.value !== 0)
          return;
        T.preventDefault(), l.optionsRef.value && !l.optionsPropsRef.value.static && T.stopPropagation(), l.nullable.value && l.mode.value === 0 && l.value.value === null && f(), l.closeCombobox();
        break;
      case Ot.Tab:
        if (h.value = !1, l.comboboxState.value !== 0)
          return;
        l.mode.value === 0 && l.activationTrigger.value !== 1 && l.selectActiveOption(), l.closeCombobox();
        break;
    }
  }
  function M(T) {
    t("change", T), l.nullable.value && l.mode.value === 0 && T.target.value === "" && f(), l.openCombobox();
  }
  function O(T) {
    var A, P, D;
    let $ = (A = T.relatedTarget) != null ? A : xr.find((Y) => Y !== T.currentTarget);
    if (h.value = !1, !((P = Qe(l.optionsRef)) != null && P.contains($)) && !((D = Qe(l.buttonRef)) != null && D.contains($)) && l.comboboxState.value === 0)
      return T.preventDefault(), l.mode.value === 0 && (l.nullable.value && l.value.value === null ? f() : l.activationTrigger.value !== 1 && l.selectActiveOption()), l.closeCombobox();
  }
  function R(T) {
    var A, P, D;
    let $ = (A = T.relatedTarget) != null ? A : xr.find((Y) => Y !== T.currentTarget);
    (P = Qe(l.buttonRef)) != null && P.contains($) || (D = Qe(l.optionsRef)) != null && D.contains($) || l.disabled.value || l.immediate.value && l.comboboxState.value !== 0 && (l.openCombobox(), ql().nextFrame(() => {
      l.setActivationTrigger(1);
    }));
  }
  let C = te(() => {
    var T, A, P, D;
    return (D = (P = (A = e.defaultValue) != null ? A : l.defaultValue.value !== void 0 ? (T = e.displayValue) == null ? void 0 : T.call(e, l.defaultValue.value) : null) != null ? P : l.defaultValue.value) != null ? D : "";
  });
  return () => {
    var T, A, P, D, $, Y, G;
    let ee = { open: l.comboboxState.value === 0 }, { id: X, displayValue: ae, onChange: ne, ...se } = e, re = { "aria-controls": (T = l.optionsRef.value) == null ? void 0 : T.id, "aria-expanded": l.comboboxState.value === 0, "aria-activedescendant": l.activeOptionIndex.value === null ? void 0 : l.virtual.value ? (A = l.options.value.find((Q) => !l.virtual.value.disabled(Q.dataRef.value) && l.compare(Q.dataRef.value, l.virtual.value.options[l.activeOptionIndex.value]))) == null ? void 0 : A.id : (P = l.options.value[l.activeOptionIndex.value]) == null ? void 0 : P.id, "aria-labelledby": (Y = (D = Qe(l.labelRef)) == null ? void 0 : D.id) != null ? Y : ($ = Qe(l.buttonRef)) == null ? void 0 : $.id, "aria-autocomplete": "list", id: X, onCompositionstart: y, onCompositionend: k, onKeydown: x, onInput: M, onFocus: R, onBlur: O, role: "combobox", type: (G = n.type) != null ? G : "text", tabIndex: 0, ref: l.inputRef, defaultValue: C.value, disabled: l.disabled.value === !0 ? !0 : void 0 };
    return Hn({ ourProps: re, theirProps: se, slot: ee, attrs: n, slots: r, features: Tr.RenderStrategy | Tr.Static, name: "ComboboxInput" });
  };
} }), fh = tt({ name: "ComboboxOptions", props: { as: { type: [Object, String], default: "ul" }, static: { type: Boolean, default: !1 }, unmount: { type: Boolean, default: !0 }, hold: { type: [Boolean], default: !1 } }, setup(e, { attrs: t, slots: n, expose: r }) {
  let a = Ar("ComboboxOptions"), l = `headlessui-combobox-options-${Ni()}`;
  r({ el: a.optionsRef, $el: a.optionsRef }), ti(() => {
    a.optionsPropsRef.value.static = e.static;
  }), ti(() => {
    a.optionsPropsRef.value.hold = e.hold;
  });
  let u = sp(), h = te(() => u !== null ? (u.value & Ti.Open) === Ti.Open : a.comboboxState.value === 0);
  return Nb({ container: te(() => Qe(a.optionsRef)), enabled: te(() => a.comboboxState.value === 0), accept(f) {
    return f.getAttribute("role") === "option" ? NodeFilter.FILTER_REJECT : f.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
  }, walk(f) {
    f.setAttribute("role", "none");
  } }), () => {
    var f, m, v;
    let y = { open: a.comboboxState.value === 0 }, k = { "aria-labelledby": (v = (f = Qe(a.labelRef)) == null ? void 0 : f.id) != null ? v : (m = Qe(a.buttonRef)) == null ? void 0 : m.id, id: l, ref: a.optionsRef, role: "listbox", "aria-multiselectable": a.mode.value === 1 ? !0 : void 0 }, x = bo(e, ["hold"]);
    return Hn({ ourProps: k, theirProps: x, slot: y, attrs: t, slots: a.virtual.value && a.comboboxState.value === 0 ? { ...n, default: () => [Cr(Gb, {}, n.default)] } : n, features: Tr.RenderStrategy | Tr.Static, visible: h.value, name: "ComboboxOptions" });
  };
} }), Ko = tt({ name: "ComboboxOption", props: { as: { type: [Object, String], default: "li" }, value: { type: [Object, String, Number, Boolean] }, disabled: { type: Boolean, default: !1 }, order: { type: [Number], default: null } }, setup(e, { slots: t, attrs: n, expose: r }) {
  let a = Ar("ComboboxOption"), l = `headlessui-combobox-option-${Ni()}`, u = je(null);
  r({ el: u, $el: u });
  let h = te(() => {
    var C;
    return a.virtual.value ? a.activeOptionIndex.value === a.calculateIndex(e.value) : a.activeOptionIndex.value === null ? !1 : ((C = a.options.value[a.activeOptionIndex.value]) == null ? void 0 : C.id) === l;
  }), f = te(() => a.isSelected(e.value)), m = Ri(dp, null), v = te(() => ({ disabled: e.disabled, value: e.value, domRef: u, order: te(() => e.order) }));
  In(() => a.registerOption(l, v)), _o(() => a.unregisterOption(l, h.value)), ti(() => {
    let C = Qe(u);
    C && (m == null || m.value.measureElement(C));
  }), ti(() => {
    a.comboboxState.value === 0 && h.value && (a.virtual.value || a.activationTrigger.value !== 0 && nn(() => {
      var C, T;
      return (T = (C = Qe(u)) == null ? void 0 : C.scrollIntoView) == null ? void 0 : T.call(C, { block: "nearest" });
    }));
  });
  function y(C) {
    var T;
    if (e.disabled || (T = a.virtual.value) != null && T.disabled(e.value))
      return C.preventDefault();
    a.selectOption(l), Xf() || requestAnimationFrame(() => {
      var A;
      return (A = Qe(a.inputRef)) == null ? void 0 : A.focus({ preventScroll: !0 });
    }), a.mode.value === 0 && requestAnimationFrame(() => a.closeCombobox());
  }
  function k() {
    var C;
    if (e.disabled || (C = a.virtual.value) != null && C.disabled(e.value))
      return a.goToOption(Pt.Nothing);
    let T = a.calculateIndex(e.value);
    a.goToOption(Pt.Specific, T);
  }
  let x = tp();
  function M(C) {
    x.update(C);
  }
  function O(C) {
    var T;
    if (!x.wasMoved(C) || e.disabled || (T = a.virtual.value) != null && T.disabled(e.value) || h.value)
      return;
    let A = a.calculateIndex(e.value);
    a.goToOption(Pt.Specific, A, 0);
  }
  function R(C) {
    var T;
    x.wasMoved(C) && (e.disabled || (T = a.virtual.value) != null && T.disabled(e.value) || h.value && (a.optionsPropsRef.value.hold || a.goToOption(Pt.Nothing)));
  }
  return () => {
    let { disabled: C } = e, T = { active: h.value, selected: f.value, disabled: C }, A = { id: l, ref: u, role: "option", tabIndex: C === !0 ? void 0 : -1, "aria-disabled": C === !0 ? !0 : void 0, "aria-selected": f.value, disabled: void 0, onClick: y, onFocus: k, onPointerenter: M, onMouseenter: M, onPointermove: O, onMousemove: O, onPointerleave: R, onMouseleave: R }, P = bo(e, ["order", "value"]);
    return Hn({ ourProps: A, theirProps: P, slot: T, attrs: n, slots: t, name: "ComboboxOption" });
  };
} }), ph = /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g;
function mh(e) {
  var t, n;
  let r = (t = e.innerText) != null ? t : "", a = e.cloneNode(!0);
  if (!(a instanceof HTMLElement))
    return r;
  let l = !1;
  for (let h of a.querySelectorAll('[hidden],[aria-hidden],[role="img"]'))
    h.remove(), l = !0;
  let u = l ? (n = a.innerText) != null ? n : "" : r;
  return ph.test(u) && (u = u.replace(ph, "")), u;
}
function qb(e) {
  let t = e.getAttribute("aria-label");
  if (typeof t == "string")
    return t.trim();
  let n = e.getAttribute("aria-labelledby");
  if (n) {
    let r = n.split(" ").map((a) => {
      let l = document.getElementById(a);
      if (l) {
        let u = l.getAttribute("aria-label");
        return typeof u == "string" ? u.trim() : mh(l).trim();
      }
      return null;
    }).filter(Boolean);
    if (r.length > 0)
      return r.join(", ");
  }
  return mh(e).trim();
}
function Kb(e) {
  let t = je(""), n = je("");
  return () => {
    let r = Qe(e);
    if (!r)
      return "";
    let a = r.innerText;
    if (t.value === a)
      return n.value;
    let l = qb(r).trim().toLowerCase();
    return t.value = a, n.value = l, l;
  };
}
function Jb(e, t) {
  return e === t;
}
var Xb = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(Xb || {}), Qb = ((e) => (e[e.Single = 0] = "Single", e[e.Multi = 1] = "Multi", e))(Qb || {}), e0 = ((e) => (e[e.Pointer = 0] = "Pointer", e[e.Other = 1] = "Other", e))(e0 || {});
function t0(e) {
  requestAnimationFrame(() => requestAnimationFrame(e));
}
let fp = Symbol("ListboxContext");
function wo(e) {
  let t = Ri(fp, null);
  if (t === null) {
    let n = new Error(`<${e} /> is missing a parent <Listbox /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, wo), n;
  }
  return t;
}
let gh = tt({ name: "Listbox", emits: { "update:modelValue": (e) => !0 }, props: { as: { type: [Object, String], default: "template" }, disabled: { type: [Boolean], default: !1 }, by: { type: [String, Function], default: () => Jb }, horizontal: { type: [Boolean], default: !1 }, modelValue: { type: [Object, String, Number, Boolean], default: void 0 }, defaultValue: { type: [Object, String, Number, Boolean], default: void 0 }, form: { type: String, optional: !0 }, name: { type: String, optional: !0 }, multiple: { type: [Boolean], default: !1 } }, inheritAttrs: !1, setup(e, { slots: t, attrs: n, emit: r }) {
  let a = je(1), l = je(null), u = je(null), h = je(null), f = je([]), m = je(""), v = je(null), y = je(1);
  function k(A = (P) => P) {
    let P = v.value !== null ? f.value[v.value] : null, D = Jf(A(f.value.slice()), (Y) => Qe(Y.dataRef.domRef)), $ = P ? D.indexOf(P) : null;
    return $ === -1 && ($ = null), { options: D, activeOptionIndex: $ };
  }
  let x = te(() => e.multiple ? 1 : 0), [M, O] = qf(te(() => e.modelValue), (A) => r("update:modelValue", A), te(() => e.defaultValue)), R = te(() => M.value === void 0 ? fn(x.value, { 1: [], 0: void 0 }) : M.value), C = { listboxState: a, value: R, mode: x, compare(A, P) {
    if (typeof e.by == "string") {
      let D = e.by;
      return (A == null ? void 0 : A[D]) === (P == null ? void 0 : P[D]);
    }
    return e.by(A, P);
  }, orientation: te(() => e.horizontal ? "horizontal" : "vertical"), labelRef: l, buttonRef: u, optionsRef: h, disabled: te(() => e.disabled), options: f, searchQuery: m, activeOptionIndex: v, activationTrigger: y, closeListbox() {
    e.disabled || a.value !== 1 && (a.value = 1, v.value = null);
  }, openListbox() {
    e.disabled || a.value !== 0 && (a.value = 0);
  }, goToOption(A, P, D) {
    if (e.disabled || a.value === 1)
      return;
    let $ = k(), Y = Gl(A === Pt.Specific ? { focus: Pt.Specific, id: P } : { focus: A }, { resolveItems: () => $.options, resolveActiveIndex: () => $.activeOptionIndex, resolveId: (G) => G.id, resolveDisabled: (G) => G.dataRef.disabled });
    m.value = "", v.value = Y, y.value = D ?? 1, f.value = $.options;
  }, search(A) {
    if (e.disabled || a.value === 1)
      return;
    let P = m.value !== "" ? 0 : 1;
    m.value += A.toLowerCase();
    let D = (v.value !== null ? f.value.slice(v.value + P).concat(f.value.slice(0, v.value + P)) : f.value).find((Y) => Y.dataRef.textValue.startsWith(m.value) && !Y.dataRef.disabled), $ = D ? f.value.indexOf(D) : -1;
    $ === -1 || $ === v.value || (v.value = $, y.value = 1);
  }, clearSearch() {
    e.disabled || a.value !== 1 && m.value !== "" && (m.value = "");
  }, registerOption(A, P) {
    let D = k(($) => [...$, { id: A, dataRef: P }]);
    f.value = D.options, v.value = D.activeOptionIndex;
  }, unregisterOption(A) {
    let P = k((D) => {
      let $ = D.findIndex((Y) => Y.id === A);
      return $ !== -1 && D.splice($, 1), D;
    });
    f.value = P.options, v.value = P.activeOptionIndex, y.value = 1;
  }, theirOnChange(A) {
    e.disabled || O(A);
  }, select(A) {
    e.disabled || O(fn(x.value, { 0: () => A, 1: () => {
      let P = tn(C.value.value).slice(), D = tn(A), $ = P.findIndex((Y) => C.compare(D, tn(Y)));
      return $ === -1 ? P.push(D) : P.splice($, 1), P;
    } }));
  } };
  Qf([u, h], (A, P) => {
    var D;
    C.closeListbox(), Kf(P, Su.Loose) || (A.preventDefault(), (D = Qe(u)) == null || D.focus());
  }, te(() => a.value === 0)), Bi(fp, C), lp(te(() => fn(a.value, { 0: Ti.Open, 1: Ti.Closed })));
  let T = te(() => {
    var A;
    return (A = Qe(u)) == null ? void 0 : A.closest("form");
  });
  return In(() => {
    kt([T], () => {
      if (!T.value || e.defaultValue === void 0)
        return;
      function A() {
        C.theirOnChange(e.defaultValue);
      }
      return T.value.addEventListener("reset", A), () => {
        var P;
        (P = T.value) == null || P.removeEventListener("reset", A);
      };
    }, { immediate: !0 });
  }), () => {
    let { name: A, modelValue: P, disabled: D, form: $, ...Y } = e, G = { open: a.value === 0, disabled: D, value: R.value };
    return Cr(Et, [...A != null && R.value != null ? Cu({ [A]: R.value }).map(([ee, X]) => Cr(ap, rp({ features: Pu.Hidden, key: ee, as: "input", type: "hidden", hidden: !0, readOnly: !0, form: $, name: ee, value: X }))) : [], Hn({ ourProps: {}, theirProps: { ...n, ...bo(Y, ["defaultValue", "onUpdate:modelValue", "horizontal", "multiple", "by"]) }, slot: G, slots: t, attrs: n, name: "Listbox" })]);
  };
} });
tt({ name: "ListboxLabel", props: { as: { type: [Object, String], default: "label" }, id: { type: String, default: () => `headlessui-listbox-label-${Ni()}` } }, setup(e, { attrs: t, slots: n }) {
  let r = wo("ListboxLabel");
  function a() {
    var l;
    (l = Qe(r.buttonRef)) == null || l.focus({ preventScroll: !0 });
  }
  return () => {
    let l = { open: r.listboxState.value === 0, disabled: r.disabled.value }, { id: u, ...h } = e, f = { id: u, ref: r.labelRef, onClick: a };
    return Hn({ ourProps: f, theirProps: h, slot: l, attrs: t, slots: n, name: "ListboxLabel" });
  };
} });
let vh = tt({ name: "ListboxButton", props: { as: { type: [Object, String], default: "button" }, id: { type: String, default: () => `headlessui-listbox-button-${Ni()}` } }, setup(e, { attrs: t, slots: n, expose: r }) {
  let a = wo("ListboxButton");
  r({ el: a.buttonRef, $el: a.buttonRef });
  function l(m) {
    switch (m.key) {
      case Ot.Space:
      case Ot.Enter:
      case Ot.ArrowDown:
        m.preventDefault(), a.openListbox(), nn(() => {
          var v;
          (v = Qe(a.optionsRef)) == null || v.focus({ preventScroll: !0 }), a.value.value || a.goToOption(Pt.First);
        });
        break;
      case Ot.ArrowUp:
        m.preventDefault(), a.openListbox(), nn(() => {
          var v;
          (v = Qe(a.optionsRef)) == null || v.focus({ preventScroll: !0 }), a.value.value || a.goToOption(Pt.Last);
        });
        break;
    }
  }
  function u(m) {
    switch (m.key) {
      case Ot.Space:
        m.preventDefault();
        break;
    }
  }
  function h(m) {
    a.disabled.value || (a.listboxState.value === 0 ? (a.closeListbox(), nn(() => {
      var v;
      return (v = Qe(a.buttonRef)) == null ? void 0 : v.focus({ preventScroll: !0 });
    })) : (m.preventDefault(), a.openListbox(), t0(() => {
      var v;
      return (v = Qe(a.optionsRef)) == null ? void 0 : v.focus({ preventScroll: !0 });
    })));
  }
  let f = ep(te(() => ({ as: e.as, type: t.type })), a.buttonRef);
  return () => {
    var m, v;
    let y = { open: a.listboxState.value === 0, disabled: a.disabled.value, value: a.value.value }, { id: k, ...x } = e, M = { ref: a.buttonRef, id: k, type: f.value, "aria-haspopup": "listbox", "aria-controls": (m = Qe(a.optionsRef)) == null ? void 0 : m.id, "aria-expanded": a.listboxState.value === 0, "aria-labelledby": a.labelRef.value ? [(v = Qe(a.labelRef)) == null ? void 0 : v.id, k].join(" ") : void 0, disabled: a.disabled.value === !0 ? !0 : void 0, onKeydown: l, onKeyup: u, onClick: h };
    return Hn({ ourProps: M, theirProps: x, slot: y, attrs: t, slots: n, name: "ListboxButton" });
  };
} }), _h = tt({ name: "ListboxOptions", props: { as: { type: [Object, String], default: "ul" }, static: { type: Boolean, default: !1 }, unmount: { type: Boolean, default: !0 }, id: { type: String, default: () => `headlessui-listbox-options-${Ni()}` } }, setup(e, { attrs: t, slots: n, expose: r }) {
  let a = wo("ListboxOptions"), l = je(null);
  r({ el: a.optionsRef, $el: a.optionsRef });
  function u(m) {
    switch (l.value && clearTimeout(l.value), m.key) {
      case Ot.Space:
        if (a.searchQuery.value !== "")
          return m.preventDefault(), m.stopPropagation(), a.search(m.key);
      case Ot.Enter:
        if (m.preventDefault(), m.stopPropagation(), a.activeOptionIndex.value !== null) {
          let v = a.options.value[a.activeOptionIndex.value];
          a.select(v.dataRef.value);
        }
        a.mode.value === 0 && (a.closeListbox(), nn(() => {
          var v;
          return (v = Qe(a.buttonRef)) == null ? void 0 : v.focus({ preventScroll: !0 });
        }));
        break;
      case fn(a.orientation.value, { vertical: Ot.ArrowDown, horizontal: Ot.ArrowRight }):
        return m.preventDefault(), m.stopPropagation(), a.goToOption(Pt.Next);
      case fn(a.orientation.value, { vertical: Ot.ArrowUp, horizontal: Ot.ArrowLeft }):
        return m.preventDefault(), m.stopPropagation(), a.goToOption(Pt.Previous);
      case Ot.Home:
      case Ot.PageUp:
        return m.preventDefault(), m.stopPropagation(), a.goToOption(Pt.First);
      case Ot.End:
      case Ot.PageDown:
        return m.preventDefault(), m.stopPropagation(), a.goToOption(Pt.Last);
      case Ot.Escape:
        m.preventDefault(), m.stopPropagation(), a.closeListbox(), nn(() => {
          var v;
          return (v = Qe(a.buttonRef)) == null ? void 0 : v.focus({ preventScroll: !0 });
        });
        break;
      case Ot.Tab:
        m.preventDefault(), m.stopPropagation();
        break;
      default:
        m.key.length === 1 && (a.search(m.key), l.value = setTimeout(() => a.clearSearch(), 350));
        break;
    }
  }
  let h = sp(), f = te(() => h !== null ? (h.value & Ti.Open) === Ti.Open : a.listboxState.value === 0);
  return () => {
    var m, v;
    let y = { open: a.listboxState.value === 0 }, { id: k, ...x } = e, M = { "aria-activedescendant": a.activeOptionIndex.value === null || (m = a.options.value[a.activeOptionIndex.value]) == null ? void 0 : m.id, "aria-multiselectable": a.mode.value === 1 ? !0 : void 0, "aria-labelledby": (v = Qe(a.buttonRef)) == null ? void 0 : v.id, "aria-orientation": a.orientation.value, id: k, onKeydown: u, role: "listbox", tabIndex: 0, ref: a.optionsRef };
    return Hn({ ourProps: M, theirProps: x, slot: y, attrs: t, slots: n, features: Tr.RenderStrategy | Tr.Static, visible: f.value, name: "ListboxOptions" });
  };
} }), yh = tt({ name: "ListboxOption", props: { as: { type: [Object, String], default: "li" }, value: { type: [Object, String, Number, Boolean] }, disabled: { type: Boolean, default: !1 }, id: { type: String, default: () => `headlessui-listbox.option-${Ni()}` } }, setup(e, { slots: t, attrs: n, expose: r }) {
  let a = wo("ListboxOption"), l = je(null);
  r({ el: l, $el: l });
  let u = te(() => a.activeOptionIndex.value !== null ? a.options.value[a.activeOptionIndex.value].id === e.id : !1), h = te(() => fn(a.mode.value, { 0: () => a.compare(tn(a.value.value), tn(e.value)), 1: () => tn(a.value.value).some((C) => a.compare(tn(C), tn(e.value))) })), f = te(() => fn(a.mode.value, { 1: () => {
    var C;
    let T = tn(a.value.value);
    return ((C = a.options.value.find((A) => T.some((P) => a.compare(tn(P), tn(A.dataRef.value))))) == null ? void 0 : C.id) === e.id;
  }, 0: () => h.value })), m = Kb(l), v = te(() => ({ disabled: e.disabled, value: e.value, get textValue() {
    return m();
  }, domRef: l }));
  In(() => a.registerOption(e.id, v)), _o(() => a.unregisterOption(e.id)), In(() => {
    kt([a.listboxState, h], () => {
      a.listboxState.value === 0 && h.value && fn(a.mode.value, { 1: () => {
        f.value && a.goToOption(Pt.Specific, e.id);
      }, 0: () => {
        a.goToOption(Pt.Specific, e.id);
      } });
    }, { immediate: !0 });
  }), ti(() => {
    a.listboxState.value === 0 && u.value && a.activationTrigger.value !== 0 && nn(() => {
      var C, T;
      return (T = (C = Qe(l)) == null ? void 0 : C.scrollIntoView) == null ? void 0 : T.call(C, { block: "nearest" });
    });
  });
  function y(C) {
    if (e.disabled)
      return C.preventDefault();
    a.select(e.value), a.mode.value === 0 && (a.closeListbox(), nn(() => {
      var T;
      return (T = Qe(a.buttonRef)) == null ? void 0 : T.focus({ preventScroll: !0 });
    }));
  }
  function k() {
    if (e.disabled)
      return a.goToOption(Pt.Nothing);
    a.goToOption(Pt.Specific, e.id);
  }
  let x = tp();
  function M(C) {
    x.update(C);
  }
  function O(C) {
    x.wasMoved(C) && (e.disabled || u.value || a.goToOption(Pt.Specific, e.id, 0));
  }
  function R(C) {
    x.wasMoved(C) && (e.disabled || u.value && a.goToOption(Pt.Nothing));
  }
  return () => {
    let { disabled: C } = e, T = { active: u.value, selected: h.value, disabled: C }, { id: A, value: P, disabled: D, ...$ } = e, Y = { id: A, ref: l, role: "option", tabIndex: C === !0 ? void 0 : -1, "aria-disabled": C === !0 ? !0 : void 0, "aria-selected": h.value, disabled: void 0, onClick: y, onFocus: k, onPointerenter: M, onMouseenter: M, onPointermove: O, onMousemove: O, onPointerleave: R, onMouseleave: R };
    return Hn({ ourProps: Y, theirProps: $, slot: T, attrs: n, slots: t, name: "ListboxOption" });
  };
} });
const pp = (e) => (mu("data-v-a09511b6"), e = e(), gu(), e), n0 = { class: "range-filter__container" }, i0 = { class: "range-filter__inputs" }, r0 = { class: "range-filter__input" }, a0 = /* @__PURE__ */ pp(() => /* @__PURE__ */ xe("span", { class: "input-label" }, "Min:", -1)), o0 = ["value", "aria-label"], s0 = {
  key: 0,
  class: "range-filter__unit-selection",
  "data-ts": "range-min-unit-dropdown"
}, l0 = { class: "range-filter__input" }, u0 = /* @__PURE__ */ pp(() => /* @__PURE__ */ xe("span", { class: "input-label" }, "Max:", -1)), c0 = ["value", "aria-label"], h0 = {
  key: 0,
  class: "range-filter__unit-selection",
  "data-ts": "range-max-unit-dropdown"
}, d0 = { class: "range-filter__slider" }, f0 = /* @__PURE__ */ tt({
  __name: "RangeFilter",
  props: /* @__PURE__ */ Ci({
    loading: {
      type: Boolean,
      required: !1,
      default: !1
    }
  }, {
    filter: {
      default: {
        type: "range",
        name: "",
        nameDisplay: "",
        rangeMin: 0,
        rangeMax: 100,
        active: !1,
        decimals: 2
      }
    },
    filterModifiers: {}
  }),
  emits: /* @__PURE__ */ Ci(["userUpdatedFilter", "update:filter", "removeFilter"], ["update:filter"]),
  setup(e, { emit: t }) {
    const n = je(), r = Ir({
      start: [0, 100],
      range: { min: 0, max: 100 },
      connect: !0
    }), a = or(e, "filter"), l = (A) => typeof A == "number", u = (A) => {
      var P;
      return y(void 0, (P = A.target) == null ? void 0 : P.textContent);
    }, h = (A) => {
      var P;
      return k(void 0, (P = A.target) == null ? void 0 : P.textContent);
    }, f = t, m = () => {
      var A, P;
      return {
        ...a.value,
        start: parseFloat(((A = r.start) == null ? void 0 : A[0]) || "0"),
        end: parseFloat(((P = r.start) == null ? void 0 : P[1]) || "100")
      };
    }, v = () => {
      a.value.active ? f("userUpdatedFilter", { ...m(), active: !1 }) : f("userUpdatedFilter", { ...m(), active: !0 });
    }, y = (A, P) => {
      var $, Y, G;
      let D = A || (($ = O.value.size) == null ? void 0 : $.toString()) || "";
      if (a.value.type === "fileSize") {
        let ee = P || O.value.unit || "";
        D = eh(D + " " + ee).toString();
      }
      (G = (Y = n.value) == null ? void 0 : Y.noUiSlider) == null || G.setHandle(0, D);
    }, k = (A, P) => {
      var $, Y, G;
      let D = A || (($ = R.value.size) == null ? void 0 : $.toString()) || "";
      if (a.value.type === "fileSize") {
        let ee = P || R.value.unit || "";
        D = eh(D + " " + ee).toString();
      }
      (G = (Y = n.value) == null ? void 0 : Y.noUiSlider) == null || G.setHandle(1, D);
    }, x = (A) => {
      if (a.value.type !== "fileSize")
        return { size: A, unit: "" };
      const P = uy(A, a.value.decimals || 2);
      return P || { size: -1, unit: "" };
    }, M = ["Bytes", "KB", "MB", "GB"], O = te(() => {
      var A;
      return x((A = r.start) == null ? void 0 : A[0]);
    }), R = te(() => {
      var A;
      return x((A = r.start) == null ? void 0 : A[1]);
    }), C = () => {
      let A = a.value.rangeMin || 0, P = a.value.rangeMax || 100, D = a.value.start || A, $ = a.value.end || P;
      l(A) || (A = 0), l(P) || (P = 100), l(D) || (D = A), l($) || ($ = P), r.range.min = A, r.range.max = P, r.start = [D, $], a.value.gap && (r.step = a.value.gap), a.value.decimals !== void 0 && a.value.decimals !== null && (a.value.decimals === 0 ? r.format = oh({ decimals: 0 }) : r.format = oh({ decimals: a.value.decimals || 2 }));
    }, T = () => {
      var A, P, D, $, Y, G, ee, X;
      (P = (A = n.value) == null ? void 0 : A.noUiSlider) == null || P.updateOptions(r, !0), (Y = (D = n.value) == null ? void 0 : D.noUiSlider) == null || Y.setHandle(0, (($ = r.start) == null ? void 0 : $[0]) || 0), (X = (G = n.value) == null ? void 0 : G.noUiSlider) == null || X.setHandle(1, ((ee = r.start) == null ? void 0 : ee[1]) || 100);
    };
    return In(() => {
      var A, P;
      fb.create(n.value, r).on("update", (D) => {
        r.start = D;
      }), (A = document.querySelector(".noUi-handle-lower")) == null || A.setAttribute("aria-label", "Slider Handle to Set Minimum Value"), (P = document.querySelector(".noUi-handle-upper")) == null || P.setAttribute("aria-label", "Slider Handle to Set Maximum Value");
    }), kt(() => a.value, () => {
      C(), T();
    }, { deep: !0, immediate: !0 }), (A, P) => Pi((we(), Te("div", n0, [
      xe("div", i0, [
        xe("span", r0, [
          a0,
          xe("input", {
            value: O.value.size,
            "aria-label": `Minimum value for ${a.value.nameDisplay}`,
            onChange: P[0] || (P[0] = (D) => {
              var $;
              return y(($ = D.target) == null ? void 0 : $.value);
            }),
            size: "1",
            "data-ts": "range-min-input"
          }, null, 40, o0),
          a.value.type === "fileSize" ? (we(), Te("div", s0, [
            ce(he(gh), {
              modelValue: O.value.unit,
              "onUpdate:modelValue": P[1] || (P[1] = (D) => O.value.unit = D)
            }, {
              default: Je(() => [
                ce(he(vh), null, {
                  default: Je(() => [
                    Se(_t(O.value.unit), 1)
                  ]),
                  _: 1
                }),
                ce(oo, null, {
                  default: Je(() => [
                    ce(he(_h), { style: { width: "4rem" } }, {
                      default: Je(() => [
                        (we(), Te(Et, null, rn(M, (D) => ce(he(yh), {
                          key: D,
                          value: D,
                          onClick: u,
                          "data-ts": `unit-selection-${D}`
                        }, {
                          default: Je(() => [
                            Se(_t(D), 1)
                          ]),
                          _: 2
                        }, 1032, ["value", "data-ts"])), 64))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])) : vt("", !0)
        ]),
        xe("span", l0, [
          u0,
          xe("input", {
            value: R.value.size,
            "aria-label": `Maximum value for ${a.value.nameDisplay}`,
            onChange: P[2] || (P[2] = (D) => {
              var $;
              return k(($ = D.target) == null ? void 0 : $.value);
            }),
            size: "1",
            "data-ts": "range-max-input"
          }, null, 40, c0),
          a.value.type === "fileSize" ? (we(), Te("div", h0, [
            ce(he(gh), {
              modelValue: R.value.unit,
              "onUpdate:modelValue": P[3] || (P[3] = (D) => R.value.unit = D)
            }, {
              default: Je(() => [
                ce(he(vh), null, {
                  default: Je(() => [
                    Se(_t(R.value.unit), 1)
                  ]),
                  _: 1
                }),
                ce(oo, null, {
                  default: Je(() => [
                    ce(he(_h), { style: { width: "4rem" } }, {
                      default: Je(() => [
                        (we(), Te(Et, null, rn(M, (D) => ce(he(yh), {
                          key: D,
                          value: D,
                          onClick: h,
                          "data-ts": `unit-selection-${D}`
                        }, {
                          default: Je(() => [
                            Se(_t(D), 1)
                          ]),
                          _: 2
                        }, 1032, ["value", "data-ts"])), 64))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])) : vt("", !0)
        ])
      ]),
      xe("div", d0, [
        xe("div", {
          ref_key: "slider",
          ref: n,
          id: "slider",
          "data-ts": "range-slider"
        }, null, 512)
      ]),
      ce(Wf, {
        onClick: v,
        class: "range-filter__submit-button",
        "aria-label": `Apply changes to ${a.value.nameDisplay}`,
        "data-ts": "range-submit"
      }, {
        default: Je(() => [
          Se(_t(a.value.active ? "Remove" : "Apply"), 1)
        ]),
        _: 1
      }, 8, ["aria-label"])
    ], 512)), [
      [vu, !e.loading]
    ]);
  }
}), X$ = /* @__PURE__ */ ur(f0, [["__scopeId", "data-v-a09511b6"]]);
function uo(e) {
  var t = e.getBoundingClientRect();
  return {
    width: t.width,
    height: t.height,
    top: t.top,
    right: t.right,
    bottom: t.bottom,
    left: t.left,
    x: t.left,
    y: t.top
  };
}
function Un(e) {
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t ? t.defaultView : window;
  }
  return e;
}
function Ou(e) {
  var t = Un(e), n = t.pageXOffset, r = t.pageYOffset;
  return {
    scrollLeft: n,
    scrollTop: r
  };
}
function co(e) {
  var t = Un(e).Element;
  return e instanceof t || e instanceof Element;
}
function oi(e) {
  var t = Un(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function p0(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function m0(e) {
  return e === Un(e) || !oi(e) ? Ou(e) : p0(e);
}
function zi(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function cr(e) {
  return (co(e) ? e.ownerDocument : e.document).documentElement;
}
function mp(e) {
  return uo(cr(e)).left + Ou(e).scrollLeft;
}
function Rr(e) {
  return Un(e).getComputedStyle(e);
}
function Eu(e) {
  var t = Rr(e), n = t.overflow, r = t.overflowX, a = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(n + a + r);
}
function gp(e, t, n) {
  n === void 0 && (n = !1);
  var r = cr(t), a = uo(e), l = {
    scrollLeft: 0,
    scrollTop: 0
  }, u = {
    x: 0,
    y: 0
  };
  return n || ((zi(t) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  Eu(r)) && (l = m0(t)), oi(t) ? (u = uo(t), u.x += t.clientLeft, u.y += t.clientTop) : r && (u.x = mp(r))), {
    x: a.left + l.scrollLeft - u.x,
    y: a.top + l.scrollTop - u.y,
    width: a.width,
    height: a.height
  };
}
function Tu(e) {
  return {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: e.offsetWidth,
    height: e.offsetHeight
  };
}
function vp(e) {
  return zi(e) === "html" ? e : (
    // $FlowFixMe: this is a quicker (but less type safe) way to save quite some bytes from the bundle
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    // $FlowFixMe: need a better way to handle this...
    e.host || // ShadowRoot detected
    // $FlowFixMe: HTMLElement is a Node
    cr(e)
  );
}
function _p(e) {
  return ["html", "body", "#document"].indexOf(zi(e)) >= 0 ? e.ownerDocument.body : oi(e) && Eu(e) ? e : _p(vp(e));
}
function io(e, t) {
  t === void 0 && (t = []);
  var n = _p(e), r = zi(n) === "body", a = Un(n), l = r ? [a].concat(a.visualViewport || [], Eu(n) ? n : []) : n, u = t.concat(l);
  return r ? u : (
    // $FlowFixMe: isBody tells us target will be an HTMLElement here
    u.concat(io(vp(l)))
  );
}
function g0(e) {
  return ["table", "td", "th"].indexOf(zi(e)) >= 0;
}
function bh(e) {
  return !oi(e) || // https://github.com/popperjs/popper-core/issues/837
  Rr(e).position === "fixed" ? null : e.offsetParent;
}
function ko(e) {
  for (var t = Un(e), n = bh(e); n && g0(n); )
    n = bh(n);
  return n && zi(n) === "body" && Rr(n).position === "static" ? t : n || t;
}
var Vn = "top", ni = "bottom", ii = "right", Yn = "left", Js = "auto", xo = [Vn, ni, ii, Yn], ma = "start", Du = "end", v0 = "clippingParents", yp = "viewport", Wa = "popper", _0 = "reference", wh = /* @__PURE__ */ xo.reduce(function(e, t) {
  return e.concat([t + "-" + ma, t + "-" + Du]);
}, []), bp = /* @__PURE__ */ [].concat(xo, [Js]).reduce(function(e, t) {
  return e.concat([t, t + "-" + ma, t + "-" + Du]);
}, []), y0 = "beforeRead", b0 = "read", w0 = "afterRead", k0 = "beforeMain", x0 = "main", L0 = "afterMain", M0 = "beforeWrite", S0 = "write", P0 = "afterWrite", Kl = [y0, b0, w0, k0, x0, L0, M0, S0, P0];
function C0(e) {
  var t = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Set(), r = [];
  e.forEach(function(l) {
    t.set(l.name, l);
  });
  function a(l) {
    n.add(l.name);
    var u = [].concat(l.requires || [], l.requiresIfExists || []);
    u.forEach(function(h) {
      if (!n.has(h)) {
        var f = t.get(h);
        f && a(f);
      }
    }), r.push(l);
  }
  return e.forEach(function(l) {
    n.has(l.name) || a(l);
  }), r;
}
function O0(e) {
  var t = C0(e);
  return Kl.reduce(function(n, r) {
    return n.concat(t.filter(function(a) {
      return a.phase === r;
    }));
  }, []);
}
function E0(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(n) {
      Promise.resolve().then(function() {
        t = void 0, n(e());
      });
    })), t;
  };
}
function Ji(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
    n[r - 1] = arguments[r];
  return [].concat(n).reduce(function(a, l) {
    return a.replace(/%s/, l);
  }, e);
}
var yr = 'Popper: modifier "%s" provided an invalid %s property, expected %s but got %s', T0 = 'Popper: modifier "%s" requires "%s", but "%s" modifier is not available', D0 = ["name", "enabled", "phase", "fn", "effect", "requires", "options"];
function I0(e) {
  e.forEach(function(t) {
    Object.keys(t).forEach(function(n) {
      switch (n) {
        case "name":
          typeof t.name != "string" && console.error(Ji(yr, String(t.name), '"name"', '"string"', '"' + String(t.name) + '"'));
          break;
        case "enabled":
          typeof t.enabled != "boolean" && console.error(Ji(yr, t.name, '"enabled"', '"boolean"', '"' + String(t.enabled) + '"'));
        case "phase":
          Kl.indexOf(t.phase) < 0 && console.error(Ji(yr, t.name, '"phase"', "either " + Kl.join(", "), '"' + String(t.phase) + '"'));
          break;
        case "fn":
          typeof t.fn != "function" && console.error(Ji(yr, t.name, '"fn"', '"function"', '"' + String(t.fn) + '"'));
          break;
        case "effect":
          typeof t.effect != "function" && console.error(Ji(yr, t.name, '"effect"', '"function"', '"' + String(t.fn) + '"'));
          break;
        case "requires":
          Array.isArray(t.requires) || console.error(Ji(yr, t.name, '"requires"', '"array"', '"' + String(t.requires) + '"'));
          break;
        case "requiresIfExists":
          Array.isArray(t.requiresIfExists) || console.error(Ji(yr, t.name, '"requiresIfExists"', '"array"', '"' + String(t.requiresIfExists) + '"'));
          break;
        case "options":
        case "data":
          break;
        default:
          console.error('PopperJS: an invalid property has been provided to the "' + t.name + '" modifier, valid properties are ' + D0.map(function(r) {
            return '"' + r + '"';
          }).join(", ") + '; but "' + n + '" was provided.');
      }
      t.requires && t.requires.forEach(function(r) {
        e.find(function(a) {
          return a.name === r;
        }) == null && console.error(Ji(T0, String(t.name), r, r));
      });
    });
  });
}
function A0(e, t) {
  var n = /* @__PURE__ */ new Set();
  return e.filter(function(r) {
    var a = t(r);
    if (!n.has(a))
      return n.add(a), !0;
  });
}
function ei(e) {
  return e.split("-")[0];
}
function R0(e) {
  var t = e.reduce(function(n, r) {
    var a = n[r.name];
    return n[r.name] = a ? Object.assign({}, a, {}, r, {
      options: Object.assign({}, a.options, {}, r.options),
      data: Object.assign({}, a.data, {}, r.data)
    }) : r, n;
  }, {});
  return Object.keys(t).map(function(n) {
    return t[n];
  });
}
var kh = "Popper: Invalid reference or popper argument provided. They must be either a DOM element or virtual element.", B0 = "Popper: An infinite loop in the modifiers cycle has been detected! The cycle has been interrupted to prevent a browser crash.", xh = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function Lh() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return !t.some(function(r) {
    return !(r && typeof r.getBoundingClientRect == "function");
  });
}
function $0(e) {
  e === void 0 && (e = {});
  var t = e, n = t.defaultModifiers, r = n === void 0 ? [] : n, a = t.defaultOptions, l = a === void 0 ? xh : a;
  return function(h, f, m) {
    m === void 0 && (m = l);
    var v = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, xh, {}, l),
      modifiersData: {},
      elements: {
        reference: h,
        popper: f
      },
      attributes: {},
      styles: {}
    }, y = [], k = !1, x = {
      state: v,
      setOptions: function(C) {
        O(), v.options = Object.assign({}, l, {}, v.options, {}, C), v.scrollParents = {
          reference: co(h) ? io(h) : h.contextElement ? io(h.contextElement) : [],
          popper: io(f)
        };
        var T = O0(R0([].concat(r, v.options.modifiers)));
        if (v.orderedModifiers = T.filter(function(X) {
          return X.enabled;
        }), process.env.NODE_ENV !== "production") {
          var A = A0([].concat(T, v.options.modifiers), function(X) {
            var ae = X.name;
            return ae;
          });
          if (I0(A), ei(v.options.placement) === Js) {
            var P = v.orderedModifiers.find(function(X) {
              var ae = X.name;
              return ae === "flip";
            });
            P || console.error(['Popper: "auto" placements require the "flip" modifier be', "present and enabled to work."].join(" "));
          }
          var D = Rr(f), $ = D.marginTop, Y = D.marginRight, G = D.marginBottom, ee = D.marginLeft;
          [$, Y, G, ee].some(function(X) {
            return parseFloat(X);
          }) && console.warn(['Popper: CSS "margin" styles cannot be used to apply padding', "between the popper and its reference element or boundary.", "To replicate margin, use the `offset` modifier, as well as", "the `padding` option in the `preventOverflow` and `flip`", "modifiers."].join(" "));
        }
        return M(), x.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!k) {
          var C = v.elements, T = C.reference, A = C.popper;
          if (!Lh(T, A)) {
            process.env.NODE_ENV !== "production" && console.error(kh);
            return;
          }
          v.rects = {
            reference: gp(T, ko(A), v.options.strategy === "fixed"),
            popper: Tu(A)
          }, v.reset = !1, v.placement = v.options.placement, v.orderedModifiers.forEach(function(ae) {
            return v.modifiersData[ae.name] = Object.assign({}, ae.data);
          });
          for (var P = 0, D = 0; D < v.orderedModifiers.length; D++) {
            if (process.env.NODE_ENV !== "production" && (P += 1, P > 100)) {
              console.error(B0);
              break;
            }
            if (v.reset === !0) {
              v.reset = !1, D = -1;
              continue;
            }
            var $ = v.orderedModifiers[D], Y = $.fn, G = $.options, ee = G === void 0 ? {} : G, X = $.name;
            typeof Y == "function" && (v = Y({
              state: v,
              options: ee,
              name: X,
              instance: x
            }) || v);
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: E0(function() {
        return new Promise(function(R) {
          x.forceUpdate(), R(v);
        });
      }),
      destroy: function() {
        O(), k = !0;
      }
    };
    if (!Lh(h, f))
      return process.env.NODE_ENV !== "production" && console.error(kh), x;
    x.setOptions(m).then(function(R) {
      !k && m.onFirstUpdate && m.onFirstUpdate(R);
    });
    function M() {
      v.orderedModifiers.forEach(function(R) {
        var C = R.name, T = R.options, A = T === void 0 ? {} : T, P = R.effect;
        if (typeof P == "function") {
          var D = P({
            state: v,
            name: C,
            instance: x,
            options: A
          }), $ = function() {
          };
          y.push(D || $);
        }
      });
    }
    function O() {
      y.forEach(function(R) {
        return R();
      }), y = [];
    }
    return x;
  };
}
var Jo = {
  passive: !0
};
function N0(e) {
  var t = e.state, n = e.instance, r = e.options, a = r.scroll, l = a === void 0 ? !0 : a, u = r.resize, h = u === void 0 ? !0 : u, f = Un(t.elements.popper), m = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return l && m.forEach(function(v) {
    v.addEventListener("scroll", n.update, Jo);
  }), h && f.addEventListener("resize", n.update, Jo), function() {
    l && m.forEach(function(v) {
      v.removeEventListener("scroll", n.update, Jo);
    }), h && f.removeEventListener("resize", n.update, Jo);
  };
}
const z0 = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: N0,
  data: {}
};
function ho(e) {
  return e.split("-")[1];
}
function Iu(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function wp(e) {
  var t = e.reference, n = e.element, r = e.placement, a = r ? ei(r) : null, l = r ? ho(r) : null, u = t.x + t.width / 2 - n.width / 2, h = t.y + t.height / 2 - n.height / 2, f;
  switch (a) {
    case Vn:
      f = {
        x: u,
        y: t.y - n.height
      };
      break;
    case ni:
      f = {
        x: u,
        y: t.y + t.height
      };
      break;
    case ii:
      f = {
        x: t.x + t.width,
        y: h
      };
      break;
    case Yn:
      f = {
        x: t.x - n.width,
        y: h
      };
      break;
    default:
      f = {
        x: t.x,
        y: t.y
      };
  }
  var m = a ? Iu(a) : null;
  if (m != null) {
    var v = m === "y" ? "height" : "width";
    switch (l) {
      case ma:
        f[m] = Math.floor(f[m]) - Math.floor(t[v] / 2 - n[v] / 2);
        break;
      case Du:
        f[m] = Math.floor(f[m]) + Math.ceil(t[v] / 2 - n[v] / 2);
        break;
    }
  }
  return f;
}
function F0(e) {
  var t = e.state, n = e.name;
  t.modifiersData[n] = wp({
    reference: t.rects.reference,
    element: t.rects.popper,
    strategy: "absolute",
    placement: t.placement
  });
}
const j0 = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: F0,
  data: {}
};
var V0 = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function Y0(e) {
  var t = e.x, n = e.y, r = window, a = r.devicePixelRatio || 1;
  return {
    x: Math.round(t * a) / a || 0,
    y: Math.round(n * a) / a || 0
  };
}
function Mh(e) {
  var t, n = e.popper, r = e.popperRect, a = e.placement, l = e.offsets, u = e.position, h = e.gpuAcceleration, f = e.adaptive, m = Y0(l), v = m.x, y = m.y, k = l.hasOwnProperty("x"), x = l.hasOwnProperty("y"), M = Yn, O = Vn, R = window;
  if (f) {
    var C = ko(n);
    C === Un(n) && (C = cr(n)), a === Vn && (O = ni, y -= C.clientHeight - r.height, y *= h ? 1 : -1), a === Yn && (M = ii, v -= C.clientWidth - r.width, v *= h ? 1 : -1);
  }
  var T = Object.assign({
    position: u
  }, f && V0);
  if (h) {
    var A;
    return Object.assign({}, T, (A = {}, A[O] = x ? "0" : "", A[M] = k ? "0" : "", A.transform = (R.devicePixelRatio || 1) < 2 ? "translate(" + v + "px, " + y + "px)" : "translate3d(" + v + "px, " + y + "px, 0)", A));
  }
  return Object.assign({}, T, (t = {}, t[O] = x ? y + "px" : "", t[M] = k ? v + "px" : "", t.transform = "", t));
}
function H0(e) {
  var t = e.state, n = e.options, r = n.gpuAcceleration, a = r === void 0 ? !0 : r, l = n.adaptive, u = l === void 0 ? !0 : l;
  if (process.env.NODE_ENV !== "production") {
    var h = Rr(t.elements.popper).transitionProperty || "";
    u && ["transform", "top", "right", "bottom", "left"].some(function(m) {
      return h.indexOf(m) >= 0;
    }) && console.warn(["Popper: Detected CSS transitions on at least one of the following", 'CSS properties: "transform", "top", "right", "bottom", "left".', `

`, 'Disable the "computeStyles" modifier\'s `adaptive` option to allow', "for smooth transitions, or remove these properties from the CSS", "transition declaration on the popper element if only transitioning", "opacity or background-color for example.", `

`, "We recommend using the popper element as a wrapper around an inner", "element that can have any CSS property transitioned for animations."].join(" "));
  }
  var f = {
    placement: ei(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: a
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, {}, Mh(Object.assign({}, f, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: u
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, {}, Mh(Object.assign({}, f, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
const U0 = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: H0,
  data: {}
};
function Z0(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(n) {
    var r = t.styles[n] || {}, a = t.attributes[n] || {}, l = t.elements[n];
    !oi(l) || !zi(l) || (Object.assign(l.style, r), Object.keys(a).forEach(function(u) {
      var h = a[u];
      h === !1 ? l.removeAttribute(u) : l.setAttribute(u, h === !0 ? "" : h);
    }));
  });
}
function W0(e) {
  var t = e.state, n = {
    popper: {
      position: t.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(t.elements.popper.style, n.popper), t.elements.arrow && Object.assign(t.elements.arrow.style, n.arrow), function() {
    Object.keys(t.elements).forEach(function(r) {
      var a = t.elements[r], l = t.attributes[r] || {}, u = Object.keys(t.styles.hasOwnProperty(r) ? t.styles[r] : n[r]), h = u.reduce(function(f, m) {
        return f[m] = "", f;
      }, {});
      !oi(a) || !zi(a) || (Object.assign(a.style, h), Object.keys(l).forEach(function(f) {
        a.removeAttribute(f);
      }));
    });
  };
}
const G0 = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: Z0,
  effect: W0,
  requires: ["computeStyles"]
};
function q0(e, t, n) {
  var r = ei(e), a = [Yn, Vn].indexOf(r) >= 0 ? -1 : 1, l = typeof n == "function" ? n(Object.assign({}, t, {
    placement: e
  })) : n, u = l[0], h = l[1];
  return u = u || 0, h = (h || 0) * a, [Yn, ii].indexOf(r) >= 0 ? {
    x: h,
    y: u
  } : {
    x: u,
    y: h
  };
}
function K0(e) {
  var t = e.state, n = e.options, r = e.name, a = n.offset, l = a === void 0 ? [0, 0] : a, u = bp.reduce(function(v, y) {
    return v[y] = q0(y, t.rects, l), v;
  }, {}), h = u[t.placement], f = h.x, m = h.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += f, t.modifiersData.popperOffsets.y += m), t.modifiersData[r] = u;
}
const J0 = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: K0
};
var X0 = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function ds(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return X0[t];
  });
}
var Q0 = {
  start: "end",
  end: "start"
};
function Sh(e) {
  return e.replace(/start|end/g, function(t) {
    return Q0[t];
  });
}
function ew(e) {
  var t = Un(e), n = t.visualViewport, r = t.innerWidth, a = t.innerHeight;
  return n && /iPhone|iPod|iPad/.test(navigator.platform) && (r = n.width, a = n.height), {
    width: r,
    height: a,
    x: 0,
    y: 0
  };
}
function tw(e) {
  var t = Un(e), n = Ou(e), r = gp(cr(e), t);
  return r.height = Math.max(r.height, t.innerHeight), r.width = Math.max(r.width, t.innerWidth), r.x = -n.scrollLeft, r.y = -n.scrollTop, r;
}
function Xo(e) {
  return parseFloat(e) || 0;
}
function nw(e) {
  var t = oi(e) ? Rr(e) : {};
  return {
    top: Xo(t.borderTopWidth),
    right: Xo(t.borderRightWidth),
    bottom: Xo(t.borderBottomWidth),
    left: Xo(t.borderLeftWidth)
  };
}
function iw(e) {
  var t = Un(e), n = nw(e), r = zi(e) === "html", a = mp(e), l = e.clientWidth + n.right, u = e.clientHeight + n.bottom;
  return r && t.innerHeight - e.clientHeight > 50 && (u = t.innerHeight - n.bottom), {
    top: r ? 0 : e.clientTop,
    right: (
      // RTL scrollbar (scrolling containers only)
      e.clientLeft > n.left ? n.right : (
        // LTR scrollbar
        r ? t.innerWidth - l - a : e.offsetWidth - l
      )
    ),
    bottom: r ? t.innerHeight - u : e.offsetHeight - u,
    left: r ? a : e.clientLeft
  };
}
function kp(e, t) {
  var n = !!(t.getRootNode && t.getRootNode().host);
  if (e.contains(t))
    return !0;
  if (n) {
    var r = t;
    do {
      if (r && e.isSameNode(r))
        return !0;
      r = r.parentNode || r.host;
    } while (r);
  }
  return !1;
}
function Jl(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function Ph(e, t) {
  return t === yp ? Jl(ew(e)) : oi(t) ? uo(t) : Jl(tw(cr(e)));
}
function rw(e) {
  var t = io(e), n = ["absolute", "fixed"].indexOf(Rr(e).position) >= 0, r = n && oi(e) ? ko(e) : e;
  return co(r) ? t.filter(function(a) {
    return co(a) && kp(a, r);
  }) : [];
}
function aw(e, t, n) {
  var r = t === "clippingParents" ? rw(e) : [].concat(t), a = [].concat(r, [n]), l = a[0], u = a.reduce(function(h, f) {
    var m = Ph(e, f), v = iw(oi(f) ? f : cr(e));
    return h.top = Math.max(m.top + v.top, h.top), h.right = Math.min(m.right - v.right, h.right), h.bottom = Math.min(m.bottom - v.bottom, h.bottom), h.left = Math.max(m.left + v.left, h.left), h;
  }, Ph(e, l));
  return u.width = u.right - u.left, u.height = u.bottom - u.top, u.x = u.left, u.y = u.top, u;
}
function xp() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function Lp(e) {
  return Object.assign({}, xp(), {}, e);
}
function Mp(e, t) {
  return t.reduce(function(n, r) {
    return n[r] = e, n;
  }, {});
}
function fo(e, t) {
  t === void 0 && (t = {});
  var n = t, r = n.placement, a = r === void 0 ? e.placement : r, l = n.boundary, u = l === void 0 ? v0 : l, h = n.rootBoundary, f = h === void 0 ? yp : h, m = n.elementContext, v = m === void 0 ? Wa : m, y = n.altBoundary, k = y === void 0 ? !1 : y, x = n.padding, M = x === void 0 ? 0 : x, O = Lp(typeof M != "number" ? M : Mp(M, xo)), R = v === Wa ? _0 : Wa, C = e.elements.reference, T = e.rects.popper, A = e.elements[k ? R : v], P = aw(co(A) ? A : A.contextElement || cr(e.elements.popper), u, f), D = uo(C), $ = wp({
    reference: D,
    element: T,
    strategy: "absolute",
    placement: a
  }), Y = Jl(Object.assign({}, T, {}, $)), G = v === Wa ? Y : D, ee = {
    top: P.top - G.top + O.top,
    bottom: G.bottom - P.bottom + O.bottom,
    left: P.left - G.left + O.left,
    right: G.right - P.right + O.right
  }, X = e.modifiersData.offset;
  if (v === Wa && X) {
    var ae = X[a];
    Object.keys(ee).forEach(function(ne) {
      var se = [ii, ni].indexOf(ne) >= 0 ? 1 : -1, re = [Vn, ni].indexOf(ne) >= 0 ? "y" : "x";
      ee[ne] += ae[re] * se;
    });
  }
  return ee;
}
function ow(e, t) {
  t === void 0 && (t = {});
  var n = t, r = n.placement, a = n.boundary, l = n.rootBoundary, u = n.padding, h = n.flipVariations, f = n.allowedAutoPlacements, m = f === void 0 ? bp : f, v = ho(r), y = (v ? h ? wh : wh.filter(function(x) {
    return ho(x) === v;
  }) : xo).filter(function(x) {
    return m.indexOf(x) >= 0;
  }), k = y.reduce(function(x, M) {
    return x[M] = fo(e, {
      placement: M,
      boundary: a,
      rootBoundary: l,
      padding: u
    })[ei(M)], x;
  }, {});
  return Object.keys(k).sort(function(x, M) {
    return k[x] - k[M];
  });
}
function sw(e) {
  if (ei(e) === Js)
    return [];
  var t = ds(e);
  return [Sh(e), t, Sh(t)];
}
function lw(e) {
  var t = e.state, n = e.options, r = e.name;
  if (!t.modifiersData[r]._skip) {
    for (var a = n.mainAxis, l = a === void 0 ? !0 : a, u = n.altAxis, h = u === void 0 ? !0 : u, f = n.fallbackPlacements, m = n.padding, v = n.boundary, y = n.rootBoundary, k = n.altBoundary, x = n.flipVariations, M = x === void 0 ? !0 : x, O = n.allowedAutoPlacements, R = t.options.placement, C = ei(R), T = C === R, A = f || (T || !M ? [ds(R)] : sw(R)), P = [R].concat(A).reduce(function(Ve, Ze) {
      return Ve.concat(ei(Ze) === Js ? ow(t, {
        placement: Ze,
        boundary: v,
        rootBoundary: y,
        padding: m,
        flipVariations: M,
        allowedAutoPlacements: O
      }) : Ze);
    }, []), D = t.rects.reference, $ = t.rects.popper, Y = /* @__PURE__ */ new Map(), G = !0, ee = P[0], X = 0; X < P.length; X++) {
      var ae = P[X], ne = ei(ae), se = ho(ae) === ma, re = [Vn, ni].indexOf(ne) >= 0, Q = re ? "width" : "height", ke = fo(t, {
        placement: ae,
        boundary: v,
        rootBoundary: y,
        altBoundary: k,
        padding: m
      }), Ae = re ? se ? ii : Yn : se ? ni : Vn;
      D[Q] > $[Q] && (Ae = ds(Ae));
      var pe = ds(Ae), Ye = [];
      if (l && Ye.push(ke[ne] <= 0), h && Ye.push(ke[Ae] <= 0, ke[pe] <= 0), Ye.every(function(Ve) {
        return Ve;
      })) {
        ee = ae, G = !1;
        break;
      }
      Y.set(ae, Ye);
    }
    if (G)
      for (var ue = M ? 3 : 1, Fe = function(Ze) {
        var Ne = P.find(function(ft) {
          var pt = Y.get(ft);
          if (pt)
            return pt.slice(0, Ze).every(function(Wt) {
              return Wt;
            });
        });
        if (Ne)
          return ee = Ne, "break";
      }, Pe = ue; Pe > 0; Pe--) {
        var nt = Fe(Pe);
        if (nt === "break")
          break;
      }
    t.placement !== ee && (t.modifiersData[r]._skip = !0, t.placement = ee, t.reset = !0);
  }
}
const uw = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: lw,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function cw(e) {
  return e === "x" ? "y" : "x";
}
function fs(e, t, n) {
  return Math.max(e, Math.min(t, n));
}
function hw(e) {
  var t = e.state, n = e.options, r = e.name, a = n.mainAxis, l = a === void 0 ? !0 : a, u = n.altAxis, h = u === void 0 ? !1 : u, f = n.boundary, m = n.rootBoundary, v = n.altBoundary, y = n.padding, k = n.tether, x = k === void 0 ? !0 : k, M = n.tetherOffset, O = M === void 0 ? 0 : M, R = fo(t, {
    boundary: f,
    rootBoundary: m,
    padding: y,
    altBoundary: v
  }), C = ei(t.placement), T = ho(t.placement), A = !T, P = Iu(C), D = cw(P), $ = t.modifiersData.popperOffsets, Y = t.rects.reference, G = t.rects.popper, ee = typeof O == "function" ? O(Object.assign({}, t.rects, {
    placement: t.placement
  })) : O, X = {
    x: 0,
    y: 0
  };
  if ($) {
    if (l) {
      var ae = P === "y" ? Vn : Yn, ne = P === "y" ? ni : ii, se = P === "y" ? "height" : "width", re = $[P], Q = $[P] + R[ae], ke = $[P] - R[ne], Ae = x ? -G[se] / 2 : 0, pe = T === ma ? Y[se] : G[se], Ye = T === ma ? -G[se] : -Y[se], ue = t.elements.arrow, Fe = x && ue ? Tu(ue) : {
        width: 0,
        height: 0
      }, Pe = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : xp(), nt = Pe[ae], Ve = Pe[ne], Ze = fs(0, Y[se], Fe[se]), Ne = A ? Y[se] / 2 - Ae - Ze - nt - ee : pe - Ze - nt - ee, ft = A ? -Y[se] / 2 + Ae + Ze + Ve + ee : Ye + Ze + Ve + ee, pt = t.elements.arrow && ko(t.elements.arrow), Wt = pt ? P === "y" ? pt.clientTop || 0 : pt.clientLeft || 0 : 0, an = t.modifiersData.offset ? t.modifiersData.offset[t.placement][P] : 0, on = $[P] + Ne - an - Wt, Dt = $[P] + ft - an, Zt = fs(x ? Math.min(Q, on) : Q, re, x ? Math.max(ke, Dt) : ke);
      $[P] = Zt, X[P] = Zt - re;
    }
    if (h) {
      var It = P === "x" ? Vn : Yn, bn = P === "x" ? ni : ii, qt = $[D], cn = qt + R[It], sn = qt - R[bn], H = fs(cn, qt, sn);
      $[D] = H, X[D] = H - qt;
    }
    t.modifiersData[r] = X;
  }
}
const dw = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: hw,
  requiresIfExists: ["offset"]
};
function fw(e) {
  var t, n = e.state, r = e.name, a = n.elements.arrow, l = n.modifiersData.popperOffsets, u = ei(n.placement), h = Iu(u), f = [Yn, ii].indexOf(u) >= 0, m = f ? "height" : "width";
  if (!(!a || !l)) {
    var v = n.modifiersData[r + "#persistent"].padding, y = Tu(a), k = h === "y" ? Vn : Yn, x = h === "y" ? ni : ii, M = n.rects.reference[m] + n.rects.reference[h] - l[h] - n.rects.popper[m], O = l[h] - n.rects.reference[h], R = ko(a), C = R ? h === "y" ? R.clientHeight || 0 : R.clientWidth || 0 : 0, T = M / 2 - O / 2, A = v[k], P = C - y[m] - v[x], D = C / 2 - y[m] / 2 + T, $ = fs(A, D, P), Y = h;
    n.modifiersData[r] = (t = {}, t[Y] = $, t.centerOffset = $ - D, t);
  }
}
function pw(e) {
  var t = e.state, n = e.options, r = e.name, a = n.element, l = a === void 0 ? "[data-popper-arrow]" : a, u = n.padding, h = u === void 0 ? 0 : u;
  if (l != null && !(typeof l == "string" && (l = t.elements.popper.querySelector(l), !l))) {
    if (process.env.NODE_ENV !== "production" && (oi(l) || console.error(['Popper: "arrow" element must be an HTMLElement (not an SVGElement).', "To use an SVG arrow, wrap it in an HTMLElement that will be used as", "the arrow."].join(" "))), !kp(t.elements.popper, l)) {
      process.env.NODE_ENV !== "production" && console.error(['Popper: "arrow" modifier\'s `element` must be a child of the popper', "element."].join(" "));
      return;
    }
    t.elements.arrow = l, t.modifiersData[r + "#persistent"] = {
      padding: Lp(typeof h != "number" ? h : Mp(h, xo))
    };
  }
}
const mw = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: fw,
  effect: pw,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function Ch(e, t, n) {
  return n === void 0 && (n = {
    x: 0,
    y: 0
  }), {
    top: e.top - t.height - n.y,
    right: e.right - t.width + n.x,
    bottom: e.bottom - t.height + n.y,
    left: e.left - t.width - n.x
  };
}
function Oh(e) {
  return [Vn, ii, ni, Yn].some(function(t) {
    return e[t] >= 0;
  });
}
function gw(e) {
  var t = e.state, n = e.name, r = t.rects.reference, a = t.rects.popper, l = t.modifiersData.preventOverflow, u = fo(t, {
    elementContext: "reference"
  }), h = fo(t, {
    altBoundary: !0
  }), f = Ch(u, r), m = Ch(h, a, l), v = Oh(f), y = Oh(m);
  t.modifiersData[n] = {
    referenceClippingOffsets: f,
    popperEscapeOffsets: m,
    isReferenceHidden: v,
    hasPopperEscaped: y
  }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-reference-hidden": v,
    "data-popper-escaped": y
  });
}
const vw = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: gw
};
var _w = [z0, j0, U0, G0, J0, uw, dw, mw, vw], yw = /* @__PURE__ */ $0({
  defaultModifiers: _w
}), bw = Object.defineProperty, ww = (e, t, n) => t in e ? bw(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, Ge = (e, t, n) => (ww(e, typeof t != "symbol" ? t + "" : t, n), n), Qo = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Sp(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var kw = Object.prototype, xw = kw.hasOwnProperty;
function Lw(e, t) {
  return e != null && xw.call(e, t);
}
var Mw = Lw, Sw = Array.isArray, si = Sw, Pw = typeof Qo == "object" && Qo && Qo.Object === Object && Qo, Pp = Pw, Cw = Pp, Ow = typeof self == "object" && self && self.Object === Object && self, Ew = Cw || Ow || Function("return this")(), mi = Ew, Tw = mi, Dw = Tw.Symbol, Xs = Dw, Eh = Xs, Cp = Object.prototype, Iw = Cp.hasOwnProperty, Aw = Cp.toString, Ga = Eh ? Eh.toStringTag : void 0;
function Rw(e) {
  var t = Iw.call(e, Ga), n = e[Ga];
  try {
    e[Ga] = void 0;
    var r = !0;
  } catch {
  }
  var a = Aw.call(e);
  return r && (t ? e[Ga] = n : delete e[Ga]), a;
}
var Bw = Rw, $w = Object.prototype, Nw = $w.toString;
function zw(e) {
  return Nw.call(e);
}
var Fw = zw, Th = Xs, jw = Bw, Vw = Fw, Yw = "[object Null]", Hw = "[object Undefined]", Dh = Th ? Th.toStringTag : void 0;
function Uw(e) {
  return e == null ? e === void 0 ? Hw : Yw : Dh && Dh in Object(e) ? jw(e) : Vw(e);
}
var gi = Uw;
function Zw(e) {
  return e != null && typeof e == "object";
}
var li = Zw, Ww = gi, Gw = li, qw = "[object Symbol]";
function Kw(e) {
  return typeof e == "symbol" || Gw(e) && Ww(e) == qw;
}
var Au = Kw, Jw = si, Xw = Au, Qw = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, e1 = /^\w*$/;
function t1(e, t) {
  if (Jw(e))
    return !1;
  var n = typeof e;
  return n == "number" || n == "symbol" || n == "boolean" || e == null || Xw(e) ? !0 : e1.test(e) || !Qw.test(e) || t != null && e in Object(t);
}
var Ru = t1;
function n1(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var Fi = n1, i1 = gi, r1 = Fi, a1 = "[object AsyncFunction]", o1 = "[object Function]", s1 = "[object GeneratorFunction]", l1 = "[object Proxy]";
function u1(e) {
  if (!r1(e))
    return !1;
  var t = i1(e);
  return t == o1 || t == s1 || t == a1 || t == l1;
}
var Br = u1, c1 = mi, h1 = c1["__core-js_shared__"], d1 = h1, Cl = d1, Ih = function() {
  var e = /[^.]+$/.exec(Cl && Cl.keys && Cl.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function f1(e) {
  return !!Ih && Ih in e;
}
var p1 = f1, m1 = Function.prototype, g1 = m1.toString;
function v1(e) {
  if (e != null) {
    try {
      return g1.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var Op = v1, _1 = Br, y1 = p1, b1 = Fi, w1 = Op, k1 = /[\\^$.*+?()[\]{}|]/g, x1 = /^\[object .+?Constructor\]$/, L1 = Function.prototype, M1 = Object.prototype, S1 = L1.toString, P1 = M1.hasOwnProperty, C1 = RegExp(
  "^" + S1.call(P1).replace(k1, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function O1(e) {
  if (!b1(e) || y1(e))
    return !1;
  var t = _1(e) ? C1 : x1;
  return t.test(w1(e));
}
var E1 = O1;
function T1(e, t) {
  return e == null ? void 0 : e[t];
}
var D1 = T1, I1 = E1, A1 = D1;
function R1(e, t) {
  var n = A1(e, t);
  return I1(n) ? n : void 0;
}
var $r = R1, B1 = $r, $1 = B1(Object, "create"), Qs = $1, Ah = Qs;
function N1() {
  this.__data__ = Ah ? Ah(null) : {}, this.size = 0;
}
var z1 = N1;
function F1(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var j1 = F1, V1 = Qs, Y1 = "__lodash_hash_undefined__", H1 = Object.prototype, U1 = H1.hasOwnProperty;
function Z1(e) {
  var t = this.__data__;
  if (V1) {
    var n = t[e];
    return n === Y1 ? void 0 : n;
  }
  return U1.call(t, e) ? t[e] : void 0;
}
var W1 = Z1, G1 = Qs, q1 = Object.prototype, K1 = q1.hasOwnProperty;
function J1(e) {
  var t = this.__data__;
  return G1 ? t[e] !== void 0 : K1.call(t, e);
}
var X1 = J1, Q1 = Qs, ek = "__lodash_hash_undefined__";
function tk(e, t) {
  var n = this.__data__;
  return this.size += this.has(e) ? 0 : 1, n[e] = Q1 && t === void 0 ? ek : t, this;
}
var nk = tk, ik = z1, rk = j1, ak = W1, ok = X1, sk = nk;
function ya(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
ya.prototype.clear = ik;
ya.prototype.delete = rk;
ya.prototype.get = ak;
ya.prototype.has = ok;
ya.prototype.set = sk;
var lk = ya;
function uk() {
  this.__data__ = [], this.size = 0;
}
var ck = uk;
function hk(e, t) {
  return e === t || e !== e && t !== t;
}
var ba = hk, dk = ba;
function fk(e, t) {
  for (var n = e.length; n--; )
    if (dk(e[n][0], t))
      return n;
  return -1;
}
var el = fk, pk = el, mk = Array.prototype, gk = mk.splice;
function vk(e) {
  var t = this.__data__, n = pk(t, e);
  if (n < 0)
    return !1;
  var r = t.length - 1;
  return n == r ? t.pop() : gk.call(t, n, 1), --this.size, !0;
}
var _k = vk, yk = el;
function bk(e) {
  var t = this.__data__, n = yk(t, e);
  return n < 0 ? void 0 : t[n][1];
}
var wk = bk, kk = el;
function xk(e) {
  return kk(this.__data__, e) > -1;
}
var Lk = xk, Mk = el;
function Sk(e, t) {
  var n = this.__data__, r = Mk(n, e);
  return r < 0 ? (++this.size, n.push([e, t])) : n[r][1] = t, this;
}
var Pk = Sk, Ck = ck, Ok = _k, Ek = wk, Tk = Lk, Dk = Pk;
function wa(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
wa.prototype.clear = Ck;
wa.prototype.delete = Ok;
wa.prototype.get = Ek;
wa.prototype.has = Tk;
wa.prototype.set = Dk;
var tl = wa, Ik = $r, Ak = mi, Rk = Ik(Ak, "Map"), Bu = Rk, Rh = lk, Bk = tl, $k = Bu;
function Nk() {
  this.size = 0, this.__data__ = {
    hash: new Rh(),
    map: new ($k || Bk)(),
    string: new Rh()
  };
}
var zk = Nk;
function Fk(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
var jk = Fk, Vk = jk;
function Yk(e, t) {
  var n = e.__data__;
  return Vk(t) ? n[typeof t == "string" ? "string" : "hash"] : n.map;
}
var nl = Yk, Hk = nl;
function Uk(e) {
  var t = Hk(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
var Zk = Uk, Wk = nl;
function Gk(e) {
  return Wk(this, e).get(e);
}
var qk = Gk, Kk = nl;
function Jk(e) {
  return Kk(this, e).has(e);
}
var Xk = Jk, Qk = nl;
function ex(e, t) {
  var n = Qk(this, e), r = n.size;
  return n.set(e, t), this.size += n.size == r ? 0 : 1, this;
}
var tx = ex, nx = zk, ix = Zk, rx = qk, ax = Xk, ox = tx;
function ka(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
ka.prototype.clear = nx;
ka.prototype.delete = ix;
ka.prototype.get = rx;
ka.prototype.has = ax;
ka.prototype.set = ox;
var $u = ka, Ep = $u, sx = "Expected a function";
function Nu(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(sx);
  var n = function() {
    var r = arguments, a = t ? t.apply(this, r) : r[0], l = n.cache;
    if (l.has(a))
      return l.get(a);
    var u = e.apply(this, r);
    return n.cache = l.set(a, u) || l, u;
  };
  return n.cache = new (Nu.Cache || Ep)(), n;
}
Nu.Cache = Ep;
var lx = Nu, ux = lx, cx = 500;
function hx(e) {
  var t = ux(e, function(r) {
    return n.size === cx && n.clear(), r;
  }), n = t.cache;
  return t;
}
var dx = hx, fx = dx, px = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, mx = /\\(\\)?/g, gx = fx(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(px, function(n, r, a, l) {
    t.push(a ? l.replace(mx, "$1") : r || n);
  }), t;
}), vx = gx;
function _x(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length, a = Array(r); ++n < r; )
    a[n] = t(e[n], n, e);
  return a;
}
var yx = _x, Bh = Xs, bx = yx, wx = si, kx = Au, xx = 1 / 0, $h = Bh ? Bh.prototype : void 0, Nh = $h ? $h.toString : void 0;
function Tp(e) {
  if (typeof e == "string")
    return e;
  if (wx(e))
    return bx(e, Tp) + "";
  if (kx(e))
    return Nh ? Nh.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -xx ? "-0" : t;
}
var Lx = Tp, Mx = Lx;
function Sx(e) {
  return e == null ? "" : Mx(e);
}
var Px = Sx, Cx = si, Ox = Ru, Ex = vx, Tx = Px;
function Dx(e, t) {
  return Cx(e) ? e : Ox(e, t) ? [e] : Ex(Tx(e));
}
var Dp = Dx, Ix = gi, Ax = li, Rx = "[object Arguments]";
function Bx(e) {
  return Ax(e) && Ix(e) == Rx;
}
var $x = Bx, zh = $x, Nx = li, Ip = Object.prototype, zx = Ip.hasOwnProperty, Fx = Ip.propertyIsEnumerable, jx = zh(/* @__PURE__ */ function() {
  return arguments;
}()) ? zh : function(e) {
  return Nx(e) && zx.call(e, "callee") && !Fx.call(e, "callee");
}, zu = jx, Vx = 9007199254740991, Yx = /^(?:0|[1-9]\d*)$/;
function Hx(e, t) {
  var n = typeof e;
  return t = t ?? Vx, !!t && (n == "number" || n != "symbol" && Yx.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
var Fu = Hx, Ux = 9007199254740991;
function Zx(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= Ux;
}
var ju = Zx, Wx = Au, Gx = 1 / 0;
function qx(e) {
  if (typeof e == "string" || Wx(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -Gx ? "-0" : t;
}
var il = qx, Kx = Dp, Jx = zu, Xx = si, Qx = Fu, eL = ju, tL = il;
function nL(e, t, n) {
  t = Kx(t, e);
  for (var r = -1, a = t.length, l = !1; ++r < a; ) {
    var u = tL(t[r]);
    if (!(l = e != null && n(e, u)))
      break;
    e = e[u];
  }
  return l || ++r != a ? l : (a = e == null ? 0 : e.length, !!a && eL(a) && Qx(u, a) && (Xx(e) || Jx(e)));
}
var Ap = nL, iL = Mw, rL = Ap;
function aL(e, t) {
  return e != null && rL(e, t, iL);
}
var Rp = aL, oL = gi, sL = li, lL = "[object Date]";
function uL(e) {
  return sL(e) && oL(e) == lL;
}
var cL = uL;
function hL(e) {
  return function(t) {
    return e(t);
  };
}
var Bp = hL, po = {}, dL = {
  get exports() {
    return po;
  },
  set exports(e) {
    po = e;
  }
};
(function(e, t) {
  var n = Pp, r = t && !t.nodeType && t, a = r && !0 && e && !e.nodeType && e, l = a && a.exports === r, u = l && n.process, h = function() {
    try {
      var f = a && a.require && a.require("util").types;
      return f || u && u.binding && u.binding("util");
    } catch {
    }
  }();
  e.exports = h;
})(dL, po);
var fL = cL, pL = Bp, Fh = po, jh = Fh && Fh.isDate, mL = jh ? pL(jh) : fL, gL = mL, vL = gi, _L = si, yL = li, bL = "[object String]";
function wL(e) {
  return typeof e == "string" || !_L(e) && yL(e) && vL(e) == bL;
}
var di = wL;
function kL(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length; ++n < r; )
    if (t(e[n], n, e))
      return !0;
  return !1;
}
var $p = kL, xL = tl;
function LL() {
  this.__data__ = new xL(), this.size = 0;
}
var ML = LL;
function SL(e) {
  var t = this.__data__, n = t.delete(e);
  return this.size = t.size, n;
}
var PL = SL;
function CL(e) {
  return this.__data__.get(e);
}
var OL = CL;
function EL(e) {
  return this.__data__.has(e);
}
var TL = EL, DL = tl, IL = Bu, AL = $u, RL = 200;
function BL(e, t) {
  var n = this.__data__;
  if (n instanceof DL) {
    var r = n.__data__;
    if (!IL || r.length < RL - 1)
      return r.push([e, t]), this.size = ++n.size, this;
    n = this.__data__ = new AL(r);
  }
  return n.set(e, t), this.size = n.size, this;
}
var $L = BL, NL = tl, zL = ML, FL = PL, jL = OL, VL = TL, YL = $L;
function xa(e) {
  var t = this.__data__ = new NL(e);
  this.size = t.size;
}
xa.prototype.clear = zL;
xa.prototype.delete = FL;
xa.prototype.get = jL;
xa.prototype.has = VL;
xa.prototype.set = YL;
var Vu = xa, HL = "__lodash_hash_undefined__";
function UL(e) {
  return this.__data__.set(e, HL), this;
}
var ZL = UL;
function WL(e) {
  return this.__data__.has(e);
}
var GL = WL, qL = $u, KL = ZL, JL = GL;
function Ts(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.__data__ = new qL(); ++t < n; )
    this.add(e[t]);
}
Ts.prototype.add = Ts.prototype.push = KL;
Ts.prototype.has = JL;
var XL = Ts;
function QL(e, t) {
  return e.has(t);
}
var eM = QL, tM = XL, nM = $p, iM = eM, rM = 1, aM = 2;
function oM(e, t, n, r, a, l) {
  var u = n & rM, h = e.length, f = t.length;
  if (h != f && !(u && f > h))
    return !1;
  var m = l.get(e), v = l.get(t);
  if (m && v)
    return m == t && v == e;
  var y = -1, k = !0, x = n & aM ? new tM() : void 0;
  for (l.set(e, t), l.set(t, e); ++y < h; ) {
    var M = e[y], O = t[y];
    if (r)
      var R = u ? r(O, M, y, t, e, l) : r(M, O, y, e, t, l);
    if (R !== void 0) {
      if (R)
        continue;
      k = !1;
      break;
    }
    if (x) {
      if (!nM(t, function(C, T) {
        if (!iM(x, T) && (M === C || a(M, C, n, r, l)))
          return x.push(T);
      })) {
        k = !1;
        break;
      }
    } else if (!(M === O || a(M, O, n, r, l))) {
      k = !1;
      break;
    }
  }
  return l.delete(e), l.delete(t), k;
}
var Np = oM, sM = mi, lM = sM.Uint8Array, zp = lM;
function uM(e) {
  var t = -1, n = Array(e.size);
  return e.forEach(function(r, a) {
    n[++t] = [a, r];
  }), n;
}
var cM = uM;
function hM(e) {
  var t = -1, n = Array(e.size);
  return e.forEach(function(r) {
    n[++t] = r;
  }), n;
}
var dM = hM, Vh = Xs, Yh = zp, fM = ba, pM = Np, mM = cM, gM = dM, vM = 1, _M = 2, yM = "[object Boolean]", bM = "[object Date]", wM = "[object Error]", kM = "[object Map]", xM = "[object Number]", LM = "[object RegExp]", MM = "[object Set]", SM = "[object String]", PM = "[object Symbol]", CM = "[object ArrayBuffer]", OM = "[object DataView]", Hh = Vh ? Vh.prototype : void 0, Ol = Hh ? Hh.valueOf : void 0;
function EM(e, t, n, r, a, l, u) {
  switch (n) {
    case OM:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case CM:
      return !(e.byteLength != t.byteLength || !l(new Yh(e), new Yh(t)));
    case yM:
    case bM:
    case xM:
      return fM(+e, +t);
    case wM:
      return e.name == t.name && e.message == t.message;
    case LM:
    case SM:
      return e == t + "";
    case kM:
      var h = mM;
    case MM:
      var f = r & vM;
      if (h || (h = gM), e.size != t.size && !f)
        return !1;
      var m = u.get(e);
      if (m)
        return m == t;
      r |= _M, u.set(e, t);
      var v = pM(h(e), h(t), r, a, l, u);
      return u.delete(e), v;
    case PM:
      if (Ol)
        return Ol.call(e) == Ol.call(t);
  }
  return !1;
}
var TM = EM;
function DM(e, t) {
  for (var n = -1, r = t.length, a = e.length; ++n < r; )
    e[a + n] = t[n];
  return e;
}
var IM = DM, AM = IM, RM = si;
function BM(e, t, n) {
  var r = t(e);
  return RM(e) ? r : AM(r, n(e));
}
var $M = BM;
function NM(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length, a = 0, l = []; ++n < r; ) {
    var u = e[n];
    t(u, n, e) && (l[a++] = u);
  }
  return l;
}
var zM = NM;
function FM() {
  return [];
}
var jM = FM, VM = zM, YM = jM, HM = Object.prototype, UM = HM.propertyIsEnumerable, Uh = Object.getOwnPropertySymbols, ZM = Uh ? function(e) {
  return e == null ? [] : (e = Object(e), VM(Uh(e), function(t) {
    return UM.call(e, t);
  }));
} : YM, WM = ZM;
function GM(e, t) {
  for (var n = -1, r = Array(e); ++n < e; )
    r[n] = t(n);
  return r;
}
var qM = GM, ga = {}, KM = {
  get exports() {
    return ga;
  },
  set exports(e) {
    ga = e;
  }
};
function JM() {
  return !1;
}
var XM = JM;
(function(e, t) {
  var n = mi, r = XM, a = t && !t.nodeType && t, l = a && !0 && e && !e.nodeType && e, u = l && l.exports === a, h = u ? n.Buffer : void 0, f = h ? h.isBuffer : void 0, m = f || r;
  e.exports = m;
})(KM, ga);
var QM = gi, eS = ju, tS = li, nS = "[object Arguments]", iS = "[object Array]", rS = "[object Boolean]", aS = "[object Date]", oS = "[object Error]", sS = "[object Function]", lS = "[object Map]", uS = "[object Number]", cS = "[object Object]", hS = "[object RegExp]", dS = "[object Set]", fS = "[object String]", pS = "[object WeakMap]", mS = "[object ArrayBuffer]", gS = "[object DataView]", vS = "[object Float32Array]", _S = "[object Float64Array]", yS = "[object Int8Array]", bS = "[object Int16Array]", wS = "[object Int32Array]", kS = "[object Uint8Array]", xS = "[object Uint8ClampedArray]", LS = "[object Uint16Array]", MS = "[object Uint32Array]", Ht = {};
Ht[vS] = Ht[_S] = Ht[yS] = Ht[bS] = Ht[wS] = Ht[kS] = Ht[xS] = Ht[LS] = Ht[MS] = !0;
Ht[nS] = Ht[iS] = Ht[mS] = Ht[rS] = Ht[gS] = Ht[aS] = Ht[oS] = Ht[sS] = Ht[lS] = Ht[uS] = Ht[cS] = Ht[hS] = Ht[dS] = Ht[fS] = Ht[pS] = !1;
function SS(e) {
  return tS(e) && eS(e.length) && !!Ht[QM(e)];
}
var PS = SS, CS = PS, OS = Bp, Zh = po, Wh = Zh && Zh.isTypedArray, ES = Wh ? OS(Wh) : CS, Yu = ES, TS = qM, DS = zu, IS = si, AS = ga, RS = Fu, BS = Yu, $S = Object.prototype, NS = $S.hasOwnProperty;
function zS(e, t) {
  var n = IS(e), r = !n && DS(e), a = !n && !r && AS(e), l = !n && !r && !a && BS(e), u = n || r || a || l, h = u ? TS(e.length, String) : [], f = h.length;
  for (var m in e)
    (t || NS.call(e, m)) && !(u && // Safari 9 has enumerable `arguments.length` in strict mode.
    (m == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    a && (m == "offset" || m == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    l && (m == "buffer" || m == "byteLength" || m == "byteOffset") || // Skip index properties.
    RS(m, f))) && h.push(m);
  return h;
}
var Fp = zS, FS = Object.prototype;
function jS(e) {
  var t = e && e.constructor, n = typeof t == "function" && t.prototype || FS;
  return e === n;
}
var Hu = jS;
function VS(e, t) {
  return function(n) {
    return e(t(n));
  };
}
var jp = VS, YS = jp, HS = YS(Object.keys, Object), US = HS, ZS = Hu, WS = US, GS = Object.prototype, qS = GS.hasOwnProperty;
function KS(e) {
  if (!ZS(e))
    return WS(e);
  var t = [];
  for (var n in Object(e))
    qS.call(e, n) && n != "constructor" && t.push(n);
  return t;
}
var JS = KS, XS = Br, QS = ju;
function eP(e) {
  return e != null && QS(e.length) && !XS(e);
}
var Lo = eP, tP = Fp, nP = JS, iP = Lo;
function rP(e) {
  return iP(e) ? tP(e) : nP(e);
}
var Uu = rP, aP = $M, oP = WM, sP = Uu;
function lP(e) {
  return aP(e, sP, oP);
}
var uP = lP, Gh = uP, cP = 1, hP = Object.prototype, dP = hP.hasOwnProperty;
function fP(e, t, n, r, a, l) {
  var u = n & cP, h = Gh(e), f = h.length, m = Gh(t), v = m.length;
  if (f != v && !u)
    return !1;
  for (var y = f; y--; ) {
    var k = h[y];
    if (!(u ? k in t : dP.call(t, k)))
      return !1;
  }
  var x = l.get(e), M = l.get(t);
  if (x && M)
    return x == t && M == e;
  var O = !0;
  l.set(e, t), l.set(t, e);
  for (var R = u; ++y < f; ) {
    k = h[y];
    var C = e[k], T = t[k];
    if (r)
      var A = u ? r(T, C, k, t, e, l) : r(C, T, k, e, t, l);
    if (!(A === void 0 ? C === T || a(C, T, n, r, l) : A)) {
      O = !1;
      break;
    }
    R || (R = k == "constructor");
  }
  if (O && !R) {
    var P = e.constructor, D = t.constructor;
    P != D && "constructor" in e && "constructor" in t && !(typeof P == "function" && P instanceof P && typeof D == "function" && D instanceof D) && (O = !1);
  }
  return l.delete(e), l.delete(t), O;
}
var pP = fP, mP = $r, gP = mi, vP = mP(gP, "DataView"), _P = vP, yP = $r, bP = mi, wP = yP(bP, "Promise"), kP = wP, xP = $r, LP = mi, MP = xP(LP, "Set"), SP = MP, PP = $r, CP = mi, OP = PP(CP, "WeakMap"), EP = OP, Xl = _P, Ql = Bu, eu = kP, tu = SP, nu = EP, Vp = gi, La = Op, qh = "[object Map]", TP = "[object Object]", Kh = "[object Promise]", Jh = "[object Set]", Xh = "[object WeakMap]", Qh = "[object DataView]", DP = La(Xl), IP = La(Ql), AP = La(eu), RP = La(tu), BP = La(nu), kr = Vp;
(Xl && kr(new Xl(new ArrayBuffer(1))) != Qh || Ql && kr(new Ql()) != qh || eu && kr(eu.resolve()) != Kh || tu && kr(new tu()) != Jh || nu && kr(new nu()) != Xh) && (kr = function(e) {
  var t = Vp(e), n = t == TP ? e.constructor : void 0, r = n ? La(n) : "";
  if (r)
    switch (r) {
      case DP:
        return Qh;
      case IP:
        return qh;
      case AP:
        return Kh;
      case RP:
        return Jh;
      case BP:
        return Xh;
    }
  return t;
});
var $P = kr, El = Vu, NP = Np, zP = TM, FP = pP, ed = $P, td = si, nd = ga, jP = Yu, VP = 1, id = "[object Arguments]", rd = "[object Array]", es = "[object Object]", YP = Object.prototype, ad = YP.hasOwnProperty;
function HP(e, t, n, r, a, l) {
  var u = td(e), h = td(t), f = u ? rd : ed(e), m = h ? rd : ed(t);
  f = f == id ? es : f, m = m == id ? es : m;
  var v = f == es, y = m == es, k = f == m;
  if (k && nd(e)) {
    if (!nd(t))
      return !1;
    u = !0, v = !1;
  }
  if (k && !v)
    return l || (l = new El()), u || jP(e) ? NP(e, t, n, r, a, l) : zP(e, t, f, n, r, a, l);
  if (!(n & VP)) {
    var x = v && ad.call(e, "__wrapped__"), M = y && ad.call(t, "__wrapped__");
    if (x || M) {
      var O = x ? e.value() : e, R = M ? t.value() : t;
      return l || (l = new El()), a(O, R, n, r, l);
    }
  }
  return k ? (l || (l = new El()), FP(e, t, n, r, a, l)) : !1;
}
var UP = HP, ZP = UP, od = li;
function Yp(e, t, n, r, a) {
  return e === t ? !0 : e == null || t == null || !od(e) && !od(t) ? e !== e && t !== t : ZP(e, t, n, r, Yp, a);
}
var Hp = Yp, WP = Vu, GP = Hp, qP = 1, KP = 2;
function JP(e, t, n, r) {
  var a = n.length, l = a, u = !r;
  if (e == null)
    return !l;
  for (e = Object(e); a--; ) {
    var h = n[a];
    if (u && h[2] ? h[1] !== e[h[0]] : !(h[0] in e))
      return !1;
  }
  for (; ++a < l; ) {
    h = n[a];
    var f = h[0], m = e[f], v = h[1];
    if (u && h[2]) {
      if (m === void 0 && !(f in e))
        return !1;
    } else {
      var y = new WP();
      if (r)
        var k = r(m, v, f, e, t, y);
      if (!(k === void 0 ? GP(v, m, qP | KP, r, y) : k))
        return !1;
    }
  }
  return !0;
}
var XP = JP, QP = Fi;
function eC(e) {
  return e === e && !QP(e);
}
var Up = eC, tC = Up, nC = Uu;
function iC(e) {
  for (var t = nC(e), n = t.length; n--; ) {
    var r = t[n], a = e[r];
    t[n] = [r, a, tC(a)];
  }
  return t;
}
var rC = iC;
function aC(e, t) {
  return function(n) {
    return n == null ? !1 : n[e] === t && (t !== void 0 || e in Object(n));
  };
}
var Zp = aC, oC = XP, sC = rC, lC = Zp;
function uC(e) {
  var t = sC(e);
  return t.length == 1 && t[0][2] ? lC(t[0][0], t[0][1]) : function(n) {
    return n === e || oC(n, e, t);
  };
}
var cC = uC, hC = Dp, dC = il;
function fC(e, t) {
  t = hC(t, e);
  for (var n = 0, r = t.length; e != null && n < r; )
    e = e[dC(t[n++])];
  return n && n == r ? e : void 0;
}
var Wp = fC, pC = Wp;
function mC(e, t, n) {
  var r = e == null ? void 0 : pC(e, t);
  return r === void 0 ? n : r;
}
var Lr = mC;
function gC(e, t) {
  return e != null && t in Object(e);
}
var vC = gC, _C = vC, yC = Ap;
function bC(e, t) {
  return e != null && yC(e, t, _C);
}
var wC = bC, kC = Hp, xC = Lr, LC = wC, MC = Ru, SC = Up, PC = Zp, CC = il, OC = 1, EC = 2;
function TC(e, t) {
  return MC(e) && SC(t) ? PC(CC(e), t) : function(n) {
    var r = xC(n, e);
    return r === void 0 && r === t ? LC(n, e) : kC(t, r, OC | EC);
  };
}
var DC = TC;
function IC(e) {
  return e;
}
var Zu = IC;
function AC(e) {
  return function(t) {
    return t == null ? void 0 : t[e];
  };
}
var RC = AC, BC = Wp;
function $C(e) {
  return function(t) {
    return BC(t, e);
  };
}
var NC = $C, zC = RC, FC = NC, jC = Ru, VC = il;
function YC(e) {
  return jC(e) ? zC(VC(e)) : FC(e);
}
var HC = YC, UC = cC, ZC = DC, WC = Zu, GC = si, qC = HC;
function KC(e) {
  return typeof e == "function" ? e : e == null ? WC : typeof e == "object" ? GC(e) ? ZC(e[0], e[1]) : UC(e) : qC(e);
}
var Gp = KC;
function JC(e) {
  return function(t, n, r) {
    for (var a = -1, l = Object(t), u = r(t), h = u.length; h--; ) {
      var f = u[e ? h : ++a];
      if (n(l[f], f, l) === !1)
        break;
    }
    return t;
  };
}
var XC = JC, QC = XC, eO = QC(), qp = eO, tO = qp, nO = Uu;
function iO(e, t) {
  return e && tO(e, t, nO);
}
var Kp = iO, rO = Lo;
function aO(e, t) {
  return function(n, r) {
    if (n == null)
      return n;
    if (!rO(n))
      return e(n, r);
    for (var a = n.length, l = t ? a : -1, u = Object(n); (t ? l-- : ++l < a) && r(u[l], l, u) !== !1; )
      ;
    return n;
  };
}
var oO = aO, sO = Kp, lO = oO, uO = lO(sO), cO = uO, hO = cO;
function dO(e, t) {
  var n;
  return hO(e, function(r, a, l) {
    return n = t(r, a, l), !n;
  }), !!n;
}
var fO = dO, pO = ba, mO = Lo, gO = Fu, vO = Fi;
function _O(e, t, n) {
  if (!vO(n))
    return !1;
  var r = typeof t;
  return (r == "number" ? mO(n) && gO(t, n.length) : r == "string" && t in n) ? pO(n[t], e) : !1;
}
var Wu = _O, yO = $p, bO = Gp, wO = fO, kO = si, xO = Wu;
function LO(e, t, n) {
  var r = kO(e) ? yO : wO;
  return n && xO(e, t, n) && (t = void 0), r(e, bO(t));
}
var MO = LO, SO = gi, PO = li, CO = "[object Boolean]";
function OO(e) {
  return e === !0 || e === !1 || PO(e) && SO(e) == CO;
}
var EO = OO, TO = gi, DO = li, IO = "[object Number]";
function AO(e) {
  return typeof e == "number" || DO(e) && TO(e) == IO;
}
var ri = AO, RO = $r, BO = function() {
  try {
    var e = RO(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}(), Jp = BO, sd = Jp;
function $O(e, t, n) {
  t == "__proto__" && sd ? sd(e, t, {
    configurable: !0,
    enumerable: !0,
    value: n,
    writable: !0
  }) : e[t] = n;
}
var rl = $O, NO = rl, zO = ba, FO = Object.prototype, jO = FO.hasOwnProperty;
function VO(e, t, n) {
  var r = e[t];
  (!(jO.call(e, t) && zO(r, n)) || n === void 0 && !(t in e)) && NO(e, t, n);
}
var YO = VO, HO = rl, UO = Kp, ZO = Gp;
function WO(e, t) {
  var n = {};
  return t = ZO(t), UO(e, function(r, a, l) {
    HO(n, a, t(r, a, l));
  }), n;
}
var GO = WO;
function qO(e, t, n) {
  switch (n.length) {
    case 0:
      return e.call(t);
    case 1:
      return e.call(t, n[0]);
    case 2:
      return e.call(t, n[0], n[1]);
    case 3:
      return e.call(t, n[0], n[1], n[2]);
  }
  return e.apply(t, n);
}
var Xp = qO, KO = Xp, ld = Math.max;
function JO(e, t, n) {
  return t = ld(t === void 0 ? e.length - 1 : t, 0), function() {
    for (var r = arguments, a = -1, l = ld(r.length - t, 0), u = Array(l); ++a < l; )
      u[a] = r[t + a];
    a = -1;
    for (var h = Array(t + 1); ++a < t; )
      h[a] = r[a];
    return h[t] = n(u), KO(e, this, h);
  };
}
var XO = JO;
function QO(e) {
  return function() {
    return e;
  };
}
var eE = QO, tE = eE, ud = Jp, nE = Zu, iE = ud ? function(e, t) {
  return ud(e, "toString", {
    configurable: !0,
    enumerable: !1,
    value: tE(t),
    writable: !0
  });
} : nE, rE = iE, aE = 800, oE = 16, sE = Date.now;
function lE(e) {
  var t = 0, n = 0;
  return function() {
    var r = sE(), a = oE - (r - n);
    if (n = r, a > 0) {
      if (++t >= aE)
        return arguments[0];
    } else
      t = 0;
    return e.apply(void 0, arguments);
  };
}
var uE = lE, cE = rE, hE = uE, dE = hE(cE), fE = dE, pE = Zu, mE = XO, gE = fE;
function vE(e, t) {
  return gE(mE(e, t, pE), e + "");
}
var Gu = vE;
function _E(e) {
  var t = [];
  if (e != null)
    for (var n in Object(e))
      t.push(n);
  return t;
}
var yE = _E, bE = Fi, wE = Hu, kE = yE, xE = Object.prototype, LE = xE.hasOwnProperty;
function ME(e) {
  if (!bE(e))
    return kE(e);
  var t = wE(e), n = [];
  for (var r in e)
    r == "constructor" && (t || !LE.call(e, r)) || n.push(r);
  return n;
}
var SE = ME, PE = Fp, CE = SE, OE = Lo;
function EE(e) {
  return OE(e) ? PE(e, !0) : CE(e);
}
var qu = EE, TE = Gu, DE = ba, IE = Wu, AE = qu, Qp = Object.prototype, RE = Qp.hasOwnProperty, BE = TE(function(e, t) {
  e = Object(e);
  var n = -1, r = t.length, a = r > 2 ? t[2] : void 0;
  for (a && IE(t[0], t[1], a) && (r = 1); ++n < r; )
    for (var l = t[n], u = AE(l), h = -1, f = u.length; ++h < f; ) {
      var m = u[h], v = e[m];
      (v === void 0 || DE(v, Qp[m]) && !RE.call(e, m)) && (e[m] = l[m]);
    }
  return e;
}), cd = BE, $E = rl, NE = ba;
function zE(e, t, n) {
  (n !== void 0 && !NE(e[t], n) || n === void 0 && !(t in e)) && $E(e, t, n);
}
var em = zE, Ds = {}, FE = {
  get exports() {
    return Ds;
  },
  set exports(e) {
    Ds = e;
  }
};
(function(e, t) {
  var n = mi, r = t && !t.nodeType && t, a = r && !0 && e && !e.nodeType && e, l = a && a.exports === r, u = l ? n.Buffer : void 0, h = u ? u.allocUnsafe : void 0;
  function f(m, v) {
    if (v)
      return m.slice();
    var y = m.length, k = h ? h(y) : new m.constructor(y);
    return m.copy(k), k;
  }
  e.exports = f;
})(FE, Ds);
var hd = zp;
function jE(e) {
  var t = new e.constructor(e.byteLength);
  return new hd(t).set(new hd(e)), t;
}
var VE = jE, YE = VE;
function HE(e, t) {
  var n = t ? YE(e.buffer) : e.buffer;
  return new e.constructor(n, e.byteOffset, e.length);
}
var UE = HE;
function ZE(e, t) {
  var n = -1, r = e.length;
  for (t || (t = Array(r)); ++n < r; )
    t[n] = e[n];
  return t;
}
var WE = ZE, GE = Fi, dd = Object.create, qE = /* @__PURE__ */ function() {
  function e() {
  }
  return function(t) {
    if (!GE(t))
      return {};
    if (dd)
      return dd(t);
    e.prototype = t;
    var n = new e();
    return e.prototype = void 0, n;
  };
}(), KE = qE, JE = jp, XE = JE(Object.getPrototypeOf, Object), tm = XE, QE = KE, eT = tm, tT = Hu;
function nT(e) {
  return typeof e.constructor == "function" && !tT(e) ? QE(eT(e)) : {};
}
var iT = nT, rT = Lo, aT = li;
function oT(e) {
  return aT(e) && rT(e);
}
var sT = oT, lT = gi, uT = tm, cT = li, hT = "[object Object]", dT = Function.prototype, fT = Object.prototype, nm = dT.toString, pT = fT.hasOwnProperty, mT = nm.call(Object);
function gT(e) {
  if (!cT(e) || lT(e) != hT)
    return !1;
  var t = uT(e);
  if (t === null)
    return !0;
  var n = pT.call(t, "constructor") && t.constructor;
  return typeof n == "function" && n instanceof n && nm.call(n) == mT;
}
var vT = gT;
function _T(e, t) {
  if (!(t === "constructor" && typeof e[t] == "function") && t != "__proto__")
    return e[t];
}
var im = _T, yT = YO, bT = rl;
function wT(e, t, n, r) {
  var a = !n;
  n || (n = {});
  for (var l = -1, u = t.length; ++l < u; ) {
    var h = t[l], f = r ? r(n[h], e[h], h, n, e) : void 0;
    f === void 0 && (f = e[h]), a ? bT(n, h, f) : yT(n, h, f);
  }
  return n;
}
var kT = wT, xT = kT, LT = qu;
function MT(e) {
  return xT(e, LT(e));
}
var ST = MT, fd = em, PT = Ds, CT = UE, OT = WE, ET = iT, pd = zu, md = si, TT = sT, DT = ga, IT = Br, AT = Fi, RT = vT, BT = Yu, gd = im, $T = ST;
function NT(e, t, n, r, a, l, u) {
  var h = gd(e, n), f = gd(t, n), m = u.get(f);
  if (m) {
    fd(e, n, m);
    return;
  }
  var v = l ? l(h, f, n + "", e, t, u) : void 0, y = v === void 0;
  if (y) {
    var k = md(f), x = !k && DT(f), M = !k && !x && BT(f);
    v = f, k || x || M ? md(h) ? v = h : TT(h) ? v = OT(h) : x ? (y = !1, v = PT(f, !0)) : M ? (y = !1, v = CT(f, !0)) : v = [] : RT(f) || pd(f) ? (v = h, pd(h) ? v = $T(h) : (!AT(h) || IT(h)) && (v = ET(f))) : y = !1;
  }
  y && (u.set(f, v), a(v, f, r, l, u), u.delete(f)), fd(e, n, v);
}
var zT = NT, FT = Vu, jT = em, VT = qp, YT = zT, HT = Fi, UT = qu, ZT = im;
function rm(e, t, n, r, a) {
  e !== t && VT(t, function(l, u) {
    if (a || (a = new FT()), HT(l))
      YT(e, t, u, n, rm, r, a);
    else {
      var h = r ? r(ZT(e, u), l, u + "", e, t, a) : void 0;
      h === void 0 && (h = l), jT(e, u, h);
    }
  }, UT);
}
var am = rm, WT = am, vd = Fi;
function om(e, t, n, r, a, l) {
  return vd(e) && vd(t) && (l.set(t, e), WT(e, t, void 0, om, l), l.delete(t)), e;
}
var GT = om, qT = Gu, KT = Wu;
function JT(e) {
  return qT(function(t, n) {
    var r = -1, a = n.length, l = a > 1 ? n[a - 1] : void 0, u = a > 2 ? n[2] : void 0;
    for (l = e.length > 3 && typeof l == "function" ? (a--, l) : void 0, u && KT(n[0], n[1], u) && (l = a < 3 ? void 0 : l, a = 1), t = Object(t); ++r < a; ) {
      var h = n[r];
      h && e(t, h, r, l);
    }
    return t;
  });
}
var XT = JT, QT = am, eD = XT, tD = eD(function(e, t, n, r) {
  QT(e, t, n, r);
}), nD = tD, iD = Xp, rD = Gu, aD = GT, oD = nD, sD = rD(function(e) {
  return e.push(void 0, aD), iD(oD, void 0, e);
}), mo = sD;
function lD(e) {
  return e && e.length ? e[0] : void 0;
}
var sm = lD;
function uD(e) {
  var t = e == null ? 0 : e.length;
  return t ? e[t - 1] : void 0;
}
var oa = uD;
const cD = (e) => Object.prototype.toString.call(e).slice(8, -1), ha = (e) => gL(e) && !isNaN(e.getTime()), Di = (e) => cD(e) === "Object", lm = Rp, _d = (e, t) => MO(t, (n) => Rp(e, n)), Bt = (e, t, n = "0") => {
  for (e = e != null ? String(e) : "", t = t || 2; e.length < t; )
    e = `${n}${e}`;
  return e;
}, Fn = (e) => Array.isArray(e), Si = (e) => Fn(e) && e.length > 0, Is = (e) => e == null ? null : document && di(e) ? document.querySelector(e) : e.$el ?? e, ir = (e, t, n, r = void 0) => {
  e.removeEventListener(t, n, r);
}, rr = (e, t, n, r = void 0) => (e.addEventListener(t, n, r), () => ir(e, t, n, r)), ps = (e, t) => !!e && !!t && (e === t || e.contains(t)), ts = (e, t) => {
  (e.key === " " || e.key === "Enter") && (t(e), e.preventDefault());
}, um = (e, ...t) => {
  const n = {};
  let r;
  for (r in e)
    t.includes(r) || (n[r] = e[r]);
  return n;
}, cm = (e, t) => {
  const n = {};
  return t.forEach((r) => {
    r in e && (n[r] = e[r]);
  }), n;
};
function hD(e, t, n) {
  return Math.min(Math.max(e, t), n);
}
var As = {}, dD = {
  get exports() {
    return As;
  },
  set exports(e) {
    As = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = n;
  function n(r) {
    if (r === null || r === !0 || r === !1)
      return NaN;
    var a = Number(r);
    return isNaN(a) ? a : a < 0 ? Math.ceil(a) : Math.floor(a);
  }
  e.exports = t.default;
})(dD, As);
const fD = /* @__PURE__ */ Sp(As);
var Rs = {}, pD = {
  get exports() {
    return Rs;
  },
  set exports(e) {
    Rs = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = n;
  function n(r) {
    var a = new Date(Date.UTC(r.getFullYear(), r.getMonth(), r.getDate(), r.getHours(), r.getMinutes(), r.getSeconds(), r.getMilliseconds()));
    return a.setUTCFullYear(r.getFullYear()), r.getTime() - a.getTime();
  }
  e.exports = t.default;
})(pD, Rs);
const yd = /* @__PURE__ */ Sp(Rs);
function mD(e, t) {
  var n = yD(t);
  return n.formatToParts ? vD(n, e) : _D(n, e);
}
var gD = {
  year: 0,
  month: 1,
  day: 2,
  hour: 3,
  minute: 4,
  second: 5
};
function vD(e, t) {
  try {
    for (var n = e.formatToParts(t), r = [], a = 0; a < n.length; a++) {
      var l = gD[n[a].type];
      l >= 0 && (r[l] = parseInt(n[a].value, 10));
    }
    return r;
  } catch (u) {
    if (u instanceof RangeError)
      return [NaN];
    throw u;
  }
}
function _D(e, t) {
  var n = e.format(t).replace(/\u200E/g, ""), r = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(n);
  return [r[3], r[1], r[2], r[4], r[5], r[6]];
}
var Tl = {};
function yD(e) {
  if (!Tl[e]) {
    var t = new Intl.DateTimeFormat("en-US", {
      hour12: !1,
      timeZone: "America/New_York",
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }).format(/* @__PURE__ */ new Date("2014-06-25T04:00:00.123Z")), n = t === "06/25/2014, 00:00:00" || t === "‎06‎/‎25‎/‎2014‎ ‎00‎:‎00‎:‎00";
    Tl[e] = n ? new Intl.DateTimeFormat("en-US", {
      hour12: !1,
      timeZone: e,
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }) : new Intl.DateTimeFormat("en-US", {
      hourCycle: "h23",
      timeZone: e,
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    });
  }
  return Tl[e];
}
function hm(e, t, n, r, a, l, u) {
  var h = /* @__PURE__ */ new Date(0);
  return h.setUTCFullYear(e, t, n), h.setUTCHours(r, a, l, u), h;
}
var bd = 36e5, bD = 6e4, Dl = {
  timezone: /([Z+-].*)$/,
  timezoneZ: /^(Z)$/,
  timezoneHH: /^([+-]\d{2})$/,
  timezoneHHMM: /^([+-]\d{2}):?(\d{2})$/
};
function wD(e, t, n) {
  var r, a;
  if (!e || (r = Dl.timezoneZ.exec(e), r))
    return 0;
  var l;
  if (r = Dl.timezoneHH.exec(e), r)
    return l = parseInt(r[1], 10), wd(l) ? -(l * bd) : NaN;
  if (r = Dl.timezoneHHMM.exec(e), r) {
    l = parseInt(r[1], 10);
    var u = parseInt(r[2], 10);
    return wd(l, u) ? (a = Math.abs(l) * bd + u * bD, l > 0 ? -a : a) : NaN;
  }
  if (LD(e)) {
    t = new Date(t || Date.now());
    var h = n ? t : kD(t), f = iu(h, e), m = n ? f : xD(t, f, e);
    return -m;
  }
  return NaN;
}
function kD(e) {
  return hm(
    e.getFullYear(),
    e.getMonth(),
    e.getDate(),
    e.getHours(),
    e.getMinutes(),
    e.getSeconds(),
    e.getMilliseconds()
  );
}
function iu(e, t) {
  var n = mD(e, t), r = hm(
    n[0],
    n[1] - 1,
    n[2],
    n[3] % 24,
    n[4],
    n[5],
    0
  ).getTime(), a = e.getTime(), l = a % 1e3;
  return a -= l >= 0 ? l : 1e3 + l, r - a;
}
function xD(e, t, n) {
  var r = e.getTime(), a = r - t, l = iu(new Date(a), n);
  if (t === l)
    return t;
  a -= l - t;
  var u = iu(new Date(a), n);
  return l === u ? l : Math.max(l, u);
}
function wd(e, t) {
  return -23 <= e && e <= 23 && (t == null || 0 <= t && t <= 59);
}
var kd = {};
function LD(e) {
  if (kd[e])
    return !0;
  try {
    return new Intl.DateTimeFormat(void 0, { timeZone: e }), kd[e] = !0, !0;
  } catch {
    return !1;
  }
}
var MD = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;
const SD = MD;
var Il = 36e5, xd = 6e4, PD = 2, Mn = {
  dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
  datePattern: /^([0-9W+-]+)(.*)/,
  plainTime: /:/,
  // year tokens
  YY: /^(\d{2})$/,
  YYY: [
    /^([+-]\d{2})$/,
    // 0 additional digits
    /^([+-]\d{3})$/,
    // 1 additional digit
    /^([+-]\d{4})$/
    // 2 additional digits
  ],
  YYYY: /^(\d{4})/,
  YYYYY: [
    /^([+-]\d{4})/,
    // 0 additional digits
    /^([+-]\d{5})/,
    // 1 additional digit
    /^([+-]\d{6})/
    // 2 additional digits
  ],
  // date tokens
  MM: /^-(\d{2})$/,
  DDD: /^-?(\d{3})$/,
  MMDD: /^-?(\d{2})-?(\d{2})$/,
  Www: /^-?W(\d{2})$/,
  WwwD: /^-?W(\d{2})-?(\d{1})$/,
  HH: /^(\d{2}([.,]\d*)?)$/,
  HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
  HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
  // time zone tokens (to identify the presence of a tz)
  timeZone: SD
};
function CD(e, t) {
  if (arguments.length < 1)
    throw new TypeError("1 argument required, but only " + arguments.length + " present");
  if (e === null)
    return /* @__PURE__ */ new Date(NaN);
  var n = t || {}, r = n.additionalDigits == null ? PD : fD(n.additionalDigits);
  if (r !== 2 && r !== 1 && r !== 0)
    throw new RangeError("additionalDigits must be 0, 1 or 2");
  if (e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]")
    return new Date(e.getTime());
  if (typeof e == "number" || Object.prototype.toString.call(e) === "[object Number]")
    return new Date(e);
  if (!(typeof e == "string" || Object.prototype.toString.call(e) === "[object String]"))
    return /* @__PURE__ */ new Date(NaN);
  var a = OD(e), l = ED(a.date, r), u = l.year, h = l.restDateString, f = TD(h, u);
  if (isNaN(f))
    return /* @__PURE__ */ new Date(NaN);
  if (f) {
    var m = f.getTime(), v = 0, y;
    if (a.time && (v = DD(a.time), isNaN(v)))
      return /* @__PURE__ */ new Date(NaN);
    if (a.timeZone || n.timeZone) {
      if (y = wD(a.timeZone || n.timeZone, new Date(m + v)), isNaN(y))
        return /* @__PURE__ */ new Date(NaN);
    } else
      y = yd(new Date(m + v)), y = yd(new Date(m + v + y));
    return new Date(m + v + y);
  } else
    return /* @__PURE__ */ new Date(NaN);
}
function OD(e) {
  var t = {}, n = Mn.dateTimePattern.exec(e), r;
  if (n ? (t.date = n[1], r = n[3]) : (n = Mn.datePattern.exec(e), n ? (t.date = n[1], r = n[2]) : (t.date = null, r = e)), r) {
    var a = Mn.timeZone.exec(r);
    a ? (t.time = r.replace(a[1], ""), t.timeZone = a[1].trim()) : t.time = r;
  }
  return t;
}
function ED(e, t) {
  var n = Mn.YYY[t], r = Mn.YYYYY[t], a;
  if (a = Mn.YYYY.exec(e) || r.exec(e), a) {
    var l = a[1];
    return {
      year: parseInt(l, 10),
      restDateString: e.slice(l.length)
    };
  }
  if (a = Mn.YY.exec(e) || n.exec(e), a) {
    var u = a[1];
    return {
      year: parseInt(u, 10) * 100,
      restDateString: e.slice(u.length)
    };
  }
  return {
    year: null
  };
}
function TD(e, t) {
  if (t === null)
    return null;
  var n, r, a, l;
  if (e.length === 0)
    return r = /* @__PURE__ */ new Date(0), r.setUTCFullYear(t), r;
  if (n = Mn.MM.exec(e), n)
    return r = /* @__PURE__ */ new Date(0), a = parseInt(n[1], 10) - 1, Md(t, a) ? (r.setUTCFullYear(t, a), r) : /* @__PURE__ */ new Date(NaN);
  if (n = Mn.DDD.exec(e), n) {
    r = /* @__PURE__ */ new Date(0);
    var u = parseInt(n[1], 10);
    return RD(t, u) ? (r.setUTCFullYear(t, 0, u), r) : /* @__PURE__ */ new Date(NaN);
  }
  if (n = Mn.MMDD.exec(e), n) {
    r = /* @__PURE__ */ new Date(0), a = parseInt(n[1], 10) - 1;
    var h = parseInt(n[2], 10);
    return Md(t, a, h) ? (r.setUTCFullYear(t, a, h), r) : /* @__PURE__ */ new Date(NaN);
  }
  if (n = Mn.Www.exec(e), n)
    return l = parseInt(n[1], 10) - 1, Sd(t, l) ? Ld(t, l) : /* @__PURE__ */ new Date(NaN);
  if (n = Mn.WwwD.exec(e), n) {
    l = parseInt(n[1], 10) - 1;
    var f = parseInt(n[2], 10) - 1;
    return Sd(t, l, f) ? Ld(t, l, f) : /* @__PURE__ */ new Date(NaN);
  }
  return null;
}
function DD(e) {
  var t, n, r;
  if (t = Mn.HH.exec(e), t)
    return n = parseFloat(t[1].replace(",", ".")), Al(n) ? n % 24 * Il : NaN;
  if (t = Mn.HHMM.exec(e), t)
    return n = parseInt(t[1], 10), r = parseFloat(t[2].replace(",", ".")), Al(n, r) ? n % 24 * Il + r * xd : NaN;
  if (t = Mn.HHMMSS.exec(e), t) {
    n = parseInt(t[1], 10), r = parseInt(t[2], 10);
    var a = parseFloat(t[3].replace(",", "."));
    return Al(n, r, a) ? n % 24 * Il + r * xd + a * 1e3 : NaN;
  }
  return null;
}
function Ld(e, t, n) {
  t = t || 0, n = n || 0;
  var r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(e, 0, 4);
  var a = r.getUTCDay() || 7, l = t * 7 + n + 1 - a;
  return r.setUTCDate(r.getUTCDate() + l), r;
}
var ID = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], AD = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function dm(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
function Md(e, t, n) {
  if (t < 0 || t > 11)
    return !1;
  if (n != null) {
    if (n < 1)
      return !1;
    var r = dm(e);
    if (r && n > AD[t] || !r && n > ID[t])
      return !1;
  }
  return !0;
}
function RD(e, t) {
  if (t < 1)
    return !1;
  var n = dm(e);
  return !(n && t > 366 || !n && t > 365);
}
function Sd(e, t, n) {
  return !(t < 0 || t > 52 || n != null && (n < 0 || n > 6));
}
function Al(e, t, n) {
  return !(e != null && (e < 0 || e >= 25) || t != null && (t < 0 || t >= 60) || n != null && (n < 0 || n >= 60));
}
function yn(e, t) {
  if (t.length < e)
    throw new TypeError(e + " argument" + (e > 1 ? "s" : "") + " required, but only " + t.length + " present");
}
function ms(e) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? ms = function(n) {
    return typeof n;
  } : ms = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, ms(e);
}
function ji(e) {
  yn(1, arguments);
  var t = Object.prototype.toString.call(e);
  return e instanceof Date || ms(e) === "object" && t === "[object Date]" ? new Date(e.getTime()) : typeof e == "number" || t === "[object Number]" ? new Date(e) : ((typeof e == "string" || t === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
function Ma(e) {
  if (e === null || e === !0 || e === !1)
    return NaN;
  var t = Number(e);
  return isNaN(t) ? t : t < 0 ? Math.ceil(t) : Math.floor(t);
}
var BD = {};
function Ku() {
  return BD;
}
function Dr(e, t) {
  var n, r, a, l, u, h, f, m;
  yn(1, arguments);
  var v = Ku(), y = Ma((n = (r = (a = (l = t == null ? void 0 : t.weekStartsOn) !== null && l !== void 0 ? l : t == null || (u = t.locale) === null || u === void 0 || (h = u.options) === null || h === void 0 ? void 0 : h.weekStartsOn) !== null && a !== void 0 ? a : v.weekStartsOn) !== null && r !== void 0 ? r : (f = v.locale) === null || f === void 0 || (m = f.options) === null || m === void 0 ? void 0 : m.weekStartsOn) !== null && n !== void 0 ? n : 0);
  if (!(y >= 0 && y <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var k = ji(e), x = k.getDay(), M = (x < y ? 7 : 0) + x - y;
  return k.setDate(k.getDate() - M), k.setHours(0, 0, 0, 0), k;
}
function Pd(e) {
  var t = new Date(Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds()));
  return t.setUTCFullYear(e.getFullYear()), e.getTime() - t.getTime();
}
var $D = 6048e5;
function ND(e, t, n) {
  yn(2, arguments);
  var r = Dr(e, n), a = Dr(t, n), l = r.getTime() - Pd(r), u = a.getTime() - Pd(a);
  return Math.round((l - u) / $D);
}
function zD(e) {
  yn(1, arguments);
  var t = ji(e), n = t.getMonth();
  return t.setFullYear(t.getFullYear(), n + 1, 0), t.setHours(0, 0, 0, 0), t;
}
function FD(e) {
  yn(1, arguments);
  var t = ji(e);
  return t.setDate(1), t.setHours(0, 0, 0, 0), t;
}
function jD(e, t) {
  return yn(1, arguments), ND(zD(e), FD(e), t) + 1;
}
function VD(e, t) {
  var n, r, a, l, u, h, f, m;
  yn(1, arguments);
  var v = ji(e), y = v.getFullYear(), k = Ku(), x = Ma((n = (r = (a = (l = t == null ? void 0 : t.firstWeekContainsDate) !== null && l !== void 0 ? l : t == null || (u = t.locale) === null || u === void 0 || (h = u.options) === null || h === void 0 ? void 0 : h.firstWeekContainsDate) !== null && a !== void 0 ? a : k.firstWeekContainsDate) !== null && r !== void 0 ? r : (f = k.locale) === null || f === void 0 || (m = f.options) === null || m === void 0 ? void 0 : m.firstWeekContainsDate) !== null && n !== void 0 ? n : 1);
  if (!(x >= 1 && x <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var M = /* @__PURE__ */ new Date(0);
  M.setFullYear(y + 1, 0, x), M.setHours(0, 0, 0, 0);
  var O = Dr(M, t), R = /* @__PURE__ */ new Date(0);
  R.setFullYear(y, 0, x), R.setHours(0, 0, 0, 0);
  var C = Dr(R, t);
  return v.getTime() >= O.getTime() ? y + 1 : v.getTime() >= C.getTime() ? y : y - 1;
}
function YD(e, t) {
  var n, r, a, l, u, h, f, m;
  yn(1, arguments);
  var v = Ku(), y = Ma((n = (r = (a = (l = t == null ? void 0 : t.firstWeekContainsDate) !== null && l !== void 0 ? l : t == null || (u = t.locale) === null || u === void 0 || (h = u.options) === null || h === void 0 ? void 0 : h.firstWeekContainsDate) !== null && a !== void 0 ? a : v.firstWeekContainsDate) !== null && r !== void 0 ? r : (f = v.locale) === null || f === void 0 || (m = f.options) === null || m === void 0 ? void 0 : m.firstWeekContainsDate) !== null && n !== void 0 ? n : 1), k = VD(e, t), x = /* @__PURE__ */ new Date(0);
  x.setFullYear(k, 0, y), x.setHours(0, 0, 0, 0);
  var M = Dr(x, t);
  return M;
}
var HD = 6048e5;
function UD(e, t) {
  yn(1, arguments);
  var n = ji(e), r = Dr(n, t).getTime() - YD(n, t).getTime();
  return Math.round(r / HD) + 1;
}
function Bs(e) {
  return yn(1, arguments), Dr(e, {
    weekStartsOn: 1
  });
}
function ZD(e) {
  yn(1, arguments);
  var t = ji(e), n = t.getFullYear(), r = /* @__PURE__ */ new Date(0);
  r.setFullYear(n + 1, 0, 4), r.setHours(0, 0, 0, 0);
  var a = Bs(r), l = /* @__PURE__ */ new Date(0);
  l.setFullYear(n, 0, 4), l.setHours(0, 0, 0, 0);
  var u = Bs(l);
  return t.getTime() >= a.getTime() ? n + 1 : t.getTime() >= u.getTime() ? n : n - 1;
}
function WD(e) {
  yn(1, arguments);
  var t = ZD(e), n = /* @__PURE__ */ new Date(0);
  n.setFullYear(t, 0, 4), n.setHours(0, 0, 0, 0);
  var r = Bs(n);
  return r;
}
var GD = 6048e5;
function qD(e) {
  yn(1, arguments);
  var t = ji(e), n = Bs(t).getTime() - WD(t).getTime();
  return Math.round(n / GD) + 1;
}
function Ln(e, t) {
  yn(2, arguments);
  var n = ji(e), r = Ma(t);
  return isNaN(r) ? /* @__PURE__ */ new Date(NaN) : (r && n.setDate(n.getDate() + r), n);
}
function $s(e, t) {
  yn(2, arguments);
  var n = ji(e), r = Ma(t);
  if (isNaN(r))
    return /* @__PURE__ */ new Date(NaN);
  if (!r)
    return n;
  var a = n.getDate(), l = new Date(n.getTime());
  l.setMonth(n.getMonth() + r + 1, 0);
  var u = l.getDate();
  return a >= u ? l : (n.setFullYear(l.getFullYear(), l.getMonth(), a), n);
}
function Cd(e, t) {
  yn(2, arguments);
  var n = Ma(t);
  return $s(e, n * 12);
}
const KD = {
  daily: ["year", "month", "day"],
  weekly: ["year", "month", "week"],
  monthly: ["year", "month"]
};
function JD({
  monthComps: e,
  prevMonthComps: t,
  nextMonthComps: n
}, r) {
  const a = [], {
    firstDayOfWeek: l,
    firstWeekday: u,
    isoWeeknumbers: h,
    weeknumbers: f,
    numDays: m,
    numWeeks: v
  } = e, y = u + (u < l ? vn : 0) - l;
  let k = !0, x = !1, M = !1, O = 0;
  const R = new Intl.DateTimeFormat(r.id, {
    weekday: "long",
    year: "numeric",
    month: "short",
    day: "numeric"
  });
  let C = t.numDays - y + 1, T = t.numDays - C + 1, A = Math.floor((C - 1) / vn + 1), P = 1, D = t.numWeeks, $ = 1, Y = t.month, G = t.year;
  const ee = /* @__PURE__ */ new Date(), X = ee.getDate(), ae = ee.getMonth() + 1, ne = ee.getFullYear();
  for (let se = 1; se <= Y2; se++) {
    for (let re = 1, Q = l; re <= vn; re++, Q += Q === vn ? 1 - vn : 1) {
      k && Q === u && (C = 1, T = e.numDays, A = Math.floor((C - 1) / vn + 1), P = Math.floor((m - C) / vn + 1), D = 1, $ = v, Y = e.month, G = e.year, k = !1, x = !0);
      const ke = r.getDateFromParams(G, Y, C, 0, 0, 0, 0), Ae = r.getDateFromParams(G, Y, C, 12, 0, 0, 0), pe = r.getDateFromParams(
        G,
        Y,
        C,
        23,
        59,
        59,
        999
      ), Ye = ke, ue = `${Bt(G, 4)}-${Bt(Y, 2)}-${Bt(C, 2)}`, Fe = re, Pe = vn - re, nt = f[se - 1], Ve = h[se - 1], Ze = C === X && Y === ae && G === ne, Ne = x && C === 1, ft = x && C === m, pt = se === 1, Wt = se === v, an = re === 1, on = re === vn, Dt = Lm(G, Y, C);
      a.push({
        locale: r,
        id: ue,
        position: ++O,
        label: C.toString(),
        ariaLabel: R.format(new Date(G, Y - 1, C)),
        day: C,
        dayFromEnd: T,
        weekday: Q,
        weekdayPosition: Fe,
        weekdayPositionFromEnd: Pe,
        weekdayOrdinal: A,
        weekdayOrdinalFromEnd: P,
        week: D,
        weekFromEnd: $,
        weekPosition: se,
        weeknumber: nt,
        isoWeeknumber: Ve,
        month: Y,
        year: G,
        date: Ye,
        startDate: ke,
        endDate: pe,
        noonDate: Ae,
        dayIndex: Dt,
        isToday: Ze,
        isFirstDay: Ne,
        isLastDay: ft,
        isDisabled: !x,
        isFocusable: !x,
        isFocused: !1,
        inMonth: x,
        inPrevMonth: k,
        inNextMonth: M,
        onTop: pt,
        onBottom: Wt,
        onLeft: an,
        onRight: on,
        classes: [
          `id-${ue}`,
          `day-${C}`,
          `day-from-end-${T}`,
          `weekday-${Q}`,
          `weekday-position-${Fe}`,
          `weekday-ordinal-${A}`,
          `weekday-ordinal-from-end-${P}`,
          `week-${D}`,
          `week-from-end-${$}`,
          {
            "is-today": Ze,
            "is-first-day": Ne,
            "is-last-day": ft,
            "in-month": x,
            "in-prev-month": k,
            "in-next-month": M,
            "on-top": pt,
            "on-bottom": Wt,
            "on-left": an,
            "on-right": on
          }
        ]
      }), x && ft ? (x = !1, M = !0, C = 1, T = m, A = 1, P = Math.floor((m - C) / vn + 1), D = 1, $ = n.numWeeks, Y = n.month, G = n.year) : (C++, T--, A = Math.floor((C - 1) / vn + 1), P = Math.floor((m - C) / vn + 1));
    }
    D++, $--;
  }
  return a;
}
function XD(e, t, n, r) {
  const a = e.reduce((l, u, h) => {
    const f = Math.floor(h / 7);
    let m = l[f];
    return m || (m = {
      id: `week-${f + 1}`,
      title: "",
      week: u.week,
      weekPosition: u.weekPosition,
      weeknumber: u.weeknumber,
      isoWeeknumber: u.isoWeeknumber,
      weeknumberDisplay: t ? u.weeknumber : n ? u.isoWeeknumber : void 0,
      days: []
    }, l[f] = m), m.days.push(u), l;
  }, Array(e.length / vn));
  return a.forEach((l) => {
    const u = l.days[0], h = l.days[l.days.length - 1];
    u.month === h.month ? l.title = `${r.formatDate(u.date, "MMMM YYYY")}` : u.year === h.year ? l.title = `${r.formatDate(
      u.date,
      "MMM"
    )} - ${r.formatDate(h.date, "MMM YYYY")}` : l.title = `${r.formatDate(
      u.date,
      "MMM YYYY"
    )} - ${r.formatDate(h.date, "MMM YYYY")}`;
  }), a;
}
function QD(e, t) {
  return e.days.map((n) => ({
    label: t.formatDate(n.date, t.masks.weekdays),
    weekday: n.weekday
  }));
}
function e2(e, t) {
  return `${t}.${Bt(e, 2)}`;
}
function fm(e, t, n) {
  return cm(
    n.getDateParts(n.toDate(e)),
    KD[t]
  );
}
function pm({ day: e, week: t, month: n, year: r }, a, l, u) {
  if (l === "daily" && e) {
    const h = new Date(r, n - 1, e), f = Ln(h, a);
    return {
      day: f.getDate(),
      month: f.getMonth() + 1,
      year: f.getFullYear()
    };
  } else if (l === "weekly" && t) {
    const f = u.getMonthParts(n, r).firstDayOfMonth, m = Ln(f, (t - 1 + a) * 7), v = u.getDateParts(m);
    return {
      week: v.week,
      month: v.month,
      year: v.year
    };
  } else {
    const h = new Date(r, n - 1, 1), f = $s(h, a);
    return {
      month: f.getMonth() + 1,
      year: f.getFullYear()
    };
  }
}
function fi(e) {
  return e != null && e.month != null && e.year != null;
}
function ru(e, t) {
  return !fi(e) || !fi(t) ? !1 : (e = e, t = t, e.year !== t.year ? e.year < t.year : e.month && t.month && e.month !== t.month ? e.month < t.month : e.week && t.week && e.week !== t.week ? e.week < t.week : e.day && t.day && e.day !== t.day ? e.day < t.day : !1);
}
function Ns(e, t) {
  return !fi(e) || !fi(t) ? !1 : (e = e, t = t, e.year !== t.year ? e.year > t.year : e.month && t.month && e.month !== t.month ? e.month > t.month : e.week && t.week && e.week !== t.week ? e.week > t.week : e.day && t.day && e.day !== t.day ? e.day > t.day : !1);
}
function t2(e, t, n) {
  return (e || !1) && !ru(e, t) && !Ns(e, n);
}
function n2(e, t) {
  return !e && t || e && !t ? !1 : !e && !t ? !0 : (e = e, t = t, e.year === t.year && e.month === t.month && e.week === t.week && e.day === t.day);
}
function i2(e, t, n, r) {
  if (!fi(e) || !fi(t))
    return [];
  const a = [];
  for (; !Ns(e, t); )
    a.push(e), e = pm(e, 1, n, r);
  return a;
}
function mm(e) {
  const { day: t, week: n, month: r, year: a } = e;
  let l = `${a}-${Bt(r, 2)}`;
  return n && (l = `${l}-w${n}`), t && (l = `${l}-${Bt(t, 2)}`), l;
}
function r2(e, t) {
  const { month: n, year: r, showWeeknumbers: a, showIsoWeeknumbers: l } = e, u = new Date(r, n - 1, 15), h = t.getMonthParts(n, r), f = t.getPrevMonthParts(n, r), m = t.getNextMonthParts(n, r), v = JD({ monthComps: h, prevMonthComps: f, nextMonthComps: m }, t), y = XD(v, a, l, t), k = QD(y[0], t);
  return {
    id: mm(e),
    month: n,
    year: r,
    monthTitle: t.formatDate(u, t.masks.title),
    shortMonthLabel: t.formatDate(u, "MMM"),
    monthLabel: t.formatDate(u, "MMMM"),
    shortYearLabel: r.toString().substring(2),
    yearLabel: r.toString(),
    monthComps: h,
    prevMonthComps: f,
    nextMonthComps: m,
    days: v,
    weeks: y,
    weekdays: k
  };
}
function a2(e, t) {
  const { day: n, week: r, view: a, trimWeeks: l } = e, u = {
    ...t,
    ...e,
    title: "",
    viewDays: [],
    viewWeeks: []
  };
  switch (a) {
    case "daily": {
      let h = u.days.find((m) => m.inMonth);
      n ? h = u.days.find((m) => m.day === n && m.inMonth) || h : r && (h = u.days.find((m) => m.week === r && m.inMonth));
      const f = u.weeks[h.week - 1];
      u.viewWeeks = [f], u.viewDays = [h], u.week = h.week, u.weekTitle = f.title, u.day = h.day, u.dayTitle = h.ariaLabel, u.title = u.dayTitle;
      break;
    }
    case "weekly": {
      u.week = r || 1;
      const h = u.weeks[u.week - 1];
      u.viewWeeks = [h], u.viewDays = h.days, u.weekTitle = h.title, u.title = u.weekTitle;
      break;
    }
    default: {
      u.title = u.monthTitle, u.viewWeeks = u.weeks.slice(
        0,
        l ? u.monthComps.numWeeks : void 0
      ), u.viewDays = u.days;
      break;
    }
  }
  return u;
}
class Od {
  constructor(t, n, r) {
    Ge(this, "keys", []), Ge(this, "store", {}), this.size = t, this.createKey = n, this.createItem = r;
  }
  get(...t) {
    const n = this.createKey(...t);
    return this.store[n];
  }
  getOrSet(...t) {
    const n = this.createKey(...t);
    if (this.store[n])
      return this.store[n];
    const r = this.createItem(...t);
    if (this.keys.length >= this.size) {
      const a = this.keys.shift();
      a != null && delete this.store[a];
    }
    return this.keys.push(n), this.store[n] = r, r;
  }
}
let Ed = class gs {
  constructor(t, n = new zs()) {
    Ge(this, "order"), Ge(this, "locale"), Ge(this, "start", null), Ge(this, "end", null), Ge(this, "repeat", null);
    var r;
    this.locale = n;
    const { start: a, end: l, span: u, order: h, repeat: f } = t;
    ha(a) && (this.start = n.getDateParts(a)), ha(l) ? this.end = n.getDateParts(l) : this.start != null && u && (this.end = n.getDateParts(Ln(this.start.date, u - 1))), this.order = h ?? 0, f && (this.repeat = new Fs(
      {
        from: (r = this.start) == null ? void 0 : r.date,
        ...f
      },
      {
        locale: this.locale
      }
    ));
  }
  static fromMany(t, n) {
    return (Fn(t) ? t : [t]).filter((r) => r).map((r) => gs.from(r, n));
  }
  static from(t, n) {
    if (t instanceof gs)
      return t;
    const r = {
      start: null,
      end: null
    };
    return t != null && (Fn(t) ? (r.start = t[0] ?? null, r.end = t[1] ?? null) : Di(t) ? Object.assign(r, t) : (r.start = t, r.end = t)), r.start != null && (r.start = new Date(r.start)), r.end != null && (r.end = new Date(r.end)), new gs(r, n);
  }
  get opts() {
    const { order: t, locale: n } = this;
    return { order: t, locale: n };
  }
  get hasRepeat() {
    return !!this.repeat;
  }
  get isSingleDay() {
    const { start: t, end: n } = this;
    return t && n && t.year === n.year && t.month === n.month && t.day === n.day;
  }
  get isMultiDay() {
    return !this.isSingleDay;
  }
  get daySpan() {
    return this.start == null || this.end == null ? this.hasRepeat ? 1 : 1 / 0 : this.end.dayIndex - this.start.dayIndex;
  }
  startsOnDay(t) {
    var n, r;
    return ((n = this.start) == null ? void 0 : n.dayIndex) === t.dayIndex || !!((r = this.repeat) != null && r.passes(t));
  }
  intersectsDay(t) {
    return this.intersectsDayRange(t, t);
  }
  intersectsRange(t) {
    var n, r;
    return this.intersectsDayRange(
      ((n = t.start) == null ? void 0 : n.dayIndex) ?? -1 / 0,
      ((r = t.end) == null ? void 0 : r.dayIndex) ?? 1 / 0
    );
  }
  intersectsDayRange(t, n) {
    return !(this.start && this.start.dayIndex > n || this.end && this.end.dayIndex < t);
  }
};
class o2 {
  constructor() {
    Ge(this, "records", {});
  }
  render(t, n, r) {
    var a, l, u, h;
    let f = null;
    const m = r[0].dayIndex, v = r[r.length - 1].dayIndex;
    return n.hasRepeat ? r.forEach((y) => {
      var k, x;
      if (n.startsOnDay(y)) {
        const M = n.daySpan < 1 / 0 ? n.daySpan : 1;
        f = {
          startDay: y.dayIndex,
          startTime: ((k = n.start) == null ? void 0 : k.time) ?? 0,
          endDay: y.dayIndex + M - 1,
          endTime: ((x = n.end) == null ? void 0 : x.time) ?? vs
        }, this.getRangeRecords(t).push(f);
      }
    }) : n.intersectsDayRange(m, v) && (f = {
      startDay: ((a = n.start) == null ? void 0 : a.dayIndex) ?? -1 / 0,
      startTime: ((l = n.start) == null ? void 0 : l.time) ?? -1 / 0,
      endDay: ((u = n.end) == null ? void 0 : u.dayIndex) ?? 1 / 0,
      endTime: ((h = n.end) == null ? void 0 : h.time) ?? 1 / 0
    }, this.getRangeRecords(t).push(f)), f;
  }
  getRangeRecords(t) {
    let n = this.records[t.key];
    return n || (n = {
      ranges: [],
      data: t
    }, this.records[t.key] = n), n.ranges;
  }
  getCell(t, n) {
    return this.getCells(n).find((l) => l.data.key === t);
  }
  cellExists(t, n) {
    const r = this.records[t];
    return r == null ? !1 : r.ranges.some(
      (a) => a.startDay <= n && a.endDay >= n
    );
  }
  getCells(t) {
    const n = Object.values(this.records), r = [], { dayIndex: a } = t;
    return n.forEach(({ data: l, ranges: u }) => {
      u.filter((h) => h.startDay <= a && h.endDay >= a).forEach((h) => {
        const f = a === h.startDay, m = a === h.endDay, v = f ? h.startTime : 0, y = new Date(t.startDate.getTime() + v), k = m ? h.endTime : vs, x = new Date(t.endDate.getTime() + k), M = v === 0 && k === vs, O = l.order || 0;
        r.push({
          ...h,
          data: l,
          onStart: f,
          onEnd: m,
          startTime: v,
          startDate: y,
          endTime: k,
          endDate: x,
          allDay: M,
          order: O
        });
      });
    }), r.sort((l, u) => l.order - u.order), r;
  }
}
const Ii = {
  // Arabic
  ar: { dow: 7, L: "D/‏M/‏YYYY" },
  // Bulgarian
  bg: { dow: 2, L: "D.MM.YYYY" },
  // Catalan
  ca: { dow: 2, L: "DD/MM/YYYY" },
  // Chinese (China)
  "zh-CN": { dow: 2, L: "YYYY/MM/DD" },
  // Chinese (Taiwan)
  "zh-TW": { dow: 1, L: "YYYY/MM/DD" },
  // Croatian
  hr: { dow: 2, L: "DD.MM.YYYY" },
  // Czech
  cs: { dow: 2, L: "DD.MM.YYYY" },
  // Danish
  da: { dow: 2, L: "DD.MM.YYYY" },
  // Dutch
  nl: { dow: 2, L: "DD-MM-YYYY" },
  // English (US)
  "en-US": { dow: 1, L: "MM/DD/YYYY" },
  // English (Australia)
  "en-AU": { dow: 2, L: "DD/MM/YYYY" },
  // English (Canada)
  "en-CA": { dow: 1, L: "YYYY-MM-DD" },
  // English (Great Britain)
  "en-GB": { dow: 2, L: "DD/MM/YYYY" },
  // English (Ireland)
  "en-IE": { dow: 2, L: "DD-MM-YYYY" },
  // English (New Zealand)
  "en-NZ": { dow: 2, L: "DD/MM/YYYY" },
  // English (South Africa)
  "en-ZA": { dow: 1, L: "YYYY/MM/DD" },
  // Esperanto
  eo: { dow: 2, L: "YYYY-MM-DD" },
  // Estonian
  et: { dow: 2, L: "DD.MM.YYYY" },
  // Finnish
  fi: { dow: 2, L: "DD.MM.YYYY" },
  // French
  fr: { dow: 2, L: "DD/MM/YYYY" },
  // French (Canada)
  "fr-CA": { dow: 1, L: "YYYY-MM-DD" },
  // French (Switzerland)
  "fr-CH": { dow: 2, L: "DD.MM.YYYY" },
  // German
  de: { dow: 2, L: "DD.MM.YYYY" },
  // Hebrew
  he: { dow: 1, L: "DD.MM.YYYY" },
  // Indonesian
  id: { dow: 2, L: "DD/MM/YYYY" },
  // Italian
  it: { dow: 2, L: "DD/MM/YYYY" },
  // Japanese
  ja: { dow: 1, L: "YYYY年M月D日" },
  // Korean
  ko: { dow: 1, L: "YYYY.MM.DD" },
  // Latvian
  lv: { dow: 2, L: "DD.MM.YYYY" },
  // Lithuanian
  lt: { dow: 2, L: "DD.MM.YYYY" },
  // Macedonian
  mk: { dow: 2, L: "D.MM.YYYY" },
  // Norwegian
  nb: { dow: 2, L: "D. MMMM YYYY" },
  nn: { dow: 2, L: "D. MMMM YYYY" },
  // Polish
  pl: { dow: 2, L: "DD.MM.YYYY" },
  // Portuguese
  pt: { dow: 2, L: "DD/MM/YYYY" },
  // Romanian
  ro: { dow: 2, L: "DD.MM.YYYY" },
  // Russian
  ru: { dow: 2, L: "DD.MM.YYYY" },
  // Slovak
  sk: { dow: 2, L: "DD.MM.YYYY" },
  // Spanish (Spain)
  "es-ES": { dow: 2, L: "DD/MM/YYYY" },
  // Spanish (Mexico)
  "es-MX": { dow: 2, L: "DD/MM/YYYY" },
  // Swedish
  sv: { dow: 2, L: "YYYY-MM-DD" },
  // Thai
  th: { dow: 1, L: "DD/MM/YYYY" },
  // Turkish
  tr: { dow: 2, L: "DD.MM.YYYY" },
  // Ukrainian
  uk: { dow: 2, L: "DD.MM.YYYY" },
  // Vietnam
  vi: { dow: 2, L: "DD/MM/YYYY" }
};
Ii.en = Ii["en-US"];
Ii.es = Ii["es-ES"];
Ii.no = Ii.nb;
Ii.zh = Ii["zh-CN"];
const s2 = Object.entries(Ii).reduce(
  (e, [t, { dow: n, L: r }]) => (e[t] = {
    id: t,
    firstDayOfWeek: n,
    masks: { L: r }
  }, e),
  {}
), l2 = "MMMM YYYY", u2 = "W", c2 = "MMM", h2 = "h A", d2 = [
  "L",
  "YYYY-MM-DD",
  "YYYY/MM/DD"
], f2 = [
  "L h:mm A",
  "YYYY-MM-DD h:mm A",
  "YYYY/MM/DD h:mm A"
], p2 = [
  "L HH:mm",
  "YYYY-MM-DD HH:mm",
  "YYYY/MM/DD HH:mm"
], m2 = [
  "h:mm A"
], g2 = [
  "HH:mm"
], v2 = "WWW, MMM D, YYYY", _2 = [
  "L",
  "YYYY-MM-DD",
  "YYYY/MM/DD"
], y2 = "iso", b2 = "YYYY-MM-DDTHH:mm:ss.SSSZ", w2 = {
  title: l2,
  weekdays: u2,
  navMonths: c2,
  hours: h2,
  input: d2,
  inputDateTime: f2,
  inputDateTime24hr: p2,
  inputTime: m2,
  inputTime24hr: g2,
  dayPopover: v2,
  data: _2,
  model: y2,
  iso: b2
}, k2 = 300, x2 = 60, L2 = 80, M2 = {
  maxSwipeTime: k2,
  minHorizontalSwipeDistance: x2,
  maxVerticalSwipeDistance: L2
}, S2 = {
  componentPrefix: "V",
  color: "blue",
  isDark: !1,
  navVisibility: "click",
  titlePosition: "center",
  transition: "slide-h",
  touch: M2,
  masks: w2,
  locales: s2,
  datePicker: {
    updateOnInput: !0,
    inputDebounce: 1e3,
    popover: {
      visibility: "hover-focus",
      placement: "bottom-start",
      isInteractive: !0
    }
  }
}, au = Ir(S2), P2 = te(() => GO(au.locales, (e) => (e.masks = mo(e.masks, au.masks), e))), lr = (e) => typeof window < "u" && lm(window.__vcalendar__, e) ? Lr(window.__vcalendar__, e) : Lr(au, e), C2 = 12, O2 = 5;
function E2(e, t) {
  const n = new Intl.DateTimeFormat().resolvedOptions().locale;
  let r;
  di(e) ? r = e : lm(e, "id") && (r = e.id), r = (r || n).toLowerCase();
  const a = Object.keys(t), l = (f) => a.find((m) => m.toLowerCase() === f);
  r = l(r) || l(r.substring(0, 2)) || n;
  const u = {
    ...t["en-IE"],
    ...t[r],
    id: r,
    monthCacheSize: C2,
    pageCacheSize: O2
  };
  return Di(e) ? mo(e, u) : u;
}
let zs = class {
  constructor(t = void 0, n) {
    Ge(this, "id"), Ge(this, "daysInWeek"), Ge(this, "firstDayOfWeek"), Ge(this, "masks"), Ge(this, "timezone"), Ge(this, "hourLabels"), Ge(this, "dayNames"), Ge(this, "dayNamesShort"), Ge(this, "dayNamesShorter"), Ge(this, "dayNamesNarrow"), Ge(this, "monthNames"), Ge(this, "monthNamesShort"), Ge(this, "relativeTimeNames"), Ge(this, "amPm", ["am", "pm"]), Ge(this, "monthCache"), Ge(this, "pageCache");
    const { id: r, firstDayOfWeek: a, masks: l, monthCacheSize: u, pageCacheSize: h } = E2(t, P2.value);
    this.monthCache = new Od(
      u,
      X2,
      Q2
    ), this.pageCache = new Od(h, mm, r2), this.id = r, this.daysInWeek = vn, this.firstDayOfWeek = hD(a, 1, vn), this.masks = l, this.timezone = n || void 0, this.hourLabels = this.getHourLabels(), this.dayNames = Rl("long", this.id), this.dayNamesShort = Rl("short", this.id), this.dayNamesShorter = this.dayNamesShort.map((f) => f.substring(0, 2)), this.dayNamesNarrow = Rl("narrow", this.id), this.monthNames = Bd("long", this.id), this.monthNamesShort = Bd("short", this.id), this.relativeTimeNames = nI(this.id);
  }
  formatDate(t, n) {
    return sI(t, n, this);
  }
  parseDate(t, n) {
    return $d(t, n, this);
  }
  toDate(t, n = {}) {
    const r = /* @__PURE__ */ new Date(NaN);
    let a = r;
    const { fillDate: l, mask: u, patch: h, rules: f } = n;
    if (ri(t) ? (n.type = "number", a = /* @__PURE__ */ new Date(+t)) : di(t) ? (n.type = "string", a = t ? $d(t, u || "iso", this) : r) : ha(t) ? (n.type = "date", a = new Date(t.getTime())) : Ju(t) && (n.type = "object", a = this.getDateFromParts(t)), a && (h || f)) {
      let m = this.getDateParts(a);
      if (h && l != null) {
        const v = this.getDateParts(this.toDate(l));
        m = this.getDateParts(
          this.toDate({ ...v, ...cm(m, V2[h]) })
        );
      }
      f && (m = oI(m, f)), a = this.getDateFromParts(m);
    }
    return a || r;
  }
  toDateOrNull(t, n = {}) {
    const r = this.toDate(t, n);
    return isNaN(r.getTime()) ? null : r;
  }
  fromDate(t, { type: n, mask: r } = {}) {
    switch (n) {
      case "number":
        return t ? t.getTime() : NaN;
      case "string":
        return t ? this.formatDate(t, r || "iso") : "";
      case "object":
        return t ? this.getDateParts(t) : null;
      default:
        return t ? new Date(t) : null;
    }
  }
  range(t) {
    return Ed.from(t, this);
  }
  ranges(t) {
    return Ed.fromMany(t, this);
  }
  getDateParts(t) {
    return J2(t, this);
  }
  getDateFromParts(t) {
    return Sm(t, this.timezone);
  }
  getDateFromParams(t, n, r, a, l, u, h) {
    return this.getDateFromParts({
      year: t,
      month: n,
      day: r,
      hours: a,
      minutes: l,
      seconds: u,
      milliseconds: h
    });
  }
  getPage(t) {
    const n = this.pageCache.getOrSet(t, this);
    return a2(t, n);
  }
  getMonthParts(t, n) {
    const { firstDayOfWeek: r } = this;
    return this.monthCache.getOrSet(t, n, r);
  }
  getThisMonthParts() {
    const t = /* @__PURE__ */ new Date();
    return this.getMonthParts(
      t.getMonth() + 1,
      t.getFullYear()
    );
  }
  getPrevMonthParts(t, n) {
    return t === 1 ? this.getMonthParts(12, n - 1) : this.getMonthParts(t - 1, n);
  }
  getNextMonthParts(t, n) {
    return t === 12 ? this.getMonthParts(1, n + 1) : this.getMonthParts(t + 1, n);
  }
  getHourLabels() {
    return tI().map((t) => this.formatDate(t, this.masks.hours));
  }
  getDayId(t) {
    return this.formatDate(t, "YYYY-MM-DD");
  }
};
var ra = /* @__PURE__ */ ((e) => (e.Any = "any", e.All = "all", e))(ra || {}), gm = /* @__PURE__ */ ((e) => (e.Days = "days", e.Weeks = "weeks", e.Months = "months", e.Years = "years", e))(gm || {}), vm = /* @__PURE__ */ ((e) => (e.Days = "days", e.Weekdays = "weekdays", e.Weeks = "weeks", e.Months = "months", e.Years = "years", e))(vm || {}), _m = /* @__PURE__ */ ((e) => (e.OrdinalWeekdays = "ordinalWeekdays", e))(_m || {});
class T2 {
  constructor(t, n, r) {
    Ge(this, "validated", !0), this.type = t, this.interval = n, this.from = r, this.from || (console.error(
      'A valid "from" date is required for date interval rule. This rule will be skipped.'
    ), this.validated = !1);
  }
  passes(t) {
    if (!this.validated)
      return !0;
    const { date: n } = t;
    switch (this.type) {
      case "days":
        return Xu(this.from.date, n) % this.interval === 0;
      case "weeks":
        return q2(this.from.date, n) % this.interval === 0;
      case "months":
        return K2(this.from.date, n) % this.interval === 0;
      case "years":
        return Mm(this.from.date, n) % this.interval === 0;
      default:
        return !1;
    }
  }
}
class Sa {
  constructor(t, n, r, a) {
    Ge(this, "components", []), this.type = t, this.validator = r, this.getter = a, this.components = this.normalizeComponents(n);
  }
  static create(t, n) {
    switch (t) {
      case "days":
        return new D2(n);
      case "weekdays":
        return new I2(n);
      case "weeks":
        return new A2(n);
      case "months":
        return new R2(n);
      case "years":
        return new B2(n);
    }
  }
  normalizeComponents(t) {
    if (this.validator(t))
      return [t];
    if (!Fn(t))
      return [];
    const n = [];
    return t.forEach((r) => {
      if (!this.validator(r)) {
        console.error(
          `Component value ${r} in invalid for "${this.type}" rule. This rule will be skipped.`
        );
        return;
      }
      n.push(r);
    }), n;
  }
  passes(t) {
    return this.getter(t).some((a) => this.components.includes(a));
  }
}
class D2 extends Sa {
  constructor(t) {
    super(
      "days",
      t,
      z2,
      ({ day: n, dayFromEnd: r }) => [n, -r]
    );
  }
}
class I2 extends Sa {
  constructor(t) {
    super(
      "weekdays",
      t,
      ou,
      ({ weekday: n }) => [n]
    );
  }
}
class A2 extends Sa {
  constructor(t) {
    super(
      "weeks",
      t,
      F2,
      ({ week: n, weekFromEnd: r }) => [n, -r]
    );
  }
}
class R2 extends Sa {
  constructor(t) {
    super("months", t, j2, ({ month: n }) => [
      n
    ]);
  }
}
class B2 extends Sa {
  constructor(t) {
    super("years", t, ri, ({ year: n }) => [n]);
  }
}
class $2 {
  constructor(t, n) {
    Ge(this, "components"), this.type = t, this.components = this.normalizeComponents(n);
  }
  normalizeArrayConfig(t) {
    const n = [];
    return t.forEach((r, a) => {
      if (ri(r)) {
        if (a === 0)
          return;
        if (!Td(t[0])) {
          console.error(
            `Ordinal range for "${this.type}" rule is from -5 to -1 or 1 to 5. This rule will be skipped.`
          );
          return;
        }
        if (!ou(r)) {
          console.error(
            `Acceptable range for "${this.type}" rule is from 1 to 5. This rule will be skipped`
          );
          return;
        }
        n.push([t[0], r]);
      } else
        Fn(r) && n.push(...this.normalizeArrayConfig(r));
    }), n;
  }
  normalizeComponents(t) {
    const n = [];
    return t.forEach((r, a) => {
      if (ri(r)) {
        if (a === 0)
          return;
        if (!Td(t[0])) {
          console.error(
            `Ordinal range for "${this.type}" rule is from -5 to -1 or 1 to 5. This rule will be skipped.`
          );
          return;
        }
        if (!ou(r)) {
          console.error(
            `Acceptable range for "${this.type}" rule is from 1 to 5. This rule will be skipped`
          );
          return;
        }
        n.push([t[0], r]);
      } else
        Fn(r) && n.push(...this.normalizeArrayConfig(r));
    }), n;
  }
  passes(t) {
    const { weekday: n, weekdayOrdinal: r, weekdayOrdinalFromEnd: a } = t;
    return this.components.some(
      ([l, u]) => (l === r || l === -a) && n === u
    );
  }
}
class N2 {
  constructor(t) {
    Ge(this, "type", "function"), Ge(this, "validated", !0), this.fn = t, Br(t) || (console.error(
      "The function rule requires a valid function. This rule will be skipped."
    ), this.validated = !1);
  }
  passes(t) {
    return this.validated ? this.fn(t) : !0;
  }
}
class Fs {
  constructor(t, n = {}, r) {
    Ge(this, "validated", !0), Ge(this, "config"), Ge(this, "type", ra.Any), Ge(this, "from"), Ge(this, "until"), Ge(this, "rules", []), Ge(this, "locale", new zs()), this.parent = r, n.locale && (this.locale = n.locale), this.config = t, Br(t) ? (this.type = ra.All, this.rules = [new N2(t)]) : Fn(t) ? (this.type = ra.Any, this.rules = t.map((a) => new Fs(a, n, this))) : Di(t) ? (this.type = ra.All, this.from = t.from ? this.locale.getDateParts(t.from) : r == null ? void 0 : r.from, this.until = t.until ? this.locale.getDateParts(t.until) : r == null ? void 0 : r.until, this.rules = this.getObjectRules(t)) : (console.error("Rule group configuration must be an object or an array."), this.validated = !1);
  }
  getObjectRules(t) {
    const n = [];
    if (t.every && (di(t.every) && (t.every = [1, `${t.every}s`]), Fn(t.every))) {
      const [r = 1, a = gm.Days] = t.every;
      n.push(new T2(a, r, this.from));
    }
    return Object.values(vm).forEach((r) => {
      r in t && n.push(Sa.create(r, t[r]));
    }), Object.values(_m).forEach((r) => {
      r in t && n.push(new $2(r, t[r]));
    }), t.on != null && (Fn(t.on) || (t.on = [t.on]), n.push(
      new Fs(t.on, { locale: this.locale }, this.parent)
    )), n;
  }
  passes(t) {
    return this.validated ? this.from && t.dayIndex <= this.from.dayIndex || this.until && t.dayIndex >= this.until.dayIndex ? !1 : this.type === ra.Any ? this.rules.some((n) => n.passes(t)) : this.rules.every((n) => n.passes(t)) : !0;
  }
}
function z2(e) {
  return ri(e) ? e >= 1 && e <= 31 : !1;
}
function ou(e) {
  return ri(e) ? e >= 1 && e <= 7 : !1;
}
function F2(e) {
  return ri(e) ? e >= -6 && e <= -1 || e >= 1 && e <= 6 : !1;
}
function j2(e) {
  return ri(e) ? e >= 1 && e <= 12 : !1;
}
function Td(e) {
  return !(!ri(e) || e < -5 || e > 5 || e === 0);
}
const V2 = {
  dateTime: [
    "year",
    "month",
    "day",
    "hours",
    "minutes",
    "seconds",
    "milliseconds"
  ],
  date: ["year", "month", "day"],
  time: ["hours", "minutes", "seconds", "milliseconds"]
}, vn = 7, Y2 = 6, ym = 1e3, bm = ym * 60, wm = bm * 60, vs = wm * 24, H2 = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], U2 = ["L", "iso"], eo = {
  milliseconds: [0, 999, 3],
  seconds: [0, 59, 2],
  minutes: [0, 59, 2],
  hours: [0, 23, 2]
}, km = /d{1,2}|W{1,4}|M{1,4}|YY(?:YY)?|S{1,3}|Do|Z{1,4}|([HhMsDm])\1?|[aA]|"[^"]*"|'[^']*'/g, Z2 = /\[([^]*?)\]/gm, Dd = {
  D(e) {
    return e.day;
  },
  DD(e) {
    return Bt(e.day, 2);
  },
  // Do(d: DateParts, l: Locale) {
  //   return l.DoFn(d.day);
  // },
  d(e) {
    return e.weekday - 1;
  },
  dd(e) {
    return Bt(e.weekday - 1, 2);
  },
  W(e, t) {
    return t.dayNamesNarrow[e.weekday - 1];
  },
  WW(e, t) {
    return t.dayNamesShorter[e.weekday - 1];
  },
  WWW(e, t) {
    return t.dayNamesShort[e.weekday - 1];
  },
  WWWW(e, t) {
    return t.dayNames[e.weekday - 1];
  },
  M(e) {
    return e.month;
  },
  MM(e) {
    return Bt(e.month, 2);
  },
  MMM(e, t) {
    return t.monthNamesShort[e.month - 1];
  },
  MMMM(e, t) {
    return t.monthNames[e.month - 1];
  },
  YY(e) {
    return String(e.year).substr(2);
  },
  YYYY(e) {
    return Bt(e.year, 4);
  },
  h(e) {
    return e.hours % 12 || 12;
  },
  hh(e) {
    return Bt(e.hours % 12 || 12, 2);
  },
  H(e) {
    return e.hours;
  },
  HH(e) {
    return Bt(e.hours, 2);
  },
  m(e) {
    return e.minutes;
  },
  mm(e) {
    return Bt(e.minutes, 2);
  },
  s(e) {
    return e.seconds;
  },
  ss(e) {
    return Bt(e.seconds, 2);
  },
  S(e) {
    return Math.round(e.milliseconds / 100);
  },
  SS(e) {
    return Bt(Math.round(e.milliseconds / 10), 2);
  },
  SSS(e) {
    return Bt(e.milliseconds, 3);
  },
  a(e, t) {
    return e.hours < 12 ? t.amPm[0] : t.amPm[1];
  },
  A(e, t) {
    return e.hours < 12 ? t.amPm[0].toUpperCase() : t.amPm[1].toUpperCase();
  },
  Z() {
    return "Z";
  },
  ZZ(e) {
    const t = e.timezoneOffset;
    return `${t > 0 ? "-" : "+"}${Bt(Math.floor(Math.abs(t) / 60), 2)}`;
  },
  ZZZ(e) {
    const t = e.timezoneOffset;
    return `${t > 0 ? "-" : "+"}${Bt(
      Math.floor(Math.abs(t) / 60) * 100 + Math.abs(t) % 60,
      4
    )}`;
  },
  ZZZZ(e) {
    const t = e.timezoneOffset;
    return `${t > 0 ? "-" : "+"}${Bt(Math.floor(Math.abs(t) / 60), 2)}:${Bt(
      Math.abs(t) % 60,
      2
    )}`;
  }
}, Xi = /\d\d?/, W2 = /\d{3}/, G2 = /\d{4}/, qa = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF/]+(\s*?[\u0600-\u06FF]+){1,2}/i, Id = () => {
}, Ad = (e) => (t, n, r) => {
  const a = r[e].indexOf(
    n.charAt(0).toUpperCase() + n.substr(1).toLowerCase()
  );
  ~a && (t.month = a);
}, zt = {
  D: [
    Xi,
    (e, t) => {
      e.day = t;
    }
  ],
  Do: [
    new RegExp(Xi.source + qa.source),
    (e, t) => {
      e.day = parseInt(t, 10);
    }
  ],
  d: [Xi, Id],
  W: [qa, Id],
  M: [
    Xi,
    (e, t) => {
      e.month = t - 1;
    }
  ],
  MMM: [qa, Ad("monthNamesShort")],
  MMMM: [qa, Ad("monthNames")],
  YY: [
    Xi,
    (e, t) => {
      const r = +(/* @__PURE__ */ new Date()).getFullYear().toString().substr(0, 2);
      e.year = +`${t > 68 ? r - 1 : r}${t}`;
    }
  ],
  YYYY: [
    G2,
    (e, t) => {
      e.year = t;
    }
  ],
  S: [
    /\d/,
    (e, t) => {
      e.milliseconds = t * 100;
    }
  ],
  SS: [
    /\d{2}/,
    (e, t) => {
      e.milliseconds = t * 10;
    }
  ],
  SSS: [
    W2,
    (e, t) => {
      e.milliseconds = t;
    }
  ],
  h: [
    Xi,
    (e, t) => {
      e.hours = t;
    }
  ],
  m: [
    Xi,
    (e, t) => {
      e.minutes = t;
    }
  ],
  s: [
    Xi,
    (e, t) => {
      e.seconds = t;
    }
  ],
  a: [
    qa,
    (e, t, n) => {
      const r = t.toLowerCase();
      r === n.amPm[0] ? e.isPm = !1 : r === n.amPm[1] && (e.isPm = !0);
    }
  ],
  Z: [
    /[^\s]*?[+-]\d\d:?\d\d|[^\s]*?Z?/,
    (e, t) => {
      t === "Z" && (t = "+00:00");
      const n = `${t}`.match(/([+-]|\d\d)/gi);
      if (n) {
        const r = +n[1] * 60 + parseInt(n[2], 10);
        e.timezoneOffset = n[0] === "+" ? r : -r;
      }
    }
  ]
};
zt.DD = zt.D;
zt.dd = zt.d;
zt.WWWW = zt.WWW = zt.WW = zt.W;
zt.MM = zt.M;
zt.mm = zt.m;
zt.hh = zt.H = zt.HH = zt.h;
zt.ss = zt.s;
zt.A = zt.a;
zt.ZZZZ = zt.ZZZ = zt.ZZ = zt.Z;
function xm(e, t) {
  return (Si(e) && e || [
    di(e) && e || "YYYY-MM-DD"
  ]).map(
    (n) => U2.reduce(
      (r, a) => r.replace(a, t.masks[a] || ""),
      n
    )
  );
}
function Ju(e) {
  return Di(e) && "year" in e && "month" in e && "day" in e;
}
function Rd(e, t = 1) {
  const n = e.getDay() + 1, r = n >= t ? t - n : -(7 - (t - n));
  return Ln(e, r);
}
function Lm(e, t, n) {
  const r = Date.UTC(e, t - 1, n);
  return Xu(/* @__PURE__ */ new Date(0), new Date(r));
}
function Xu(e, t) {
  return Math.round((t.getTime() - e.getTime()) / vs);
}
function q2(e, t) {
  return Math.ceil(Xu(Rd(e), Rd(t)) / 7);
}
function Mm(e, t) {
  return t.getUTCFullYear() - e.getUTCFullYear();
}
function K2(e, t) {
  return Mm(e, t) * 12 + (t.getMonth() - e.getMonth());
}
function Sm(e, t = "") {
  const n = /* @__PURE__ */ new Date(), {
    year: r = n.getFullYear(),
    month: a = n.getMonth() + 1,
    day: l = n.getDate(),
    hours: u = 0,
    minutes: h = 0,
    seconds: f = 0,
    milliseconds: m = 0
  } = e;
  if (t) {
    const v = `${Bt(r, 4)}-${Bt(a, 2)}-${Bt(l, 2)}T${Bt(
      u,
      2
    )}:${Bt(h, 2)}:${Bt(f, 2)}.${Bt(m, 3)}`;
    return CD(v, { timeZone: t });
  }
  return new Date(r, a - 1, l, u, h, f, m);
}
function J2(e, t) {
  let n = new Date(e.getTime());
  t.timezone && (n = new Date(
    e.toLocaleString("en-US", { timeZone: t.timezone })
  ), n.setMilliseconds(e.getMilliseconds()));
  const r = n.getMilliseconds(), a = n.getSeconds(), l = n.getMinutes(), u = n.getHours(), h = r + a * ym + l * bm + u * wm, f = n.getMonth() + 1, m = n.getFullYear(), v = t.getMonthParts(f, m), y = n.getDate(), k = v.numDays - y + 1, x = n.getDay() + 1, M = Math.floor((y - 1) / 7 + 1), O = Math.floor((v.numDays - y) / 7 + 1), R = Math.ceil(
    (y + Math.abs(v.firstWeekday - v.firstDayOfWeek)) / 7
  ), C = v.numWeeks - R + 1, T = v.weeknumbers[R], A = Lm(m, f, y);
  return {
    milliseconds: r,
    seconds: a,
    minutes: l,
    hours: u,
    time: h,
    day: y,
    dayFromEnd: k,
    weekday: x,
    weekdayOrdinal: M,
    weekdayOrdinalFromEnd: O,
    week: R,
    weekFromEnd: C,
    weeknumber: T,
    month: f,
    year: m,
    date: n,
    dateTime: n.getTime(),
    dayIndex: A,
    timezoneOffset: 0,
    isValid: !0
  };
}
function X2(e, t, n) {
  return `${t}-${e}-${n}`;
}
function Q2(e, t, n) {
  const r = t % 4 === 0 && t % 100 !== 0 || t % 400 === 0, a = new Date(t, e - 1, 1), l = a.getDay() + 1, u = e === 2 && r ? 29 : H2[e - 1], h = n - 1, f = jD(a, {
    weekStartsOn: h
  }), m = [], v = [];
  for (let y = 0; y < f; y++) {
    const k = Ln(a, y * 7);
    m.push(UD(k, { weekStartsOn: h })), v.push(qD(k));
  }
  return {
    firstDayOfWeek: n,
    firstDayOfMonth: a,
    inLeapYear: r,
    firstWeekday: l,
    numDays: u,
    numWeeks: f,
    month: e,
    year: t,
    weeknumbers: m,
    isoWeeknumbers: v
  };
}
function eI() {
  const e = [];
  for (let a = 0; a < vn; a++)
    e.push(
      Sm({
        year: 2020,
        month: 1,
        day: 5 + a,
        hours: 12
      })
    );
  return e;
}
function Rl(e, t = void 0) {
  const n = new Intl.DateTimeFormat(t, {
    weekday: e
  });
  return eI().map((r) => n.format(r));
}
function tI() {
  const e = [];
  for (let t = 0; t <= 24; t++)
    e.push(new Date(2e3, 0, 1, t));
  return e;
}
function nI(e = void 0) {
  const t = [
    "second",
    "minute",
    "hour",
    "day",
    "week",
    "month",
    "quarter",
    "year"
  ], n = new Intl.RelativeTimeFormat(e);
  return t.reduce((r, a) => {
    const l = n.formatToParts(100, a);
    return r[a] = l[1].unit, r;
  }, {});
}
function Pm() {
  const e = [];
  for (let t = 0; t < 12; t++)
    e.push(new Date(2e3, t, 15));
  return e;
}
function Bd(e, t = void 0) {
  const n = new Intl.DateTimeFormat(t, {
    month: e,
    timeZone: "UTC"
  });
  return Pm().map((r) => n.format(r));
}
function iI(e, t, n) {
  return ri(t) ? t === e : Fn(t) ? t.includes(e) : Br(t) ? t(e, n) : !(t.min != null && t.min > e || t.max != null && t.max < e || t.interval != null && e % t.interval !== 0);
}
function to(e, t, n) {
  const r = [], [a, l, u] = t;
  for (let h = a; h <= l; h++)
    (n == null || iI(h, n, e)) && r.push({
      value: h,
      label: Bt(h, u)
    });
  return r;
}
function rI(e, t) {
  return {
    milliseconds: to(
      e,
      eo.milliseconds,
      t.milliseconds
    ),
    seconds: to(e, eo.seconds, t.seconds),
    minutes: to(e, eo.minutes, t.minutes),
    hours: to(e, eo.hours, t.hours)
  };
}
function aI(e, t, n, r) {
  const l = to(e, t, r).reduce((u, h) => {
    if (h.disabled)
      return u;
    if (isNaN(u))
      return h.value;
    const f = Math.abs(u - n);
    return Math.abs(h.value - n) < f ? h.value : u;
  }, NaN);
  return isNaN(l) ? n : l;
}
function oI(e, t) {
  const n = { ...e };
  return Object.entries(t).forEach(([r, a]) => {
    const l = eo[r], u = e[r];
    n[r] = aI(
      e,
      l,
      u,
      a
    );
  }), n;
}
function $d(e, t, n) {
  return xm(t, n).map((a) => {
    if (typeof a != "string")
      throw new Error("Invalid mask");
    let l = e;
    if (l.length > 1e3)
      return !1;
    let u = !0;
    const h = {};
    if (a.replace(km, (v) => {
      if (zt[v]) {
        const y = zt[v], k = l.search(y[0]);
        ~k ? l.replace(y[0], (x) => (y[1](h, x, n), l = l.substr(k + x.length), x)) : u = !1;
      }
      return zt[v] ? "" : v.slice(1, v.length - 1);
    }), !u)
      return !1;
    const f = /* @__PURE__ */ new Date();
    h.hours != null && (h.isPm === !0 && +h.hours != 12 ? h.hours = +h.hours + 12 : h.isPm === !1 && +h.hours == 12 && (h.hours = 0));
    let m;
    return h.timezoneOffset != null ? (h.minutes = +(h.minutes || 0) - +h.timezoneOffset, m = new Date(
      Date.UTC(
        h.year || f.getFullYear(),
        h.month || 0,
        h.day || 1,
        h.hours || 0,
        h.minutes || 0,
        h.seconds || 0,
        h.milliseconds || 0
      )
    )) : m = n.getDateFromParts({
      year: h.year || f.getFullYear(),
      month: (h.month || 0) + 1,
      day: h.day || 1,
      hours: h.hours || 0,
      minutes: h.minutes || 0,
      seconds: h.seconds || 0,
      milliseconds: h.milliseconds || 0
    }), m;
  }).find((a) => a) || new Date(e);
}
function sI(e, t, n) {
  if (e == null)
    return "";
  let r = xm(t, n)[0];
  /Z$/.test(r) && (n.timezone = "utc");
  const a = [];
  r = r.replace(Z2, (u, h) => (a.push(h), "??"));
  const l = n.getDateParts(e);
  return r = r.replace(
    km,
    (u) => u in Dd ? Dd[u](l, n) : u.slice(1, u.length - 1)
  ), r.replace(/\?\?/g, () => a.shift());
}
let lI = 0;
class Cm {
  constructor(t, n, r) {
    Ge(this, "key", ""), Ge(this, "hashcode", ""), Ge(this, "highlight", null), Ge(this, "content", null), Ge(this, "dot", null), Ge(this, "bar", null), Ge(this, "event", null), Ge(this, "popover", null), Ge(this, "customData", null), Ge(this, "ranges"), Ge(this, "hasRanges", !1), Ge(this, "order", 0), Ge(this, "pinPage", !1), Ge(this, "maxRepeatSpan", 0), Ge(this, "locale");
    const { dates: a } = Object.assign(
      this,
      { hashcode: "", order: 0, pinPage: !1 },
      t
    );
    this.key || (this.key = ++lI), this.locale = r, n.normalizeGlyphs(this), this.ranges = r.ranges(a ?? []), this.hasRanges = !!Si(this.ranges), this.maxRepeatSpan = this.ranges.filter((l) => l.hasRepeat).map((l) => l.daySpan).reduce((l, u) => Math.max(l, u), 0);
  }
  intersectsRange({ start: t, end: n }) {
    if (t == null || n == null)
      return !1;
    const r = this.ranges.filter((u) => !u.hasRepeat);
    for (const u of r)
      if (u.intersectsDayRange(t.dayIndex, n.dayIndex))
        return !0;
    const a = this.ranges.filter((u) => u.hasRepeat);
    if (!a.length)
      return !1;
    let l = t;
    for (this.maxRepeatSpan > 1 && (l = this.locale.getDateParts(Ln(l.date, -this.maxRepeatSpan))); l.dayIndex <= n.dayIndex; ) {
      for (const u of a)
        if (u.startsOnDay(l))
          return !0;
      l = this.locale.getDateParts(Ln(l.date, 1));
    }
    return !1;
  }
}
function su(e) {
  document && document.dispatchEvent(
    new CustomEvent("show-popover", {
      detail: e
    })
  );
}
function go(e) {
  document && document.dispatchEvent(
    new CustomEvent("hide-popover", {
      detail: e
    })
  );
}
function Om(e) {
  document && document.dispatchEvent(
    new CustomEvent("toggle-popover", {
      detail: e
    })
  );
}
function Em(e) {
  const { visibility: t } = e, n = t === "click", r = t === "hover", a = t === "hover-focus", l = t === "focus";
  e.autoHide = !n;
  let u = !1, h = !1;
  const f = (M) => {
    n && (Om({
      ...e,
      target: e.target || M.currentTarget
    }), M.stopPropagation());
  }, m = (M) => {
    u || (u = !0, (r || a) && su({
      ...e,
      target: e.target || M.currentTarget
    }));
  }, v = () => {
    u && (u = !1, (r || a && !h) && go(e));
  }, y = (M) => {
    h || (h = !0, (l || a) && su({
      ...e,
      target: e.target || M.currentTarget
    }));
  }, k = (M) => {
    h && !ps(M.currentTarget, M.relatedTarget) && (h = !1, (l || a && !u) && go(e));
  }, x = {};
  switch (e.visibility) {
    case "click":
      x.click = f;
      break;
    case "hover":
      x.mousemove = m, x.mouseleave = v;
      break;
    case "focus":
      x.focusin = y, x.focusout = k;
      break;
    case "hover-focus":
      x.mousemove = m, x.mouseleave = v, x.focusin = y, x.focusout = k;
      break;
  }
  return x;
}
const Nd = (e) => {
  const t = Is(e);
  if (t == null)
    return;
  const n = t.popoverHandlers;
  !n || !n.length || (n.forEach((r) => r()), delete t.popoverHandlers);
}, zd = (e, t) => {
  const n = Is(e);
  if (n == null)
    return;
  const r = [], a = Em(t);
  Object.entries(a).forEach(([l, u]) => {
    r.push(rr(n, l, u));
  }), n.popoverHandlers = r;
}, Tm = {
  mounted(e, t) {
    const { value: n } = t;
    n && zd(e, n);
  },
  updated(e, t) {
    const { oldValue: n, value: r } = t, a = n == null ? void 0 : n.visibility, l = r == null ? void 0 : r.visibility;
    a !== l && (a && (Nd(e), l || go(n)), l && zd(e, r));
  },
  unmounted(e) {
    Nd(e);
  }
}, uI = (e, t, {
  maxSwipeTime: n,
  minHorizontalSwipeDistance: r,
  maxVerticalSwipeDistance: a
}) => {
  if (!e || !e.addEventListener || !Br(t))
    return null;
  let l = 0, u = 0, h = null, f = !1;
  function m(y) {
    const k = y.changedTouches[0];
    l = k.screenX, u = k.screenY, h = (/* @__PURE__ */ new Date()).getTime(), f = !0;
  }
  function v(y) {
    if (!f || !h)
      return;
    f = !1;
    const k = y.changedTouches[0], x = k.screenX - l, M = k.screenY - u;
    if ((/* @__PURE__ */ new Date()).getTime() - h < n && Math.abs(x) >= r && Math.abs(M) <= a) {
      const R = { toLeft: !1, toRight: !1 };
      x < 0 ? R.toLeft = !0 : R.toRight = !0, t(R);
    }
  }
  return rr(e, "touchstart", m, { passive: !0 }), rr(e, "touchend", v, { passive: !0 }), () => {
    ir(e, "touchstart", m), ir(e, "touchend", v);
  };
}, _s = {}, cI = (e, t = 10) => {
  _s[e] = Date.now() + t;
}, hI = (e, t) => {
  if (e in _s) {
    const n = _s[e];
    if (Date.now() < n)
      return;
    delete _s[e];
  }
  t();
};
function Dm() {
  return typeof window < "u";
}
function dI(e) {
  return Dm() && e in window;
}
function fI(e) {
  const t = je(!1), n = te(() => t.value ? "dark" : "light");
  let r, a;
  function l(x) {
    t.value = x.matches;
  }
  function u() {
    dI("matchMedia") && (r = window.matchMedia("(prefers-color-scheme: dark)"), r.addEventListener("change", l), t.value = r.matches);
  }
  function h() {
    const { selector: x = ":root", darkClass: M = "dark" } = e.value, O = document.querySelector(x);
    t.value = O.classList.contains(M);
  }
  function f(x) {
    const { selector: M = ":root", darkClass: O = "dark" } = x;
    if (Dm() && M && O) {
      const R = document.querySelector(M);
      R && (a = new MutationObserver(h), a.observe(R, {
        attributes: !0,
        attributeFilter: ["class"]
      }), t.value = R.classList.contains(O));
    }
  }
  function m() {
    y();
    const x = typeof e.value;
    x === "string" && e.value.toLowerCase() === "system" ? u() : x === "object" ? f(e.value) : t.value = !!e.value;
  }
  const v = kt(() => e.value, () => m(), {
    immediate: !0
  });
  function y() {
    r && (r.removeEventListener("change", l), r = void 0), a && (a.disconnect(), a = void 0);
  }
  function k() {
    y(), v();
  }
  return _o(() => k()), {
    isDark: t,
    displayMode: n,
    cleanup: k
  };
}
const pI = ["base", "start", "end", "startEnd"], mI = [
  "class",
  "wrapperClass",
  "contentClass",
  "style",
  "contentStyle",
  "color",
  "fillMode"
], gI = { base: {}, start: {}, end: {} };
function Qu(e, t, n = gI) {
  let r = e, a = {};
  t === !0 || di(t) ? (r = di(t) ? t : r, a = { ...n }) : Di(t) && (_d(t, pI) ? a = { ...t } : a = {
    base: { ...t },
    start: { ...t },
    end: { ...t }
  });
  const l = mo(
    a,
    { start: a.startEnd, end: a.startEnd },
    n
  );
  return Object.entries(l).forEach(([u, h]) => {
    let f = r;
    h === !0 || di(h) ? (f = di(h) ? h : f, l[u] = { color: f }) : Di(h) && (_d(h, mI) ? l[u] = { ...h } : l[u] = {}), mo(l[u], { color: f });
  }), l;
}
class vI {
  constructor() {
    Ge(this, "type", "highlight");
  }
  normalizeConfig(t, n) {
    return Qu(t, n, {
      base: { fillMode: "light" },
      start: { fillMode: "solid" },
      end: { fillMode: "solid" }
    });
  }
  prepareRender(t) {
    t.highlights = [], t.content || (t.content = []);
  }
  render({ data: t, onStart: n, onEnd: r }, a) {
    const { key: l, highlight: u } = t;
    if (!u)
      return;
    const { highlights: h } = a, { base: f, start: m, end: v } = u;
    n && r ? h.push({
      ...m,
      key: l,
      wrapperClass: `vc-day-layer vc-day-box-center-center vc-attr vc-${m.color}`,
      class: [`vc-highlight vc-highlight-bg-${m.fillMode}`, m.class],
      contentClass: [
        `vc-attr vc-highlight-content-${m.fillMode} vc-${m.color}`,
        m.contentClass
      ]
    }) : n ? (h.push({
      ...f,
      key: `${l}-base`,
      wrapperClass: `vc-day-layer vc-day-box-right-center vc-attr vc-${f.color}`,
      class: [
        `vc-highlight vc-highlight-base-start vc-highlight-bg-${f.fillMode}`,
        f.class
      ]
    }), h.push({
      ...m,
      key: l,
      wrapperClass: `vc-day-layer vc-day-box-center-center vc-attr vc-${m.color}`,
      class: [`vc-highlight vc-highlight-bg-${m.fillMode}`, m.class],
      contentClass: [
        `vc-attr vc-highlight-content-${m.fillMode} vc-${m.color}`,
        m.contentClass
      ]
    })) : r ? (h.push({
      ...f,
      key: `${l}-base`,
      wrapperClass: `vc-day-layer vc-day-box-left-center vc-attr vc-${f.color}`,
      class: [
        `vc-highlight vc-highlight-base-end vc-highlight-bg-${f.fillMode}`,
        f.class
      ]
    }), h.push({
      ...v,
      key: l,
      wrapperClass: `vc-day-layer vc-day-box-center-center vc-attr vc-${v.color}`,
      class: [`vc-highlight vc-highlight-bg-${v.fillMode}`, v.class],
      contentClass: [
        `vc-attr vc-highlight-content-${v.fillMode} vc-${v.color}`,
        v.contentClass
      ]
    })) : h.push({
      ...f,
      key: `${l}-middle`,
      wrapperClass: `vc-day-layer vc-day-box-center-center vc-attr vc-${f.color}`,
      class: [
        `vc-highlight vc-highlight-base-middle vc-highlight-bg-${f.fillMode}`,
        f.class
      ],
      contentClass: [
        `vc-attr vc-highlight-content-${f.fillMode} vc-${f.color}`,
        f.contentClass
      ]
    });
  }
}
class ec {
  constructor(t, n) {
    Ge(this, "type", ""), Ge(this, "collectionType", ""), this.type = t, this.collectionType = n;
  }
  normalizeConfig(t, n) {
    return Qu(t, n);
  }
  prepareRender(t) {
    t[this.collectionType] = [];
  }
  render({ data: t, onStart: n, onEnd: r }, a) {
    const { key: l } = t, u = t[this.type];
    if (!l || !u)
      return;
    const h = a[this.collectionType], { base: f, start: m, end: v } = u;
    n ? h.push({
      ...m,
      key: l,
      class: [
        `vc-${this.type} vc-${this.type}-start vc-${m.color} vc-attr`,
        m.class
      ]
    }) : r ? h.push({
      ...v,
      key: l,
      class: [
        `vc-${this.type} vc-${this.type}-end vc-${v.color} vc-attr`,
        v.class
      ]
    }) : h.push({
      ...f,
      key: l,
      class: [
        `vc-${this.type} vc-${this.type}-base vc-${f.color} vc-attr`,
        f.class
      ]
    });
  }
}
class _I extends ec {
  constructor() {
    super("content", "content");
  }
  normalizeConfig(t, n) {
    return Qu("base", n);
  }
}
class yI extends ec {
  constructor() {
    super("dot", "dots");
  }
}
class bI extends ec {
  constructor() {
    super("bar", "bars");
  }
}
class wI {
  constructor(t) {
    Ge(this, "color"), Ge(this, "renderers", [
      new _I(),
      new vI(),
      new yI(),
      new bI()
    ]), this.color = t;
  }
  normalizeGlyphs(t) {
    this.renderers.forEach((n) => {
      const r = n.type;
      t[r] != null && (t[r] = n.normalizeConfig(this.color, t[r]));
    });
  }
  prepareRender(t = {}) {
    return this.renderers.forEach((n) => {
      n.prepareRender(t);
    }), t;
  }
  render(t, n) {
    this.renderers.forEach((r) => {
      r.render(t, n);
    });
  }
}
const Im = Symbol("__vc_base_context__"), Am = {
  color: {
    type: String,
    default: () => lr("color")
  },
  isDark: {
    type: [Boolean, String, Object],
    default: () => lr("isDark")
  },
  firstDayOfWeek: Number,
  masks: Object,
  locale: [String, Object],
  timezone: String,
  minDate: null,
  maxDate: null,
  disabledDates: null
};
function Rm(e) {
  const t = te(() => e.color ?? ""), n = te(() => e.isDark ?? !1), { displayMode: r } = fI(n), a = te(() => new wI(t.value)), l = te(() => {
    if (e.locale instanceof zs)
      return e.locale;
    const k = Di(e.locale) ? e.locale : {
      id: e.locale,
      firstDayOfWeek: e.firstDayOfWeek,
      masks: e.masks
    };
    return new zs(k, e.timezone);
  }), u = te(() => l.value.masks), h = te(() => e.minDate), f = te(() => e.maxDate), m = te(() => {
    const k = e.disabledDates ? [...e.disabledDates] : [];
    return h.value != null && k.push({
      start: null,
      end: Ln(l.value.toDate(h.value), -1)
    }), f.value != null && k.push({
      start: Ln(l.value.toDate(f.value), 1),
      end: null
    }), l.value.ranges(k);
  }), v = te(() => new Cm(
    {
      key: "disabled",
      dates: m.value,
      order: 100
    },
    a.value,
    l.value
  )), y = {
    color: t,
    isDark: n,
    displayMode: r,
    theme: a,
    locale: l,
    masks: u,
    minDate: h,
    maxDate: f,
    disabledDates: m,
    disabledAttribute: v
  };
  return Bi(Im, y), y;
}
function kI(e) {
  return Ri(Im, () => Rm(e), !0);
}
function Bm(e) {
  return `__vc_slot_${e}__`;
}
function $m(e, t = {}) {
  Object.keys(e).forEach((n) => {
    Bi(Bm(t[n] ?? n), e[n]);
  });
}
function Nm(e) {
  return Ri(Bm(e), null);
}
const xI = {
  ...Am,
  view: {
    type: String,
    default: "monthly",
    validator(e) {
      return ["daily", "weekly", "monthly"].includes(e);
    }
  },
  rows: {
    type: Number,
    default: 1
  },
  columns: {
    type: Number,
    default: 1
  },
  step: Number,
  titlePosition: {
    type: String,
    default: () => lr("titlePosition")
  },
  navVisibility: {
    type: String,
    default: () => lr("navVisibility")
  },
  showWeeknumbers: [Boolean, String],
  showIsoWeeknumbers: [Boolean, String],
  expanded: Boolean,
  borderless: Boolean,
  transparent: Boolean,
  initialPage: Object,
  initialPagePosition: { type: Number, default: 1 },
  minPage: Object,
  maxPage: Object,
  transition: String,
  attributes: Array,
  trimWeeks: Boolean,
  disablePageSwipe: Boolean
}, LI = [
  "dayclick",
  "daymouseenter",
  "daymouseleave",
  "dayfocusin",
  "dayfocusout",
  "daykeydown",
  "weeknumberclick",
  "transition-start",
  "transition-end",
  "did-move",
  "update:view",
  "update:pages"
], zm = Symbol("__vc_calendar_context__");
function MI(e, { slots: t, emit: n }) {
  const r = je(null), a = je(null), l = je((/* @__PURE__ */ new Date()).getDate()), u = je(!1), h = je(Symbol()), f = je(Symbol()), m = je(e.view), v = je([]), y = je("");
  let k = null, x = null;
  $m(t);
  const {
    theme: M,
    color: O,
    displayMode: R,
    locale: C,
    masks: T,
    minDate: A,
    maxDate: P,
    disabledAttribute: D,
    disabledDates: $
  } = kI(e), Y = te(() => e.rows * e.columns), G = te(() => e.step || Y.value), ee = te(() => sm(v.value) ?? null), X = te(() => oa(v.value) ?? null), ae = te(
    () => e.minPage || (A.value ? Pe(A.value) : null)
  ), ne = te(
    () => e.maxPage || (P.value ? Pe(P.value) : null)
  ), se = te(() => e.navVisibility), re = te(() => !!e.showWeeknumbers), Q = te(() => !!e.showIsoWeeknumbers), ke = te(() => m.value === "monthly"), Ae = te(() => m.value === "weekly"), pe = te(() => m.value === "daily"), Ye = () => {
    u.value = !0, n("transition-start");
  }, ue = () => {
    u.value = !1, n("transition-end"), k && (k.resolve(!0), k = null);
  }, Fe = (be, j, ge = m.value) => pm(be, j, ge, C.value), Pe = (be) => fm(be, m.value, C.value), nt = (be) => {
    !D.value || !Wt.value || (be.isDisabled = Wt.value.cellExists(
      D.value.key,
      be.dayIndex
    ));
  }, Ve = (be) => {
    be.isFocusable = be.inMonth && be.day === l.value;
  }, Ze = (be, j) => {
    for (const ge of be)
      for (const De of ge.days)
        if (j(De) === !1)
          return;
  }, Ne = te(
    () => v.value.reduce((be, j) => (be.push(...j.viewDays), be), [])
  ), ft = te(() => {
    const be = [];
    return (e.attributes || []).forEach((j, ge) => {
      !j || !j.dates || be.push(
        new Cm(
          {
            ...j,
            order: j.order || 0
          },
          M.value,
          C.value
        )
      );
    }), D.value && be.push(D.value), be;
  }), pt = te(() => Si(ft.value)), Wt = te(() => {
    const be = new o2();
    return ft.value.forEach((j) => {
      j.ranges.forEach((ge) => {
        be.render(j, ge, Ne.value);
      });
    }), be;
  }), an = te(() => Ne.value.reduce((be, j) => (be[j.dayIndex] = { day: j, cells: [] }, be[j.dayIndex].cells.push(...Wt.value.getCells(j)), be), {})), on = (be, j) => {
    const ge = e.showWeeknumbers || e.showIsoWeeknumbers;
    return ge == null ? "" : EO(ge) ? ge ? "left" : "" : ge.startsWith("right") ? j > 1 ? "right" : ge : be > 1 ? "left" : ge;
  }, Dt = () => {
    var be, j;
    if (!pt.value)
      return null;
    const ge = ft.value.find((U) => U.pinPage) || ft.value[0];
    if (!ge || !ge.hasRanges)
      return null;
    const [De] = ge.ranges, N = ((be = De.start) == null ? void 0 : be.date) || ((j = De.end) == null ? void 0 : j.date);
    return N ? Pe(N) : null;
  }, Zt = () => {
    if (fi(ee.value))
      return ee.value;
    const be = Dt();
    return fi(be) ? be : Pe(/* @__PURE__ */ new Date());
  }, It = (be, j = {}) => {
    const { view: ge = m.value, position: De = 1, force: N } = j, U = De > 0 ? 1 - De : -(Y.value + De);
    let ie = Fe(be, U, ge), ve = Fe(ie, Y.value - 1, ge);
    return N || (ru(ie, ae.value) ? ie = ae.value : Ns(ve, ne.value) && (ie = Fe(ne.value, 1 - Y.value)), ve = Fe(ie, Y.value - 1)), { fromPage: ie, toPage: ve };
  }, bn = (be, j, ge = "") => {
    if (ge === "none" || ge === "fade")
      return ge;
    if ((be == null ? void 0 : be.view) !== (j == null ? void 0 : j.view))
      return "fade";
    const De = Ns(j, be), N = ru(j, be);
    return !De && !N ? "fade" : ge === "slide-v" ? N ? "slide-down" : "slide-up" : N ? "slide-right" : "slide-left";
  }, qt = (be = {}) => new Promise((j, ge) => {
    const { position: De = 1, force: N = !1, transition: U } = be, ie = fi(be.page) ? be.page : Zt(), { fromPage: ve } = It(ie, {
      position: De,
      force: N
    }), Ee = [];
    for (let Ce = 0; Ce < Y.value; Ce++) {
      const He = Fe(ve, Ce), Re = Ce + 1, mt = Math.ceil(Re / e.columns), ht = e.rows - mt + 1, wt = Re % e.columns || e.columns, ct = e.columns - wt + 1, ut = on(wt, ct);
      Ee.push(
        C.value.getPage({
          ...He,
          view: m.value,
          titlePosition: e.titlePosition,
          trimWeeks: e.trimWeeks,
          position: Re,
          row: mt,
          rowFromEnd: ht,
          column: wt,
          columnFromEnd: ct,
          showWeeknumbers: re.value,
          showIsoWeeknumbers: Q.value,
          weeknumberPosition: ut
        })
      );
    }
    y.value = bn(
      v.value[0],
      Ee[0],
      U
    ), v.value = Ee, y.value && y.value !== "none" ? k = {
      resolve: j,
      reject: ge
    } : j(!0);
  }), cn = (be) => {
    const j = ee.value ?? Pe(/* @__PURE__ */ new Date());
    return Fe(j, be);
  }, sn = (be, j = {}) => {
    const ge = fi(be) ? be : Pe(be);
    return Object.assign(
      j,
      It(ge, {
        ...j,
        force: !0
      })
    ), i2(
      j.fromPage,
      j.toPage,
      m.value,
      C.value
    ).map((N) => t2(N, ae.value, ne.value)).some((N) => N);
  }, H = (be, j = {}) => sn(cn(be), j), S = te(() => H(-G.value)), E = te(() => H(G.value)), z = async (be, j = {}) => !j.force && !sn(be, j) ? !1 : (j.fromPage && !n2(j.fromPage, ee.value) && (go({ id: h.value, hideDelay: 0 }), j.view && (cI("view", 10), m.value = j.view), await qt({
    ...j,
    page: j.fromPage,
    position: 1,
    force: !0
  }), n("did-move", v.value)), !0), q = (be, j = {}) => z(cn(be), j), J = () => q(-G.value), me = () => q(G.value), ye = (be) => {
    const j = ke.value ? ".in-month" : "", ge = `.id-${C.value.getDayId(be)}${j}`, De = `${ge}.vc-focusable, ${ge} .vc-focusable`, N = r.value;
    if (N) {
      const U = N.querySelector(De);
      if (U)
        return U.focus(), !0;
    }
    return !1;
  }, Oe = async (be, j = {}) => ye(be) ? !0 : (await z(be, j), ye(be)), Ue = (be, j) => {
    l.value = be.day, n("dayclick", be, j);
  }, at = (be, j) => {
    n("daymouseenter", be, j);
  }, Xe = (be, j) => {
    n("daymouseleave", be, j);
  }, We = (be, j) => {
    l.value = be.day, a.value = be, be.isFocused = !0, n("dayfocusin", be, j);
  }, xt = (be, j) => {
    a.value = null, be.isFocused = !1, n("dayfocusout", be, j);
  }, lt = (be, j) => {
    n("daykeydown", be, j);
    const ge = be.noonDate;
    let De = null;
    switch (j.key) {
      case "ArrowLeft": {
        De = Ln(ge, -1);
        break;
      }
      case "ArrowRight": {
        De = Ln(ge, 1);
        break;
      }
      case "ArrowUp": {
        De = Ln(ge, -7);
        break;
      }
      case "ArrowDown": {
        De = Ln(ge, 7);
        break;
      }
      case "Home": {
        De = Ln(ge, -be.weekdayPosition + 1);
        break;
      }
      case "End": {
        De = Ln(ge, be.weekdayPositionFromEnd);
        break;
      }
      case "PageUp": {
        j.altKey ? De = Cd(ge, -1) : De = $s(ge, -1);
        break;
      }
      case "PageDown": {
        j.altKey ? De = Cd(ge, 1) : De = $s(ge, 1);
        break;
      }
    }
    De && (j.preventDefault(), Oe(De).catch());
  }, bt = (be) => {
    const j = a.value;
    j != null && lt(j, be);
  }, At = (be, j) => {
    n("weeknumberclick", be, j);
  };
  qt({
    page: e.initialPage,
    position: e.initialPagePosition
  }), In(() => {
    !e.disablePageSwipe && r.value && (x = uI(
      r.value,
      ({ toLeft: be = !1, toRight: j = !1 }) => {
        be ? me() : j && J();
      },
      lr("touch")
    ));
  }), _o(() => {
    v.value = [], x && x();
  }), kt(
    () => C.value,
    () => {
      qt();
    }
  ), kt(
    () => Y.value,
    () => qt()
  ), kt(
    () => e.view,
    () => m.value = e.view
  ), kt(
    () => m.value,
    () => {
      hI("view", () => {
        qt();
      }), n("update:view", m.value);
    }
  ), kt(
    () => l.value,
    () => {
      Ze(v.value, (be) => Ve(be));
    }
  ), ti(() => {
    n("update:pages", v.value), Ze(v.value, (be) => {
      nt(be), Ve(be);
    });
  });
  const Rt = {
    emit: n,
    containerRef: r,
    focusedDay: a,
    inTransition: u,
    navPopoverId: h,
    dayPopoverId: f,
    view: m,
    pages: v,
    transitionName: y,
    theme: M,
    color: O,
    displayMode: R,
    locale: C,
    masks: T,
    attributes: ft,
    disabledAttribute: D,
    disabledDates: $,
    attributeContext: Wt,
    days: Ne,
    dayCells: an,
    count: Y,
    step: G,
    firstPage: ee,
    lastPage: X,
    canMovePrev: S,
    canMoveNext: E,
    minPage: ae,
    maxPage: ne,
    isMonthly: ke,
    isWeekly: Ae,
    isDaily: pe,
    navVisibility: se,
    showWeeknumbers: re,
    showIsoWeeknumbers: Q,
    getDateAddress: Pe,
    canMove: sn,
    canMoveBy: H,
    move: z,
    moveBy: q,
    movePrev: J,
    moveNext: me,
    onTransitionBeforeEnter: Ye,
    onTransitionAfterEnter: ue,
    tryFocusDate: ye,
    focusDate: Oe,
    onKeydown: bt,
    onDayKeydown: lt,
    onDayClick: Ue,
    onDayMouseenter: at,
    onDayMouseleave: Xe,
    onDayFocusin: We,
    onDayFocusout: xt,
    onWeeknumberClick: At
  };
  return Bi(zm, Rt), Rt;
}
function Nr() {
  const e = Ri(zm);
  if (e)
    return e;
  throw new Error(
    "Calendar context missing. Please verify this component is nested within a valid context provider."
  );
}
const SI = tt({
  inheritAttrs: !1,
  emits: ["before-show", "after-show", "before-hide", "after-hide"],
  props: {
    id: { type: [Number, String, Symbol], required: !0 },
    showDelay: { type: Number, default: 0 },
    hideDelay: { type: Number, default: 110 },
    boundarySelector: { type: String }
  },
  setup(e, { emit: t }) {
    let n;
    const r = je();
    let a = null, l = null;
    const u = Ir({
      isVisible: !1,
      target: null,
      data: null,
      transition: "slide-fade",
      placement: "bottom",
      direction: "",
      positionFixed: !1,
      modifiers: [],
      isInteractive: !0,
      visibility: "click",
      isHovered: !1,
      isFocused: !1,
      autoHide: !1,
      force: !1
    });
    function h(ue) {
      ue && (u.direction = ue.split("-")[0]);
    }
    function f({ placement: ue, options: Fe }) {
      h(ue || (Fe == null ? void 0 : Fe.placement));
    }
    const m = te(() => ({
      placement: u.placement,
      strategy: u.positionFixed ? "fixed" : "absolute",
      boundary: "",
      modifiers: [
        {
          name: "onUpdate",
          enabled: !0,
          phase: "afterWrite",
          fn: f
        },
        ...u.modifiers || []
      ],
      onFirstUpdate: f
    })), v = te(() => {
      const ue = u.direction === "left" || u.direction === "right";
      let Fe = "";
      if (u.placement) {
        const Pe = u.placement.split("-");
        Pe.length > 1 && (Fe = Pe[1]);
      }
      return ["start", "top", "left"].includes(Fe) ? ue ? "top" : "left" : ["end", "bottom", "right"].includes(Fe) ? ue ? "bottom" : "right" : ue ? "middle" : "center";
    });
    function y() {
      l && (l.destroy(), l = null);
    }
    function k() {
      nn(() => {
        const ue = Is(u.target);
        !ue || !r.value || (l && l.state.elements.reference !== ue && y(), l ? l.update() : l = yw(
          ue,
          r.value,
          m.value
        ));
      });
    }
    function x(ue) {
      Object.assign(u, um(ue, "force"));
    }
    function M(ue, Fe) {
      clearTimeout(n), ue > 0 ? n = setTimeout(Fe, ue) : Fe();
    }
    function O(ue) {
      return !ue || !l ? !1 : Is(ue) === l.state.elements.reference;
    }
    async function R(ue = {}) {
      u.force || (ue.force && (u.force = !0), M(ue.showDelay ?? e.showDelay, () => {
        u.isVisible && (u.force = !1), x({
          ...ue,
          isVisible: !0
        }), k();
      }));
    }
    function C(ue = {}) {
      l && (ue.target && !O(ue.target) || u.force || (ue.force && (u.force = !0), M(ue.hideDelay ?? e.hideDelay, () => {
        u.isVisible || (u.force = !1), u.isVisible = !1;
      })));
    }
    function T(ue = {}) {
      ue.target != null && (u.isVisible && O(ue.target) ? C(ue) : R(ue));
    }
    function A(ue) {
      if (!l)
        return;
      const Fe = l.state.elements.reference;
      if (!r.value || !Fe)
        return;
      const Pe = ue.target;
      ps(r.value, Pe) || ps(Fe, Pe) || C({ force: !0 });
    }
    function P(ue) {
      (ue.key === "Esc" || ue.key === "Escape") && C();
    }
    function D({ detail: ue }) {
      !ue.id || ue.id !== e.id || R(ue);
    }
    function $({ detail: ue }) {
      !ue.id || ue.id !== e.id || C(ue);
    }
    function Y({ detail: ue }) {
      !ue.id || ue.id !== e.id || T(ue);
    }
    function G() {
      rr(document, "keydown", P), rr(document, "click", A), rr(document, "show-popover", D), rr(document, "hide-popover", $), rr(document, "toggle-popover", Y);
    }
    function ee() {
      ir(document, "keydown", P), ir(document, "click", A), ir(document, "show-popover", D), ir(document, "hide-popover", $), ir(document, "toggle-popover", Y);
    }
    function X(ue) {
      t("before-show", ue);
    }
    function ae(ue) {
      u.force = !1, t("after-show", ue);
    }
    function ne(ue) {
      t("before-hide", ue);
    }
    function se(ue) {
      u.force = !1, y(), t("after-hide", ue);
    }
    function re(ue) {
      ue.stopPropagation();
    }
    function Q() {
      u.isHovered = !0, u.isInteractive && ["hover", "hover-focus"].includes(u.visibility) && R();
    }
    function ke() {
      if (u.isHovered = !1, !l)
        return;
      const ue = l.state.elements.reference;
      u.autoHide && !u.isFocused && (!ue || ue !== document.activeElement) && ["hover", "hover-focus"].includes(u.visibility) && C();
    }
    function Ae() {
      u.isFocused = !0, u.isInteractive && ["focus", "hover-focus"].includes(u.visibility) && R();
    }
    function pe(ue) {
      ["focus", "hover-focus"].includes(u.visibility) && (!ue.relatedTarget || !ps(r.value, ue.relatedTarget)) && (u.isFocused = !1, !u.isHovered && u.autoHide && C());
    }
    function Ye() {
      a != null && (a.disconnect(), a = null);
    }
    return kt(
      () => r.value,
      (ue) => {
        Ye(), ue && (a = new ResizeObserver(() => {
          l && l.update();
        }), a.observe(ue));
      }
    ), kt(() => u.placement, h, {
      immediate: !0
    }), In(() => {
      G();
    }), _o(() => {
      y(), Ye(), ee();
    }), {
      ...Av(u),
      popoverRef: r,
      alignment: v,
      hide: C,
      setupPopper: k,
      beforeEnter: X,
      afterEnter: ae,
      beforeLeave: ne,
      afterLeave: se,
      onClick: re,
      onMouseOver: Q,
      onMouseLeave: ke,
      onFocusIn: Ae,
      onFocusOut: pe
    };
  }
}), hr = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [r, a] of t)
    n[r] = a;
  return n;
};
function PI(e, t, n, r, a, l) {
  return we(), Te("div", {
    class: gt(["vc-popover-content-wrapper", { "is-interactive": e.isInteractive }]),
    ref: "popoverRef",
    onClick: t[0] || (t[0] = (...u) => e.onClick && e.onClick(...u)),
    onMouseover: t[1] || (t[1] = (...u) => e.onMouseOver && e.onMouseOver(...u)),
    onMouseleave: t[2] || (t[2] = (...u) => e.onMouseLeave && e.onMouseLeave(...u)),
    onFocusin: t[3] || (t[3] = (...u) => e.onFocusIn && e.onFocusIn(...u)),
    onFocusout: t[4] || (t[4] = (...u) => e.onFocusOut && e.onFocusOut(...u))
  }, [
    ce(oo, {
      name: `vc-${e.transition}`,
      appear: "",
      onBeforeEnter: e.beforeEnter,
      onAfterEnter: e.afterEnter,
      onBeforeLeave: e.beforeLeave,
      onAfterLeave: e.afterLeave
    }, {
      default: Je(() => [
        e.isVisible ? (we(), Te("div", Qt({
          key: 0,
          tabindex: "-1",
          class: `vc-popover-content direction-${e.direction}`
        }, e.$attrs), [
          Xt(e.$slots, "default", {
            direction: e.direction,
            alignment: e.alignment,
            data: e.data,
            hide: e.hide
          }, () => [
            Se(_t(e.data), 1)
          ]),
          xe("span", {
            class: gt([
              "vc-popover-caret",
              `direction-${e.direction}`,
              `align-${e.alignment}`
            ])
          }, null, 2)
        ], 16)) : vt("", !0)
      ]),
      _: 3
    }, 8, ["name", "onBeforeEnter", "onAfterEnter", "onBeforeLeave", "onAfterLeave"])
  ], 34);
}
const tc = /* @__PURE__ */ hr(SI, [["render", PI]]), CI = { class: "vc-day-popover-row" }, OI = {
  key: 0,
  class: "vc-day-popover-row-indicator"
}, EI = { class: "vc-day-popover-row-label" }, TI = /* @__PURE__ */ tt({
  __name: "PopoverRow",
  props: {
    attribute: null
  },
  setup(e) {
    const t = e, n = te(() => {
      const { content: r, highlight: a, dot: l, bar: u, popover: h } = t.attribute;
      return h && h.hideIndicator ? null : r ? {
        class: `vc-bar vc-day-popover-row-bar vc-attr vc-${r.base.color}`
      } : a ? {
        class: `vc-highlight-bg-solid vc-day-popover-row-highlight vc-attr vc-${a.base.color}`
      } : l ? {
        class: `vc-dot vc-attr vc-${l.base.color}`
      } : u ? {
        class: `vc-bar vc-day-popover-row-bar vc-attr vc-${u.base.color}`
      } : null;
    });
    return (r, a) => (we(), Te("div", CI, [
      he(n) ? (we(), Te("div", OI, [
        xe("span", {
          class: gt(he(n).class)
        }, null, 2)
      ])) : vt("", !0),
      xe("div", EI, [
        Xt(r.$slots, "default", {}, () => [
          Se(_t(e.attribute.popover ? e.attribute.popover.label : "No content provided"), 1)
        ])
      ])
    ]));
  }
}), DI = {
  inheritAttrs: !1
}, $n = /* @__PURE__ */ tt({
  ...DI,
  __name: "CalendarSlot",
  props: {
    name: null
  },
  setup(e) {
    const n = Nm(e.name);
    return (r, a) => he(n) ? (we(), Ut(ao(he(n)), ua(Qt({ key: 0 }, r.$attrs)), null, 16)) : Xt(r.$slots, "default", { key: 1 });
  }
}), II = { class: "vc-day-popover-container" }, AI = {
  key: 0,
  class: "vc-day-popover-header"
}, RI = /* @__PURE__ */ tt({
  __name: "CalendarDayPopover",
  setup(e) {
    const { dayPopoverId: t, displayMode: n, color: r, masks: a, locale: l } = Nr();
    function u(f, m) {
      return l.value.formatDate(f, m);
    }
    function h(f) {
      return l.value.formatDate(f.date, a.value.dayPopover);
    }
    return (f, m) => (we(), Ut(tc, {
      id: he(t),
      class: gt([`vc-${he(r)}`, `vc-${he(n)}`])
    }, {
      default: Je(({ data: { day: v, attributes: y }, hide: k }) => [
        ce($n, {
          name: "day-popover",
          day: v,
          "day-title": h(v),
          attributes: y,
          format: u,
          masks: he(a),
          hide: k
        }, {
          default: Je(() => [
            xe("div", II, [
              he(a).dayPopover ? (we(), Te("div", AI, _t(h(v)), 1)) : vt("", !0),
              (we(!0), Te(Et, null, rn(y, (x) => (we(), Ut(TI, {
                key: x.key,
                attribute: x
              }, null, 8, ["attribute"]))), 128))
            ])
          ]),
          _: 2
        }, 1032, ["day", "day-title", "attributes", "masks", "hide"])
      ]),
      _: 1
    }, 8, ["id", "class"]));
  }
}), BI = {}, $I = {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  viewBox: "0 0 24 24"
}, NI = /* @__PURE__ */ xe("polyline", { points: "9 18 15 12 9 6" }, null, -1), zI = [
  NI
];
function FI(e, t) {
  return we(), Te("svg", $I, zI);
}
const jI = /* @__PURE__ */ hr(BI, [["render", FI]]), VI = {}, YI = {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  viewBox: "0 0 24 24"
}, HI = /* @__PURE__ */ xe("polyline", { points: "15 18 9 12 15 6" }, null, -1), UI = [
  HI
];
function ZI(e, t) {
  return we(), Te("svg", YI, UI);
}
const WI = /* @__PURE__ */ hr(VI, [["render", ZI]]), GI = {}, qI = {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  viewBox: "0 0 24 24"
}, KI = /* @__PURE__ */ xe("polyline", { points: "6 9 12 15 18 9" }, null, -1), JI = [
  KI
];
function XI(e, t) {
  return we(), Te("svg", qI, JI);
}
const QI = /* @__PURE__ */ hr(GI, [["render", XI]]), eA = {}, tA = {
  fill: "none",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24"
}, nA = /* @__PURE__ */ xe("path", { d: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" }, null, -1), iA = [
  nA
];
function rA(e, t) {
  return we(), Te("svg", tA, iA);
}
const aA = /* @__PURE__ */ hr(eA, [["render", rA]]), oA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  IconChevronDown: QI,
  IconChevronLeft: WI,
  IconChevronRight: jI,
  IconClock: aA
}, Symbol.toStringTag, { value: "Module" })), va = /* @__PURE__ */ tt({
  __name: "BaseIcon",
  props: {
    name: { type: String, required: !0 },
    width: { type: String },
    height: { type: String },
    size: { type: String, default: "26" },
    viewBox: { type: String }
  },
  setup(e) {
    const t = e, n = te(() => t.width || t.size), r = te(() => t.height || t.size), a = te(() => oA[`Icon${t.name}`]);
    return (l, u) => (we(), Ut(ao(he(a)), {
      width: he(n),
      height: he(r),
      class: "vc-base-icon"
    }, null, 8, ["width", "height"]));
  }
}), sA = ["disabled"], lA = {
  key: 1,
  class: "vc-title-wrapper"
}, uA = {
  type: "button",
  class: "vc-title"
}, cA = ["disabled"], Fm = /* @__PURE__ */ tt({
  __name: "CalendarHeader",
  props: {
    page: null,
    layout: null,
    isLg: { type: Boolean },
    isXl: { type: Boolean },
    is2xl: { type: Boolean },
    hideTitle: { type: Boolean },
    hideArrows: { type: Boolean }
  },
  setup(e) {
    const t = e, {
      navPopoverId: n,
      navVisibility: r,
      canMovePrev: a,
      movePrev: l,
      canMoveNext: u,
      moveNext: h
    } = Nr(), f = te(() => {
      switch (t.page.titlePosition) {
        case "left":
          return "bottom-start";
        case "right":
          return "bottom-end";
        default:
          return "bottom";
      }
    }), m = te(() => {
      const { page: O } = t;
      return {
        id: n.value,
        visibility: r.value,
        placement: f.value,
        modifiers: [{ name: "flip", options: { fallbackPlacements: ["bottom"] } }],
        data: { page: O },
        isInteractive: !0
      };
    }), v = te(() => t.page.titlePosition.includes("left")), y = te(() => t.page.titlePosition.includes("right")), k = te(() => t.layout ? t.layout : v.value ? "tu-pn" : y.value ? "pn-tu" : "p-tu-n;"), x = te(() => ({
      prev: k.value.includes("p") && !t.hideArrows,
      title: k.value.includes("t") && !t.hideTitle,
      next: k.value.includes("n") && !t.hideArrows
    })), M = te(() => ({ gridTemplateColumns: k.value.split("").map((R) => {
      switch (R) {
        case "p":
          return "[prev] auto";
        case "n":
          return "[next] auto";
        case "t":
          return "[title] auto";
        case "-":
          return "1fr";
        default:
          return "";
      }
    }).join(" ") }));
    return (O, R) => (we(), Te("div", {
      class: gt(["vc-header", { "is-lg": e.isLg, "is-xl": e.isXl, "is-2xl": e.is2xl }]),
      style: la(he(M))
    }, [
      he(x).prev ? (we(), Te("button", {
        key: 0,
        type: "button",
        class: "vc-arrow vc-prev vc-focus",
        disabled: !he(a),
        onClick: R[0] || (R[0] = //@ts-ignore
        (...C) => he(l) && he(l)(...C)),
        onKeydown: R[1] || (R[1] = xs(
          //@ts-ignore
          (...C) => he(l) && he(l)(...C),
          ["space", "enter"]
        ))
      }, [
        ce($n, {
          name: "header-prev-button",
          disabled: !he(a)
        }, {
          default: Je(() => [
            ce(va, {
              name: "ChevronLeft",
              size: "24"
            })
          ]),
          _: 1
        }, 8, ["disabled"])
      ], 40, sA)) : vt("", !0),
      he(x).title ? (we(), Te("div", lA, [
        ce($n, { name: "header-title-wrapper" }, {
          default: Je(() => [
            Pi((we(), Te("button", uA, [
              ce($n, {
                name: "header-title",
                title: e.page.title
              }, {
                default: Je(() => [
                  xe("span", null, _t(e.page.title), 1)
                ]),
                _: 1
              }, 8, ["title"])
            ])), [
              [he(Tm), he(m)]
            ])
          ]),
          _: 1
        })
      ])) : vt("", !0),
      he(x).next ? (we(), Te("button", {
        key: 2,
        type: "button",
        class: "vc-arrow vc-next vc-focus",
        disabled: !he(u),
        onClick: R[2] || (R[2] = //@ts-ignore
        (...C) => he(h) && he(h)(...C)),
        onKeydown: R[3] || (R[3] = xs(
          //@ts-ignore
          (...C) => he(h) && he(h)(...C),
          ["space", "enter"]
        ))
      }, [
        ce($n, {
          name: "header-next-button",
          disabled: !he(u)
        }, {
          default: Je(() => [
            ce(va, {
              name: "ChevronRight",
              size: "24"
            })
          ]),
          _: 1
        }, 8, ["disabled"])
      ], 40, cA)) : vt("", !0)
    ], 6));
  }
}), jm = Symbol("__vc_page_context__");
function hA(e) {
  const { locale: t, getDateAddress: n, canMove: r } = Nr();
  function a(h, f) {
    const { month: m, year: v } = n(/* @__PURE__ */ new Date());
    return Pm().map((y, k) => {
      const x = k + 1;
      return {
        month: x,
        year: h,
        id: e2(x, h),
        label: t.value.formatDate(y, f),
        ariaLabel: t.value.formatDate(y, "MMMM"),
        isActive: x === e.value.month && h === e.value.year,
        isCurrent: x === m && h === v,
        isDisabled: !r(
          { month: x, year: h },
          { position: e.value.position }
        )
      };
    });
  }
  function l(h, f) {
    const { year: m } = n(/* @__PURE__ */ new Date()), { position: v } = e.value, y = [];
    for (let k = h; k <= f; k += 1) {
      const x = [...Array(12).keys()].some(
        (M) => r({ month: M + 1, year: k }, { position: v })
      );
      y.push({
        year: k,
        id: k.toString(),
        label: k.toString(),
        ariaLabel: k.toString(),
        isActive: k === e.value.year,
        isCurrent: k === m,
        isDisabled: !x
      });
    }
    return y;
  }
  const u = { page: e, getMonthItems: a, getYearItems: l };
  return Bi(jm, u), u;
}
function Vm() {
  const e = Ri(jm);
  if (e)
    return e;
  throw new Error(
    "Page context missing. Please verify this component is nested within a valid context provider."
  );
}
const dA = { class: "vc-nav-header" }, fA = ["disabled"], pA = ["disabled"], mA = { class: "vc-nav-items" }, gA = ["data-id", "aria-label", "disabled", "onClick", "onKeydown"], vA = /* @__PURE__ */ tt({
  __name: "CalendarNav",
  setup(e) {
    const { masks: t, move: n } = Nr(), { page: r, getMonthItems: a, getYearItems: l } = Vm(), u = je(!0), h = 12, f = je(r.value.year), m = je(k(r.value.year)), v = je(null);
    function y() {
      setTimeout(() => {
        if (v.value == null)
          return;
        const Pe = v.value.querySelector(
          ".vc-nav-item:not(:disabled)"
        );
        Pe && Pe.focus();
      }, 10);
    }
    function k(Pe) {
      return Math.floor(Pe / h);
    }
    function x() {
      u.value = !u.value;
    }
    function M(Pe) {
      return Pe * h;
    }
    function O(Pe) {
      return h * (Pe + 1) - 1;
    }
    function R() {
      Ae.value && (u.value && T(), P());
    }
    function C() {
      pe.value && (u.value && A(), D());
    }
    function T() {
      f.value--;
    }
    function A() {
      f.value++;
    }
    function P() {
      m.value--;
    }
    function D() {
      m.value++;
    }
    const $ = te(
      () => a(f.value, t.value.navMonths).map((Pe) => ({
        ...Pe,
        click: () => n(
          { month: Pe.month, year: Pe.year },
          { position: r.value.position }
        )
      }))
    ), Y = te(
      () => a(f.value - 1, t.value.navMonths)
    ), G = te(
      () => Y.value.some((Pe) => !Pe.isDisabled)
    ), ee = te(
      () => a(f.value + 1, t.value.navMonths)
    ), X = te(
      () => ee.value.some((Pe) => !Pe.isDisabled)
    ), ae = te(
      () => l(
        M(m.value),
        O(m.value)
      ).map((Pe) => ({
        ...Pe,
        click: () => {
          f.value = Pe.year, u.value = !0, y();
        }
      }))
    ), ne = te(
      () => l(
        M(m.value - 1),
        O(m.value - 1)
      )
    ), se = te(
      () => ne.value.some((Pe) => !Pe.isDisabled)
    ), re = te(
      () => l(
        M(m.value + 1),
        O(m.value + 1)
      )
    ), Q = te(
      () => re.value.some((Pe) => !Pe.isDisabled)
    ), ke = te(
      () => u.value ? $.value : ae.value
    ), Ae = te(
      () => u.value ? G.value : se.value
    ), pe = te(
      () => u.value ? X.value : Q.value
    ), Ye = te(() => sm(ae.value.map((Pe) => Pe.year))), ue = te(() => oa(ae.value.map((Pe) => Pe.year))), Fe = te(() => u.value ? f.value : `${Ye.value} - ${ue.value}`);
    return ti(() => {
      f.value = r.value.year, y();
    }), kt(
      () => f.value,
      (Pe) => m.value = k(Pe)
    ), In(() => y()), (Pe, nt) => (we(), Te("div", {
      class: "vc-nav-container",
      ref_key: "navContainer",
      ref: v
    }, [
      xe("div", dA, [
        xe("button", {
          type: "button",
          class: "vc-nav-arrow is-left vc-focus",
          disabled: !he(Ae),
          onClick: R,
          onKeydown: nt[0] || (nt[0] = (Ve) => he(ts)(Ve, R))
        }, [
          ce($n, {
            name: "nav-prev-button",
            move: R,
            disabled: !he(Ae)
          }, {
            default: Je(() => [
              ce(va, {
                name: "ChevronLeft",
                width: "22px",
                height: "24px"
              })
            ]),
            _: 1
          }, 8, ["disabled"])
        ], 40, fA),
        xe("button", {
          type: "button",
          class: "vc-nav-title vc-focus",
          onClick: x,
          onKeydown: nt[1] || (nt[1] = (Ve) => he(ts)(Ve, x))
        }, _t(he(Fe)), 33),
        xe("button", {
          type: "button",
          class: "vc-nav-arrow is-right vc-focus",
          disabled: !he(pe),
          onClick: C,
          onKeydown: nt[2] || (nt[2] = (Ve) => he(ts)(Ve, C))
        }, [
          ce($n, {
            name: "nav-next-button",
            move: C,
            disabled: !he(pe)
          }, {
            default: Je(() => [
              ce(va, {
                name: "ChevronRight",
                width: "22px",
                height: "24px"
              })
            ]),
            _: 1
          }, 8, ["disabled"])
        ], 40, pA)
      ]),
      xe("div", mA, [
        (we(!0), Te(Et, null, rn(he(ke), (Ve) => (we(), Te("button", {
          key: Ve.label,
          type: "button",
          "data-id": Ve.id,
          "aria-label": Ve.ariaLabel,
          class: gt(["vc-nav-item vc-focus", [
            Ve.isActive ? "is-active" : Ve.isCurrent ? "is-current" : ""
          ]]),
          disabled: Ve.isDisabled,
          onClick: Ve.click,
          onKeydown: (Ze) => he(ts)(Ze, Ve.click)
        }, _t(Ve.label), 43, gA))), 128))
      ])
    ], 512));
  }
}), Ym = /* @__PURE__ */ tt({
  __name: "CalendarPageProvider",
  props: {
    page: null
  },
  setup(e) {
    return hA(us(e, "page")), (n, r) => Xt(n.$slots, "default");
  }
}), _A = /* @__PURE__ */ tt({
  __name: "CalendarNavPopover",
  setup(e) {
    const { navPopoverId: t, color: n, displayMode: r } = Nr();
    return (a, l) => (we(), Ut(tc, {
      id: he(t),
      class: gt(["vc-nav-popover-container", `vc-${he(n)}`, `vc-${he(r)}`])
    }, {
      default: Je(({ data: u }) => [
        ce(Ym, {
          page: u.page
        }, {
          default: Je(() => [
            ce($n, { name: "nav" }, {
              default: Je(() => [
                ce(vA)
              ]),
              _: 1
            })
          ]),
          _: 2
        }, 1032, ["page"])
      ]),
      _: 1
    }, 8, ["id", "class"]));
  }
}), yA = tt({
  directives: { popover: Tm },
  components: { CalendarSlot: $n },
  props: {
    day: { type: Object, required: !0 }
  },
  setup(e) {
    const {
      locale: t,
      theme: n,
      attributeContext: r,
      dayPopoverId: a,
      onDayClick: l,
      onDayMouseenter: u,
      onDayMouseleave: h,
      onDayFocusin: f,
      onDayFocusout: m,
      onDayKeydown: v
    } = Nr(), y = te(() => e.day), k = te(() => r.value.getCells(y.value)), x = te(
      () => k.value.map((Q) => Q.data)
    ), M = te(() => ({
      ...y.value,
      attributes: x.value,
      attributeCells: k.value
    }));
    function O({ data: Q }, { popovers: ke }) {
      const { key: Ae, customData: pe, popover: Ye } = Q;
      if (!Ye)
        return;
      const ue = cd(
        {
          key: Ae,
          customData: pe,
          attribute: Q
        },
        { ...Ye },
        {
          visibility: Ye.label ? "hover" : "click",
          placement: "bottom",
          isInteractive: !Ye.label
        }
      );
      ke.splice(0, 0, ue);
    }
    const R = te(() => {
      const Q = {
        ...n.value.prepareRender({}),
        popovers: []
      };
      return k.value.forEach((ke) => {
        n.value.render(ke, Q), O(ke, Q);
      }), Q;
    }), C = te(() => R.value.highlights), T = te(() => !!Si(C.value)), A = te(() => R.value.content), P = te(() => R.value.dots), D = te(() => !!Si(P.value)), $ = te(() => R.value.bars), Y = te(() => !!Si($.value)), G = te(() => R.value.popovers), ee = te(
      () => G.value.map((Q) => Q.attribute)
    ), X = Nm("day-content"), ae = te(() => [
      "vc-day",
      ...y.value.classes,
      { "vc-day-box-center-center": !X },
      { "is-not-in-month": !e.day.inMonth }
    ]), ne = te(() => {
      let Q;
      y.value.isFocusable ? Q = "0" : Q = "-1";
      const ke = [
        "vc-day-content vc-focusable vc-focus vc-attr",
        { "vc-disabled": y.value.isDisabled },
        Lr(oa(C.value), "contentClass"),
        Lr(oa(A.value), "class") || ""
      ], Ae = {
        ...Lr(oa(C.value), "contentStyle"),
        ...Lr(oa(A.value), "style")
      };
      return {
        class: ke,
        style: Ae,
        tabindex: Q,
        "aria-label": y.value.ariaLabel,
        "aria-disabled": !!y.value.isDisabled,
        role: "button"
      };
    }), se = te(() => ({
      click(Q) {
        l(M.value, Q);
      },
      mouseenter(Q) {
        u(M.value, Q);
      },
      mouseleave(Q) {
        h(M.value, Q);
      },
      focusin(Q) {
        f(M.value, Q);
      },
      focusout(Q) {
        m(M.value, Q);
      },
      keydown(Q) {
        v(M.value, Q);
      }
    })), re = te(() => Si(G.value) ? cd(
      {
        id: a.value,
        data: { day: y, attributes: ee.value }
      },
      ...G.value
    ) : null);
    return {
      attributes: x,
      attributeCells: k,
      bars: $,
      dayClasses: ae,
      dayContentProps: ne,
      dayContentEvents: se,
      dayPopover: re,
      glyphs: R,
      dots: P,
      hasDots: D,
      hasBars: Y,
      highlights: C,
      hasHighlights: T,
      locale: t,
      popovers: G
    };
  }
}), bA = {
  key: 0,
  class: "vc-highlights vc-day-layer"
}, wA = {
  key: 1,
  class: "vc-day-layer vc-day-box-center-bottom"
}, kA = { class: "vc-dots" }, xA = {
  key: 2,
  class: "vc-day-layer vc-day-box-center-bottom"
}, LA = { class: "vc-bars" };
function MA(e, t, n, r, a, l) {
  const u = Mi("CalendarSlot"), h = Rv("popover");
  return we(), Te("div", {
    class: gt(e.dayClasses)
  }, [
    e.hasHighlights ? (we(), Te("div", bA, [
      (we(!0), Te(Et, null, rn(e.highlights, ({ key: f, wrapperClass: m, class: v, style: y }) => (we(), Te("div", {
        key: f,
        class: gt(m)
      }, [
        xe("div", {
          class: gt(v),
          style: la(y)
        }, null, 6)
      ], 2))), 128))
    ])) : vt("", !0),
    ce(u, {
      name: "day-content",
      day: e.day,
      attributes: e.attributes,
      "attribute-cells": e.attributeCells,
      dayProps: e.dayContentProps,
      dayEvents: e.dayContentEvents,
      locale: e.locale
    }, {
      default: Je(() => [
        Pi((we(), Te("div", Qt(e.dayContentProps, Bv(e.dayContentEvents, !0)), [
          Se(_t(e.day.label), 1)
        ], 16)), [
          [h, e.dayPopover]
        ])
      ]),
      _: 1
    }, 8, ["day", "attributes", "attribute-cells", "dayProps", "dayEvents", "locale"]),
    e.hasDots ? (we(), Te("div", wA, [
      xe("div", kA, [
        (we(!0), Te(Et, null, rn(e.dots, ({ key: f, class: m, style: v }) => (we(), Te("span", {
          key: f,
          class: gt(m),
          style: la(v)
        }, null, 6))), 128))
      ])
    ])) : vt("", !0),
    e.hasBars ? (we(), Te("div", xA, [
      xe("div", LA, [
        (we(!0), Te(Et, null, rn(e.bars, ({ key: f, class: m, style: v }) => (we(), Te("span", {
          key: f,
          class: gt(m),
          style: la(v)
        }, null, 6))), 128))
      ])
    ])) : vt("", !0)
  ], 2);
}
const SA = /* @__PURE__ */ hr(yA, [["render", MA]]), PA = { class: "vc-weekdays" }, CA = ["onClick"], OA = {
  inheritAttrs: !1
}, EA = /* @__PURE__ */ tt({
  ...OA,
  __name: "CalendarPage",
  setup(e) {
    const { page: t } = Vm(), { onWeeknumberClick: n } = Nr();
    return (r, a) => (we(), Te("div", {
      class: gt([
        "vc-pane",
        `row-${he(t).row}`,
        `row-from-end-${he(t).rowFromEnd}`,
        `column-${he(t).column}`,
        `column-from-end-${he(t).columnFromEnd}`
      ]),
      ref: "pane"
    }, [
      ce(Fm, {
        page: he(t),
        "is-lg": "",
        "hide-arrows": ""
      }, null, 8, ["page"]),
      xe("div", {
        class: gt(["vc-weeks", {
          [`vc-show-weeknumbers-${he(t).weeknumberPosition}`]: he(t).weeknumberPosition
        }])
      }, [
        xe("div", PA, [
          (we(!0), Te(Et, null, rn(he(t).weekdays, ({ weekday: l, label: u }, h) => (we(), Te("div", {
            key: h,
            class: gt(`vc-weekday vc-weekday-${l}`)
          }, _t(u), 3))), 128))
        ]),
        (we(!0), Te(Et, null, rn(he(t).viewWeeks, (l) => (we(), Te("div", {
          key: `weeknumber-${l.weeknumber}`,
          class: "vc-week"
        }, [
          he(t).weeknumberPosition ? (we(), Te("div", {
            key: 0,
            class: gt(["vc-weeknumber", `is-${he(t).weeknumberPosition}`])
          }, [
            xe("span", {
              class: gt(["vc-weeknumber-content"]),
              onClick: (u) => he(n)(l, u)
            }, _t(l.weeknumberDisplay), 9, CA)
          ], 2)) : vt("", !0),
          (we(!0), Te(Et, null, rn(l.days, (u) => (we(), Ut(SA, {
            key: u.id,
            day: u
          }, null, 8, ["day"]))), 128))
        ]))), 128))
      ], 2)
    ], 2));
  }
}), TA = tt({
  components: {
    CalendarHeader: Fm,
    CalendarPage: EA,
    CalendarNavPopover: _A,
    CalendarDayPopover: RI,
    CalendarPageProvider: Ym,
    CalendarSlot: $n
  },
  props: xI,
  emit: LI,
  setup(e, { emit: t, slots: n }) {
    return MI(e, { emit: t, slots: n });
  }
}), DA = { class: "vc-pane-header-wrapper" };
function IA(e, t, n, r, a, l) {
  const u = Mi("CalendarHeader"), h = Mi("CalendarPage"), f = Mi("CalendarSlot"), m = Mi("CalendarPageProvider"), v = Mi("CalendarDayPopover"), y = Mi("CalendarNavPopover");
  return we(), Te(Et, null, [
    xe("div", Qt({ "data-helptext": "Press the arrow keys to navigate by day, Home and End to navigate to week ends, PageUp and PageDown to navigate by month, Alt+PageUp and Alt+PageDown to navigate by year" }, e.$attrs, {
      class: [
        "vc-container",
        `vc-${e.view}`,
        `vc-${e.color}`,
        `vc-${e.displayMode}`,
        {
          "vc-expanded": e.expanded,
          "vc-bordered": !e.borderless,
          "vc-transparent": e.transparent
        }
      ],
      onMouseup: t[0] || (t[0] = ws(() => {
      }, ["prevent"])),
      ref: "containerRef"
    }), [
      xe("div", {
        class: gt(["vc-pane-container", { "in-transition": e.inTransition }])
      }, [
        xe("div", DA, [
          e.firstPage ? (we(), Ut(u, {
            key: 0,
            page: e.firstPage,
            "is-lg": "",
            "hide-title": ""
          }, null, 8, ["page"])) : vt("", !0)
        ]),
        ce(oo, {
          name: `vc-${e.transitionName}`,
          onBeforeEnter: e.onTransitionBeforeEnter,
          onAfterEnter: e.onTransitionAfterEnter
        }, {
          default: Je(() => [
            (we(), Te("div", {
              key: e.pages[0].id,
              class: "vc-pane-layout",
              style: la({
                gridTemplateColumns: `repeat(${e.columns}, 1fr)`
              })
            }, [
              (we(!0), Te(Et, null, rn(e.pages, (k) => (we(), Ut(m, {
                key: k.id,
                page: k
              }, {
                default: Je(() => [
                  ce(f, {
                    name: "page",
                    page: k
                  }, {
                    default: Je(() => [
                      ce(h)
                    ]),
                    _: 2
                  }, 1032, ["page"])
                ]),
                _: 2
              }, 1032, ["page"]))), 128))
            ], 4))
          ]),
          _: 1
        }, 8, ["name", "onBeforeEnter", "onAfterEnter"]),
        ce(f, { name: "footer" })
      ], 2)
    ], 16),
    ce(v),
    ce(y)
  ], 64);
}
const AA = /* @__PURE__ */ hr(TA, [["render", IA]]), Hm = Symbol("__vc_date_picker_context__"), RA = {
  ...Am,
  mode: { type: String, default: "date" },
  modelValue: {
    type: [Number, String, Date, Object]
  },
  modelModifiers: {
    type: Object,
    default: () => ({})
  },
  rules: [String, Object],
  is24hr: Boolean,
  hideTimeHeader: Boolean,
  timeAccuracy: { type: Number, default: 2 },
  isRequired: Boolean,
  isRange: Boolean,
  updateOnInput: {
    type: Boolean,
    default: () => lr("datePicker.updateOnInput")
  },
  inputDebounce: {
    type: Number,
    default: () => lr("datePicker.inputDebounce")
  },
  popover: {
    type: [Boolean, Object],
    default: !0
  },
  dragAttribute: Object,
  selectAttribute: Object,
  attributes: [Object, Array]
}, BA = [
  "update:modelValue",
  "drag",
  "dayclick",
  "daykeydown",
  "popover-will-show",
  "popover-did-show",
  "popover-will-hide",
  "popover-did-hide"
];
function $A(e, { emit: t, slots: n }) {
  $m(n, { footer: "dp-footer" });
  const r = Rm(e), { locale: a, masks: l, disabledAttribute: u } = r, h = je(!1), f = je(Symbol()), m = je(null), v = je(null), y = je(["", ""]), k = je(null), x = je(null);
  let M, O, R = !0;
  const C = te(() => e.isRange || e.modelModifiers.range === !0), T = te(
    () => C.value && m.value != null ? m.value.start : null
  ), A = te(
    () => C.value && m.value != null ? m.value.end : null
  ), P = te(() => e.mode.toLowerCase() === "date"), D = te(
    () => e.mode.toLowerCase() === "datetime"
  ), $ = te(() => e.mode.toLowerCase() === "time"), Y = te(() => !!v.value), G = te(() => {
    let j = "date";
    e.modelModifiers.number && (j = "number"), e.modelModifiers.string && (j = "string");
    const ge = l.value.modelValue || "iso";
    return nt({ type: j, mask: ge });
  }), ee = te(
    () => H(v.value ?? m.value)
  ), X = te(() => $.value ? e.is24hr ? l.value.inputTime24hr : l.value.inputTime : D.value ? e.is24hr ? l.value.inputDateTime24hr : l.value.inputDateTime : l.value.input), ae = te(() => /[Hh]/g.test(X.value)), ne = te(
    () => /[dD]{1,2}|Do|W{1,4}|M{1,4}|YY(?:YY)?/g.test(X.value)
  ), se = te(() => {
    if (ae.value && ne.value)
      return "dateTime";
    if (ne.value)
      return "date";
    if (ae.value)
      return "time";
  }), re = te(() => {
    var j;
    const ge = ((j = k.value) == null ? void 0 : j.$el.previousElementSibling) ?? void 0;
    return mo({}, e.popover, lr("datePicker.popover"), {
      target: ge
    });
  }), Q = te(
    () => Em({
      ...re.value,
      id: f.value
    })
  ), ke = te(() => C.value ? {
    start: y.value[0],
    end: y.value[1]
  } : y.value[0]), Ae = te(() => {
    const j = ["start", "end"].map((ge) => ({
      input: qt(ge),
      change: cn(ge),
      keyup: sn,
      ...e.popover && Q.value
    }));
    return C.value ? {
      start: j[0],
      end: j[1]
    } : j[0];
  }), pe = te(() => {
    if (!ft(m.value))
      return null;
    const j = {
      key: "select-drag",
      ...e.selectAttribute,
      dates: m.value,
      pinPage: !0
    }, { dot: ge, bar: De, highlight: N, content: U } = j;
    return !ge && !De && !N && !U && (j.highlight = !0), j;
  }), Ye = te(() => {
    if (!C.value || !ft(v.value))
      return null;
    const j = {
      key: "select-drag",
      ...e.dragAttribute,
      dates: v.value
    }, { dot: ge, bar: De, highlight: N, content: U } = j;
    return !ge && !De && !N && !U && (j.highlight = {
      startEnd: {
        fillMode: "outline"
      }
    }), j;
  }), ue = te(() => {
    const j = Fn(e.attributes) ? [...e.attributes] : [];
    return Ye.value ? j.unshift(Ye.value) : pe.value && j.unshift(pe.value), j;
  }), Fe = te(() => nt(
    e.rules === "auto" ? Pe() : e.rules ?? {}
  ));
  function Pe() {
    const j = {
      ms: [0, 999],
      sec: [0, 59],
      min: [0, 59],
      hr: [0, 23]
    }, ge = P.value ? 0 : e.timeAccuracy;
    return [0, 1].map((De) => {
      switch (ge) {
        case 0:
          return {
            hours: j.hr[De],
            minutes: j.min[De],
            seconds: j.sec[De],
            milliseconds: j.ms[De]
          };
        case 1:
          return {
            minutes: j.min[De],
            seconds: j.sec[De],
            milliseconds: j.ms[De]
          };
        case 3:
          return { milliseconds: j.ms[De] };
        case 4:
          return {};
        default:
          return { seconds: j.sec[De], milliseconds: j.ms[De] };
      }
    });
  }
  function nt(j) {
    return Fn(j) ? j.length === 1 ? [j[0], j[0]] : j : [j, j];
  }
  function Ve(j) {
    return nt(j).map(
      (ge, De) => ({
        ...ge,
        rules: Fe.value[De]
      })
    );
  }
  function Ze(j) {
    return j == null ? !1 : ri(j) ? !isNaN(j) : ha(j) ? !isNaN(j.getTime()) : di(j) ? j !== "" : Ju(j);
  }
  function Ne(j) {
    return Di(j) && "start" in j && "end" in j && Ze(j.start ?? null) && Ze(j.end ?? null);
  }
  function ft(j) {
    return Ne(j) || Ze(j);
  }
  function pt(j, ge) {
    if (j == null && ge == null)
      return !0;
    if (j == null || ge == null)
      return !1;
    const De = ha(j), N = ha(ge);
    return De && N ? j.getTime() === ge.getTime() : De || N ? !1 : pt(j.start, ge.start) && pt(j.end, ge.end);
  }
  function Wt(j) {
    return !ft(j) || !u.value ? !1 : u.value.intersectsRange(a.value.range(j));
  }
  function an(j, ge, De, N) {
    if (!ft(j))
      return null;
    if (Ne(j)) {
      const U = a.value.toDate(j.start, {
        ...ge[0],
        fillDate: T.value ?? void 0,
        patch: De
      }), ie = a.value.toDate(j.end, {
        ...ge[1],
        fillDate: A.value ?? void 0,
        patch: De
      });
      return xt({ start: U, end: ie }, N);
    }
    return a.value.toDateOrNull(j, {
      ...ge[0],
      fillDate: m.value,
      patch: De
    });
  }
  function on(j, ge) {
    return Ne(j) ? {
      start: a.value.fromDate(j.start, ge[0]),
      end: a.value.fromDate(j.end, ge[1])
    } : C.value ? null : a.value.fromDate(j, ge[0]);
  }
  function Dt(j, ge = {}) {
    return clearTimeout(M), new Promise((De) => {
      const { debounce: N = 0, ...U } = ge;
      N > 0 ? M = window.setTimeout(() => {
        De(Zt(j, U));
      }, N) : De(Zt(j, U));
    });
  }
  function Zt(j, {
    config: ge = G.value,
    patch: De = "dateTime",
    clearIfEqual: N = !1,
    formatInput: U = !0,
    hidePopover: ie = !1,
    dragging: ve = Y.value,
    targetPriority: Ee,
    moveToValue: Ce = !1
  } = {}) {
    const He = Ve(ge);
    let Re = an(
      j,
      He,
      De,
      Ee
    );
    if (Wt(Re)) {
      if (ve)
        return null;
      Re = m.value, ie = !1;
    } else
      Re == null && e.isRequired ? Re = m.value : (
        // Clear value if same value was passed
        Re != null && pt(m.value, Re) && N && (Re = null)
      );
    const ht = ve ? v : m, wt = !pt(ht.value, Re);
    ht.value = Re, ve || (v.value = null);
    const ct = on(
      Re,
      G.value
    );
    return wt && (R = !1, t(ve ? "drag" : "update:modelValue", ct), nn(() => R = !0)), ie && !ve && Xe(), U && It(), Ce && nn(() => At(Ee ?? "start")), ct;
  }
  function It() {
    nn(() => {
      const j = Ve({
        type: "string",
        mask: X.value
      }), ge = on(
        v.value ?? m.value,
        j
      );
      C.value ? y.value = [ge && ge.start, ge && ge.end] : y.value = [ge, ""];
    });
  }
  function bn(j, ge, De) {
    y.value.splice(ge === "start" ? 0 : 1, 1, j);
    const N = C.value ? {
      start: y.value[0],
      end: y.value[1] || y.value[0]
    } : j, U = {
      type: "string",
      mask: X.value
    };
    Dt(N, {
      ...De,
      config: U,
      patch: se.value,
      targetPriority: ge,
      moveToValue: !0
    });
  }
  function qt(j) {
    return (ge) => {
      e.updateOnInput && bn(ge.currentTarget.value, j, {
        formatInput: !1,
        hidePopover: !1,
        debounce: e.inputDebounce
      });
    };
  }
  function cn(j) {
    return (ge) => {
      bn(ge.currentTarget.value, j, {
        formatInput: !0,
        hidePopover: !1
      });
    };
  }
  function sn(j) {
    j.key === "Escape" && Dt(m.value, {
      formatInput: !0,
      hidePopover: !0
    });
  }
  function H(j) {
    return C.value ? [
      j && j.start ? a.value.getDateParts(j.start) : null,
      j && j.end ? a.value.getDateParts(j.end) : null
    ] : [j ? a.value.getDateParts(j) : null];
  }
  function S() {
    v.value = null, It();
  }
  function E(j) {
    t("popover-will-show", j);
  }
  function z(j) {
    t("popover-did-show", j);
  }
  function q(j) {
    S(), t("popover-will-hide", j);
  }
  function J(j) {
    t("popover-did-hide", j);
  }
  function me(j) {
    const ge = {
      patch: "date",
      formatInput: !0,
      hidePopover: !0
    };
    if (C.value) {
      const De = !Y.value;
      De ? O = { start: j.startDate, end: j.endDate } : O != null && (O.end = j.date), Dt(O, {
        ...ge,
        dragging: De
      });
    } else
      Dt(j.date, {
        ...ge,
        clearIfEqual: !e.isRequired
      });
  }
  function ye(j, ge) {
    me(j), t("dayclick", j, ge);
  }
  function Oe(j, ge) {
    switch (ge.key) {
      case " ":
      case "Enter": {
        me(j), ge.preventDefault();
        break;
      }
      case "Escape":
        Xe();
    }
    t("daykeydown", j, ge);
  }
  function Ue(j, ge) {
    !Y.value || O == null || (O.end = j.date, Dt(xt(O), {
      patch: "date",
      formatInput: !0
    }));
  }
  function at(j = {}) {
    su({
      ...re.value,
      ...j,
      isInteractive: !0,
      id: f.value
    });
  }
  function Xe(j = {}) {
    go({
      hideDelay: 10,
      force: !0,
      ...re.value,
      ...j,
      id: f.value
    });
  }
  function We(j) {
    Om({
      ...re.value,
      ...j,
      isInteractive: !0,
      id: f.value
    });
  }
  function xt(j, ge) {
    const { start: De, end: N } = j;
    if (De > N)
      switch (ge) {
        case "start":
          return { start: De, end: De };
        case "end":
          return { start: N, end: N };
        default:
          return { start: N, end: De };
      }
    return { start: De, end: N };
  }
  async function lt(j, ge = {}) {
    return x.value == null ? !1 : x.value.move(j, ge);
  }
  async function bt(j, ge = {}) {
    return x.value == null ? !1 : x.value.moveBy(j, ge);
  }
  async function At(j, ge = {}) {
    const De = m.value;
    if (x.value == null || !ft(De))
      return !1;
    const N = j !== "end", U = N ? 1 : -1, ie = Ne(De) ? N ? De.start : De.end : De, ve = fm(ie, "monthly", a.value);
    return x.value.move(ve, { position: U, ...ge });
  }
  kt(
    () => e.isRange,
    (j) => {
      j && console.warn(
        "The `is-range` prop will be deprecated in future releases. Please use the `range` modifier."
      );
    },
    { immediate: !0 }
  ), kt(
    () => C.value,
    () => {
      Zt(null, { formatInput: !0 });
    }
  ), kt(
    () => X.value,
    () => It()
  ), kt(
    () => e.modelValue,
    (j) => {
      R && Zt(j, {
        formatInput: !0,
        hidePopover: !1
      });
    }
  ), kt(
    () => Fe.value,
    () => {
      Di(e.rules) && Zt(e.modelValue, {
        formatInput: !0,
        hidePopover: !1
      });
    }
  ), kt(
    () => e.timezone,
    () => {
      Zt(m.value, { formatInput: !0 });
    }
  );
  const Rt = nt(G.value);
  m.value = an(
    e.modelValue ?? null,
    Rt,
    "dateTime"
  ), In(() => {
    Zt(e.modelValue, {
      formatInput: !0,
      hidePopover: !1
    });
  }), nn(() => h.value = !0);
  const be = {
    ...r,
    showCalendar: h,
    datePickerPopoverId: f,
    popoverRef: k,
    popoverEvents: Q,
    calendarRef: x,
    isRange: C,
    isTimeMode: $,
    isDateTimeMode: D,
    is24hr: us(e, "is24hr"),
    hideTimeHeader: us(e, "hideTimeHeader"),
    timeAccuracy: us(e, "timeAccuracy"),
    isDragging: Y,
    inputValue: ke,
    inputEvents: Ae,
    dateParts: ee,
    attributes: ue,
    rules: Fe,
    move: lt,
    moveBy: bt,
    moveToValue: At,
    updateValue: Dt,
    showPopover: at,
    hidePopover: Xe,
    togglePopover: We,
    onDayClick: ye,
    onDayKeydown: Oe,
    onDayMouseEnter: Ue,
    onPopoverBeforeShow: E,
    onPopoverAfterShow: z,
    onPopoverBeforeHide: q,
    onPopoverAfterHide: J
  };
  return Bi(Hm, be), be;
}
function nc() {
  const e = Ri(Hm);
  if (e)
    return e;
  throw new Error(
    "DatePicker context missing. Please verify this component is nested within a valid context provider."
  );
}
const NA = [
  { value: 0, label: "12" },
  { value: 1, label: "1" },
  { value: 2, label: "2" },
  { value: 3, label: "3" },
  { value: 4, label: "4" },
  { value: 5, label: "5" },
  { value: 6, label: "6" },
  { value: 7, label: "7" },
  { value: 8, label: "8" },
  { value: 9, label: "9" },
  { value: 10, label: "10" },
  { value: 11, label: "11" }
], zA = [
  { value: 12, label: "12" },
  { value: 13, label: "1" },
  { value: 14, label: "2" },
  { value: 15, label: "3" },
  { value: 16, label: "4" },
  { value: 17, label: "5" },
  { value: 18, label: "6" },
  { value: 19, label: "7" },
  { value: 20, label: "8" },
  { value: 21, label: "9" },
  { value: 22, label: "10" },
  { value: 23, label: "11" }
];
function FA(e) {
  const t = nc(), {
    locale: n,
    isRange: r,
    isTimeMode: a,
    dateParts: l,
    rules: u,
    is24hr: h,
    hideTimeHeader: f,
    timeAccuracy: m,
    updateValue: v
  } = t;
  function y(ne) {
    ne = Object.assign(x.value, ne);
    let se = null;
    if (r.value) {
      const re = k.value ? ne : l.value[0], Q = k.value ? l.value[1] : ne;
      se = { start: re, end: Q };
    } else
      se = ne;
    v(se, {
      patch: "time",
      targetPriority: k.value ? "start" : "end",
      moveToValue: !0
    });
  }
  const k = te(() => e.position === 0), x = te(
    () => l.value[e.position] || { isValid: !1 }
  ), M = te(() => Ju(x.value)), O = te(() => !!x.value.isValid), R = te(() => !f.value && O.value), C = te(() => {
    if (!M.value)
      return null;
    let ne = n.value.toDate(x.value);
    return x.value.hours === 24 && (ne = new Date(ne.getTime() - 1)), ne;
  }), T = te({
    get() {
      return x.value.hours;
    },
    set(ne) {
      y({ hours: ne });
    }
  }), A = te({
    get() {
      return x.value.minutes;
    },
    set(ne) {
      y({ minutes: ne });
    }
  }), P = te({
    get() {
      return x.value.seconds;
    },
    set(ne) {
      y({ seconds: ne });
    }
  }), D = te({
    get() {
      return x.value.milliseconds;
    },
    set(ne) {
      y({ milliseconds: ne });
    }
  }), $ = te({
    get() {
      return x.value.hours < 12;
    },
    set(ne) {
      ne = String(ne).toLowerCase() == "true";
      let se = T.value;
      ne && se >= 12 ? se -= 12 : !ne && se < 12 && (se += 12), y({ hours: se });
    }
  }), Y = te(
    () => rI(x.value, u.value[e.position])
  ), G = te(() => NA.filter(
    (ne) => Y.value.hours.some((se) => se.value === ne.value)
  )), ee = te(() => zA.filter(
    (ne) => Y.value.hours.some((se) => se.value === ne.value)
  )), X = te(() => h.value ? Y.value.hours : $.value ? G.value : ee.value), ae = te(() => {
    const ne = [];
    return Si(G.value) && ne.push({ value: !0, label: "AM" }), Si(ee.value) && ne.push({ value: !1, label: "PM" }), ne;
  });
  return {
    ...t,
    showHeader: R,
    timeAccuracy: m,
    parts: x,
    isValid: O,
    date: C,
    hours: T,
    minutes: A,
    seconds: P,
    milliseconds: D,
    options: Y,
    hourOptions: X,
    isAM: $,
    isAMOptions: ae,
    is24hr: h
  };
}
const jA = ["value"], VA = ["value", "disabled"], YA = {
  key: 1,
  class: "vc-base-sizer",
  "aria-hidden": "true"
}, HA = {
  inheritAttrs: !1
}, Ka = /* @__PURE__ */ tt({
  ...HA,
  __name: "BaseSelect",
  props: {
    options: null,
    modelValue: null,
    alignRight: { type: Boolean },
    alignLeft: { type: Boolean },
    showIcon: { type: Boolean },
    fitContent: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(e) {
    const t = e, n = te(() => {
      const r = t.options.find((a) => a.value === t.modelValue);
      return r == null ? void 0 : r.label;
    });
    return (r, a) => (we(), Te("div", {
      class: gt(["vc-base-select", {
        "vc-fit-content": e.fitContent,
        "vc-has-icon": e.showIcon
      }])
    }, [
      xe("select", Qt(r.$attrs, {
        value: e.modelValue,
        class: ["vc-focus", {
          "vc-align-right": e.alignRight,
          "vc-align-left": e.alignLeft
        }],
        onChange: a[0] || (a[0] = (l) => r.$emit("update:modelValue", l.target.value))
      }), [
        (we(!0), Te(Et, null, rn(e.options, (l) => (we(), Te("option", {
          key: l.value,
          value: l.value,
          disabled: l.disabled
        }, _t(l.label), 9, VA))), 128))
      ], 16, jA),
      e.showIcon ? (we(), Ut(va, {
        key: 0,
        name: "ChevronDown",
        size: "18"
      })) : vt("", !0),
      e.fitContent ? (we(), Te("div", YA, _t(he(n)), 1)) : vt("", !0)
    ], 2));
  }
}), UA = {
  key: 0,
  class: "vc-time-header"
}, ZA = { class: "vc-time-weekday" }, WA = { class: "vc-time-month" }, GA = { class: "vc-time-day" }, qA = { class: "vc-time-year" }, KA = { class: "vc-time-select-group" }, JA = /* @__PURE__ */ xe("span", { class: "vc-time-colon" }, ":", -1), XA = /* @__PURE__ */ xe("span", { class: "vc-time-colon" }, ":", -1), QA = /* @__PURE__ */ xe("span", { class: "vc-time-decimal" }, ".", -1), Fd = /* @__PURE__ */ tt({
  __name: "TimePicker",
  props: {
    position: null
  },
  setup(e, { expose: t }) {
    const r = FA(e);
    t(r);
    const {
      locale: a,
      isValid: l,
      date: u,
      hours: h,
      minutes: f,
      seconds: m,
      milliseconds: v,
      options: y,
      hourOptions: k,
      isTimeMode: x,
      isAM: M,
      isAMOptions: O,
      is24hr: R,
      showHeader: C,
      timeAccuracy: T
    } = r;
    return (A, P) => (we(), Te("div", {
      class: gt(["vc-time-picker", [{ "vc-invalid": !he(l), "vc-attached": !he(x) }]])
    }, [
      ce($n, { name: "time-header" }, {
        default: Je(() => [
          he(C) && he(u) ? (we(), Te("div", UA, [
            xe("span", ZA, _t(he(a).formatDate(he(u), "WWW")), 1),
            xe("span", WA, _t(he(a).formatDate(he(u), "MMM")), 1),
            xe("span", GA, _t(he(a).formatDate(he(u), "D")), 1),
            xe("span", qA, _t(he(a).formatDate(he(u), "YYYY")), 1)
          ])) : vt("", !0)
        ]),
        _: 1
      }),
      xe("div", KA, [
        ce(va, {
          name: "Clock",
          size: "17"
        }),
        ce(Ka, {
          modelValue: he(h),
          "onUpdate:modelValue": P[0] || (P[0] = (D) => Za(h) ? h.value = D : null),
          modelModifiers: { number: !0 },
          options: he(k),
          class: "vc-time-select-hours",
          "align-right": ""
        }, null, 8, ["modelValue", "options"]),
        he(T) > 1 ? (we(), Te(Et, { key: 0 }, [
          JA,
          ce(Ka, {
            modelValue: he(f),
            "onUpdate:modelValue": P[1] || (P[1] = (D) => Za(f) ? f.value = D : null),
            modelModifiers: { number: !0 },
            options: he(y).minutes,
            class: "vc-time-select-minutes",
            "align-left": he(T) === 2
          }, null, 8, ["modelValue", "options", "align-left"])
        ], 64)) : vt("", !0),
        he(T) > 2 ? (we(), Te(Et, { key: 1 }, [
          XA,
          ce(Ka, {
            modelValue: he(m),
            "onUpdate:modelValue": P[2] || (P[2] = (D) => Za(m) ? m.value = D : null),
            modelModifiers: { number: !0 },
            options: he(y).seconds,
            class: "vc-time-select-seconds",
            "align-left": he(T) === 3
          }, null, 8, ["modelValue", "options", "align-left"])
        ], 64)) : vt("", !0),
        he(T) > 3 ? (we(), Te(Et, { key: 2 }, [
          QA,
          ce(Ka, {
            modelValue: he(v),
            "onUpdate:modelValue": P[3] || (P[3] = (D) => Za(v) ? v.value = D : null),
            modelModifiers: { number: !0 },
            options: he(y).milliseconds,
            class: "vc-time-select-milliseconds",
            "align-left": ""
          }, null, 8, ["modelValue", "options"])
        ], 64)) : vt("", !0),
        he(R) ? vt("", !0) : (we(), Ut(Ka, {
          key: 3,
          modelValue: he(M),
          "onUpdate:modelValue": P[4] || (P[4] = (D) => Za(M) ? M.value = D : null),
          options: he(O)
        }, null, 8, ["modelValue", "options"]))
      ])
    ], 2));
  }
}), Um = /* @__PURE__ */ tt({
  __name: "DatePickerBase",
  setup(e) {
    const {
      attributes: t,
      calendarRef: n,
      color: r,
      displayMode: a,
      isDateTimeMode: l,
      isTimeMode: u,
      isRange: h,
      onDayClick: f,
      onDayMouseEnter: m,
      onDayKeydown: v
    } = nc(), y = h.value ? [0, 1] : [0];
    return (k, x) => he(u) ? (we(), Te("div", {
      key: 0,
      class: gt(`vc-container vc-bordered vc-${he(r)} vc-${he(a)}`)
    }, [
      (we(!0), Te(Et, null, rn(he(y), (M) => (we(), Ut(Fd, {
        key: M,
        position: M
      }, null, 8, ["position"]))), 128))
    ], 2)) : (we(), Ut(AA, {
      key: 1,
      attributes: he(t),
      ref_key: "calendarRef",
      ref: n,
      onDayclick: he(f),
      onDaymouseenter: he(m),
      onDaykeydown: he(v)
    }, {
      footer: Je(() => [
        he(l) ? (we(!0), Te(Et, { key: 0 }, rn(he(y), (M) => (we(), Ut(Fd, {
          key: M,
          position: M
        }, null, 8, ["position"]))), 128)) : vt("", !0),
        ce($n, { name: "dp-footer" })
      ]),
      _: 1
    }, 8, ["attributes", "onDayclick", "onDaymouseenter", "onDaykeydown"]));
  }
}), eR = {
  inheritAttrs: !1
}, tR = /* @__PURE__ */ tt({
  ...eR,
  __name: "DatePickerPopover",
  setup(e) {
    const {
      datePickerPopoverId: t,
      color: n,
      displayMode: r,
      popoverRef: a,
      onPopoverBeforeShow: l,
      onPopoverAfterShow: u,
      onPopoverBeforeHide: h,
      onPopoverAfterHide: f
    } = nc();
    return (m, v) => (we(), Ut(tc, {
      id: he(t),
      placement: "bottom-start",
      class: gt(`vc-date-picker-content vc-${he(n)} vc-${he(r)}`),
      ref_key: "popoverRef",
      ref: a,
      onBeforeShow: he(l),
      onAfterShow: he(u),
      onBeforeHide: he(h),
      onAfterHide: he(f)
    }, {
      default: Je(() => [
        ce(Um, ua(ks(m.$attrs)), null, 16)
      ]),
      _: 1
    }, 8, ["id", "class", "onBeforeShow", "onAfterShow", "onBeforeHide", "onAfterHide"]));
  }
}), nR = tt({
  inheritAttrs: !1,
  emits: BA,
  props: RA,
  components: { DatePickerBase: Um, DatePickerPopover: tR },
  setup(e, t) {
    const n = $A(e, t), r = Ir(um(n, "calendarRef", "popoverRef"));
    return { ...n, slotCtx: r };
  }
});
function iR(e, t, n, r, a, l) {
  const u = Mi("DatePickerPopover"), h = Mi("DatePickerBase");
  return e.$slots.default ? (we(), Te(Et, { key: 0 }, [
    Xt(e.$slots, "default", ua(ks(e.slotCtx))),
    ce(u, ua(ks(e.$attrs)), null, 16)
  ], 64)) : (we(), Ut(h, ua(Qt({ key: 1 }, e.$attrs)), null, 16));
}
const jd = /* @__PURE__ */ hr(nR, [["render", iR]]);
class zr extends Error {
}
class rR extends zr {
  constructor(t) {
    super(`Invalid DateTime: ${t.toMessage()}`);
  }
}
class aR extends zr {
  constructor(t) {
    super(`Invalid Interval: ${t.toMessage()}`);
  }
}
class oR extends zr {
  constructor(t) {
    super(`Invalid Duration: ${t.toMessage()}`);
  }
}
class sa extends zr {
}
class Zm extends zr {
  constructor(t) {
    super(`Invalid unit ${t}`);
  }
}
class On extends zr {
}
class Qi extends zr {
  constructor() {
    super("Zone is an abstract class");
  }
}
const $e = "numeric", ai = "short", Dn = "long", js = {
  year: $e,
  month: $e,
  day: $e
}, Wm = {
  year: $e,
  month: ai,
  day: $e
}, sR = {
  year: $e,
  month: ai,
  day: $e,
  weekday: ai
}, Gm = {
  year: $e,
  month: Dn,
  day: $e
}, qm = {
  year: $e,
  month: Dn,
  day: $e,
  weekday: Dn
}, Km = {
  hour: $e,
  minute: $e
}, Jm = {
  hour: $e,
  minute: $e,
  second: $e
}, Xm = {
  hour: $e,
  minute: $e,
  second: $e,
  timeZoneName: ai
}, Qm = {
  hour: $e,
  minute: $e,
  second: $e,
  timeZoneName: Dn
}, eg = {
  hour: $e,
  minute: $e,
  hourCycle: "h23"
}, tg = {
  hour: $e,
  minute: $e,
  second: $e,
  hourCycle: "h23"
}, ng = {
  hour: $e,
  minute: $e,
  second: $e,
  hourCycle: "h23",
  timeZoneName: ai
}, ig = {
  hour: $e,
  minute: $e,
  second: $e,
  hourCycle: "h23",
  timeZoneName: Dn
}, rg = {
  year: $e,
  month: $e,
  day: $e,
  hour: $e,
  minute: $e
}, ag = {
  year: $e,
  month: $e,
  day: $e,
  hour: $e,
  minute: $e,
  second: $e
}, og = {
  year: $e,
  month: ai,
  day: $e,
  hour: $e,
  minute: $e
}, sg = {
  year: $e,
  month: ai,
  day: $e,
  hour: $e,
  minute: $e,
  second: $e
}, lR = {
  year: $e,
  month: ai,
  day: $e,
  weekday: ai,
  hour: $e,
  minute: $e
}, lg = {
  year: $e,
  month: Dn,
  day: $e,
  hour: $e,
  minute: $e,
  timeZoneName: ai
}, ug = {
  year: $e,
  month: Dn,
  day: $e,
  hour: $e,
  minute: $e,
  second: $e,
  timeZoneName: ai
}, cg = {
  year: $e,
  month: Dn,
  day: $e,
  weekday: Dn,
  hour: $e,
  minute: $e,
  timeZoneName: Dn
}, hg = {
  year: $e,
  month: Dn,
  day: $e,
  weekday: Dn,
  hour: $e,
  minute: $e,
  second: $e,
  timeZoneName: Dn
};
class Mo {
  /**
   * The type of zone
   * @abstract
   * @type {string}
   */
  get type() {
    throw new Qi();
  }
  /**
   * The name of this zone.
   * @abstract
   * @type {string}
   */
  get name() {
    throw new Qi();
  }
  get ianaName() {
    return this.name;
  }
  /**
   * Returns whether the offset is known to be fixed for the whole year.
   * @abstract
   * @type {boolean}
   */
  get isUniversal() {
    throw new Qi();
  }
  /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */
  offsetName(t, n) {
    throw new Qi();
  }
  /**
   * Returns the offset's value as a string
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */
  formatOffset(t, n) {
    throw new Qi();
  }
  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to compute the offset
   * @return {number}
   */
  offset(t) {
    throw new Qi();
  }
  /**
   * Return whether this Zone is equal to another zone
   * @abstract
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */
  equals(t) {
    throw new Qi();
  }
  /**
   * Return whether this Zone is valid.
   * @abstract
   * @type {boolean}
   */
  get isValid() {
    throw new Qi();
  }
}
let Bl = null;
class al extends Mo {
  /**
   * Get a singleton instance of the local zone
   * @return {SystemZone}
   */
  static get instance() {
    return Bl === null && (Bl = new al()), Bl;
  }
  /** @override **/
  get type() {
    return "system";
  }
  /** @override **/
  get name() {
    return new Intl.DateTimeFormat().resolvedOptions().timeZone;
  }
  /** @override **/
  get isUniversal() {
    return !1;
  }
  /** @override **/
  offsetName(t, { format: n, locale: r }) {
    return bg(t, n, r);
  }
  /** @override **/
  formatOffset(t, n) {
    return ro(this.offset(t), n);
  }
  /** @override **/
  offset(t) {
    return -new Date(t).getTimezoneOffset();
  }
  /** @override **/
  equals(t) {
    return t.type === "system";
  }
  /** @override **/
  get isValid() {
    return !0;
  }
}
let ys = {};
function uR(e) {
  return ys[e] || (ys[e] = new Intl.DateTimeFormat("en-US", {
    hour12: !1,
    timeZone: e,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    era: "short"
  })), ys[e];
}
const cR = {
  year: 0,
  month: 1,
  day: 2,
  era: 3,
  hour: 4,
  minute: 5,
  second: 6
};
function hR(e, t) {
  const n = e.format(t).replace(/\u200E/g, ""), r = /(\d+)\/(\d+)\/(\d+) (AD|BC),? (\d+):(\d+):(\d+)/.exec(n), [, a, l, u, h, f, m, v] = r;
  return [u, a, l, h, f, m, v];
}
function dR(e, t) {
  const n = e.formatToParts(t), r = [];
  for (let a = 0; a < n.length; a++) {
    const { type: l, value: u } = n[a], h = cR[l];
    l === "era" ? r[h] = u : rt(h) || (r[h] = parseInt(u, 10));
  }
  return r;
}
let ns = {};
class Ai extends Mo {
  /**
   * @param {string} name - Zone name
   * @return {IANAZone}
   */
  static create(t) {
    return ns[t] || (ns[t] = new Ai(t)), ns[t];
  }
  /**
   * Reset local caches. Should only be necessary in testing scenarios.
   * @return {void}
   */
  static resetCache() {
    ns = {}, ys = {};
  }
  /**
   * Returns whether the provided string is a valid specifier. This only checks the string's format, not that the specifier identifies a known zone; see isValidZone for that.
   * @param {string} s - The string to check validity on
   * @example IANAZone.isValidSpecifier("America/New_York") //=> true
   * @example IANAZone.isValidSpecifier("Sport~~blorp") //=> false
   * @deprecated This method returns false for some valid IANA names. Use isValidZone instead.
   * @return {boolean}
   */
  static isValidSpecifier(t) {
    return this.isValidZone(t);
  }
  /**
   * Returns whether the provided string identifies a real zone
   * @param {string} zone - The string to check
   * @example IANAZone.isValidZone("America/New_York") //=> true
   * @example IANAZone.isValidZone("Fantasia/Castle") //=> false
   * @example IANAZone.isValidZone("Sport~~blorp") //=> false
   * @return {boolean}
   */
  static isValidZone(t) {
    if (!t)
      return !1;
    try {
      return new Intl.DateTimeFormat("en-US", { timeZone: t }).format(), !0;
    } catch {
      return !1;
    }
  }
  constructor(t) {
    super(), this.zoneName = t, this.valid = Ai.isValidZone(t);
  }
  /** @override **/
  get type() {
    return "iana";
  }
  /** @override **/
  get name() {
    return this.zoneName;
  }
  /** @override **/
  get isUniversal() {
    return !1;
  }
  /** @override **/
  offsetName(t, { format: n, locale: r }) {
    return bg(t, n, r, this.name);
  }
  /** @override **/
  formatOffset(t, n) {
    return ro(this.offset(t), n);
  }
  /** @override **/
  offset(t) {
    const n = new Date(t);
    if (isNaN(n))
      return NaN;
    const r = uR(this.name);
    let [a, l, u, h, f, m, v] = r.formatToParts ? dR(r, n) : hR(r, n);
    h === "BC" && (a = -Math.abs(a) + 1);
    const k = sl({
      year: a,
      month: l,
      day: u,
      hour: f === 24 ? 0 : f,
      minute: m,
      second: v,
      millisecond: 0
    });
    let x = +n;
    const M = x % 1e3;
    return x -= M >= 0 ? M : 1e3 + M, (k - x) / (60 * 1e3);
  }
  /** @override **/
  equals(t) {
    return t.type === "iana" && t.name === this.name;
  }
  /** @override **/
  get isValid() {
    return this.valid;
  }
}
let Vd = {};
function fR(e, t = {}) {
  const n = JSON.stringify([e, t]);
  let r = Vd[n];
  return r || (r = new Intl.ListFormat(e, t), Vd[n] = r), r;
}
let lu = {};
function uu(e, t = {}) {
  const n = JSON.stringify([e, t]);
  let r = lu[n];
  return r || (r = new Intl.DateTimeFormat(e, t), lu[n] = r), r;
}
let cu = {};
function pR(e, t = {}) {
  const n = JSON.stringify([e, t]);
  let r = cu[n];
  return r || (r = new Intl.NumberFormat(e, t), cu[n] = r), r;
}
let hu = {};
function mR(e, t = {}) {
  const { base: n, ...r } = t, a = JSON.stringify([e, r]);
  let l = hu[a];
  return l || (l = new Intl.RelativeTimeFormat(e, t), hu[a] = l), l;
}
let no = null;
function gR() {
  return no || (no = new Intl.DateTimeFormat().resolvedOptions().locale, no);
}
let Yd = {};
function vR(e) {
  let t = Yd[e];
  if (!t) {
    const n = new Intl.Locale(e);
    t = "getWeekInfo" in n ? n.getWeekInfo() : n.weekInfo, Yd[e] = t;
  }
  return t;
}
function _R(e) {
  const t = e.indexOf("-x-");
  t !== -1 && (e = e.substring(0, t));
  const n = e.indexOf("-u-");
  if (n === -1)
    return [e];
  {
    let r, a;
    try {
      r = uu(e).resolvedOptions(), a = e;
    } catch {
      const f = e.substring(0, n);
      r = uu(f).resolvedOptions(), a = f;
    }
    const { numberingSystem: l, calendar: u } = r;
    return [a, l, u];
  }
}
function yR(e, t, n) {
  return (n || t) && (e.includes("-u-") || (e += "-u"), n && (e += `-ca-${n}`), t && (e += `-nu-${t}`)), e;
}
function bR(e) {
  const t = [];
  for (let n = 1; n <= 12; n++) {
    const r = et.utc(2009, n, 1);
    t.push(e(r));
  }
  return t;
}
function wR(e) {
  const t = [];
  for (let n = 1; n <= 7; n++) {
    const r = et.utc(2016, 11, 13 + n);
    t.push(e(r));
  }
  return t;
}
function is(e, t, n, r) {
  const a = e.listingMode();
  return a === "error" ? null : a === "en" ? n(t) : r(t);
}
function kR(e) {
  return e.numberingSystem && e.numberingSystem !== "latn" ? !1 : e.numberingSystem === "latn" || !e.locale || e.locale.startsWith("en") || new Intl.DateTimeFormat(e.intl).resolvedOptions().numberingSystem === "latn";
}
class xR {
  constructor(t, n, r) {
    this.padTo = r.padTo || 0, this.floor = r.floor || !1;
    const { padTo: a, floor: l, ...u } = r;
    if (!n || Object.keys(u).length > 0) {
      const h = { useGrouping: !1, ...r };
      r.padTo > 0 && (h.minimumIntegerDigits = r.padTo), this.inf = pR(t, h);
    }
  }
  format(t) {
    if (this.inf) {
      const n = this.floor ? Math.floor(t) : t;
      return this.inf.format(n);
    } else {
      const n = this.floor ? Math.floor(t) : oc(t, 3);
      return un(n, this.padTo);
    }
  }
}
class LR {
  constructor(t, n, r) {
    this.opts = r, this.originalZone = void 0;
    let a;
    if (this.opts.timeZone)
      this.dt = t;
    else if (t.zone.type === "fixed") {
      const u = -1 * (t.offset / 60), h = u >= 0 ? `Etc/GMT+${u}` : `Etc/GMT${u}`;
      t.offset !== 0 && Ai.create(h).valid ? (a = h, this.dt = t) : (a = "UTC", this.dt = t.offset === 0 ? t : t.setZone("UTC").plus({ minutes: t.offset }), this.originalZone = t.zone);
    } else
      t.zone.type === "system" ? this.dt = t : t.zone.type === "iana" ? (this.dt = t, a = t.zone.name) : (a = "UTC", this.dt = t.setZone("UTC").plus({ minutes: t.offset }), this.originalZone = t.zone);
    const l = { ...this.opts };
    l.timeZone = l.timeZone || a, this.dtf = uu(n, l);
  }
  format() {
    return this.originalZone ? this.formatToParts().map(({ value: t }) => t).join("") : this.dtf.format(this.dt.toJSDate());
  }
  formatToParts() {
    const t = this.dtf.formatToParts(this.dt.toJSDate());
    return this.originalZone ? t.map((n) => {
      if (n.type === "timeZoneName") {
        const r = this.originalZone.offsetName(this.dt.ts, {
          locale: this.dt.locale,
          format: this.opts.timeZoneName
        });
        return {
          ...n,
          value: r
        };
      } else
        return n;
    }) : t;
  }
  resolvedOptions() {
    return this.dtf.resolvedOptions();
  }
}
class MR {
  constructor(t, n, r) {
    this.opts = { style: "long", ...r }, !n && _g() && (this.rtf = mR(t, r));
  }
  format(t, n) {
    return this.rtf ? this.rtf.format(t, n) : UR(n, t, this.opts.numeric, this.opts.style !== "long");
  }
  formatToParts(t, n) {
    return this.rtf ? this.rtf.formatToParts(t, n) : [];
  }
}
const SR = {
  firstDay: 1,
  minimalDays: 4,
  weekend: [6, 7]
};
class $t {
  static fromOpts(t) {
    return $t.create(
      t.locale,
      t.numberingSystem,
      t.outputCalendar,
      t.weekSettings,
      t.defaultToEN
    );
  }
  static create(t, n, r, a, l = !1) {
    const u = t || en.defaultLocale, h = u || (l ? "en-US" : gR()), f = n || en.defaultNumberingSystem, m = r || en.defaultOutputCalendar, v = du(a) || en.defaultWeekSettings;
    return new $t(h, f, m, v, u);
  }
  static resetCache() {
    no = null, lu = {}, cu = {}, hu = {};
  }
  static fromObject({ locale: t, numberingSystem: n, outputCalendar: r, weekSettings: a } = {}) {
    return $t.create(t, n, r, a);
  }
  constructor(t, n, r, a, l) {
    const [u, h, f] = _R(t);
    this.locale = u, this.numberingSystem = n || h || null, this.outputCalendar = r || f || null, this.weekSettings = a, this.intl = yR(this.locale, this.numberingSystem, this.outputCalendar), this.weekdaysCache = { format: {}, standalone: {} }, this.monthsCache = { format: {}, standalone: {} }, this.meridiemCache = null, this.eraCache = {}, this.specifiedLocale = l, this.fastNumbersCached = null;
  }
  get fastNumbers() {
    return this.fastNumbersCached == null && (this.fastNumbersCached = kR(this)), this.fastNumbersCached;
  }
  listingMode() {
    const t = this.isEnglish(), n = (this.numberingSystem === null || this.numberingSystem === "latn") && (this.outputCalendar === null || this.outputCalendar === "gregory");
    return t && n ? "en" : "intl";
  }
  clone(t) {
    return !t || Object.getOwnPropertyNames(t).length === 0 ? this : $t.create(
      t.locale || this.specifiedLocale,
      t.numberingSystem || this.numberingSystem,
      t.outputCalendar || this.outputCalendar,
      du(t.weekSettings) || this.weekSettings,
      t.defaultToEN || !1
    );
  }
  redefaultToEN(t = {}) {
    return this.clone({ ...t, defaultToEN: !0 });
  }
  redefaultToSystem(t = {}) {
    return this.clone({ ...t, defaultToEN: !1 });
  }
  months(t, n = !1) {
    return is(this, t, xg, () => {
      const r = n ? { month: t, day: "numeric" } : { month: t }, a = n ? "format" : "standalone";
      return this.monthsCache[a][t] || (this.monthsCache[a][t] = bR((l) => this.extract(l, r, "month"))), this.monthsCache[a][t];
    });
  }
  weekdays(t, n = !1) {
    return is(this, t, Sg, () => {
      const r = n ? { weekday: t, year: "numeric", month: "long", day: "numeric" } : { weekday: t }, a = n ? "format" : "standalone";
      return this.weekdaysCache[a][t] || (this.weekdaysCache[a][t] = wR(
        (l) => this.extract(l, r, "weekday")
      )), this.weekdaysCache[a][t];
    });
  }
  meridiems() {
    return is(
      this,
      void 0,
      () => Pg,
      () => {
        if (!this.meridiemCache) {
          const t = { hour: "numeric", hourCycle: "h12" };
          this.meridiemCache = [et.utc(2016, 11, 13, 9), et.utc(2016, 11, 13, 19)].map(
            (n) => this.extract(n, t, "dayperiod")
          );
        }
        return this.meridiemCache;
      }
    );
  }
  eras(t) {
    return is(this, t, Cg, () => {
      const n = { era: t };
      return this.eraCache[t] || (this.eraCache[t] = [et.utc(-40, 1, 1), et.utc(2017, 1, 1)].map(
        (r) => this.extract(r, n, "era")
      )), this.eraCache[t];
    });
  }
  extract(t, n, r) {
    const a = this.dtFormatter(t, n), l = a.formatToParts(), u = l.find((h) => h.type.toLowerCase() === r);
    return u ? u.value : null;
  }
  numberFormatter(t = {}) {
    return new xR(this.intl, t.forceSimple || this.fastNumbers, t);
  }
  dtFormatter(t, n = {}) {
    return new LR(t, this.intl, n);
  }
  relFormatter(t = {}) {
    return new MR(this.intl, this.isEnglish(), t);
  }
  listFormatter(t = {}) {
    return fR(this.intl, t);
  }
  isEnglish() {
    return this.locale === "en" || this.locale.toLowerCase() === "en-us" || new Intl.DateTimeFormat(this.intl).resolvedOptions().locale.startsWith("en-us");
  }
  getWeekSettings() {
    return this.weekSettings ? this.weekSettings : yg() ? vR(this.locale) : SR;
  }
  getStartOfWeek() {
    return this.getWeekSettings().firstDay;
  }
  getMinDaysInFirstWeek() {
    return this.getWeekSettings().minimalDays;
  }
  getWeekendDays() {
    return this.getWeekSettings().weekend;
  }
  equals(t) {
    return this.locale === t.locale && this.numberingSystem === t.numberingSystem && this.outputCalendar === t.outputCalendar;
  }
}
let $l = null;
class Sn extends Mo {
  /**
   * Get a singleton instance of UTC
   * @return {FixedOffsetZone}
   */
  static get utcInstance() {
    return $l === null && ($l = new Sn(0)), $l;
  }
  /**
   * Get an instance with a specified offset
   * @param {number} offset - The offset in minutes
   * @return {FixedOffsetZone}
   */
  static instance(t) {
    return t === 0 ? Sn.utcInstance : new Sn(t);
  }
  /**
   * Get an instance of FixedOffsetZone from a UTC offset string, like "UTC+6"
   * @param {string} s - The offset string to parse
   * @example FixedOffsetZone.parseSpecifier("UTC+6")
   * @example FixedOffsetZone.parseSpecifier("UTC+06")
   * @example FixedOffsetZone.parseSpecifier("UTC-6:00")
   * @return {FixedOffsetZone}
   */
  static parseSpecifier(t) {
    if (t) {
      const n = t.match(/^utc(?:([+-]\d{1,2})(?::(\d{2}))?)?$/i);
      if (n)
        return new Sn(ll(n[1], n[2]));
    }
    return null;
  }
  constructor(t) {
    super(), this.fixed = t;
  }
  /** @override **/
  get type() {
    return "fixed";
  }
  /** @override **/
  get name() {
    return this.fixed === 0 ? "UTC" : `UTC${ro(this.fixed, "narrow")}`;
  }
  get ianaName() {
    return this.fixed === 0 ? "Etc/UTC" : `Etc/GMT${ro(-this.fixed, "narrow")}`;
  }
  /** @override **/
  offsetName() {
    return this.name;
  }
  /** @override **/
  formatOffset(t, n) {
    return ro(this.fixed, n);
  }
  /** @override **/
  get isUniversal() {
    return !0;
  }
  /** @override **/
  offset() {
    return this.fixed;
  }
  /** @override **/
  equals(t) {
    return t.type === "fixed" && t.fixed === this.fixed;
  }
  /** @override **/
  get isValid() {
    return !0;
  }
}
class PR extends Mo {
  constructor(t) {
    super(), this.zoneName = t;
  }
  /** @override **/
  get type() {
    return "invalid";
  }
  /** @override **/
  get name() {
    return this.zoneName;
  }
  /** @override **/
  get isUniversal() {
    return !1;
  }
  /** @override **/
  offsetName() {
    return null;
  }
  /** @override **/
  formatOffset() {
    return "";
  }
  /** @override **/
  offset() {
    return NaN;
  }
  /** @override **/
  equals() {
    return !1;
  }
  /** @override **/
  get isValid() {
    return !1;
  }
}
function ar(e, t) {
  if (rt(e) || e === null)
    return t;
  if (e instanceof Mo)
    return e;
  if (ER(e)) {
    const n = e.toLowerCase();
    return n === "default" ? t : n === "local" || n === "system" ? al.instance : n === "utc" || n === "gmt" ? Sn.utcInstance : Sn.parseSpecifier(n) || Ai.create(e);
  } else
    return Pr(e) ? Sn.instance(e) : typeof e == "object" && "offset" in e && typeof e.offset == "function" ? e : new PR(e);
}
let Hd = () => Date.now(), Ud = "system", Zd = null, Wd = null, Gd = null, qd = 60, Kd, Jd = null;
class en {
  /**
   * Get the callback for returning the current timestamp.
   * @type {function}
   */
  static get now() {
    return Hd;
  }
  /**
   * Set the callback for returning the current timestamp.
   * The function should return a number, which will be interpreted as an Epoch millisecond count
   * @type {function}
   * @example Settings.now = () => Date.now() + 3000 // pretend it is 3 seconds in the future
   * @example Settings.now = () => 0 // always pretend it's Jan 1, 1970 at midnight in UTC time
   */
  static set now(t) {
    Hd = t;
  }
  /**
   * Set the default time zone to create DateTimes in. Does not affect existing instances.
   * Use the value "system" to reset this value to the system's time zone.
   * @type {string}
   */
  static set defaultZone(t) {
    Ud = t;
  }
  /**
   * Get the default time zone object currently used to create DateTimes. Does not affect existing instances.
   * The default value is the system's time zone (the one set on the machine that runs this code).
   * @type {Zone}
   */
  static get defaultZone() {
    return ar(Ud, al.instance);
  }
  /**
   * Get the default locale to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultLocale() {
    return Zd;
  }
  /**
   * Set the default locale to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultLocale(t) {
    Zd = t;
  }
  /**
   * Get the default numbering system to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultNumberingSystem() {
    return Wd;
  }
  /**
   * Set the default numbering system to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultNumberingSystem(t) {
    Wd = t;
  }
  /**
   * Get the default output calendar to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultOutputCalendar() {
    return Gd;
  }
  /**
   * Set the default output calendar to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultOutputCalendar(t) {
    Gd = t;
  }
  /**
   * @typedef {Object} WeekSettings
   * @property {number} firstDay
   * @property {number} minimalDays
   * @property {number[]} weekend
   */
  /**
   * @return {WeekSettings|null}
   */
  static get defaultWeekSettings() {
    return Jd;
  }
  /**
   * Allows overriding the default locale week settings, i.e. the start of the week, the weekend and
   * how many days are required in the first week of a year.
   * Does not affect existing instances.
   *
   * @param {WeekSettings|null} weekSettings
   */
  static set defaultWeekSettings(t) {
    Jd = du(t);
  }
  /**
   * Get the cutoff year after which a string encoding a year as two digits is interpreted to occur in the current century.
   * @type {number}
   */
  static get twoDigitCutoffYear() {
    return qd;
  }
  /**
   * Set the cutoff year after which a string encoding a year as two digits is interpreted to occur in the current century.
   * @type {number}
   * @example Settings.twoDigitCutoffYear = 0 // cut-off year is 0, so all 'yy' are interpreted as current century
   * @example Settings.twoDigitCutoffYear = 50 // '49' -> 1949; '50' -> 2050
   * @example Settings.twoDigitCutoffYear = 1950 // interpreted as 50
   * @example Settings.twoDigitCutoffYear = 2050 // ALSO interpreted as 50
   */
  static set twoDigitCutoffYear(t) {
    qd = t % 100;
  }
  /**
   * Get whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
   * @type {boolean}
   */
  static get throwOnInvalid() {
    return Kd;
  }
  /**
   * Set whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
   * @type {boolean}
   */
  static set throwOnInvalid(t) {
    Kd = t;
  }
  /**
   * Reset Luxon's global caches. Should only be necessary in testing scenarios.
   * @return {void}
   */
  static resetCaches() {
    $t.resetCache(), Ai.resetCache();
  }
}
class Xn {
  constructor(t, n) {
    this.reason = t, this.explanation = n;
  }
  toMessage() {
    return this.explanation ? `${this.reason}: ${this.explanation}` : this.reason;
  }
}
const dg = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334], fg = [0, 31, 60, 91, 121, 152, 182, 213, 244, 274, 305, 335];
function Nn(e, t) {
  return new Xn(
    "unit out of range",
    `you specified ${t} (of type ${typeof t}) as a ${e}, which is invalid`
  );
}
function ic(e, t, n) {
  const r = new Date(Date.UTC(e, t - 1, n));
  e < 100 && e >= 0 && r.setUTCFullYear(r.getUTCFullYear() - 1900);
  const a = r.getUTCDay();
  return a === 0 ? 7 : a;
}
function pg(e, t, n) {
  return n + (So(e) ? fg : dg)[t - 1];
}
function mg(e, t) {
  const n = So(e) ? fg : dg, r = n.findIndex((l) => l < t), a = t - n[r];
  return { month: r + 1, day: a };
}
function rc(e, t) {
  return (e - t + 7) % 7 + 1;
}
function Vs(e, t = 4, n = 1) {
  const { year: r, month: a, day: l } = e, u = pg(r, a, l), h = rc(ic(r, a, l), n);
  let f = Math.floor((u - h + 14 - t) / 7), m;
  return f < 1 ? (m = r - 1, f = vo(m, t, n)) : f > vo(r, t, n) ? (m = r + 1, f = 1) : m = r, { weekYear: m, weekNumber: f, weekday: h, ...ul(e) };
}
function Xd(e, t = 4, n = 1) {
  const { weekYear: r, weekNumber: a, weekday: l } = e, u = rc(ic(r, 1, t), n), h = da(r);
  let f = a * 7 + l - u - 7 + t, m;
  f < 1 ? (m = r - 1, f += da(m)) : f > h ? (m = r + 1, f -= da(r)) : m = r;
  const { month: v, day: y } = mg(m, f);
  return { year: m, month: v, day: y, ...ul(e) };
}
function Nl(e) {
  const { year: t, month: n, day: r } = e, a = pg(t, n, r);
  return { year: t, ordinal: a, ...ul(e) };
}
function Qd(e) {
  const { year: t, ordinal: n } = e, { month: r, day: a } = mg(t, n);
  return { year: t, month: r, day: a, ...ul(e) };
}
function ef(e, t) {
  if (!rt(e.localWeekday) || !rt(e.localWeekNumber) || !rt(e.localWeekYear)) {
    if (!rt(e.weekday) || !rt(e.weekNumber) || !rt(e.weekYear))
      throw new sa(
        "Cannot mix locale-based week fields with ISO-based week fields"
      );
    return rt(e.localWeekday) || (e.weekday = e.localWeekday), rt(e.localWeekNumber) || (e.weekNumber = e.localWeekNumber), rt(e.localWeekYear) || (e.weekYear = e.localWeekYear), delete e.localWeekday, delete e.localWeekNumber, delete e.localWeekYear, {
      minDaysInFirstWeek: t.getMinDaysInFirstWeek(),
      startOfWeek: t.getStartOfWeek()
    };
  } else
    return { minDaysInFirstWeek: 4, startOfWeek: 1 };
}
function CR(e, t = 4, n = 1) {
  const r = ol(e.weekYear), a = zn(
    e.weekNumber,
    1,
    vo(e.weekYear, t, n)
  ), l = zn(e.weekday, 1, 7);
  return r ? a ? l ? !1 : Nn("weekday", e.weekday) : Nn("week", e.weekNumber) : Nn("weekYear", e.weekYear);
}
function OR(e) {
  const t = ol(e.year), n = zn(e.ordinal, 1, da(e.year));
  return t ? n ? !1 : Nn("ordinal", e.ordinal) : Nn("year", e.year);
}
function gg(e) {
  const t = ol(e.year), n = zn(e.month, 1, 12), r = zn(e.day, 1, Ys(e.year, e.month));
  return t ? n ? r ? !1 : Nn("day", e.day) : Nn("month", e.month) : Nn("year", e.year);
}
function vg(e) {
  const { hour: t, minute: n, second: r, millisecond: a } = e, l = zn(t, 0, 23) || t === 24 && n === 0 && r === 0 && a === 0, u = zn(n, 0, 59), h = zn(r, 0, 59), f = zn(a, 0, 999);
  return l ? u ? h ? f ? !1 : Nn("millisecond", a) : Nn("second", r) : Nn("minute", n) : Nn("hour", t);
}
function rt(e) {
  return typeof e > "u";
}
function Pr(e) {
  return typeof e == "number";
}
function ol(e) {
  return typeof e == "number" && e % 1 === 0;
}
function ER(e) {
  return typeof e == "string";
}
function TR(e) {
  return Object.prototype.toString.call(e) === "[object Date]";
}
function _g() {
  try {
    return typeof Intl < "u" && !!Intl.RelativeTimeFormat;
  } catch {
    return !1;
  }
}
function yg() {
  try {
    return typeof Intl < "u" && !!Intl.Locale && ("weekInfo" in Intl.Locale.prototype || "getWeekInfo" in Intl.Locale.prototype);
  } catch {
    return !1;
  }
}
function DR(e) {
  return Array.isArray(e) ? e : [e];
}
function tf(e, t, n) {
  if (e.length !== 0)
    return e.reduce((r, a) => {
      const l = [t(a), a];
      return r && n(r[0], l[0]) === r[0] ? r : l;
    }, null)[1];
}
function IR(e, t) {
  return t.reduce((n, r) => (n[r] = e[r], n), {});
}
function _a(e, t) {
  return Object.prototype.hasOwnProperty.call(e, t);
}
function du(e) {
  if (e == null)
    return null;
  if (typeof e != "object")
    throw new On("Week settings must be an object");
  if (!zn(e.firstDay, 1, 7) || !zn(e.minimalDays, 1, 7) || !Array.isArray(e.weekend) || e.weekend.some((t) => !zn(t, 1, 7)))
    throw new On("Invalid week settings");
  return {
    firstDay: e.firstDay,
    minimalDays: e.minimalDays,
    weekend: Array.from(e.weekend)
  };
}
function zn(e, t, n) {
  return ol(e) && e >= t && e <= n;
}
function AR(e, t) {
  return e - t * Math.floor(e / t);
}
function un(e, t = 2) {
  const n = e < 0;
  let r;
  return n ? r = "-" + ("" + -e).padStart(t, "0") : r = ("" + e).padStart(t, "0"), r;
}
function nr(e) {
  if (!(rt(e) || e === null || e === ""))
    return parseInt(e, 10);
}
function br(e) {
  if (!(rt(e) || e === null || e === ""))
    return parseFloat(e);
}
function ac(e) {
  if (!(rt(e) || e === null || e === "")) {
    const t = parseFloat("0." + e) * 1e3;
    return Math.floor(t);
  }
}
function oc(e, t, n = !1) {
  const r = 10 ** t;
  return (n ? Math.trunc : Math.round)(e * r) / r;
}
function So(e) {
  return e % 4 === 0 && (e % 100 !== 0 || e % 400 === 0);
}
function da(e) {
  return So(e) ? 366 : 365;
}
function Ys(e, t) {
  const n = AR(t - 1, 12) + 1, r = e + (t - n) / 12;
  return n === 2 ? So(r) ? 29 : 28 : [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][n - 1];
}
function sl(e) {
  let t = Date.UTC(
    e.year,
    e.month - 1,
    e.day,
    e.hour,
    e.minute,
    e.second,
    e.millisecond
  );
  return e.year < 100 && e.year >= 0 && (t = new Date(t), t.setUTCFullYear(e.year, e.month - 1, e.day)), +t;
}
function nf(e, t, n) {
  return -rc(ic(e, 1, t), n) + t - 1;
}
function vo(e, t = 4, n = 1) {
  const r = nf(e, t, n), a = nf(e + 1, t, n);
  return (da(e) - r + a) / 7;
}
function fu(e) {
  return e > 99 ? e : e > en.twoDigitCutoffYear ? 1900 + e : 2e3 + e;
}
function bg(e, t, n, r = null) {
  const a = new Date(e), l = {
    hourCycle: "h23",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit"
  };
  r && (l.timeZone = r);
  const u = { timeZoneName: t, ...l }, h = new Intl.DateTimeFormat(n, u).formatToParts(a).find((f) => f.type.toLowerCase() === "timezonename");
  return h ? h.value : null;
}
function ll(e, t) {
  let n = parseInt(e, 10);
  Number.isNaN(n) && (n = 0);
  const r = parseInt(t, 10) || 0, a = n < 0 || Object.is(n, -0) ? -r : r;
  return n * 60 + a;
}
function wg(e) {
  const t = Number(e);
  if (typeof e == "boolean" || e === "" || Number.isNaN(t))
    throw new On(`Invalid unit value ${e}`);
  return t;
}
function Hs(e, t) {
  const n = {};
  for (const r in e)
    if (_a(e, r)) {
      const a = e[r];
      if (a == null)
        continue;
      n[t(r)] = wg(a);
    }
  return n;
}
function ro(e, t) {
  const n = Math.trunc(Math.abs(e / 60)), r = Math.trunc(Math.abs(e % 60)), a = e >= 0 ? "+" : "-";
  switch (t) {
    case "short":
      return `${a}${un(n, 2)}:${un(r, 2)}`;
    case "narrow":
      return `${a}${n}${r > 0 ? `:${r}` : ""}`;
    case "techie":
      return `${a}${un(n, 2)}${un(r, 2)}`;
    default:
      throw new RangeError(`Value format ${t} is out of range for property format`);
  }
}
function ul(e) {
  return IR(e, ["hour", "minute", "second", "millisecond"]);
}
const RR = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
], kg = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
], BR = ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"];
function xg(e) {
  switch (e) {
    case "narrow":
      return [...BR];
    case "short":
      return [...kg];
    case "long":
      return [...RR];
    case "numeric":
      return ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];
    case "2-digit":
      return ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
    default:
      return null;
  }
}
const Lg = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday"
], Mg = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"], $R = ["M", "T", "W", "T", "F", "S", "S"];
function Sg(e) {
  switch (e) {
    case "narrow":
      return [...$R];
    case "short":
      return [...Mg];
    case "long":
      return [...Lg];
    case "numeric":
      return ["1", "2", "3", "4", "5", "6", "7"];
    default:
      return null;
  }
}
const Pg = ["AM", "PM"], NR = ["Before Christ", "Anno Domini"], zR = ["BC", "AD"], FR = ["B", "A"];
function Cg(e) {
  switch (e) {
    case "narrow":
      return [...FR];
    case "short":
      return [...zR];
    case "long":
      return [...NR];
    default:
      return null;
  }
}
function jR(e) {
  return Pg[e.hour < 12 ? 0 : 1];
}
function VR(e, t) {
  return Sg(t)[e.weekday - 1];
}
function YR(e, t) {
  return xg(t)[e.month - 1];
}
function HR(e, t) {
  return Cg(t)[e.year < 0 ? 0 : 1];
}
function UR(e, t, n = "always", r = !1) {
  const a = {
    years: ["year", "yr."],
    quarters: ["quarter", "qtr."],
    months: ["month", "mo."],
    weeks: ["week", "wk."],
    days: ["day", "day", "days"],
    hours: ["hour", "hr."],
    minutes: ["minute", "min."],
    seconds: ["second", "sec."]
  }, l = ["hours", "minutes", "seconds"].indexOf(e) === -1;
  if (n === "auto" && l) {
    const y = e === "days";
    switch (t) {
      case 1:
        return y ? "tomorrow" : `next ${a[e][0]}`;
      case -1:
        return y ? "yesterday" : `last ${a[e][0]}`;
      case 0:
        return y ? "today" : `this ${a[e][0]}`;
    }
  }
  const u = Object.is(t, -0) || t < 0, h = Math.abs(t), f = h === 1, m = a[e], v = r ? f ? m[1] : m[2] || m[1] : f ? a[e][0] : e;
  return u ? `${h} ${v} ago` : `in ${h} ${v}`;
}
function rf(e, t) {
  let n = "";
  for (const r of e)
    r.literal ? n += r.val : n += t(r.val);
  return n;
}
const ZR = {
  D: js,
  DD: Wm,
  DDD: Gm,
  DDDD: qm,
  t: Km,
  tt: Jm,
  ttt: Xm,
  tttt: Qm,
  T: eg,
  TT: tg,
  TTT: ng,
  TTTT: ig,
  f: rg,
  ff: og,
  fff: lg,
  ffff: cg,
  F: ag,
  FF: sg,
  FFF: ug,
  FFFF: hg
};
class _n {
  static create(t, n = {}) {
    return new _n(t, n);
  }
  static parseFormat(t) {
    let n = null, r = "", a = !1;
    const l = [];
    for (let u = 0; u < t.length; u++) {
      const h = t.charAt(u);
      h === "'" ? (r.length > 0 && l.push({ literal: a || /^\s+$/.test(r), val: r }), n = null, r = "", a = !a) : a || h === n ? r += h : (r.length > 0 && l.push({ literal: /^\s+$/.test(r), val: r }), r = h, n = h);
    }
    return r.length > 0 && l.push({ literal: a || /^\s+$/.test(r), val: r }), l;
  }
  static macroTokenToFormatOpts(t) {
    return ZR[t];
  }
  constructor(t, n) {
    this.opts = n, this.loc = t, this.systemLoc = null;
  }
  formatWithSystemDefault(t, n) {
    return this.systemLoc === null && (this.systemLoc = this.loc.redefaultToSystem()), this.systemLoc.dtFormatter(t, { ...this.opts, ...n }).format();
  }
  dtFormatter(t, n = {}) {
    return this.loc.dtFormatter(t, { ...this.opts, ...n });
  }
  formatDateTime(t, n) {
    return this.dtFormatter(t, n).format();
  }
  formatDateTimeParts(t, n) {
    return this.dtFormatter(t, n).formatToParts();
  }
  formatInterval(t, n) {
    return this.dtFormatter(t.start, n).dtf.formatRange(t.start.toJSDate(), t.end.toJSDate());
  }
  resolvedOptions(t, n) {
    return this.dtFormatter(t, n).resolvedOptions();
  }
  num(t, n = 0) {
    if (this.opts.forceSimple)
      return un(t, n);
    const r = { ...this.opts };
    return n > 0 && (r.padTo = n), this.loc.numberFormatter(r).format(t);
  }
  formatDateTimeFromString(t, n) {
    const r = this.loc.listingMode() === "en", a = this.loc.outputCalendar && this.loc.outputCalendar !== "gregory", l = (x, M) => this.loc.extract(t, x, M), u = (x) => t.isOffsetFixed && t.offset === 0 && x.allowZ ? "Z" : t.isValid ? t.zone.formatOffset(t.ts, x.format) : "", h = () => r ? jR(t) : l({ hour: "numeric", hourCycle: "h12" }, "dayperiod"), f = (x, M) => r ? YR(t, x) : l(M ? { month: x } : { month: x, day: "numeric" }, "month"), m = (x, M) => r ? VR(t, x) : l(
      M ? { weekday: x } : { weekday: x, month: "long", day: "numeric" },
      "weekday"
    ), v = (x) => {
      const M = _n.macroTokenToFormatOpts(x);
      return M ? this.formatWithSystemDefault(t, M) : x;
    }, y = (x) => r ? HR(t, x) : l({ era: x }, "era"), k = (x) => {
      switch (x) {
        case "S":
          return this.num(t.millisecond);
        case "u":
        case "SSS":
          return this.num(t.millisecond, 3);
        case "s":
          return this.num(t.second);
        case "ss":
          return this.num(t.second, 2);
        case "uu":
          return this.num(Math.floor(t.millisecond / 10), 2);
        case "uuu":
          return this.num(Math.floor(t.millisecond / 100));
        case "m":
          return this.num(t.minute);
        case "mm":
          return this.num(t.minute, 2);
        case "h":
          return this.num(t.hour % 12 === 0 ? 12 : t.hour % 12);
        case "hh":
          return this.num(t.hour % 12 === 0 ? 12 : t.hour % 12, 2);
        case "H":
          return this.num(t.hour);
        case "HH":
          return this.num(t.hour, 2);
        case "Z":
          return u({ format: "narrow", allowZ: this.opts.allowZ });
        case "ZZ":
          return u({ format: "short", allowZ: this.opts.allowZ });
        case "ZZZ":
          return u({ format: "techie", allowZ: this.opts.allowZ });
        case "ZZZZ":
          return t.zone.offsetName(t.ts, { format: "short", locale: this.loc.locale });
        case "ZZZZZ":
          return t.zone.offsetName(t.ts, { format: "long", locale: this.loc.locale });
        case "z":
          return t.zoneName;
        case "a":
          return h();
        case "d":
          return a ? l({ day: "numeric" }, "day") : this.num(t.day);
        case "dd":
          return a ? l({ day: "2-digit" }, "day") : this.num(t.day, 2);
        case "c":
          return this.num(t.weekday);
        case "ccc":
          return m("short", !0);
        case "cccc":
          return m("long", !0);
        case "ccccc":
          return m("narrow", !0);
        case "E":
          return this.num(t.weekday);
        case "EEE":
          return m("short", !1);
        case "EEEE":
          return m("long", !1);
        case "EEEEE":
          return m("narrow", !1);
        case "L":
          return a ? l({ month: "numeric", day: "numeric" }, "month") : this.num(t.month);
        case "LL":
          return a ? l({ month: "2-digit", day: "numeric" }, "month") : this.num(t.month, 2);
        case "LLL":
          return f("short", !0);
        case "LLLL":
          return f("long", !0);
        case "LLLLL":
          return f("narrow", !0);
        case "M":
          return a ? l({ month: "numeric" }, "month") : this.num(t.month);
        case "MM":
          return a ? l({ month: "2-digit" }, "month") : this.num(t.month, 2);
        case "MMM":
          return f("short", !1);
        case "MMMM":
          return f("long", !1);
        case "MMMMM":
          return f("narrow", !1);
        case "y":
          return a ? l({ year: "numeric" }, "year") : this.num(t.year);
        case "yy":
          return a ? l({ year: "2-digit" }, "year") : this.num(t.year.toString().slice(-2), 2);
        case "yyyy":
          return a ? l({ year: "numeric" }, "year") : this.num(t.year, 4);
        case "yyyyyy":
          return a ? l({ year: "numeric" }, "year") : this.num(t.year, 6);
        case "G":
          return y("short");
        case "GG":
          return y("long");
        case "GGGGG":
          return y("narrow");
        case "kk":
          return this.num(t.weekYear.toString().slice(-2), 2);
        case "kkkk":
          return this.num(t.weekYear, 4);
        case "W":
          return this.num(t.weekNumber);
        case "WW":
          return this.num(t.weekNumber, 2);
        case "n":
          return this.num(t.localWeekNumber);
        case "nn":
          return this.num(t.localWeekNumber, 2);
        case "ii":
          return this.num(t.localWeekYear.toString().slice(-2), 2);
        case "iiii":
          return this.num(t.localWeekYear, 4);
        case "o":
          return this.num(t.ordinal);
        case "ooo":
          return this.num(t.ordinal, 3);
        case "q":
          return this.num(t.quarter);
        case "qq":
          return this.num(t.quarter, 2);
        case "X":
          return this.num(Math.floor(t.ts / 1e3));
        case "x":
          return this.num(t.ts);
        default:
          return v(x);
      }
    };
    return rf(_n.parseFormat(n), k);
  }
  formatDurationFromString(t, n) {
    const r = (f) => {
      switch (f[0]) {
        case "S":
          return "millisecond";
        case "s":
          return "second";
        case "m":
          return "minute";
        case "h":
          return "hour";
        case "d":
          return "day";
        case "w":
          return "week";
        case "M":
          return "month";
        case "y":
          return "year";
        default:
          return null;
      }
    }, a = (f) => (m) => {
      const v = r(m);
      return v ? this.num(f.get(v), m.length) : m;
    }, l = _n.parseFormat(n), u = l.reduce(
      (f, { literal: m, val: v }) => m ? f : f.concat(v),
      []
    ), h = t.shiftTo(...u.map(r).filter((f) => f));
    return rf(l, a(h));
  }
}
const Og = /[A-Za-z_+-]{1,256}(?::?\/[A-Za-z0-9_+-]{1,256}(?:\/[A-Za-z0-9_+-]{1,256})?)?/;
function Pa(...e) {
  const t = e.reduce((n, r) => n + r.source, "");
  return RegExp(`^${t}$`);
}
function Ca(...e) {
  return (t) => e.reduce(
    ([n, r, a], l) => {
      const [u, h, f] = l(t, a);
      return [{ ...n, ...u }, h || r, f];
    },
    [{}, null, 1]
  ).slice(0, 2);
}
function Oa(e, ...t) {
  if (e == null)
    return [null, null];
  for (const [n, r] of t) {
    const a = n.exec(e);
    if (a)
      return r(a);
  }
  return [null, null];
}
function Eg(...e) {
  return (t, n) => {
    const r = {};
    let a;
    for (a = 0; a < e.length; a++)
      r[e[a]] = nr(t[n + a]);
    return [r, null, n + a];
  };
}
const Tg = /(?:(Z)|([+-]\d\d)(?::?(\d\d))?)/, WR = `(?:${Tg.source}?(?:\\[(${Og.source})\\])?)?`, sc = /(\d\d)(?::?(\d\d)(?::?(\d\d)(?:[.,](\d{1,30}))?)?)?/, Dg = RegExp(`${sc.source}${WR}`), lc = RegExp(`(?:T${Dg.source})?`), GR = /([+-]\d{6}|\d{4})(?:-?(\d\d)(?:-?(\d\d))?)?/, qR = /(\d{4})-?W(\d\d)(?:-?(\d))?/, KR = /(\d{4})-?(\d{3})/, JR = Eg("weekYear", "weekNumber", "weekDay"), XR = Eg("year", "ordinal"), QR = /(\d{4})-(\d\d)-(\d\d)/, Ig = RegExp(
  `${sc.source} ?(?:${Tg.source}|(${Og.source}))?`
), eB = RegExp(`(?: ${Ig.source})?`);
function fa(e, t, n) {
  const r = e[t];
  return rt(r) ? n : nr(r);
}
function tB(e, t) {
  return [{
    year: fa(e, t),
    month: fa(e, t + 1, 1),
    day: fa(e, t + 2, 1)
  }, null, t + 3];
}
function Ea(e, t) {
  return [{
    hours: fa(e, t, 0),
    minutes: fa(e, t + 1, 0),
    seconds: fa(e, t + 2, 0),
    milliseconds: ac(e[t + 3])
  }, null, t + 4];
}
function Po(e, t) {
  const n = !e[t] && !e[t + 1], r = ll(e[t + 1], e[t + 2]), a = n ? null : Sn.instance(r);
  return [{}, a, t + 3];
}
function Co(e, t) {
  const n = e[t] ? Ai.create(e[t]) : null;
  return [{}, n, t + 1];
}
const nB = RegExp(`^T?${sc.source}$`), iB = /^-?P(?:(?:(-?\d{1,20}(?:\.\d{1,20})?)Y)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20}(?:\.\d{1,20})?)W)?(?:(-?\d{1,20}(?:\.\d{1,20})?)D)?(?:T(?:(-?\d{1,20}(?:\.\d{1,20})?)H)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20})(?:[.,](-?\d{1,20}))?S)?)?)$/;
function rB(e) {
  const [t, n, r, a, l, u, h, f, m] = e, v = t[0] === "-", y = f && f[0] === "-", k = (x, M = !1) => x !== void 0 && (M || x && v) ? -x : x;
  return [
    {
      years: k(br(n)),
      months: k(br(r)),
      weeks: k(br(a)),
      days: k(br(l)),
      hours: k(br(u)),
      minutes: k(br(h)),
      seconds: k(br(f), f === "-0"),
      milliseconds: k(ac(m), y)
    }
  ];
}
const aB = {
  GMT: 0,
  EDT: -4 * 60,
  EST: -5 * 60,
  CDT: -5 * 60,
  CST: -6 * 60,
  MDT: -6 * 60,
  MST: -7 * 60,
  PDT: -7 * 60,
  PST: -8 * 60
};
function uc(e, t, n, r, a, l, u) {
  const h = {
    year: t.length === 2 ? fu(nr(t)) : nr(t),
    month: kg.indexOf(n) + 1,
    day: nr(r),
    hour: nr(a),
    minute: nr(l)
  };
  return u && (h.second = nr(u)), e && (h.weekday = e.length > 3 ? Lg.indexOf(e) + 1 : Mg.indexOf(e) + 1), h;
}
const oB = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|(?:([+-]\d\d)(\d\d)))$/;
function sB(e) {
  const [
    ,
    t,
    n,
    r,
    a,
    l,
    u,
    h,
    f,
    m,
    v,
    y
  ] = e, k = uc(t, a, r, n, l, u, h);
  let x;
  return f ? x = aB[f] : m ? x = 0 : x = ll(v, y), [k, new Sn(x)];
}
function lB(e) {
  return e.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").trim();
}
const uB = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d\d) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d\d):(\d\d):(\d\d) GMT$/, cB = /^(Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday), (\d\d)-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d\d) (\d\d):(\d\d):(\d\d) GMT$/, hB = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( \d|\d\d) (\d\d):(\d\d):(\d\d) (\d{4})$/;
function af(e) {
  const [, t, n, r, a, l, u, h] = e;
  return [uc(t, a, r, n, l, u, h), Sn.utcInstance];
}
function dB(e) {
  const [, t, n, r, a, l, u, h] = e;
  return [uc(t, h, n, r, a, l, u), Sn.utcInstance];
}
const fB = Pa(GR, lc), pB = Pa(qR, lc), mB = Pa(KR, lc), gB = Pa(Dg), Ag = Ca(
  tB,
  Ea,
  Po,
  Co
), vB = Ca(
  JR,
  Ea,
  Po,
  Co
), _B = Ca(
  XR,
  Ea,
  Po,
  Co
), yB = Ca(
  Ea,
  Po,
  Co
);
function bB(e) {
  return Oa(
    e,
    [fB, Ag],
    [pB, vB],
    [mB, _B],
    [gB, yB]
  );
}
function wB(e) {
  return Oa(lB(e), [oB, sB]);
}
function kB(e) {
  return Oa(
    e,
    [uB, af],
    [cB, af],
    [hB, dB]
  );
}
function xB(e) {
  return Oa(e, [iB, rB]);
}
const LB = Ca(Ea);
function MB(e) {
  return Oa(e, [nB, LB]);
}
const SB = Pa(QR, eB), PB = Pa(Ig), CB = Ca(
  Ea,
  Po,
  Co
);
function OB(e) {
  return Oa(
    e,
    [SB, Ag],
    [PB, CB]
  );
}
const of = "Invalid Duration", Rg = {
  weeks: {
    days: 7,
    hours: 7 * 24,
    minutes: 7 * 24 * 60,
    seconds: 7 * 24 * 60 * 60,
    milliseconds: 7 * 24 * 60 * 60 * 1e3
  },
  days: {
    hours: 24,
    minutes: 24 * 60,
    seconds: 24 * 60 * 60,
    milliseconds: 24 * 60 * 60 * 1e3
  },
  hours: { minutes: 60, seconds: 60 * 60, milliseconds: 60 * 60 * 1e3 },
  minutes: { seconds: 60, milliseconds: 60 * 1e3 },
  seconds: { milliseconds: 1e3 }
}, EB = {
  years: {
    quarters: 4,
    months: 12,
    weeks: 52,
    days: 365,
    hours: 365 * 24,
    minutes: 365 * 24 * 60,
    seconds: 365 * 24 * 60 * 60,
    milliseconds: 365 * 24 * 60 * 60 * 1e3
  },
  quarters: {
    months: 3,
    weeks: 13,
    days: 91,
    hours: 91 * 24,
    minutes: 91 * 24 * 60,
    seconds: 91 * 24 * 60 * 60,
    milliseconds: 91 * 24 * 60 * 60 * 1e3
  },
  months: {
    weeks: 4,
    days: 30,
    hours: 30 * 24,
    minutes: 30 * 24 * 60,
    seconds: 30 * 24 * 60 * 60,
    milliseconds: 30 * 24 * 60 * 60 * 1e3
  },
  ...Rg
}, Bn = 146097 / 400, na = 146097 / 4800, TB = {
  years: {
    quarters: 4,
    months: 12,
    weeks: Bn / 7,
    days: Bn,
    hours: Bn * 24,
    minutes: Bn * 24 * 60,
    seconds: Bn * 24 * 60 * 60,
    milliseconds: Bn * 24 * 60 * 60 * 1e3
  },
  quarters: {
    months: 3,
    weeks: Bn / 28,
    days: Bn / 4,
    hours: Bn * 24 / 4,
    minutes: Bn * 24 * 60 / 4,
    seconds: Bn * 24 * 60 * 60 / 4,
    milliseconds: Bn * 24 * 60 * 60 * 1e3 / 4
  },
  months: {
    weeks: na / 7,
    days: na,
    hours: na * 24,
    minutes: na * 24 * 60,
    seconds: na * 24 * 60 * 60,
    milliseconds: na * 24 * 60 * 60 * 1e3
  },
  ...Rg
}, Mr = [
  "years",
  "quarters",
  "months",
  "weeks",
  "days",
  "hours",
  "minutes",
  "seconds",
  "milliseconds"
], DB = Mr.slice(0).reverse();
function er(e, t, n = !1) {
  const r = {
    values: n ? t.values : { ...e.values, ...t.values || {} },
    loc: e.loc.clone(t.loc),
    conversionAccuracy: t.conversionAccuracy || e.conversionAccuracy,
    matrix: t.matrix || e.matrix
  };
  return new Mt(r);
}
function Bg(e, t) {
  let n = t.milliseconds ?? 0;
  for (const r of DB.slice(1))
    t[r] && (n += t[r] * e[r].milliseconds);
  return n;
}
function sf(e, t) {
  const n = Bg(e, t) < 0 ? -1 : 1;
  Mr.reduceRight((r, a) => {
    if (rt(t[a]))
      return r;
    if (r) {
      const l = t[r] * n, u = e[a][r], h = Math.floor(l / u);
      t[a] += h * n, t[r] -= h * u * n;
    }
    return a;
  }, null), Mr.reduce((r, a) => {
    if (rt(t[a]))
      return r;
    if (r) {
      const l = t[r] % 1;
      t[r] -= l, t[a] += l * e[r][a];
    }
    return a;
  }, null);
}
function IB(e) {
  const t = {};
  for (const [n, r] of Object.entries(e))
    r !== 0 && (t[n] = r);
  return t;
}
class Mt {
  /**
   * @private
   */
  constructor(t) {
    const n = t.conversionAccuracy === "longterm" || !1;
    let r = n ? TB : EB;
    t.matrix && (r = t.matrix), this.values = t.values, this.loc = t.loc || $t.create(), this.conversionAccuracy = n ? "longterm" : "casual", this.invalid = t.invalid || null, this.matrix = r, this.isLuxonDuration = !0;
  }
  /**
   * Create Duration from a number of milliseconds.
   * @param {number} count of milliseconds
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */
  static fromMillis(t, n) {
    return Mt.fromObject({ milliseconds: t }, n);
  }
  /**
   * Create a Duration from a JavaScript object with keys like 'years' and 'hours'.
   * If this object is empty then a zero milliseconds duration is returned.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.years
   * @param {number} obj.quarters
   * @param {number} obj.months
   * @param {number} obj.weeks
   * @param {number} obj.days
   * @param {number} obj.hours
   * @param {number} obj.minutes
   * @param {number} obj.seconds
   * @param {number} obj.milliseconds
   * @param {Object} [opts=[]] - options for creating this Duration
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the custom conversion system to use
   * @return {Duration}
   */
  static fromObject(t, n = {}) {
    if (t == null || typeof t != "object")
      throw new On(
        `Duration.fromObject: argument expected to be an object, got ${t === null ? "null" : typeof t}`
      );
    return new Mt({
      values: Hs(t, Mt.normalizeUnit),
      loc: $t.fromObject(n),
      conversionAccuracy: n.conversionAccuracy,
      matrix: n.matrix
    });
  }
  /**
   * Create a Duration from DurationLike.
   *
   * @param {Object | number | Duration} durationLike
   * One of:
   * - object with keys like 'years' and 'hours'.
   * - number representing milliseconds
   * - Duration instance
   * @return {Duration}
   */
  static fromDurationLike(t) {
    if (Pr(t))
      return Mt.fromMillis(t);
    if (Mt.isDuration(t))
      return t;
    if (typeof t == "object")
      return Mt.fromObject(t);
    throw new On(
      `Unknown duration argument ${t} of type ${typeof t}`
    );
  }
  /**
   * Create a Duration from an ISO 8601 duration string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the preset conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromISO('P3Y6M1W4DT12H30M5S').toObject() //=> { years: 3, months: 6, weeks: 1, days: 4, hours: 12, minutes: 30, seconds: 5 }
   * @example Duration.fromISO('PT23H').toObject() //=> { hours: 23 }
   * @example Duration.fromISO('P5Y3M').toObject() //=> { years: 5, months: 3 }
   * @return {Duration}
   */
  static fromISO(t, n) {
    const [r] = xB(t);
    return r ? Mt.fromObject(r, n) : Mt.invalid("unparsable", `the input "${t}" can't be parsed as ISO 8601`);
  }
  /**
   * Create a Duration from an ISO 8601 time string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @example Duration.fromISOTime('11:22:33.444').toObject() //=> { hours: 11, minutes: 22, seconds: 33, milliseconds: 444 }
   * @example Duration.fromISOTime('11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @return {Duration}
   */
  static fromISOTime(t, n) {
    const [r] = MB(t);
    return r ? Mt.fromObject(r, n) : Mt.invalid("unparsable", `the input "${t}" can't be parsed as ISO 8601`);
  }
  /**
   * Create an invalid Duration.
   * @param {string} reason - simple string of why this datetime is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Duration}
   */
  static invalid(t, n = null) {
    if (!t)
      throw new On("need to specify a reason the Duration is invalid");
    const r = t instanceof Xn ? t : new Xn(t, n);
    if (en.throwOnInvalid)
      throw new oR(r);
    return new Mt({ invalid: r });
  }
  /**
   * @private
   */
  static normalizeUnit(t) {
    const n = {
      year: "years",
      years: "years",
      quarter: "quarters",
      quarters: "quarters",
      month: "months",
      months: "months",
      week: "weeks",
      weeks: "weeks",
      day: "days",
      days: "days",
      hour: "hours",
      hours: "hours",
      minute: "minutes",
      minutes: "minutes",
      second: "seconds",
      seconds: "seconds",
      millisecond: "milliseconds",
      milliseconds: "milliseconds"
    }[t && t.toLowerCase()];
    if (!n)
      throw new Zm(t);
    return n;
  }
  /**
   * Check if an object is a Duration. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isDuration(t) {
    return t && t.isLuxonDuration || !1;
  }
  /**
   * Get  the locale of a Duration, such 'en-GB'
   * @type {string}
   */
  get locale() {
    return this.isValid ? this.loc.locale : null;
  }
  /**
   * Get the numbering system of a Duration, such 'beng'. The numbering system is used when formatting the Duration
   *
   * @type {string}
   */
  get numberingSystem() {
    return this.isValid ? this.loc.numberingSystem : null;
  }
  /**
   * Returns a string representation of this Duration formatted according to the specified format string. You may use these tokens:
   * * `S` for milliseconds
   * * `s` for seconds
   * * `m` for minutes
   * * `h` for hours
   * * `d` for days
   * * `w` for weeks
   * * `M` for months
   * * `y` for years
   * Notes:
   * * Add padding by repeating the token, e.g. "yy" pads the years to two digits, "hhhh" pads the hours out to four digits
   * * Tokens can be escaped by wrapping with single quotes.
   * * The duration will be converted to the set of units in the format string using {@link Duration#shiftTo} and the Durations's conversion accuracy setting.
   * @param {string} fmt - the format string
   * @param {Object} opts - options
   * @param {boolean} [opts.floor=true] - floor numerical values
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("y d s") //=> "1 6 2"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("yy dd sss") //=> "01 06 002"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("M S") //=> "12 518402000"
   * @return {string}
   */
  toFormat(t, n = {}) {
    const r = {
      ...n,
      floor: n.round !== !1 && n.floor !== !1
    };
    return this.isValid ? _n.create(this.loc, r).formatDurationFromString(this, t) : of;
  }
  /**
   * Returns a string representation of a Duration with all units included.
   * To modify its behavior, use `listStyle` and any Intl.NumberFormat option, though `unitDisplay` is especially relevant.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat#options
   * @param {Object} opts - Formatting options. Accepts the same keys as the options parameter of the native `Intl.NumberFormat` constructor, as well as `listStyle`.
   * @param {string} [opts.listStyle='narrow'] - How to format the merged list. Corresponds to the `style` property of the options parameter of the native `Intl.ListFormat` constructor.
   * @example
   * ```js
   * var dur = Duration.fromObject({ days: 1, hours: 5, minutes: 6 })
   * dur.toHuman() //=> '1 day, 5 hours, 6 minutes'
   * dur.toHuman({ listStyle: "long" }) //=> '1 day, 5 hours, and 6 minutes'
   * dur.toHuman({ unitDisplay: "short" }) //=> '1 day, 5 hr, 6 min'
   * ```
   */
  toHuman(t = {}) {
    if (!this.isValid)
      return of;
    const n = Mr.map((r) => {
      const a = this.values[r];
      return rt(a) ? null : this.loc.numberFormatter({ style: "unit", unitDisplay: "long", ...t, unit: r.slice(0, -1) }).format(a);
    }).filter((r) => r);
    return this.loc.listFormatter({ type: "conjunction", style: t.listStyle || "narrow", ...t }).format(n);
  }
  /**
   * Returns a JavaScript object with this Duration's values.
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toObject() //=> { years: 1, days: 6, seconds: 2 }
   * @return {Object}
   */
  toObject() {
    return this.isValid ? { ...this.values } : {};
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Duration.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromObject({ years: 3, seconds: 45 }).toISO() //=> 'P3YT45S'
   * @example Duration.fromObject({ months: 4, seconds: 45 }).toISO() //=> 'P4MT45S'
   * @example Duration.fromObject({ months: 5 }).toISO() //=> 'P5M'
   * @example Duration.fromObject({ minutes: 5 }).toISO() //=> 'PT5M'
   * @example Duration.fromObject({ milliseconds: 6 }).toISO() //=> 'PT0.006S'
   * @return {string}
   */
  toISO() {
    if (!this.isValid)
      return null;
    let t = "P";
    return this.years !== 0 && (t += this.years + "Y"), (this.months !== 0 || this.quarters !== 0) && (t += this.months + this.quarters * 3 + "M"), this.weeks !== 0 && (t += this.weeks + "W"), this.days !== 0 && (t += this.days + "D"), (this.hours !== 0 || this.minutes !== 0 || this.seconds !== 0 || this.milliseconds !== 0) && (t += "T"), this.hours !== 0 && (t += this.hours + "H"), this.minutes !== 0 && (t += this.minutes + "M"), (this.seconds !== 0 || this.milliseconds !== 0) && (t += oc(this.seconds + this.milliseconds / 1e3, 3) + "S"), t === "P" && (t += "T0S"), t;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Duration, formatted as a time of day.
   * Note that this will return null if the duration is invalid, negative, or equal to or greater than 24 hours.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example Duration.fromObject({ hours: 11 }).toISOTime() //=> '11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressMilliseconds: true }) //=> '11:00:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressSeconds: true }) //=> '11:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ includePrefix: true }) //=> 'T11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ format: 'basic' }) //=> '110000.000'
   * @return {string}
   */
  toISOTime(t = {}) {
    if (!this.isValid)
      return null;
    const n = this.toMillis();
    return n < 0 || n >= 864e5 ? null : (t = {
      suppressMilliseconds: !1,
      suppressSeconds: !1,
      includePrefix: !1,
      format: "extended",
      ...t,
      includeOffset: !1
    }, et.fromMillis(n, { zone: "UTC" }).toISOTime(t));
  }
  /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in JSON.
   * @return {string}
   */
  toJSON() {
    return this.toISO();
  }
  /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in debugging.
   * @return {string}
   */
  toString() {
    return this.toISO();
  }
  /**
   * Returns a string representation of this Duration appropriate for the REPL.
   * @return {string}
   */
  [Symbol.for("nodejs.util.inspect.custom")]() {
    return this.isValid ? `Duration { values: ${JSON.stringify(this.values)} }` : `Duration { Invalid, reason: ${this.invalidReason} }`;
  }
  /**
   * Returns an milliseconds value of this Duration.
   * @return {number}
   */
  toMillis() {
    return this.isValid ? Bg(this.matrix, this.values) : NaN;
  }
  /**
   * Returns an milliseconds value of this Duration. Alias of {@link toMillis}
   * @return {number}
   */
  valueOf() {
    return this.toMillis();
  }
  /**
   * Make this Duration longer by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */
  plus(t) {
    if (!this.isValid)
      return this;
    const n = Mt.fromDurationLike(t), r = {};
    for (const a of Mr)
      (_a(n.values, a) || _a(this.values, a)) && (r[a] = n.get(a) + this.get(a));
    return er(this, { values: r }, !0);
  }
  /**
   * Make this Duration shorter by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */
  minus(t) {
    if (!this.isValid)
      return this;
    const n = Mt.fromDurationLike(t);
    return this.plus(n.negate());
  }
  /**
   * Scale this Duration by the specified amount. Return a newly-constructed Duration.
   * @param {function} fn - The function to apply to each unit. Arity is 1 or 2: the value of the unit and, optionally, the unit name. Must return a number.
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits(x => x * 2) //=> { hours: 2, minutes: 60 }
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits((x, u) => u === "hours" ? x * 2 : x) //=> { hours: 2, minutes: 30 }
   * @return {Duration}
   */
  mapUnits(t) {
    if (!this.isValid)
      return this;
    const n = {};
    for (const r of Object.keys(this.values))
      n[r] = wg(t(this.values[r], r));
    return er(this, { values: n }, !0);
  }
  /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example Duration.fromObject({years: 2, days: 3}).get('years') //=> 2
   * @example Duration.fromObject({years: 2, days: 3}).get('months') //=> 0
   * @example Duration.fromObject({years: 2, days: 3}).get('days') //=> 3
   * @return {number}
   */
  get(t) {
    return this[Mt.normalizeUnit(t)];
  }
  /**
   * "Set" the values of specified units. Return a newly-constructed Duration.
   * @param {Object} values - a mapping of units to numbers
   * @example dur.set({ years: 2017 })
   * @example dur.set({ hours: 8, minutes: 30 })
   * @return {Duration}
   */
  set(t) {
    if (!this.isValid)
      return this;
    const n = { ...this.values, ...Hs(t, Mt.normalizeUnit) };
    return er(this, { values: n });
  }
  /**
   * "Set" the locale and/or numberingSystem.  Returns a newly-constructed Duration.
   * @example dur.reconfigure({ locale: 'en-GB' })
   * @return {Duration}
   */
  reconfigure({ locale: t, numberingSystem: n, conversionAccuracy: r, matrix: a } = {}) {
    const u = { loc: this.loc.clone({ locale: t, numberingSystem: n }), matrix: a, conversionAccuracy: r };
    return er(this, u);
  }
  /**
   * Return the length of the duration in the specified unit.
   * @param {string} unit - a unit such as 'minutes' or 'days'
   * @example Duration.fromObject({years: 1}).as('days') //=> 365
   * @example Duration.fromObject({years: 1}).as('months') //=> 12
   * @example Duration.fromObject({hours: 60}).as('days') //=> 2.5
   * @return {number}
   */
  as(t) {
    return this.isValid ? this.shiftTo(t).get(t) : NaN;
  }
  /**
   * Reduce this Duration to its canonical representation in its current units.
   * Assuming the overall value of the Duration is positive, this means:
   * - excessive values for lower-order units are converted to higher-order units (if possible, see first and second example)
   * - negative lower-order units are converted to higher order units (there must be such a higher order unit, otherwise
   *   the overall value would be negative, see third example)
   * - fractional values for higher-order units are converted to lower-order units (if possible, see fourth example)
   *
   * If the overall value is negative, the result of this method is equivalent to `this.negate().normalize().negate()`.
   * @example Duration.fromObject({ years: 2, days: 5000 }).normalize().toObject() //=> { years: 15, days: 255 }
   * @example Duration.fromObject({ days: 5000 }).normalize().toObject() //=> { days: 5000 }
   * @example Duration.fromObject({ hours: 12, minutes: -45 }).normalize().toObject() //=> { hours: 11, minutes: 15 }
   * @example Duration.fromObject({ years: 2.5, days: 0, hours: 0 }).normalize().toObject() //=> { years: 2, days: 182, hours: 12 }
   * @return {Duration}
   */
  normalize() {
    if (!this.isValid)
      return this;
    const t = this.toObject();
    return sf(this.matrix, t), er(this, { values: t }, !0);
  }
  /**
   * Rescale units to its largest representation
   * @example Duration.fromObject({ milliseconds: 90000 }).rescale().toObject() //=> { minutes: 1, seconds: 30 }
   * @return {Duration}
   */
  rescale() {
    if (!this.isValid)
      return this;
    const t = IB(this.normalize().shiftToAll().toObject());
    return er(this, { values: t }, !0);
  }
  /**
   * Convert this Duration into its representation in a different set of units.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).shiftTo('minutes', 'milliseconds').toObject() //=> { minutes: 60, milliseconds: 30000 }
   * @return {Duration}
   */
  shiftTo(...t) {
    if (!this.isValid)
      return this;
    if (t.length === 0)
      return this;
    t = t.map((u) => Mt.normalizeUnit(u));
    const n = {}, r = {}, a = this.toObject();
    let l;
    for (const u of Mr)
      if (t.indexOf(u) >= 0) {
        l = u;
        let h = 0;
        for (const m in r)
          h += this.matrix[m][u] * r[m], r[m] = 0;
        Pr(a[u]) && (h += a[u]);
        const f = Math.trunc(h);
        n[u] = f, r[u] = (h * 1e3 - f * 1e3) / 1e3;
      } else
        Pr(a[u]) && (r[u] = a[u]);
    for (const u in r)
      r[u] !== 0 && (n[l] += u === l ? r[u] : r[u] / this.matrix[l][u]);
    return sf(this.matrix, n), er(this, { values: n }, !0);
  }
  /**
   * Shift this Duration to all available units.
   * Same as shiftTo("years", "months", "weeks", "days", "hours", "minutes", "seconds", "milliseconds")
   * @return {Duration}
   */
  shiftToAll() {
    return this.isValid ? this.shiftTo(
      "years",
      "months",
      "weeks",
      "days",
      "hours",
      "minutes",
      "seconds",
      "milliseconds"
    ) : this;
  }
  /**
   * Return the negative of this Duration.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).negate().toObject() //=> { hours: -1, seconds: -30 }
   * @return {Duration}
   */
  negate() {
    if (!this.isValid)
      return this;
    const t = {};
    for (const n of Object.keys(this.values))
      t[n] = this.values[n] === 0 ? 0 : -this.values[n];
    return er(this, { values: t }, !0);
  }
  /**
   * Get the years.
   * @type {number}
   */
  get years() {
    return this.isValid ? this.values.years || 0 : NaN;
  }
  /**
   * Get the quarters.
   * @type {number}
   */
  get quarters() {
    return this.isValid ? this.values.quarters || 0 : NaN;
  }
  /**
   * Get the months.
   * @type {number}
   */
  get months() {
    return this.isValid ? this.values.months || 0 : NaN;
  }
  /**
   * Get the weeks
   * @type {number}
   */
  get weeks() {
    return this.isValid ? this.values.weeks || 0 : NaN;
  }
  /**
   * Get the days.
   * @type {number}
   */
  get days() {
    return this.isValid ? this.values.days || 0 : NaN;
  }
  /**
   * Get the hours.
   * @type {number}
   */
  get hours() {
    return this.isValid ? this.values.hours || 0 : NaN;
  }
  /**
   * Get the minutes.
   * @type {number}
   */
  get minutes() {
    return this.isValid ? this.values.minutes || 0 : NaN;
  }
  /**
   * Get the seconds.
   * @return {number}
   */
  get seconds() {
    return this.isValid ? this.values.seconds || 0 : NaN;
  }
  /**
   * Get the milliseconds.
   * @return {number}
   */
  get milliseconds() {
    return this.isValid ? this.values.milliseconds || 0 : NaN;
  }
  /**
   * Returns whether the Duration is invalid. Invalid durations are returned by diff operations
   * on invalid DateTimes or Intervals.
   * @return {boolean}
   */
  get isValid() {
    return this.invalid === null;
  }
  /**
   * Returns an error code if this Duration became invalid, or null if the Duration is valid
   * @return {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
   * Returns an explanation of why this Duration became invalid, or null if the Duration is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
   * Equality check
   * Two Durations are equal iff they have the same units and the same values for each unit.
   * @param {Duration} other
   * @return {boolean}
   */
  equals(t) {
    if (!this.isValid || !t.isValid || !this.loc.equals(t.loc))
      return !1;
    function n(r, a) {
      return r === void 0 || r === 0 ? a === void 0 || a === 0 : r === a;
    }
    for (const r of Mr)
      if (!n(this.values[r], t.values[r]))
        return !1;
    return !0;
  }
}
const ia = "Invalid Interval";
function AB(e, t) {
  return !e || !e.isValid ? Jt.invalid("missing or invalid start") : !t || !t.isValid ? Jt.invalid("missing or invalid end") : t < e ? Jt.invalid(
    "end before start",
    `The end of an interval must be after its start, but you had start=${e.toISO()} and end=${t.toISO()}`
  ) : null;
}
class Jt {
  /**
   * @private
   */
  constructor(t) {
    this.s = t.start, this.e = t.end, this.invalid = t.invalid || null, this.isLuxonInterval = !0;
  }
  /**
   * Create an invalid Interval.
   * @param {string} reason - simple string of why this Interval is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Interval}
   */
  static invalid(t, n = null) {
    if (!t)
      throw new On("need to specify a reason the Interval is invalid");
    const r = t instanceof Xn ? t : new Xn(t, n);
    if (en.throwOnInvalid)
      throw new aR(r);
    return new Jt({ invalid: r });
  }
  /**
   * Create an Interval from a start DateTime and an end DateTime. Inclusive of the start but not the end.
   * @param {DateTime|Date|Object} start
   * @param {DateTime|Date|Object} end
   * @return {Interval}
   */
  static fromDateTimes(t, n) {
    const r = Xa(t), a = Xa(n), l = AB(r, a);
    return l ?? new Jt({
      start: r,
      end: a
    });
  }
  /**
   * Create an Interval from a start DateTime and a Duration to extend to.
   * @param {DateTime|Date|Object} start
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */
  static after(t, n) {
    const r = Mt.fromDurationLike(n), a = Xa(t);
    return Jt.fromDateTimes(a, a.plus(r));
  }
  /**
   * Create an Interval from an end DateTime and a Duration to extend backwards to.
   * @param {DateTime|Date|Object} end
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */
  static before(t, n) {
    const r = Mt.fromDurationLike(n), a = Xa(t);
    return Jt.fromDateTimes(a.minus(r), a);
  }
  /**
   * Create an Interval from an ISO 8601 string.
   * Accepts `<start>/<end>`, `<start>/<duration>`, and `<duration>/<end>` formats.
   * @param {string} text - the ISO string to parse
   * @param {Object} [opts] - options to pass {@link DateTime#fromISO} and optionally {@link Duration#fromISO}
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {Interval}
   */
  static fromISO(t, n) {
    const [r, a] = (t || "").split("/", 2);
    if (r && a) {
      let l, u;
      try {
        l = et.fromISO(r, n), u = l.isValid;
      } catch {
        u = !1;
      }
      let h, f;
      try {
        h = et.fromISO(a, n), f = h.isValid;
      } catch {
        f = !1;
      }
      if (u && f)
        return Jt.fromDateTimes(l, h);
      if (u) {
        const m = Mt.fromISO(a, n);
        if (m.isValid)
          return Jt.after(l, m);
      } else if (f) {
        const m = Mt.fromISO(r, n);
        if (m.isValid)
          return Jt.before(h, m);
      }
    }
    return Jt.invalid("unparsable", `the input "${t}" can't be parsed as ISO 8601`);
  }
  /**
   * Check if an object is an Interval. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isInterval(t) {
    return t && t.isLuxonInterval || !1;
  }
  /**
   * Returns the start of the Interval
   * @type {DateTime}
   */
  get start() {
    return this.isValid ? this.s : null;
  }
  /**
   * Returns the end of the Interval
   * @type {DateTime}
   */
  get end() {
    return this.isValid ? this.e : null;
  }
  /**
   * Returns whether this Interval's end is at least its start, meaning that the Interval isn't 'backwards'.
   * @type {boolean}
   */
  get isValid() {
    return this.invalidReason === null;
  }
  /**
   * Returns an error code if this Interval is invalid, or null if the Interval is valid
   * @type {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
   * Returns an explanation of why this Interval became invalid, or null if the Interval is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
   * Returns the length of the Interval in the specified unit.
   * @param {string} unit - the unit (such as 'hours' or 'days') to return the length in.
   * @return {number}
   */
  length(t = "milliseconds") {
    return this.isValid ? this.toDuration(t).get(t) : NaN;
  }
  /**
   * Returns the count of minutes, hours, days, months, or years included in the Interval, even in part.
   * Unlike {@link Interval#length} this counts sections of the calendar, not periods of time, e.g. specifying 'day'
   * asks 'what dates are included in this interval?', not 'how many days long is this interval?'
   * @param {string} [unit='milliseconds'] - the unit of time to count.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week; this operation will always use the locale of the start DateTime
   * @return {number}
   */
  count(t = "milliseconds", n) {
    if (!this.isValid)
      return NaN;
    const r = this.start.startOf(t, n);
    let a;
    return n != null && n.useLocaleWeeks ? a = this.end.reconfigure({ locale: r.locale }) : a = this.end, a = a.startOf(t, n), Math.floor(a.diff(r, t).get(t)) + (a.valueOf() !== this.end.valueOf());
  }
  /**
   * Returns whether this Interval's start and end are both in the same unit of time
   * @param {string} unit - the unit of time to check sameness on
   * @return {boolean}
   */
  hasSame(t) {
    return this.isValid ? this.isEmpty() || this.e.minus(1).hasSame(this.s, t) : !1;
  }
  /**
   * Return whether this Interval has the same start and end DateTimes.
   * @return {boolean}
   */
  isEmpty() {
    return this.s.valueOf() === this.e.valueOf();
  }
  /**
   * Return whether this Interval's start is after the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  isAfter(t) {
    return this.isValid ? this.s > t : !1;
  }
  /**
   * Return whether this Interval's end is before the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  isBefore(t) {
    return this.isValid ? this.e <= t : !1;
  }
  /**
   * Return whether this Interval contains the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  contains(t) {
    return this.isValid ? this.s <= t && this.e > t : !1;
  }
  /**
   * "Sets" the start and/or end dates. Returns a newly-constructed Interval.
   * @param {Object} values - the values to set
   * @param {DateTime} values.start - the starting DateTime
   * @param {DateTime} values.end - the ending DateTime
   * @return {Interval}
   */
  set({ start: t, end: n } = {}) {
    return this.isValid ? Jt.fromDateTimes(t || this.s, n || this.e) : this;
  }
  /**
   * Split this Interval at each of the specified DateTimes
   * @param {...DateTime} dateTimes - the unit of time to count.
   * @return {Array}
   */
  splitAt(...t) {
    if (!this.isValid)
      return [];
    const n = t.map(Xa).filter((u) => this.contains(u)).sort((u, h) => u.toMillis() - h.toMillis()), r = [];
    let { s: a } = this, l = 0;
    for (; a < this.e; ) {
      const u = n[l] || this.e, h = +u > +this.e ? this.e : u;
      r.push(Jt.fromDateTimes(a, h)), a = h, l += 1;
    }
    return r;
  }
  /**
   * Split this Interval into smaller Intervals, each of the specified length.
   * Left over time is grouped into a smaller interval
   * @param {Duration|Object|number} duration - The length of each resulting interval.
   * @return {Array}
   */
  splitBy(t) {
    const n = Mt.fromDurationLike(t);
    if (!this.isValid || !n.isValid || n.as("milliseconds") === 0)
      return [];
    let { s: r } = this, a = 1, l;
    const u = [];
    for (; r < this.e; ) {
      const h = this.start.plus(n.mapUnits((f) => f * a));
      l = +h > +this.e ? this.e : h, u.push(Jt.fromDateTimes(r, l)), r = l, a += 1;
    }
    return u;
  }
  /**
   * Split this Interval into the specified number of smaller intervals.
   * @param {number} numberOfParts - The number of Intervals to divide the Interval into.
   * @return {Array}
   */
  divideEqually(t) {
    return this.isValid ? this.splitBy(this.length() / t).slice(0, t) : [];
  }
  /**
   * Return whether this Interval overlaps with the specified Interval
   * @param {Interval} other
   * @return {boolean}
   */
  overlaps(t) {
    return this.e > t.s && this.s < t.e;
  }
  /**
   * Return whether this Interval's end is adjacent to the specified Interval's start.
   * @param {Interval} other
   * @return {boolean}
   */
  abutsStart(t) {
    return this.isValid ? +this.e == +t.s : !1;
  }
  /**
   * Return whether this Interval's start is adjacent to the specified Interval's end.
   * @param {Interval} other
   * @return {boolean}
   */
  abutsEnd(t) {
    return this.isValid ? +t.e == +this.s : !1;
  }
  /**
   * Return whether this Interval engulfs the start and end of the specified Interval.
   * @param {Interval} other
   * @return {boolean}
   */
  engulfs(t) {
    return this.isValid ? this.s <= t.s && this.e >= t.e : !1;
  }
  /**
   * Return whether this Interval has the same start and end as the specified Interval.
   * @param {Interval} other
   * @return {boolean}
   */
  equals(t) {
    return !this.isValid || !t.isValid ? !1 : this.s.equals(t.s) && this.e.equals(t.e);
  }
  /**
   * Return an Interval representing the intersection of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the maximum start time and the minimum end time of the two Intervals.
   * Returns null if the intersection is empty, meaning, the intervals don't intersect.
   * @param {Interval} other
   * @return {Interval}
   */
  intersection(t) {
    if (!this.isValid)
      return this;
    const n = this.s > t.s ? this.s : t.s, r = this.e < t.e ? this.e : t.e;
    return n >= r ? null : Jt.fromDateTimes(n, r);
  }
  /**
   * Return an Interval representing the union of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the minimum start time and the maximum end time of the two Intervals.
   * @param {Interval} other
   * @return {Interval}
   */
  union(t) {
    if (!this.isValid)
      return this;
    const n = this.s < t.s ? this.s : t.s, r = this.e > t.e ? this.e : t.e;
    return Jt.fromDateTimes(n, r);
  }
  /**
   * Merge an array of Intervals into a equivalent minimal set of Intervals.
   * Combines overlapping and adjacent Intervals.
   * @param {Array} intervals
   * @return {Array}
   */
  static merge(t) {
    const [n, r] = t.sort((a, l) => a.s - l.s).reduce(
      ([a, l], u) => l ? l.overlaps(u) || l.abutsStart(u) ? [a, l.union(u)] : [a.concat([l]), u] : [a, u],
      [[], null]
    );
    return r && n.push(r), n;
  }
  /**
   * Return an array of Intervals representing the spans of time that only appear in one of the specified Intervals.
   * @param {Array} intervals
   * @return {Array}
   */
  static xor(t) {
    let n = null, r = 0;
    const a = [], l = t.map((f) => [
      { time: f.s, type: "s" },
      { time: f.e, type: "e" }
    ]), u = Array.prototype.concat(...l), h = u.sort((f, m) => f.time - m.time);
    for (const f of h)
      r += f.type === "s" ? 1 : -1, r === 1 ? n = f.time : (n && +n != +f.time && a.push(Jt.fromDateTimes(n, f.time)), n = null);
    return Jt.merge(a);
  }
  /**
   * Return an Interval representing the span of time in this Interval that doesn't overlap with any of the specified Intervals.
   * @param {...Interval} intervals
   * @return {Array}
   */
  difference(...t) {
    return Jt.xor([this].concat(t)).map((n) => this.intersection(n)).filter((n) => n && !n.isEmpty());
  }
  /**
   * Returns a string representation of this Interval appropriate for debugging.
   * @return {string}
   */
  toString() {
    return this.isValid ? `[${this.s.toISO()} – ${this.e.toISO()})` : ia;
  }
  /**
   * Returns a string representation of this Interval appropriate for the REPL.
   * @return {string}
   */
  [Symbol.for("nodejs.util.inspect.custom")]() {
    return this.isValid ? `Interval { start: ${this.s.toISO()}, end: ${this.e.toISO()} }` : `Interval { Invalid, reason: ${this.invalidReason} }`;
  }
  /**
   * Returns a localized string representing this Interval. Accepts the same options as the
   * Intl.DateTimeFormat constructor and any presets defined by Luxon, such as
   * {@link DateTime.DATE_FULL} or {@link DateTime.TIME_SIMPLE}. The exact behavior of this method
   * is browser-specific, but in general it will return an appropriate representation of the
   * Interval in the assigned locale. Defaults to the system's locale if no locale has been
   * specified.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {Object} [formatOpts=DateTime.DATE_SHORT] - Either a DateTime preset or
   * Intl.DateTimeFormat constructor options.
   * @param {Object} opts - Options to override the configuration of the start DateTime.
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(); //=> 11/7/2022 – 11/8/2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL); //=> November 7 – 8, 2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL, { locale: 'fr-FR' }); //=> 7–8 novembre 2022
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString(DateTime.TIME_SIMPLE); //=> 6:00 – 8:00 PM
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> Mon, Nov 07, 6:00 – 8:00 p
   * @return {string}
   */
  toLocaleString(t = js, n = {}) {
    return this.isValid ? _n.create(this.s.loc.clone(n), t).formatInterval(this) : ia;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Interval.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */
  toISO(t) {
    return this.isValid ? `${this.s.toISO(t)}/${this.e.toISO(t)}` : ia;
  }
  /**
   * Returns an ISO 8601-compliant string representation of date of this Interval.
   * The time components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {string}
   */
  toISODate() {
    return this.isValid ? `${this.s.toISODate()}/${this.e.toISODate()}` : ia;
  }
  /**
   * Returns an ISO 8601-compliant string representation of time of this Interval.
   * The date components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */
  toISOTime(t) {
    return this.isValid ? `${this.s.toISOTime(t)}/${this.e.toISOTime(t)}` : ia;
  }
  /**
   * Returns a string representation of this Interval formatted according to the specified format
   * string. **You may not want this.** See {@link Interval#toLocaleString} for a more flexible
   * formatting tool.
   * @param {string} dateFormat - The format string. This string formats the start and end time.
   * See {@link DateTime#toFormat} for details.
   * @param {Object} opts - Options.
   * @param {string} [opts.separator =  ' – '] - A separator to place between the start and end
   * representations.
   * @return {string}
   */
  toFormat(t, { separator: n = " – " } = {}) {
    return this.isValid ? `${this.s.toFormat(t)}${n}${this.e.toFormat(t)}` : ia;
  }
  /**
   * Return a Duration representing the time spanned by this interval.
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example Interval.fromDateTimes(dt1, dt2).toDuration().toObject() //=> { milliseconds: 88489257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('days').toObject() //=> { days: 1.0241812152777778 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes']).toObject() //=> { hours: 24, minutes: 34.82095 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes', 'seconds']).toObject() //=> { hours: 24, minutes: 34, seconds: 49.257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('seconds').toObject() //=> { seconds: 88489.257 }
   * @return {Duration}
   */
  toDuration(t, n) {
    return this.isValid ? this.e.diff(this.s, t, n) : Mt.invalid(this.invalidReason);
  }
  /**
   * Run mapFn on the interval start and end, returning a new Interval from the resulting DateTimes
   * @param {function} mapFn
   * @return {Interval}
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.toUTC())
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.plus({ hours: 2 }))
   */
  mapEndpoints(t) {
    return Jt.fromDateTimes(t(this.s), t(this.e));
  }
}
class rs {
  /**
   * Return whether the specified zone contains a DST.
   * @param {string|Zone} [zone='local'] - Zone to check. Defaults to the environment's local zone.
   * @return {boolean}
   */
  static hasDST(t = en.defaultZone) {
    const n = et.now().setZone(t).set({ month: 12 });
    return !t.isUniversal && n.offset !== n.set({ month: 6 }).offset;
  }
  /**
   * Return whether the specified zone is a valid IANA specifier.
   * @param {string} zone - Zone to check
   * @return {boolean}
   */
  static isValidIANAZone(t) {
    return Ai.isValidZone(t);
  }
  /**
   * Converts the input into a {@link Zone} instance.
   *
   * * If `input` is already a Zone instance, it is returned unchanged.
   * * If `input` is a string containing a valid time zone name, a Zone instance
   *   with that name is returned.
   * * If `input` is a string that doesn't refer to a known time zone, a Zone
   *   instance with {@link Zone#isValid} == false is returned.
   * * If `input is a number, a Zone instance with the specified fixed offset
   *   in minutes is returned.
   * * If `input` is `null` or `undefined`, the default zone is returned.
   * @param {string|Zone|number} [input] - the value to be converted
   * @return {Zone}
   */
  static normalizeZone(t) {
    return ar(t, en.defaultZone);
  }
  /**
   * Get the weekday on which the week starts according to the given locale.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number} the start of the week, 1 for Monday through 7 for Sunday
   */
  static getStartOfWeek({ locale: t = null, locObj: n = null } = {}) {
    return (n || $t.create(t)).getStartOfWeek();
  }
  /**
   * Get the minimum number of days necessary in a week before it is considered part of the next year according
   * to the given locale.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number}
   */
  static getMinimumDaysInFirstWeek({ locale: t = null, locObj: n = null } = {}) {
    return (n || $t.create(t)).getMinDaysInFirstWeek();
  }
  /**
   * Get the weekdays, which are considered the weekend according to the given locale
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number[]} an array of weekdays, 1 for Monday through 7 for Sunday
   */
  static getWeekendWeekdays({ locale: t = null, locObj: n = null } = {}) {
    return (n || $t.create(t)).getWeekendDays().slice();
  }
  /**
   * Return an array of standalone month names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @example Info.months()[0] //=> 'January'
   * @example Info.months('short')[0] //=> 'Jan'
   * @example Info.months('numeric')[0] //=> '1'
   * @example Info.months('short', { locale: 'fr-CA' } )[0] //=> 'janv.'
   * @example Info.months('numeric', { locale: 'ar' })[0] //=> '١'
   * @example Info.months('long', { outputCalendar: 'islamic' })[0] //=> 'Rabiʻ I'
   * @return {Array}
   */
  static months(t = "long", { locale: n = null, numberingSystem: r = null, locObj: a = null, outputCalendar: l = "gregory" } = {}) {
    return (a || $t.create(n, r, l)).months(t);
  }
  /**
   * Return an array of format month names.
   * Format months differ from standalone months in that they're meant to appear next to the day of the month. In some languages, that
   * changes the string.
   * See {@link Info#months}
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @return {Array}
   */
  static monthsFormat(t = "long", { locale: n = null, numberingSystem: r = null, locObj: a = null, outputCalendar: l = "gregory" } = {}) {
    return (a || $t.create(n, r, l)).months(t, !0);
  }
  /**
   * Return an array of standalone week names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the weekday representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @example Info.weekdays()[0] //=> 'Monday'
   * @example Info.weekdays('short')[0] //=> 'Mon'
   * @example Info.weekdays('short', { locale: 'fr-CA' })[0] //=> 'lun.'
   * @example Info.weekdays('short', { locale: 'ar' })[0] //=> 'الاثنين'
   * @return {Array}
   */
  static weekdays(t = "long", { locale: n = null, numberingSystem: r = null, locObj: a = null } = {}) {
    return (a || $t.create(n, r, null)).weekdays(t);
  }
  /**
   * Return an array of format week names.
   * Format weekdays differ from standalone weekdays in that they're meant to appear next to more date information. In some languages, that
   * changes the string.
   * See {@link Info#weekdays}
   * @param {string} [length='long'] - the length of the month representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale=null] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @return {Array}
   */
  static weekdaysFormat(t = "long", { locale: n = null, numberingSystem: r = null, locObj: a = null } = {}) {
    return (a || $t.create(n, r, null)).weekdays(t, !0);
  }
  /**
   * Return an array of meridiems.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.meridiems() //=> [ 'AM', 'PM' ]
   * @example Info.meridiems({ locale: 'my' }) //=> [ 'နံနက်', 'ညနေ' ]
   * @return {Array}
   */
  static meridiems({ locale: t = null } = {}) {
    return $t.create(t).meridiems();
  }
  /**
   * Return an array of eras, such as ['BC', 'AD']. The locale can be specified, but the calendar system is always Gregorian.
   * @param {string} [length='short'] - the length of the era representation, such as "short" or "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.eras() //=> [ 'BC', 'AD' ]
   * @example Info.eras('long') //=> [ 'Before Christ', 'Anno Domini' ]
   * @example Info.eras('long', { locale: 'fr' }) //=> [ 'avant Jésus-Christ', 'après Jésus-Christ' ]
   * @return {Array}
   */
  static eras(t = "short", { locale: n = null } = {}) {
    return $t.create(n, null, "gregory").eras(t);
  }
  /**
   * Return the set of available features in this environment.
   * Some features of Luxon are not available in all environments. For example, on older browsers, relative time formatting support is not available. Use this function to figure out if that's the case.
   * Keys:
   * * `relative`: whether this environment supports relative time formatting
   * * `localeWeek`: whether this environment supports different weekdays for the start of the week based on the locale
   * @example Info.features() //=> { relative: false, localeWeek: true }
   * @return {Object}
   */
  static features() {
    return { relative: _g(), localeWeek: yg() };
  }
}
function lf(e, t) {
  const n = (a) => a.toUTC(0, { keepLocalTime: !0 }).startOf("day").valueOf(), r = n(t) - n(e);
  return Math.floor(Mt.fromMillis(r).as("days"));
}
function RB(e, t, n) {
  const r = [
    ["years", (f, m) => m.year - f.year],
    ["quarters", (f, m) => m.quarter - f.quarter + (m.year - f.year) * 4],
    ["months", (f, m) => m.month - f.month + (m.year - f.year) * 12],
    [
      "weeks",
      (f, m) => {
        const v = lf(f, m);
        return (v - v % 7) / 7;
      }
    ],
    ["days", lf]
  ], a = {}, l = e;
  let u, h;
  for (const [f, m] of r)
    n.indexOf(f) >= 0 && (u = f, a[f] = m(e, t), h = l.plus(a), h > t ? (a[f]--, e = l.plus(a), e > t && (h = e, a[f]--, e = l.plus(a))) : e = h);
  return [e, a, h, u];
}
function BB(e, t, n, r) {
  let [a, l, u, h] = RB(e, t, n);
  const f = t - a, m = n.filter(
    (y) => ["hours", "minutes", "seconds", "milliseconds"].indexOf(y) >= 0
  );
  m.length === 0 && (u < t && (u = a.plus({ [h]: 1 })), u !== a && (l[h] = (l[h] || 0) + f / (u - a)));
  const v = Mt.fromObject(l, r);
  return m.length > 0 ? Mt.fromMillis(f, r).shiftTo(...m).plus(v) : v;
}
const cc = {
  arab: "[٠-٩]",
  arabext: "[۰-۹]",
  bali: "[᭐-᭙]",
  beng: "[০-৯]",
  deva: "[०-९]",
  fullwide: "[０-９]",
  gujr: "[૦-૯]",
  hanidec: "[〇|一|二|三|四|五|六|七|八|九]",
  khmr: "[០-៩]",
  knda: "[೦-೯]",
  laoo: "[໐-໙]",
  limb: "[᥆-᥏]",
  mlym: "[൦-൯]",
  mong: "[᠐-᠙]",
  mymr: "[၀-၉]",
  orya: "[୦-୯]",
  tamldec: "[௦-௯]",
  telu: "[౦-౯]",
  thai: "[๐-๙]",
  tibt: "[༠-༩]",
  latn: "\\d"
}, uf = {
  arab: [1632, 1641],
  arabext: [1776, 1785],
  bali: [6992, 7001],
  beng: [2534, 2543],
  deva: [2406, 2415],
  fullwide: [65296, 65303],
  gujr: [2790, 2799],
  khmr: [6112, 6121],
  knda: [3302, 3311],
  laoo: [3792, 3801],
  limb: [6470, 6479],
  mlym: [3430, 3439],
  mong: [6160, 6169],
  mymr: [4160, 4169],
  orya: [2918, 2927],
  tamldec: [3046, 3055],
  telu: [3174, 3183],
  thai: [3664, 3673],
  tibt: [3872, 3881]
}, $B = cc.hanidec.replace(/[\[|\]]/g, "").split("");
function NB(e) {
  let t = parseInt(e, 10);
  if (isNaN(t)) {
    t = "";
    for (let n = 0; n < e.length; n++) {
      const r = e.charCodeAt(n);
      if (e[n].search(cc.hanidec) !== -1)
        t += $B.indexOf(e[n]);
      else
        for (const a in uf) {
          const [l, u] = uf[a];
          r >= l && r <= u && (t += r - l);
        }
    }
    return parseInt(t, 10);
  } else
    return t;
}
function Kn({ numberingSystem: e }, t = "") {
  return new RegExp(`${cc[e || "latn"]}${t}`);
}
const zB = "missing Intl.DateTimeFormat.formatToParts support";
function St(e, t = (n) => n) {
  return { regex: e, deser: ([n]) => t(NB(n)) };
}
const FB = " ", $g = `[ ${FB}]`, Ng = new RegExp($g, "g");
function jB(e) {
  return e.replace(/\./g, "\\.?").replace(Ng, $g);
}
function cf(e) {
  return e.replace(/\./g, "").replace(Ng, " ").toLowerCase();
}
function Jn(e, t) {
  return e === null ? null : {
    regex: RegExp(e.map(jB).join("|")),
    deser: ([n]) => e.findIndex((r) => cf(n) === cf(r)) + t
  };
}
function hf(e, t) {
  return { regex: e, deser: ([, n, r]) => ll(n, r), groups: t };
}
function as(e) {
  return { regex: e, deser: ([t]) => t };
}
function VB(e) {
  return e.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
}
function YB(e, t) {
  const n = Kn(t), r = Kn(t, "{2}"), a = Kn(t, "{3}"), l = Kn(t, "{4}"), u = Kn(t, "{6}"), h = Kn(t, "{1,2}"), f = Kn(t, "{1,3}"), m = Kn(t, "{1,6}"), v = Kn(t, "{1,9}"), y = Kn(t, "{2,4}"), k = Kn(t, "{4,6}"), x = (R) => ({ regex: RegExp(VB(R.val)), deser: ([C]) => C, literal: !0 }), O = ((R) => {
    if (e.literal)
      return x(R);
    switch (R.val) {
      case "G":
        return Jn(t.eras("short"), 0);
      case "GG":
        return Jn(t.eras("long"), 0);
      case "y":
        return St(m);
      case "yy":
        return St(y, fu);
      case "yyyy":
        return St(l);
      case "yyyyy":
        return St(k);
      case "yyyyyy":
        return St(u);
      case "M":
        return St(h);
      case "MM":
        return St(r);
      case "MMM":
        return Jn(t.months("short", !0), 1);
      case "MMMM":
        return Jn(t.months("long", !0), 1);
      case "L":
        return St(h);
      case "LL":
        return St(r);
      case "LLL":
        return Jn(t.months("short", !1), 1);
      case "LLLL":
        return Jn(t.months("long", !1), 1);
      case "d":
        return St(h);
      case "dd":
        return St(r);
      case "o":
        return St(f);
      case "ooo":
        return St(a);
      case "HH":
        return St(r);
      case "H":
        return St(h);
      case "hh":
        return St(r);
      case "h":
        return St(h);
      case "mm":
        return St(r);
      case "m":
        return St(h);
      case "q":
        return St(h);
      case "qq":
        return St(r);
      case "s":
        return St(h);
      case "ss":
        return St(r);
      case "S":
        return St(f);
      case "SSS":
        return St(a);
      case "u":
        return as(v);
      case "uu":
        return as(h);
      case "uuu":
        return St(n);
      case "a":
        return Jn(t.meridiems(), 0);
      case "kkkk":
        return St(l);
      case "kk":
        return St(y, fu);
      case "W":
        return St(h);
      case "WW":
        return St(r);
      case "E":
      case "c":
        return St(n);
      case "EEE":
        return Jn(t.weekdays("short", !1), 1);
      case "EEEE":
        return Jn(t.weekdays("long", !1), 1);
      case "ccc":
        return Jn(t.weekdays("short", !0), 1);
      case "cccc":
        return Jn(t.weekdays("long", !0), 1);
      case "Z":
      case "ZZ":
        return hf(new RegExp(`([+-]${h.source})(?::(${r.source}))?`), 2);
      case "ZZZ":
        return hf(new RegExp(`([+-]${h.source})(${r.source})?`), 2);
      case "z":
        return as(/[a-z_+-/]{1,256}?/i);
      case " ":
        return as(/[^\S\n\r]/);
      default:
        return x(R);
    }
  })(e) || {
    invalidReason: zB
  };
  return O.token = e, O;
}
const HB = {
  year: {
    "2-digit": "yy",
    numeric: "yyyyy"
  },
  month: {
    numeric: "M",
    "2-digit": "MM",
    short: "MMM",
    long: "MMMM"
  },
  day: {
    numeric: "d",
    "2-digit": "dd"
  },
  weekday: {
    short: "EEE",
    long: "EEEE"
  },
  dayperiod: "a",
  dayPeriod: "a",
  hour12: {
    numeric: "h",
    "2-digit": "hh"
  },
  hour24: {
    numeric: "H",
    "2-digit": "HH"
  },
  minute: {
    numeric: "m",
    "2-digit": "mm"
  },
  second: {
    numeric: "s",
    "2-digit": "ss"
  },
  timeZoneName: {
    long: "ZZZZZ",
    short: "ZZZ"
  }
};
function UB(e, t, n) {
  const { type: r, value: a } = e;
  if (r === "literal") {
    const f = /^\s+$/.test(a);
    return {
      literal: !f,
      val: f ? " " : a
    };
  }
  const l = t[r];
  let u = r;
  r === "hour" && (t.hour12 != null ? u = t.hour12 ? "hour12" : "hour24" : t.hourCycle != null ? t.hourCycle === "h11" || t.hourCycle === "h12" ? u = "hour12" : u = "hour24" : u = n.hour12 ? "hour12" : "hour24");
  let h = HB[u];
  if (typeof h == "object" && (h = h[l]), h)
    return {
      literal: !1,
      val: h
    };
}
function ZB(e) {
  return [`^${e.map((n) => n.regex).reduce((n, r) => `${n}(${r.source})`, "")}$`, e];
}
function WB(e, t, n) {
  const r = e.match(t);
  if (r) {
    const a = {};
    let l = 1;
    for (const u in n)
      if (_a(n, u)) {
        const h = n[u], f = h.groups ? h.groups + 1 : 1;
        !h.literal && h.token && (a[h.token.val[0]] = h.deser(r.slice(l, l + f))), l += f;
      }
    return [r, a];
  } else
    return [r, {}];
}
function GB(e) {
  const t = (l) => {
    switch (l) {
      case "S":
        return "millisecond";
      case "s":
        return "second";
      case "m":
        return "minute";
      case "h":
      case "H":
        return "hour";
      case "d":
        return "day";
      case "o":
        return "ordinal";
      case "L":
      case "M":
        return "month";
      case "y":
        return "year";
      case "E":
      case "c":
        return "weekday";
      case "W":
        return "weekNumber";
      case "k":
        return "weekYear";
      case "q":
        return "quarter";
      default:
        return null;
    }
  };
  let n = null, r;
  return rt(e.z) || (n = Ai.create(e.z)), rt(e.Z) || (n || (n = new Sn(e.Z)), r = e.Z), rt(e.q) || (e.M = (e.q - 1) * 3 + 1), rt(e.h) || (e.h < 12 && e.a === 1 ? e.h += 12 : e.h === 12 && e.a === 0 && (e.h = 0)), e.G === 0 && e.y && (e.y = -e.y), rt(e.u) || (e.S = ac(e.u)), [Object.keys(e).reduce((l, u) => {
    const h = t(u);
    return h && (l[h] = e[u]), l;
  }, {}), n, r];
}
let zl = null;
function qB() {
  return zl || (zl = et.fromMillis(1555555555555)), zl;
}
function KB(e, t) {
  if (e.literal)
    return e;
  const n = _n.macroTokenToFormatOpts(e.val), r = jg(n, t);
  return r == null || r.includes(void 0) ? e : r;
}
function zg(e, t) {
  return Array.prototype.concat(...e.map((n) => KB(n, t)));
}
function Fg(e, t, n) {
  const r = zg(_n.parseFormat(n), e), a = r.map((u) => YB(u, e)), l = a.find((u) => u.invalidReason);
  if (l)
    return { input: t, tokens: r, invalidReason: l.invalidReason };
  {
    const [u, h] = ZB(a), f = RegExp(u, "i"), [m, v] = WB(t, f, h), [y, k, x] = v ? GB(v) : [null, null, void 0];
    if (_a(v, "a") && _a(v, "H"))
      throw new sa(
        "Can't include meridiem when specifying 24-hour format"
      );
    return { input: t, tokens: r, regex: f, rawMatches: m, matches: v, result: y, zone: k, specificOffset: x };
  }
}
function JB(e, t, n) {
  const { result: r, zone: a, specificOffset: l, invalidReason: u } = Fg(e, t, n);
  return [r, a, l, u];
}
function jg(e, t) {
  if (!e)
    return null;
  const r = _n.create(t, e).dtFormatter(qB()), a = r.formatToParts(), l = r.resolvedOptions();
  return a.map((u) => UB(u, e, l));
}
const Fl = "Invalid DateTime", df = 864e13;
function os(e) {
  return new Xn("unsupported zone", `the zone "${e.name}" is not supported`);
}
function jl(e) {
  return e.weekData === null && (e.weekData = Vs(e.c)), e.weekData;
}
function Vl(e) {
  return e.localWeekData === null && (e.localWeekData = Vs(
    e.c,
    e.loc.getMinDaysInFirstWeek(),
    e.loc.getStartOfWeek()
  )), e.localWeekData;
}
function wr(e, t) {
  const n = {
    ts: e.ts,
    zone: e.zone,
    c: e.c,
    o: e.o,
    loc: e.loc,
    invalid: e.invalid
  };
  return new et({ ...n, ...t, old: n });
}
function Vg(e, t, n) {
  let r = e - t * 60 * 1e3;
  const a = n.offset(r);
  if (t === a)
    return [r, t];
  r -= (a - t) * 60 * 1e3;
  const l = n.offset(r);
  return a === l ? [r, a] : [e - Math.min(a, l) * 60 * 1e3, Math.max(a, l)];
}
function ss(e, t) {
  e += t * 60 * 1e3;
  const n = new Date(e);
  return {
    year: n.getUTCFullYear(),
    month: n.getUTCMonth() + 1,
    day: n.getUTCDate(),
    hour: n.getUTCHours(),
    minute: n.getUTCMinutes(),
    second: n.getUTCSeconds(),
    millisecond: n.getUTCMilliseconds()
  };
}
function bs(e, t, n) {
  return Vg(sl(e), t, n);
}
function ff(e, t) {
  const n = e.o, r = e.c.year + Math.trunc(t.years), a = e.c.month + Math.trunc(t.months) + Math.trunc(t.quarters) * 3, l = {
    ...e.c,
    year: r,
    month: a,
    day: Math.min(e.c.day, Ys(r, a)) + Math.trunc(t.days) + Math.trunc(t.weeks) * 7
  }, u = Mt.fromObject({
    years: t.years - Math.trunc(t.years),
    quarters: t.quarters - Math.trunc(t.quarters),
    months: t.months - Math.trunc(t.months),
    weeks: t.weeks - Math.trunc(t.weeks),
    days: t.days - Math.trunc(t.days),
    hours: t.hours,
    minutes: t.minutes,
    seconds: t.seconds,
    milliseconds: t.milliseconds
  }).as("milliseconds"), h = sl(l);
  let [f, m] = Vg(h, n, e.zone);
  return u !== 0 && (f += u, m = e.zone.offset(f)), { ts: f, o: m };
}
function Ja(e, t, n, r, a, l) {
  const { setZone: u, zone: h } = n;
  if (e && Object.keys(e).length !== 0 || t) {
    const f = t || h, m = et.fromObject(e, {
      ...n,
      zone: f,
      specificOffset: l
    });
    return u ? m : m.setZone(h);
  } else
    return et.invalid(
      new Xn("unparsable", `the input "${a}" can't be parsed as ${r}`)
    );
}
function ls(e, t, n = !0) {
  return e.isValid ? _n.create($t.create("en-US"), {
    allowZ: n,
    forceSimple: !0
  }).formatDateTimeFromString(e, t) : null;
}
function Yl(e, t) {
  const n = e.c.year > 9999 || e.c.year < 0;
  let r = "";
  return n && e.c.year >= 0 && (r += "+"), r += un(e.c.year, n ? 6 : 4), t ? (r += "-", r += un(e.c.month), r += "-", r += un(e.c.day)) : (r += un(e.c.month), r += un(e.c.day)), r;
}
function pf(e, t, n, r, a, l) {
  let u = un(e.c.hour);
  return t ? (u += ":", u += un(e.c.minute), (e.c.millisecond !== 0 || e.c.second !== 0 || !n) && (u += ":")) : u += un(e.c.minute), (e.c.millisecond !== 0 || e.c.second !== 0 || !n) && (u += un(e.c.second), (e.c.millisecond !== 0 || !r) && (u += ".", u += un(e.c.millisecond, 3))), a && (e.isOffsetFixed && e.offset === 0 && !l ? u += "Z" : e.o < 0 ? (u += "-", u += un(Math.trunc(-e.o / 60)), u += ":", u += un(Math.trunc(-e.o % 60))) : (u += "+", u += un(Math.trunc(e.o / 60)), u += ":", u += un(Math.trunc(e.o % 60)))), l && (u += "[" + e.zone.ianaName + "]"), u;
}
const Yg = {
  month: 1,
  day: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
}, XB = {
  weekNumber: 1,
  weekday: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
}, QB = {
  ordinal: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
}, Hg = ["year", "month", "day", "hour", "minute", "second", "millisecond"], e$ = [
  "weekYear",
  "weekNumber",
  "weekday",
  "hour",
  "minute",
  "second",
  "millisecond"
], t$ = ["year", "ordinal", "hour", "minute", "second", "millisecond"];
function n$(e) {
  const t = {
    year: "year",
    years: "year",
    month: "month",
    months: "month",
    day: "day",
    days: "day",
    hour: "hour",
    hours: "hour",
    minute: "minute",
    minutes: "minute",
    quarter: "quarter",
    quarters: "quarter",
    second: "second",
    seconds: "second",
    millisecond: "millisecond",
    milliseconds: "millisecond",
    weekday: "weekday",
    weekdays: "weekday",
    weeknumber: "weekNumber",
    weeksnumber: "weekNumber",
    weeknumbers: "weekNumber",
    weekyear: "weekYear",
    weekyears: "weekYear",
    ordinal: "ordinal"
  }[e.toLowerCase()];
  if (!t)
    throw new Zm(e);
  return t;
}
function mf(e) {
  switch (e.toLowerCase()) {
    case "localweekday":
    case "localweekdays":
      return "localWeekday";
    case "localweeknumber":
    case "localweeknumbers":
      return "localWeekNumber";
    case "localweekyear":
    case "localweekyears":
      return "localWeekYear";
    default:
      return n$(e);
  }
}
function gf(e, t) {
  const n = ar(t.zone, en.defaultZone), r = $t.fromObject(t), a = en.now();
  let l, u;
  if (rt(e.year))
    l = a;
  else {
    for (const m of Hg)
      rt(e[m]) && (e[m] = Yg[m]);
    const h = gg(e) || vg(e);
    if (h)
      return et.invalid(h);
    const f = n.offset(a);
    [l, u] = bs(e, f, n);
  }
  return new et({ ts: l, zone: n, loc: r, o: u });
}
function vf(e, t, n) {
  const r = rt(n.round) ? !0 : n.round, a = (u, h) => (u = oc(u, r || n.calendary ? 0 : 2, !0), t.loc.clone(n).relFormatter(n).format(u, h)), l = (u) => n.calendary ? t.hasSame(e, u) ? 0 : t.startOf(u).diff(e.startOf(u), u).get(u) : t.diff(e, u).get(u);
  if (n.unit)
    return a(l(n.unit), n.unit);
  for (const u of n.units) {
    const h = l(u);
    if (Math.abs(h) >= 1)
      return a(h, u);
  }
  return a(e > t ? -0 : 0, n.units[n.units.length - 1]);
}
function _f(e) {
  let t = {}, n;
  return e.length > 0 && typeof e[e.length - 1] == "object" ? (t = e[e.length - 1], n = Array.from(e).slice(0, e.length - 1)) : n = Array.from(e), [t, n];
}
class et {
  /**
   * @access private
   */
  constructor(t) {
    const n = t.zone || en.defaultZone;
    let r = t.invalid || (Number.isNaN(t.ts) ? new Xn("invalid input") : null) || (n.isValid ? null : os(n));
    this.ts = rt(t.ts) ? en.now() : t.ts;
    let a = null, l = null;
    if (!r)
      if (t.old && t.old.ts === this.ts && t.old.zone.equals(n))
        [a, l] = [t.old.c, t.old.o];
      else {
        const h = n.offset(this.ts);
        a = ss(this.ts, h), r = Number.isNaN(a.year) ? new Xn("invalid input") : null, a = r ? null : a, l = r ? null : h;
      }
    this._zone = n, this.loc = t.loc || $t.create(), this.invalid = r, this.weekData = null, this.localWeekData = null, this.c = a, this.o = l, this.isLuxonDateTime = !0;
  }
  // CONSTRUCT
  /**
   * Create a DateTime for the current instant, in the system's time zone.
   *
   * Use Settings to override these default values if needed.
   * @example DateTime.now().toISO() //~> now in the ISO format
   * @return {DateTime}
   */
  static now() {
    return new et({});
  }
  /**
   * Create a local DateTime
   * @param {number} [year] - The calendar year. If omitted (as in, call `local()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month, 1-indexed
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @example DateTime.local()                                  //~> now
   * @example DateTime.local({ zone: "America/New_York" })      //~> now, in US east coast time
   * @example DateTime.local(2017)                              //~> 2017-01-01T00:00:00
   * @example DateTime.local(2017, 3)                           //~> 2017-03-01T00:00:00
   * @example DateTime.local(2017, 3, 12, { locale: "fr" })     //~> 2017-03-12T00:00:00, with a French locale
   * @example DateTime.local(2017, 3, 12, 5)                    //~> 2017-03-12T05:00:00
   * @example DateTime.local(2017, 3, 12, 5, { zone: "utc" })   //~> 2017-03-12T05:00:00, in UTC
   * @example DateTime.local(2017, 3, 12, 5, 45)                //~> 2017-03-12T05:45:00
   * @example DateTime.local(2017, 3, 12, 5, 45, 10)            //~> 2017-03-12T05:45:10
   * @example DateTime.local(2017, 3, 12, 5, 45, 10, 765)       //~> 2017-03-12T05:45:10.765
   * @return {DateTime}
   */
  static local() {
    const [t, n] = _f(arguments), [r, a, l, u, h, f, m] = n;
    return gf({ year: r, month: a, day: l, hour: u, minute: h, second: f, millisecond: m }, t);
  }
  /**
   * Create a DateTime in UTC
   * @param {number} [year] - The calendar year. If omitted (as in, call `utc()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @param {Object} options - configuration options for the DateTime
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} [options.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [options.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @example DateTime.utc()                                              //~> now
   * @example DateTime.utc(2017)                                          //~> 2017-01-01T00:00:00Z
   * @example DateTime.utc(2017, 3)                                       //~> 2017-03-01T00:00:00Z
   * @example DateTime.utc(2017, 3, 12)                                   //~> 2017-03-12T00:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5)                                //~> 2017-03-12T05:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45)                            //~> 2017-03-12T05:45:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, { locale: "fr" })          //~> 2017-03-12T05:45:00Z with a French locale
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10)                        //~> 2017-03-12T05:45:10Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10, 765, { locale: "fr" }) //~> 2017-03-12T05:45:10.765Z with a French locale
   * @return {DateTime}
   */
  static utc() {
    const [t, n] = _f(arguments), [r, a, l, u, h, f, m] = n;
    return t.zone = Sn.utcInstance, gf({ year: r, month: a, day: l, hour: u, minute: h, second: f, millisecond: m }, t);
  }
  /**
   * Create a DateTime from a JavaScript Date object. Uses the default zone.
   * @param {Date} date - a JavaScript Date object
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @return {DateTime}
   */
  static fromJSDate(t, n = {}) {
    const r = TR(t) ? t.valueOf() : NaN;
    if (Number.isNaN(r))
      return et.invalid("invalid input");
    const a = ar(n.zone, en.defaultZone);
    return a.isValid ? new et({
      ts: r,
      zone: a,
      loc: $t.fromObject(n)
    }) : et.invalid(os(a));
  }
  /**
   * Create a DateTime from a number of milliseconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} milliseconds - a number of milliseconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromMillis(t, n = {}) {
    if (Pr(t))
      return t < -df || t > df ? et.invalid("Timestamp out of range") : new et({
        ts: t,
        zone: ar(n.zone, en.defaultZone),
        loc: $t.fromObject(n)
      });
    throw new On(
      `fromMillis requires a numerical input, but received a ${typeof t} with value ${t}`
    );
  }
  /**
   * Create a DateTime from a number of seconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} seconds - a number of seconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromSeconds(t, n = {}) {
    if (Pr(t))
      return new et({
        ts: t * 1e3,
        zone: ar(n.zone, en.defaultZone),
        loc: $t.fromObject(n)
      });
    throw new On("fromSeconds requires a numerical input");
  }
  /**
   * Create a DateTime from a JavaScript object with keys like 'year' and 'hour' with reasonable defaults.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.year - a year, such as 1987
   * @param {number} obj.month - a month, 1-12
   * @param {number} obj.day - a day of the month, 1-31, depending on the month
   * @param {number} obj.ordinal - day of the year, 1-365 or 366
   * @param {number} obj.weekYear - an ISO week year
   * @param {number} obj.weekNumber - an ISO week number, between 1 and 52 or 53, depending on the year
   * @param {number} obj.weekday - an ISO weekday, 1-7, where 1 is Monday and 7 is Sunday
   * @param {number} obj.localWeekYear - a week year, according to the locale
   * @param {number} obj.localWeekNumber - a week number, between 1 and 52 or 53, depending on the year, according to the locale
   * @param {number} obj.localWeekday - a weekday, 1-7, where 1 is the first and 7 is the last day of the week, according to the locale
   * @param {number} obj.hour - hour of the day, 0-23
   * @param {number} obj.minute - minute of the hour, 0-59
   * @param {number} obj.second - second of the minute, 0-59
   * @param {number} obj.millisecond - millisecond of the second, 0-999
   * @param {Object} opts - options for creating this DateTime
   * @param {string|Zone} [opts.zone='local'] - interpret the numbers in the context of a particular zone. Can take any value taken as the first argument to setZone()
   * @param {string} [opts.locale='system\'s locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromObject({ year: 1982, month: 5, day: 25}).toISODate() //=> '1982-05-25'
   * @example DateTime.fromObject({ year: 1982 }).toISODate() //=> '1982-01-01'
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }) //~> today at 10:26:06
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'utc' }),
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'local' })
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'America/New_York' })
   * @example DateTime.fromObject({ weekYear: 2016, weekNumber: 2, weekday: 3 }).toISODate() //=> '2016-01-13'
   * @example DateTime.fromObject({ localWeekYear: 2022, localWeekNumber: 1, localWeekday: 1 }, { locale: "en-US" }).toISODate() //=> '2021-12-26'
   * @return {DateTime}
   */
  static fromObject(t, n = {}) {
    t = t || {};
    const r = ar(n.zone, en.defaultZone);
    if (!r.isValid)
      return et.invalid(os(r));
    const a = $t.fromObject(n), l = Hs(t, mf), { minDaysInFirstWeek: u, startOfWeek: h } = ef(l, a), f = en.now(), m = rt(n.specificOffset) ? r.offset(f) : n.specificOffset, v = !rt(l.ordinal), y = !rt(l.year), k = !rt(l.month) || !rt(l.day), x = y || k, M = l.weekYear || l.weekNumber;
    if ((x || v) && M)
      throw new sa(
        "Can't mix weekYear/weekNumber units with year/month/day or ordinals"
      );
    if (k && v)
      throw new sa("Can't mix ordinal dates with month/day");
    const O = M || l.weekday && !x;
    let R, C, T = ss(f, m);
    O ? (R = e$, C = XB, T = Vs(T, u, h)) : v ? (R = t$, C = QB, T = Nl(T)) : (R = Hg, C = Yg);
    let A = !1;
    for (const X of R) {
      const ae = l[X];
      rt(ae) ? A ? l[X] = C[X] : l[X] = T[X] : A = !0;
    }
    const P = O ? CR(l, u, h) : v ? OR(l) : gg(l), D = P || vg(l);
    if (D)
      return et.invalid(D);
    const $ = O ? Xd(l, u, h) : v ? Qd(l) : l, [Y, G] = bs($, m, r), ee = new et({
      ts: Y,
      zone: r,
      o: G,
      loc: a
    });
    return l.weekday && x && t.weekday !== ee.weekday ? et.invalid(
      "mismatched weekday",
      `you can't specify both a weekday of ${l.weekday} and a date of ${ee.toISO()}`
    ) : ee;
  }
  /**
   * Create a DateTime from an ISO 8601 string
   * @param {string} text - the ISO string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the time to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} [opts.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [opts.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromISO('2016-05-25T09:08:34.123')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00', {setZone: true})
   * @example DateTime.fromISO('2016-05-25T09:08:34.123', {zone: 'utc'})
   * @example DateTime.fromISO('2016-W05-4')
   * @return {DateTime}
   */
  static fromISO(t, n = {}) {
    const [r, a] = bB(t);
    return Ja(r, a, n, "ISO 8601", t);
  }
  /**
   * Create a DateTime from an RFC 2822 string
   * @param {string} text - the RFC 2822 string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since the offset is always specified in the string itself, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23:12 GMT')
   * @example DateTime.fromRFC2822('Fri, 25 Nov 2016 13:23:12 +0600')
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23 Z')
   * @return {DateTime}
   */
  static fromRFC2822(t, n = {}) {
    const [r, a] = wB(t);
    return Ja(r, a, n, "RFC 2822", t);
  }
  /**
   * Create a DateTime from an HTTP header date
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @param {string} text - the HTTP header date
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since HTTP dates are always in UTC, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with the fixed-offset zone specified in the string. For HTTP dates, this is always UTC, so this option is equivalent to setting the `zone` option to 'utc', but this option is included for consistency with similar methods.
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromHTTP('Sun, 06 Nov 1994 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sunday, 06-Nov-94 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sun Nov  6 08:49:37 1994')
   * @return {DateTime}
   */
  static fromHTTP(t, n = {}) {
    const [r, a] = kB(t);
    return Ja(r, a, n, "HTTP", n);
  }
  /**
   * Create a DateTime from an input string and format string.
   * Defaults to en-US if no locale has been specified, regardless of the system's locale. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/parsing?id=table-of-tokens).
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see the link below for the formats)
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromFormat(t, n, r = {}) {
    if (rt(t) || rt(n))
      throw new On("fromFormat requires an input string and a format");
    const { locale: a = null, numberingSystem: l = null } = r, u = $t.fromOpts({
      locale: a,
      numberingSystem: l,
      defaultToEN: !0
    }), [h, f, m, v] = JB(u, t, n);
    return v ? et.invalid(v) : Ja(h, f, r, `format ${n}`, t, m);
  }
  /**
   * @deprecated use fromFormat instead
   */
  static fromString(t, n, r = {}) {
    return et.fromFormat(t, n, r);
  }
  /**
   * Create a DateTime from a SQL date, time, or datetime
   * Defaults to en-US if no locale has been specified, regardless of the system's locale
   * @param {string} text - the string to parse
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @example DateTime.fromSQL('2017-05-15')
   * @example DateTime.fromSQL('2017-05-15 09:12:34')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342+06:00')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles', { setZone: true })
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342', { zone: 'America/Los_Angeles' })
   * @example DateTime.fromSQL('09:12:34.342')
   * @return {DateTime}
   */
  static fromSQL(t, n = {}) {
    const [r, a] = OB(t);
    return Ja(r, a, n, "SQL", t);
  }
  /**
   * Create an invalid DateTime.
   * @param {string} reason - simple string of why this DateTime is invalid. Should not contain parameters or anything else data-dependent.
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {DateTime}
   */
  static invalid(t, n = null) {
    if (!t)
      throw new On("need to specify a reason the DateTime is invalid");
    const r = t instanceof Xn ? t : new Xn(t, n);
    if (en.throwOnInvalid)
      throw new rR(r);
    return new et({ invalid: r });
  }
  /**
   * Check if an object is an instance of DateTime. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isDateTime(t) {
    return t && t.isLuxonDateTime || !1;
  }
  /**
   * Produce the format string for a set of options
   * @param formatOpts
   * @param localeOpts
   * @returns {string}
   */
  static parseFormatForOpts(t, n = {}) {
    const r = jg(t, $t.fromObject(n));
    return r ? r.map((a) => a ? a.val : null).join("") : null;
  }
  /**
   * Produce the the fully expanded format token for the locale
   * Does NOT quote characters, so quoted tokens will not round trip correctly
   * @param fmt
   * @param localeOpts
   * @returns {string}
   */
  static expandFormat(t, n = {}) {
    return zg(_n.parseFormat(t), $t.fromObject(n)).map((a) => a.val).join("");
  }
  // INFO
  /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example DateTime.local(2017, 7, 4).get('month'); //=> 7
   * @example DateTime.local(2017, 7, 4).get('day'); //=> 4
   * @return {number}
   */
  get(t) {
    return this[t];
  }
  /**
   * Returns whether the DateTime is valid. Invalid DateTimes occur when:
   * * The DateTime was created from invalid calendar information, such as the 13th month or February 30
   * * The DateTime was created by an operation on another invalid date
   * @type {boolean}
   */
  get isValid() {
    return this.invalid === null;
  }
  /**
   * Returns an error code if this DateTime is invalid, or null if the DateTime is valid
   * @type {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
   * Returns an explanation of why this DateTime became invalid, or null if the DateTime is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
   * Get the locale of a DateTime, such 'en-GB'. The locale is used when formatting the DateTime
   *
   * @type {string}
   */
  get locale() {
    return this.isValid ? this.loc.locale : null;
  }
  /**
   * Get the numbering system of a DateTime, such 'beng'. The numbering system is used when formatting the DateTime
   *
   * @type {string}
   */
  get numberingSystem() {
    return this.isValid ? this.loc.numberingSystem : null;
  }
  /**
   * Get the output calendar of a DateTime, such 'islamic'. The output calendar is used when formatting the DateTime
   *
   * @type {string}
   */
  get outputCalendar() {
    return this.isValid ? this.loc.outputCalendar : null;
  }
  /**
   * Get the time zone associated with this DateTime.
   * @type {Zone}
   */
  get zone() {
    return this._zone;
  }
  /**
   * Get the name of the time zone.
   * @type {string}
   */
  get zoneName() {
    return this.isValid ? this.zone.name : null;
  }
  /**
   * Get the year
   * @example DateTime.local(2017, 5, 25).year //=> 2017
   * @type {number}
   */
  get year() {
    return this.isValid ? this.c.year : NaN;
  }
  /**
   * Get the quarter
   * @example DateTime.local(2017, 5, 25).quarter //=> 2
   * @type {number}
   */
  get quarter() {
    return this.isValid ? Math.ceil(this.c.month / 3) : NaN;
  }
  /**
   * Get the month (1-12).
   * @example DateTime.local(2017, 5, 25).month //=> 5
   * @type {number}
   */
  get month() {
    return this.isValid ? this.c.month : NaN;
  }
  /**
   * Get the day of the month (1-30ish).
   * @example DateTime.local(2017, 5, 25).day //=> 25
   * @type {number}
   */
  get day() {
    return this.isValid ? this.c.day : NaN;
  }
  /**
   * Get the hour of the day (0-23).
   * @example DateTime.local(2017, 5, 25, 9).hour //=> 9
   * @type {number}
   */
  get hour() {
    return this.isValid ? this.c.hour : NaN;
  }
  /**
   * Get the minute of the hour (0-59).
   * @example DateTime.local(2017, 5, 25, 9, 30).minute //=> 30
   * @type {number}
   */
  get minute() {
    return this.isValid ? this.c.minute : NaN;
  }
  /**
   * Get the second of the minute (0-59).
   * @example DateTime.local(2017, 5, 25, 9, 30, 52).second //=> 52
   * @type {number}
   */
  get second() {
    return this.isValid ? this.c.second : NaN;
  }
  /**
   * Get the millisecond of the second (0-999).
   * @example DateTime.local(2017, 5, 25, 9, 30, 52, 654).millisecond //=> 654
   * @type {number}
   */
  get millisecond() {
    return this.isValid ? this.c.millisecond : NaN;
  }
  /**
   * Get the week year
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2014, 12, 31).weekYear //=> 2015
   * @type {number}
   */
  get weekYear() {
    return this.isValid ? jl(this).weekYear : NaN;
  }
  /**
   * Get the week number of the week year (1-52ish).
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2017, 5, 25).weekNumber //=> 21
   * @type {number}
   */
  get weekNumber() {
    return this.isValid ? jl(this).weekNumber : NaN;
  }
  /**
   * Get the day of the week.
   * 1 is Monday and 7 is Sunday
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2014, 11, 31).weekday //=> 4
   * @type {number}
   */
  get weekday() {
    return this.isValid ? jl(this).weekday : NaN;
  }
  /**
   * Returns true if this date is on a weekend according to the locale, false otherwise
   * @returns {boolean}
   */
  get isWeekend() {
    return this.isValid && this.loc.getWeekendDays().includes(this.weekday);
  }
  /**
   * Get the day of the week according to the locale.
   * 1 is the first day of the week and 7 is the last day of the week.
   * If the locale assigns Sunday as the first day of the week, then a date which is a Sunday will return 1,
   * @returns {number}
   */
  get localWeekday() {
    return this.isValid ? Vl(this).weekday : NaN;
  }
  /**
   * Get the week number of the week year according to the locale. Different locales assign week numbers differently,
   * because the week can start on different days of the week (see localWeekday) and because a different number of days
   * is required for a week to count as the first week of a year.
   * @returns {number}
   */
  get localWeekNumber() {
    return this.isValid ? Vl(this).weekNumber : NaN;
  }
  /**
   * Get the week year according to the locale. Different locales assign week numbers (and therefor week years)
   * differently, see localWeekNumber.
   * @returns {number}
   */
  get localWeekYear() {
    return this.isValid ? Vl(this).weekYear : NaN;
  }
  /**
   * Get the ordinal (meaning the day of the year)
   * @example DateTime.local(2017, 5, 25).ordinal //=> 145
   * @type {number|DateTime}
   */
  get ordinal() {
    return this.isValid ? Nl(this.c).ordinal : NaN;
  }
  /**
   * Get the human readable short month name, such as 'Oct'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).monthShort //=> Oct
   * @type {string}
   */
  get monthShort() {
    return this.isValid ? rs.months("short", { locObj: this.loc })[this.month - 1] : null;
  }
  /**
   * Get the human readable long month name, such as 'October'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).monthLong //=> October
   * @type {string}
   */
  get monthLong() {
    return this.isValid ? rs.months("long", { locObj: this.loc })[this.month - 1] : null;
  }
  /**
   * Get the human readable short weekday, such as 'Mon'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).weekdayShort //=> Mon
   * @type {string}
   */
  get weekdayShort() {
    return this.isValid ? rs.weekdays("short", { locObj: this.loc })[this.weekday - 1] : null;
  }
  /**
   * Get the human readable long weekday, such as 'Monday'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).weekdayLong //=> Monday
   * @type {string}
   */
  get weekdayLong() {
    return this.isValid ? rs.weekdays("long", { locObj: this.loc })[this.weekday - 1] : null;
  }
  /**
   * Get the UTC offset of this DateTime in minutes
   * @example DateTime.now().offset //=> -240
   * @example DateTime.utc().offset //=> 0
   * @type {number}
   */
  get offset() {
    return this.isValid ? +this.o : NaN;
  }
  /**
   * Get the short human name for the zone's current offset, for example "EST" or "EDT".
   * Defaults to the system's locale if no locale has been specified
   * @type {string}
   */
  get offsetNameShort() {
    return this.isValid ? this.zone.offsetName(this.ts, {
      format: "short",
      locale: this.locale
    }) : null;
  }
  /**
   * Get the long human name for the zone's current offset, for example "Eastern Standard Time" or "Eastern Daylight Time".
   * Defaults to the system's locale if no locale has been specified
   * @type {string}
   */
  get offsetNameLong() {
    return this.isValid ? this.zone.offsetName(this.ts, {
      format: "long",
      locale: this.locale
    }) : null;
  }
  /**
   * Get whether this zone's offset ever changes, as in a DST.
   * @type {boolean}
   */
  get isOffsetFixed() {
    return this.isValid ? this.zone.isUniversal : null;
  }
  /**
   * Get whether the DateTime is in a DST.
   * @type {boolean}
   */
  get isInDST() {
    return this.isOffsetFixed ? !1 : this.offset > this.set({ month: 1, day: 1 }).offset || this.offset > this.set({ month: 5 }).offset;
  }
  /**
   * Get those DateTimes which have the same local time as this DateTime, but a different offset from UTC
   * in this DateTime's zone. During DST changes local time can be ambiguous, for example
   * `2023-10-29T02:30:00` in `Europe/Berlin` can have offset `+01:00` or `+02:00`.
   * This method will return both possible DateTimes if this DateTime's local time is ambiguous.
   * @returns {DateTime[]}
   */
  getPossibleOffsets() {
    if (!this.isValid || this.isOffsetFixed)
      return [this];
    const t = 864e5, n = 6e4, r = sl(this.c), a = this.zone.offset(r - t), l = this.zone.offset(r + t), u = this.zone.offset(r - a * n), h = this.zone.offset(r - l * n);
    if (u === h)
      return [this];
    const f = r - u * n, m = r - h * n, v = ss(f, u), y = ss(m, h);
    return v.hour === y.hour && v.minute === y.minute && v.second === y.second && v.millisecond === y.millisecond ? [wr(this, { ts: f }), wr(this, { ts: m })] : [this];
  }
  /**
   * Returns true if this DateTime is in a leap year, false otherwise
   * @example DateTime.local(2016).isInLeapYear //=> true
   * @example DateTime.local(2013).isInLeapYear //=> false
   * @type {boolean}
   */
  get isInLeapYear() {
    return So(this.year);
  }
  /**
   * Returns the number of days in this DateTime's month
   * @example DateTime.local(2016, 2).daysInMonth //=> 29
   * @example DateTime.local(2016, 3).daysInMonth //=> 31
   * @type {number}
   */
  get daysInMonth() {
    return Ys(this.year, this.month);
  }
  /**
   * Returns the number of days in this DateTime's year
   * @example DateTime.local(2016).daysInYear //=> 366
   * @example DateTime.local(2013).daysInYear //=> 365
   * @type {number}
   */
  get daysInYear() {
    return this.isValid ? da(this.year) : NaN;
  }
  /**
   * Returns the number of weeks in this DateTime's year
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2004).weeksInWeekYear //=> 53
   * @example DateTime.local(2013).weeksInWeekYear //=> 52
   * @type {number}
   */
  get weeksInWeekYear() {
    return this.isValid ? vo(this.weekYear) : NaN;
  }
  /**
   * Returns the number of weeks in this DateTime's local week year
   * @example DateTime.local(2020, 6, {locale: 'en-US'}).weeksInLocalWeekYear //=> 52
   * @example DateTime.local(2020, 6, {locale: 'de-DE'}).weeksInLocalWeekYear //=> 53
   * @type {number}
   */
  get weeksInLocalWeekYear() {
    return this.isValid ? vo(
      this.localWeekYear,
      this.loc.getMinDaysInFirstWeek(),
      this.loc.getStartOfWeek()
    ) : NaN;
  }
  /**
   * Returns the resolved Intl options for this DateTime.
   * This is useful in understanding the behavior of formatting methods
   * @param {Object} opts - the same options as toLocaleString
   * @return {Object}
   */
  resolvedLocaleOptions(t = {}) {
    const { locale: n, numberingSystem: r, calendar: a } = _n.create(
      this.loc.clone(t),
      t
    ).resolvedOptions(this);
    return { locale: n, numberingSystem: r, outputCalendar: a };
  }
  // TRANSFORM
  /**
   * "Set" the DateTime's zone to UTC. Returns a newly-constructed DateTime.
   *
   * Equivalent to {@link DateTime#setZone}('utc')
   * @param {number} [offset=0] - optionally, an offset from UTC in minutes
   * @param {Object} [opts={}] - options to pass to `setZone()`
   * @return {DateTime}
   */
  toUTC(t = 0, n = {}) {
    return this.setZone(Sn.instance(t), n);
  }
  /**
   * "Set" the DateTime's zone to the host's local zone. Returns a newly-constructed DateTime.
   *
   * Equivalent to `setZone('local')`
   * @return {DateTime}
   */
  toLocal() {
    return this.setZone(en.defaultZone);
  }
  /**
   * "Set" the DateTime's zone to specified zone. Returns a newly-constructed DateTime.
   *
   * By default, the setter keeps the underlying time the same (as in, the same timestamp), but the new instance will report different local times and consider DSTs when making computations, as with {@link DateTime#plus}. You may wish to use {@link DateTime#toLocal} and {@link DateTime#toUTC} which provide simple convenience wrappers for commonly used zones.
   * @param {string|Zone} [zone='local'] - a zone identifier. As a string, that can be any IANA zone supported by the host environment, or a fixed-offset name of the form 'UTC+3', or the strings 'local' or 'utc'. You may also supply an instance of a {@link DateTime#Zone} class.
   * @param {Object} opts - options
   * @param {boolean} [opts.keepLocalTime=false] - If true, adjust the underlying time so that the local time stays the same, but in the target zone. You should rarely need this.
   * @return {DateTime}
   */
  setZone(t, { keepLocalTime: n = !1, keepCalendarTime: r = !1 } = {}) {
    if (t = ar(t, en.defaultZone), t.equals(this.zone))
      return this;
    if (t.isValid) {
      let a = this.ts;
      if (n || r) {
        const l = t.offset(this.ts), u = this.toObject();
        [a] = bs(u, l, t);
      }
      return wr(this, { ts: a, zone: t });
    } else
      return et.invalid(os(t));
  }
  /**
   * "Set" the locale, numberingSystem, or outputCalendar. Returns a newly-constructed DateTime.
   * @param {Object} properties - the properties to set
   * @example DateTime.local(2017, 5, 25).reconfigure({ locale: 'en-GB' })
   * @return {DateTime}
   */
  reconfigure({ locale: t, numberingSystem: n, outputCalendar: r } = {}) {
    const a = this.loc.clone({ locale: t, numberingSystem: n, outputCalendar: r });
    return wr(this, { loc: a });
  }
  /**
   * "Set" the locale. Returns a newly-constructed DateTime.
   * Just a convenient alias for reconfigure({ locale })
   * @example DateTime.local(2017, 5, 25).setLocale('en-GB')
   * @return {DateTime}
   */
  setLocale(t) {
    return this.reconfigure({ locale: t });
  }
  /**
   * "Set" the values of specified units. Returns a newly-constructed DateTime.
   * You can only set units with this method; for "setting" metadata, see {@link DateTime#reconfigure} and {@link DateTime#setZone}.
   *
   * This method also supports setting locale-based week units, i.e. `localWeekday`, `localWeekNumber` and `localWeekYear`.
   * They cannot be mixed with ISO-week units like `weekday`.
   * @param {Object} values - a mapping of units to numbers
   * @example dt.set({ year: 2017 })
   * @example dt.set({ hour: 8, minute: 30 })
   * @example dt.set({ weekday: 5 })
   * @example dt.set({ year: 2005, ordinal: 234 })
   * @return {DateTime}
   */
  set(t) {
    if (!this.isValid)
      return this;
    const n = Hs(t, mf), { minDaysInFirstWeek: r, startOfWeek: a } = ef(n, this.loc), l = !rt(n.weekYear) || !rt(n.weekNumber) || !rt(n.weekday), u = !rt(n.ordinal), h = !rt(n.year), f = !rt(n.month) || !rt(n.day), m = h || f, v = n.weekYear || n.weekNumber;
    if ((m || u) && v)
      throw new sa(
        "Can't mix weekYear/weekNumber units with year/month/day or ordinals"
      );
    if (f && u)
      throw new sa("Can't mix ordinal dates with month/day");
    let y;
    l ? y = Xd(
      { ...Vs(this.c, r, a), ...n },
      r,
      a
    ) : rt(n.ordinal) ? (y = { ...this.toObject(), ...n }, rt(n.day) && (y.day = Math.min(Ys(y.year, y.month), y.day))) : y = Qd({ ...Nl(this.c), ...n });
    const [k, x] = bs(y, this.o, this.zone);
    return wr(this, { ts: k, o: x });
  }
  /**
   * Add a period of time to this DateTime and return the resulting DateTime
   *
   * Adding hours, minutes, seconds, or milliseconds increases the timestamp by the right number of milliseconds. Adding days, months, or years shifts the calendar, accounting for DSTs and leap years along the way. Thus, `dt.plus({ hours: 24 })` may result in a different time than `dt.plus({ days: 1 })` if there's a DST shift in between.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @example DateTime.now().plus(123) //~> in 123 milliseconds
   * @example DateTime.now().plus({ minutes: 15 }) //~> in 15 minutes
   * @example DateTime.now().plus({ days: 1 }) //~> this time tomorrow
   * @example DateTime.now().plus({ days: -1 }) //~> this time yesterday
   * @example DateTime.now().plus({ hours: 3, minutes: 13 }) //~> in 3 hr, 13 min
   * @example DateTime.now().plus(Duration.fromObject({ hours: 3, minutes: 13 })) //~> in 3 hr, 13 min
   * @return {DateTime}
   */
  plus(t) {
    if (!this.isValid)
      return this;
    const n = Mt.fromDurationLike(t);
    return wr(this, ff(this, n));
  }
  /**
   * Subtract a period of time to this DateTime and return the resulting DateTime
   * See {@link DateTime#plus}
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   @return {DateTime}
   */
  minus(t) {
    if (!this.isValid)
      return this;
    const n = Mt.fromDurationLike(t).negate();
    return wr(this, ff(this, n));
  }
  /**
   * "Set" this DateTime to the beginning of a unit of time.
   * @param {string} unit - The unit to go to the beginning of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week
   * @example DateTime.local(2014, 3, 3).startOf('month').toISODate(); //=> '2014-03-01'
   * @example DateTime.local(2014, 3, 3).startOf('year').toISODate(); //=> '2014-01-01'
   * @example DateTime.local(2014, 3, 3).startOf('week').toISODate(); //=> '2014-03-03', weeks always start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('day').toISOTime(); //=> '00:00.000-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('hour').toISOTime(); //=> '05:00:00.000-05:00'
   * @return {DateTime}
   */
  startOf(t, { useLocaleWeeks: n = !1 } = {}) {
    if (!this.isValid)
      return this;
    const r = {}, a = Mt.normalizeUnit(t);
    switch (a) {
      case "years":
        r.month = 1;
      case "quarters":
      case "months":
        r.day = 1;
      case "weeks":
      case "days":
        r.hour = 0;
      case "hours":
        r.minute = 0;
      case "minutes":
        r.second = 0;
      case "seconds":
        r.millisecond = 0;
        break;
    }
    if (a === "weeks")
      if (n) {
        const l = this.loc.getStartOfWeek(), { weekday: u } = this;
        u < l && (r.weekNumber = this.weekNumber - 1), r.weekday = l;
      } else
        r.weekday = 1;
    if (a === "quarters") {
      const l = Math.ceil(this.month / 3);
      r.month = (l - 1) * 3 + 1;
    }
    return this.set(r);
  }
  /**
   * "Set" this DateTime to the end (meaning the last millisecond) of a unit of time
   * @param {string} unit - The unit to go to the end of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week
   * @example DateTime.local(2014, 3, 3).endOf('month').toISO(); //=> '2014-03-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('year').toISO(); //=> '2014-12-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('week').toISO(); // => '2014-03-09T23:59:59.999-05:00', weeks start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('day').toISO(); //=> '2014-03-03T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('hour').toISO(); //=> '2014-03-03T05:59:59.999-05:00'
   * @return {DateTime}
   */
  endOf(t, n) {
    return this.isValid ? this.plus({ [t]: 1 }).startOf(t, n).minus(1) : this;
  }
  // OUTPUT
  /**
   * Returns a string representation of this DateTime formatted according to the specified format string.
   * **You may not want this.** See {@link DateTime#toLocaleString} for a more flexible formatting tool. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/formatting?id=table-of-tokens).
   * Defaults to en-US if no locale has been specified, regardless of the system's locale.
   * @param {string} fmt - the format string
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toFormat('yyyy LLL dd') //=> '2017 Apr 22'
   * @example DateTime.now().setLocale('fr').toFormat('yyyy LLL dd') //=> '2017 avr. 22'
   * @example DateTime.now().toFormat('yyyy LLL dd', { locale: "fr" }) //=> '2017 avr. 22'
   * @example DateTime.now().toFormat("HH 'hours and' mm 'minutes'") //=> '20 hours and 55 minutes'
   * @return {string}
   */
  toFormat(t, n = {}) {
    return this.isValid ? _n.create(this.loc.redefaultToEN(n)).formatDateTimeFromString(this, t) : Fl;
  }
  /**
   * Returns a localized string representing this date. Accepts the same options as the Intl.DateTimeFormat constructor and any presets defined by Luxon, such as `DateTime.DATE_FULL` or `DateTime.TIME_SIMPLE`.
   * The exact behavior of this method is browser-specific, but in general it will return an appropriate representation
   * of the DateTime in the assigned locale.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param formatOpts {Object} - Intl.DateTimeFormat constructor options and configuration options
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toLocaleString(); //=> 4/20/2017
   * @example DateTime.now().setLocale('en-gb').toLocaleString(); //=> '20/04/2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL); //=> 'April 20, 2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL, { locale: 'fr' }); //=> '28 août 2022'
   * @example DateTime.now().toLocaleString(DateTime.TIME_SIMPLE); //=> '11:32 AM'
   * @example DateTime.now().toLocaleString(DateTime.DATETIME_SHORT); //=> '4/20/2017, 11:32 AM'
   * @example DateTime.now().toLocaleString({ weekday: 'long', month: 'long', day: '2-digit' }); //=> 'Thursday, April 20'
   * @example DateTime.now().toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> 'Thu, Apr 20, 11:27 AM'
   * @example DateTime.now().toLocaleString({ hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }); //=> '11:32'
   * @return {string}
   */
  toLocaleString(t = js, n = {}) {
    return this.isValid ? _n.create(this.loc.clone(n), t).formatDateTime(this) : Fl;
  }
  /**
   * Returns an array of format "parts", meaning individual tokens along with metadata. This is allows callers to post-process individual sections of the formatted output.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat/formatToParts
   * @param opts {Object} - Intl.DateTimeFormat constructor options, same as `toLocaleString`.
   * @example DateTime.now().toLocaleParts(); //=> [
   *                                   //=>   { type: 'day', value: '25' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'month', value: '05' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'year', value: '1982' }
   *                                   //=> ]
   */
  toLocaleParts(t = {}) {
    return this.isValid ? _n.create(this.loc.clone(t), t).formatDateTimeParts(this) : [];
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=false] - add the time zone format extension
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc(1983, 5, 25).toISO() //=> '1982-05-25T00:00:00.000Z'
   * @example DateTime.now().toISO() //=> '2017-04-22T20:47:05.335-04:00'
   * @example DateTime.now().toISO({ includeOffset: false }) //=> '2017-04-22T20:47:05.335'
   * @example DateTime.now().toISO({ format: 'basic' }) //=> '20170422T204705.335-0400'
   * @return {string}
   */
  toISO({
    format: t = "extended",
    suppressSeconds: n = !1,
    suppressMilliseconds: r = !1,
    includeOffset: a = !0,
    extendedZone: l = !1
  } = {}) {
    if (!this.isValid)
      return null;
    const u = t === "extended";
    let h = Yl(this, u);
    return h += "T", h += pf(this, u, n, r, a, l), h;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's date component
   * @param {Object} opts - options
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc(1982, 5, 25).toISODate() //=> '1982-05-25'
   * @example DateTime.utc(1982, 5, 25).toISODate({ format: 'basic' }) //=> '19820525'
   * @return {string}
   */
  toISODate({ format: t = "extended" } = {}) {
    return this.isValid ? Yl(this, t === "extended") : null;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's week date
   * @example DateTime.utc(1982, 5, 25).toISOWeekDate() //=> '1982-W21-2'
   * @return {string}
   */
  toISOWeekDate() {
    return ls(this, "kkkk-'W'WW-c");
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's time component
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=true] - add the time zone format extension
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime() //=> '07:34:19.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34, seconds: 0, milliseconds: 0 }).toISOTime({ suppressSeconds: true }) //=> '07:34Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ format: 'basic' }) //=> '073419.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ includePrefix: true }) //=> 'T07:34:19.361Z'
   * @return {string}
   */
  toISOTime({
    suppressMilliseconds: t = !1,
    suppressSeconds: n = !1,
    includeOffset: r = !0,
    includePrefix: a = !1,
    extendedZone: l = !1,
    format: u = "extended"
  } = {}) {
    return this.isValid ? (a ? "T" : "") + pf(
      this,
      u === "extended",
      n,
      t,
      r,
      l
    ) : null;
  }
  /**
   * Returns an RFC 2822-compatible string representation of this DateTime
   * @example DateTime.utc(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 +0000'
   * @example DateTime.local(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 -0400'
   * @return {string}
   */
  toRFC2822() {
    return ls(this, "EEE, dd LLL yyyy HH:mm:ss ZZZ", !1);
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in HTTP headers. The output is always expressed in GMT.
   * Specifically, the string conforms to RFC 1123.
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @example DateTime.utc(2014, 7, 13).toHTTP() //=> 'Sun, 13 Jul 2014 00:00:00 GMT'
   * @example DateTime.utc(2014, 7, 13, 19).toHTTP() //=> 'Sun, 13 Jul 2014 19:00:00 GMT'
   * @return {string}
   */
  toHTTP() {
    return ls(this.toUTC(), "EEE, dd LLL yyyy HH:mm:ss 'GMT'");
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL Date
   * @example DateTime.utc(2014, 7, 13).toSQLDate() //=> '2014-07-13'
   * @return {string}
   */
  toSQLDate() {
    return this.isValid ? Yl(this, !0) : null;
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL Time
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc().toSQL() //=> '05:15:16.345'
   * @example DateTime.now().toSQL() //=> '05:15:16.345 -04:00'
   * @example DateTime.now().toSQL({ includeOffset: false }) //=> '05:15:16.345'
   * @example DateTime.now().toSQL({ includeZone: false }) //=> '05:15:16.345 America/New_York'
   * @return {string}
   */
  toSQLTime({ includeOffset: t = !0, includeZone: n = !1, includeOffsetSpace: r = !0 } = {}) {
    let a = "HH:mm:ss.SSS";
    return (n || t) && (r && (a += " "), n ? a += "z" : t && (a += "ZZ")), ls(this, a, !0);
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 Z'
   * @example DateTime.local(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 -04:00'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeOffset: false }) //=> '2014-07-13 00:00:00.000'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeZone: true }) //=> '2014-07-13 00:00:00.000 America/New_York'
   * @return {string}
   */
  toSQL(t = {}) {
    return this.isValid ? `${this.toSQLDate()} ${this.toSQLTime(t)}` : null;
  }
  /**
   * Returns a string representation of this DateTime appropriate for debugging
   * @return {string}
   */
  toString() {
    return this.isValid ? this.toISO() : Fl;
  }
  /**
   * Returns a string representation of this DateTime appropriate for the REPL.
   * @return {string}
   */
  [Symbol.for("nodejs.util.inspect.custom")]() {
    return this.isValid ? `DateTime { ts: ${this.toISO()}, zone: ${this.zone.name}, locale: ${this.locale} }` : `DateTime { Invalid, reason: ${this.invalidReason} }`;
  }
  /**
   * Returns the epoch milliseconds of this DateTime. Alias of {@link DateTime#toMillis}
   * @return {number}
   */
  valueOf() {
    return this.toMillis();
  }
  /**
   * Returns the epoch milliseconds of this DateTime.
   * @return {number}
   */
  toMillis() {
    return this.isValid ? this.ts : NaN;
  }
  /**
   * Returns the epoch seconds of this DateTime.
   * @return {number}
   */
  toSeconds() {
    return this.isValid ? this.ts / 1e3 : NaN;
  }
  /**
   * Returns the epoch seconds (as a whole number) of this DateTime.
   * @return {number}
   */
  toUnixInteger() {
    return this.isValid ? Math.floor(this.ts / 1e3) : NaN;
  }
  /**
   * Returns an ISO 8601 representation of this DateTime appropriate for use in JSON.
   * @return {string}
   */
  toJSON() {
    return this.toISO();
  }
  /**
   * Returns a BSON serializable equivalent to this DateTime.
   * @return {Date}
   */
  toBSON() {
    return this.toJSDate();
  }
  /**
   * Returns a JavaScript object with this DateTime's year, month, day, and so on.
   * @param opts - options for generating the object
   * @param {boolean} [opts.includeConfig=false] - include configuration attributes in the output
   * @example DateTime.now().toObject() //=> { year: 2017, month: 4, day: 22, hour: 20, minute: 49, second: 42, millisecond: 268 }
   * @return {Object}
   */
  toObject(t = {}) {
    if (!this.isValid)
      return {};
    const n = { ...this.c };
    return t.includeConfig && (n.outputCalendar = this.outputCalendar, n.numberingSystem = this.loc.numberingSystem, n.locale = this.loc.locale), n;
  }
  /**
   * Returns a JavaScript Date equivalent to this DateTime.
   * @return {Date}
   */
  toJSDate() {
    return new Date(this.isValid ? this.ts : NaN);
  }
  // COMPARE
  /**
   * Return the difference between two DateTimes as a Duration.
   * @param {DateTime} otherDateTime - the DateTime to compare this one to
   * @param {string|string[]} [unit=['milliseconds']] - the unit or array of units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example
   * var i1 = DateTime.fromISO('1982-05-25T09:45'),
   *     i2 = DateTime.fromISO('1983-10-14T10:30');
   * i2.diff(i1).toObject() //=> { milliseconds: 43807500000 }
   * i2.diff(i1, 'hours').toObject() //=> { hours: 12168.75 }
   * i2.diff(i1, ['months', 'days']).toObject() //=> { months: 16, days: 19.03125 }
   * i2.diff(i1, ['months', 'days', 'hours']).toObject() //=> { months: 16, days: 19, hours: 0.75 }
   * @return {Duration}
   */
  diff(t, n = "milliseconds", r = {}) {
    if (!this.isValid || !t.isValid)
      return Mt.invalid("created by diffing an invalid DateTime");
    const a = { locale: this.locale, numberingSystem: this.numberingSystem, ...r }, l = DR(n).map(Mt.normalizeUnit), u = t.valueOf() > this.valueOf(), h = u ? this : t, f = u ? t : this, m = BB(h, f, l, a);
    return u ? m.negate() : m;
  }
  /**
   * Return the difference between this DateTime and right now.
   * See {@link DateTime#diff}
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units units (such as 'hours' or 'days') to include in the duration
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */
  diffNow(t = "milliseconds", n = {}) {
    return this.diff(et.now(), t, n);
  }
  /**
   * Return an Interval spanning between this DateTime and another DateTime
   * @param {DateTime} otherDateTime - the other end point of the Interval
   * @return {Interval}
   */
  until(t) {
    return this.isValid ? Jt.fromDateTimes(this, t) : this;
  }
  /**
   * Return whether this DateTime is in the same unit of time as another DateTime.
   * Higher-order units must also be identical for this function to return `true`.
   * Note that time zones are **ignored** in this comparison, which compares the **local** calendar time. Use {@link DateTime#setZone} to convert one of the dates if needed.
   * @param {DateTime} otherDateTime - the other DateTime
   * @param {string} unit - the unit of time to check sameness on
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week; only the locale of this DateTime is used
   * @example DateTime.now().hasSame(otherDT, 'day'); //~> true if otherDT is in the same current calendar day
   * @return {boolean}
   */
  hasSame(t, n, r) {
    if (!this.isValid)
      return !1;
    const a = t.valueOf(), l = this.setZone(t.zone, { keepLocalTime: !0 });
    return l.startOf(n, r) <= a && a <= l.endOf(n, r);
  }
  /**
   * Equality check
   * Two DateTimes are equal if and only if they represent the same millisecond, have the same zone and location, and are both valid.
   * To compare just the millisecond values, use `+dt1 === +dt2`.
   * @param {DateTime} other - the other DateTime
   * @return {boolean}
   */
  equals(t) {
    return this.isValid && t.isValid && this.valueOf() === t.valueOf() && this.zone.equals(t.zone) && this.loc.equals(t.loc);
  }
  /**
   * Returns a string representation of a this time relative to now, such as "in two days". Can only internationalize if your
   * platform supports Intl.RelativeTimeFormat. Rounds down by default.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} [options.style="long"] - the style of units, must be "long", "short", or "narrow"
   * @param {string|string[]} options.unit - use a specific unit or array of units; if omitted, or an array, the method will pick the best unit. Use an array or one of "years", "quarters", "months", "weeks", "days", "hours", "minutes", or "seconds"
   * @param {boolean} [options.round=true] - whether to round the numbers in the output.
   * @param {number} [options.padding=0] - padding in milliseconds. This allows you to round up the result if it fits inside the threshold. Don't use in combination with {round: false} because the decimal output will include the padding.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelative() //=> "in 1 day"
   * @example DateTime.now().setLocale("es").toRelative({ days: 1 }) //=> "dentro de 1 día"
   * @example DateTime.now().plus({ days: 1 }).toRelative({ locale: "fr" }) //=> "dans 23 heures"
   * @example DateTime.now().minus({ days: 2 }).toRelative() //=> "2 days ago"
   * @example DateTime.now().minus({ days: 2 }).toRelative({ unit: "hours" }) //=> "48 hours ago"
   * @example DateTime.now().minus({ hours: 36 }).toRelative({ round: false }) //=> "1.5 days ago"
   */
  toRelative(t = {}) {
    if (!this.isValid)
      return null;
    const n = t.base || et.fromObject({}, { zone: this.zone }), r = t.padding ? this < n ? -t.padding : t.padding : 0;
    let a = ["years", "months", "days", "hours", "minutes", "seconds"], l = t.unit;
    return Array.isArray(t.unit) && (a = t.unit, l = void 0), vf(n, this.plus(r), {
      ...t,
      numeric: "always",
      units: a,
      unit: l
    });
  }
  /**
   * Returns a string representation of this date relative to today, such as "yesterday" or "next month".
   * Only internationalizes on platforms that supports Intl.RelativeTimeFormat.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.unit - use a specific unit; if omitted, the method will pick the unit. Use one of "years", "quarters", "months", "weeks", or "days"
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar() //=> "tomorrow"
   * @example DateTime.now().setLocale("es").plus({ days: 1 }).toRelative() //=> ""mañana"
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar({ locale: "fr" }) //=> "demain"
   * @example DateTime.now().minus({ days: 2 }).toRelativeCalendar() //=> "2 days ago"
   */
  toRelativeCalendar(t = {}) {
    return this.isValid ? vf(t.base || et.fromObject({}, { zone: this.zone }), this, {
      ...t,
      numeric: "auto",
      units: ["years", "months", "days"],
      calendary: !0
    }) : null;
  }
  /**
   * Return the min of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the minimum
   * @return {DateTime} the min DateTime, or undefined if called with no argument
   */
  static min(...t) {
    if (!t.every(et.isDateTime))
      throw new On("min requires all arguments be DateTimes");
    return tf(t, (n) => n.valueOf(), Math.min);
  }
  /**
   * Return the max of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the maximum
   * @return {DateTime} the max DateTime, or undefined if called with no argument
   */
  static max(...t) {
    if (!t.every(et.isDateTime))
      throw new On("max requires all arguments be DateTimes");
    return tf(t, (n) => n.valueOf(), Math.max);
  }
  // MISC
  /**
   * Explain how a string would be parsed by fromFormat()
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see description)
   * @param {Object} options - options taken by fromFormat()
   * @return {Object}
   */
  static fromFormatExplain(t, n, r = {}) {
    const { locale: a = null, numberingSystem: l = null } = r, u = $t.fromOpts({
      locale: a,
      numberingSystem: l,
      defaultToEN: !0
    });
    return Fg(u, t, n);
  }
  /**
   * @deprecated use fromFormatExplain instead
   */
  static fromStringExplain(t, n, r = {}) {
    return et.fromFormatExplain(t, n, r);
  }
  // FORMAT PRESETS
  /**
   * {@link DateTime#toLocaleString} format like 10/14/1983
   * @type {Object}
   */
  static get DATE_SHORT() {
    return js;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983'
   * @type {Object}
   */
  static get DATE_MED() {
    return Wm;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Fri, Oct 14, 1983'
   * @type {Object}
   */
  static get DATE_MED_WITH_WEEKDAY() {
    return sR;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983'
   * @type {Object}
   */
  static get DATE_FULL() {
    return Gm;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Tuesday, October 14, 1983'
   * @type {Object}
   */
  static get DATE_HUGE() {
    return qm;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_SIMPLE() {
    return Km;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_SECONDS() {
    return Jm;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_SHORT_OFFSET() {
    return Xm;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_LONG_OFFSET() {
    return Qm;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_SIMPLE() {
    return eg;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_SECONDS() {
    return tg;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 EDT', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_SHORT_OFFSET() {
    return ng;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 Eastern Daylight Time', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_LONG_OFFSET() {
    return ig;
  }
  /**
   * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_SHORT() {
    return rg;
  }
  /**
   * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30:33 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_SHORT_WITH_SECONDS() {
    return ag;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED() {
    return og;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30:33 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED_WITH_SECONDS() {
    return sg;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Fri, 14 Oct 1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED_WITH_WEEKDAY() {
    return lR;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_FULL() {
    return lg;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30:33 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_FULL_WITH_SECONDS() {
    return ug;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_HUGE() {
    return cg;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30:33 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_HUGE_WITH_SECONDS() {
    return hg;
  }
}
function Xa(e) {
  if (et.isDateTime(e))
    return e;
  if (e && e.valueOf && Pr(e.valueOf()))
    return et.fromJSDate(e);
  if (e && typeof e == "object")
    return et.fromObject(e);
  throw new On(
    `Unknown datetime argument: ${e}, of type ${typeof e}`
  );
}
const i$ = { class: "date-filter__container" }, r$ = { class: "date-filter__date-buttons" }, a$ = { class: "date-filter__date-picker" }, o$ = { class: "date-filter__input-wrapper" }, s$ = ["onClick"], l$ = ["value", "aria-label"], u$ = { class: "date-filter__date-picker" }, c$ = { class: "date-filter__input-wrapper" }, h$ = ["onClick"], d$ = ["value", "aria-label"], f$ = /* @__PURE__ */ tt({
  __name: "DateRange",
  props: /* @__PURE__ */ Ci({
    loading: {
      type: Boolean,
      required: !1,
      default: !1
    }
  }, {
    filter: {
      default: {
        name: "",
        nameDisplay: "",
        type: "dateRange",
        start: void 0,
        end: void 0,
        rangeMin: void 0,
        rangeMax: void 0,
        active: !1
      }
    },
    filterModifiers: {}
  }),
  emits: /* @__PURE__ */ Ci(["userUpdatedFilter"], ["update:filter"]),
  setup(e, { emit: t }) {
    const n = or(e, "filter"), r = te({
      get: () => {
        let f = n.value.start || n.value.rangeMin || "";
        try {
          return et.fromISO(f).toLocal().toJSDate();
        } catch {
          return /* @__PURE__ */ new Date();
        }
      },
      set: (f) => {
        f ? n.value.start = et.fromJSDate(f).toUTC().toISO() || void 0 : n.value.start = (/* @__PURE__ */ new Date()).toISOString();
      }
    }), a = te({
      get: () => {
        let f = n.value.end || n.value.rangeMax || "";
        try {
          return et.fromISO(f).toLocal().toJSDate();
        } catch {
          return /* @__PURE__ */ new Date();
        }
      },
      set: (f) => {
        f ? n.value.end = et.fromJSDate(f).toUTC().toISO() || void 0 : n.value.end = (/* @__PURE__ */ new Date()).toISOString();
      }
    }), l = (f, m) => {
      var k, x;
      let v;
      const y = ((x = (k = f.target) == null ? void 0 : k.value) == null ? void 0 : x.trim()) || void 0;
      if (y === void 0 || y === "") {
        n.value[m] = void 0;
        return;
      }
      try {
        const M = f.target.value.split("/").map((O) => Number.parseInt(O));
        v = et.fromObject({ month: M[0], day: M[1], year: M[2] }).toUTC().toISO() || void 0;
      } catch {
        const O = m === "start" ? "rangeMin" : "rangeMax";
        v = n.value[m] || n.value[O];
      }
      n.value[m] = v, document.activeElement instanceof HTMLElement && document.activeElement.blur();
    }, u = t, h = () => {
      n.value.active ? u("userUpdatedFilter", { ...n.value, active: !1 }) : u("userUpdatedFilter", { ...n.value, active: !0 });
    };
    return (f, m) => Pi((we(), Te("div", i$, [
      xe("div", r$, [
        xe("div", a$, [
          ce(he(jd), {
            modelValue: r.value,
            "onUpdate:modelValue": m[1] || (m[1] = (v) => r.value = v),
            "max-date": n.value.rangeMax
          }, {
            default: Je(({ inputValue: v, togglePopover: y }) => [
              xe("div", o$, [
                xe("button", {
                  onClick: (k) => y(),
                  "data-ts": "start-date-button"
                }, [
                  ce(he(Qc), { size: "18" }),
                  Se(" Start ")
                ], 8, s$),
                xe("input", {
                  value: v,
                  placeholder: "Any Date",
                  "aria-label": `Starting date for the filter ${n.value.nameDisplay}, in the format mm/dd/yyyy`,
                  onChange: m[0] || (m[0] = (k) => l(k, "start")),
                  class: "date-filter__date-input",
                  "data-ts": "start-date-input"
                }, null, 40, l$)
              ])
            ]),
            _: 1
          }, 8, ["modelValue", "max-date"])
        ]),
        xe("div", u$, [
          ce(he(jd), {
            modelValue: a.value,
            "onUpdate:modelValue": m[3] || (m[3] = (v) => a.value = v),
            "min-date": n.value.rangeMin
          }, {
            default: Je(({ inputValue: v, togglePopover: y }) => [
              xe("div", c$, [
                xe("button", {
                  onClick: (k) => y(),
                  "data-ts": "end-date-button"
                }, [
                  ce(he(Qc), { size: "18" }),
                  Se(" End ")
                ], 8, h$),
                xe("input", {
                  value: v,
                  placeholder: "Any Date",
                  "aria-label": `Starting date for the filter ${n.value.nameDisplay}, in the format mm/dd/yyyy`,
                  onChange: m[2] || (m[2] = (k) => l(k, "end")),
                  class: "date-filter__date-input",
                  "data-ts": "end-date-input"
                }, null, 40, d$)
              ])
            ]),
            _: 1
          }, 8, ["modelValue", "min-date"])
        ])
      ]),
      ce(Wf, {
        onClick: h,
        class: "date-filter__submit-button",
        "aria-label": `Apply changes to ${n.value.nameDisplay}`,
        "data-ts": "date-range-submit"
      }, {
        default: Je(() => [
          Se(_t(n.value.active ? "Remove" : "Apply"), 1)
        ]),
        _: 1
      }, 8, ["aria-label"])
    ], 512)), [
      [vu, !e.loading]
    ]);
  }
}), eN = /* @__PURE__ */ ur(f$, [["__scopeId", "data-v-91562d35"]]), p$ = {
  class: "filter-container",
  "data-ts": "filter-container"
}, m$ = {
  class: "filter-container__content",
  "data-ts": "filter-container-content"
}, g$ = /* @__PURE__ */ tt({
  __name: "FilterContainer",
  props: {
    isOpen: { type: Boolean, default: !1 },
    isOpenModifiers: {}
  },
  emits: /* @__PURE__ */ Ci(["openToggled"], ["update:isOpen"]),
  setup(e, { emit: t }) {
    const n = or(e, "isOpen"), r = t, a = () => {
      n.value = !n.value, r("openToggled");
    };
    return (l, u) => (we(), Te("div", p$, [
      xe("div", {
        class: "filter-container__header",
        onClick: a,
        "data-ts": "filter-header"
      }, [
        Xt(l.$slots, "filterName", {}, void 0, !0),
        ce(he($f), {
          class: gt(n.value ? "filter-open" : "filter-closed")
        }, null, 8, ["class"])
      ]),
      ce(oo, { name: "filterSlide" }, {
        default: Je(() => [
          Pi(xe("div", m$, [
            Xt(l.$slots, "default", {}, void 0, !0)
          ], 512), [
            [vu, n.value]
          ])
        ]),
        _: 3
      })
    ]));
  }
}), tN = /* @__PURE__ */ ur(g$, [["__scopeId", "data-v-f62e2b76"]]), v$ = { class: "filter-chip__container" }, _$ = { class: "filter-chip" }, y$ = /* @__PURE__ */ tt({
  __name: "FilterChip",
  props: {
    display: String,
    filter: Object,
    value: {
      type: Object,
      required: !1
    }
  },
  emits: ["remove"],
  setup(e, { emit: t }) {
    const n = e, r = t, a = () => r("remove", n.value);
    return (l, u) => (we(), Te("div", v$, [
      xe("span", _$, [
        Se(_t(e.display) + " ", 1),
        ce(he(j_), {
          onClick: a,
          class: "remove-filter"
        })
      ])
    ]));
  }
}), nN = /* @__PURE__ */ ur(y$, [["__scopeId", "data-v-5a230d70"]]), b$ = { class: "search-bar__container" }, w$ = { class: "search-bar__keyword" }, k$ = { class: "search-bar__place" }, x$ = /* @__PURE__ */ xe("label", {
  for: "placefinder-op",
  "data-tg-off": "Within",
  "data-tg-on": "Intersects",
  class: "place-op__toggle-label"
}, null, -1), L$ = { class: "search-bar__place-input" }, M$ = { class: "search-bar__extra-buttons" }, iN = /* @__PURE__ */ tt({
  __name: "VoyagerSearchBar",
  props: /* @__PURE__ */ Ci({
    keywordSuggestions: {
      type: Array,
      required: !1,
      default: () => []
    },
    placeSuggestions: {
      type: Array,
      required: !1,
      default: () => []
    }
  }, {
    keyword: { required: !1 },
    keywordModifiers: {},
    place: { required: !1 },
    placeModifiers: {},
    intersects: { type: Boolean, required: !1 },
    intersectsModifiers: {},
    expansion: { type: Boolean, required: !1 },
    expansionModifiers: {}
  }),
  emits: /* @__PURE__ */ Ci(["search", "openAdvancedSearch"], ["update:keyword", "update:place", "update:intersects", "update:expansion"]),
  setup(e, { emit: t }) {
    const n = e, r = or(e, "keyword"), a = or(e, "place"), l = or(e, "intersects"), u = or(e, "expansion"), h = t, f = je(null), m = () => {
      n.keywordSuggestions.length > 0 && n.placeSuggestions.length > 0 || h("search", {
        keyword: r.value,
        place: a.value,
        intersects: l.value,
        expansion: u.value
      });
    }, v = () => h("openAdvancedSearch");
    return (y, k) => (we(), Te("div", b$, [
      xe("div", w$, [
        ce(he(hh), {
          modelValue: r.value,
          "onUpdate:modelValue": k[1] || (k[1] = (x) => r.value = x),
          ref_key: "searchAutocomplete",
          ref: f
        }, {
          default: Je(() => [
            ce(he(dh), {
              onChange: k[0] || (k[0] = (x) => r.value = x.target.value),
              onKeyup: xs(m, ["enter"]),
              "aria-label": "Keyword Search",
              spellcheck: "false",
              placeholder: "What are you looking for?",
              autocomplete: "off",
              "data-ts": "keyword-input"
            }),
            ce(he(fh), { class: "search-bar__keyword-suggestions" }, {
              default: Je(() => [
                r.value ? (we(), Ut(he(Ko), {
                  key: 0,
                  value: r.value ? r.value : ""
                }, {
                  default: Je(({ active: x }) => [
                    xe("li", {
                      class: gt(["suggestion", x ? "highlight" : ""])
                    }, _t(r.value), 3)
                  ]),
                  _: 1
                }, 8, ["value"])) : vt("", !0),
                (we(!0), Te(Et, null, rn(e.keywordSuggestions, (x) => (we(), Ut(he(Ko), {
                  key: x,
                  value: x,
                  "data-ts": "keyword-suggestion"
                }, {
                  default: Je(({ active: M }) => [
                    xe("li", {
                      class: gt(["suggestion", M ? "highlight" : ""])
                    }, _t(x), 3)
                  ]),
                  _: 2
                }, 1032, ["value"]))), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      xe("button", {
        onClick: m,
        "aria-label": "Submit Search",
        class: "search-bar__search-button",
        "data-ts": "submit-search"
      }, [
        ce(he(z_))
      ]),
      xe("div", k$, [
        Pi(xe("input", {
          id: "placefinder-op",
          "onUpdate:modelValue": k[2] || (k[2] = (x) => l.value = x),
          type: "checkbox",
          "aria-label": "Include Boundaries that Intersect Specified Place",
          class: "place-op__toggle",
          "data-ts": "intersect-toggle"
        }, null, 512), [
          [kf, l.value]
        ]),
        x$,
        xe("div", L$, [
          ce(he(hh), {
            modelValue: a.value,
            "onUpdate:modelValue": k[4] || (k[4] = (x) => a.value = x)
          }, {
            default: Je(() => [
              ce(he(dh), {
                onChange: k[3] || (k[3] = (x) => a.value = x.target.value),
                onKeyup: xs(m, ["enter"]),
                "aria-label": "Place Search",
                spellcheck: "false",
                autocomplete: "off",
                placeholder: "Where is it located?",
                "data-ts": "placefinder-input"
              }),
              ce(he(fh), { class: "search-bar__place-suggestions" }, {
                default: Je(() => [
                  a.value ? (we(), Ut(he(Ko), {
                    key: 0,
                    value: a.value ? a.value : ""
                  }, {
                    default: Je(({ active: x }) => [
                      xe("li", {
                        class: gt(["suggestion", x ? "highlight" : ""])
                      }, _t(a.value), 3)
                    ]),
                    _: 1
                  }, 8, ["value"])) : vt("", !0),
                  (we(!0), Te(Et, null, rn(e.placeSuggestions, (x) => (we(), Ut(he(Ko), {
                    key: x,
                    value: x,
                    autocomplete: "off",
                    "data-ts": "placefinder-suggestion"
                  }, {
                    default: Je(({ active: M }) => [
                      xe("li", {
                        class: gt(["suggestion", M ? "highlight" : ""])
                      }, _t(x), 3)
                    ]),
                    _: 2
                  }, 1032, ["value"]))), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])
      ]),
      xe("div", M$, [
        xe("button", {
          title: "Use Query Expansion",
          onClick: k[5] || (k[5] = (x) => u.value = !u.value),
          class: gt(u.value ? "" : "expansion-disabled"),
          "data-ts": "expansion-toggle"
        }, [
          ce(he(F_))
        ], 2),
        xe("button", {
          title: "Advanced Search",
          onClick: v,
          "data-ts": "advanced-form"
        }, [
          ce(he(O_))
        ])
      ])
    ]));
  }
}), S$ = { class: "voyager-slide" }, P$ = {
  key: 0,
  controls: ""
}, C$ = ["src", "type"], O$ = {
  key: 1,
  controls: ""
}, E$ = ["src", "type"], T$ = { key: 2 }, D$ = ["srcset"], I$ = ["src", "alt"], rN = /* @__PURE__ */ tt({
  __name: "VoyagerSlide",
  props: {
    slides: {
      type: Array,
      required: !1,
      default: () => []
    }
  },
  setup(e) {
    const t = e, n = je(0), r = te(() => {
      var u;
      return ((u = t.slides[n.value]) == null ? void 0 : u.type) === "video";
    }), a = te(() => {
      var u;
      return ((u = t.slides[n.value]) == null ? void 0 : u.type) === "image";
    }), l = te(() => {
      var u;
      return ((u = t.slides[n.value]) == null ? void 0 : u.type) === "audio";
    });
    return (u, h) => (we(), Te("div", S$, [
      ce(he(D_), {
        class: gt(["slide-control previous-source", n.value === 0 ? "disabled" : ""]),
        onClick: h[0] || (h[0] = (f) => n.value > 0 ? n.value-- : void 0)
      }, null, 8, ["class"]),
      r.value ? (we(), Te("video", P$, [
        (we(!0), Te(Et, null, rn(e.slides[n.value].sources, (f, m) => (we(), Te("source", {
          key: m,
          src: f.url,
          type: f.mediaType
        }, null, 8, C$))), 128))
      ])) : vt("", !0),
      l.value ? (we(), Te("audio", O$, [
        (we(!0), Te(Et, null, rn(e.slides[n.value].sources, (f, m) => (we(), Te("source", {
          key: m,
          src: f.url,
          type: f.mediaType
        }, null, 8, E$))), 128))
      ])) : vt("", !0),
      a.value ? (we(), Te("picture", T$, [
        xe("source", {
          srcset: e.slides[n.value].set
        }, null, 8, D$),
        xe("img", {
          src: e.slides[n.value].source,
          alt: e.slides[n.value].alt
        }, null, 8, I$)
      ])) : vt("", !0),
      ce(he($f), {
        class: gt(["slide-control next-source", n.value === e.slides.length - 1 ? "disabled" : ""]),
        onClick: h[1] || (h[1] = (f) => n.value < e.slides.length - 1 ? n.value++ : void 0)
      }, null, 8, ["class"])
    ]));
  }
}), hc = (e) => (mu("data-v-5b6bad2b"), e = e(), gu(), e), A$ = { class: "login-wrapper" }, R$ = /* @__PURE__ */ hc(() => /* @__PURE__ */ xe("h2", null, "Login", -1)), B$ = {
  key: 0,
  class: "error"
}, $$ = { class: "password-section" }, N$ = ["type"], z$ = ["disabled"], F$ = { class: "remember-me" }, j$ = /* @__PURE__ */ hc(() => /* @__PURE__ */ xe("label", { for: "rememberMe" }, "Remember Me", -1)), V$ = { class: "signup" }, Y$ = {
  key: 0,
  class: "other-methods"
}, H$ = /* @__PURE__ */ hc(() => /* @__PURE__ */ xe("hr", {
  class: "hr-text",
  "data-content": "or connect with"
}, null, -1)), U$ = /* @__PURE__ */ tt({
  __name: "LoginForm",
  props: {
    error: {
      type: String,
      required: !1
    }
  },
  emits: ["signup", "forgotPassword", "login"],
  setup(e, { emit: t }) {
    const n = t, r = e, a = $v(), l = je(!0), u = te(() => h.username && h.password), h = Ir({
      username: "",
      password: "",
      rememberMe: !1
    }), f = () => {
      n("login", h);
    };
    return (m, v) => (we(), Te("div", A$, [
      Xt(m.$slots, "header", {}, () => [
        R$
      ], !0),
      Xt(m.$slots, "error", {}, () => [
        r.error ? (we(), Te("div", B$, _t(r.error), 1)) : vt("", !0)
      ], !0),
      Xt(m.$slots, "default", {}, () => [
        xe("form", null, [
          Pi(xe("input", {
            type: "text",
            placeholder: "Username",
            autocomplete: "username",
            "onUpdate:modelValue": v[0] || (v[0] = (y) => h.username = y),
            "data-ts": "username-input"
          }, null, 512), [
            [Nv, h.username]
          ]),
          xe("div", $$, [
            Pi(xe("input", {
              placeholder: "Password",
              autocomplete: "current-password",
              "onUpdate:modelValue": v[1] || (v[1] = (y) => h.password = y),
              type: l.value ? "password" : "text",
              "data-ts": "password-input"
            }, null, 8, N$), [
              [zv, h.password]
            ]),
            xe("button", {
              disabled: !u.value,
              type: "button",
              onClick: v[2] || (v[2] = (y) => l.value = !l.value),
              class: "password-visibility",
              "data-ts": "password-toggle"
            }, [
              l.value ? (we(), Ut(he(R_), { key: 0 })) : (we(), Ut(he(B_), { key: 1 }))
            ], 8, z$)
          ]),
          xe("span", F$, [
            Pi(xe("input", {
              type: "checkbox",
              id: "rememberMe",
              "onUpdate:modelValue": v[3] || (v[3] = (y) => h.rememberMe = y),
              "data-ts": "remember-input"
            }, null, 512), [
              [kf, h.rememberMe]
            ]),
            j$
          ]),
          xe("button", {
            type: "button",
            onClick: f,
            class: gt(["login-button", u.value ? "" : "disabled"]),
            "data-ts": "login-button"
          }, " Login ", 2)
        ])
      ], !0),
      Xt(m.$slots, "forgotPassword", {}, () => [
        xe("button", {
          type: "button",
          onClick: v[4] || (v[4] = (y) => n("forgotPassword")),
          class: "forgot-password",
          "data-ts": "forgot-button"
        }, " Forgot Password? ")
      ], !0),
      Xt(m.$slots, "signup", {}, () => [
        xe("span", V$, [
          Se(" Don't have an account yet? "),
          xe("button", {
            type: "button",
            onClick: v[5] || (v[5] = (y) => n("signup")),
            "data-ts": "signup-button"
          }, "Sign Up")
        ])
      ], !0),
      he(a).otherMethods ? (we(), Te("div", Y$, [
        H$,
        Xt(m.$slots, "otherMethods", {}, void 0, !0)
      ])) : vt("", !0)
    ]));
  }
}), aN = /* @__PURE__ */ ur(U$, [["__scopeId", "data-v-5b6bad2b"]]);
export {
  eN as DateRangeFilter,
  nN as FilterChip,
  tN as FilterContainer,
  aN as LoginForm,
  X$ as RangeFilter,
  iN as SearchBar,
  K$ as SelectFilter,
  zf as VoyagerCard,
  q$ as VoyagerDetailsTable,
  G$ as VoyagerMap,
  ku as VoyagerPopper,
  rN as VoyagerSlide,
  W_ as VoyagerSplitButton,
  W$ as VoyagerTile
};
//# sourceMappingURL=voyager-components.es.js.map
